

const serviceAreas = [
{ city: "KOWEN FOREST", state: "ACT", postcode: "2620" },
{ city: "OAKS ESTATE", state: "ACT", postcode: "2620" },
{ city: "THARWA", state: "ACT", postcode: "2620" },
{ city: "TOP NAAS", state: "ACT", postcode: "2620" },
{ city: "WILLIAMSDALE", state: "ACT", postcode: "2620" },
{ city: "BEROWRA CREEK", state: "NSW", postcode: "2082" },
{ city: "BAR POINT", state: "NSW", postcode: "2083" },
{ city: "BROOKLYN", state: "NSW", postcode: "2083" },
{ city: "CHEERO POINT", state: "NSW", postcode: "2083" },
{ city: "COGRA BAY", state: "NSW", postcode: "2083" },
{ city: "DANGAR ISLAND", state: "NSW", postcode: "2083" },
{ city: "MILSONS PASSAGE", state: "NSW", postcode: "2083" },
{ city: "MOONEY MOONEY", state: "NSW", postcode: "2083" },
{ city: "COTTAGE POINT", state: "NSW", postcode: "2084" },
{ city: "DUFFYS FOREST", state: "NSW", postcode: "2084" },
{ city: "BERRILEE", state: "NSW", postcode: "2159" },
{ city: "FIDDLETOWN", state: "NSW", postcode: "2159" },
{ city: "GALSTON", state: "NSW", postcode: "2159" },
{ city: "BUNDEENA", state: "NSW", postcode: "2230" },
{ city: "MAIANBAR", state: "NSW", postcode: "2230" },
{ city: "AUDLEY", state: "NSW", postcode: "2232" },
{ city: "GARIE", state: "NSW", postcode: "2232" },
{ city: "BUCKETTY", state: "NSW", postcode: "2250" },
{ city: "CALGA", state: "NSW", postcode: "2250" },
{ city: "CENTRAL MANGROVE", state: "NSW", postcode: "2250" },
{ city: "LOWER MANGROVE", state: "NSW", postcode: "2250" },
{ city: "MANGROVE CREEK", state: "NSW", postcode: "2250" },
{ city: "MANGROVE MOUNTAIN", state: "NSW", postcode: "2250" },
{ city: "MATCHAM", state: "NSW", postcode: "2250" },
{ city: "MOONEY MOONEY CREEK", state: "NSW", postcode: "2250" },
{ city: "MOUNT ELLIOT", state: "NSW", postcode: "2250" },
{ city: "MOUNT WHITE", state: "NSW", postcode: "2250" },
{ city: "PEATS RIDGE", state: "NSW", postcode: "2250" },
{ city: "POINT CLARE", state: "NSW", postcode: "2250" },
{ city: "POINT FREDERICK", state: "NSW", postcode: "2250" },
{ city: "SPRINGFIELD", state: "NSW", postcode: "2250" },
{ city: "TASCOTT", state: "NSW", postcode: "2250" },
{ city: "TEN MILE HOLLOW", state: "NSW", postcode: "2250" },
{ city: "UPPER MANGROVE", state: "NSW", postcode: "2250" },
{ city: "BENSVILLE", state: "NSW", postcode: "2251" },
{ city: "BOUDDI", state: "NSW", postcode: "2251" },
{ city: "COPACABANA", state: "NSW", postcode: "2251" },
{ city: "DAVISTOWN", state: "NSW", postcode: "2251" },
{ city: "GREEN POINT", state: "NSW", postcode: "2251" },
{ city: "KINCUMBER SOUTH", state: "NSW", postcode: "2251" },
{ city: "MACMASTERS BEACH", state: "NSW", postcode: "2251" },
{ city: "PICKETTS VALLEY", state: "NSW", postcode: "2251" },
{ city: "SARATOGA", state: "NSW", postcode: "2251" },
{ city: "YATTALUNGA", state: "NSW", postcode: "2251" },
{ city: "BLACKWALL", state: "NSW", postcode: "2256" },
{ city: "HORSFIELD BAY", state: "NSW", postcode: "2256" },
{ city: "KOOLEWONG", state: "NSW", postcode: "2256" },
{ city: "LITTLE WOBBY", state: "NSW", postcode: "2256" },
{ city: "PATONGA", state: "NSW", postcode: "2256" },
{ city: "PEARL BEACH", state: "NSW", postcode: "2256" },
{ city: "PHEGANS BAY", state: "NSW", postcode: "2256" },
{ city: "WONDABYNE", state: "NSW", postcode: "2256" },
{ city: "WOY WOY BAY", state: "NSW", postcode: "2256" },
{ city: "BOOKER BAY", state: "NSW", postcode: "2257" },
{ city: "BOX HEAD", state: "NSW", postcode: "2257" },
{ city: "DALEYS POINT", state: "NSW", postcode: "2257" },
{ city: "EMPIRE BAY", state: "NSW", postcode: "2257" },
{ city: "ETTALONG BEACH", state: "NSW", postcode: "2257" },
{ city: "HARDYS BAY", state: "NSW", postcode: "2257" },
{ city: "KILLCARE", state: "NSW", postcode: "2257" },
{ city: "KILLCARE HEIGHTS", state: "NSW", postcode: "2257" },
{ city: "PRETTY BEACH", state: "NSW", postcode: "2257" },
{ city: "WAGSTAFFE", state: "NSW", postcode: "2257" },
{ city: "FOUNTAINDALE", state: "NSW", postcode: "2258" },
{ city: "KANGY ANGY", state: "NSW", postcode: "2258" },
{ city: "PALMDALE", state: "NSW", postcode: "2258" },
{ city: "PALM GROVE", state: "NSW", postcode: "2258" },
{ city: "ALISON", state: "NSW", postcode: "2259" },
{ city: "CEDAR BRUSH CREEK", state: "NSW", postcode: "2259" },
{ city: "CHAIN VALLEY BAY", state: "NSW", postcode: "2259" },
{ city: "CRANGAN BAY", state: "NSW", postcode: "2259" },
{ city: "DOORALONG", state: "NSW", postcode: "2259" },
{ city: "DURREN DURREN", state: "NSW", postcode: "2259" },
{ city: "FRAZER PARK", state: "NSW", postcode: "2259" },
{ city: "GWANDALAN", state: "NSW", postcode: "2259" },
{ city: "HALLORAN", state: "NSW", postcode: "2259" },
{ city: "HAMLYN TERRACE", state: "NSW", postcode: "2259" },
{ city: "JILLIBY", state: "NSW", postcode: "2259" },
{ city: "LITTLE JILLIBY", state: "NSW", postcode: "2259" },
{ city: "RAVENSDALE", state: "NSW", postcode: "2259" },
{ city: "TUMBI UMBI", state: "NSW", postcode: "2261" },
{ city: "BLUE HAVEN", state: "NSW", postcode: "2262" },
{ city: "BUFF POINT", state: "NSW", postcode: "2262" },
{ city: "HALEKULANI", state: "NSW", postcode: "2262" },
{ city: "SAN REMO", state: "NSW", postcode: "2262" },
{ city: "CANTON BEACH", state: "NSW", postcode: "2263" },
{ city: "GOROKAN", state: "NSW", postcode: "2263" },
{ city: "NORAH HEAD", state: "NSW", postcode: "2263" },
{ city: "NORAVILLE", state: "NSW", postcode: "2263" },
{ city: "BALCOLYN", state: "NSW", postcode: "2264" },
{ city: "BONNELLS BAY", state: "NSW", postcode: "2264" },
{ city: "BRIGHTWATERS", state: "NSW", postcode: "2264" },
{ city: "DORA CREEK", state: "NSW", postcode: "2264" },
{ city: "ERARING", state: "NSW", postcode: "2264" },
{ city: "MANDALONG", state: "NSW", postcode: "2264" },
{ city: "MIRRABOOKA", state: "NSW", postcode: "2264" },
{ city: "MORISSET PARK", state: "NSW", postcode: "2264" },
{ city: "MYUNA BAY", state: "NSW", postcode: "2264" },
{ city: "SILVERWATER", state: "NSW", postcode: "2264" },
{ city: "SUNSHINE", state: "NSW", postcode: "2264" },
{ city: "WINDERMERE PARK", state: "NSW", postcode: "2264" },
{ city: "YARRAWONGA PARK", state: "NSW", postcode: "2264" },
{ city: "MARTINSVILLE", state: "NSW", postcode: "2265" },
{ city: "WANGI WANGI", state: "NSW", postcode: "2267" },
{ city: "BARNSLEY", state: "NSW", postcode: "2278" },
{ city: "KILLINGWORTH", state: "NSW", postcode: "2278" },
{ city: "WAKEFIELD", state: "NSW", postcode: "2278" },
{ city: "CROUDACE BAY", state: "NSW", postcode: "2280" },
{ city: "FLORAVILLE", state: "NSW", postcode: "2280" },
{ city: "ALLYNBROOK", state: "NSW", postcode: "2311" },
{ city: "BINGLEBURRA", state: "NSW", postcode: "2311" },
{ city: "CARRABOLLA", state: "NSW", postcode: "2311" },
{ city: "EAST GRESFORD", state: "NSW", postcode: "2311" },
{ city: "ECCLESTON", state: "NSW", postcode: "2311" },
{ city: "GRESFORD", state: "NSW", postcode: "2311" },
{ city: "HALTON", state: "NSW", postcode: "2311" },
{ city: "LEWINSBROOK", state: "NSW", postcode: "2311" },
{ city: "LOSTOCK", state: "NSW", postcode: "2311" },
{ city: "MOUNT RIVERS", state: "NSW", postcode: "2311" },
{ city: "CORLETTE", state: "NSW", postcode: "2315" },
{ city: "FINGAL BAY", state: "NSW", postcode: "2315" },
{ city: "NELSON BAY", state: "NSW", postcode: "2315" },
{ city: "SHOAL BAY", state: "NSW", postcode: "2315" },
{ city: "ANNA BAY", state: "NSW", postcode: "2316" },
{ city: "BOAT HARBOUR", state: "NSW", postcode: "2316" },
{ city: "BOBS FARM", state: "NSW", postcode: "2316" },
{ city: "FISHERMANS BAY", state: "NSW", postcode: "2316" },
{ city: "ONE MILE", state: "NSW", postcode: "2316" },
{ city: "TAYLORS BEACH", state: "NSW", postcode: "2316" },
{ city: "SALAMANDER BAY", state: "NSW", postcode: "2317" },
{ city: "SOLDIERS POINT", state: "NSW", postcode: "2317" },
{ city: "CAMPVALE", state: "NSW", postcode: "2318" },
{ city: "FERODALE", state: "NSW", postcode: "2318" },
{ city: "FULLERTON COVE", state: "NSW", postcode: "2318" },
{ city: "MEDOWIE", state: "NSW", postcode: "2318" },
{ city: "OYSTER COVE", state: "NSW", postcode: "2318" },
{ city: "SALT ASH", state: "NSW", postcode: "2318" },
{ city: "LEMON TREE PASSAGE", state: "NSW", postcode: "2319" },
{ city: "MALLABULA", state: "NSW", postcode: "2319" },
{ city: "TANILBA BAY", state: "NSW", postcode: "2319" },
{ city: "ABERGLASSLYN", state: "NSW", postcode: "2320" },
{ city: "ALLANDALE", state: "NSW", postcode: "2320" },
{ city: "ANAMBAH", state: "NSW", postcode: "2320" },
{ city: "BOLWARRA", state: "NSW", postcode: "2320" },
{ city: "BOLWARRA HEIGHTS", state: "NSW", postcode: "2320" },
{ city: "FARLEY", state: "NSW", postcode: "2320" },
{ city: "GLEN OAK", state: "NSW", postcode: "2320" },
{ city: "GOSFORTH", state: "NSW", postcode: "2320" },
{ city: "HILLSBOROUGH", state: "NSW", postcode: "2320" },
{ city: "HORSESHOE BEND", state: "NSW", postcode: "2320" },
{ city: "KEINBAH", state: "NSW", postcode: "2320" },
{ city: "LARGS", state: "NSW", postcode: "2320" },
{ city: "LORN", state: "NSW", postcode: "2320" },
{ city: "LOUTH PARK", state: "NSW", postcode: "2320" },
{ city: "MAITLAND VALE", state: "NSW", postcode: "2320" },
{ city: "MELVILLE", state: "NSW", postcode: "2320" },
{ city: "MINDARIBBA", state: "NSW", postcode: "2320" },
{ city: "MOUNT DEE", state: "NSW", postcode: "2320" },
{ city: "OAKHAMPTON", state: "NSW", postcode: "2320" },
{ city: "OAKHAMPTON HEIGHTS", state: "NSW", postcode: "2320" },
{ city: "POKOLBIN", state: "NSW", postcode: "2320" },
{ city: "ROSEBROOK", state: "NSW", postcode: "2320" },
{ city: "ROTHBURY", state: "NSW", postcode: "2320" },
{ city: "TELARAH", state: "NSW", postcode: "2320" },
{ city: "WALLALONG", state: "NSW", postcode: "2320" },
{ city: "WINDELLA", state: "NSW", postcode: "2320" },
{ city: "BERRY PARK", state: "NSW", postcode: "2321" },
{ city: "BUTTERWICK", state: "NSW", postcode: "2321" },
{ city: "CLARENCE TOWN", state: "NSW", postcode: "2321" },
{ city: "CLIFTLEIGH", state: "NSW", postcode: "2321" },
{ city: "DUCKENFIELD", state: "NSW", postcode: "2321" },
{ city: "DUNS CREEK", state: "NSW", postcode: "2321" },
{ city: "GILLIESTON HEIGHTS", state: "NSW", postcode: "2321" },
{ city: "GLEN MARTIN", state: "NSW", postcode: "2321" },
{ city: "GLEN WILLIAM", state: "NSW", postcode: "2321" },
{ city: "HARPERS HILL", state: "NSW", postcode: "2321" },
{ city: "HEDDON GRETA", state: "NSW", postcode: "2321" },
{ city: "HINTON", state: "NSW", postcode: "2321" },
{ city: "LOCHINVAR", state: "NSW", postcode: "2321" },
{ city: "LUSKINTYRE", state: "NSW", postcode: "2321" },
{ city: "OSWALD", state: "NSW", postcode: "2321" },
{ city: "PHOENIX PARK", state: "NSW", postcode: "2321" },
{ city: "RAWORTH", state: "NSW", postcode: "2321" },
{ city: "WINDERMERE", state: "NSW", postcode: "2321" },
{ city: "WOODVILLE", state: "NSW", postcode: "2321" },
{ city: "BLACK HILL", state: "NSW", postcode: "2322" },
{ city: "LENAGHAN", state: "NSW", postcode: "2322" },
{ city: "STOCKRINGTON", state: "NSW", postcode: "2322" },
{ city: "TARRO", state: "NSW", postcode: "2322" },
{ city: "TOMAGO", state: "NSW", postcode: "2322" },
{ city: "WOODBERRY", state: "NSW", postcode: "2322" },
{ city: "ASHTONFIELD", state: "NSW", postcode: "2323" },
{ city: "BRUNKERVILLE", state: "NSW", postcode: "2323" },
{ city: "BUCHANAN", state: "NSW", postcode: "2323" },
{ city: "BUTTAI", state: "NSW", postcode: "2323" },
{ city: "FOUR MILE CREEK", state: "NSW", postcode: "2323" },
{ city: "FREEMANS WATERHOLE", state: "NSW", postcode: "2323" },
{ city: "GREEN HILLS", state: "NSW", postcode: "2323" },
{ city: "METFORD", state: "NSW", postcode: "2323" },
{ city: "METFORD DC", state: "NSW", postcode: "2323" },
{ city: "MOUNT VINCENT", state: "NSW", postcode: "2323" },
{ city: "MULBRING", state: "NSW", postcode: "2323" },
{ city: "PITNACREE", state: "NSW", postcode: "2323" },
{ city: "RICHMOND VALE", state: "NSW", postcode: "2323" },
{ city: "TENAMBIT", state: "NSW", postcode: "2323" },
{ city: "BALICKERA", state: "NSW", postcode: "2324" },
{ city: "BRANDY HILL", state: "NSW", postcode: "2324" },
{ city: "BUNDABAH", state: "NSW", postcode: "2324" },
{ city: "CARRINGTON", state: "NSW", postcode: "2324" },
{ city: "EAGLETON", state: "NSW", postcode: "2324" },
{ city: "EAST SEAHAM", state: "NSW", postcode: "2324" },
{ city: "HAWKS NEST", state: "NSW", postcode: "2324" },
{ city: "HEATHERBRAE", state: "NSW", postcode: "2324" },
{ city: "KARUAH", state: "NSW", postcode: "2324" },
{ city: "LIMEBURNERS CREEK", state: "NSW", postcode: "2324" },
{ city: "MILLERS FOREST", state: "NSW", postcode: "2324" },
{ city: "NELSONS PLAINS", state: "NSW", postcode: "2324" },
{ city: "NORTH ARM COVE", state: "NSW", postcode: "2324" },
{ city: "OSTERLEY", state: "NSW", postcode: "2324" },
{ city: "PINDIMAR", state: "NSW", postcode: "2324" },
{ city: "SEAHAM", state: "NSW", postcode: "2324" },
{ city: "SWAN BAY", state: "NSW", postcode: "2324" },
{ city: "TAHLEE", state: "NSW", postcode: "2324" },
{ city: "TWELVE MILE CREEK", state: "NSW", postcode: "2324" },
{ city: "ABERDARE", state: "NSW", postcode: "2325" },
{ city: "ABERNETHY", state: "NSW", postcode: "2325" },
{ city: "BELLBIRD", state: "NSW", postcode: "2325" },
{ city: "BELLBIRD HEIGHTS", state: "NSW", postcode: "2325" },
{ city: "CEDAR CREEK", state: "NSW", postcode: "2325" },
{ city: "CESSNOCK", state: "NSW", postcode: "2325" },
{ city: "CESSNOCK WEST", state: "NSW", postcode: "2325" },
{ city: "CONGEWAI", state: "NSW", postcode: "2325" },
{ city: "CORRABARE", state: "NSW", postcode: "2325" },
{ city: "ELLALONG", state: "NSW", postcode: "2325" },
{ city: "ELRINGTON", state: "NSW", postcode: "2325" },
{ city: "GRETA MAIN", state: "NSW", postcode: "2325" },
{ city: "KEARSLEY", state: "NSW", postcode: "2325" },
{ city: "KITCHENER", state: "NSW", postcode: "2325" },
{ city: "LAGUNA", state: "NSW", postcode: "2325" },
{ city: "LOVEDALE", state: "NSW", postcode: "2325" },
{ city: "MILLFIELD", state: "NSW", postcode: "2325" },
{ city: "MORUBEN", state: "NSW", postcode: "2325" },
{ city: "MOUNT VIEW", state: "NSW", postcode: "2325" },
{ city: "NULKABA", state: "NSW", postcode: "2325" },
{ city: "OLNEY", state: "NSW", postcode: "2325" },
{ city: "PAXTON", state: "NSW", postcode: "2325" },
{ city: "PAYNES CROSSING", state: "NSW", postcode: "2325" },
{ city: "PELTON", state: "NSW", postcode: "2325" },
{ city: "QUORROBOLONG", state: "NSW", postcode: "2325" },
{ city: "SWEETMANS CREEK", state: "NSW", postcode: "2325" },
{ city: "WOLLOMBI", state: "NSW", postcode: "2325" },
{ city: "ABERMAIN", state: "NSW", postcode: "2326" },
{ city: "BISHOPS BRIDGE", state: "NSW", postcode: "2326" },
{ city: "LOXFORD", state: "NSW", postcode: "2326" },
{ city: "NEATH", state: "NSW", postcode: "2326" },
{ city: "SAWYERS GULLY", state: "NSW", postcode: "2326" },
{ city: "WESTON", state: "NSW", postcode: "2326" },
{ city: "KURRI KURRI", state: "NSW", postcode: "2327" },
{ city: "PELAW MAIN", state: "NSW", postcode: "2327" },
{ city: "STANFORD MERTHYR", state: "NSW", postcode: "2327" },
{ city: "BUREEN", state: "NSW", postcode: "2328" },
{ city: "DALSWINTON", state: "NSW", postcode: "2328" },
{ city: "DENMAN", state: "NSW", postcode: "2328" },
{ city: "GIANTS CREEK", state: "NSW", postcode: "2328" },
{ city: "HOLLYDEEN", state: "NSW", postcode: "2328" },
{ city: "KERRABEE", state: "NSW", postcode: "2328" },
{ city: "MANGOOLA", state: "NSW", postcode: "2328" },
{ city: "MARTINDALE", state: "NSW", postcode: "2328" },
{ city: "WIDDEN", state: "NSW", postcode: "2328" },
{ city: "YARRAWA", state: "NSW", postcode: "2328" },
{ city: "CASSILIS", state: "NSW", postcode: "2329" },
{ city: "MERRIWA", state: "NSW", postcode: "2329" },
{ city: "UARBRY", state: "NSW", postcode: "2329" },
{ city: "APPLETREE FLAT", state: "NSW", postcode: "2330" },
{ city: "BIG RIDGE", state: "NSW", postcode: "2330" },
{ city: "BIG YENGO", state: "NSW", postcode: "2330" },
{ city: "BOWMANS CREEK", state: "NSW", postcode: "2330" },
{ city: "BRIDGMAN", state: "NSW", postcode: "2330" },
{ city: "BROKE", state: "NSW", postcode: "2330" },
{ city: "BULGA", state: "NSW", postcode: "2330" },
{ city: "CAMBERWELL", state: "NSW", postcode: "2330" },
{ city: "CARROWBROOK", state: "NSW", postcode: "2330" },
{ city: "CLYDESDALE", state: "NSW", postcode: "2330" },
{ city: "COMBO", state: "NSW", postcode: "2330" },
{ city: "DARLINGTON", state: "NSW", postcode: "2330" },
{ city: "DOYLES CREEK", state: "NSW", postcode: "2330" },
{ city: "DUNOLLY", state: "NSW", postcode: "2330" },
{ city: "DYRRING", state: "NSW", postcode: "2330" },
{ city: "FALBROOK", state: "NSW", postcode: "2330" },
{ city: "FERN GULLY", state: "NSW", postcode: "2330" },
{ city: "FORDWICH", state: "NSW", postcode: "2330" },
{ city: "GARLAND VALLEY", state: "NSW", postcode: "2330" },
{ city: "GLENDON", state: "NSW", postcode: "2330" },
{ city: "GLENDON BROOK", state: "NSW", postcode: "2330" },
{ city: "GLENNIES CREEK", state: "NSW", postcode: "2330" },
{ city: "GLENRIDDING", state: "NSW", postcode: "2330" },
{ city: "GOORANGOOLA", state: "NSW", postcode: "2330" },
{ city: "GOULDSVILLE", state: "NSW", postcode: "2330" },
{ city: "GOWRIE", state: "NSW", postcode: "2330" },
{ city: "GREENLANDS", state: "NSW", postcode: "2330" },
{ city: "HAMBLEDON HILL", state: "NSW", postcode: "2330" },
{ city: "HEBDEN", state: "NSW", postcode: "2330" },
{ city: "HOWES VALLEY", state: "NSW", postcode: "2330" },
{ city: "HOWICK", state: "NSW", postcode: "2330" },
{ city: "HUNTERVIEW", state: "NSW", postcode: "2330" },
{ city: "JERRYS PLAINS", state: "NSW", postcode: "2330" },
{ city: "LEMINGTON", state: "NSW", postcode: "2330" },
{ city: "LONG POINT", state: "NSW", postcode: "2330" },
{ city: "MAISON DIEU", state: "NSW", postcode: "2330" },
{ city: "MCDOUGALLS HILL", state: "NSW", postcode: "2330" },
{ city: "MIDDLE FALBROOK", state: "NSW", postcode: "2330" },
{ city: "MILBRODALE", state: "NSW", postcode: "2330" },
{ city: "MIRANNIE", state: "NSW", postcode: "2330" },
{ city: "MITCHELLS FLAT", state: "NSW", postcode: "2330" },
{ city: "MOUNT OLIVE", state: "NSW", postcode: "2330" },
{ city: "MOUNT ROYAL", state: "NSW", postcode: "2330" },
{ city: "MOUNT THORLEY", state: "NSW", postcode: "2330" },
{ city: "OBANVALE", state: "NSW", postcode: "2330" },
{ city: "PUTTY", state: "NSW", postcode: "2330" },
{ city: "RAVENSWORTH", state: "NSW", postcode: "2330" },
{ city: "REDBOURNBERRY", state: "NSW", postcode: "2330" },
{ city: "REEDY CREEK", state: "NSW", postcode: "2330" },
{ city: "RIXS CREEK", state: "NSW", postcode: "2330" },
{ city: "ROUGHIT", state: "NSW", postcode: "2330" },
{ city: "SCOTTS FLAT", state: "NSW", postcode: "2330" },
{ city: "SEDGEFIELD", state: "NSW", postcode: "2330" },
{ city: "SINGLETON", state: "NSW", postcode: "2330" },
{ city: "SINGLETON DC", state: "NSW", postcode: "2330" },
{ city: "SINGLETON HEIGHTS", state: "NSW", postcode: "2330" },
{ city: "ST CLAIR", state: "NSW", postcode: "2330" },
{ city: "WARKWORTH", state: "NSW", postcode: "2330" },
{ city: "WATTLE PONDS", state: "NSW", postcode: "2330" },
{ city: "WESTBROOK", state: "NSW", postcode: "2330" },
{ city: "WHITTINGHAM", state: "NSW", postcode: "2330" },
{ city: "WOLLEMI", state: "NSW", postcode: "2330" },
{ city: "WYLIES FLAT", state: "NSW", postcode: "2330" },
{ city: "BAERAMI", state: "NSW", postcode: "2333" },
{ city: "BAERAMI CREEK", state: "NSW", postcode: "2333" },
{ city: "BENGALLA", state: "NSW", postcode: "2333" },
{ city: "CASTLE ROCK", state: "NSW", postcode: "2333" },
{ city: "EDDERTON", state: "NSW", postcode: "2333" },
{ city: "GUNGAL", state: "NSW", postcode: "2333" },
{ city: "KAYUGA", state: "NSW", postcode: "2333" },
{ city: "LIDDELL", state: "NSW", postcode: "2333" },
{ city: "MANOBALAI", state: "NSW", postcode: "2333" },
{ city: "MCCULLYS GAP", state: "NSW", postcode: "2333" },
{ city: "MUSCLE CREEK", state: "NSW", postcode: "2333" },
{ city: "MUSWELLBROOK", state: "NSW", postcode: "2333" },
{ city: "SANDY HOLLOW", state: "NSW", postcode: "2333" },
{ city: "WYBONG", state: "NSW", postcode: "2333" },
{ city: "GRETA", state: "NSW", postcode: "2334" },
{ city: "BELFORD", state: "NSW", postcode: "2335" },
{ city: "BRANXTON", state: "NSW", postcode: "2335" },
{ city: "DALWOOD", state: "NSW", postcode: "2335" },
{ city: "EAST BRANXTON", state: "NSW", postcode: "2335" },
{ city: "ELDERSLIE", state: "NSW", postcode: "2335" },
{ city: "LAMBS VALLEY", state: "NSW", postcode: "2335" },
{ city: "LECONFIELD", state: "NSW", postcode: "2335" },
{ city: "LOWER BELFORD", state: "NSW", postcode: "2335" },
{ city: "NORTH ROTHBURY", state: "NSW", postcode: "2335" },
{ city: "STANHOPE", state: "NSW", postcode: "2335" },
{ city: "ABERDEEN", state: "NSW", postcode: "2336" },
{ city: "DARTBROOK", state: "NSW", postcode: "2336" },
{ city: "DAVIS CREEK", state: "NSW", postcode: "2336" },
{ city: "ROSSGOLE", state: "NSW", postcode: "2336" },
{ city: "ROUCHEL", state: "NSW", postcode: "2336" },
{ city: "ROUCHEL BROOK", state: "NSW", postcode: "2336" },
{ city: "UPPER DARTBROOK", state: "NSW", postcode: "2336" },
{ city: "UPPER ROUCHEL", state: "NSW", postcode: "2336" },
{ city: "BELLTREES", state: "NSW", postcode: "2337" },
{ city: "BRAWBOY", state: "NSW", postcode: "2337" },
{ city: "BUNNAN", state: "NSW", postcode: "2337" },
{ city: "DRY CREEK", state: "NSW", postcode: "2337" },
{ city: "ELLERSTON", state: "NSW", postcode: "2337" },
{ city: "GLENBAWN", state: "NSW", postcode: "2337" },
{ city: "GLENROCK", state: "NSW", postcode: "2337" },
{ city: "GUNDY", state: "NSW", postcode: "2337" },
{ city: "KARS SPRINGS", state: "NSW", postcode: "2337" },
{ city: "MIDDLE BROOK", state: "NSW", postcode: "2337" },
{ city: "MOOBI", state: "NSW", postcode: "2337" },
{ city: "MOONAN BROOK", state: "NSW", postcode: "2337" },
{ city: "MOONAN FLAT", state: "NSW", postcode: "2337" },
{ city: "MURULLA", state: "NSW", postcode: "2337" },
{ city: "OMADALE", state: "NSW", postcode: "2337" },
{ city: "OWENS GAP", state: "NSW", postcode: "2337" },
{ city: "PAGES CREEK", state: "NSW", postcode: "2337" },
{ city: "PARKVILLE", state: "NSW", postcode: "2337" },
{ city: "SCONE", state: "NSW", postcode: "2337" },
{ city: "SEGENHOE", state: "NSW", postcode: "2337" },
{ city: "STEWARTS BROOK", state: "NSW", postcode: "2337" },
{ city: "TOMALLA", state: "NSW", postcode: "2337" },
{ city: "WAVERLY", state: "NSW", postcode: "2337" },
{ city: "WINGEN", state: "NSW", postcode: "2337" },
{ city: "WOOLOOMA", state: "NSW", postcode: "2337" },
{ city: "ARDGLEN", state: "NSW", postcode: "2338" },
{ city: "BLANDFORD", state: "NSW", postcode: "2338" },
{ city: "CRAWNEY", state: "NSW", postcode: "2338" },
{ city: "GREEN CREEK", state: "NSW", postcode: "2338" },
{ city: "MURRURUNDI", state: "NSW", postcode: "2338" },
{ city: "PAGES RIVER", state: "NSW", postcode: "2338" },
{ city: "SANDY CREEK", state: "NSW", postcode: "2338" },
{ city: "SCOTTS CREEK", state: "NSW", postcode: "2338" },
{ city: "TIMOR", state: "NSW", postcode: "2338" },
{ city: "BIG JACKS CREEK", state: "NSW", postcode: "2339" },
{ city: "BRAEFIELD", state: "NSW", postcode: "2339" },
{ city: "CATTLE CREEK", state: "NSW", postcode: "2339" },
{ city: "CHILCOTTS CREEK", state: "NSW", postcode: "2339" },
{ city: "LITTLE JACKS CREEK", state: "NSW", postcode: "2339" },
{ city: "MACDONALDS CREEK", state: "NSW", postcode: "2339" },
{ city: "PARRAWEENA", state: "NSW", postcode: "2339" },
{ city: "WARRAH", state: "NSW", postcode: "2339" },
{ city: "WARRAH CREEK", state: "NSW", postcode: "2339" },
{ city: "WILLOW TREE", state: "NSW", postcode: "2339" },
{ city: "APPLEBY", state: "NSW", postcode: "2340" },
{ city: "BARRY", state: "NSW", postcode: "2340" },
{ city: "BECTIVE", state: "NSW", postcode: "2340" },
{ city: "BITHRAMERE", state: "NSW", postcode: "2340" },
{ city: "BOWLING ALLEY POINT", state: "NSW", postcode: "2340" },
{ city: "CALALA", state: "NSW", postcode: "2340" },
{ city: "CARROLL", state: "NSW", postcode: "2340" },
{ city: "DARUKA", state: "NSW", postcode: "2340" },
{ city: "DUNGOWAN", state: "NSW", postcode: "2340" },
{ city: "GIDLEY", state: "NSW", postcode: "2340" },
{ city: "GOONOO GOONOO", state: "NSW", postcode: "2340" },
{ city: "GOWRIE", state: "NSW", postcode: "2340" },
{ city: "HANGING ROCK", state: "NSW", postcode: "2340" },
{ city: "HILLVUE", state: "NSW", postcode: "2340" },
{ city: "KEEPIT", state: "NSW", postcode: "2340" },
{ city: "KINGSWOOD", state: "NSW", postcode: "2340" },
{ city: "LOOMBERAH", state: "NSW", postcode: "2340" },
{ city: "MOORE CREEK", state: "NSW", postcode: "2340" },
{ city: "NEMINGHA", state: "NSW", postcode: "2340" },
{ city: "NUNDLE", state: "NSW", postcode: "2340" },
{ city: "OGUNBIL", state: "NSW", postcode: "2340" },
{ city: "OXLEY VALE", state: "NSW", postcode: "2340" },
{ city: "PIALLAMORE", state: "NSW", postcode: "2340" },
{ city: "SOMERTON", state: "NSW", postcode: "2340" },
{ city: "TIMBUMBURI", state: "NSW", postcode: "2340" },
{ city: "WALLAMORE", state: "NSW", postcode: "2340" },
{ city: "WARRAL", state: "NSW", postcode: "2340" },
{ city: "WEABONGA", state: "NSW", postcode: "2340" },
{ city: "WESTDALE", state: "NSW", postcode: "2340" },
{ city: "WOOLOMIN", state: "NSW", postcode: "2340" },
{ city: "WERRIS CREEK", state: "NSW", postcode: "2341" },
{ city: "CURRABUBULA", state: "NSW", postcode: "2342" },
{ city: "PIALLAWAY", state: "NSW", postcode: "2342" },
{ city: "BLACKVILLE", state: "NSW", postcode: "2343" },
{ city: "BORAMBIL", state: "NSW", postcode: "2343" },
{ city: "BUNDELLA", state: "NSW", postcode: "2343" },
{ city: "CAROONA", state: "NSW", postcode: "2343" },
{ city: "COLLY BLUE", state: "NSW", postcode: "2343" },
{ city: "COOMOO COOMOO", state: "NSW", postcode: "2343" },
{ city: "PINE RIDGE", state: "NSW", postcode: "2343" },
{ city: "QUIPOLLY", state: "NSW", postcode: "2343" },
{ city: "QUIRINDI", state: "NSW", postcode: "2343" },
{ city: "SPRING RIDGE", state: "NSW", postcode: "2343" },
{ city: "WALLABADAH", state: "NSW", postcode: "2343" },
{ city: "WARRAH RIDGE", state: "NSW", postcode: "2343" },
{ city: "WINDY", state: "NSW", postcode: "2343" },
{ city: "YANNERGEE", state: "NSW", postcode: "2343" },
{ city: "YARRAMAN", state: "NSW", postcode: "2343" },
{ city: "DURI", state: "NSW", postcode: "2344" },
{ city: "WINTON", state: "NSW", postcode: "2344" },
{ city: "ATTUNGA", state: "NSW", postcode: "2345" },
{ city: "GARTHOWEN", state: "NSW", postcode: "2345" },
{ city: "BORAH CREEK", state: "NSW", postcode: "2346" },
{ city: "HALLS CREEK", state: "NSW", postcode: "2346" },
{ city: "KLORI", state: "NSW", postcode: "2346" },
{ city: "MANILLA", state: "NSW", postcode: "2346" },
{ city: "NAMOI RIVER", state: "NSW", postcode: "2346" },
{ city: "NEW MEXICO", state: "NSW", postcode: "2346" },
{ city: "RUSHES CREEK", state: "NSW", postcode: "2346" },
{ city: "UPPER MANILLA", state: "NSW", postcode: "2346" },
{ city: "WARRABAH", state: "NSW", postcode: "2346" },
{ city: "WIMBORNE", state: "NSW", postcode: "2346" },
{ city: "WONGO CREEK", state: "NSW", postcode: "2346" },
{ city: "BANOON", state: "NSW", postcode: "2347" },
{ city: "BARRABA", state: "NSW", postcode: "2347" },
{ city: "COBBADAH", state: "NSW", postcode: "2347" },
{ city: "GULF CREEK", state: "NSW", postcode: "2347" },
{ city: "GUNDAMULDA", state: "NSW", postcode: "2347" },
{ city: "IRONBARK", state: "NSW", postcode: "2347" },
{ city: "LINDESAY", state: "NSW", postcode: "2347" },
{ city: "LONGARM", state: "NSW", postcode: "2347" },
{ city: "MAYVALE", state: "NSW", postcode: "2347" },
{ city: "RED HILL", state: "NSW", postcode: "2347" },
{ city: "THIRLDENE", state: "NSW", postcode: "2347" },
{ city: "THIRLOENE", state: "NSW", postcode: "2347" },
{ city: "UPPER HORTON", state: "NSW", postcode: "2347" },
{ city: "WOODSREEF", state: "NSW", postcode: "2347" },
{ city: "ABERFOYLE", state: "NSW", postcode: "2350" },
{ city: "ABINGTON", state: "NSW", postcode: "2350" },
{ city: "ARGYLE", state: "NSW", postcode: "2350" },
{ city: "ARMIDALE", state: "NSW", postcode: "2350" },
{ city: "BOOROLONG", state: "NSW", postcode: "2350" },
{ city: "CASTLE DOYLE", state: "NSW", postcode: "2350" },
{ city: "DANGARSLEIGH", state: "NSW", postcode: "2350" },
{ city: "DONALD CREEK", state: "NSW", postcode: "2350" },
{ city: "DUMARESQ", state: "NSW", postcode: "2350" },
{ city: "DUVAL", state: "NSW", postcode: "2350" },
{ city: "ENMORE", state: "NSW", postcode: "2350" },
{ city: "HILLGROVE", state: "NSW", postcode: "2350" },
{ city: "INVERGOWRIE", state: "NSW", postcode: "2350" },
{ city: "JEOGLA", state: "NSW", postcode: "2350" },
{ city: "KELLYS PLAINS", state: "NSW", postcode: "2350" },
{ city: "LYNDHURST", state: "NSW", postcode: "2350" },
{ city: "PUDDLEDOCK", state: "NSW", postcode: "2350" },
{ city: "SAUMAREZ", state: "NSW", postcode: "2350" },
{ city: "SAUMAREZ PONDS", state: "NSW", postcode: "2350" },
{ city: "THALGARRAH", state: "NSW", postcode: "2350" },
{ city: "TILBUSTER", state: "NSW", postcode: "2350" },
{ city: "WARDS MISTAKE", state: "NSW", postcode: "2350" },
{ city: "WEST ARMIDALE", state: "NSW", postcode: "2350" },
{ city: "WOLLOMOMBI", state: "NSW", postcode: "2350" },
{ city: "WONGWIBINDA", state: "NSW", postcode: "2350" },
{ city: "KOOTINGAL", state: "NSW", postcode: "2352" },
{ city: "LIMBRI", state: "NSW", postcode: "2352" },
{ city: "MULLA CREEK", state: "NSW", postcode: "2352" },
{ city: "TINTINHULL", state: "NSW", postcode: "2352" },
{ city: "MOONBI", state: "NSW", postcode: "2353" },
{ city: "KENTUCKY", state: "NSW", postcode: "2354" },
{ city: "KENTUCKY SOUTH", state: "NSW", postcode: "2354" },
{ city: "NIANGALA", state: "NSW", postcode: "2354" },
{ city: "NOWENDOC", state: "NSW", postcode: "2354" },
{ city: "WALCHA", state: "NSW", postcode: "2354" },
{ city: "WALCHA ROAD", state: "NSW", postcode: "2354" },
{ city: "WOLLUN", state: "NSW", postcode: "2354" },
{ city: "WOOLBROOK", state: "NSW", postcode: "2354" },
{ city: "YARROWITCH", state: "NSW", postcode: "2354" },
{ city: "BENDEMEER", state: "NSW", postcode: "2355" },
{ city: "RETREAT", state: "NSW", postcode: "2355" },
{ city: "WATSONS CREEK", state: "NSW", postcode: "2355" },
{ city: "GWABEGAR", state: "NSW", postcode: "2356" },
{ city: "BOMERA", state: "NSW", postcode: "2357" },
{ city: "BOX RIDGE", state: "NSW", postcode: "2357" },
{ city: "BUGALDIE", state: "NSW", postcode: "2357" },
{ city: "COONABARABRAN", state: "NSW", postcode: "2357" },
{ city: "DANDRY", state: "NSW", postcode: "2357" },
{ city: "GOWANG", state: "NSW", postcode: "2357" },
{ city: "PURLEWAUGH", state: "NSW", postcode: "2357" },
{ city: "ROCKY GLEN", state: "NSW", postcode: "2357" },
{ city: "TANNABAR", state: "NSW", postcode: "2357" },
{ city: "ULAMAMBRI", state: "NSW", postcode: "2357" },
{ city: "WATTLE SPRINGS", state: "NSW", postcode: "2357" },
{ city: "ARDING", state: "NSW", postcode: "2358" },
{ city: "BALALA", state: "NSW", postcode: "2358" },
{ city: "GOSTWYCK", state: "NSW", postcode: "2358" },
{ city: "KINGSTOWN", state: "NSW", postcode: "2358" },
{ city: "MIHI", state: "NSW", postcode: "2358" },
{ city: "ROCKY RIVER", state: "NSW", postcode: "2358" },
{ city: "SALISBURY PLAINS", state: "NSW", postcode: "2358" },
{ city: "TORRYBURN", state: "NSW", postcode: "2358" },
{ city: "URALLA", state: "NSW", postcode: "2358" },
{ city: "YARROWYCK", state: "NSW", postcode: "2358" },
{ city: "ABERDEEN", state: "NSW", postcode: "2359" },
{ city: "BAKERS CREEK", state: "NSW", postcode: "2359" },
{ city: "BUNDARRA", state: "NSW", postcode: "2359" },
{ city: "CAMERONS CREEK", state: "NSW", postcode: "2359" },
{ city: "AUBURN VALE", state: "NSW", postcode: "2360" },
{ city: "BRODIES PLAINS", state: "NSW", postcode: "2360" },
{ city: "BUKKULLA", state: "NSW", postcode: "2360" },
{ city: "CHERRY TREE HILL", state: "NSW", postcode: "2360" },
{ city: "COPETON", state: "NSW", postcode: "2360" },
{ city: "ELSMORE", state: "NSW", postcode: "2360" },
{ city: "GILGAI", state: "NSW", postcode: "2360" },
{ city: "GRAMAN", state: "NSW", postcode: "2360" },
{ city: "GUM FLAT", state: "NSW", postcode: "2360" },
{ city: "HOWELL", state: "NSW", postcode: "2360" },
{ city: "INVERELL", state: "NSW", postcode: "2360" },
{ city: "KINGS PLAINS", state: "NSW", postcode: "2360" },
{ city: "LITTLE PLAIN", state: "NSW", postcode: "2360" },
{ city: "LONG PLAIN", state: "NSW", postcode: "2360" },
{ city: "MOUNT RUSSELL", state: "NSW", postcode: "2360" },
{ city: "NEWSTEAD", state: "NSW", postcode: "2360" },
{ city: "NULLAMANNA", state: "NSW", postcode: "2360" },
{ city: "OAKWOOD", state: "NSW", postcode: "2360" },
{ city: "PARADISE", state: "NSW", postcode: "2360" },
{ city: "ROB ROY", state: "NSW", postcode: "2360" },
{ city: "SAPPHIRE", state: "NSW", postcode: "2360" },
{ city: "SPRING MOUNTAIN", state: "NSW", postcode: "2360" },
{ city: "STANBOROUGH", state: "NSW", postcode: "2360" },
{ city: "SWANBROOK", state: "NSW", postcode: "2360" },
{ city: "WALLANGRA", state: "NSW", postcode: "2360" },
{ city: "WANDERA", state: "NSW", postcode: "2360" },
{ city: "WOODSTOCK", state: "NSW", postcode: "2360" },
{ city: "ASHFORD", state: "NSW", postcode: "2361" },
{ city: "ATHOLWOOD", state: "NSW", postcode: "2361" },
{ city: "BONSHAW", state: "NSW", postcode: "2361" },
{ city: "LIMESTONE", state: "NSW", postcode: "2361" },
{ city: "PINDAROI", state: "NSW", postcode: "2361" },
{ city: "BACKWATER", state: "NSW", postcode: "2365" },
{ city: "BALD BLAIR", state: "NSW", postcode: "2365" },
{ city: "BALDERSLEIGH", state: "NSW", postcode: "2365" },
{ city: "BASSENDEAN", state: "NSW", postcode: "2365" },
{ city: "BEN LOMOND", state: "NSW", postcode: "2365" },
{ city: "BLACK MOUNTAIN", state: "NSW", postcode: "2365" },
{ city: "BRIARBROOK", state: "NSW", postcode: "2365" },
{ city: "BROCKLEY", state: "NSW", postcode: "2365" },
{ city: "BRUSHY CREEK", state: "NSW", postcode: "2365" },
{ city: "FALCONER", state: "NSW", postcode: "2365" },
{ city: "GEORGES CREEK", state: "NSW", postcode: "2365" },
{ city: "GLENCOE", state: "NSW", postcode: "2365" },
{ city: "GLEN NEVIS", state: "NSW", postcode: "2365" },
{ city: "GREEN HILLS", state: "NSW", postcode: "2365" },
{ city: "GUYRA", state: "NSW", postcode: "2365" },
{ city: "LLANGOTHLIN", state: "NSW", postcode: "2365" },
{ city: "MAYBOLE", state: "NSW", postcode: "2365" },
{ city: "MOUNT MITCHELL", state: "NSW", postcode: "2365" },
{ city: "NEW VALLEY", state: "NSW", postcode: "2365" },
{ city: "OBAN", state: "NSW", postcode: "2365" },
{ city: "SOUTH GUYRA", state: "NSW", postcode: "2365" },
{ city: "TENTERDEN", state: "NSW", postcode: "2365" },
{ city: "THE BASIN", state: "NSW", postcode: "2365" },
{ city: "THE GULF", state: "NSW", postcode: "2365" },
{ city: "TUBBAMURRA", state: "NSW", postcode: "2365" },
{ city: "WANDSWORTH", state: "NSW", postcode: "2365" },
{ city: "OLD MILL", state: "NSW", postcode: "2369" },
{ city: "STANNIFER", state: "NSW", postcode: "2369" },
{ city: "TINGHA", state: "NSW", postcode: "2369" },
{ city: "BALD NOB", state: "NSW", postcode: "2370" },
{ city: "DIEHARD", state: "NSW", postcode: "2370" },
{ city: "DUNDEE", state: "NSW", postcode: "2370" },
{ city: "FURRACABAD", state: "NSW", postcode: "2370" },
{ city: "GIBRALTAR RANGE", state: "NSW", postcode: "2370" },
{ city: "GLEN ELGIN", state: "NSW", postcode: "2370" },
{ city: "GLEN INNES", state: "NSW", postcode: "2370" },
{ city: "KINGSGATE", state: "NSW", postcode: "2370" },
{ city: "KINGSLAND", state: "NSW", postcode: "2370" },
{ city: "KOOKABOOKRA", state: "NSW", postcode: "2370" },
{ city: "LAMBS VALLEY", state: "NSW", postcode: "2370" },
{ city: "MATHESON", state: "NSW", postcode: "2370" },
{ city: "MOGGS SWAMP", state: "NSW", postcode: "2370" },
{ city: "MOOGEM", state: "NSW", postcode: "2370" },
{ city: "MORVEN", state: "NSW", postcode: "2370" },
{ city: "NEWTON BOYD", state: "NSW", postcode: "2370" },
{ city: "PINKETT", state: "NSW", postcode: "2370" },
{ city: "RANGERS VALLEY", state: "NSW", postcode: "2370" },
{ city: "REDDESTONE", state: "NSW", postcode: "2370" },
{ city: "RED RANGE", state: "NSW", postcode: "2370" },
{ city: "SHANNON VALE", state: "NSW", postcode: "2370" },
{ city: "STONEHENGE", state: "NSW", postcode: "2370" },
{ city: "SWAN VALE", state: "NSW", postcode: "2370" },
{ city: "WELLINGROVE", state: "NSW", postcode: "2370" },
{ city: "YARROWFORD", state: "NSW", postcode: "2370" },
{ city: "CAPOOMPETA", state: "NSW", postcode: "2371" },
{ city: "DEEPWATER", state: "NSW", postcode: "2371" },
{ city: "EMMAVILLE", state: "NSW", postcode: "2371" },
{ city: "ROCKY CREEK", state: "NSW", postcode: "2371" },
{ city: "STANNUM", state: "NSW", postcode: "2371" },
{ city: "THE GULF", state: "NSW", postcode: "2371" },
{ city: "TORRINGTON", state: "NSW", postcode: "2371" },
{ city: "WELLINGTON VALE", state: "NSW", postcode: "2371" },
{ city: "YELLOW DAM", state: "NSW", postcode: "2371" },
{ city: "BACK CREEK", state: "NSW", postcode: "2372" },
{ city: "BOLIVIA", state: "NSW", postcode: "2372" },
{ city: "BOOKOOKOORARA", state: "NSW", postcode: "2372" },
{ city: "BOONOO BOONOO", state: "NSW", postcode: "2372" },
{ city: "BOOROOK", state: "NSW", postcode: "2372" },
{ city: "CARROLLS CREEK", state: "NSW", postcode: "2372" },
{ city: "CULLENDORE", state: "NSW", postcode: "2372" },
{ city: "DUMARESQ VALLEY", state: "NSW", postcode: "2372" },
{ city: "FOREST LAND", state: "NSW", postcode: "2372" },
{ city: "LISTON", state: "NSW", postcode: "2372" },
{ city: "MOLE RIVER", state: "NSW", postcode: "2372" },
{ city: "RIVERTREE", state: "NSW", postcode: "2372" },
{ city: "ROCKY RIVER", state: "NSW", postcode: "2372" },
{ city: "SANDY FLAT", state: "NSW", postcode: "2372" },
{ city: "SANDY HILL", state: "NSW", postcode: "2372" },
{ city: "SILENT GROVE", state: "NSW", postcode: "2372" },
{ city: "TARBAN", state: "NSW", postcode: "2372" },
{ city: "TENTERFIELD", state: "NSW", postcode: "2372" },
{ city: "TIMBARRA", state: "NSW", postcode: "2372" },
{ city: "WILLSONS DOWNFALL", state: "NSW", postcode: "2372" },
{ city: "WOODSIDE", state: "NSW", postcode: "2372" },
{ city: "WYLIE CREEK", state: "NSW", postcode: "2372" },
{ city: "GOOLHI", state: "NSW", postcode: "2379" },
{ city: "MULLALEY", state: "NSW", postcode: "2379" },
{ city: "NAPIER LANE", state: "NSW", postcode: "2379" },
{ city: "NOMBI", state: "NSW", postcode: "2379" },
{ city: "BLUE VALE", state: "NSW", postcode: "2380" },
{ city: "EMERALD HILL", state: "NSW", postcode: "2380" },
{ city: "GHOOLENDAADI", state: "NSW", postcode: "2380" },
{ city: "GUNNEDAH", state: "NSW", postcode: "2380" },
{ city: "KELVIN", state: "NSW", postcode: "2380" },
{ city: "MARYS MOUNT", state: "NSW", postcode: "2380" },
{ city: "MILROY", state: "NSW", postcode: "2380" },
{ city: "ORANGE GROVE", state: "NSW", postcode: "2380" },
{ city: "RANGARI", state: "NSW", postcode: "2380" },
{ city: "BREEZA", state: "NSW", postcode: "2381" },
{ city: "CURLEWIS", state: "NSW", postcode: "2381" },
{ city: "PREMER", state: "NSW", postcode: "2381" },
{ city: "TAMBAR SPRINGS", state: "NSW", postcode: "2381" },
{ city: "BOGGABRI", state: "NSW", postcode: "2382" },
{ city: "MAULES CREEK", state: "NSW", postcode: "2382" },
{ city: "WEAN", state: "NSW", postcode: "2382" },
{ city: "WILLALA", state: "NSW", postcode: "2382" },
{ city: "BURREN JUNCTION", state: "NSW", postcode: "2386" },
{ city: "DRILDOOL", state: "NSW", postcode: "2386" },
{ city: "NOWLEY", state: "NSW", postcode: "2386" },
{ city: "BULYEROI", state: "NSW", postcode: "2387" },
{ city: "ROWENA", state: "NSW", postcode: "2387" },
{ city: "BOOLCARROLL", state: "NSW", postcode: "2388" },
{ city: "CUTTABRI", state: "NSW", postcode: "2388" },
{ city: "JEWS LAGOON", state: "NSW", postcode: "2388" },
{ city: "MERAH NORTH", state: "NSW", postcode: "2388" },
{ city: "PILLIGA", state: "NSW", postcode: "2388" },
{ city: "SPRING PLAINS", state: "NSW", postcode: "2388" },
{ city: "THE PILLIGA", state: "NSW", postcode: "2388" },
{ city: "WEE WAA", state: "NSW", postcode: "2388" },
{ city: "YARRIE LAKE", state: "NSW", postcode: "2388" },
{ city: "BAAN BAA", state: "NSW", postcode: "2390" },
{ city: "BACK CREEK", state: "NSW", postcode: "2390" },
{ city: "BERRIGAL", state: "NSW", postcode: "2390" },
{ city: "BOHENA CREEK", state: "NSW", postcode: "2390" },
{ city: "BULLAWA CREEK", state: "NSW", postcode: "2390" },
{ city: "COURADDA", state: "NSW", postcode: "2390" },
{ city: "EDGEROI", state: "NSW", postcode: "2390" },
{ city: "EULAH CREEK", state: "NSW", postcode: "2390" },
{ city: "HARPARARY", state: "NSW", postcode: "2390" },
{ city: "JACKS CREEK", state: "NSW", postcode: "2390" },
{ city: "KAPUTAR", state: "NSW", postcode: "2390" },
{ city: "NARRABRI", state: "NSW", postcode: "2390" },
{ city: "NARRABRI WEST", state: "NSW", postcode: "2390" },
{ city: "ROCKY CREEK", state: "NSW", postcode: "2390" },
{ city: "TARRIARO", state: "NSW", postcode: "2390" },
{ city: "TURRAWAN", state: "NSW", postcode: "2390" },
{ city: "BINNAWAY", state: "NSW", postcode: "2395" },
{ city: "ROPERS ROAD", state: "NSW", postcode: "2395" },
{ city: "WEETALIBA", state: "NSW", postcode: "2395" },
{ city: "BARADINE", state: "NSW", postcode: "2396" },
{ city: "BARWON", state: "NSW", postcode: "2396" },
{ city: "GOORIANAWA", state: "NSW", postcode: "2396" },
{ city: "KENEBRI", state: "NSW", postcode: "2396" },
{ city: "BELLATA", state: "NSW", postcode: "2397" },
{ city: "JEWS LAGOON", state: "NSW", postcode: "2397" },
{ city: "MILLIE", state: "NSW", postcode: "2397" },
{ city: "GURLEY", state: "NSW", postcode: "2398" },
{ city: "BINIGUY", state: "NSW", postcode: "2399" },
{ city: "PALLAMALLAWA", state: "NSW", postcode: "2399" },
{ city: "ASHLEY", state: "NSW", postcode: "2400" },
{ city: "BULLARAH", state: "NSW", postcode: "2400" },
{ city: "CROOBLE", state: "NSW", postcode: "2400" },
{ city: "MALLOWA", state: "NSW", postcode: "2400" },
{ city: "MOREE", state: "NSW", postcode: "2400" },
{ city: "MOREE EAST", state: "NSW", postcode: "2400" },
{ city: "TERRY HIE HIE", state: "NSW", postcode: "2400" },
{ city: "TULLOONA", state: "NSW", postcode: "2400" },
{ city: "GRAVESEND", state: "NSW", postcode: "2401" },
{ city: "BALFOURS PEAK", state: "NSW", postcode: "2402" },
{ city: "COOLATAI", state: "NSW", postcode: "2402" },
{ city: "WARIALDA", state: "NSW", postcode: "2402" },
{ city: "WARIALDA RAIL", state: "NSW", postcode: "2402" },
{ city: "BALFOURS PEAK", state: "NSW", postcode: "2403" },
{ city: "DELUNGRA", state: "NSW", postcode: "2403" },
{ city: "GRAGIN", state: "NSW", postcode: "2403" },
{ city: "MYALL CREEK", state: "NSW", postcode: "2403" },
{ city: "BANGHEET", state: "NSW", postcode: "2404" },
{ city: "BINGARA", state: "NSW", postcode: "2404" },
{ city: "DINOGA", state: "NSW", postcode: "2404" },
{ city: "ELCOMBE", state: "NSW", postcode: "2404" },
{ city: "GINEROI", state: "NSW", postcode: "2404" },
{ city: "KEERA", state: "NSW", postcode: "2404" },
{ city: "PALLAL", state: "NSW", postcode: "2404" },
{ city: "RIVERVIEW", state: "NSW", postcode: "2404" },
{ city: "UPPER BINGARA", state: "NSW", postcode: "2404" },
{ city: "BOOMI", state: "NSW", postcode: "2405" },
{ city: "GARAH", state: "NSW", postcode: "2405" },
{ city: "MUNGINDI", state: "NSW", postcode: "2406" },
{ city: "WEEMELAH", state: "NSW", postcode: "2406" },
{ city: "BLUE NOBBY", state: "NSW", postcode: "2408" },
{ city: "NORTH STAR", state: "NSW", postcode: "2408" },
{ city: "YALLAROI", state: "NSW", postcode: "2408" },
{ city: "BOGGABILLA", state: "NSW", postcode: "2409" },
{ city: "BOONAL", state: "NSW", postcode: "2409" },
{ city: "TWIN RIVERS", state: "NSW", postcode: "2410" },
{ city: "YETMAN", state: "NSW", postcode: "2410" },
{ city: "CROPPA CREEK", state: "NSW", postcode: "2411" },
{ city: "MONKERAI", state: "NSW", postcode: "2415" },
{ city: "NOOROO", state: "NSW", postcode: "2415" },
{ city: "STROUD ROAD", state: "NSW", postcode: "2415" },
{ city: "UPPER KARUAH RIVER", state: "NSW", postcode: "2415" },
{ city: "WEISMANTELS", state: "NSW", postcode: "2415" },
{ city: "ALISON", state: "NSW", postcode: "2420" },
{ city: "BANDON GROVE", state: "NSW", postcode: "2420" },
{ city: "BENDOLBA", state: "NSW", postcode: "2420" },
{ city: "BROOKFIELD", state: "NSW", postcode: "2420" },
{ city: "CAMBRA", state: "NSW", postcode: "2420" },
{ city: "CHICHESTER", state: "NSW", postcode: "2420" },
{ city: "DUNGOG", state: "NSW", postcode: "2420" },
{ city: "FLAT TOPS", state: "NSW", postcode: "2420" },
{ city: "FOSTERTON", state: "NSW", postcode: "2420" },
{ city: "HANLEYS CREEK", state: "NSW", postcode: "2420" },
{ city: "HILLDALE", state: "NSW", postcode: "2420" },
{ city: "MAIN CREEK", state: "NSW", postcode: "2420" },
{ city: "MARSHDALE", state: "NSW", postcode: "2420" },
{ city: "MARTINS CREEK", state: "NSW", postcode: "2420" },
{ city: "MUNNI", state: "NSW", postcode: "2420" },
{ city: "SALISBURY", state: "NSW", postcode: "2420" },
{ city: "STROUD HILL", state: "NSW", postcode: "2420" },
{ city: "SUGARLOAF", state: "NSW", postcode: "2420" },
{ city: "TABBIL CREEK", state: "NSW", postcode: "2420" },
{ city: "UNDERBANK", state: "NSW", postcode: "2420" },
{ city: "WALLARINGA", state: "NSW", postcode: "2420" },
{ city: "WALLAROBBA", state: "NSW", postcode: "2420" },
{ city: "WIRRAGULLA", state: "NSW", postcode: "2420" },
{ city: "FISHERS HILL", state: "NSW", postcode: "2421" },
{ city: "PATERSON", state: "NSW", postcode: "2421" },
{ city: "SUMMER HILL", state: "NSW", postcode: "2421" },
{ city: "TOCAL", state: "NSW", postcode: "2421" },
{ city: "TORRYBURN", state: "NSW", postcode: "2421" },
{ city: "VACY", state: "NSW", postcode: "2421" },
{ city: "WEBBERS CREEK", state: "NSW", postcode: "2421" },
{ city: "BACK CREEK", state: "NSW", postcode: "2422" },
{ city: "BAKERS CREEK", state: "NSW", postcode: "2422" },
{ city: "BARRINGTON", state: "NSW", postcode: "2422" },
{ city: "BARRINGTON TOPS", state: "NSW", postcode: "2422" },
{ city: "BAXTERS RIDGE", state: "NSW", postcode: "2422" },
{ city: "BELBORA", state: "NSW", postcode: "2422" },
{ city: "BERRICO", state: "NSW", postcode: "2422" },
{ city: "BINDERA", state: "NSW", postcode: "2422" },
{ city: "BOWMAN", state: "NSW", postcode: "2422" },
{ city: "BOWMAN FARM", state: "NSW", postcode: "2422" },
{ city: "BRETTI", state: "NSW", postcode: "2422" },
{ city: "BULLIAC", state: "NSW", postcode: "2422" },
{ city: "BUNDOOK", state: "NSW", postcode: "2422" },
{ city: "CALLAGHANS CREEK", state: "NSW", postcode: "2422" },
{ city: "COBARK", state: "NSW", postcode: "2422" },
{ city: "CONEAC", state: "NSW", postcode: "2422" },
{ city: "COPELAND", state: "NSW", postcode: "2422" },
{ city: "CRAVEN", state: "NSW", postcode: "2422" },
{ city: "CRAVEN PLATEAU", state: "NSW", postcode: "2422" },
{ city: "CURRICABARK", state: "NSW", postcode: "2422" },
{ city: "DEWITT", state: "NSW", postcode: "2422" },
{ city: "FAULKLAND", state: "NSW", postcode: "2422" },
{ city: "FORBESDALE", state: "NSW", postcode: "2422" },
{ city: "GANGAT", state: "NSW", postcode: "2422" },
{ city: "GIRO", state: "NSW", postcode: "2422" },
{ city: "GLEN WARD", state: "NSW", postcode: "2422" },
{ city: "GLOUCESTER", state: "NSW", postcode: "2422" },
{ city: "GLOUCESTER TOPS", state: "NSW", postcode: "2422" },
{ city: "INVERGORDON", state: "NSW", postcode: "2422" },
{ city: "KIA ORA", state: "NSW", postcode: "2422" },
{ city: "MARES RUN", state: "NSW", postcode: "2422" },
{ city: "MERNOT", state: "NSW", postcode: "2422" },
{ city: "MOGRANI", state: "NSW", postcode: "2422" },
{ city: "MOPPY", state: "NSW", postcode: "2422" },
{ city: "RAWDON VALE", state: "NSW", postcode: "2422" },
{ city: "ROOKHURST", state: "NSW", postcode: "2422" },
{ city: "STRATFORD", state: "NSW", postcode: "2422" },
{ city: "TERREEL", state: "NSW", postcode: "2422" },
{ city: "TIBBUC", state: "NSW", postcode: "2422" },
{ city: "TITAATEE CREEK", state: "NSW", postcode: "2422" },
{ city: "TUGRABAKH", state: "NSW", postcode: "2422" },
{ city: "WALLANBAH", state: "NSW", postcode: "2422" },
{ city: "WARDS RIVER", state: "NSW", postcode: "2422" },
{ city: "WAUKIVORY", state: "NSW", postcode: "2422" },
{ city: "WOKO", state: "NSW", postcode: "2422" },
{ city: "BOMBAH POINT", state: "NSW", postcode: "2423" },
{ city: "BOOLAMBAYTE", state: "NSW", postcode: "2423" },
{ city: "BULAHDELAH", state: "NSW", postcode: "2423" },
{ city: "BUNGWAHL", state: "NSW", postcode: "2423" },
{ city: "COOLONGOLOOK", state: "NSW", postcode: "2423" },
{ city: "CRAWFORD RIVER", state: "NSW", postcode: "2423" },
{ city: "MARKWELL", state: "NSW", postcode: "2423" },
{ city: "MAYERS FLAT", state: "NSW", postcode: "2423" },
{ city: "MUNGO BRUSH", state: "NSW", postcode: "2423" },
{ city: "MYALL LAKE", state: "NSW", postcode: "2423" },
{ city: "NERONG", state: "NSW", postcode: "2423" },
{ city: "SEAL ROCKS", state: "NSW", postcode: "2423" },
{ city: "TOPI TOPI", state: "NSW", postcode: "2423" },
{ city: "UPPER MYALL", state: "NSW", postcode: "2423" },
{ city: "VIOLET HILL", state: "NSW", postcode: "2423" },
{ city: "WANG WAUK", state: "NSW", postcode: "2423" },
{ city: "WARRANULLA", state: "NSW", postcode: "2423" },
{ city: "WILLINA", state: "NSW", postcode: "2423" },
{ city: "WOOTTON", state: "NSW", postcode: "2423" },
{ city: "YAGON", state: "NSW", postcode: "2423" },
{ city: "CAFFREYS FLAT", state: "NSW", postcode: "2424" },
{ city: "CELLS RIVER", state: "NSW", postcode: "2424" },
{ city: "COOPLACURRIPA", state: "NSW", postcode: "2424" },
{ city: "CUNDLE FLAT", state: "NSW", postcode: "2424" },
{ city: "KNORRIT FLAT", state: "NSW", postcode: "2424" },
{ city: "KNORRIT FOREST", state: "NSW", postcode: "2424" },
{ city: "MOUNT GEORGE", state: "NSW", postcode: "2424" },
{ city: "NUMBER ONE", state: "NSW", postcode: "2424" },
{ city: "TIRI", state: "NSW", postcode: "2424" },
{ city: "ALLWORTH", state: "NSW", postcode: "2425" },
{ city: "BOORAL", state: "NSW", postcode: "2425" },
{ city: "GIRVAN", state: "NSW", postcode: "2425" },
{ city: "STROUD", state: "NSW", postcode: "2425" },
{ city: "THE BRANCH", state: "NSW", postcode: "2425" },
{ city: "WASHPOOL", state: "NSW", postcode: "2425" },
{ city: "COOPERNOOK", state: "NSW", postcode: "2426" },
{ city: "LANGLEY VALE", state: "NSW", postcode: "2426" },
{ city: "MOTO", state: "NSW", postcode: "2426" },
{ city: "CROWDY HEAD", state: "NSW", postcode: "2427" },
{ city: "HARRINGTON", state: "NSW", postcode: "2427" },
{ city: "BLUEYS BEACH", state: "NSW", postcode: "2428" },
{ city: "BOOMERANG BEACH", state: "NSW", postcode: "2428" },
{ city: "BOOTI BOOTI", state: "NSW", postcode: "2428" },
{ city: "CHARLOTTE BAY", state: "NSW", postcode: "2428" },
{ city: "COOMBA BAY", state: "NSW", postcode: "2428" },
{ city: "COOMBA PARK", state: "NSW", postcode: "2428" },
{ city: "DARAWANK", state: "NSW", postcode: "2428" },
{ city: "ELIZABETH BEACH", state: "NSW", postcode: "2428" },
{ city: "FORSTER SHOPPING VILLAGE", state: "NSW", postcode: "2428" },
{ city: "GREEN POINT", state: "NSW", postcode: "2428" },
{ city: "PACIFIC PALMS", state: "NSW", postcode: "2428" },
{ city: "SANDBAR", state: "NSW", postcode: "2428" },
{ city: "SHALLOW BAY", state: "NSW", postcode: "2428" },
{ city: "SMITHS LAKE", state: "NSW", postcode: "2428" },
{ city: "TARBUCK BAY", state: "NSW", postcode: "2428" },
{ city: "TIONA", state: "NSW", postcode: "2428" },
{ city: "TUNCURRY", state: "NSW", postcode: "2428" },
{ city: "WALLINGAT", state: "NSW", postcode: "2428" },
{ city: "WALLIS LAKE", state: "NSW", postcode: "2428" },
{ city: "WHOOTA", state: "NSW", postcode: "2428" },
{ city: "BOBIN", state: "NSW", postcode: "2429" },
{ city: "BOORGANNA", state: "NSW", postcode: "2429" },
{ city: "BUCCA WAUKA", state: "NSW", postcode: "2429" },
{ city: "BULGA FOREST", state: "NSW", postcode: "2429" },
{ city: "BUNYAH", state: "NSW", postcode: "2429" },
{ city: "BURRELL CREEK", state: "NSW", postcode: "2429" },
{ city: "CAPARRA", state: "NSW", postcode: "2429" },
{ city: "CEDAR PARTY", state: "NSW", postcode: "2429" },
{ city: "COMBOYNE", state: "NSW", postcode: "2429" },
{ city: "DINGO FOREST", state: "NSW", postcode: "2429" },
{ city: "DOLLYS FLAT", state: "NSW", postcode: "2429" },
{ city: "DYERS CROSSING", state: "NSW", postcode: "2429" },
{ city: "ELANDS", state: "NSW", postcode: "2429" },
{ city: "FIREFLY", state: "NSW", postcode: "2429" },
{ city: "INNES VIEW", state: "NSW", postcode: "2429" },
{ city: "KARAAK FLAT", state: "NSW", postcode: "2429" },
{ city: "KHATAMBUHL", state: "NSW", postcode: "2429" },
{ city: "KILLABAKH", state: "NSW", postcode: "2429" },
{ city: "KILLAWARRA", state: "NSW", postcode: "2429" },
{ city: "KIMBRIKI", state: "NSW", postcode: "2429" },
{ city: "KIPPAXS", state: "NSW", postcode: "2429" },
{ city: "KRAMBACH", state: "NSW", postcode: "2429" },
{ city: "KUNDIBAKH", state: "NSW", postcode: "2429" },
{ city: "MARLEE", state: "NSW", postcode: "2429" },
{ city: "MOORAL CREEK", state: "NSW", postcode: "2429" },
{ city: "STRATHCEDAR", state: "NSW", postcode: "2429" },
{ city: "THE BIGHT", state: "NSW", postcode: "2429" },
{ city: "TIPPERARY", state: "NSW", postcode: "2429" },
{ city: "WARRIWILLAH", state: "NSW", postcode: "2429" },
{ city: "WHERROL FLAT", state: "NSW", postcode: "2429" },
{ city: "WINGHAM", state: "NSW", postcode: "2429" },
{ city: "YARRATT FOREST", state: "NSW", postcode: "2429" },
{ city: "BLACK HEAD", state: "NSW", postcode: "2430" },
{ city: "BOHNOCK", state: "NSW", postcode: "2430" },
{ city: "BOOTAWA", state: "NSW", postcode: "2430" },
{ city: "BRIMBIN", state: "NSW", postcode: "2430" },
{ city: "ARAKOON", state: "NSW", postcode: "2431" },
{ city: "JERSEYVILLE", state: "NSW", postcode: "2431" },
{ city: "SOUTH WEST ROCKS", state: "NSW", postcode: "2431" },
{ city: "BATAR CREEK", state: "NSW", postcode: "2439" },
{ city: "BLACK CREEK", state: "NSW", postcode: "2439" },
{ city: "KENDALL", state: "NSW", postcode: "2439" },
{ city: "KEREWONG", state: "NSW", postcode: "2439" },
{ city: "KEW", state: "NSW", postcode: "2439" },
{ city: "LOGANS CROSSING", state: "NSW", postcode: "2439" },
{ city: "LORNE", state: "NSW", postcode: "2439" },
{ city: "ROSSGLEN", state: "NSW", postcode: "2439" },
{ city: "SWANS CROSSING", state: "NSW", postcode: "2439" },
{ city: "UPSALLS CREEK", state: "NSW", postcode: "2439" },
{ city: "ALDAVILLA", state: "NSW", postcode: "2440" },
{ city: "AUSTRAL EDEN", state: "NSW", postcode: "2440" },
{ city: "BELLBROOK", state: "NSW", postcode: "2440" },
{ city: "BELLIMBOPINNI", state: "NSW", postcode: "2440" },
{ city: "BELMORE RIVER", state: "NSW", postcode: "2440" },
{ city: "BURNT BRIDGE", state: "NSW", postcode: "2440" },
{ city: "CARRAI", state: "NSW", postcode: "2440" },
{ city: "CLYBUCCA", state: "NSW", postcode: "2440" },
{ city: "COLLOMBATTI", state: "NSW", postcode: "2440" },
{ city: "COMARA", state: "NSW", postcode: "2440" },
{ city: "CORANGULA", state: "NSW", postcode: "2440" },
{ city: "CRESCENT HEAD", state: "NSW", postcode: "2440" },
{ city: "DEEP CREEK", state: "NSW", postcode: "2440" },
{ city: "DONDINGALONG", state: "NSW", postcode: "2440" },
{ city: "EUROKA", state: "NSW", postcode: "2440" },
{ city: "FREDERICKTON", state: "NSW", postcode: "2440" },
{ city: "GREENHILL", state: "NSW", postcode: "2440" },
{ city: "HAMPDEN HALL", state: "NSW", postcode: "2440" },
{ city: "HAT HEAD", state: "NSW", postcode: "2440" },
{ city: "HICKEYS CREEK", state: "NSW", postcode: "2440" },
{ city: "KEMPSEY", state: "NSW", postcode: "2440" },
{ city: "KINCHELA", state: "NSW", postcode: "2440" },
{ city: "LOWER CREEK", state: "NSW", postcode: "2440" },
{ city: "MILLBANK", state: "NSW", postcode: "2440" },
{ city: "MOONEBA", state: "NSW", postcode: "2440" },
{ city: "MOPARRABAH", state: "NSW", postcode: "2440" },
{ city: "MUNGAY CREEK", state: "NSW", postcode: "2440" },
{ city: "OLD STATION", state: "NSW", postcode: "2440" },
{ city: "POLA CREEK", state: "NSW", postcode: "2440" },
{ city: "RAINBOW REACH", state: "NSW", postcode: "2440" },
{ city: "SEVEN OAKS", state: "NSW", postcode: "2440" },
{ city: "SHERWOOD", state: "NSW", postcode: "2440" },
{ city: "SKILLION FLAT", state: "NSW", postcode: "2440" },
{ city: "SMITHTOWN", state: "NSW", postcode: "2440" },
{ city: "SUMMER ISLAND", state: "NSW", postcode: "2440" },
{ city: "TEMAGOG", state: "NSW", postcode: "2440" },
{ city: "TOOROOKA", state: "NSW", postcode: "2440" },
{ city: "TURNERS FLAT", state: "NSW", postcode: "2440" },
{ city: "VERGES CREEK", state: "NSW", postcode: "2440" },
{ city: "WILLAWARRIN", state: "NSW", postcode: "2440" },
{ city: "WILLI WILLI", state: "NSW", postcode: "2440" },
{ city: "WITTITRIN", state: "NSW", postcode: "2440" },
{ city: "YARRAVEL", state: "NSW", postcode: "2440" },
{ city: "YESSABAH", state: "NSW", postcode: "2440" },
{ city: "ALLGOMERA", state: "NSW", postcode: "2441" },
{ city: "BALLENGARRA", state: "NSW", postcode: "2441" },
{ city: "BARRAGANYATTI", state: "NSW", postcode: "2441" },
{ city: "BONVILLE", state: "NSW", postcode: "2441" },
{ city: "BRIL BRIL", state: "NSW", postcode: "2441" },
{ city: "BRINERVILLE", state: "NSW", postcode: "2441" },
{ city: "COOPERABUNG", state: "NSW", postcode: "2441" },
{ city: "EUNGAI CREEK", state: "NSW", postcode: "2441" },
{ city: "EUNGAI RAIL", state: "NSW", postcode: "2441" },
{ city: "FISHERMANS REACH", state: "NSW", postcode: "2441" },
{ city: "GRASSY HEAD", state: "NSW", postcode: "2441" },
{ city: "GUM SCRUB", state: "NSW", postcode: "2441" },
{ city: "HACKS FERRY", state: "NSW", postcode: "2441" },
{ city: "KIPPARA", state: "NSW", postcode: "2441" },
{ city: "KUNDABUNG", state: "NSW", postcode: "2441" },
{ city: "MARLO MERRICAN", state: "NSW", postcode: "2441" },
{ city: "ROLLANDS PLAINS", state: "NSW", postcode: "2441" },
{ city: "STUARTS POINT", state: "NSW", postcode: "2441" },
{ city: "TAMBAN", state: "NSW", postcode: "2441" },
{ city: "TELEGRAPH POINT", state: "NSW", postcode: "2441" },
{ city: "UPPER ROLLANDS PLAINS", state: "NSW", postcode: "2441" },
{ city: "YARRAHAPINNI", state: "NSW", postcode: "2441" },
{ city: "BOBS CREEK", state: "NSW", postcode: "2443" },
{ city: "CAMDEN HEAD", state: "NSW", postcode: "2443" },
{ city: "CORALVILLE", state: "NSW", postcode: "2443" },
{ city: "CROWDY BAY NATIONAL PARK", state: "NSW", postcode: "2443" },
{ city: "DEAUVILLE", state: "NSW", postcode: "2443" },
{ city: "DIAMOND HEAD", state: "NSW", postcode: "2443" },
{ city: "DUNBOGAN", state: "NSW", postcode: "2443" },
{ city: "HANNAM VALE", state: "NSW", postcode: "2443" },
{ city: "HERONS CREEK", state: "NSW", postcode: "2443" },
{ city: "JOHNS RIVER", state: "NSW", postcode: "2443" },
{ city: "LAKEWOOD", state: "NSW", postcode: "2443" },
{ city: "LAURIETON", state: "NSW", postcode: "2443" },
{ city: "MIDDLE BROTHER", state: "NSW", postcode: "2443" },
{ city: "MOORLAND", state: "NSW", postcode: "2443" },
{ city: "NORTH BROTHER", state: "NSW", postcode: "2443" },
{ city: "NORTH HAVEN", state: "NSW", postcode: "2443" },
{ city: "STEWARTS RIVER", state: "NSW", postcode: "2443" },
{ city: "WAITUI", state: "NSW", postcode: "2443" },
{ city: "WEST HAVEN", state: "NSW", postcode: "2443" },
{ city: "BONNY HILLS", state: "NSW", postcode: "2445" },
{ city: "GRANTS BEACH", state: "NSW", postcode: "2445" },
{ city: "JOLLY NOSE", state: "NSW", postcode: "2445" },
{ city: "LAKE CATHIE", state: "NSW", postcode: "2445" },
{ city: "BAGNOO", state: "NSW", postcode: "2446" },
{ city: "BAGO", state: "NSW", postcode: "2446" },
{ city: "BANDA BANDA", state: "NSW", postcode: "2446" },
{ city: "BEECHWOOD", state: "NSW", postcode: "2446" },
{ city: "BELLANGRY", state: "NSW", postcode: "2446" },
{ city: "BIRDWOOD", state: "NSW", postcode: "2446" },
{ city: "BROMBIN", state: "NSW", postcode: "2446" },
{ city: "BYABARRA", state: "NSW", postcode: "2446" },
{ city: "CAIRNCROSS", state: "NSW", postcode: "2446" },
{ city: "CROSSLANDS", state: "NSW", postcode: "2446" },
{ city: "DEBENHAM", state: "NSW", postcode: "2446" },
{ city: "DOYLES RIVER", state: "NSW", postcode: "2446" },
{ city: "ELLENBOROUGH", state: "NSW", postcode: "2446" },
{ city: "FORBES RIVER", state: "NSW", postcode: "2446" },
{ city: "FRAZERS CREEK", state: "NSW", postcode: "2446" },
{ city: "GEARYS FLAT", state: "NSW", postcode: "2446" },
{ city: "HARTYS PLAINS", state: "NSW", postcode: "2446" },
{ city: "HOLLISDALE", state: "NSW", postcode: "2446" },
{ city: "HUNTINGDON", state: "NSW", postcode: "2446" },
{ city: "HYNDMANS CREEK", state: "NSW", postcode: "2446" },
{ city: "KINDEE", state: "NSW", postcode: "2446" },
{ city: "KING CREEK", state: "NSW", postcode: "2446" },
{ city: "LAKE INNES", state: "NSW", postcode: "2446" },
{ city: "LONG FLAT", state: "NSW", postcode: "2446" },
{ city: "LOWER PAPPINBARRA", state: "NSW", postcode: "2446" },
{ city: "MARLO MERRICAN", state: "NSW", postcode: "2446" },
{ city: "MORTONS CREEK", state: "NSW", postcode: "2446" },
{ city: "MOUNT SEAVIEW", state: "NSW", postcode: "2446" },
{ city: "PAPPINBARRA", state: "NSW", postcode: "2446" },
{ city: "PEMBROOKE", state: "NSW", postcode: "2446" },
{ city: "PIPECLAY", state: "NSW", postcode: "2446" },
{ city: "RAWDON ISLAND", state: "NSW", postcode: "2446" },
{ city: "REDBANK", state: "NSW", postcode: "2446" },
{ city: "ROSEWOOD", state: "NSW", postcode: "2446" },
{ city: "SANCROX", state: "NSW", postcode: "2446" },
{ city: "TOMS CREEK", state: "NSW", postcode: "2446" },
{ city: "UPPER PAPPINBARRA", state: "NSW", postcode: "2446" },
{ city: "WAUCHOPE", state: "NSW", postcode: "2446" },
{ city: "WERRIKIMBE", state: "NSW", postcode: "2446" },
{ city: "YARRAS", state: "NSW", postcode: "2446" },
{ city: "YIPPIN CREEK", state: "NSW", postcode: "2446" },
{ city: "BAKERS CREEK", state: "NSW", postcode: "2447" },
{ city: "BURRAPINE", state: "NSW", postcode: "2447" },
{ city: "CONGARINNI", state: "NSW", postcode: "2447" },
{ city: "CONGARINNI NORTH", state: "NSW", postcode: "2447" },
{ city: "DONNELLYVILLE", state: "NSW", postcode: "2447" },
{ city: "GUMMA", state: "NSW", postcode: "2447" },
{ city: "MACKSVILLE", state: "NSW", postcode: "2447" },
{ city: "NEWEE CREEK", state: "NSW", postcode: "2447" },
{ city: "NORTH MACKSVILLE", state: "NSW", postcode: "2447" },
{ city: "SCOTTS HEAD", state: "NSW", postcode: "2447" },
{ city: "TALARM", state: "NSW", postcode: "2447" },
{ city: "TAYLORS ARM", state: "NSW", postcode: "2447" },
{ city: "THUMB CREEK", state: "NSW", postcode: "2447" },
{ city: "UPPER TAYLORS ARM", state: "NSW", postcode: "2447" },
{ city: "UTUNGUN", state: "NSW", postcode: "2447" },
{ city: "WARRELL CREEK", state: "NSW", postcode: "2447" },
{ city: "WAY WAY", state: "NSW", postcode: "2447" },
{ city: "WIRRIMBI", state: "NSW", postcode: "2447" },
{ city: "YARRANBELLA", state: "NSW", postcode: "2447" },
{ city: "HYLAND PARK", state: "NSW", postcode: "2448" },
{ city: "NAMBUCCA HEADS", state: "NSW", postcode: "2448" },
{ city: "VALLA", state: "NSW", postcode: "2448" },
{ city: "VALLA BEACH", state: "NSW", postcode: "2448" },
{ city: "ARGENTS HILL", state: "NSW", postcode: "2449" },
{ city: "BOWRAVILLE", state: "NSW", postcode: "2449" },
{ city: "BUCKRA BENDINNI", state: "NSW", postcode: "2449" },
{ city: "GIRRALONG", state: "NSW", postcode: "2449" },
{ city: "KENNAICLE CREEK", state: "NSW", postcode: "2449" },
{ city: "KILLIEKRANKIE", state: "NSW", postcode: "2449" },
{ city: "MISSABOTTI", state: "NSW", postcode: "2449" },
{ city: "SOUTH ARM", state: "NSW", postcode: "2449" },
{ city: "TEWINGA", state: "NSW", postcode: "2449" },
{ city: "BONVILLE", state: "NSW", postcode: "2450" },
{ city: "BROOKLANA", state: "NSW", postcode: "2450" },
{ city: "BUCCA", state: "NSW", postcode: "2450" },
{ city: "CORAMBA", state: "NSW", postcode: "2450" },
{ city: "GLENREAGH", state: "NSW", postcode: "2450" },
{ city: "KARANGI", state: "NSW", postcode: "2450" },
{ city: "KORORA", state: "NSW", postcode: "2450" },
{ city: "LOWANNA", state: "NSW", postcode: "2450" },
{ city: "MOONEE BEACH", state: "NSW", postcode: "2450" },
{ city: "NANA GLEN", state: "NSW", postcode: "2450" },
{ city: "NORTH BOAMBEE VALLEY", state: "NSW", postcode: "2450" },
{ city: "SAPPHIRE BEACH", state: "NSW", postcode: "2450" },
{ city: "SHERWOOD", state: "NSW", postcode: "2450" },
{ city: "ULONG", state: "NSW", postcode: "2450" },
{ city: "UPPER ORARA", state: "NSW", postcode: "2450" },
{ city: "BIELSDOWN HILLS", state: "NSW", postcode: "2453" },
{ city: "BILLYS CREEK", state: "NSW", postcode: "2453" },
{ city: "BOSTOBRICK", state: "NSW", postcode: "2453" },
{ city: "CASCADE", state: "NSW", postcode: "2453" },
{ city: "CLOUDS CREEK", state: "NSW", postcode: "2453" },
{ city: "DEER VALE", state: "NSW", postcode: "2453" },
{ city: "DORRIGO", state: "NSW", postcode: "2453" },
{ city: "DORRIGO MOUNTAIN", state: "NSW", postcode: "2453" },
{ city: "DUNDURRABIN", state: "NSW", postcode: "2453" },
{ city: "EBOR", state: "NSW", postcode: "2453" },
{ city: "FERNBROOK", state: "NSW", postcode: "2453" },
{ city: "HERNANI", state: "NSW", postcode: "2453" },
{ city: "MARENGO", state: "NSW", postcode: "2453" },
{ city: "MEGAN", state: "NSW", postcode: "2453" },
{ city: "MOONPAR", state: "NSW", postcode: "2453" },
{ city: "NEVER NEVER", state: "NSW", postcode: "2453" },
{ city: "NORTH DORRIGO", state: "NSW", postcode: "2453" },
{ city: "TALLOWWOOD RIDGE", state: "NSW", postcode: "2453" },
{ city: "TYRINGHAM", state: "NSW", postcode: "2453" },
{ city: "WILD CATTLE CREEK", state: "NSW", postcode: "2453" },
{ city: "BELLINGEN", state: "NSW", postcode: "2454" },
{ city: "BRIERFIELD", state: "NSW", postcode: "2454" },
{ city: "BRINERVILLE", state: "NSW", postcode: "2454" },
{ city: "BUNDAGEN", state: "NSW", postcode: "2454" },
{ city: "DARKWOOD", state: "NSW", postcode: "2454" },
{ city: "FERNMOUNT", state: "NSW", postcode: "2454" },
{ city: "GLENIFFER", state: "NSW", postcode: "2454" },
{ city: "KALANG", state: "NSW", postcode: "2454" },
{ city: "MYLESTOM", state: "NSW", postcode: "2454" },
{ city: "RALEIGH", state: "NSW", postcode: "2454" },
{ city: "REPTON", state: "NSW", postcode: "2454" },
{ city: "SPICKETTS CREEK", state: "NSW", postcode: "2454" },
{ city: "THORA", state: "NSW", postcode: "2454" },
{ city: "VALERY", state: "NSW", postcode: "2454" },
{ city: "URUNGA", state: "NSW", postcode: "2455" },
{ city: "ARRAWARRA", state: "NSW", postcode: "2456" },
{ city: "ARRAWARRA HEADLAND", state: "NSW", postcode: "2456" },
{ city: "CORINDI BEACH", state: "NSW", postcode: "2456" },
{ city: "DIRTY CREEK", state: "NSW", postcode: "2456" },
{ city: "EMERALD BEACH", state: "NSW", postcode: "2456" },
{ city: "MULLAWAY", state: "NSW", postcode: "2456" },
{ city: "RED ROCK", state: "NSW", postcode: "2456" },
{ city: "SAFETY BEACH", state: "NSW", postcode: "2456" },
{ city: "SANDY BEACH", state: "NSW", postcode: "2456" },
{ city: "UPPER CORINDI", state: "NSW", postcode: "2456" },
{ city: "WOOLGOOLGA", state: "NSW", postcode: "2456" },
{ city: "ALICE", state: "NSW", postcode: "2460" },
{ city: "ALUMY CREEK", state: "NSW", postcode: "2460" },
{ city: "BANYABBA", state: "NSW", postcode: "2460" },
{ city: "BARCOONGERE", state: "NSW", postcode: "2460" },
{ city: "BARRETTS CREEK", state: "NSW", postcode: "2460" },
{ city: "BARYULGIL", state: "NSW", postcode: "2460" },
{ city: "BLAXLANDS CREEK", state: "NSW", postcode: "2460" },
{ city: "BOM BOM", state: "NSW", postcode: "2460" },
{ city: "BOOKRAM", state: "NSW", postcode: "2460" },
{ city: "BRAUNSTONE", state: "NSW", postcode: "2460" },
{ city: "BRUSHGROVE", state: "NSW", postcode: "2460" },
{ city: "BUCCARUMBI", state: "NSW", postcode: "2460" },
{ city: "CALAMIA", state: "NSW", postcode: "2460" },
{ city: "CANGAI", state: "NSW", postcode: "2460" },
{ city: "CARNHAM", state: "NSW", postcode: "2460" },
{ city: "CARRS CREEK", state: "NSW", postcode: "2460" },
{ city: "CARRS ISLAND", state: "NSW", postcode: "2460" },
{ city: "CARRS PENINSULAR", state: "NSW", postcode: "2460" },
{ city: "CHAELUNDI", state: "NSW", postcode: "2460" },
{ city: "CHAMBIGNE", state: "NSW", postcode: "2460" },
{ city: "CLARENZA", state: "NSW", postcode: "2460" },
{ city: "CLIFDEN", state: "NSW", postcode: "2460" },
{ city: "COALDALE", state: "NSW", postcode: "2460" },
{ city: "COLLUM COLLUM", state: "NSW", postcode: "2460" },
{ city: "COOMBADJHA", state: "NSW", postcode: "2460" },
{ city: "COPMANHURST", state: "NSW", postcode: "2460" },
{ city: "COUTTS CROSSING", state: "NSW", postcode: "2460" },
{ city: "COWPER", state: "NSW", postcode: "2460" },
{ city: "CROWTHER ISLAND", state: "NSW", postcode: "2460" },
{ city: "DALMORTON", state: "NSW", postcode: "2460" },
{ city: "DEEP CREEK", state: "NSW", postcode: "2460" },
{ city: "DILKOON", state: "NSW", postcode: "2460" },
{ city: "DIRTY CREEK", state: "NSW", postcode: "2460" },
{ city: "DUMBUDGERY", state: "NSW", postcode: "2460" },
{ city: "EATONSVILLE", state: "NSW", postcode: "2460" },
{ city: "EIGHTEEN MILE", state: "NSW", postcode: "2460" },
{ city: "ELLAND", state: "NSW", postcode: "2460" },
{ city: "FINE FLOWER", state: "NSW", postcode: "2460" },
{ city: "FORTIS CREEK", state: "NSW", postcode: "2460" },
{ city: "GLENUGIE", state: "NSW", postcode: "2460" },
{ city: "GREAT MARLOW", state: "NSW", postcode: "2460" },
{ city: "GURRANANG", state: "NSW", postcode: "2460" },
{ city: "HALFWAY CREEK", state: "NSW", postcode: "2460" },
{ city: "HEIFER STATION", state: "NSW", postcode: "2460" },
{ city: "JACKADGERY", state: "NSW", postcode: "2460" },
{ city: "JUNCTION HILL", state: "NSW", postcode: "2460" },
{ city: "KANGAROO CREEK", state: "NSW", postcode: "2460" },
{ city: "KOOLKHAN", state: "NSW", postcode: "2460" },
{ city: "KREMNOS", state: "NSW", postcode: "2460" },
{ city: "KUNGALA", state: "NSW", postcode: "2460" },
{ city: "KYARRAN", state: "NSW", postcode: "2460" },
{ city: "LANITZA", state: "NSW", postcode: "2460" },
{ city: "LAWRENCE", state: "NSW", postcode: "2460" },
{ city: "LEVENSTRATH", state: "NSW", postcode: "2460" },
{ city: "LILYDALE", state: "NSW", postcode: "2460" },
{ city: "LIONSVILLE", state: "NSW", postcode: "2460" },
{ city: "LOWER SOUTHGATE", state: "NSW", postcode: "2460" },
{ city: "MALABUGILMAH", state: "NSW", postcode: "2460" },
{ city: "MOLEVILLE CREEK", state: "NSW", postcode: "2460" },
{ city: "MOUNTAIN VIEW", state: "NSW", postcode: "2460" },
{ city: "MYLNEFORD", state: "NSW", postcode: "2460" },
{ city: "NEWBOLD", state: "NSW", postcode: "2460" },
{ city: "NYMBOIDA", state: "NSW", postcode: "2460" },
{ city: "PULGANBAR", state: "NSW", postcode: "2460" },
{ city: "PUNCHBOWL", state: "NSW", postcode: "2460" },
{ city: "RAMORNIE", state: "NSW", postcode: "2460" },
{ city: "RUSHFORTH", state: "NSW", postcode: "2460" },
{ city: "SANDY CROSSING", state: "NSW", postcode: "2460" },
{ city: "SEELANDS", state: "NSW", postcode: "2460" },
{ city: "SHANNONDALE", state: "NSW", postcode: "2460" },
{ city: "SMITHS CREEK", state: "NSW", postcode: "2460" },
{ city: "SOUTHAMPTON", state: "NSW", postcode: "2460" },
{ city: "SOUTH ARM", state: "NSW", postcode: "2460" },
{ city: "STOCKYARD CREEK", state: "NSW", postcode: "2460" },
{ city: "THE PINNACLES", state: "NSW", postcode: "2460" },
{ city: "THE WHITEMAN", state: "NSW", postcode: "2460" },
{ city: "TOWALLUM", state: "NSW", postcode: "2460" },
{ city: "TRENAYR", state: "NSW", postcode: "2460" },
{ city: "TYNDALE", state: "NSW", postcode: "2460" },
{ city: "UPPER COPMANHURST", state: "NSW", postcode: "2460" },
{ city: "UPPER FINE FLOWER", state: "NSW", postcode: "2460" },
{ city: "WARRAGAI CREEK", state: "NSW", postcode: "2460" },
{ city: "WASHPOOL", state: "NSW", postcode: "2460" },
{ city: "WATERVIEW", state: "NSW", postcode: "2460" },
{ city: "WATERVIEW HEIGHTS", state: "NSW", postcode: "2460" },
{ city: "WELLS CROSSING", state: "NSW", postcode: "2460" },
{ city: "WHITEMAN CREEK", state: "NSW", postcode: "2460" },
{ city: "WINEGROVE", state: "NSW", postcode: "2460" },
{ city: "WOMBAT CREEK", state: "NSW", postcode: "2460" },
{ city: "CALLIOPE", state: "NSW", postcode: "2462" },
{ city: "COLDSTREAM", state: "NSW", postcode: "2462" },
{ city: "DIGGERS CAMP", state: "NSW", postcode: "2462" },
{ city: "GILLETTS RIDGE", state: "NSW", postcode: "2462" },
{ city: "LAKE HIAWATHA", state: "NSW", postcode: "2462" },
{ city: "LAVADIA", state: "NSW", postcode: "2462" },
{ city: "MINNIE WATER", state: "NSW", postcode: "2462" },
{ city: "PILLAR VALLEY", state: "NSW", postcode: "2462" },
{ city: "SWAN CREEK", state: "NSW", postcode: "2462" },
{ city: "TUCABIA", state: "NSW", postcode: "2462" },
{ city: "ULMARRA", state: "NSW", postcode: "2462" },
{ city: "WOOLI", state: "NSW", postcode: "2462" },
{ city: "ASHBY", state: "NSW", postcode: "2463" },
{ city: "ASHBY HEIGHTS", state: "NSW", postcode: "2463" },
{ city: "ASHBY ISLAND", state: "NSW", postcode: "2463" },
{ city: "BROOMS HEAD", state: "NSW", postcode: "2463" },
{ city: "GULMARRAD", state: "NSW", postcode: "2463" },
{ city: "ILARWILL", state: "NSW", postcode: "2463" },
{ city: "JACKY BULBIN FLAT", state: "NSW", postcode: "2463" },
{ city: "JAMES CREEK", state: "NSW", postcode: "2463" },
{ city: "MACLEAN", state: "NSW", postcode: "2463" },
{ city: "PALMERS CHANNEL", state: "NSW", postcode: "2463" },
{ city: "PALMERS ISLAND", state: "NSW", postcode: "2463" },
{ city: "SANDON", state: "NSW", postcode: "2463" },
{ city: "SHARK CREEK", state: "NSW", postcode: "2463" },
{ city: "TALOUMBI", state: "NSW", postcode: "2463" },
{ city: "THE SANDON", state: "NSW", postcode: "2463" },
{ city: "TOWNSEND", state: "NSW", postcode: "2463" },
{ city: "TULLYMORGAN", state: "NSW", postcode: "2463" },
{ city: "WOODFORD ISLAND", state: "NSW", postcode: "2463" },
{ city: "ANGOURIE", state: "NSW", postcode: "2464" },
{ city: "FREEBURN ISLAND", state: "NSW", postcode: "2464" },
{ city: "MICALO ISLAND", state: "NSW", postcode: "2464" },
{ city: "WOOLOWEYAH", state: "NSW", postcode: "2464" },
{ city: "YURAYGIR", state: "NSW", postcode: "2464" },
{ city: "HARWOOD", state: "NSW", postcode: "2465" },
{ city: "THE FRESHWATER", state: "NSW", postcode: "2466" },
{ city: "WOODY HEAD", state: "NSW", postcode: "2466" },
{ city: "ALICE", state: "NSW", postcode: "2469" },
{ city: "BANYABBA", state: "NSW", postcode: "2469" },
{ city: "BEAN CREEK", state: "NSW", postcode: "2469" },
{ city: "BINGEEBEEBRA CREEK", state: "NSW", postcode: "2469" },
{ city: "BONALBO", state: "NSW", postcode: "2469" },
{ city: "BOTTLE CREEK", state: "NSW", postcode: "2469" },
{ city: "BULLDOG", state: "NSW", postcode: "2469" },
{ city: "BUNGAWALBIN", state: "NSW", postcode: "2469" },
{ city: "BUSBYS FLAT", state: "NSW", postcode: "2469" },
{ city: "CAMBRIDGE PLATEAU", state: "NSW", postcode: "2469" },
{ city: "CAMIRA", state: "NSW", postcode: "2469" },
{ city: "CAPEEN CREEK", state: "NSW", postcode: "2469" },
{ city: "CHATSWORTH", state: "NSW", postcode: "2469" },
{ city: "CLEARFIELD", state: "NSW", postcode: "2469" },
{ city: "COONGBAR", state: "NSW", postcode: "2469" },
{ city: "CULMARAN CREEK", state: "NSW", postcode: "2469" },
{ city: "DEEP CREEK", state: "NSW", postcode: "2469" },
{ city: "DRAKE", state: "NSW", postcode: "2469" },
{ city: "DRAKE VILLAGE", state: "NSW", postcode: "2469" },
{ city: "DUCK CREEK", state: "NSW", postcode: "2469" },
{ city: "EWINGAR", state: "NSW", postcode: "2469" },
{ city: "GIBBERAGEE", state: "NSW", postcode: "2469" },
{ city: "GOODWOOD ISLAND", state: "NSW", postcode: "2469" },
{ city: "GORGE CREEK", state: "NSW", postcode: "2469" },
{ city: "HAYSTACK", state: "NSW", postcode: "2469" },
{ city: "HOGARTH RANGE", state: "NSW", postcode: "2469" },
{ city: "JACKSONS FLAT", state: "NSW", postcode: "2469" },
{ city: "JOES BOX", state: "NSW", postcode: "2469" },
{ city: "KEYBARBIN", state: "NSW", postcode: "2469" },
{ city: "KIPPENDUFF", state: "NSW", postcode: "2469" },
{ city: "LOUISA CREEK", state: "NSW", postcode: "2469" },
{ city: "LOWER BOTTLE CREEK", state: "NSW", postcode: "2469" },
{ city: "LOWER DUCK CREEK", state: "NSW", postcode: "2469" },
{ city: "LOWER PEACOCK", state: "NSW", postcode: "2469" },
{ city: "MALLANGANEE", state: "NSW", postcode: "2469" },
{ city: "MOOKIMA WYBRA", state: "NSW", postcode: "2469" },
{ city: "MORORO", state: "NSW", postcode: "2469" },
{ city: "MOUNT MARSH", state: "NSW", postcode: "2469" },
{ city: "MUMMULGUM", state: "NSW", postcode: "2469" },
{ city: "MYRTLE CREEK", state: "NSW", postcode: "2469" },
{ city: "OLD BONALBO", state: "NSW", postcode: "2469" },
{ city: "PADDYS FLAT", state: "NSW", postcode: "2469" },
{ city: "PAGANS FLAT", state: "NSW", postcode: "2469" },
{ city: "PEACOCK CREEK", state: "NSW", postcode: "2469" },
{ city: "PIKAPENE", state: "NSW", postcode: "2469" },
{ city: "RAPPVILLE", state: "NSW", postcode: "2469" },
{ city: "SANDILANDS", state: "NSW", postcode: "2469" },
{ city: "SIMPKINS CREEK", state: "NSW", postcode: "2469" },
{ city: "SIX MILE SWAMP", state: "NSW", postcode: "2469" },
{ city: "TABULAM", state: "NSW", postcode: "2469" },
{ city: "THERESA CREEK", state: "NSW", postcode: "2469" },
{ city: "TUNGLEBUNG", state: "NSW", postcode: "2469" },
{ city: "UPPER DUCK CREEK", state: "NSW", postcode: "2469" },
{ city: "WARREGAH ISLAND", state: "NSW", postcode: "2469" },
{ city: "WHIPORIE", state: "NSW", postcode: "2469" },
{ city: "WOOMBAH", state: "NSW", postcode: "2469" },
{ city: "WYAN", state: "NSW", postcode: "2469" },
{ city: "YABBRA", state: "NSW", postcode: "2469" },
{ city: "BABYL CREEK", state: "NSW", postcode: "2470" },
{ city: "BACKMEDE", state: "NSW", postcode: "2470" },
{ city: "CASINO", state: "NSW", postcode: "2470" },
{ city: "COOMBELL", state: "NSW", postcode: "2470" },
{ city: "DOBIES BIGHT", state: "NSW", postcode: "2470" },
{ city: "DOUBTFUL CREEK", state: "NSW", postcode: "2470" },
{ city: "DYRAABA", state: "NSW", postcode: "2470" },
{ city: "ELLANGOWAN", state: "NSW", postcode: "2470" },
{ city: "FAIRY HILL", state: "NSW", postcode: "2470" },
{ city: "IRVINGTON", state: "NSW", postcode: "2470" },
{ city: "LEEVILLE", state: "NSW", postcode: "2470" },
{ city: "LOWER DYRAABA", state: "NSW", postcode: "2470" },
{ city: "MONGOGARIE", state: "NSW", postcode: "2470" },
{ city: "NAUGHTONS GAP", state: "NSW", postcode: "2470" },
{ city: "NORTH CASINO", state: "NSW", postcode: "2470" },
{ city: "PIORA", state: "NSW", postcode: "2470" },
{ city: "SEXTONVILLE", state: "NSW", postcode: "2470" },
{ city: "SHANNON BROOK", state: "NSW", postcode: "2470" },
{ city: "SPRING GROVE", state: "NSW", postcode: "2470" },
{ city: "STRATHEDEN", state: "NSW", postcode: "2470" },
{ city: "TOMKI", state: "NSW", postcode: "2470" },
{ city: "UPPER MONGOGARIE", state: "NSW", postcode: "2470" },
{ city: "WOODVIEW", state: "NSW", postcode: "2470" },
{ city: "WOOLNERS ARM", state: "NSW", postcode: "2470" },
{ city: "YORKLEA", state: "NSW", postcode: "2470" },
{ city: "BORA RIDGE", state: "NSW", postcode: "2471" },
{ city: "CODRINGTON", state: "NSW", postcode: "2471" },
{ city: "CORAKI", state: "NSW", postcode: "2471" },
{ city: "EAST CORAKI", state: "NSW", postcode: "2471" },
{ city: "GREEN FOREST", state: "NSW", postcode: "2471" },
{ city: "GREENRIDGE", state: "NSW", postcode: "2471" },
{ city: "NORTH WOODBURN", state: "NSW", postcode: "2471" },
{ city: "SWAN BAY", state: "NSW", postcode: "2471" },
{ city: "TATHAM", state: "NSW", postcode: "2471" },
{ city: "WEST BUNGAWALBIN", state: "NSW", postcode: "2471" },
{ city: "WEST CORAKI", state: "NSW", postcode: "2471" },
{ city: "BROADWATER", state: "NSW", postcode: "2472" },
{ city: "BUCKENDOON", state: "NSW", postcode: "2472" },
{ city: "ESK", state: "NSW", postcode: "2472" },
{ city: "KILGIN", state: "NSW", postcode: "2472" },
{ city: "MOONEM", state: "NSW", postcode: "2472" },
{ city: "NEW ITALY", state: "NSW", postcode: "2472" },
{ city: "RILEYS HILL", state: "NSW", postcode: "2472" },
{ city: "TABBIMOBLE", state: "NSW", postcode: "2472" },
{ city: "THE GAP", state: "NSW", postcode: "2472" },
{ city: "TRUSTUMS HILL", state: "NSW", postcode: "2472" },
{ city: "WOODBURN", state: "NSW", postcode: "2472" },
{ city: "BUNDJALUNG", state: "NSW", postcode: "2473" },
{ city: "DOONBAH", state: "NSW", postcode: "2473" },
{ city: "EVANS HEAD", state: "NSW", postcode: "2473" },
{ city: "IRON GATES", state: "NSW", postcode: "2473" },
{ city: "SOUTH EVANS HEAD", state: "NSW", postcode: "2473" },
{ city: "AFTERLEE", state: "NSW", postcode: "2474" },
{ city: "BARKERS VALE", state: "NSW", postcode: "2474" },
{ city: "BORDER RANGES", state: "NSW", postcode: "2474" },
{ city: "CAWONGLA", state: "NSW", postcode: "2474" },
{ city: "CEDAR POINT", state: "NSW", postcode: "2474" },
{ city: "COLLINS CREEK", state: "NSW", postcode: "2474" },
{ city: "COUGAL", state: "NSW", postcode: "2474" },
{ city: "DAIRY FLAT", state: "NSW", postcode: "2474" },
{ city: "EDEN CREEK", state: "NSW", postcode: "2474" },
{ city: "EDENVILLE", state: "NSW", postcode: "2474" },
{ city: "ETTRICK", state: "NSW", postcode: "2474" },
{ city: "FAWCETTS PLAIN", state: "NSW", postcode: "2474" },
{ city: "FINDON CREEK", state: "NSW", postcode: "2474" },
{ city: "GENEVA", state: "NSW", postcode: "2474" },
{ city: "GHINNI GHI", state: "NSW", postcode: "2474" },
{ city: "GRADYS CREEK", state: "NSW", postcode: "2474" },
{ city: "GREEN PIGEON", state: "NSW", postcode: "2474" },
{ city: "GREVILLIA", state: "NSW", postcode: "2474" },
{ city: "HOMELEIGH", state: "NSW", postcode: "2474" },
{ city: "HORSESHOE CREEK", state: "NSW", postcode: "2474" },
{ city: "HORSE STATION CREEK", state: "NSW", postcode: "2474" },
{ city: "IRON POT CREEK", state: "NSW", postcode: "2474" },
{ city: "KILGRA", state: "NSW", postcode: "2474" },
{ city: "KYOGLE", state: "NSW", postcode: "2474" },
{ city: "LITTLE BACK CREEK", state: "NSW", postcode: "2474" },
{ city: "LOADSTONE", state: "NSW", postcode: "2474" },
{ city: "LYNCHS CREEK", state: "NSW", postcode: "2474" },
{ city: "NEW PARK", state: "NSW", postcode: "2474" },
{ city: "OLD GREVILLIA", state: "NSW", postcode: "2474" },
{ city: "ROSEBERRY", state: "NSW", postcode: "2474" },
{ city: "ROSEBERRY CREEK", state: "NSW", postcode: "2474" },
{ city: "RUKENVALE", state: "NSW", postcode: "2474" },
{ city: "SAWPIT CREEK", state: "NSW", postcode: "2474" },
{ city: "SHERWOOD", state: "NSW", postcode: "2474" },
{ city: "SMITHS CREEK", state: "NSW", postcode: "2474" },
{ city: "TERRACE CREEK", state: "NSW", postcode: "2474" },
{ city: "THE RISK", state: "NSW", postcode: "2474" },
{ city: "TOONUMBAR", state: "NSW", postcode: "2474" },
{ city: "UNUMGAR", state: "NSW", postcode: "2474" },
{ city: "UPPER EDEN CREEK", state: "NSW", postcode: "2474" },
{ city: "UPPER HORSESHOE CREEK", state: "NSW", postcode: "2474" },
{ city: "WADEVILLE", state: "NSW", postcode: "2474" },
{ city: "WARRAZAMBIL CREEK", state: "NSW", postcode: "2474" },
{ city: "WEST WIANGAREE", state: "NSW", postcode: "2474" },
{ city: "WIANGAREE", state: "NSW", postcode: "2474" },
{ city: "WYNEDEN", state: "NSW", postcode: "2474" },
{ city: "TOOLOOM", state: "NSW", postcode: "2475" },
{ city: "UPPER TOOLOOM", state: "NSW", postcode: "2475" },
{ city: "URBENVILLE", state: "NSW", postcode: "2475" },
{ city: "ACACIA CREEK", state: "NSW", postcode: "2476" },
{ city: "BOOMI CREEK", state: "NSW", postcode: "2476" },
{ city: "BRUMBY PLAINS", state: "NSW", postcode: "2476" },
{ city: "KOREELAH", state: "NSW", postcode: "2476" },
{ city: "LEGUME", state: "NSW", postcode: "2476" },
{ city: "LINDESAY CREEK", state: "NSW", postcode: "2476" },
{ city: "LOWER ACACIA CREEK", state: "NSW", postcode: "2476" },
{ city: "MULI MULI", state: "NSW", postcode: "2476" },
{ city: "OLD KOREELAH", state: "NSW", postcode: "2476" },
{ city: "THE GLEN", state: "NSW", postcode: "2476" },
{ city: "WOODENBONG", state: "NSW", postcode: "2476" },
{ city: "ALSTONVALE", state: "NSW", postcode: "2477" },
{ city: "ALSTONVILLE", state: "NSW", postcode: "2477" },
{ city: "BAGOTVILLE", state: "NSW", postcode: "2477" },
{ city: "CABBAGE TREE ISLAND", state: "NSW", postcode: "2477" },
{ city: "DALWOOD", state: "NSW", postcode: "2477" },
{ city: "EAST WARDELL", state: "NSW", postcode: "2477" },
{ city: "GOAT ISLAND", state: "NSW", postcode: "2477" },
{ city: "LYNWOOD", state: "NSW", postcode: "2477" },
{ city: "MEERSCHAUM VALE", state: "NSW", postcode: "2477" },
{ city: "PEARCES CREEK", state: "NSW", postcode: "2477" },
{ city: "ROUS", state: "NSW", postcode: "2477" },
{ city: "ROUS MILL", state: "NSW", postcode: "2477" },
{ city: "TUCKOMBIL", state: "NSW", postcode: "2477" },
{ city: "URALBA", state: "NSW", postcode: "2477" },
{ city: "WARDELL", state: "NSW", postcode: "2477" },
{ city: "WOLLONGBAR", state: "NSW", postcode: "2477" },
{ city: "BALLINA", state: "NSW", postcode: "2478" },
{ city: "BALLINA DC", state: "NSW", postcode: "2478" },
{ city: "COOLGARDIE", state: "NSW", postcode: "2478" },
{ city: "CUMBALUM", state: "NSW", postcode: "2478" },
{ city: "EAST BALLINA", state: "NSW", postcode: "2478" },
{ city: "EMPIRE VALE", state: "NSW", postcode: "2478" },
{ city: "KEITH HALL", state: "NSW", postcode: "2478" },
{ city: "KINVARA", state: "NSW", postcode: "2478" },
{ city: "LENNOX HEAD", state: "NSW", postcode: "2478" },
{ city: "PATCHS BEACH", state: "NSW", postcode: "2478" },
{ city: "PIMLICO", state: "NSW", postcode: "2478" },
{ city: "PIMLICO ISLAND", state: "NSW", postcode: "2478" },
{ city: "SKENNARS HEAD", state: "NSW", postcode: "2478" },
{ city: "SOUTH BALLINA", state: "NSW", postcode: "2478" },
{ city: "TEVEN", state: "NSW", postcode: "2478" },
{ city: "TINTENBAR", state: "NSW", postcode: "2478" },
{ city: "WEST BALLINA", state: "NSW", postcode: "2478" },
{ city: "BANGALOW", state: "NSW", postcode: "2479" },
{ city: "BINNA BURRA", state: "NSW", postcode: "2479" },
{ city: "BROOKLET", state: "NSW", postcode: "2479" },
{ city: "COOPERS SHOOT", state: "NSW", postcode: "2479" },
{ city: "COORABELL", state: "NSW", postcode: "2479" },
{ city: "FERNLEIGH", state: "NSW", postcode: "2479" },
{ city: "KNOCKROW", state: "NSW", postcode: "2479" },
{ city: "MCLEODS SHOOT", state: "NSW", postcode: "2479" },
{ city: "NASHUA", state: "NSW", postcode: "2479" },
{ city: "NEWRYBAR", state: "NSW", postcode: "2479" },
{ city: "POSSUM CREEK", state: "NSW", postcode: "2479" },
{ city: "BENTLEY", state: "NSW", postcode: "2480" },
{ city: "BEXHILL", state: "NSW", postcode: "2480" },
{ city: "BLAKEBROOK", state: "NSW", postcode: "2480" },
{ city: "BLUE KNOB", state: "NSW", postcode: "2480" },
{ city: "BOAT HARBOUR", state: "NSW", postcode: "2480" },
{ city: "BOOERIE CREEK", state: "NSW", postcode: "2480" },
{ city: "BOORABEE PARK", state: "NSW", postcode: "2480" },
{ city: "BOOYONG", state: "NSW", postcode: "2480" },
{ city: "BUNGABBEE", state: "NSW", postcode: "2480" },
{ city: "CANIABA", state: "NSW", postcode: "2480" },
{ city: "CHILCOTTS GRASS", state: "NSW", postcode: "2480" },
{ city: "CLOVASS", state: "NSW", postcode: "2480" },
{ city: "CLUNES", state: "NSW", postcode: "2480" },
{ city: "COFFEE CAMP", state: "NSW", postcode: "2480" },
{ city: "CORNDALE", state: "NSW", postcode: "2480" },
{ city: "DORROUGHBY", state: "NSW", postcode: "2480" },
{ city: "DUNGARUBBA", state: "NSW", postcode: "2480" },
{ city: "DUNOON", state: "NSW", postcode: "2480" },
{ city: "ELTHAM", state: "NSW", postcode: "2480" },
{ city: "EUREKA", state: "NSW", postcode: "2480" },
{ city: "FEDERAL", state: "NSW", postcode: "2480" },
{ city: "FERNSIDE", state: "NSW", postcode: "2480" },
{ city: "GEORGICA", state: "NSW", postcode: "2480" },
{ city: "GIRARDS HILL", state: "NSW", postcode: "2480" },
{ city: "GOOLMANGAR", state: "NSW", postcode: "2480" },
{ city: "GOONELLABAH", state: "NSW", postcode: "2480" },
{ city: "HOWARDS GRASS", state: "NSW", postcode: "2480" },
{ city: "JIGGI", state: "NSW", postcode: "2480" },
{ city: "KEERRONG", state: "NSW", postcode: "2480" },
{ city: "KOONORIGAN", state: "NSW", postcode: "2480" },
{ city: "LAGOON GRASS", state: "NSW", postcode: "2480" },
{ city: "LARNOOK", state: "NSW", postcode: "2480" },
{ city: "LEYCESTER", state: "NSW", postcode: "2480" },
{ city: "LILLIAN ROCK", state: "NSW", postcode: "2480" },
{ city: "LINDENDALE", state: "NSW", postcode: "2480" },
{ city: "LOFTVILLE", state: "NSW", postcode: "2480" },
{ city: "MAROM CREEK", state: "NSW", postcode: "2480" },
{ city: "MCKEES HILL", state: "NSW", postcode: "2480" },
{ city: "MCLEANS RIDGES", state: "NSW", postcode: "2480" },
{ city: "MODANVILLE", state: "NSW", postcode: "2480" },
{ city: "MONALTRIE", state: "NSW", postcode: "2480" },
{ city: "MOUNTAIN TOP", state: "NSW", postcode: "2480" },
{ city: "NIGHTCAP", state: "NSW", postcode: "2480" },
{ city: "NIMBIN", state: "NSW", postcode: "2480" },
{ city: "NUMULGI", state: "NSW", postcode: "2480" },
{ city: "REPENTANCE CREEK", state: "NSW", postcode: "2480" },
{ city: "RICHMOND HILL", state: "NSW", postcode: "2480" },
{ city: "ROCK VALLEY", state: "NSW", postcode: "2480" },
{ city: "ROSEBANK", state: "NSW", postcode: "2480" },
{ city: "RUTHVEN", state: "NSW", postcode: "2480" },
{ city: "SOUTH GUNDURIMBA", state: "NSW", postcode: "2480" },
{ city: "STONY CHUTE", state: "NSW", postcode: "2480" },
{ city: "TERANIA CREEK", state: "NSW", postcode: "2480" },
{ city: "THE CHANNON", state: "NSW", postcode: "2480" },
{ city: "TREGEAGLE", state: "NSW", postcode: "2480" },
{ city: "TUCKI TUCKI", state: "NSW", postcode: "2480" },
{ city: "TUCKURIMBA", state: "NSW", postcode: "2480" },
{ city: "TULLERA", state: "NSW", postcode: "2480" },
{ city: "TUNCESTER", state: "NSW", postcode: "2480" },
{ city: "TUNTABLE CREEK", state: "NSW", postcode: "2480" },
{ city: "WHIAN WHIAN", state: "NSW", postcode: "2480" },
{ city: "WOODLAWN", state: "NSW", postcode: "2480" },
{ city: "WYRALLAH", state: "NSW", postcode: "2480" },
{ city: "BROKEN HEAD", state: "NSW", postcode: "2481" },
{ city: "BYRON BAY", state: "NSW", postcode: "2481" },
{ city: "EWINGSDALE", state: "NSW", postcode: "2481" },
{ city: "HAYTERS HILL", state: "NSW", postcode: "2481" },
{ city: "MYOCUM", state: "NSW", postcode: "2481" },
{ city: "SKINNERS SHOOT", state: "NSW", postcode: "2481" },
{ city: "SUFFOLK PARK", state: "NSW", postcode: "2481" },
{ city: "TALOFA", state: "NSW", postcode: "2481" },
{ city: "TYAGARAH", state: "NSW", postcode: "2481" },
{ city: "GOONENGERRY", state: "NSW", postcode: "2482" },
{ city: "HUONBROOK", state: "NSW", postcode: "2482" },
{ city: "KOONYUM RANGE", state: "NSW", postcode: "2482" },
{ city: "MAIN ARM", state: "NSW", postcode: "2482" },
{ city: "MONTECOLLUM", state: "NSW", postcode: "2482" },
{ city: "MULLUMBIMBY", state: "NSW", postcode: "2482" },
{ city: "MULLUMBIMBY CREEK", state: "NSW", postcode: "2482" },
{ city: "PALMWOODS", state: "NSW", postcode: "2482" },
{ city: "UPPER COOPERS CREEK", state: "NSW", postcode: "2482" },
{ city: "UPPER MAIN ARM", state: "NSW", postcode: "2482" },
{ city: "UPPER WILSONS CREEK", state: "NSW", postcode: "2482" },
{ city: "WANGANUI", state: "NSW", postcode: "2482" },
{ city: "WILSONS CREEK", state: "NSW", postcode: "2482" },
{ city: "BILLINUDGEL", state: "NSW", postcode: "2483" },
{ city: "BRUNSWICK HEADS", state: "NSW", postcode: "2483" },
{ city: "BURRINGBAR", state: "NSW", postcode: "2483" },
{ city: "CRABBES CREEK", state: "NSW", postcode: "2483" },
{ city: "MIDDLE POCKET", state: "NSW", postcode: "2483" },
{ city: "MOOBALL", state: "NSW", postcode: "2483" },
{ city: "NEW BRIGHTON", state: "NSW", postcode: "2483" },
{ city: "OCEAN SHORES", state: "NSW", postcode: "2483" },
{ city: "SLEEPY HOLLOW", state: "NSW", postcode: "2483" },
{ city: "SOUTH GOLDEN BEACH", state: "NSW", postcode: "2483" },
{ city: "THE POCKET", state: "NSW", postcode: "2483" },
{ city: "UPPER BURRINGBAR", state: "NSW", postcode: "2483" },
{ city: "WOOYUNG", state: "NSW", postcode: "2483" },
{ city: "YELGUN", state: "NSW", postcode: "2483" },
{ city: "BACK CREEK", state: "NSW", postcode: "2484" },
{ city: "BRAY PARK", state: "NSW", postcode: "2484" },
{ city: "BRAYS CREEK", state: "NSW", postcode: "2484" },
{ city: "BYANGUM", state: "NSW", postcode: "2484" },
{ city: "BYRRILL CREEK", state: "NSW", postcode: "2484" },
{ city: "CEDAR CREEK", state: "NSW", postcode: "2484" },
{ city: "CHILLINGHAM", state: "NSW", postcode: "2484" },
{ city: "CHOWAN CREEK", state: "NSW", postcode: "2484" },
{ city: "CLOTHIERS CREEK", state: "NSW", postcode: "2484" },
{ city: "COMMISSIONERS CREEK", state: "NSW", postcode: "2484" },
{ city: "CONDONG", state: "NSW", postcode: "2484" },
{ city: "CRYSTAL CREEK", state: "NSW", postcode: "2484" },
{ city: "CUDGERA CREEK", state: "NSW", postcode: "2484" },
{ city: "DOON DOON", state: "NSW", postcode: "2484" },
{ city: "DULGUIGAN", state: "NSW", postcode: "2484" },
{ city: "DUM DUM", state: "NSW", postcode: "2484" },
{ city: "DUNBIBLE", state: "NSW", postcode: "2484" },
{ city: "DUNGAY", state: "NSW", postcode: "2484" },
{ city: "EUNGELLA", state: "NSW", postcode: "2484" },
{ city: "EVIRON", state: "NSW", postcode: "2484" },
{ city: "FARRANTS HILL", state: "NSW", postcode: "2484" },
{ city: "FERNVALE", state: "NSW", postcode: "2484" },
{ city: "HOPKINS CREEK", state: "NSW", postcode: "2484" },
{ city: "KIELVALE", state: "NSW", postcode: "2484" },
{ city: "KUNGHUR", state: "NSW", postcode: "2484" },
{ city: "KUNGHUR CREEK", state: "NSW", postcode: "2484" },
{ city: "KYNNUMBOON", state: "NSW", postcode: "2484" },
{ city: "LIMPINWOOD", state: "NSW", postcode: "2484" },
{ city: "MEBBIN", state: "NSW", postcode: "2484" },
{ city: "MIDGINBIL", state: "NSW", postcode: "2484" },
{ city: "MOUNT BURRELL", state: "NSW", postcode: "2484" },
{ city: "MOUNT WARNING", state: "NSW", postcode: "2484" },
{ city: "MURWILLUMBAH", state: "NSW", postcode: "2484" },
{ city: "MURWILLUMBAH SOUTH", state: "NSW", postcode: "2484" },
{ city: "NOBBYS CREEK", state: "NSW", postcode: "2484" },
{ city: "NORTH ARM", state: "NSW", postcode: "2484" },
{ city: "NUMINBAH", state: "NSW", postcode: "2484" },
{ city: "NUNDERI", state: "NSW", postcode: "2484" },
{ city: "PALMVALE", state: "NSW", postcode: "2484" },
{ city: "PUMPENBIL", state: "NSW", postcode: "2484" },
{ city: "RESERVE CREEK", state: "NSW", postcode: "2484" },
{ city: "ROUND MOUNTAIN", state: "NSW", postcode: "2484" },
{ city: "ROWLANDS CREEK", state: "NSW", postcode: "2484" },
{ city: "SMITHS CREEK", state: "NSW", postcode: "2484" },
{ city: "SOUTH MURWILLUMBAH", state: "NSW", postcode: "2484" },
{ city: "STOKERS SIDING", state: "NSW", postcode: "2484" },
{ city: "TERRAGON", state: "NSW", postcode: "2484" },
{ city: "TOMEWIN", state: "NSW", postcode: "2484" },
{ city: "TYALGUM", state: "NSW", postcode: "2484" },
{ city: "TYALGUM CREEK", state: "NSW", postcode: "2484" },
{ city: "TYGALGAH", state: "NSW", postcode: "2484" },
{ city: "UKI", state: "NSW", postcode: "2484" },
{ city: "UPPER CRYSTAL CREEK", state: "NSW", postcode: "2484" },
{ city: "URLIUP", state: "NSW", postcode: "2484" },
{ city: "WARDROP VALLEY", state: "NSW", postcode: "2484" },
{ city: "ZARA", state: "NSW", postcode: "2484" },
{ city: "TWEED HEADS WEST", state: "NSW", postcode: "2485" },
{ city: "BANORA POINT", state: "NSW", postcode: "2486" },
{ city: "BILAMBIL", state: "NSW", postcode: "2486" },
{ city: "BILAMBIL HEIGHTS", state: "NSW", postcode: "2486" },
{ city: "BUNGALORA", state: "NSW", postcode: "2486" },
{ city: "CAROOL", state: "NSW", postcode: "2486" },
{ city: "COBAKI", state: "NSW", postcode: "2486" },
{ city: "COBAKI LAKES", state: "NSW", postcode: "2486" },
{ city: "DUROBY", state: "NSW", postcode: "2486" },
{ city: "GLENGARRIE", state: "NSW", postcode: "2486" },
{ city: "PIGGABEEN", state: "NSW", postcode: "2486" },
{ city: "TERRANORA", state: "NSW", postcode: "2486" },
{ city: "UPPER DUROBY", state: "NSW", postcode: "2486" },
{ city: "CASUARINA", state: "NSW", postcode: "2487" },
{ city: "CHINDERAH", state: "NSW", postcode: "2487" },
{ city: "CUDGEN", state: "NSW", postcode: "2487" },
{ city: "DURANBAH", state: "NSW", postcode: "2487" },
{ city: "FINGAL HEAD", state: "NSW", postcode: "2487" },
{ city: "KINGSCLIFF", state: "NSW", postcode: "2487" },
{ city: "KINGS FOREST", state: "NSW", postcode: "2487" },
{ city: "STOTTS CREEK", state: "NSW", postcode: "2487" },
{ city: "BOGANGAR", state: "NSW", postcode: "2488" },
{ city: "CABARITA BEACH", state: "NSW", postcode: "2488" },
{ city: "TANGLEWOOD", state: "NSW", postcode: "2488" },
{ city: "HASTINGS POINT", state: "NSW", postcode: "2489" },
{ city: "POTTSVILLE", state: "NSW", postcode: "2489" },
{ city: "POTTSVILLE BEACH", state: "NSW", postcode: "2489" },
{ city: "NORTH TUMBULGUM", state: "NSW", postcode: "2490" },
{ city: "TUMBULGUM", state: "NSW", postcode: "2490" },
{ city: "COALCLIFF", state: "NSW", postcode: "2508" },
{ city: "DARKES FOREST", state: "NSW", postcode: "2508" },
{ city: "HELENSBURGH", state: "NSW", postcode: "2508" },
{ city: "LILYVALE", state: "NSW", postcode: "2508" },
{ city: "MADDENS PLAINS", state: "NSW", postcode: "2508" },
{ city: "OTFORD", state: "NSW", postcode: "2508" },
{ city: "STANWELL PARK", state: "NSW", postcode: "2508" },
{ city: "STANWELL TOPS", state: "NSW", postcode: "2508" },
{ city: "WORONORA DAM", state: "NSW", postcode: "2508" },
{ city: "CLIFTON", state: "NSW", postcode: "2515" },
{ city: "COLEDALE", state: "NSW", postcode: "2515" },
{ city: "WOMBARRA", state: "NSW", postcode: "2515" },
{ city: "PENROSE", state: "NSW", postcode: "2530" },
{ city: "BOMBO", state: "NSW", postcode: "2533" },
{ city: "CURRAMORE", state: "NSW", postcode: "2533" },
{ city: "JAMBEROO", state: "NSW", postcode: "2533" },
{ city: "JERRARA", state: "NSW", postcode: "2533" },
{ city: "SADDLEBACK MOUNTAIN", state: "NSW", postcode: "2533" },
{ city: "BROUGHTON VILLAGE", state: "NSW", postcode: "2534" },
{ city: "FOXGROUND", state: "NSW", postcode: "2534" },
{ city: "GERRINGONG", state: "NSW", postcode: "2534" },
{ city: "GERROA", state: "NSW", postcode: "2534" },
{ city: "ROSE VALLEY", state: "NSW", postcode: "2534" },
{ city: "TOOLIJOOA", state: "NSW", postcode: "2534" },
{ city: "WERRI BEACH", state: "NSW", postcode: "2534" },
{ city: "WILLOW VALE", state: "NSW", postcode: "2534" },
{ city: "BACK FOREST", state: "NSW", postcode: "2535" },
{ city: "BELLAWONGARAH", state: "NSW", postcode: "2535" },
{ city: "BERRY MOUNTAIN", state: "NSW", postcode: "2535" },
{ city: "BROGERS CREEK", state: "NSW", postcode: "2535" },
{ city: "BROUGHTON", state: "NSW", postcode: "2535" },
{ city: "BROUGHTON VALE", state: "NSW", postcode: "2535" },
{ city: "BUDDEROO", state: "NSW", postcode: "2535" },
{ city: "BUNDEWALLAH", state: "NSW", postcode: "2535" },
{ city: "COOLANGATTA", state: "NSW", postcode: "2535" },
{ city: "FAR MEADOW", state: "NSW", postcode: "2535" },
{ city: "JASPERS BRUSH", state: "NSW", postcode: "2535" },
{ city: "SHOALHAVEN HEADS", state: "NSW", postcode: "2535" },
{ city: "WATTAMOLLA", state: "NSW", postcode: "2535" },
{ city: "WOODHILL", state: "NSW", postcode: "2535" },
{ city: "PYREE", state: "NSW", postcode: "2540" },
{ city: "SWANHAVEN", state: "NSW", postcode: "2540" },
{ city: "TAPITALLEE", state: "NSW", postcode: "2540" },
{ city: "TERARA", state: "NSW", postcode: "2540" },
{ city: "TOMERONG", state: "NSW", postcode: "2540" },
{ city: "WANDANDIAN", state: "NSW", postcode: "2540" },
{ city: "WOOLLAMIA", state: "NSW", postcode: "2540" },
{ city: "WORRIGEE", state: "NSW", postcode: "2540" },
{ city: "WORROWING HEIGHTS", state: "NSW", postcode: "2540" },
{ city: "WRIGHTS BEACH", state: "NSW", postcode: "2540" },
{ city: "YALWAL", state: "NSW", postcode: "2540" },
{ city: "YERRIYONG", state: "NSW", postcode: "2540" },
{ city: "BANGALEE", state: "NSW", postcode: "2541" },
{ city: "MENANGLE PARK", state: "NSW", postcode: "2563" },
{ city: "MENANGLE", state: "NSW", postcode: "2568" },
{ city: "DOUGLAS PARK", state: "NSW", postcode: "2569" },
{ city: "BELIMBLA PARK", state: "NSW", postcode: "2570" },
{ city: "BICKLEY VALE", state: "NSW", postcode: "2570" },
{ city: "BROWNLOW HILL", state: "NSW", postcode: "2570" },
{ city: "ELDERSLIE", state: "NSW", postcode: "2570" },
{ city: "ELLIS LANE", state: "NSW", postcode: "2570" },
{ city: "GLENMORE", state: "NSW", postcode: "2570" },
{ city: "GRASMERE", state: "NSW", postcode: "2570" },
{ city: "KIRKHAM", state: "NSW", postcode: "2570" },
{ city: "MOUNT HUNTER", state: "NSW", postcode: "2570" },
{ city: "NATTAI", state: "NSW", postcode: "2570" },
{ city: "OAKDALE", state: "NSW", postcode: "2570" },
{ city: "ORANGEVILLE", state: "NSW", postcode: "2570" },
{ city: "SPRING FARM", state: "NSW", postcode: "2570" },
{ city: "WEROMBI", state: "NSW", postcode: "2570" },
{ city: "BALMORAL", state: "NSW", postcode: "2571" },
{ city: "BUXTON", state: "NSW", postcode: "2571" },
{ city: "COURIDJAH", state: "NSW", postcode: "2571" },
{ city: "MOWBRAY PARK", state: "NSW", postcode: "2571" },
{ city: "RAZORBACK", state: "NSW", postcode: "2571" },
{ city: "WILTON", state: "NSW", postcode: "2571" },
{ city: "LAKESLAND", state: "NSW", postcode: "2572" },
{ city: "TAHMOOR", state: "NSW", postcode: "2573" },
{ city: "AVON", state: "NSW", postcode: "2574" },
{ city: "BARGO", state: "NSW", postcode: "2574" },
{ city: "PHEASANTS NEST", state: "NSW", postcode: "2574" },
{ city: "YANDERRA", state: "NSW", postcode: "2574" },
{ city: "ALPINE", state: "NSW", postcode: "2575" },
{ city: "AYLMERTON", state: "NSW", postcode: "2575" },
{ city: "BALACLAVA", state: "NSW", postcode: "2575" },
{ city: "BRAEMAR", state: "NSW", postcode: "2575" },
{ city: "BULLIO", state: "NSW", postcode: "2575" },
{ city: "COLO VALE", state: "NSW", postcode: "2575" },
{ city: "GOODMANS FORD", state: "NSW", postcode: "2575" },
{ city: "HIGH RANGE", state: "NSW", postcode: "2575" },
{ city: "HILL TOP", state: "NSW", postcode: "2575" },
{ city: "JOADJA", state: "NSW", postcode: "2575" },
{ city: "MANDEMAR", state: "NSW", postcode: "2575" },
{ city: "MOUNT LINDSEY", state: "NSW", postcode: "2575" },
{ city: "RENWICK", state: "NSW", postcode: "2575" },
{ city: "WATTLE RIDGE", state: "NSW", postcode: "2575" },
{ city: "WELBY", state: "NSW", postcode: "2575" },
{ city: "WILLOW VALE", state: "NSW", postcode: "2575" },
{ city: "WOODLANDS", state: "NSW", postcode: "2575" },
{ city: "YERRINBOOL", state: "NSW", postcode: "2575" },
{ city: "BURRADOO", state: "NSW", postcode: "2576" },
{ city: "EAST KANGALOON", state: "NSW", postcode: "2576" },
{ city: "GLENQUARRY", state: "NSW", postcode: "2576" },
{ city: "KANGALOON", state: "NSW", postcode: "2576" },
{ city: "AVOCA", state: "NSW", postcode: "2577" },
{ city: "BANGADILLY", state: "NSW", postcode: "2577" },
{ city: "BARRENGARRY", state: "NSW", postcode: "2577" },
{ city: "BARREN GROUNDS", state: "NSW", postcode: "2577" },
{ city: "BEAUMONT", state: "NSW", postcode: "2577" },
{ city: "BELANGLO", state: "NSW", postcode: "2577" },
{ city: "BUDGONG", state: "NSW", postcode: "2577" },
{ city: "BURRAWANG", state: "NSW", postcode: "2577" },
{ city: "CANYONLEIGH", state: "NSW", postcode: "2577" },
{ city: "CARRINGTON FALLS", state: "NSW", postcode: "2577" },
{ city: "FITZROY FALLS", state: "NSW", postcode: "2577" },
{ city: "HANGING ROCK", state: "NSW", postcode: "2577" },
{ city: "KANGAROO VALLEY", state: "NSW", postcode: "2577" },
{ city: "KNIGHTS HILL", state: "NSW", postcode: "2577" },
{ city: "MACQUARIE PASS", state: "NSW", postcode: "2577" },
{ city: "MANCHESTER SQUARE", state: "NSW", postcode: "2577" },
{ city: "MEDWAY", state: "NSW", postcode: "2577" },
{ city: "MERYLA", state: "NSW", postcode: "2577" },
{ city: "MOUNT MURRAY", state: "NSW", postcode: "2577" },
{ city: "NEW BERRIMA", state: "NSW", postcode: "2577" },
{ city: "PADDYS RIVER", state: "NSW", postcode: "2577" },
{ city: "RED ROCKS", state: "NSW", postcode: "2577" },
{ city: "ROBERTSON", state: "NSW", postcode: "2577" },
{ city: "SUTTON FOREST", state: "NSW", postcode: "2577" },
{ city: "UPPER KANGAROO RIVER", state: "NSW", postcode: "2577" },
{ city: "UPPER KANGAROO VALLEY", state: "NSW", postcode: "2577" },
{ city: "WERAI", state: "NSW", postcode: "2577" },
{ city: "WILDES MEADOW", state: "NSW", postcode: "2577" },
{ city: "BUNDANOON", state: "NSW", postcode: "2578" },
{ city: "BIG HILL", state: "NSW", postcode: "2579" },
{ city: "BRAYTON", state: "NSW", postcode: "2579" },
{ city: "EXETER", state: "NSW", postcode: "2579" },
{ city: "MARULAN", state: "NSW", postcode: "2579" },
{ city: "PENROSE", state: "NSW", postcode: "2579" },
{ city: "TALLONG", state: "NSW", postcode: "2579" },
{ city: "WINGELLO", state: "NSW", postcode: "2579" },
{ city: "PALING YARDS", state: "NSW", postcode: "2580" },
{ city: "BELLMOUNT FOREST", state: "NSW", postcode: "2581" },
{ city: "BEVENDALE", state: "NSW", postcode: "2581" },
{ city: "BIALA", state: "NSW", postcode: "2581" },
{ city: "BLAKNEY CREEK", state: "NSW", postcode: "2581" },
{ city: "BREADALBANE", state: "NSW", postcode: "2581" },
{ city: "BROADWAY", state: "NSW", postcode: "2581" },
{ city: "COLLECTOR", state: "NSW", postcode: "2581" },
{ city: "CULLERIN", state: "NSW", postcode: "2581" },
{ city: "DALTON", state: "NSW", postcode: "2581" },
{ city: "GUNNING", state: "NSW", postcode: "2581" },
{ city: "GURRUNDAH", state: "NSW", postcode: "2581" },
{ city: "LADE VALE", state: "NSW", postcode: "2581" },
{ city: "LAKE GEORGE", state: "NSW", postcode: "2581" },
{ city: "LERIDA", state: "NSW", postcode: "2581" },
{ city: "MERRILL", state: "NSW", postcode: "2581" },
{ city: "OOLONG", state: "NSW", postcode: "2581" },
{ city: "WOLLOGORANG", state: "NSW", postcode: "2581" },
{ city: "BANGO", state: "NSW", postcode: "2582" },
{ city: "BERREMANGRA", state: "NSW", postcode: "2582" },
{ city: "BOAMBOLO", state: "NSW", postcode: "2582" },
{ city: "BOOKHAM", state: "NSW", postcode: "2582" },
{ city: "BOWNING", state: "NSW", postcode: "2582" },
{ city: "BURRINJUCK", state: "NSW", postcode: "2582" },
{ city: "CAVAN", state: "NSW", postcode: "2582" },
{ city: "GOOD HOPE", state: "NSW", postcode: "2582" },
{ city: "JEIR", state: "NSW", postcode: "2582" },
{ city: "JERRAWA", state: "NSW", postcode: "2582" },
{ city: "KANGIARA", state: "NSW", postcode: "2582" },
{ city: "LAVERSTOCK", state: "NSW", postcode: "2582" },
{ city: "MANTON", state: "NSW", postcode: "2582" },
{ city: "MARCHMONT", state: "NSW", postcode: "2582" },
{ city: "MULLION", state: "NSW", postcode: "2582" },
{ city: "MURRUMBATEMAN", state: "NSW", postcode: "2582" },
{ city: "NARRANGULLEN", state: "NSW", postcode: "2582" },
{ city: "WEE JASPER", state: "NSW", postcode: "2582" },
{ city: "WOOLGARLO", state: "NSW", postcode: "2582" },
{ city: "YASS RIVER", state: "NSW", postcode: "2582" },
{ city: "BIGGA", state: "NSW", postcode: "2583" },
{ city: "BINDA", state: "NSW", postcode: "2583" },
{ city: "CROOKED CORNER", state: "NSW", postcode: "2583" },
{ city: "CROOKWELL", state: "NSW", postcode: "2583" },
{ city: "FULLERTON", state: "NSW", postcode: "2583" },
{ city: "GRABBEN GULLEN", state: "NSW", postcode: "2583" },
{ city: "GRABINE", state: "NSW", postcode: "2583" },
{ city: "LAGGAN", state: "NSW", postcode: "2583" },
{ city: "LIMERICK", state: "NSW", postcode: "2583" },
{ city: "LOST RIVER", state: "NSW", postcode: "2583" },
{ city: "NARRAWA", state: "NSW", postcode: "2583" },
{ city: "PEELWOOD", state: "NSW", postcode: "2583" },
{ city: "PEJAR", state: "NSW", postcode: "2583" },
{ city: "RUGBY", state: "NSW", postcode: "2583" },
{ city: "TUENA", state: "NSW", postcode: "2583" },
{ city: "WHEEO", state: "NSW", postcode: "2583" },
{ city: "BINALONG", state: "NSW", postcode: "2584" },
{ city: "GALONG", state: "NSW", postcode: "2585" },
{ city: "BOOROWA", state: "NSW", postcode: "2586" },
{ city: "FROGMORE", state: "NSW", postcode: "2586" },
{ city: "GODFREYS CREEK", state: "NSW", postcode: "2586" },
{ city: "MURRINGO", state: "NSW", postcode: "2586" },
{ city: "REIDS FLAT", state: "NSW", postcode: "2586" },
{ city: "RYE PARK", state: "NSW", postcode: "2586" },
{ city: "TAYLORS FLAT", state: "NSW", postcode: "2586" },
{ city: "BEGGAN BEGGAN", state: "NSW", postcode: "2587" },
{ city: "CUNNINGAR", state: "NSW", postcode: "2587" },
{ city: "HARDEN", state: "NSW", postcode: "2587" },
{ city: "KINGSVALE", state: "NSW", postcode: "2587" },
{ city: "MCMAHONS REEF", state: "NSW", postcode: "2587" },
{ city: "MURRUMBURRAH", state: "NSW", postcode: "2587" },
{ city: "NUBBA", state: "NSW", postcode: "2587" },
{ city: "WOMBAT", state: "NSW", postcode: "2587" },
{ city: "WALLENDBEEN", state: "NSW", postcode: "2588" },
{ city: "BETHUNGRA", state: "NSW", postcode: "2590" },
{ city: "COOTAMUNDRA", state: "NSW", postcode: "2590" },
{ city: "ILLABO", state: "NSW", postcode: "2590" },
{ city: "BARWANG", state: "NSW", postcode: "2594" },
{ city: "BERTHONG", state: "NSW", postcode: "2594" },
{ city: "BRIBBAREE", state: "NSW", postcode: "2594" },
{ city: "BULLA CREEK", state: "NSW", postcode: "2594" },
{ city: "BURRANGONG", state: "NSW", postcode: "2594" },
{ city: "KIKIAMAH", state: "NSW", postcode: "2594" },
{ city: "MAIMURU", state: "NSW", postcode: "2594" },
{ city: "MEMAGONG", state: "NSW", postcode: "2594" },
{ city: "MILVALE", state: "NSW", postcode: "2594" },
{ city: "MONTEAGLE", state: "NSW", postcode: "2594" },
{ city: "THUDDUNGRA", state: "NSW", postcode: "2594" },
{ city: "TUBBUL", state: "NSW", postcode: "2594" },
{ city: "WEEDALLION", state: "NSW", postcode: "2594" },
{ city: "YOUNG", state: "NSW", postcode: "2594" },
{ city: "NANIMA", state: "NSW", postcode: "2618" },
{ city: "SPRINGRANGE", state: "NSW", postcode: "2618" },
{ city: "WALLAROO", state: "NSW", postcode: "2618" },
{ city: "WILLIAMSDALE", state: "NSW", postcode: "2620" },
{ city: "ANEMBO", state: "NSW", postcode: "2621" },
{ city: "BUNGENDORE", state: "NSW", postcode: "2621" },
{ city: "BYWONG", state: "NSW", postcode: "2621" },
{ city: "FORBES CREEK", state: "NSW", postcode: "2621" },
{ city: "HOSKINSTOWN", state: "NSW", postcode: "2621" },
{ city: "PRIMROSE VALLEY", state: "NSW", postcode: "2621" },
{ city: "ROSSI", state: "NSW", postcode: "2621" },
{ city: "ARALUEN", state: "NSW", postcode: "2622" },
{ city: "BACK CREEK", state: "NSW", postcode: "2622" },
{ city: "BALLALABA", state: "NSW", postcode: "2622" },
{ city: "BENDOURA", state: "NSW", postcode: "2622" },
{ city: "BERLANG", state: "NSW", postcode: "2622" },
{ city: "BOMBAY", state: "NSW", postcode: "2622" },
{ city: "BORO", state: "NSW", postcode: "2622" },
{ city: "BRAIDWOOD", state: "NSW", postcode: "2622" },
{ city: "BUDAWANG", state: "NSW", postcode: "2622" },
{ city: "BULEE", state: "NSW", postcode: "2622" },
{ city: "CHARLEYS FOREST", state: "NSW", postcode: "2622" },
{ city: "COOLUMBURRA", state: "NSW", postcode: "2622" },
{ city: "CORANG", state: "NSW", postcode: "2622" },
{ city: "DURRAN DURRA", state: "NSW", postcode: "2622" },
{ city: "ENDRICK", state: "NSW", postcode: "2622" },
{ city: "FARRINGDON", state: "NSW", postcode: "2622" },
{ city: "HAROLDS CROSS", state: "NSW", postcode: "2622" },
{ city: "HEREFORD HALL", state: "NSW", postcode: "2622" },
{ city: "JEMBAICUMBENE", state: "NSW", postcode: "2622" },
{ city: "JERRABATTGULLA", state: "NSW", postcode: "2622" },
{ city: "JINDEN", state: "NSW", postcode: "2622" },
{ city: "JINGERA", state: "NSW", postcode: "2622" },
{ city: "KINDERVALE", state: "NSW", postcode: "2622" },
{ city: "KRAWARREE", state: "NSW", postcode: "2622" },
{ city: "LARBERT", state: "NSW", postcode: "2622" },
{ city: "MAJORS CREEK", state: "NSW", postcode: "2622" },
{ city: "MANAR", state: "NSW", postcode: "2622" },
{ city: "MARLOWE", state: "NSW", postcode: "2622" },
{ city: "MERRICUMBENE", state: "NSW", postcode: "2622" },
{ city: "MONGA", state: "NSW", postcode: "2622" },
{ city: "MONGARLOWE", state: "NSW", postcode: "2622" },
{ city: "MULLOON", state: "NSW", postcode: "2622" },
{ city: "MURRENGENBURG", state: "NSW", postcode: "2622" },
{ city: "NERINGLA", state: "NSW", postcode: "2622" },
{ city: "NERRIGA", state: "NSW", postcode: "2622" },
{ city: "NORTHANGERA", state: "NSW", postcode: "2622" },
{ city: "OALLEN", state: "NSW", postcode: "2622" },
{ city: "PALERANG", state: "NSW", postcode: "2622" },
{ city: "QUIERA", state: "NSW", postcode: "2622" },
{ city: "REIDSDALE", state: "NSW", postcode: "2622" },
{ city: "SASSAFRAS", state: "NSW", postcode: "2622" },
{ city: "SNOWBALL", state: "NSW", postcode: "2622" },
{ city: "ST GEORGE", state: "NSW", postcode: "2622" },
{ city: "TIANJARA", state: "NSW", postcode: "2622" },
{ city: "TOLWONG", state: "NSW", postcode: "2622" },
{ city: "TOMBOYE", state: "NSW", postcode: "2622" },
{ city: "TOUGA", state: "NSW", postcode: "2622" },
{ city: "WARRI", state: "NSW", postcode: "2622" },
{ city: "WOG WOG", state: "NSW", postcode: "2622" },
{ city: "WYANBENE", state: "NSW", postcode: "2622" },
{ city: "CAPTAINS FLAT", state: "NSW", postcode: "2623" },
{ city: "PERISHER VALLEY", state: "NSW", postcode: "2624" },
{ city: "THREDBO", state: "NSW", postcode: "2625" },
{ city: "BREDBO", state: "NSW", postcode: "2626" },
{ city: "BUMBALONG", state: "NSW", postcode: "2626" },
{ city: "COLINTON", state: "NSW", postcode: "2626" },
{ city: "CRACKENBACK", state: "NSW", postcode: "2627" },
{ city: "EAST JINDABYNE", state: "NSW", postcode: "2627" },
{ city: "GROSSES PLAIN", state: "NSW", postcode: "2627" },
{ city: "INGEBIRAH", state: "NSW", postcode: "2627" },
{ city: "JINDABYNE", state: "NSW", postcode: "2627" },
{ city: "KALKITE", state: "NSW", postcode: "2627" },
{ city: "KOSCIUSZKO", state: "NSW", postcode: "2627" },
{ city: "KOSCIUSZKO NATIONAL PARK", state: "NSW", postcode: "2627" },
{ city: "MOONBAH", state: "NSW", postcode: "2627" },
{ city: "PILOT WILDERNESS", state: "NSW", postcode: "2627" },
{ city: "AVONSIDE", state: "NSW", postcode: "2628" },
{ city: "BELOKA", state: "NSW", postcode: "2628" },
{ city: "BERRIDALE", state: "NSW", postcode: "2628" },
{ city: "BRAEMAR BAY", state: "NSW", postcode: "2628" },
{ city: "BYADBO WILDERNESS", state: "NSW", postcode: "2628" },
{ city: "COOTRALANTRA", state: "NSW", postcode: "2628" },
{ city: "DALGETY", state: "NSW", postcode: "2628" },
{ city: "EUCUMBENE", state: "NSW", postcode: "2628" },
{ city: "HILL TOP", state: "NSW", postcode: "2628" },
{ city: "JIMENBUEN", state: "NSW", postcode: "2628" },
{ city: "NIMMO", state: "NSW", postcode: "2628" },
{ city: "NUMBLA VALE", state: "NSW", postcode: "2628" },
{ city: "PAUPONG", state: "NSW", postcode: "2628" },
{ city: "ROCKY PLAIN", state: "NSW", postcode: "2628" },
{ city: "SNOWY PLAIN", state: "NSW", postcode: "2628" },
{ city: "ADAMINABY", state: "NSW", postcode: "2629" },
{ city: "ANGLERS REACH", state: "NSW", postcode: "2629" },
{ city: "BOLARO", state: "NSW", postcode: "2629" },
{ city: "CABRAMURRA", state: "NSW", postcode: "2629" },
{ city: "LONG PLAIN", state: "NSW", postcode: "2629" },
{ city: "OLD ADAMINABY", state: "NSW", postcode: "2629" },
{ city: "PROVIDENCE PORTAL", state: "NSW", postcode: "2629" },
{ city: "TANTANGARA", state: "NSW", postcode: "2629" },
{ city: "YAOUK", state: "NSW", postcode: "2629" },
{ city: "COOMA", state: "NSW", postcode: "2630" },
{ city: "COOMA NORTH", state: "NSW", postcode: "2630" },
{ city: "ANDO", state: "NSW", postcode: "2631" },
{ city: "BOCO", state: "NSW", postcode: "2631" },
{ city: "CREEWAH", state: "NSW", postcode: "2631" },
{ city: "GLEN ALLEN", state: "NSW", postcode: "2631" },
{ city: "GREENLANDS", state: "NSW", postcode: "2631" },
{ city: "HOLTS FLAT", state: "NSW", postcode: "2631" },
{ city: "JINCUMBILLY", state: "NSW", postcode: "2631" },
{ city: "KYBEYAN", state: "NSW", postcode: "2631" },
{ city: "MOUNT COOPER", state: "NSW", postcode: "2631" },
{ city: "NIMMITABEL", state: "NSW", postcode: "2631" },
{ city: "STEEPLE FLAT", state: "NSW", postcode: "2631" },
{ city: "WINIFRED", state: "NSW", postcode: "2631" },
{ city: "BIBBENLUKE", state: "NSW", postcode: "2632" },
{ city: "BOMBALA", state: "NSW", postcode: "2632" },
{ city: "BONDI FOREST", state: "NSW", postcode: "2632" },
{ city: "BUKALONG", state: "NSW", postcode: "2632" },
{ city: "CAMBALONG", state: "NSW", postcode: "2632" },
{ city: "CATHCART", state: "NSW", postcode: "2632" },
{ city: "COOLUMBOOKA", state: "NSW", postcode: "2632" },
{ city: "CRAIGIE", state: "NSW", postcode: "2632" },
{ city: "GUNNINGRAH", state: "NSW", postcode: "2632" },
{ city: "LORDS HILL", state: "NSW", postcode: "2632" },
{ city: "MERRIANGAAH", state: "NSW", postcode: "2632" },
{ city: "MILA", state: "NSW", postcode: "2632" },
{ city: "MOUNT DARRAGH", state: "NSW", postcode: "2632" },
{ city: "PADDYS FLAT", state: "NSW", postcode: "2632" },
{ city: "PALARANG", state: "NSW", postcode: "2632" },
{ city: "QUIDONG", state: "NSW", postcode: "2632" },
{ city: "ROCKTON", state: "NSW", postcode: "2632" },
{ city: "ROSEMEATH", state: "NSW", postcode: "2632" },
{ city: "CORROWONG", state: "NSW", postcode: "2633" },
{ city: "DELEGATE", state: "NSW", postcode: "2633" },
{ city: "TOMBONG", state: "NSW", postcode: "2633" },
{ city: "HAMILTON VALLEY", state: "NSW", postcode: "2641" },
{ city: "SPRINGDALE HEIGHTS", state: "NSW", postcode: "2641" },
{ city: "BIDGEEMIA", state: "NSW", postcode: "2642" },
{ city: "BROCKLESBY", state: "NSW", postcode: "2642" },
{ city: "BURRUMBUTTOCK", state: "NSW", postcode: "2642" },
{ city: "GEEHI", state: "NSW", postcode: "2642" },
{ city: "GEROGERY", state: "NSW", postcode: "2642" },
{ city: "GLENELLEN", state: "NSW", postcode: "2642" },
{ city: "GREG GREG", state: "NSW", postcode: "2642" },
{ city: "INDI", state: "NSW", postcode: "2642" },
{ city: "JAGUMBA", state: "NSW", postcode: "2642" },
{ city: "JAGUNGAL WILDERNESS", state: "NSW", postcode: "2642" },
{ city: "JINDERA", state: "NSW", postcode: "2642" },
{ city: "JINGELLIC", state: "NSW", postcode: "2642" },
{ city: "KHANCOBAN", state: "NSW", postcode: "2642" },
{ city: "MURRAY GORGE", state: "NSW", postcode: "2642" },
{ city: "RAND", state: "NSW", postcode: "2642" },
{ city: "TOOMA", state: "NSW", postcode: "2642" },
{ city: "WALBUNDRIE", state: "NSW", postcode: "2642" },
{ city: "WELAREGANG", state: "NSW", postcode: "2642" },
{ city: "WRATHALL", state: "NSW", postcode: "2642" },
{ city: "YERONG CREEK", state: "NSW", postcode: "2642" },
{ city: "HOWLONG", state: "NSW", postcode: "2643" },
{ city: "BOWNA", state: "NSW", postcode: "2644" },
{ city: "COPPABELLA", state: "NSW", postcode: "2644" },
{ city: "HOLBROOK", state: "NSW", postcode: "2644" },
{ city: "LANKEYS CREEK", state: "NSW", postcode: "2644" },
{ city: "LITTLE BILLABONG", state: "NSW", postcode: "2644" },
{ city: "MOUNTAIN CREEK", state: "NSW", postcode: "2644" },
{ city: "MULLENGANDRA", state: "NSW", postcode: "2644" },
{ city: "WANTAGONG", state: "NSW", postcode: "2644" },
{ city: "WOOMARGAMA", state: "NSW", postcode: "2644" },
{ city: "YARARA", state: "NSW", postcode: "2644" },
{ city: "CULLIVEL", state: "NSW", postcode: "2645" },
{ city: "URANA", state: "NSW", postcode: "2645" },
{ city: "BALLDALE", state: "NSW", postcode: "2646" },
{ city: "COLLENDINA", state: "NSW", postcode: "2646" },
{ city: "COREEN", state: "NSW", postcode: "2646" },
{ city: "COROWA", state: "NSW", postcode: "2646" },
{ city: "DAYSDALE", state: "NSW", postcode: "2646" },
{ city: "GOOMBARGANA", state: "NSW", postcode: "2646" },
{ city: "HOPEFIELD", state: "NSW", postcode: "2646" },
{ city: "LOWESDALE", state: "NSW", postcode: "2646" },
{ city: "NYORA", state: "NSW", postcode: "2646" },
{ city: "OAKLANDS", state: "NSW", postcode: "2646" },
{ city: "REDLANDS", state: "NSW", postcode: "2646" },
{ city: "RENNIE", state: "NSW", postcode: "2646" },
{ city: "RINGWOOD", state: "NSW", postcode: "2646" },
{ city: "SANGER", state: "NSW", postcode: "2646" },
{ city: "SAVERNAKE", state: "NSW", postcode: "2646" },
{ city: "MULWALA", state: "NSW", postcode: "2647" },
{ city: "ANABRANCH", state: "NSW", postcode: "2648" },
{ city: "ANABRANCH NORTH", state: "NSW", postcode: "2648" },
{ city: "ANABRANCH SOUTH", state: "NSW", postcode: "2648" },
{ city: "CURLWAA", state: "NSW", postcode: "2648" },
{ city: "ELLERSLIE", state: "NSW", postcode: "2648" },
{ city: "MOORARA", state: "NSW", postcode: "2648" },
{ city: "PAN BAN", state: "NSW", postcode: "2648" },
{ city: "PARA", state: "NSW", postcode: "2648" },
{ city: "PINE CAMP", state: "NSW", postcode: "2648" },
{ city: "POMONA", state: "NSW", postcode: "2648" },
{ city: "POONCARIE", state: "NSW", postcode: "2648" },
{ city: "RUFUS", state: "NSW", postcode: "2648" },
{ city: "RUFUS RIVER", state: "NSW", postcode: "2648" },
{ city: "SCOTIA", state: "NSW", postcode: "2648" },
{ city: "WENTWORTH", state: "NSW", postcode: "2648" },
{ city: "LAUREL HILL", state: "NSW", postcode: "2649" },
{ city: "NURENMERENMONG", state: "NSW", postcode: "2649" },
{ city: "ALFREDTOWN", state: "NSW", postcode: "2650" },
{ city: "ASHMONT", state: "NSW", postcode: "2650" },
{ city: "BELFRAYDEN", state: "NSW", postcode: "2650" },
{ city: "BIG SPRINGS", state: "NSW", postcode: "2650" },
{ city: "BOMEN", state: "NSW", postcode: "2650" },
{ city: "BOOK BOOK", state: "NSW", postcode: "2650" },
{ city: "BOOROOMA", state: "NSW", postcode: "2650" },
{ city: "BORAMBOLA", state: "NSW", postcode: "2650" },
{ city: "BOURKELANDS", state: "NSW", postcode: "2650" },
{ city: "BRUCEDALE", state: "NSW", postcode: "2650" },
{ city: "BULGARY", state: "NSW", postcode: "2650" },
{ city: "BURRANDANA", state: "NSW", postcode: "2650" },
{ city: "CARABOST", state: "NSW", postcode: "2650" },
{ city: "CARTWRIGHTS HILL", state: "NSW", postcode: "2650" },
{ city: "COLLINGULLIE", state: "NSW", postcode: "2650" },
{ city: "COOKARDINIA", state: "NSW", postcode: "2650" },
{ city: "CURRAWARNA", state: "NSW", postcode: "2650" },
{ city: "DOWNSIDE", state: "NSW", postcode: "2650" },
{ city: "ESTELLA", state: "NSW", postcode: "2650" },
{ city: "EUBERTA", state: "NSW", postcode: "2650" },
{ city: "GALORE", state: "NSW", postcode: "2650" },
{ city: "GELSTON PARK", state: "NSW", postcode: "2650" },
{ city: "GLENFIELD PARK", state: "NSW", postcode: "2650" },
{ city: "GOBBAGOMBALIN", state: "NSW", postcode: "2650" },
{ city: "GREGADOO", state: "NSW", postcode: "2650" },
{ city: "HAREFIELD", state: "NSW", postcode: "2650" },
{ city: "HILLGROVE", state: "NSW", postcode: "2650" },
{ city: "KOORINGAL", state: "NSW", postcode: "2650" },
{ city: "KYEAMBA", state: "NSW", postcode: "2650" },
{ city: "LAKE ALBERT", state: "NSW", postcode: "2650" },
{ city: "LLOYD", state: "NSW", postcode: "2650" },
{ city: "MAXWELL", state: "NSW", postcode: "2650" },
{ city: "MOORONG", state: "NSW", postcode: "2650" },
{ city: "MOUNT AUSTIN", state: "NSW", postcode: "2650" },
{ city: "OBERNE CREEK", state: "NSW", postcode: "2650" },
{ city: "OURA", state: "NSW", postcode: "2650" },
{ city: "PULLETOP", state: "NSW", postcode: "2650" },
{ city: "ROWAN", state: "NSW", postcode: "2650" },
{ city: "SAN ISIDORE", state: "NSW", postcode: "2650" },
{ city: "SPRINGVALE", state: "NSW", postcode: "2650" },
{ city: "TATTON", state: "NSW", postcode: "2650" },
{ city: "THE GAP", state: "NSW", postcode: "2650" },
{ city: "TOLLAND", state: "NSW", postcode: "2650" },
{ city: "TURVEY PARK", state: "NSW", postcode: "2650" },
{ city: "WALLACETOWN", state: "NSW", postcode: "2650" },
{ city: "WANTABADGERY", state: "NSW", postcode: "2650" },
{ city: "YARRAGUNDRY", state: "NSW", postcode: "2650" },
{ city: "YATHELLA", state: "NSW", postcode: "2650" },
{ city: "FOREST HILL", state: "NSW", postcode: "2651" },
{ city: "BOORGA", state: "NSW", postcode: "2652" },
{ city: "BOREE CREEK", state: "NSW", postcode: "2652" },
{ city: "COWABBIE", state: "NSW", postcode: "2652" },
{ city: "GOOLGOWI", state: "NSW", postcode: "2652" },
{ city: "GRONG GRONG", state: "NSW", postcode: "2652" },
{ city: "GUMLY GUMLY", state: "NSW", postcode: "2652" },
{ city: "HUMULA", state: "NSW", postcode: "2652" },
{ city: "LADYSMITH", state: "NSW", postcode: "2652" },
{ city: "LANDERVALE", state: "NSW", postcode: "2652" },
{ city: "MANGOPLAH", state: "NSW", postcode: "2652" },
{ city: "MARRAR", state: "NSW", postcode: "2652" },
{ city: "MATONG", state: "NSW", postcode: "2652" },
{ city: "MERRIWAGGA", state: "NSW", postcode: "2652" },
{ city: "MURRULEBALE", state: "NSW", postcode: "2652" },
{ city: "OLD JUNEE", state: "NSW", postcode: "2652" },
{ city: "ROSEWOOD", state: "NSW", postcode: "2652" },
{ city: "TABBITA", state: "NSW", postcode: "2652" },
{ city: "TARCUTTA", state: "NSW", postcode: "2652" },
{ city: "URANQUINTY", state: "NSW", postcode: "2652" },
{ city: "BURRA", state: "NSW", postcode: "2653" },
{ city: "COURABYRA", state: "NSW", postcode: "2653" },
{ city: "GLENROY", state: "NSW", postcode: "2653" },
{ city: "MANNUS", state: "NSW", postcode: "2653" },
{ city: "MARAGLE", state: "NSW", postcode: "2653" },
{ city: "MUNDEROO", state: "NSW", postcode: "2653" },
{ city: "PADDYS RIVER", state: "NSW", postcode: "2653" },
{ city: "TARADALE", state: "NSW", postcode: "2653" },
{ city: "TUMBARUMBA", state: "NSW", postcode: "2653" },
{ city: "WESTDALE", state: "NSW", postcode: "2653" },
{ city: "WILLIGOBUNG", state: "NSW", postcode: "2653" },
{ city: "FRENCH PARK", state: "NSW", postcode: "2655" },
{ city: "KUBURA", state: "NSW", postcode: "2655" },
{ city: "THE ROCK", state: "NSW", postcode: "2655" },
{ city: "TOOTOOL", state: "NSW", postcode: "2655" },
{ city: "BROOKDALE", state: "NSW", postcode: "2656" },
{ city: "BROOKONG", state: "NSW", postcode: "2656" },
{ city: "FARGUNYAH", state: "NSW", postcode: "2656" },
{ city: "LOCKHART", state: "NSW", postcode: "2656" },
{ city: "MILBRULONG", state: "NSW", postcode: "2656" },
{ city: "OSBORNE", state: "NSW", postcode: "2656" },
{ city: "URANGELINE", state: "NSW", postcode: "2656" },
{ city: "URANGELINE EAST", state: "NSW", postcode: "2656" },
{ city: "HENTY", state: "NSW", postcode: "2658" },
{ city: "MUNYABLA", state: "NSW", postcode: "2658" },
{ city: "PLEASANT HILLS", state: "NSW", postcode: "2658" },
{ city: "RYAN", state: "NSW", postcode: "2658" },
{ city: "ALMA PARK", state: "NSW", postcode: "2659" },
{ city: "WALLA WALLA", state: "NSW", postcode: "2659" },
{ city: "CULCAIRN", state: "NSW", postcode: "2660" },
{ city: "MORVEN", state: "NSW", postcode: "2660" },
{ city: "KAPOOKA", state: "NSW", postcode: "2661" },
{ city: "COWABBIE", state: "NSW", postcode: "2663" },
{ city: "ERIN VALE", state: "NSW", postcode: "2663" },
{ city: "EURONGILLY", state: "NSW", postcode: "2663" },
{ city: "JUNEE", state: "NSW", postcode: "2663" },
{ city: "MARINNA", state: "NSW", postcode: "2663" },
{ city: "WANTIOOL", state: "NSW", postcode: "2663" },
{ city: "ARDLETHAN", state: "NSW", postcode: "2665" },
{ city: "ARIAH PARK", state: "NSW", postcode: "2665" },
{ city: "BARELLAN", state: "NSW", postcode: "2665" },
{ city: "BECKOM", state: "NSW", postcode: "2665" },
{ city: "BECTRIC", state: "NSW", postcode: "2665" },
{ city: "BINYA", state: "NSW", postcode: "2665" },
{ city: "KAMARAH", state: "NSW", postcode: "2665" },
{ city: "MIRROOL", state: "NSW", postcode: "2665" },
{ city: "MOOMBOOLDOOL", state: "NSW", postcode: "2665" },
{ city: "QUANDARY", state: "NSW", postcode: "2665" },
{ city: "TARA", state: "NSW", postcode: "2665" },
{ city: "WALLEROOBIE", state: "NSW", postcode: "2665" },
{ city: "COMBANING", state: "NSW", postcode: "2666" },
{ city: "DIRNASEER", state: "NSW", postcode: "2666" },
{ city: "GIDGINBUNG", state: "NSW", postcode: "2666" },
{ city: "GROGAN", state: "NSW", postcode: "2666" },
{ city: "JUNEE REEFS", state: "NSW", postcode: "2666" },
{ city: "MIMOSA", state: "NSW", postcode: "2666" },
{ city: "MORANGARELL", state: "NSW", postcode: "2666" },
{ city: "NARRABURRA", state: "NSW", postcode: "2666" },
{ city: "PUCAWAN", state: "NSW", postcode: "2666" },
{ city: "REEFTON", state: "NSW", postcode: "2666" },
{ city: "SEBASTOPOL", state: "NSW", postcode: "2666" },
{ city: "SPRINGDALE", state: "NSW", postcode: "2666" },
{ city: "TEMORA", state: "NSW", postcode: "2666" },
{ city: "TRUNGLEY HALL", state: "NSW", postcode: "2666" },
{ city: "BARMEDMAN", state: "NSW", postcode: "2668" },
{ city: "ERIGOLIA", state: "NSW", postcode: "2669" },
{ city: "GIRRAL", state: "NSW", postcode: "2669" },
{ city: "KIKOIRA", state: "NSW", postcode: "2669" },
{ city: "MELBERGEN", state: "NSW", postcode: "2669" },
{ city: "NARADHAN", state: "NSW", postcode: "2669" },
{ city: "RANKINS SPRINGS", state: "NSW", postcode: "2669" },
{ city: "TALLIMBA", state: "NSW", postcode: "2669" },
{ city: "TULLIBIGEAL", state: "NSW", postcode: "2669" },
{ city: "UNGARIE", state: "NSW", postcode: "2669" },
{ city: "WEETHALLE", state: "NSW", postcode: "2669" },
{ city: "ALLEENA", state: "NSW", postcode: "2671" },
{ city: "BACK CREEK", state: "NSW", postcode: "2671" },
{ city: "BURCHER", state: "NSW", postcode: "2671" },
{ city: "LAKE COWAL", state: "NSW", postcode: "2671" },
{ city: "NORTH YALGOGRIN", state: "NSW", postcode: "2671" },
{ city: "WEST WYALONG", state: "NSW", postcode: "2671" },
{ city: "WYALONG", state: "NSW", postcode: "2671" },
{ city: "CURLEW WATERS", state: "NSW", postcode: "2672" },
{ city: "LAKE CARGELLIGO", state: "NSW", postcode: "2672" },
{ city: "MURRIN BRIDGE", state: "NSW", postcode: "2672" },
{ city: "HILLSTON", state: "NSW", postcode: "2675" },
{ city: "LAKE BREWSTER", state: "NSW", postcode: "2675" },
{ city: "MONIA GAP", state: "NSW", postcode: "2675" },
{ city: "ROTO", state: "NSW", postcode: "2675" },
{ city: "WALLANTHERY", state: "NSW", postcode: "2675" },
{ city: "CHARLES STURT UNIVERSITY", state: "NSW", postcode: "2678" },
{ city: "RIVERINA MSC", state: "NSW", postcode: "2678" },
{ city: "BEELBANGERA", state: "NSW", postcode: "2680" },
{ city: "BENEREMBAH", state: "NSW", postcode: "2680" },
{ city: "BILBUL", state: "NSW", postcode: "2680" },
{ city: "GRIFFITH", state: "NSW", postcode: "2680" },
{ city: "GRIFFITH DC", state: "NSW", postcode: "2680" },
{ city: "GRIFFITH EAST", state: "NSW", postcode: "2680" },
{ city: "HANWOOD", state: "NSW", postcode: "2680" },
{ city: "KOOBA", state: "NSW", postcode: "2680" },
{ city: "LAKE WYANGAN", state: "NSW", postcode: "2680" },
{ city: "NERICON", state: "NSW", postcode: "2680" },
{ city: "THARBOGANG", state: "NSW", postcode: "2680" },
{ city: "WARBURN", state: "NSW", postcode: "2680" },
{ city: "WARRAWIDGEE", state: "NSW", postcode: "2680" },
{ city: "WIDGELLI", state: "NSW", postcode: "2680" },
{ city: "WILLBRIGGIE", state: "NSW", postcode: "2680" },
{ city: "YOOGALI", state: "NSW", postcode: "2680" },
{ city: "MYALL PARK", state: "NSW", postcode: "2681" },
{ city: "YENDA", state: "NSW", postcode: "2681" },
{ city: "BUNDURE", state: "NSW", postcode: "2700" },
{ city: "COLINROOBIE", state: "NSW", postcode: "2700" },
{ city: "COROBIMILLA", state: "NSW", postcode: "2700" },
{ city: "CUDGEL", state: "NSW", postcode: "2700" },
{ city: "EUROLEY", state: "NSW", postcode: "2700" },
{ city: "GILLENBAH", state: "NSW", postcode: "2700" },
{ city: "KYWONG", state: "NSW", postcode: "2700" },
{ city: "MORUNDAH", state: "NSW", postcode: "2700" },
{ city: "NARRANDERA", state: "NSW", postcode: "2700" },
{ city: "SANDIGO", state: "NSW", postcode: "2700" },
{ city: "BERRY JERRY", state: "NSW", postcode: "2701" },
{ city: "COOLAMON", state: "NSW", postcode: "2701" },
{ city: "METHUL", state: "NSW", postcode: "2701" },
{ city: "RANNOCK", state: "NSW", postcode: "2701" },
{ city: "GANMAIN", state: "NSW", postcode: "2702" },
{ city: "YANCO", state: "NSW", postcode: "2703" },
{ city: "BROBENAH", state: "NSW", postcode: "2705" },
{ city: "CORBIE HILL", state: "NSW", postcode: "2705" },
{ city: "GOGELDRIE", state: "NSW", postcode: "2705" },
{ city: "LEETON", state: "NSW", postcode: "2705" },
{ city: "MERUNGLE HILL", state: "NSW", postcode: "2705" },
{ city: "MURRAMI", state: "NSW", postcode: "2705" },
{ city: "STANBRIDGE", state: "NSW", postcode: "2705" },
{ city: "WHITTON", state: "NSW", postcode: "2705" },
{ city: "DARLINGTON POINT", state: "NSW", postcode: "2706" },
{ city: "ARGOON", state: "NSW", postcode: "2707" },
{ city: "COLEAMBALLY", state: "NSW", postcode: "2707" },
{ city: "BARRATTA", state: "NSW", postcode: "2710" },
{ city: "BIRGANBIGIL", state: "NSW", postcode: "2710" },
{ city: "BOOROORBAN", state: "NSW", postcode: "2710" },
{ city: "BULLATALE", state: "NSW", postcode: "2710" },
{ city: "CALDWELL", state: "NSW", postcode: "2710" },
{ city: "CALIMO", state: "NSW", postcode: "2710" },
{ city: "CONARGO", state: "NSW", postcode: "2710" },
{ city: "COREE", state: "NSW", postcode: "2710" },
{ city: "DENILIQUIN", state: "NSW", postcode: "2710" },
{ city: "HARTWOOD", state: "NSW", postcode: "2710" },
{ city: "LINDIFFERON", state: "NSW", postcode: "2710" },
{ city: "MATHOURA", state: "NSW", postcode: "2710" },
{ city: "MAYRUNG", state: "NSW", postcode: "2710" },
{ city: "MOONBRIA", state: "NSW", postcode: "2710" },
{ city: "MORAGO", state: "NSW", postcode: "2710" },
{ city: "PRETTY PINE", state: "NSW", postcode: "2710" },
{ city: "STEAM PLAINS", state: "NSW", postcode: "2710" },
{ city: "STUD PARK", state: "NSW", postcode: "2710" },
{ city: "WAKOOL", state: "NSW", postcode: "2710" },
{ city: "WANDOOK", state: "NSW", postcode: "2710" },
{ city: "WANGANELLA", state: "NSW", postcode: "2710" },
{ city: "WARRAGOON", state: "NSW", postcode: "2710" },
{ city: "WILLURAH", state: "NSW", postcode: "2710" },
{ city: "BOOLIGAL", state: "NSW", postcode: "2711" },
{ city: "CARRATHOOL", state: "NSW", postcode: "2711" },
{ city: "CLARE", state: "NSW", postcode: "2711" },
{ city: "CORRONG", state: "NSW", postcode: "2711" },
{ city: "GUNBAR", state: "NSW", postcode: "2711" },
{ city: "HAY", state: "NSW", postcode: "2711" },
{ city: "HAY SOUTH", state: "NSW", postcode: "2711" },
{ city: "KERI KERI", state: "NSW", postcode: "2711" },
{ city: "MAUDE", state: "NSW", postcode: "2711" },
{ city: "ONE TREE", state: "NSW", postcode: "2711" },
{ city: "OXLEY", state: "NSW", postcode: "2711" },
{ city: "WAUGORAH", state: "NSW", postcode: "2711" },
{ city: "YANGA", state: "NSW", postcode: "2711" },
{ city: "BERRIGAN", state: "NSW", postcode: "2712" },
{ city: "BOOMANOOMANA", state: "NSW", postcode: "2712" },
{ city: "BLIGHTY", state: "NSW", postcode: "2713" },
{ city: "FINLEY", state: "NSW", postcode: "2713" },
{ city: "LOGIE BRAE", state: "NSW", postcode: "2713" },
{ city: "MYRTLE PARK", state: "NSW", postcode: "2713" },
{ city: "ARATULA", state: "NSW", postcode: "2714" },
{ city: "PINE LODGE", state: "NSW", postcode: "2714" },
{ city: "TOCUMWAL", state: "NSW", postcode: "2714" },
{ city: "TUPPAL", state: "NSW", postcode: "2714" },
{ city: "ARUMPO", state: "NSW", postcode: "2715" },
{ city: "BALRANALD", state: "NSW", postcode: "2715" },
{ city: "HATFIELD", state: "NSW", postcode: "2715" },
{ city: "KYALITE", state: "NSW", postcode: "2715" },
{ city: "MUNGO", state: "NSW", postcode: "2715" },
{ city: "FOUR CORNERS", state: "NSW", postcode: "2716" },
{ city: "GALA VALE", state: "NSW", postcode: "2716" },
{ city: "JERILDERIE", state: "NSW", postcode: "2716" },
{ city: "MABINS WELL", state: "NSW", postcode: "2716" },
{ city: "MAIRJIMMY", state: "NSW", postcode: "2716" },
{ city: "COOMEALLA", state: "NSW", postcode: "2717" },
{ city: "DARETON", state: "NSW", postcode: "2717" },
{ city: "ARGALONG", state: "NSW", postcode: "2720" },
{ city: "BLOWERING", state: "NSW", postcode: "2720" },
{ city: "BOGONG PEAKS WILDERNESS", state: "NSW", postcode: "2720" },
{ city: "BOMBOWLEE", state: "NSW", postcode: "2720" },
{ city: "BOMBOWLEE CREEK", state: "NSW", postcode: "2720" },
{ city: "BUDDONG", state: "NSW", postcode: "2720" },
{ city: "COURAGAGO", state: "NSW", postcode: "2720" },
{ city: "GADARA", state: "NSW", postcode: "2720" },
{ city: "GILMORE", state: "NSW", postcode: "2720" },
{ city: "GOCUP", state: "NSW", postcode: "2720" },
{ city: "GOOBARRAGANDRA", state: "NSW", postcode: "2720" },
{ city: "JONES BRIDGE", state: "NSW", postcode: "2720" },
{ city: "KILLIMICAT", state: "NSW", postcode: "2720" },
{ city: "LACMALAC", state: "NSW", postcode: "2720" },
{ city: "LITTLE RIVER", state: "NSW", postcode: "2720" },
{ city: "MINJARY", state: "NSW", postcode: "2720" },
{ city: "MUNDONGO", state: "NSW", postcode: "2720" },
{ city: "PINBEYAN", state: "NSW", postcode: "2720" },
{ city: "RED HILL", state: "NSW", postcode: "2720" },
{ city: "TALBINGO", state: "NSW", postcode: "2720" },
{ city: "TUMORRAMA", state: "NSW", postcode: "2720" },
{ city: "TUMUT", state: "NSW", postcode: "2720" },
{ city: "TUMUT PLAINS", state: "NSW", postcode: "2720" },
{ city: "WEREBOLDERA", state: "NSW", postcode: "2720" },
{ city: "WERMATONG", state: "NSW", postcode: "2720" },
{ city: "WINDOWIE", state: "NSW", postcode: "2720" },
{ city: "WYANGLE", state: "NSW", postcode: "2720" },
{ city: "YARRANGOBILLY", state: "NSW", postcode: "2720" },
{ city: "BLAND", state: "NSW", postcode: "2721" },
{ city: "QUANDIALLA", state: "NSW", postcode: "2721" },
{ city: "BRUNGLE", state: "NSW", postcode: "2722" },
{ city: "BRUNGLE CREEK", state: "NSW", postcode: "2722" },
{ city: "BURRA CREEK", state: "NSW", postcode: "2722" },
{ city: "DARBALARA", state: "NSW", postcode: "2722" },
{ city: "GUNDAGAI", state: "NSW", postcode: "2722" },
{ city: "JONES CREEK", state: "NSW", postcode: "2722" },
{ city: "MUTTAMA", state: "NSW", postcode: "2722" },
{ city: "NANGUS", state: "NSW", postcode: "2722" },
{ city: "SOUTH GUNDAGAI", state: "NSW", postcode: "2722" },
{ city: "STOCKINBINGAL", state: "NSW", postcode: "2725" },
{ city: "COONEYS CREEK", state: "NSW", postcode: "2726" },
{ city: "JUGIONG", state: "NSW", postcode: "2726" },
{ city: "ADJUNGBILLY", state: "NSW", postcode: "2727" },
{ city: "COOLAC", state: "NSW", postcode: "2727" },
{ city: "GOBARRALONG", state: "NSW", postcode: "2727" },
{ city: "ADELONG", state: "NSW", postcode: "2729" },
{ city: "BANGADANG", state: "NSW", postcode: "2729" },
{ city: "BLACK CREEK", state: "NSW", postcode: "2729" },
{ city: "CALIFAT", state: "NSW", postcode: "2729" },
{ city: "COOLEYS CREEK", state: "NSW", postcode: "2729" },
{ city: "DARLOW", state: "NSW", postcode: "2729" },
{ city: "ELLERSLIE", state: "NSW", postcode: "2729" },
{ city: "GRAHAMSTOWN", state: "NSW", postcode: "2729" },
{ city: "MOUNT ADRAH", state: "NSW", postcode: "2729" },
{ city: "MOUNT HOREB", state: "NSW", postcode: "2729" },
{ city: "MUNDARLO", state: "NSW", postcode: "2729" },
{ city: "SANDY GULLY", state: "NSW", postcode: "2729" },
{ city: "SHARPS CREEK", state: "NSW", postcode: "2729" },
{ city: "TUMBLONG", state: "NSW", postcode: "2729" },
{ city: "WESTWOOD", state: "NSW", postcode: "2729" },
{ city: "WONDALGA", state: "NSW", postcode: "2729" },
{ city: "YAVEN CREEK", state: "NSW", postcode: "2729" },
{ city: "BATLOW", state: "NSW", postcode: "2730" },
{ city: "GREEN HILLS", state: "NSW", postcode: "2730" },
{ city: "KUNAMA", state: "NSW", postcode: "2730" },
{ city: "LOWER BAGO", state: "NSW", postcode: "2730" },
{ city: "BUNNALOO", state: "NSW", postcode: "2731" },
{ city: "MOAMA", state: "NSW", postcode: "2731" },
{ city: "TANTONAN", state: "NSW", postcode: "2731" },
{ city: "THYRA", state: "NSW", postcode: "2731" },
{ city: "WOMBOOTA", state: "NSW", postcode: "2731" },
{ city: "BARHAM", state: "NSW", postcode: "2732" },
{ city: "BURRABOI", state: "NSW", postcode: "2732" },
{ city: "COBRAMUNGA", state: "NSW", postcode: "2732" },
{ city: "GONN", state: "NSW", postcode: "2732" },
{ city: "NOORONG", state: "NSW", postcode: "2732" },
{ city: "THULE", state: "NSW", postcode: "2732" },
{ city: "TULLAKOOL", state: "NSW", postcode: "2732" },
{ city: "DHURAGOON", state: "NSW", postcode: "2733" },
{ city: "MOULAMEIN", state: "NSW", postcode: "2733" },
{ city: "NIEMUR", state: "NSW", postcode: "2733" },
{ city: "CUNNINYEUK", state: "NSW", postcode: "2734" },
{ city: "DILPURRA", state: "NSW", postcode: "2734" },
{ city: "KYALITE", state: "NSW", postcode: "2734" },
{ city: "MALLAN", state: "NSW", postcode: "2734" },
{ city: "MELLOOL", state: "NSW", postcode: "2734" },
{ city: "MOOLPA", state: "NSW", postcode: "2734" },
{ city: "MURRAY DOWNS", state: "NSW", postcode: "2734" },
{ city: "STONY CROSSING", state: "NSW", postcode: "2734" },
{ city: "TOORANIE", state: "NSW", postcode: "2734" },
{ city: "WETUPPA", state: "NSW", postcode: "2734" },
{ city: "KORALEIGH", state: "NSW", postcode: "2735" },
{ city: "SPEEWA", state: "NSW", postcode: "2735" },
{ city: "GOODNIGHT", state: "NSW", postcode: "2736" },
{ city: "TOOLEYBUC", state: "NSW", postcode: "2736" },
{ city: "EUSTON", state: "NSW", postcode: "2737" },
{ city: "GOL GOL", state: "NSW", postcode: "2738" },
{ city: "MALLEE", state: "NSW", postcode: "2738" },
{ city: "MONAK", state: "NSW", postcode: "2738" },
{ city: "PARINGI", state: "NSW", postcode: "2738" },
{ city: "TRENTHAM CLIFFS", state: "NSW", postcode: "2738" },
{ city: "BOEILL CREEK", state: "NSW", postcode: "2739" },
{ city: "BURONGA", state: "NSW", postcode: "2739" },
{ city: "MOURQUONG", state: "NSW", postcode: "2739" },
{ city: "BOWEN MOUNTAIN", state: "NSW", postcode: "2753" },
{ city: "GROSE VALE", state: "NSW", postcode: "2753" },
{ city: "GROSE WOLD", state: "NSW", postcode: "2753" },
{ city: "YARRAMUNDI", state: "NSW", postcode: "2753" },
{ city: "CATTAI", state: "NSW", postcode: "2756" },
{ city: "CENTRAL COLO", state: "NSW", postcode: "2756" },
{ city: "CLARENDON", state: "NSW", postcode: "2756" },
{ city: "COLO", state: "NSW", postcode: "2756" },
{ city: "COLO HEIGHTS", state: "NSW", postcode: "2756" },
{ city: "CORNWALLIS", state: "NSW", postcode: "2756" },
{ city: "EBENEZER", state: "NSW", postcode: "2756" },
{ city: "FREEMANS REACH", state: "NSW", postcode: "2756" },
{ city: "GLOSSODIA", state: "NSW", postcode: "2756" },
{ city: "LOWER PORTLAND", state: "NSW", postcode: "2756" },
{ city: "MAROOTA", state: "NSW", postcode: "2756" },
{ city: "MELLONG", state: "NSW", postcode: "2756" },
{ city: "PITT TOWN", state: "NSW", postcode: "2756" },
{ city: "SACKVILLE", state: "NSW", postcode: "2756" },
{ city: "SACKVILLE NORTH", state: "NSW", postcode: "2756" },
{ city: "SCHEYVILLE", state: "NSW", postcode: "2756" },
{ city: "SOUTH MAROOTA", state: "NSW", postcode: "2756" },
{ city: "UPPER COLO", state: "NSW", postcode: "2756" },
{ city: "KURMOND", state: "NSW", postcode: "2757" },
{ city: "BERAMBING", state: "NSW", postcode: "2758" },
{ city: "BILPIN", state: "NSW", postcode: "2758" },
{ city: "BLAXLANDS RIDGE", state: "NSW", postcode: "2758" },
{ city: "EAST KURRAJONG", state: "NSW", postcode: "2758" },
{ city: "KURRAJONG", state: "NSW", postcode: "2758" },
{ city: "KURRAJONG HEIGHTS", state: "NSW", postcode: "2758" },
{ city: "KURRAJONG HILLS", state: "NSW", postcode: "2758" },
{ city: "MOUNTAIN LAGOON", state: "NSW", postcode: "2758" },
{ city: "MOUNT TOMAH", state: "NSW", postcode: "2758" },
{ city: "THE DEVILS WILDERNESS", state: "NSW", postcode: "2758" },
{ city: "WHEENY CREEK", state: "NSW", postcode: "2758" },
{ city: "LAPSTONE", state: "NSW", postcode: "2773" },
{ city: "MOUNT RIVERVIEW", state: "NSW", postcode: "2774" },
{ city: "WARRIMOO", state: "NSW", postcode: "2774" },
{ city: "CENTRAL MACDONALD", state: "NSW", postcode: "2775" },
{ city: "FERNANCES", state: "NSW", postcode: "2775" },
{ city: "GUNDERMAN", state: "NSW", postcode: "2775" },
{ city: "HIGHER MACDONALD", state: "NSW", postcode: "2775" },
{ city: "LAUGHTONDALE", state: "NSW", postcode: "2775" },
{ city: "LEETS VALE", state: "NSW", postcode: "2775" },
{ city: "LOWER MACDONALD", state: "NSW", postcode: "2775" },
{ city: "MARLOW", state: "NSW", postcode: "2775" },
{ city: "MOGO CREEK", state: "NSW", postcode: "2775" },
{ city: "PERRYS CROSSING", state: "NSW", postcode: "2775" },
{ city: "SINGLETONS MILL", state: "NSW", postcode: "2775" },
{ city: "SPENCER", state: "NSW", postcode: "2775" },
{ city: "ST ALBANS", state: "NSW", postcode: "2775" },
{ city: "UPPER MACDONALD", state: "NSW", postcode: "2775" },
{ city: "WEBBS CREEK", state: "NSW", postcode: "2775" },
{ city: "WISEMANS FERRY", state: "NSW", postcode: "2775" },
{ city: "WRIGHTS CREEK", state: "NSW", postcode: "2775" },
{ city: "HAWKESBURY HEIGHTS", state: "NSW", postcode: "2777" },
{ city: "SUN VALLEY", state: "NSW", postcode: "2777" },
{ city: "WINMALEE", state: "NSW", postcode: "2777" },
{ city: "YELLOW ROCK", state: "NSW", postcode: "2777" },
{ city: "LINDEN", state: "NSW", postcode: "2778" },
{ city: "BULLABURRA", state: "NSW", postcode: "2784" },
{ city: "MEGALONG", state: "NSW", postcode: "2785" },
{ city: "MEGALONG VALLEY", state: "NSW", postcode: "2785" },
{ city: "BELL", state: "NSW", postcode: "2786" },
{ city: "DARGAN", state: "NSW", postcode: "2786" },
{ city: "MOUNT IRVINE", state: "NSW", postcode: "2786" },
{ city: "MOUNT WILSON", state: "NSW", postcode: "2786" },
{ city: "BLACK SPRINGS", state: "NSW", postcode: "2787" },
{ city: "CHATHAM VALLEY", state: "NSW", postcode: "2787" },
{ city: "DUCKMALOI", state: "NSW", postcode: "2787" },
{ city: "EDITH", state: "NSW", postcode: "2787" },
{ city: "ESSINGTON", state: "NSW", postcode: "2787" },
{ city: "GINGKIN", state: "NSW", postcode: "2787" },
{ city: "GURNANG", state: "NSW", postcode: "2787" },
{ city: "HAZELGROVE", state: "NSW", postcode: "2787" },
{ city: "JAUNTER", state: "NSW", postcode: "2787" },
{ city: "KANANGRA", state: "NSW", postcode: "2787" },
{ city: "MAYFIELD", state: "NSW", postcode: "2787" },
{ city: "MOUNT OLIVE", state: "NSW", postcode: "2787" },
{ city: "MOUNT WERONG", state: "NSW", postcode: "2787" },
{ city: "MOZART", state: "NSW", postcode: "2787" },
{ city: "NORWAY", state: "NSW", postcode: "2787" },
{ city: "OBERON", state: "NSW", postcode: "2787" },
{ city: "PORTERS RETREAT", state: "NSW", postcode: "2787" },
{ city: "SHOOTERS HILL", state: "NSW", postcode: "2787" },
{ city: "TARANA", state: "NSW", postcode: "2787" },
{ city: "THE MEADOWS", state: "NSW", postcode: "2787" },
{ city: "BEN BULLEN", state: "NSW", postcode: "2790" },
{ city: "BLACKMANS FLAT", state: "NSW", postcode: "2790" },
{ city: "BOWENFELS", state: "NSW", postcode: "2790" },
{ city: "CLARENCE", state: "NSW", postcode: "2790" },
{ city: "COBAR PARK", state: "NSW", postcode: "2790" },
{ city: "CORNEY TOWN", state: "NSW", postcode: "2790" },
{ city: "CULLEN BULLEN", state: "NSW", postcode: "2790" },
{ city: "DOCTORS GAP", state: "NSW", postcode: "2790" },
{ city: "GANBENANG", state: "NSW", postcode: "2790" },
{ city: "GOOD FOREST", state: "NSW", postcode: "2790" },
{ city: "HAMPTON", state: "NSW", postcode: "2790" },
{ city: "HARTLEY", state: "NSW", postcode: "2790" },
{ city: "HARTLEY VALE", state: "NSW", postcode: "2790" },
{ city: "HASSANS WALLS", state: "NSW", postcode: "2790" },
{ city: "HERMITAGE FLAT", state: "NSW", postcode: "2790" },
{ city: "JENOLAN", state: "NSW", postcode: "2790" },
{ city: "KANIMBLA", state: "NSW", postcode: "2790" },
{ city: "LIDSDALE", state: "NSW", postcode: "2790" },
{ city: "LITHGOW", state: "NSW", postcode: "2790" },
{ city: "LITHGOW DC", state: "NSW", postcode: "2790" },
{ city: "LITTLE HARTLEY", state: "NSW", postcode: "2790" },
{ city: "LITTLETON", state: "NSW", postcode: "2790" },
{ city: "LOWTHER", state: "NSW", postcode: "2790" },
{ city: "MARRANGAROO", state: "NSW", postcode: "2790" },
{ city: "MCKELLARS PARK", state: "NSW", postcode: "2790" },
{ city: "MORTS ESTATE", state: "NSW", postcode: "2790" },
{ city: "MOUNT LAMBIE", state: "NSW", postcode: "2790" },
{ city: "NEWNES", state: "NSW", postcode: "2790" },
{ city: "NEWNES PLATEAU", state: "NSW", postcode: "2790" },
{ city: "OAKY PARK", state: "NSW", postcode: "2790" },
{ city: "POTTERY ESTATE", state: "NSW", postcode: "2790" },
{ city: "RYDAL", state: "NSW", postcode: "2790" },
{ city: "SHEEDYS GULLY", state: "NSW", postcode: "2790" },
{ city: "SODWALLS", state: "NSW", postcode: "2790" },
{ city: "SOUTH BOWENFELS", state: "NSW", postcode: "2790" },
{ city: "SOUTH LITTLETON", state: "NSW", postcode: "2790" },
{ city: "SPRINGVALE", state: "NSW", postcode: "2790" },
{ city: "STATE MINE GULLY", state: "NSW", postcode: "2790" },
{ city: "VALE OF CLWYDD", state: "NSW", postcode: "2790" },
{ city: "WOLGAN VALLEY", state: "NSW", postcode: "2790" },
{ city: "WOLLANGAMBE", state: "NSW", postcode: "2790" },
{ city: "CARCOAR", state: "NSW", postcode: "2791" },
{ city: "ERROWANBANG", state: "NSW", postcode: "2791" },
{ city: "BURNT YARDS", state: "NSW", postcode: "2792" },
{ city: "MANDURAMA", state: "NSW", postcode: "2792" },
{ city: "DARBYS FALLS", state: "NSW", postcode: "2793" },
{ city: "ROSEBERG", state: "NSW", postcode: "2793" },
{ city: "WOODSTOCK", state: "NSW", postcode: "2793" },
{ city: "BUMBALDRY", state: "NSW", postcode: "2794" },
{ city: "COWRA", state: "NSW", postcode: "2794" },
{ city: "HOVELLS CREEK", state: "NSW", postcode: "2794" },
{ city: "MOUNT COLLINS", state: "NSW", postcode: "2794" },
{ city: "WATTAMONDARA", state: "NSW", postcode: "2794" },
{ city: "ABERCROMBIE", state: "NSW", postcode: "2795" },
{ city: "ABERCROMBIE RIVER", state: "NSW", postcode: "2795" },
{ city: "ARKELL", state: "NSW", postcode: "2795" },
{ city: "ARKSTONE", state: "NSW", postcode: "2795" },
{ city: "BALD RIDGE", state: "NSW", postcode: "2795" },
{ city: "BALLYROE", state: "NSW", postcode: "2795" },
{ city: "BATHAMPTON", state: "NSW", postcode: "2795" },
{ city: "BILLYWILLINGA", state: "NSW", postcode: "2795" },
{ city: "BREWONGLE", state: "NSW", postcode: "2795" },
{ city: "BRUINBUN", state: "NSW", postcode: "2795" },
{ city: "BURRAGA", state: "NSW", postcode: "2795" },
{ city: "CALOOLA", state: "NSW", postcode: "2795" },
{ city: "CHARLES STURT UNIVERSITY", state: "NSW", postcode: "2795" },
{ city: "CHARLTON", state: "NSW", postcode: "2795" },
{ city: "CLEAR CREEK", state: "NSW", postcode: "2795" },
{ city: "COLO", state: "NSW", postcode: "2795" },
{ city: "COPPERHANNIA", state: "NSW", postcode: "2795" },
{ city: "COW FLAT", state: "NSW", postcode: "2795" },
{ city: "CRUDINE", state: "NSW", postcode: "2795" },
{ city: "CURRAGH", state: "NSW", postcode: "2795" },
{ city: "DARK CORNER", state: "NSW", postcode: "2795" },
{ city: "DOG ROCKS", state: "NSW", postcode: "2795" },
{ city: "DUNKELD", state: "NSW", postcode: "2795" },
{ city: "DURAMANA", state: "NSW", postcode: "2795" },
{ city: "EGLINTON", state: "NSW", postcode: "2795" },
{ city: "ESSINGTON", state: "NSW", postcode: "2795" },
{ city: "EVANS PLAINS", state: "NSW", postcode: "2795" },
{ city: "FITZGERALDS VALLEY", state: "NSW", postcode: "2795" },
{ city: "FOREST GROVE", state: "NSW", postcode: "2795" },
{ city: "FOSTERS VALLEY", state: "NSW", postcode: "2795" },
{ city: "FREEMANTLE", state: "NSW", postcode: "2795" },
{ city: "GEMALLA", state: "NSW", postcode: "2795" },
{ city: "GEORGES PLAINS", state: "NSW", postcode: "2795" },
{ city: "GILMANDYKE", state: "NSW", postcode: "2795" },
{ city: "GLANMIRE", state: "NSW", postcode: "2795" },
{ city: "GORMANS HILL", state: "NSW", postcode: "2795" },
{ city: "GOWAN", state: "NSW", postcode: "2795" },
{ city: "HOBBYS YARDS", state: "NSW", postcode: "2795" },
{ city: "ISABELLA", state: "NSW", postcode: "2795" },
{ city: "JEREMY", state: "NSW", postcode: "2795" },
{ city: "JUDDS CREEK", state: "NSW", postcode: "2795" },
{ city: "KILLONGBUTTA", state: "NSW", postcode: "2795" },
{ city: "KIRKCONNELL", state: "NSW", postcode: "2795" },
{ city: "LAFFING WATERS", state: "NSW", postcode: "2795" },
{ city: "LIMEKILNS", state: "NSW", postcode: "2795" },
{ city: "LLANARTH", state: "NSW", postcode: "2795" },
{ city: "LOCKSLEY", state: "NSW", postcode: "2795" },
{ city: "MEADOW FLAT", state: "NSW", postcode: "2795" },
{ city: "MILKERS FLAT", state: "NSW", postcode: "2795" },
{ city: "MILLAH MURRAH", state: "NSW", postcode: "2795" },
{ city: "MITCHELL", state: "NSW", postcode: "2795" },
{ city: "MOORILDA", state: "NSW", postcode: "2795" },
{ city: "MOUNT DAVID", state: "NSW", postcode: "2795" },
{ city: "MOUNT RANKIN", state: "NSW", postcode: "2795" },
{ city: "NAPOLEON REEF", state: "NSW", postcode: "2795" },
{ city: "NEWBRIDGE", state: "NSW", postcode: "2795" },
{ city: "O'CONNELL", state: "NSW", postcode: "2795" },
{ city: "ORTON PARK", state: "NSW", postcode: "2795" },
{ city: "PALING YARDS", state: "NSW", postcode: "2795" },
{ city: "PALMERS OAKY", state: "NSW", postcode: "2795" },
{ city: "PEEL", state: "NSW", postcode: "2795" },
{ city: "PERTHVILLE", state: "NSW", postcode: "2795" },
{ city: "ROBIN HILL", state: "NSW", postcode: "2795" },
{ city: "ROCK FOREST", state: "NSW", postcode: "2795" },
{ city: "ROCKLEY", state: "NSW", postcode: "2795" },
{ city: "ROCKLEY MOUNT", state: "NSW", postcode: "2795" },
{ city: "SOFALA", state: "NSW", postcode: "2795" },
{ city: "STEWARTS MOUNT", state: "NSW", postcode: "2795" },
{ city: "SUNNY CORNER", state: "NSW", postcode: "2795" },
{ city: "TAMBAROORA", state: "NSW", postcode: "2795" },
{ city: "TANNAS MOUNT", state: "NSW", postcode: "2795" },
{ city: "THE LAGOON", state: "NSW", postcode: "2795" },
{ city: "THE ROCKS", state: "NSW", postcode: "2795" },
{ city: "TRIANGLE FLAT", state: "NSW", postcode: "2795" },
{ city: "TRUNKEY CREEK", state: "NSW", postcode: "2795" },
{ city: "TURONDALE", state: "NSW", postcode: "2795" },
{ city: "TWENTY FORESTS", state: "NSW", postcode: "2795" },
{ city: "UPPER TURON", state: "NSW", postcode: "2795" },
{ city: "WALANG", state: "NSW", postcode: "2795" },
{ city: "WAMBOOL", state: "NSW", postcode: "2795" },
{ city: "WATTLE FLAT", state: "NSW", postcode: "2795" },
{ city: "WATTON", state: "NSW", postcode: "2795" },
{ city: "WHITE ROCK", state: "NSW", postcode: "2795" },
{ city: "WIAGDON", state: "NSW", postcode: "2795" },
{ city: "WIMBLEDON", state: "NSW", postcode: "2795" },
{ city: "WINBURNDALE", state: "NSW", postcode: "2795" },
{ city: "WINDRADYNE", state: "NSW", postcode: "2795" },
{ city: "WISEMANS CREEK", state: "NSW", postcode: "2795" },
{ city: "YARRAS", state: "NSW", postcode: "2795" },
{ city: "YETHOLME", state: "NSW", postcode: "2795" },
{ city: "GARLAND", state: "NSW", postcode: "2797" },
{ city: "LYNDHURST", state: "NSW", postcode: "2797" },
{ city: "BYNG", state: "NSW", postcode: "2798" },
{ city: "FOREST REEFS", state: "NSW", postcode: "2798" },
{ city: "GUYONG", state: "NSW", postcode: "2798" },
{ city: "MILLTHORPE", state: "NSW", postcode: "2798" },
{ city: "SPRING TERRACE", state: "NSW", postcode: "2798" },
{ city: "TALLWOOD", state: "NSW", postcode: "2798" },
{ city: "BARRY", state: "NSW", postcode: "2799" },
{ city: "BLAYNEY", state: "NSW", postcode: "2799" },
{ city: "BROWNS CREEK", state: "NSW", postcode: "2799" },
{ city: "FITZGERALDS MOUNT", state: "NSW", postcode: "2799" },
{ city: "KINGS PLAINS", state: "NSW", postcode: "2799" },
{ city: "NEVILLE", state: "NSW", postcode: "2799" },
{ city: "VITTORIA", state: "NSW", postcode: "2799" },
{ city: "BENDICK MURRELL", state: "NSW", postcode: "2803" },
{ city: "CROWTHER", state: "NSW", postcode: "2803" },
{ city: "WIRRIMAH", state: "NSW", postcode: "2803" },
{ city: "BILLIMARI", state: "NSW", postcode: "2804" },
{ city: "CANOWINDRA", state: "NSW", postcode: "2804" },
{ city: "MOORBEL", state: "NSW", postcode: "2804" },
{ city: "NYRANG CREEK", state: "NSW", postcode: "2804" },
{ city: "GOOLOOGONG", state: "NSW", postcode: "2805" },
{ city: "EUGOWRA", state: "NSW", postcode: "2806" },
{ city: "KOORAWATHA", state: "NSW", postcode: "2807" },
{ city: "WYANGALA", state: "NSW", postcode: "2808" },
{ city: "GREENETHORPE", state: "NSW", postcode: "2809" },
{ city: "BIMBI", state: "NSW", postcode: "2810" },
{ city: "CARAGABAL", state: "NSW", postcode: "2810" },
{ city: "GLENELG", state: "NSW", postcode: "2810" },
{ city: "GRENFELL", state: "NSW", postcode: "2810" },
{ city: "PINEY RANGE", state: "NSW", postcode: "2810" },
{ city: "PINNACLE", state: "NSW", postcode: "2810" },
{ city: "PULLABOOKA", state: "NSW", postcode: "2810" },
{ city: "WARRADERRY", state: "NSW", postcode: "2810" },
{ city: "BENOLONG", state: "NSW", postcode: "2818" },
{ city: "GEURIE", state: "NSW", postcode: "2818" },
{ city: "PONTO", state: "NSW", postcode: "2818" },
{ city: "TERRABELLA", state: "NSW", postcode: "2818" },
{ city: "APSLEY", state: "NSW", postcode: "2820" },
{ city: "ARTHURVILLE", state: "NSW", postcode: "2820" },
{ city: "BAKERS SWAMP", state: "NSW", postcode: "2820" },
{ city: "BODANGORA", state: "NSW", postcode: "2820" },
{ city: "COMOBELLA", state: "NSW", postcode: "2820" },
{ city: "CURRA CREEK", state: "NSW", postcode: "2820" },
{ city: "DRIPSTONE", state: "NSW", postcode: "2820" },
{ city: "FARNHAM", state: "NSW", postcode: "2820" },
{ city: "GOLLAN", state: "NSW", postcode: "2820" },
{ city: "LAKE BURRENDONG", state: "NSW", postcode: "2820" },
{ city: "MARYVALE", state: "NSW", postcode: "2820" },
{ city: "MEDWAY", state: "NSW", postcode: "2820" },
{ city: "MONTEFIORES", state: "NSW", postcode: "2820" },
{ city: "MOOKERAWA", state: "NSW", postcode: "2820" },
{ city: "MOUNT AQUILA", state: "NSW", postcode: "2820" },
{ city: "MOUNT ARTHUR", state: "NSW", postcode: "2820" },
{ city: "MUMBIL", state: "NSW", postcode: "2820" },
{ city: "NANIMA", state: "NSW", postcode: "2820" },
{ city: "NEUREA", state: "NSW", postcode: "2820" },
{ city: "SPICERS CREEK", state: "NSW", postcode: "2820" },
{ city: "STUART TOWN", state: "NSW", postcode: "2820" },
{ city: "SUNTOP", state: "NSW", postcode: "2820" },
{ city: "WALMER", state: "NSW", postcode: "2820" },
{ city: "WELLINGTON", state: "NSW", postcode: "2820" },
{ city: "WUULUMAN", state: "NSW", postcode: "2820" },
{ city: "YARRAGAL", state: "NSW", postcode: "2820" },
{ city: "BURROWAY", state: "NSW", postcode: "2821" },
{ city: "NARROMINE", state: "NSW", postcode: "2821" },
{ city: "BUNDEMAR", state: "NSW", postcode: "2823" },
{ city: "CATHUNDRAL", state: "NSW", postcode: "2823" },
{ city: "DANDALOO", state: "NSW", postcode: "2823" },
{ city: "GIN GIN", state: "NSW", postcode: "2823" },
{ city: "TRANGIE", state: "NSW", postcode: "2823" },
{ city: "BEEMUNNEL", state: "NSW", postcode: "2824" },
{ city: "BULLAGREEN", state: "NSW", postcode: "2824" },
{ city: "EENAWEENA", state: "NSW", postcode: "2824" },
{ city: "MARTHAGUY", state: "NSW", postcode: "2824" },
{ city: "MOUNT FOSTER", state: "NSW", postcode: "2824" },
{ city: "MOUNT HARRIS", state: "NSW", postcode: "2824" },
{ city: "MUMBLEBONE PLAIN", state: "NSW", postcode: "2824" },
{ city: "OXLEY", state: "NSW", postcode: "2824" },
{ city: "PIGEONBAH", state: "NSW", postcode: "2824" },
{ city: "PINE CLUMP", state: "NSW", postcode: "2824" },
{ city: "RAVENSWOOD", state: "NSW", postcode: "2824" },
{ city: "RED HILL", state: "NSW", postcode: "2824" },
{ city: "SNAKES PLAIN", state: "NSW", postcode: "2824" },
{ city: "TENANDRA", state: "NSW", postcode: "2824" },
{ city: "WARREN", state: "NSW", postcode: "2824" },
{ city: "BABINDA", state: "NSW", postcode: "2825" },
{ city: "BOBADAH", state: "NSW", postcode: "2825" },
{ city: "BOGAN", state: "NSW", postcode: "2825" },
{ city: "BUDDABADAH", state: "NSW", postcode: "2825" },
{ city: "CANONBA", state: "NSW", postcode: "2825" },
{ city: "FIVE WAYS", state: "NSW", postcode: "2825" },
{ city: "HONEYBUGLE", state: "NSW", postcode: "2825" },
{ city: "MIANDETTA", state: "NSW", postcode: "2825" },
{ city: "MULLA", state: "NSW", postcode: "2825" },
{ city: "MULLENGUDGERY", state: "NSW", postcode: "2825" },
{ city: "MURRAWOMBIE", state: "NSW", postcode: "2825" },
{ city: "NYNGAN", state: "NSW", postcode: "2825" },
{ city: "PANGEE", state: "NSW", postcode: "2825" },
{ city: "BOGAN", state: "NSW", postcode: "2826" },
{ city: "NEVERTIRE", state: "NSW", postcode: "2826" },
{ city: "BEARBONG", state: "NSW", postcode: "2827" },
{ city: "BIDDON", state: "NSW", postcode: "2827" },
{ city: "BREELONG", state: "NSW", postcode: "2827" },
{ city: "COLLIE", state: "NSW", postcode: "2827" },
{ city: "CURBAN", state: "NSW", postcode: "2827" },
{ city: "GILGANDRA", state: "NSW", postcode: "2827" },
{ city: "MERRIGAL", state: "NSW", postcode: "2827" },
{ city: "ARMATREE", state: "NSW", postcode: "2828" },
{ city: "BLACK HOLLOW", state: "NSW", postcode: "2828" },
{ city: "BOURBAH", state: "NSW", postcode: "2828" },
{ city: "GULARGAMBONE", state: "NSW", postcode: "2828" },
{ city: "MOUNT TENANDRA", state: "NSW", postcode: "2828" },
{ city: "QUANDA", state: "NSW", postcode: "2828" },
{ city: "TONDERBURINE", state: "NSW", postcode: "2828" },
{ city: "WARRUMBUNGLE", state: "NSW", postcode: "2828" },
{ city: "BILLEROY", state: "NSW", postcode: "2829" },
{ city: "COMBARA", state: "NSW", postcode: "2829" },
{ city: "CONIMBIA", state: "NSW", postcode: "2829" },
{ city: "COONAMBLE", state: "NSW", postcode: "2829" },
{ city: "GILGOOMA", state: "NSW", postcode: "2829" },
{ city: "GUNGALMAN", state: "NSW", postcode: "2829" },
{ city: "MAGOMETON", state: "NSW", postcode: "2829" },
{ city: "NEBEA", state: "NSW", postcode: "2829" },
{ city: "PINE GROVE", state: "NSW", postcode: "2829" },
{ city: "TERIDGERIE", state: "NSW", postcode: "2829" },
{ city: "TOOLOON", state: "NSW", postcode: "2829" },
{ city: "URAWILKIE", state: "NSW", postcode: "2829" },
{ city: "WINGADEE", state: "NSW", postcode: "2829" },
{ city: "ARMATREE", state: "NSW", postcode: "2831" },
{ city: "BALLADORAN", state: "NSW", postcode: "2831" },
{ city: "BILLEROY", state: "NSW", postcode: "2831" },
{ city: "BRENDA", state: "NSW", postcode: "2831" },
{ city: "BULLAGREEN", state: "NSW", postcode: "2831" },
{ city: "BYROCK", state: "NSW", postcode: "2831" },
{ city: "CARINDA", state: "NSW", postcode: "2831" },
{ city: "COOLABAH", state: "NSW", postcode: "2831" },
{ city: "ELONG ELONG", state: "NSW", postcode: "2831" },
{ city: "EUMUNGERIE", state: "NSW", postcode: "2831" },
{ city: "GEURIE", state: "NSW", postcode: "2831" },
{ city: "GIRILAMBONE", state: "NSW", postcode: "2831" },
{ city: "GOODOOGA", state: "NSW", postcode: "2831" },
{ city: "GUNGALMAN", state: "NSW", postcode: "2831" },
{ city: "HERMIDALE", state: "NSW", postcode: "2831" },
{ city: "MACQUARIE MARSHES", state: "NSW", postcode: "2831" },
{ city: "MERRYGOEN", state: "NSW", postcode: "2831" },
{ city: "NEILREX", state: "NSW", postcode: "2831" },
{ city: "NEVERTIRE", state: "NSW", postcode: "2831" },
{ city: "NUBINGERIE", state: "NSW", postcode: "2831" },
{ city: "NYMAGEE", state: "NSW", postcode: "2831" },
{ city: "PINE CLUMP", state: "NSW", postcode: "2831" },
{ city: "PONTO", state: "NSW", postcode: "2831" },
{ city: "QUAMBONE", state: "NSW", postcode: "2831" },
{ city: "TERRABELLA", state: "NSW", postcode: "2831" },
{ city: "THE MARRA", state: "NSW", postcode: "2831" },
{ city: "TOOLOON", state: "NSW", postcode: "2831" },
{ city: "TOORAWEENAH", state: "NSW", postcode: "2831" },
{ city: "WESTELLA", state: "NSW", postcode: "2831" },
{ city: "WONGARBON", state: "NSW", postcode: "2831" },
{ city: "COME BY CHANCE", state: "NSW", postcode: "2832" },
{ city: "CRYON", state: "NSW", postcode: "2832" },
{ city: "CUMBORAH", state: "NSW", postcode: "2832" },
{ city: "WALGETT", state: "NSW", postcode: "2832" },
{ city: "COLLARENEBRI", state: "NSW", postcode: "2833" },
{ city: "ANGLEDOOL", state: "NSW", postcode: "2834" },
{ city: "LIGHTNING RIDGE", state: "NSW", postcode: "2834" },
{ city: "BULLA", state: "NSW", postcode: "2835" },
{ city: "CANBELEGO", state: "NSW", postcode: "2835" },
{ city: "COBAR", state: "NSW", postcode: "2835" },
{ city: "CUBBA", state: "NSW", postcode: "2835" },
{ city: "GILGUNNIA", state: "NSW", postcode: "2835" },
{ city: "IRYMPLE", state: "NSW", postcode: "2835" },
{ city: "KERRIGUNDI", state: "NSW", postcode: "2835" },
{ city: "KULWIN", state: "NSW", postcode: "2835" },
{ city: "LERIDA", state: "NSW", postcode: "2835" },
{ city: "NOONA", state: "NSW", postcode: "2835" },
{ city: "SANDY CREEK", state: "NSW", postcode: "2835" },
{ city: "TINDAREY", state: "NSW", postcode: "2835" },
{ city: "WHITE CLIFFS", state: "NSW", postcode: "2836" },
{ city: "WILCANNIA", state: "NSW", postcode: "2836" },
{ city: "GOODOOGA", state: "NSW", postcode: "2838" },
{ city: "BOGAN", state: "NSW", postcode: "2839" },
{ city: "BREWARRINA", state: "NSW", postcode: "2839" },
{ city: "COLLERINA", state: "NSW", postcode: "2839" },
{ city: "GONGOLGON", state: "NSW", postcode: "2839" },
{ city: "NARRAN LAKE", state: "NSW", postcode: "2839" },
{ city: "TALAWANTA", state: "NSW", postcode: "2839" },
{ city: "WEILMORINGLE", state: "NSW", postcode: "2839" },
{ city: "BOURKE", state: "NSW", postcode: "2840" },
{ city: "ENNGONIA", state: "NSW", postcode: "2840" },
{ city: "FORDS BRIDGE", state: "NSW", postcode: "2840" },
{ city: "GUMBALIE", state: "NSW", postcode: "2840" },
{ city: "GUNDERBOOKA", state: "NSW", postcode: "2840" },
{ city: "HUNGERFORD", state: "NSW", postcode: "2840" },
{ city: "LOUTH", state: "NSW", postcode: "2840" },
{ city: "NORTH BOURKE", state: "NSW", postcode: "2840" },
{ city: "TILPA", state: "NSW", postcode: "2840" },
{ city: "WANAARING", state: "NSW", postcode: "2840" },
{ city: "YANTABULLA", state: "NSW", postcode: "2840" },
{ city: "MENDOORAN", state: "NSW", postcode: "2842" },
{ city: "MOLLYAN", state: "NSW", postcode: "2842" },
{ city: "WATTLE SPRINGS", state: "NSW", postcode: "2842" },
{ city: "YARRAGRIN", state: "NSW", postcode: "2842" },
{ city: "COOLAH", state: "NSW", postcode: "2843" },
{ city: "BIRRIWA", state: "NSW", postcode: "2844" },
{ city: "DUNEDOO", state: "NSW", postcode: "2844" },
{ city: "LEADVILLE", state: "NSW", postcode: "2844" },
{ city: "WALLERAWANG", state: "NSW", postcode: "2845" },
{ city: "CAPERTEE", state: "NSW", postcode: "2846" },
{ city: "GLEN DAVIS", state: "NSW", postcode: "2846" },
{ city: "ROUND SWAMP", state: "NSW", postcode: "2846" },
{ city: "BROGANS CREEK", state: "NSW", postcode: "2848" },
{ city: "CHARBON", state: "NSW", postcode: "2848" },
{ city: "CLANDULLA", state: "NSW", postcode: "2848" },
{ city: "KANDOS", state: "NSW", postcode: "2848" },
{ city: "BOGEE", state: "NSW", postcode: "2849" },
{ city: "BREAKFAST CREEK", state: "NSW", postcode: "2849" },
{ city: "BUDDEN", state: "NSW", postcode: "2849" },
{ city: "BYLONG", state: "NSW", postcode: "2849" },
{ city: "CAMBOON", state: "NSW", postcode: "2849" },
{ city: "CARWELL", state: "NSW", postcode: "2849" },
{ city: "COGGAN", state: "NSW", postcode: "2849" },
{ city: "COXS CREEK", state: "NSW", postcode: "2849" },
{ city: "COXS CROWN", state: "NSW", postcode: "2849" },
{ city: "DABEE", state: "NSW", postcode: "2849" },
{ city: "DUNGEREE", state: "NSW", postcode: "2849" },
{ city: "DUNVILLE LOOP", state: "NSW", postcode: "2849" },
{ city: "GINGHI", state: "NSW", postcode: "2849" },
{ city: "GLEN ALICE", state: "NSW", postcode: "2849" },
{ city: "GROWEE", state: "NSW", postcode: "2849" },
{ city: "KELGOOLA", state: "NSW", postcode: "2849" },
{ city: "LEE CREEK", state: "NSW", postcode: "2849" },
{ city: "MOUNT MARSDEN", state: "NSW", postcode: "2849" },
{ city: "MURRUMBO", state: "NSW", postcode: "2849" },
{ city: "NULLO MOUNTAIN", state: "NSW", postcode: "2849" },
{ city: "OLINDA", state: "NSW", postcode: "2849" },
{ city: "PINNACLE SWAMP", state: "NSW", postcode: "2849" },
{ city: "PYANGLE", state: "NSW", postcode: "2849" },
{ city: "REEDY CREEK", state: "NSW", postcode: "2849" },
{ city: "RYLSTONE", state: "NSW", postcode: "2849" },
{ city: "UPPER BYLONG", state: "NSW", postcode: "2849" },
{ city: "UPPER GROWEE", state: "NSW", postcode: "2849" },
{ city: "UPPER NILE", state: "NSW", postcode: "2849" },
{ city: "WIRRABA", state: "NSW", postcode: "2849" },
{ city: "AARONS PASS", state: "NSW", postcode: "2850" },
{ city: "APPLE TREE FLAT", state: "NSW", postcode: "2850" },
{ city: "AVISFORD", state: "NSW", postcode: "2850" },
{ city: "BARA", state: "NSW", postcode: "2850" },
{ city: "BARIGAN", state: "NSW", postcode: "2850" },
{ city: "BEN BUCKLEY", state: "NSW", postcode: "2850" },
{ city: "BOCOBLE", state: "NSW", postcode: "2850" },
{ city: "BOMBIRA", state: "NSW", postcode: "2850" },
{ city: "BOTOBOLAR", state: "NSW", postcode: "2850" },
{ city: "BUCKAROO", state: "NSW", postcode: "2850" },
{ city: "BUDGEE BUDGEE", state: "NSW", postcode: "2850" },
{ city: "BURRUNDULLA", state: "NSW", postcode: "2850" },
{ city: "CAERLEON", state: "NSW", postcode: "2850" },
{ city: "CANADIAN LEAD", state: "NSW", postcode: "2850" },
{ city: "CARCALGONG", state: "NSW", postcode: "2850" },
{ city: "COLLINGWOOD", state: "NSW", postcode: "2850" },
{ city: "COOKS GAP", state: "NSW", postcode: "2850" },
{ city: "COOYAL", state: "NSW", postcode: "2850" },
{ city: "CROSS ROADS", state: "NSW", postcode: "2850" },
{ city: "CUDGEGONG", state: "NSW", postcode: "2850" },
{ city: "CULLENBONE", state: "NSW", postcode: "2850" },
{ city: "CUMBO", state: "NSW", postcode: "2850" },
{ city: "ERUDGERE", state: "NSW", postcode: "2850" },
{ city: "EURUNDEREE", state: "NSW", postcode: "2850" },
{ city: "FROG ROCK", state: "NSW", postcode: "2850" },
{ city: "GALAMBINE", state: "NSW", postcode: "2850" },
{ city: "GLEN AYR", state: "NSW", postcode: "2850" },
{ city: "GRATTAI", state: "NSW", postcode: "2850" },
{ city: "GREEN GULLY", state: "NSW", postcode: "2850" },
{ city: "HARGRAVES", state: "NSW", postcode: "2850" },
{ city: "HAVILAH", state: "NSW", postcode: "2850" },
{ city: "HAYES GAP", state: "NSW", postcode: "2850" },
{ city: "HILL END", state: "NSW", postcode: "2850" },
{ city: "HOME RULE", state: "NSW", postcode: "2850" },
{ city: "ILFORD", state: "NSW", postcode: "2850" },
{ city: "KAINS FLAT", state: "NSW", postcode: "2850" },
{ city: "LINBURN", state: "NSW", postcode: "2850" },
{ city: "LUE", state: "NSW", postcode: "2850" },
{ city: "MAITLAND BAR", state: "NSW", postcode: "2850" },
{ city: "MENAH", state: "NSW", postcode: "2850" },
{ city: "MEROO", state: "NSW", postcode: "2850" },
{ city: "MILROY", state: "NSW", postcode: "2850" },
{ city: "MOGO", state: "NSW", postcode: "2850" },
{ city: "MONIVAE", state: "NSW", postcode: "2850" },
{ city: "MOOLARBEN", state: "NSW", postcode: "2850" },
{ city: "MOUNT FROME", state: "NSW", postcode: "2850" },
{ city: "MOUNT KNOWLES", state: "NSW", postcode: "2850" },
{ city: "MOUNT VINCENT", state: "NSW", postcode: "2850" },
{ city: "MULLAMUDDY", state: "NSW", postcode: "2850" },
{ city: "MUNGHORN", state: "NSW", postcode: "2850" },
{ city: "PIAMBONG", state: "NSW", postcode: "2850" },
{ city: "PUTTA BUCCA", state: "NSW", postcode: "2850" },
{ city: "PYRAMUL", state: "NSW", postcode: "2850" },
{ city: "QUEENS PINCH", state: "NSW", postcode: "2850" },
{ city: "RAZORBACK", state: "NSW", postcode: "2850" },
{ city: "RIVERLEA", state: "NSW", postcode: "2850" },
{ city: "RUNNING STREAM", state: "NSW", postcode: "2850" },
{ city: "SALLYS FLAT", state: "NSW", postcode: "2850" },
{ city: "SPRING FLAT", state: "NSW", postcode: "2850" },
{ city: "ST FILLANS", state: "NSW", postcode: "2850" },
{ city: "STONY CREEK", state: "NSW", postcode: "2850" },
{ city: "TAMBAROORA", state: "NSW", postcode: "2850" },
{ city: "TICHULAR", state: "NSW", postcode: "2850" },
{ city: "TOTNES VALLEY", state: "NSW", postcode: "2850" },
{ city: "TRIAMBLE", state: "NSW", postcode: "2850" },
{ city: "TURILL", state: "NSW", postcode: "2850" },
{ city: "TWELVE MILE", state: "NSW", postcode: "2850" },
{ city: "ULAN", state: "NSW", postcode: "2850" },
{ city: "ULLAMALLA", state: "NSW", postcode: "2850" },
{ city: "WILBETREE", state: "NSW", postcode: "2850" },
{ city: "WILPINJONG", state: "NSW", postcode: "2850" },
{ city: "WINDEYER", state: "NSW", postcode: "2850" },
{ city: "WOLLAR", state: "NSW", postcode: "2850" },
{ city: "WORLDS END", state: "NSW", postcode: "2850" },
{ city: "YARRABIN", state: "NSW", postcode: "2850" },
{ city: "YARRAWONGA", state: "NSW", postcode: "2850" },
{ city: "BARNEYS REEF", state: "NSW", postcode: "2852" },
{ city: "BERYL", state: "NSW", postcode: "2852" },
{ city: "BIRAGANBIL", state: "NSW", postcode: "2852" },
{ city: "BUNGABA", state: "NSW", postcode: "2852" },
{ city: "COPE", state: "NSW", postcode: "2852" },
{ city: "CUMBANDRY", state: "NSW", postcode: "2852" },
{ city: "GOOLMA", state: "NSW", postcode: "2852" },
{ city: "GULGONG", state: "NSW", postcode: "2852" },
{ city: "GUNTAWANG", state: "NSW", postcode: "2852" },
{ city: "MEBUL", state: "NSW", postcode: "2852" },
{ city: "MEROTHERIE", state: "NSW", postcode: "2852" },
{ city: "STUBBO", state: "NSW", postcode: "2852" },
{ city: "TALLAWANG", state: "NSW", postcode: "2852" },
{ city: "TWO MILE FLAT", state: "NSW", postcode: "2852" },
{ city: "BOREE", state: "NSW", postcode: "2864" },
{ city: "BOWAN PARK", state: "NSW", postcode: "2864" },
{ city: "CUDAL", state: "NSW", postcode: "2864" },
{ city: "MURGA", state: "NSW", postcode: "2864" },
{ city: "TOOGONG", state: "NSW", postcode: "2864" },
{ city: "BOCOBRA", state: "NSW", postcode: "2865" },
{ city: "GUMBLE", state: "NSW", postcode: "2865" },
{ city: "MANILDRA", state: "NSW", postcode: "2865" },
{ city: "AMAROO", state: "NSW", postcode: "2866" },
{ city: "BOOMEY", state: "NSW", postcode: "2866" },
{ city: "CUNDUMBUL", state: "NSW", postcode: "2866" },
{ city: "EUCHAREENA", state: "NSW", postcode: "2866" },
{ city: "GARRA", state: "NSW", postcode: "2866" },
{ city: "LARRAS LEE", state: "NSW", postcode: "2866" },
{ city: "MOLONG", state: "NSW", postcode: "2866" },
{ city: "BALDRY", state: "NSW", postcode: "2867" },
{ city: "CUMNOCK", state: "NSW", postcode: "2867" },
{ city: "EURIMBLA", state: "NSW", postcode: "2867" },
{ city: "LOOMBAH", state: "NSW", postcode: "2867" },
{ city: "YULLUNDRY", state: "NSW", postcode: "2867" },
{ city: "BOURNEWOOD", state: "NSW", postcode: "2868" },
{ city: "LITTLE RIVER", state: "NSW", postcode: "2868" },
{ city: "NORTH YEOVAL", state: "NSW", postcode: "2868" },
{ city: "OBLEY", state: "NSW", postcode: "2868" },
{ city: "UPPER OBLEY", state: "NSW", postcode: "2868" },
{ city: "YEOVAL", state: "NSW", postcode: "2868" },
{ city: "PEAK HILL", state: "NSW", postcode: "2869" },
{ city: "TOMINGLEY", state: "NSW", postcode: "2869" },
{ city: "TREWILGA", state: "NSW", postcode: "2869" },
{ city: "ALECTOWN", state: "NSW", postcode: "2870" },
{ city: "BUMBERRY", state: "NSW", postcode: "2870" },
{ city: "COOKAMIDGERA", state: "NSW", postcode: "2870" },
{ city: "COOKS MYALLS", state: "NSW", postcode: "2870" },
{ city: "DAROOBALGIE", state: "NSW", postcode: "2870" },
{ city: "GOONUMBLA", state: "NSW", postcode: "2870" },
{ city: "MANDAGERY", state: "NSW", postcode: "2870" },
{ city: "PARKES", state: "NSW", postcode: "2870" },
{ city: "TICHBORNE", state: "NSW", postcode: "2870" },
{ city: "BANDON", state: "NSW", postcode: "2871" },
{ city: "BEDGERABONG", state: "NSW", postcode: "2871" },
{ city: "BEDGEREBONG", state: "NSW", postcode: "2871" },
{ city: "BUNDABURRAH", state: "NSW", postcode: "2871" },
{ city: "CALARIE", state: "NSW", postcode: "2871" },
{ city: "CARRAWABBITY", state: "NSW", postcode: "2871" },
{ city: "CORINELLA", state: "NSW", postcode: "2871" },
{ city: "CUMBIJOWA", state: "NSW", postcode: "2871" },
{ city: "DAROOBALGIE", state: "NSW", postcode: "2871" },
{ city: "FAIRHOLME", state: "NSW", postcode: "2871" },
{ city: "FORBES", state: "NSW", postcode: "2871" },
{ city: "GAREMA", state: "NSW", postcode: "2871" },
{ city: "GRAWLIN", state: "NSW", postcode: "2871" },
{ city: "GUNNING GAP", state: "NSW", postcode: "2871" },
{ city: "JEMALONG", state: "NSW", postcode: "2871" },
{ city: "MULYANDRY", state: "NSW", postcode: "2871" },
{ city: "OOMA", state: "NSW", postcode: "2871" },
{ city: "PAYTENS BRIDGE", state: "NSW", postcode: "2871" },
{ city: "WARROO", state: "NSW", postcode: "2871" },
{ city: "WEELONG", state: "NSW", postcode: "2871" },
{ city: "WIRRINYA", state: "NSW", postcode: "2871" },
{ city: "YARRAGONG", state: "NSW", postcode: "2871" },
{ city: "ALBERT", state: "NSW", postcode: "2873" },
{ city: "FIVE WAYS", state: "NSW", postcode: "2873" },
{ city: "MIAMLEY", state: "NSW", postcode: "2873" },
{ city: "TOTTENHAM", state: "NSW", postcode: "2873" },
{ city: "TULLAMORE", state: "NSW", postcode: "2874" },
{ city: "BRUIE PLAINS", state: "NSW", postcode: "2875" },
{ city: "FIFIELD", state: "NSW", postcode: "2875" },
{ city: "OOTHA", state: "NSW", postcode: "2875" },
{ city: "TRUNDLE", state: "NSW", postcode: "2875" },
{ city: "YARRABANDAI", state: "NSW", postcode: "2875" },
{ city: "BOGAN GATE", state: "NSW", postcode: "2876" },
{ city: "GUNNINGBLAND", state: "NSW", postcode: "2876" },
{ city: "NELUNGALOO", state: "NSW", postcode: "2876" },
{ city: "BOBADAH", state: "NSW", postcode: "2877" },
{ city: "BOONA MOUNT", state: "NSW", postcode: "2877" },
{ city: "CONDOBOLIN", state: "NSW", postcode: "2877" },
{ city: "DERRIWONG", state: "NSW", postcode: "2877" },
{ city: "EREMERANG", state: "NSW", postcode: "2877" },
{ city: "EUABALONG", state: "NSW", postcode: "2877" },
{ city: "EUABALONG WEST", state: "NSW", postcode: "2877" },
{ city: "KIACATOO", state: "NSW", postcode: "2877" },
{ city: "MOUNT HOPE", state: "NSW", postcode: "2877" },
{ city: "MULGUTHRIE", state: "NSW", postcode: "2877" },
{ city: "IVANHOE", state: "NSW", postcode: "2878" },
{ city: "MOSSGIEL", state: "NSW", postcode: "2878" },
{ city: "MENINDEE", state: "NSW", postcode: "2879" },
{ city: "SUNSET STRIP", state: "NSW", postcode: "2879" },
{ city: "BROKEN HILL NORTH", state: "NSW", postcode: "2880" },
{ city: "BROKEN HILL WEST", state: "NSW", postcode: "2880" },
{ city: "BROUGHAMS GATE", state: "NSW", postcode: "2880" },
{ city: "FOWLERS GAP", state: "NSW", postcode: "2880" },
{ city: "LITTLE TOPAR", state: "NSW", postcode: "2880" },
{ city: "MILPARINKA", state: "NSW", postcode: "2880" },
{ city: "MUTAWINTJI", state: "NSW", postcode: "2880" },
{ city: "PACKSADDLE", state: "NSW", postcode: "2880" },
{ city: "SILVERTON", state: "NSW", postcode: "2880" },
{ city: "SOUTH BROKEN HILL", state: "NSW", postcode: "2880" },
{ city: "TIBOOBURRA", state: "NSW", postcode: "2880" },
{ city: "LORD HOWE ISLAND", state: "NSW", postcode: "2898" },
{ city: "NORFOLK ISLAND", state: "NSW", postcode: "2899" },
{ city: "PARINGI", state: "NSW", postcode: "3500" },
{ city: "MURRAY DOWNS", state: "NSW", postcode: "3585" },
{ city: "MALLAN", state: "NSW", postcode: "3586" },
{ city: "BAROOGA", state: "NSW", postcode: "3644" },
{ city: "LALALTY", state: "NSW", postcode: "3644" },
{ city: "LAKE HUME VILLAGE", state: "NSW", postcode: "3691" },
{ city: "BRINGENBRONG", state: "NSW", postcode: "3707" },
{ city: "MARYLAND", state: "NSW", postcode: "4377" },
{ city: "JENNINGS", state: "NSW", postcode: "4383" },
{ city: "CAMP CREEK", state: "NSW", postcode: "4385" },
{ city: "TEXAS", state: "NSW", postcode: "4385" },
{ city: "ACACIA HILLS", state: "NT", postcode: "822" },
{ city: "ANGURUGU", state: "NT", postcode: "822" },
{ city: "ANINDILYAKWA", state: "NT", postcode: "822" },
{ city: "ANNIE RIVER", state: "NT", postcode: "822" },
{ city: "BATHURST ISLAND", state: "NT", postcode: "822" },
{ city: "BEES CREEK", state: "NT", postcode: "822" },
{ city: "BELYUEN", state: "NT", postcode: "822" },
{ city: "BLACK JUNGLE", state: "NT", postcode: "822" },
{ city: "BLACKMORE", state: "NT", postcode: "822" },
{ city: "BURRUNDIE", state: "NT", postcode: "822" },
{ city: "BYNOE", state: "NT", postcode: "822" },
{ city: "BYNOE HARBOUR", state: "NT", postcode: "822" },
{ city: "CAMP CREEK", state: "NT", postcode: "822" },
{ city: "CHANNEL ISLAND", state: "NT", postcode: "822" },
{ city: "CHARLOTTE", state: "NT", postcode: "822" },
{ city: "CLARAVALE", state: "NT", postcode: "822" },
{ city: "COBOURG", state: "NT", postcode: "822" },
{ city: "COLLETT CREEK", state: "NT", postcode: "822" },
{ city: "COOMALIE CREEK", state: "NT", postcode: "822" },
{ city: "COX PENINSULA", state: "NT", postcode: "822" },
{ city: "CROKER ISLAND", state: "NT", postcode: "822" },
{ city: "DALY", state: "NT", postcode: "822" },
{ city: "DALY RIVER", state: "NT", postcode: "822" },
{ city: "DARWIN RIVER DAM", state: "NT", postcode: "822" },
{ city: "DELISSAVILLE", state: "NT", postcode: "822" },
{ city: "DOUGLAS-DALY", state: "NT", postcode: "822" },
{ city: "EAST ARNHEM", state: "NT", postcode: "822" },
{ city: "EVA VALLEY", state: "NT", postcode: "822" },
{ city: "FINNISS VALLEY", state: "NT", postcode: "822" },
{ city: "FLEMING", state: "NT", postcode: "822" },
{ city: "FLY CREEK", state: "NT", postcode: "822" },
{ city: "FREDS PASS", state: "NT", postcode: "822" },
{ city: "GALIWINKU", state: "NT", postcode: "822" },
{ city: "GLYDE POINT", state: "NT", postcode: "822" },
{ city: "GOULBURN ISLAND", state: "NT", postcode: "822" },
{ city: "GUNBALANYA", state: "NT", postcode: "822" },
{ city: "GUNN POINT", state: "NT", postcode: "822" },
{ city: "HAYES CREEK", state: "NT", postcode: "822" },
{ city: "HOTHAM", state: "NT", postcode: "822" },
{ city: "HUGHES", state: "NT", postcode: "822" },
{ city: "KAKADU", state: "NT", postcode: "822" },
{ city: "KOOLPINYAH", state: "NT", postcode: "822" },
{ city: "LAKE BENNETT", state: "NT", postcode: "822" },
{ city: "LAMBELLS LAGOON", state: "NT", postcode: "822" },
{ city: "LITCHFIELD PARK", state: "NT", postcode: "822" },
{ city: "LIVINGSTONE", state: "NT", postcode: "822" },
{ city: "LLOYD CREEK", state: "NT", postcode: "822" },
{ city: "MANDORAH", state: "NT", postcode: "822" },
{ city: "MANINGRIDA", state: "NT", postcode: "822" },
{ city: "MAPURU", state: "NT", postcode: "822" },
{ city: "MARANUNGA", state: "NT", postcode: "822" },
{ city: "MARGARET RIVER", state: "NT", postcode: "822" },
{ city: "MARRAKAI", state: "NT", postcode: "822" },
{ city: "MIDDLE POINT", state: "NT", postcode: "822" },
{ city: "MILIKAPITI", state: "NT", postcode: "822" },
{ city: "MILINGIMBI", state: "NT", postcode: "822" },
{ city: "MILYAKBURRA", state: "NT", postcode: "822" },
{ city: "MINJILANG", state: "NT", postcode: "822" },
{ city: "MOUNT BUNDEY", state: "NT", postcode: "822" },
{ city: "MURRUMUJUK", state: "NT", postcode: "822" },
{ city: "NAUIYU", state: "NT", postcode: "822" },
{ city: "NEMARLUK", state: "NT", postcode: "822" },
{ city: "NGANMARRIYANGA", state: "NT", postcode: "822" },
{ city: "NUMBULWAR", state: "NT", postcode: "822" },
{ city: "NUMBURINDI", state: "NT", postcode: "822" },
{ city: "OENPELLI", state: "NT", postcode: "822" },
{ city: "PEPPIMENARTI", state: "NT", postcode: "822" },
{ city: "PIRLANGIMPI", state: "NT", postcode: "822" },
{ city: "POINT STEPHENS", state: "NT", postcode: "822" },
{ city: "POINT STUART", state: "NT", postcode: "822" },
{ city: "PULARUMPI", state: "NT", postcode: "822" },
{ city: "RAKULA", state: "NT", postcode: "822" },
{ city: "RAMINGINING", state: "NT", postcode: "822" },
{ city: "ROBIN FALLS", state: "NT", postcode: "822" },
{ city: "RUM JUNGLE", state: "NT", postcode: "822" },
{ city: "SANDPALMS ROADHOUSE", state: "NT", postcode: "822" },
{ city: "SOUTHPORT", state: "NT", postcode: "822" },
{ city: "STAPLETON", state: "NT", postcode: "822" },
{ city: "THAMARRURR", state: "NT", postcode: "822" },
{ city: "TIPPERARY", state: "NT", postcode: "822" },
{ city: "TIWI ISLANDS", state: "NT", postcode: "822" },
{ city: "TORTILLA FLATS", state: "NT", postcode: "822" },
{ city: "TUMBLING WATERS", state: "NT", postcode: "822" },
{ city: "UMBAKUMBA", state: "NT", postcode: "822" },
{ city: "VERNON ISLANDS", state: "NT", postcode: "822" },
{ city: "WADEYE", state: "NT", postcode: "822" },
{ city: "WAGAIT BEACH", state: "NT", postcode: "822" },
{ city: "WAK WAK", state: "NT", postcode: "822" },
{ city: "WARRUWI", state: "NT", postcode: "822" },
{ city: "WEDDELL", state: "NT", postcode: "822" },
{ city: "WEST ARNHEM", state: "NT", postcode: "822" },
{ city: "WICKHAM", state: "NT", postcode: "822" },
{ city: "WOOLANING", state: "NT", postcode: "822" },
{ city: "WURRUMIYANGA", state: "NT", postcode: "822" },
{ city: "JOHNSTON", state: "NT", postcode: "832" },
{ city: "ZUCCOLI", state: "NT", postcode: "832" },
{ city: "VIRGINIA", state: "NT", postcode: "834" },
{ city: "COOLALINGA", state: "NT", postcode: "835" },
{ city: "HOWARD SPRINGS", state: "NT", postcode: "835" },
{ city: "VIRGINIA", state: "NT", postcode: "835" },
{ city: "GIRRAWEEN", state: "NT", postcode: "836" },
{ city: "HERBERT", state: "NT", postcode: "836" },
{ city: "HUMPTY DOO", state: "NT", postcode: "836" },
{ city: "MANTON", state: "NT", postcode: "837" },
{ city: "NOONAMAH", state: "NT", postcode: "837" },
{ city: "BERRY SPRINGS", state: "NT", postcode: "838" },
{ city: "COOLALINGA", state: "NT", postcode: "839" },
{ city: "DUNDEE BEACH", state: "NT", postcode: "840" },
{ city: "DUNDEE DOWNS", state: "NT", postcode: "840" },
{ city: "DUNDEE FOREST", state: "NT", postcode: "840" },
{ city: "DARWIN RIVER", state: "NT", postcode: "841" },
{ city: "BATCHELOR", state: "NT", postcode: "845" },
{ city: "ADELAIDE RIVER", state: "NT", postcode: "846" },
{ city: "PINE CREEK", state: "NT", postcode: "847" },
{ city: "COSSACK", state: "NT", postcode: "850" },
{ city: "EMUNGALAN", state: "NT", postcode: "850" },
{ city: "LANSDOWNE", state: "NT", postcode: "850" },
{ city: "ARNOLD", state: "NT", postcode: "852" },
{ city: "BAINES", state: "NT", postcode: "852" },
{ city: "BARUNGA", state: "NT", postcode: "852" },
{ city: "BESWICK", state: "NT", postcode: "852" },
{ city: "BESWICK CREEK", state: "NT", postcode: "852" },
{ city: "BINJARI", state: "NT", postcode: "852" },
{ city: "BIRDUM", state: "NT", postcode: "852" },
{ city: "BRADSHAW", state: "NT", postcode: "852" },
{ city: "BUCHANAN", state: "NT", postcode: "852" },
{ city: "BULMAN WEEMOL", state: "NT", postcode: "852" },
{ city: "CRESWELL", state: "NT", postcode: "852" },
{ city: "DAGURAGU", state: "NT", postcode: "852" },
{ city: "DALY WATERS", state: "NT", postcode: "852" },
{ city: "DELAMERE", state: "NT", postcode: "852" },
{ city: "DUNMARRA", state: "NT", postcode: "852" },
{ city: "EDITH", state: "NT", postcode: "852" },
{ city: "ELSEY", state: "NT", postcode: "852" },
{ city: "ELSEY STATION", state: "NT", postcode: "852" },
{ city: "FLORINA", state: "NT", postcode: "852" },
{ city: "FLYING FOX", state: "NT", postcode: "852" },
{ city: "GREGORY", state: "NT", postcode: "852" },
{ city: "GULUNG MARDRULK", state: "NT", postcode: "852" },
{ city: "GURINDJI", state: "NT", postcode: "852" },
{ city: "HELEN SPRINGS STATION", state: "NT", postcode: "852" },
{ city: "JILKMINGGAN", state: "NT", postcode: "852" },
{ city: "KALKARINDJI", state: "NT", postcode: "852" },
{ city: "LAJAMANU", state: "NT", postcode: "852" },
{ city: "LARRIMAH", state: "NT", postcode: "852" },
{ city: "LIMMEN", state: "NT", postcode: "852" },
{ city: "MANBULLOO", state: "NT", postcode: "852" },
{ city: "MARANBOY", state: "NT", postcode: "852" },
{ city: "MATARANKA", state: "NT", postcode: "852" },
{ city: "MCARTHUR", state: "NT", postcode: "852" },
{ city: "MINIYERI", state: "NT", postcode: "852" },
{ city: "NGUKURR", state: "NT", postcode: "852" },
{ city: "NITMILUK", state: "NT", postcode: "852" },
{ city: "NUTWOOD DOWNS", state: "NT", postcode: "852" },
{ city: "PELLEW ISLANDS", state: "NT", postcode: "852" },
{ city: "PIGEON HOLE", state: "NT", postcode: "852" },
{ city: "ROBINSON RIVER", state: "NT", postcode: "852" },
{ city: "STURT PLATEAU", state: "NT", postcode: "852" },
{ city: "TANAMI EAST", state: "NT", postcode: "852" },
{ city: "TIMBER CREEK", state: "NT", postcode: "852" },
{ city: "TOP SPRINGS", state: "NT", postcode: "852" },
{ city: "URALLA", state: "NT", postcode: "852" },
{ city: "VENN", state: "NT", postcode: "852" },
{ city: "VICTORIA RIVER", state: "NT", postcode: "852" },
{ city: "VICTORIA RIVER DOWNS", state: "NT", postcode: "852" },
{ city: "WARUMUNGU", state: "NT", postcode: "852" },
{ city: "WAVE HILL", state: "NT", postcode: "852" },
{ city: "WILTON", state: "NT", postcode: "852" },
{ city: "YARRALIN", state: "NT", postcode: "852" },
{ city: "TINDAL", state: "NT", postcode: "853" },
{ city: "TINDAL RAAF", state: "NT", postcode: "853" },
{ city: "BORROLOOLA", state: "NT", postcode: "854" },
{ city: "KING ASH BAY", state: "NT", postcode: "854" },
{ city: "TENNANT CREEK", state: "NT", postcode: "860" },
{ city: "AVON DOWNS", state: "NT", postcode: "862" },
{ city: "CALVERT", state: "NT", postcode: "862" },
{ city: "CRESSWELL DOWNS", state: "NT", postcode: "862" },
{ city: "ELLIOTT", state: "NT", postcode: "862" },
{ city: "HELEN SPRINGS", state: "NT", postcode: "862" },
{ city: "MUCKATY STATION", state: "NT", postcode: "862" },
{ city: "NEWCASTLE WATERS", state: "NT", postcode: "862" },
{ city: "NICHOLSON", state: "NT", postcode: "862" },
{ city: "PAMAYU", state: "NT", postcode: "862" },
{ city: "PHILLIP CREEK STATION", state: "NT", postcode: "862" },
{ city: "RENNER SPRINGS", state: "NT", postcode: "862" },
{ city: "TABLELANDS", state: "NT", postcode: "862" },
{ city: "TENNANT CREEK", state: "NT", postcode: "862" },
{ city: "THREE WAYS", state: "NT", postcode: "862" },
{ city: "WARREGO", state: "NT", postcode: "862" },
{ city: "WOLLOGORANG STATION", state: "NT", postcode: "862" },
{ city: "WYCLIFFE WELL", state: "NT", postcode: "862" },
{ city: "ARALUEN", state: "NT", postcode: "870" },
{ city: "ARUMBERA", state: "NT", postcode: "870" },
{ city: "BRAITLING", state: "NT", postcode: "870" },
{ city: "CICCONE", state: "NT", postcode: "870" },
{ city: "CONNELLAN", state: "NT", postcode: "870" },
{ city: "DESERT SPRINGS", state: "NT", postcode: "870" },
{ city: "EAST SIDE", state: "NT", postcode: "870" },
{ city: "FLYNN", state: "NT", postcode: "870" },
{ city: "GILLEN", state: "NT", postcode: "870" },
{ city: "ILPARPA", state: "NT", postcode: "870" },
{ city: "IRLPME", state: "NT", postcode: "870" },
{ city: "LARAPINTA", state: "NT", postcode: "870" },
{ city: "MOUNT JOHNS", state: "NT", postcode: "870" },
{ city: "ROSS", state: "NT", postcode: "870" },
{ city: "SADADEEN", state: "NT", postcode: "870" },
{ city: "STUART", state: "NT", postcode: "870" },
{ city: "THE GAP", state: "NT", postcode: "870" },
{ city: "UNDOOLYA", state: "NT", postcode: "870" },
{ city: "WHITE GUMS", state: "NT", postcode: "870" },
{ city: "AHERRENGE", state: "NT", postcode: "872" },
{ city: "ALI CURUNG", state: "NT", postcode: "872" },
{ city: "AMATA", state: "NT", postcode: "872" },
{ city: "AMOONGUNA", state: "NT", postcode: "872" },
{ city: "AMPILATWATJA", state: "NT", postcode: "872" },
{ city: "ANATYE", state: "NT", postcode: "872" },
{ city: "ANMATJERE", state: "NT", postcode: "872" },
{ city: "ANTEWENEGERRDE", state: "NT", postcode: "872" },
{ city: "AREYONGA", state: "NT", postcode: "872" },
{ city: "ATITJERE", state: "NT", postcode: "872" },
{ city: "AYERS ROCK", state: "NT", postcode: "872" },
{ city: "BARROW CREEK", state: "NT", postcode: "872" },
{ city: "BURT PLAIN", state: "NT", postcode: "872" },
{ city: "CANTEEN CREEK", state: "NT", postcode: "872" },
{ city: "CHILLA WELL", state: "NT", postcode: "872" },
{ city: "COSTELLO", state: "NT", postcode: "872" },
{ city: "DAVENPORT", state: "NT", postcode: "872" },
{ city: "DOCKER RIVER", state: "NT", postcode: "872" },
{ city: "ENGAWALA", state: "NT", postcode: "872" },
{ city: "ERLDUNDA", state: "NT", postcode: "872" },
{ city: "FINKE", state: "NT", postcode: "872" },
{ city: "GHAN", state: "NT", postcode: "872" },
{ city: "HAASTS BLUFF", state: "NT", postcode: "872" },
{ city: "HALE", state: "NT", postcode: "872" },
{ city: "HART", state: "NT", postcode: "872" },
{ city: "HART RANGE", state: "NT", postcode: "872" },
{ city: "HERMANNSBURG", state: "NT", postcode: "872" },
{ city: "HUGH", state: "NT", postcode: "872" },
{ city: "IMANPA", state: "NT", postcode: "872" },
{ city: "ININTI STORE", state: "NT", postcode: "872" },
{ city: "JAY CREEK", state: "NT", postcode: "872" },
{ city: "KALTUKATJARA", state: "NT", postcode: "872" },
{ city: "KINGS CREEK STATION", state: "NT", postcode: "872" },
{ city: "KINTORE", state: "NT", postcode: "872" },
{ city: "KIWIRRKURRA", state: "NT", postcode: "872" },
{ city: "KULGERA", state: "NT", postcode: "872" },
{ city: "KUNPARRKA", state: "NT", postcode: "872" },
{ city: "LAKE MACKAY", state: "NT", postcode: "872" },
{ city: "LARAMBA", state: "NT", postcode: "872" },
{ city: "MACDONNELL RANGE", state: "NT", postcode: "872" },
{ city: "MEREENIE", state: "NT", postcode: "872" },
{ city: "MOUNT LIEBIG", state: "NT", postcode: "872" },
{ city: "MOUNT ZEIL", state: "NT", postcode: "872" },
{ city: "MULGA BORE", state: "NT", postcode: "872" },
{ city: "MURPUTJA HOMELANDS", state: "NT", postcode: "872" },
{ city: "MUTITJULU", state: "NT", postcode: "872" },
{ city: "NAMATJIRA", state: "NT", postcode: "872" },
{ city: "NAPPERBY STATION", state: "NT", postcode: "872" },
{ city: "NYAPARI", state: "NT", postcode: "872" },
{ city: "NYIRRIPI", state: "NT", postcode: "872" },
{ city: "PAPUNYA", state: "NT", postcode: "872" },
{ city: "PATJARR", state: "NT", postcode: "872" },
{ city: "PETERMANN", state: "NT", postcode: "872" },
{ city: "PITJANTJATJARA HOMELANDS", state: "NT", postcode: "872" },
{ city: "SANDOVER", state: "NT", postcode: "872" },
{ city: "SANTA TERESA", state: "NT", postcode: "872" },
{ city: "SIMPSON", state: "NT", postcode: "872" },
{ city: "TANAMI", state: "NT", postcode: "872" },
{ city: "TARA", state: "NT", postcode: "872" },
{ city: "TELEGRAPH STATION", state: "NT", postcode: "872" },
{ city: "THANGKENHARENGE", state: "NT", postcode: "872" },
{ city: "TITJIKALA", state: "NT", postcode: "872" },
{ city: "TI TREE", state: "NT", postcode: "872" },
{ city: "TJIRRKARLI", state: "NT", postcode: "872" },
{ city: "TJUKURLA", state: "NT", postcode: "872" },
{ city: "ULURU", state: "NT", postcode: "872" },
{ city: "UMPANGARA", state: "NT", postcode: "872" },
{ city: "URAPUNTJA", state: "NT", postcode: "872" },
{ city: "WALLACE ROCKHOLE", state: "NT", postcode: "872" },
{ city: "WANARN", state: "NT", postcode: "872" },
{ city: "WILLOWRA", state: "NT", postcode: "872" },
{ city: "WILORA", state: "NT", postcode: "872" },
{ city: "WINGELLINA", state: "NT", postcode: "872" },
{ city: "WUTUNUGURRA", state: "NT", postcode: "872" },
{ city: "YUELAMU", state: "NT", postcode: "872" },
{ city: "YUENDUMU", state: "NT", postcode: "872" },
{ city: "YULARA", state: "NT", postcode: "872" },
{ city: "IRLPME", state: "NT", postcode: "874" },
{ city: "MOUNT JOHNS", state: "NT", postcode: "874" },
{ city: "UNDOOLYA", state: "NT", postcode: "874" },
{ city: "FLYNN", state: "NT", postcode: "875" },
{ city: "LARAPINTA", state: "NT", postcode: "875" },
{ city: "GAPUWIYAK", state: "NT", postcode: "880" },
{ city: "GOVE", state: "NT", postcode: "880" },
{ city: "GUNYANGARA", state: "NT", postcode: "880" },
{ city: "NHULUNBUY", state: "NT", postcode: "880" },
{ city: "YIRRKALA", state: "NT", postcode: "880" },
{ city: "NHULUNBUY", state: "NT", postcode: "881" },
{ city: "ALYANGULA", state: "NT", postcode: "885" },
{ city: "JABIRU", state: "NT", postcode: "886" },
{ city: "ALPURRURULAM", state: "NT", postcode: "4825" },
{ city: "MT ISA", state: "NT", postcode: "4825" },
{ city: "RANKEN", state: "NT", postcode: "4825" },
{ city: "AMITY", state: "QLD", postcode: "4183" },
{ city: "AMITY POINT", state: "QLD", postcode: "4183" },
{ city: "DUNWICH", state: "QLD", postcode: "4183" },
{ city: "NORTH STRADBROKE ISLAND", state: "QLD", postcode: "4183" },
{ city: "POINT LOOKOUT", state: "QLD", postcode: "4183" },
{ city: "COOCHIEMUDLO ISLAND", state: "QLD", postcode: "4184" },
{ city: "KARRAGARRA ISLAND", state: "QLD", postcode: "4184" },
{ city: "LAMB ISLAND", state: "QLD", postcode: "4184" },
{ city: "MACLEAY ISLAND", state: "QLD", postcode: "4184" },
{ city: "PEEL ISLAND", state: "QLD", postcode: "4184" },
{ city: "PERULPA ISLAND", state: "QLD", postcode: "4184" },
{ city: "RUSSELL ISLAND", state: "QLD", postcode: "4184" },
{ city: "SOUTH STRADBROKE", state: "QLD", postcode: "4216" },
{ city: "TAMBORINE", state: "QLD", postcode: "4270" },
{ city: "EAGLE HEIGHTS", state: "QLD", postcode: "4271" },
{ city: "MOUNT TAMBORINE", state: "QLD", postcode: "4272" },
{ city: "NORTH TAMBORINE", state: "QLD", postcode: "4272" },
{ city: "TAMBORINE MOUNTAIN", state: "QLD", postcode: "4272" },
{ city: "BENOBBLE", state: "QLD", postcode: "4275" },
{ city: "BIDDADDABA", state: "QLD", postcode: "4275" },
{ city: "BOYLAND", state: "QLD", postcode: "4275" },
{ city: "CANUNGRA", state: "QLD", postcode: "4275" },
{ city: "FERNY GLEN", state: "QLD", postcode: "4275" },
{ city: "FLYING FOX", state: "QLD", postcode: "4275" },
{ city: "ILLINBAH", state: "QLD", postcode: "4275" },
{ city: "LAMINGTON NATIONAL PARK", state: "QLD", postcode: "4275" },
{ city: "O'REILLY", state: "QLD", postcode: "4275" },
{ city: "SARABAH", state: "QLD", postcode: "4275" },
{ city: "WITHEREN", state: "QLD", postcode: "4275" },
{ city: "WONGLEPONG", state: "QLD", postcode: "4275" },
{ city: "FLAGSTONE", state: "QLD", postcode: "4280" },
{ city: "GLENLOGAN", state: "QLD", postcode: "4280" },
{ city: "JIMBOOMBA", state: "QLD", postcode: "4280" },
{ city: "NORTH MACLEAN", state: "QLD", postcode: "4280" },
{ city: "RIVERBEND", state: "QLD", postcode: "4280" },
{ city: "SOUTH MACLEAN", state: "QLD", postcode: "4280" },
{ city: "STOCKLEIGH", state: "QLD", postcode: "4280" },
{ city: "ALLENVIEW", state: "QLD", postcode: "4285" },
{ city: "BIRNAM", state: "QLD", postcode: "4285" },
{ city: "BROMELTON", state: "QLD", postcode: "4285" },
{ city: "CAINBABLE", state: "QLD", postcode: "4285" },
{ city: "CEDAR GROVE", state: "QLD", postcode: "4285" },
{ city: "CEDAR VALE", state: "QLD", postcode: "4285" },
{ city: "CHINGHEE CREEK", state: "QLD", postcode: "4285" },
{ city: "CHRISTMAS CREEK", state: "QLD", postcode: "4285" },
{ city: "CRYNA", state: "QLD", postcode: "4285" },
{ city: "DARLINGTON", state: "QLD", postcode: "4285" },
{ city: "GLENEAGLE", state: "QLD", postcode: "4285" },
{ city: "HILLVIEW", state: "QLD", postcode: "4285" },
{ city: "INNISPLAIN", state: "QLD", postcode: "4285" },
{ city: "JOSEPHVILLE", state: "QLD", postcode: "4285" },
{ city: "KAGARU", state: "QLD", postcode: "4285" },
{ city: "KERRY", state: "QLD", postcode: "4285" },
{ city: "KNAPP CREEK", state: "QLD", postcode: "4285" },
{ city: "KOORALBYN", state: "QLD", postcode: "4285" },
{ city: "LAMINGTON", state: "QLD", postcode: "4285" },
{ city: "LARAVALE", state: "QLD", postcode: "4285" },
{ city: "MOUNT GIPPS", state: "QLD", postcode: "4285" },
{ city: "MUNDOOLUN", state: "QLD", postcode: "4285" },
{ city: "NINDOOINBAH", state: "QLD", postcode: "4285" },
{ city: "OAKY CREEK", state: "QLD", postcode: "4285" },
{ city: "TABOOBA", state: "QLD", postcode: "4285" },
{ city: "TABRAGALBA", state: "QLD", postcode: "4285" },
{ city: "TAMROOKUM", state: "QLD", postcode: "4285" },
{ city: "TAMROOKUM CREEK", state: "QLD", postcode: "4285" },
{ city: "UNDULLAH", state: "QLD", postcode: "4285" },
{ city: "VERESDALE", state: "QLD", postcode: "4285" },
{ city: "VERESDALE SCRUB", state: "QLD", postcode: "4285" },
{ city: "WOODHILL", state: "QLD", postcode: "4285" },
{ city: "BARNEY VIEW", state: "QLD", postcode: "4287" },
{ city: "MOUNT BARNEY", state: "QLD", postcode: "4287" },
{ city: "MOUNT LINDESAY", state: "QLD", postcode: "4287" },
{ city: "PALEN CREEK", state: "QLD", postcode: "4287" },
{ city: "RATHDOWNEY", state: "QLD", postcode: "4287" },
{ city: "RUNNING CREEK", state: "QLD", postcode: "4287" },
{ city: "AMBERLEY", state: "QLD", postcode: "4306" },
{ city: "AVOCA VALE", state: "QLD", postcode: "4306" },
{ city: "BANKS CREEK", state: "QLD", postcode: "4306" },
{ city: "BARELLAN POINT", state: "QLD", postcode: "4306" },
{ city: "BENARKIN", state: "QLD", postcode: "4306" },
{ city: "BENARKIN NORTH", state: "QLD", postcode: "4306" },
{ city: "BLACKBUTT", state: "QLD", postcode: "4306" },
{ city: "BLACKBUTT NORTH", state: "QLD", postcode: "4306" },
{ city: "BLACKBUTT SOUTH", state: "QLD", postcode: "4306" },
{ city: "BLACKSOIL", state: "QLD", postcode: "4306" },
{ city: "BORALLON", state: "QLD", postcode: "4306" },
{ city: "CHERRY CREEK", state: "QLD", postcode: "4306" },
{ city: "CHUWAR", state: "QLD", postcode: "4306" },
{ city: "COLINTON", state: "QLD", postcode: "4306" },
{ city: "DEEBING HEIGHTS", state: "QLD", postcode: "4306" },
{ city: "DUNDAS", state: "QLD", postcode: "4306" },
{ city: "ENGLAND CREEK", state: "QLD", postcode: "4306" },
{ city: "FAIRNEY VIEW", state: "QLD", postcode: "4306" },
{ city: "FERNVALE", state: "QLD", postcode: "4306" },
{ city: "GLAMORGAN VALE", state: "QLD", postcode: "4306" },
{ city: "GOOGA CREEK", state: "QLD", postcode: "4306" },
{ city: "GOOLMAN", state: "QLD", postcode: "4306" },
{ city: "HAIGSLEA", state: "QLD", postcode: "4306" },
{ city: "HARLIN", state: "QLD", postcode: "4306" },
{ city: "IRONBARK", state: "QLD", postcode: "4306" },
{ city: "KARALEE", state: "QLD", postcode: "4306" },
{ city: "KARANA DOWNS", state: "QLD", postcode: "4306" },
{ city: "KARRABIN", state: "QLD", postcode: "4306" },
{ city: "KHOLO", state: "QLD", postcode: "4306" },
{ city: "LAKE MANCHESTER", state: "QLD", postcode: "4306" },
{ city: "LARK HILL", state: "QLD", postcode: "4306" },
{ city: "LINVILLE", state: "QLD", postcode: "4306" },
{ city: "MOORE", state: "QLD", postcode: "4306" },
{ city: "MOUNT BINGA", state: "QLD", postcode: "4306" },
{ city: "MOUNT CROSBY", state: "QLD", postcode: "4306" },
{ city: "MOUNT MARROW", state: "QLD", postcode: "4306" },
{ city: "MOUNT STANLEY", state: "QLD", postcode: "4306" },
{ city: "MUIRLEA", state: "QLD", postcode: "4306" },
{ city: "NUKKU", state: "QLD", postcode: "4306" },
{ city: "PEAK CROSSING", state: "QLD", postcode: "4306" },
{ city: "PINE MOUNTAIN", state: "QLD", postcode: "4306" },
{ city: "PURGA", state: "QLD", postcode: "4306" },
{ city: "RIPLEY", state: "QLD", postcode: "4306" },
{ city: "SOUTH RIPLEY", state: "QLD", postcode: "4306" },
{ city: "SPLIT YARD CREEK", state: "QLD", postcode: "4306" },
{ city: "SWANBANK", state: "QLD", postcode: "4306" },
{ city: "TAROMEO", state: "QLD", postcode: "4306" },
{ city: "TEELAH", state: "QLD", postcode: "4306" },
{ city: "THAGOONA", state: "QLD", postcode: "4306" },
{ city: "VERNOR", state: "QLD", postcode: "4306" },
{ city: "WALLOON", state: "QLD", postcode: "4306" },
{ city: "WANORA", state: "QLD", postcode: "4306" },
{ city: "WASHPOOL", state: "QLD", postcode: "4306" },
{ city: "WEST AMBERLEY", state: "QLD", postcode: "4306" },
{ city: "WHITE ROCK", state: "QLD", postcode: "4306" },
{ city: "WILLOWBANK", state: "QLD", postcode: "4306" },
{ city: "WIVENHOE POCKET", state: "QLD", postcode: "4306" },
{ city: "COLEYVILLE", state: "QLD", postcode: "4307" },
{ city: "HARRISVILLE", state: "QLD", postcode: "4307" },
{ city: "MUTDAPILLY", state: "QLD", postcode: "4307" },
{ city: "RADFORD", state: "QLD", postcode: "4307" },
{ city: "SILVERDALE", state: "QLD", postcode: "4307" },
{ city: "WARRILL VIEW", state: "QLD", postcode: "4307" },
{ city: "WILSONS PLAINS", state: "QLD", postcode: "4307" },
{ city: "ARATULA", state: "QLD", postcode: "4309" },
{ city: "CHARLWOOD", state: "QLD", postcode: "4309" },
{ city: "CLUMBER", state: "QLD", postcode: "4309" },
{ city: "FASSIFERN", state: "QLD", postcode: "4309" },
{ city: "FASSIFERN VALLEY", state: "QLD", postcode: "4309" },
{ city: "FRAZERVIEW", state: "QLD", postcode: "4309" },
{ city: "KALBAR", state: "QLD", postcode: "4309" },
{ city: "KENTS LAGOON", state: "QLD", postcode: "4309" },
{ city: "KULGUN", state: "QLD", postcode: "4309" },
{ city: "MILORA", state: "QLD", postcode: "4309" },
{ city: "MOOGERAH", state: "QLD", postcode: "4309" },
{ city: "MORWINCHA", state: "QLD", postcode: "4309" },
{ city: "MOUNT EDWARDS", state: "QLD", postcode: "4309" },
{ city: "MUNBILLA", state: "QLD", postcode: "4309" },
{ city: "OBUM OBUM", state: "QLD", postcode: "4309" },
{ city: "TAROME", state: "QLD", postcode: "4309" },
{ city: "TEVIOTVILLE", state: "QLD", postcode: "4309" },
{ city: "ALLANDALE", state: "QLD", postcode: "4310" },
{ city: "ANTHONY", state: "QLD", postcode: "4310" },
{ city: "BLANTYRE", state: "QLD", postcode: "4310" },
{ city: "BOONAH", state: "QLD", postcode: "4310" },
{ city: "BUNBURRA", state: "QLD", postcode: "4310" },
{ city: "BUNJURGEN", state: "QLD", postcode: "4310" },
{ city: "BURNETT CREEK", state: "QLD", postcode: "4310" },
{ city: "CANNON CREEK", state: "QLD", postcode: "4310" },
{ city: "CARNEYS CREEK", state: "QLD", postcode: "4310" },
{ city: "COOCHIN", state: "QLD", postcode: "4310" },
{ city: "COULSON", state: "QLD", postcode: "4310" },
{ city: "CROFTBY", state: "QLD", postcode: "4310" },
{ city: "DUGANDAN", state: "QLD", postcode: "4310" },
{ city: "FRENCHES CREEK", state: "QLD", postcode: "4310" },
{ city: "HOYA", state: "QLD", postcode: "4310" },
{ city: "KENTS POCKET", state: "QLD", postcode: "4310" },
{ city: "MAROON", state: "QLD", postcode: "4310" },
{ city: "MILBONG", state: "QLD", postcode: "4310" },
{ city: "MILFORD", state: "QLD", postcode: "4310" },
{ city: "MOUNT ALFORD", state: "QLD", postcode: "4310" },
{ city: "MOUNT FRENCH", state: "QLD", postcode: "4310" },
{ city: "ROADVALE", state: "QLD", postcode: "4310" },
{ city: "TEMPLIN", state: "QLD", postcode: "4310" },
{ city: "WALLACES CREEK", state: "QLD", postcode: "4310" },
{ city: "WOOLOOMAN", state: "QLD", postcode: "4310" },
{ city: "WYARALONG", state: "QLD", postcode: "4310" },
{ city: "ATKINSONS DAM", state: "QLD", postcode: "4311" },
{ city: "BRIGHTVIEW", state: "QLD", postcode: "4311" },
{ city: "BUARABA", state: "QLD", postcode: "4311" },
{ city: "BUARABA SOUTH", state: "QLD", postcode: "4311" },
{ city: "CHURCHABLE", state: "QLD", postcode: "4311" },
{ city: "CLARENDON", state: "QLD", postcode: "4311" },
{ city: "COOLANA", state: "QLD", postcode: "4311" },
{ city: "COOMINYA", state: "QLD", postcode: "4311" },
{ city: "LOCKYER WATERS", state: "QLD", postcode: "4311" },
{ city: "LOWOOD", state: "QLD", postcode: "4311" },
{ city: "MINDEN", state: "QLD", postcode: "4311" },
{ city: "MOUNT TARAMPA", state: "QLD", postcode: "4311" },
{ city: "PATRICK ESTATE", state: "QLD", postcode: "4311" },
{ city: "PRENZLAU", state: "QLD", postcode: "4311" },
{ city: "RIFLE RANGE", state: "QLD", postcode: "4311" },
{ city: "TARAMPA", state: "QLD", postcode: "4311" },
{ city: "WIVENHOE HILL", state: "QLD", postcode: "4311" },
{ city: "BRYDEN", state: "QLD", postcode: "4312" },
{ city: "CABOONBAH", state: "QLD", postcode: "4312" },
{ city: "COAL CREEK", state: "QLD", postcode: "4312" },
{ city: "CROSSDALE", state: "QLD", postcode: "4312" },
{ city: "ESK", state: "QLD", postcode: "4312" },
{ city: "ESKDALE", state: "QLD", postcode: "4312" },
{ city: "GLEN ESK", state: "QLD", postcode: "4312" },
{ city: "MOOMBRA", state: "QLD", postcode: "4312" },
{ city: "MOUNT BYRON", state: "QLD", postcode: "4312" },
{ city: "MOUNT HALLEN", state: "QLD", postcode: "4312" },
{ city: "MURRUMBA", state: "QLD", postcode: "4312" },
{ city: "REDBANK CREEK", state: "QLD", postcode: "4312" },
{ city: "SOMERSET DAM", state: "QLD", postcode: "4312" },
{ city: "BIARRA", state: "QLD", postcode: "4313" },
{ city: "BRAEMORE", state: "QLD", postcode: "4313" },
{ city: "COOEEIMBARDI", state: "QLD", postcode: "4313" },
{ city: "CRESSBROOK", state: "QLD", postcode: "4313" },
{ city: "FULHAM", state: "QLD", postcode: "4313" },
{ city: "GREGORS CREEK", state: "QLD", postcode: "4313" },
{ city: "IVORY CREEK", state: "QLD", postcode: "4313" },
{ city: "LOWER CRESSBROOK", state: "QLD", postcode: "4313" },
{ city: "MOUNT BEPPO", state: "QLD", postcode: "4313" },
{ city: "OTTABA", state: "QLD", postcode: "4313" },
{ city: "SCRUB CREEK", state: "QLD", postcode: "4313" },
{ city: "TOOGOOLAWAH", state: "QLD", postcode: "4313" },
{ city: "YIMBUN", state: "QLD", postcode: "4313" },
{ city: "TAROMEO", state: "QLD", postcode: "4314" },
{ city: "ASHWELL", state: "QLD", postcode: "4340" },
{ city: "CALVERT", state: "QLD", postcode: "4340" },
{ city: "EBENEZER", state: "QLD", postcode: "4340" },
{ city: "GRANDCHESTER", state: "QLD", postcode: "4340" },
{ city: "JEEBROPILLY", state: "QLD", postcode: "4340" },
{ city: "LANEFIELD", state: "QLD", postcode: "4340" },
{ city: "LOWER MOUNT WALKER", state: "QLD", postcode: "4340" },
{ city: "MERRYVALE", state: "QLD", postcode: "4340" },
{ city: "MOORANG", state: "QLD", postcode: "4340" },
{ city: "MOUNT FORBES", state: "QLD", postcode: "4340" },
{ city: "MOUNT MORT", state: "QLD", postcode: "4340" },
{ city: "MOUNT WALKER", state: "QLD", postcode: "4340" },
{ city: "MOUNT WALKER WEST", state: "QLD", postcode: "4340" },
{ city: "ROSEVALE", state: "QLD", postcode: "4340" },
{ city: "ROSEWOOD", state: "QLD", postcode: "4340" },
{ city: "TALLEGALLA", state: "QLD", postcode: "4340" },
{ city: "THE BLUFF", state: "QLD", postcode: "4340" },
{ city: "WOOLSHED", state: "QLD", postcode: "4340" },
{ city: "BLENHEIM", state: "QLD", postcode: "4341" },
{ city: "HATTON VALE", state: "QLD", postcode: "4341" },
{ city: "KENSINGTON GROVE", state: "QLD", postcode: "4341" },
{ city: "KENTVILLE", state: "QLD", postcode: "4341" },
{ city: "LAIDLEY", state: "QLD", postcode: "4341" },
{ city: "LAIDLEY CREEK WEST", state: "QLD", postcode: "4341" },
{ city: "LAIDLEY HEIGHTS", state: "QLD", postcode: "4341" },
{ city: "LAIDLEY NORTH", state: "QLD", postcode: "4341" },
{ city: "LAIDLEY SOUTH", state: "QLD", postcode: "4341" },
{ city: "MOUNT BERRYMAN", state: "QLD", postcode: "4341" },
{ city: "MULGOWIE", state: "QLD", postcode: "4341" },
{ city: "PLAINLAND", state: "QLD", postcode: "4341" },
{ city: "REGENCY DOWNS", state: "QLD", postcode: "4341" },
{ city: "SUMMERHOLM", state: "QLD", postcode: "4341" },
{ city: "THORNTON", state: "QLD", postcode: "4341" },
{ city: "TOWNSON", state: "QLD", postcode: "4341" },
{ city: "CROWLEY VALE", state: "QLD", postcode: "4342" },
{ city: "FOREST HILL", state: "QLD", postcode: "4342" },
{ city: "GLEN CAIRN", state: "QLD", postcode: "4342" },
{ city: "GLENORE GROVE", state: "QLD", postcode: "4342" },
{ city: "LOCKROSE", state: "QLD", postcode: "4342" },
{ city: "LYNFORD", state: "QLD", postcode: "4342" },
{ city: "ADARE", state: "QLD", postcode: "4343" },
{ city: "BLACK DUCK CREEK", state: "QLD", postcode: "4343" },
{ city: "CAFFEY", state: "QLD", postcode: "4343" },
{ city: "COLLEGE VIEW", state: "QLD", postcode: "4343" },
{ city: "EAST HALDON", state: "QLD", postcode: "4343" },
{ city: "FORDSDALE", state: "QLD", postcode: "4343" },
{ city: "INGOLDSBY", state: "QLD", postcode: "4343" },
{ city: "JUNCTION VIEW", state: "QLD", postcode: "4343" },
{ city: "LAKE CLARENDON", state: "QLD", postcode: "4343" },
{ city: "LAWES", state: "QLD", postcode: "4343" },
{ city: "LEFTHAND BRANCH", state: "QLD", postcode: "4343" },
{ city: "LOWER TENTHILL", state: "QLD", postcode: "4343" },
{ city: "MORTON VALE", state: "QLD", postcode: "4343" },
{ city: "MOUNT SYLVIA", state: "QLD", postcode: "4343" },
{ city: "PLACID HILLS", state: "QLD", postcode: "4343" },
{ city: "RINGWOOD", state: "QLD", postcode: "4343" },
{ city: "ROCKSIDE", state: "QLD", postcode: "4343" },
{ city: "ROPELEY", state: "QLD", postcode: "4343" },
{ city: "SPRING CREEK", state: "QLD", postcode: "4343" },
{ city: "UPPER TENTHILL", state: "QLD", postcode: "4343" },
{ city: "VINEGAR HILL", state: "QLD", postcode: "4343" },
{ city: "WOODBINE", state: "QLD", postcode: "4343" },
{ city: "WOODLANDS", state: "QLD", postcode: "4343" },
{ city: "CARPENDALE", state: "QLD", postcode: "4344" },
{ city: "EGYPT", state: "QLD", postcode: "4344" },
{ city: "FLAGSTONE CREEK", state: "QLD", postcode: "4344" },
{ city: "HELIDON", state: "QLD", postcode: "4344" },
{ city: "HELIDON SPA", state: "QLD", postcode: "4344" },
{ city: "IREDALE", state: "QLD", postcode: "4344" },
{ city: "LILYDALE", state: "QLD", postcode: "4344" },
{ city: "LOCKYER", state: "QLD", postcode: "4344" },
{ city: "ROCKMOUNT", state: "QLD", postcode: "4344" },
{ city: "SEVENTEEN MILE", state: "QLD", postcode: "4344" },
{ city: "STOCKYARD", state: "QLD", postcode: "4344" },
{ city: "UPPER FLAGSTONE", state: "QLD", postcode: "4344" },
{ city: "GATTON COLLEGE", state: "QLD", postcode: "4345" },
{ city: "MARBURG", state: "QLD", postcode: "4346" },
{ city: "GRANTHAM", state: "QLD", postcode: "4347" },
{ city: "MA MA CREEK", state: "QLD", postcode: "4347" },
{ city: "MOUNT WHITESTONE", state: "QLD", postcode: "4347" },
{ city: "VERADILLA", state: "QLD", postcode: "4347" },
{ city: "WINWILL", state: "QLD", postcode: "4347" },
{ city: "BALLARD", state: "QLD", postcode: "4352" },
{ city: "BAPAUME", state: "QLD", postcode: "4352" },
{ city: "BIRNAM", state: "QLD", postcode: "4352" },
{ city: "BLANCHVIEW", state: "QLD", postcode: "4352" },
{ city: "BRANCHVIEW", state: "QLD", postcode: "4352" },
{ city: "CABARLAH", state: "QLD", postcode: "4352" },
{ city: "CEMENT MILLS", state: "QLD", postcode: "4352" },
{ city: "COALBANK", state: "QLD", postcode: "4352" },
{ city: "CONDAMINE PLAINS", state: "QLD", postcode: "4352" },
{ city: "CUTELLA", state: "QLD", postcode: "4352" },
{ city: "DERRYMORE", state: "QLD", postcode: "4352" },
{ city: "DJUAN", state: "QLD", postcode: "4352" },
{ city: "DOCTOR CREEK", state: "QLD", postcode: "4352" },
{ city: "EVERGREEN", state: "QLD", postcode: "4352" },
{ city: "FIFTEEN MILE", state: "QLD", postcode: "4352" },
{ city: "GEHAM", state: "QLD", postcode: "4352" },
{ city: "GLENCOE", state: "QLD", postcode: "4352" },
{ city: "GORE", state: "QLD", postcode: "4352" },
{ city: "GOWRIE JUNCTION", state: "QLD", postcode: "4352" },
{ city: "GOWRIE LITTLE PLAIN", state: "QLD", postcode: "4352" },
{ city: "GRAPETREE", state: "QLD", postcode: "4352" },
{ city: "GROOMSVILLE", state: "QLD", postcode: "4352" },
{ city: "HAMPTON", state: "QLD", postcode: "4352" },
{ city: "HIGHFIELDS", state: "QLD", postcode: "4352" },
{ city: "HIGHGROVE", state: "QLD", postcode: "4352" },
{ city: "HODGSON VALE", state: "QLD", postcode: "4352" },
{ city: "KARARA", state: "QLD", postcode: "4352" },
{ city: "KLEINTON", state: "QLD", postcode: "4352" },
{ city: "KULPI", state: "QLD", postcode: "4352" },
{ city: "KURROWAH", state: "QLD", postcode: "4352" },
{ city: "LILYVALE", state: "QLD", postcode: "4352" },
{ city: "MACLAGAN", state: "QLD", postcode: "4352" },
{ city: "MALLING", state: "QLD", postcode: "4352" },
{ city: "MERINGANDAN", state: "QLD", postcode: "4352" },
{ city: "MERINGANDAN WEST", state: "QLD", postcode: "4352" },
{ city: "MERRITTS CREEK", state: "QLD", postcode: "4352" },
{ city: "MOUNT LUKE", state: "QLD", postcode: "4352" },
{ city: "MUNIGANEEN", state: "QLD", postcode: "4352" },
{ city: "MURPHYS CREEK", state: "QLD", postcode: "4352" },
{ city: "NARKO", state: "QLD", postcode: "4352" },
{ city: "NORTH MACLAGAN", state: "QLD", postcode: "4352" },
{ city: "NUTGROVE", state: "QLD", postcode: "4352" },
{ city: "OMAN AMA", state: "QLD", postcode: "4352" },
{ city: "PALMTREE", state: "QLD", postcode: "4352" },
{ city: "PAMPAS", state: "QLD", postcode: "4352" },
{ city: "PECHEY", state: "QLD", postcode: "4352" },
{ city: "PERANGA", state: "QLD", postcode: "4352" },
{ city: "PERSEVERANCE", state: "QLD", postcode: "4352" },
{ city: "POSTMANS RIDGE", state: "QLD", postcode: "4352" },
{ city: "POZIERES", state: "QLD", postcode: "4352" },
{ city: "PRESTON", state: "QLD", postcode: "4352" },
{ city: "RANGEMORE", state: "QLD", postcode: "4352" },
{ city: "RAVENSBOURNE", state: "QLD", postcode: "4352" },
{ city: "SILVER RIDGE", state: "QLD", postcode: "4352" },
{ city: "SPRING BLUFF", state: "QLD", postcode: "4352" },
{ city: "ST AUBYN", state: "QLD", postcode: "4352" },
{ city: "THORNVILLE", state: "QLD", postcode: "4352" },
{ city: "TUMMAVILLE", state: "QLD", postcode: "4352" },
{ city: "UMBIRAM", state: "QLD", postcode: "4352" },
{ city: "UPPER LOCKYER", state: "QLD", postcode: "4352" },
{ city: "VALE VIEW", state: "QLD", postcode: "4352" },
{ city: "WHICHELLO", state: "QLD", postcode: "4352" },
{ city: "WHITE MOUNTAIN", state: "QLD", postcode: "4352" },
{ city: "WITHCOTT", state: "QLD", postcode: "4352" },
{ city: "WOODLEIGH", state: "QLD", postcode: "4352" },
{ city: "WOOLMER", state: "QLD", postcode: "4352" },
{ city: "WUTUL", state: "QLD", postcode: "4352" },
{ city: "WYREEMA", state: "QLD", postcode: "4352" },
{ city: "YALANGUR", state: "QLD", postcode: "4352" },
{ city: "YANDILLA", state: "QLD", postcode: "4352" },
{ city: "BERGEN", state: "QLD", postcode: "4353" },
{ city: "EAST COOYAR", state: "QLD", postcode: "4353" },
{ city: "HADEN", state: "QLD", postcode: "4353" },
{ city: "DOUGLAS", state: "QLD", postcode: "4354" },
{ city: "GOOMBUNGEE", state: "QLD", postcode: "4354" },
{ city: "KILBIRNIE", state: "QLD", postcode: "4354" },
{ city: "ANDURAMBA", state: "QLD", postcode: "4355" },
{ city: "CRESSBROOK CREEK", state: "QLD", postcode: "4355" },
{ city: "CROWS NEST", state: "QLD", postcode: "4355" },
{ city: "EMU CREEK", state: "QLD", postcode: "4355" },
{ city: "GLENAVEN", state: "QLD", postcode: "4355" },
{ city: "JONES GULLY", state: "QLD", postcode: "4355" },
{ city: "MOUNTAIN CAMP", state: "QLD", postcode: "4355" },
{ city: "PIERCES CREEK", state: "QLD", postcode: "4355" },
{ city: "PINELANDS", state: "QLD", postcode: "4355" },
{ city: "PLAINBY", state: "QLD", postcode: "4355" },
{ city: "THE BLUFF", state: "QLD", postcode: "4355" },
{ city: "UPPER PINELANDS", state: "QLD", postcode: "4355" },
{ city: "BONGEEN", state: "QLD", postcode: "4356" },
{ city: "BROXBURN", state: "QLD", postcode: "4356" },
{ city: "EVANSLEA", state: "QLD", postcode: "4356" },
{ city: "IRONGATE", state: "QLD", postcode: "4356" },
{ city: "KINCORA", state: "QLD", postcode: "4356" },
{ city: "LINTHORPE", state: "QLD", postcode: "4356" },
{ city: "MOTLEY", state: "QLD", postcode: "4356" },
{ city: "MOUNT TYSON", state: "QLD", postcode: "4356" },
{ city: "NORTH BRANCH", state: "QLD", postcode: "4356" },
{ city: "NORWIN", state: "QLD", postcode: "4356" },
{ city: "PITTSWORTH", state: "QLD", postcode: "4356" },
{ city: "PURRAWUNDA", state: "QLD", postcode: "4356" },
{ city: "ROSSVALE", state: "QLD", postcode: "4356" },
{ city: "SCRUBBY MOUNTAIN", state: "QLD", postcode: "4356" },
{ city: "SPRINGSIDE", state: "QLD", postcode: "4356" },
{ city: "ST HELENS", state: "QLD", postcode: "4356" },
{ city: "STONELEIGH", state: "QLD", postcode: "4356" },
{ city: "YARRANLEA", state: "QLD", postcode: "4356" },
{ city: "BRINGALILY", state: "QLD", postcode: "4357" },
{ city: "BULLI CREEK", state: "QLD", postcode: "4357" },
{ city: "CANNING CREEK", state: "QLD", postcode: "4357" },
{ city: "CAPTAINS MOUNTAIN", state: "QLD", postcode: "4357" },
{ city: "CLONTARF", state: "QLD", postcode: "4357" },
{ city: "CONDAMINE FARMS", state: "QLD", postcode: "4357" },
{ city: "CYPRESS GARDENS", state: "QLD", postcode: "4357" },
{ city: "DOMVILLE", state: "QLD", postcode: "4357" },
{ city: "FOREST RIDGE", state: "QLD", postcode: "4357" },
{ city: "GRAYS GATE", state: "QLD", postcode: "4357" },
{ city: "KOOROONGARRA", state: "QLD", postcode: "4357" },
{ city: "LAVELLE", state: "QLD", postcode: "4357" },
{ city: "LEMONTREE", state: "QLD", postcode: "4357" },
{ city: "MILLMERRAN", state: "QLD", postcode: "4357" },
{ city: "MILLMERRAN DOWNS", state: "QLD", postcode: "4357" },
{ city: "MILLMERRAN WOODS", state: "QLD", postcode: "4357" },
{ city: "MILLWOOD", state: "QLD", postcode: "4357" },
{ city: "MOUNT EMLYN", state: "QLD", postcode: "4357" },
{ city: "PUNCHS CREEK", state: "QLD", postcode: "4357" },
{ city: "ROCKY CREEK", state: "QLD", postcode: "4357" },
{ city: "STONEHENGE", state: "QLD", postcode: "4357" },
{ city: "THE PINES", state: "QLD", postcode: "4357" },
{ city: "TURALLIN", state: "QLD", postcode: "4357" },
{ city: "WATTLE RIDGE", state: "QLD", postcode: "4357" },
{ city: "WESTERN CREEK", state: "QLD", postcode: "4357" },
{ city: "WOONDUL", state: "QLD", postcode: "4357" },
{ city: "CAMBOOYA", state: "QLD", postcode: "4358" },
{ city: "FELTON", state: "QLD", postcode: "4358" },
{ city: "FELTON SOUTH", state: "QLD", postcode: "4358" },
{ city: "RAMSAY", state: "QLD", postcode: "4358" },
{ city: "BUDGEE", state: "QLD", postcode: "4359" },
{ city: "EAST GREENMOUNT", state: "QLD", postcode: "4359" },
{ city: "GREENMOUNT", state: "QLD", postcode: "4359" },
{ city: "HIRSTGLEN", state: "QLD", postcode: "4359" },
{ city: "WEST HALDON", state: "QLD", postcode: "4359" },
{ city: "NOBBY", state: "QLD", postcode: "4360" },
{ city: "BACK PLAINS", state: "QLD", postcode: "4361" },
{ city: "CLIFTON", state: "QLD", postcode: "4361" },
{ city: "ELLANGOWAN", state: "QLD", postcode: "4361" },
{ city: "ELPHINSTONE", state: "QLD", postcode: "4361" },
{ city: "HEADINGTON HILL", state: "QLD", postcode: "4361" },
{ city: "KINGS CREEK", state: "QLD", postcode: "4361" },
{ city: "MANAPOURI", state: "QLD", postcode: "4361" },
{ city: "MISSEN FLAT", state: "QLD", postcode: "4361" },
{ city: "MOUNT MOLAR", state: "QLD", postcode: "4361" },
{ city: "NEVILTON", state: "QLD", postcode: "4361" },
{ city: "PILTON", state: "QLD", postcode: "4361" },
{ city: "RYEFORD", state: "QLD", postcode: "4361" },
{ city: "SANDY CAMP", state: "QLD", postcode: "4361" },
{ city: "SPRING CREEK", state: "QLD", postcode: "4361" },
{ city: "UPPER PILTON", state: "QLD", postcode: "4361" },
{ city: "VICTORIA HILL", state: "QLD", postcode: "4361" },
{ city: "ALLORA", state: "QLD", postcode: "4362" },
{ city: "BERAT", state: "QLD", postcode: "4362" },
{ city: "DEUCHAR", state: "QLD", postcode: "4362" },
{ city: "ELLINTHORP", state: "QLD", postcode: "4362" },
{ city: "GOOMBURRA", state: "QLD", postcode: "4362" },
{ city: "HENDON", state: "QLD", postcode: "4362" },
{ city: "MOUNT MARSHALL", state: "QLD", postcode: "4362" },
{ city: "TALGAI", state: "QLD", postcode: "4362" },
{ city: "SOUTHBROOK", state: "QLD", postcode: "4363" },
{ city: "BROOKSTEAD", state: "QLD", postcode: "4364" },
{ city: "LEYBURN", state: "QLD", postcode: "4365" },
{ city: "ALLAN", state: "QLD", postcode: "4370" },
{ city: "BONY MOUNTAIN", state: "QLD", postcode: "4370" },
{ city: "CANNINGVALE", state: "QLD", postcode: "4370" },
{ city: "CHERRY GULLY", state: "QLD", postcode: "4370" },
{ city: "CLINTONVALE", state: "QLD", postcode: "4370" },
{ city: "CUNNINGHAM", state: "QLD", postcode: "4370" },
{ city: "DANDEROO", state: "QLD", postcode: "4370" },
{ city: "ELBOW VALLEY", state: "QLD", postcode: "4370" },
{ city: "FREESTONE", state: "QLD", postcode: "4370" },
{ city: "GLADFIELD", state: "QLD", postcode: "4370" },
{ city: "GLENGALLAN", state: "QLD", postcode: "4370" },
{ city: "GREYMARE", state: "QLD", postcode: "4370" },
{ city: "JUNABEE", state: "QLD", postcode: "4370" },
{ city: "LESLIE", state: "QLD", postcode: "4370" },
{ city: "LESLIE DAM", state: "QLD", postcode: "4370" },
{ city: "LOCH LOMOND", state: "QLD", postcode: "4370" },
{ city: "MARYVALE", state: "QLD", postcode: "4370" },
{ city: "MASSIE", state: "QLD", postcode: "4370" },
{ city: "MONTROSE", state: "QLD", postcode: "4370" },
{ city: "MORGAN PARK", state: "QLD", postcode: "4370" },
{ city: "MOUNT COLLIERY", state: "QLD", postcode: "4370" },
{ city: "MOUNT STURT", state: "QLD", postcode: "4370" },
{ city: "MOUNT TABOR", state: "QLD", postcode: "4370" },
{ city: "MURRAYS BRIDGE", state: "QLD", postcode: "4370" },
{ city: "NORTH BRANCH", state: "QLD", postcode: "4370" },
{ city: "PRATTEN", state: "QLD", postcode: "4370" },
{ city: "RODGERS CREEK", state: "QLD", postcode: "4370" },
{ city: "ROSEHILL", state: "QLD", postcode: "4370" },
{ city: "ROSENTHAL HEIGHTS", state: "QLD", postcode: "4370" },
{ city: "SILVERWOOD", state: "QLD", postcode: "4370" },
{ city: "SLADEVALE", state: "QLD", postcode: "4370" },
{ city: "SWAN CREEK", state: "QLD", postcode: "4370" },
{ city: "THANE", state: "QLD", postcode: "4370" },
{ city: "THANES CREEK", state: "QLD", postcode: "4370" },
{ city: "THE GLEN", state: "QLD", postcode: "4370" },
{ city: "THE HERMITAGE", state: "QLD", postcode: "4370" },
{ city: "TOOLBURRA", state: "QLD", postcode: "4370" },
{ city: "TREGONY", state: "QLD", postcode: "4370" },
{ city: "UPPER FREESTONE", state: "QLD", postcode: "4370" },
{ city: "UPPER WHEATVALE", state: "QLD", postcode: "4370" },
{ city: "WHEATVALE", state: "QLD", postcode: "4370" },
{ city: "WILDASH", state: "QLD", postcode: "4370" },
{ city: "WILLOWVALE", state: "QLD", postcode: "4370" },
{ city: "WIYARRA", state: "QLD", postcode: "4370" },
{ city: "WOMINA", state: "QLD", postcode: "4370" },
{ city: "EMU VALE", state: "QLD", postcode: "4371" },
{ city: "SWANFELS", state: "QLD", postcode: "4371" },
{ city: "YANGAN", state: "QLD", postcode: "4371" },
{ city: "TANNYMOREL", state: "QLD", postcode: "4372" },
{ city: "KILLARNEY", state: "QLD", postcode: "4373" },
{ city: "THE FALLS", state: "QLD", postcode: "4373" },
{ city: "THE HEAD", state: "QLD", postcode: "4373" },
{ city: "DALVEEN", state: "QLD", postcode: "4374" },
{ city: "COTTONVALE", state: "QLD", postcode: "4375" },
{ city: "FLEURBAIX", state: "QLD", postcode: "4375" },
{ city: "THULIMBAH", state: "QLD", postcode: "4376" },
{ city: "GLEN NIVEN", state: "QLD", postcode: "4377" },
{ city: "THE SUMMIT", state: "QLD", postcode: "4377" },
{ city: "APPLETHORPE", state: "QLD", postcode: "4378" },
{ city: "AMIENS", state: "QLD", postcode: "4380" },
{ city: "BROADWATER", state: "QLD", postcode: "4380" },
{ city: "CANNON CREEK", state: "QLD", postcode: "4380" },
{ city: "DALCOUTH", state: "QLD", postcode: "4380" },
{ city: "DIAMONDVALE", state: "QLD", postcode: "4380" },
{ city: "EUKEY", state: "QLD", postcode: "4380" },
{ city: "GLENLYON", state: "QLD", postcode: "4380" },
{ city: "GREENLANDS", state: "QLD", postcode: "4380" },
{ city: "KYOOMBA", state: "QLD", postcode: "4380" },
{ city: "MINGOOLA", state: "QLD", postcode: "4380" },
{ city: "MOUNT TULLY", state: "QLD", postcode: "4380" },
{ city: "NUNDUBBERMERE", state: "QLD", postcode: "4380" },
{ city: "PIKEDALE", state: "QLD", postcode: "4380" },
{ city: "PIKES CREEK", state: "QLD", postcode: "4380" },
{ city: "SEVERNLEA", state: "QLD", postcode: "4380" },
{ city: "SPRINGDALE", state: "QLD", postcode: "4380" },
{ city: "STANTHORPE", state: "QLD", postcode: "4380" },
{ city: "STORM KING", state: "QLD", postcode: "4380" },
{ city: "SUGARLOAF", state: "QLD", postcode: "4380" },
{ city: "THORNDALE", state: "QLD", postcode: "4380" },
{ city: "FLETCHER", state: "QLD", postcode: "4381" },
{ city: "GLEN APLIN", state: "QLD", postcode: "4381" },
{ city: "BALLANDEAN", state: "QLD", postcode: "4382" },
{ city: "GIRRAWEEN", state: "QLD", postcode: "4382" },
{ city: "LYRA", state: "QLD", postcode: "4382" },
{ city: "SOMME", state: "QLD", postcode: "4382" },
{ city: "WYBERBA", state: "QLD", postcode: "4382" },
{ city: "WALLANGARRA", state: "QLD", postcode: "4383" },
{ city: "LIMEVALE", state: "QLD", postcode: "4384" },
{ city: "BEEBO", state: "QLD", postcode: "4385" },
{ city: "BONSHAW", state: "QLD", postcode: "4385" },
{ city: "GLENARBON", state: "QLD", postcode: "4385" },
{ city: "MAIDENHEAD", state: "QLD", postcode: "4385" },
{ city: "RIVERTON", state: "QLD", postcode: "4385" },
{ city: "SILVER SPUR", state: "QLD", postcode: "4385" },
{ city: "SMITHLEA", state: "QLD", postcode: "4385" },
{ city: "TEXAS", state: "QLD", postcode: "4385" },
{ city: "WATSONS CROSSING", state: "QLD", postcode: "4385" },
{ city: "BRUSH CREEK", state: "QLD", postcode: "4387" },
{ city: "BYBERA", state: "QLD", postcode: "4387" },
{ city: "COOLMUNDA", state: "QLD", postcode: "4387" },
{ city: "GREENUP", state: "QLD", postcode: "4387" },
{ city: "INGLEWOOD", state: "QLD", postcode: "4387" },
{ city: "MOSQUITO CREEK", state: "QLD", postcode: "4387" },
{ city: "TERRICA", state: "QLD", postcode: "4387" },
{ city: "WARROO", state: "QLD", postcode: "4387" },
{ city: "WHETSTONE", state: "QLD", postcode: "4387" },
{ city: "KURUMBUL", state: "QLD", postcode: "4388" },
{ city: "YELARBON", state: "QLD", postcode: "4388" },
{ city: "BILLA BILLA", state: "QLD", postcode: "4390" },
{ city: "CALINGUNEE", state: "QLD", postcode: "4390" },
{ city: "CALLANDOON", state: "QLD", postcode: "4390" },
{ city: "GOODAR", state: "QLD", postcode: "4390" },
{ city: "GOONDIWINDI", state: "QLD", postcode: "4390" },
{ city: "KINDON", state: "QLD", postcode: "4390" },
{ city: "LUNDAVRA", state: "QLD", postcode: "4390" },
{ city: "WONDALLI", state: "QLD", postcode: "4390" },
{ city: "WYAGA", state: "QLD", postcode: "4390" },
{ city: "YAGABURNE", state: "QLD", postcode: "4390" },
{ city: "KINGSTHORPE", state: "QLD", postcode: "4400" },
{ city: "ACLAND", state: "QLD", postcode: "4401" },
{ city: "AUBIGNY", state: "QLD", postcode: "4401" },
{ city: "BALGOWAN", state: "QLD", postcode: "4401" },
{ city: "BIDDESTON", state: "QLD", postcode: "4401" },
{ city: "BOODUA", state: "QLD", postcode: "4401" },
{ city: "DEVON PARK", state: "QLD", postcode: "4401" },
{ city: "GREENWOOD", state: "QLD", postcode: "4401" },
{ city: "HIGHLAND PLAINS", state: "QLD", postcode: "4401" },
{ city: "KELVINHAUGH", state: "QLD", postcode: "4401" },
{ city: "MOUNT IRVING", state: "QLD", postcode: "4401" },
{ city: "MULDU", state: "QLD", postcode: "4401" },
{ city: "OAKEY", state: "QLD", postcode: "4401" },
{ city: "ROSALIE PLAINS", state: "QLD", postcode: "4401" },
{ city: "SABINE", state: "QLD", postcode: "4401" },
{ city: "SILVERLEIGH", state: "QLD", postcode: "4401" },
{ city: "YARGULLEN", state: "QLD", postcode: "4401" },
{ city: "COOYAR", state: "QLD", postcode: "4402" },
{ city: "KOORALGIN", state: "QLD", postcode: "4402" },
{ city: "UPPER COOYAR CREEK", state: "QLD", postcode: "4402" },
{ city: "BRYMAROO", state: "QLD", postcode: "4403" },
{ city: "JONDARYAN", state: "QLD", postcode: "4403" },
{ city: "MALU", state: "QLD", postcode: "4403" },
{ city: "MOUNT MORIAH", state: "QLD", postcode: "4403" },
{ city: "QUINALOW", state: "QLD", postcode: "4403" },
{ city: "WEST PRAIRIE", state: "QLD", postcode: "4403" },
{ city: "BOWENVILLE", state: "QLD", postcode: "4404" },
{ city: "FORMARTIN", state: "QLD", postcode: "4404" },
{ city: "IRVINGDALE", state: "QLD", postcode: "4404" },
{ city: "WAINUI", state: "QLD", postcode: "4404" },
{ city: "BUNYA MOUNTAINS", state: "QLD", postcode: "4405" },
{ city: "DALBY", state: "QLD", postcode: "4405" },
{ city: "DUCKLO", state: "QLD", postcode: "4405" },
{ city: "GRASSDALE", state: "QLD", postcode: "4405" },
{ city: "MARMADUA", state: "QLD", postcode: "4405" },
{ city: "PIRRINUAN", state: "QLD", postcode: "4405" },
{ city: "RANGES BRIDGE", state: "QLD", postcode: "4405" },
{ city: "ST RUTH", state: "QLD", postcode: "4405" },
{ city: "TIPTON", state: "QLD", postcode: "4405" },
{ city: "WERANGA", state: "QLD", postcode: "4405" },
{ city: "BOONDANDILLA", state: "QLD", postcode: "4406" },
{ city: "HANNAFORD", state: "QLD", postcode: "4406" },
{ city: "JIMBOUR", state: "QLD", postcode: "4406" },
{ city: "KAIMKILLENBUN", state: "QLD", postcode: "4406" },
{ city: "KOGAN", state: "QLD", postcode: "4406" },
{ city: "MACALISTER", state: "QLD", postcode: "4406" },
{ city: "MOONIE", state: "QLD", postcode: "4406" },
{ city: "SOUTHWOOD", state: "QLD", postcode: "4406" },
{ city: "THE GUMS", state: "QLD", postcode: "4406" },
{ city: "WEIR RIVER", state: "QLD", postcode: "4406" },
{ city: "CATTLE CREEK", state: "QLD", postcode: "4407" },
{ city: "CECIL PLAINS", state: "QLD", postcode: "4407" },
{ city: "DUNMORE", state: "QLD", postcode: "4407" },
{ city: "NANGWEE", state: "QLD", postcode: "4407" },
{ city: "BELL", state: "QLD", postcode: "4408" },
{ city: "JANDOWAE", state: "QLD", postcode: "4410" },
{ city: "WARRA", state: "QLD", postcode: "4411" },
{ city: "BRIGALOW", state: "QLD", postcode: "4412" },
{ city: "BAKING BOARD", state: "QLD", postcode: "4413" },
{ city: "BOONARGA", state: "QLD", postcode: "4413" },
{ city: "BURNCLUITH", state: "QLD", postcode: "4413" },
{ city: "CANAGA", state: "QLD", postcode: "4413" },
{ city: "CHANCES PLAIN", state: "QLD", postcode: "4413" },
{ city: "DURAH", state: "QLD", postcode: "4413" },
{ city: "HOPELAND", state: "QLD", postcode: "4413" },
{ city: "MONTROSE", state: "QLD", postcode: "4413" },
{ city: "WIEAMBILLA", state: "QLD", postcode: "4413" },
{ city: "COLUMBOOLA", state: "QLD", postcode: "4415" },
{ city: "DALWOGON", state: "QLD", postcode: "4415" },
{ city: "GURULMUNDI", state: "QLD", postcode: "4415" },
{ city: "HOOKSWOOD", state: "QLD", postcode: "4415" },
{ city: "KOWGURAN", state: "QLD", postcode: "4415" },
{ city: "MILES", state: "QLD", postcode: "4415" },
{ city: "MYALL PARK", state: "QLD", postcode: "4415" },
{ city: "PELHAM", state: "QLD", postcode: "4415" },
{ city: "BARRAMORNIE", state: "QLD", postcode: "4416" },
{ city: "CONDAMINE", state: "QLD", postcode: "4416" },
{ city: "MORABY", state: "QLD", postcode: "4416" },
{ city: "NANGRAM", state: "QLD", postcode: "4416" },
{ city: "PINE HILLS", state: "QLD", postcode: "4416" },
{ city: "SUNNYSIDE", state: "QLD", postcode: "4416" },
{ city: "YULABILLA", state: "QLD", postcode: "4416" },
{ city: "NOORINDOO", state: "QLD", postcode: "4417" },
{ city: "OBERINA", state: "QLD", postcode: "4417" },
{ city: "PARKNOOK", state: "QLD", postcode: "4417" },
{ city: "SURAT", state: "QLD", postcode: "4417" },
{ city: "WARKON", state: "QLD", postcode: "4417" },
{ city: "WELLESLEY", state: "QLD", postcode: "4417" },
{ city: "WERIBONE", state: "QLD", postcode: "4417" },
{ city: "GULUGUBA", state: "QLD", postcode: "4418" },
{ city: "COCKATOO", state: "QLD", postcode: "4419" },
{ city: "GROSMONT", state: "QLD", postcode: "4419" },
{ city: "WANDOAN", state: "QLD", postcode: "4419" },
{ city: "BROADMERE", state: "QLD", postcode: "4420" },
{ city: "COORADA", state: "QLD", postcode: "4420" },
{ city: "GHINGHINDA", state: "QLD", postcode: "4420" },
{ city: "GLENHAUGHTON", state: "QLD", postcode: "4420" },
{ city: "GWAMBEGWINE", state: "QLD", postcode: "4420" },
{ city: "HORNET BANK", state: "QLD", postcode: "4420" },
{ city: "PEEK-A-DOO", state: "QLD", postcode: "4420" },
{ city: "SPRING CREEK", state: "QLD", postcode: "4420" },
{ city: "TAROOM", state: "QLD", postcode: "4420" },
{ city: "GORANBA", state: "QLD", postcode: "4421" },
{ city: "TARA", state: "QLD", postcode: "4421" },
{ city: "COOMRITH", state: "QLD", postcode: "4422" },
{ city: "FLINTON", state: "QLD", postcode: "4422" },
{ city: "INGLESTONE", state: "QLD", postcode: "4422" },
{ city: "MEANDARRA", state: "QLD", postcode: "4422" },
{ city: "WESTMAR", state: "QLD", postcode: "4422" },
{ city: "GLENMORGAN", state: "QLD", postcode: "4423" },
{ city: "TEELBA", state: "QLD", postcode: "4423" },
{ city: "DRILLHAM", state: "QLD", postcode: "4424" },
{ city: "DRILLHAM SOUTH", state: "QLD", postcode: "4424" },
{ city: "GLENAUBYN", state: "QLD", postcode: "4424" },
{ city: "BOGANDILLA", state: "QLD", postcode: "4425" },
{ city: "DULACCA", state: "QLD", postcode: "4425" },
{ city: "JACKSON", state: "QLD", postcode: "4426" },
{ city: "JACKSON NORTH", state: "QLD", postcode: "4426" },
{ city: "JACKSON SOUTH", state: "QLD", postcode: "4426" },
{ city: "CLIFFORD", state: "QLD", postcode: "4427" },
{ city: "YULEBA", state: "QLD", postcode: "4427" },
{ city: "YULEBA NORTH", state: "QLD", postcode: "4427" },
{ city: "YULEBA SOUTH", state: "QLD", postcode: "4427" },
{ city: "PICKANJINNIE", state: "QLD", postcode: "4428" },
{ city: "WALLUMBILLA", state: "QLD", postcode: "4428" },
{ city: "WALLUMBILLA NORTH", state: "QLD", postcode: "4428" },
{ city: "WALLUMBILLA SOUTH", state: "QLD", postcode: "4428" },
{ city: "BAFFLE WEST", state: "QLD", postcode: "4454" },
{ city: "BEILBA", state: "QLD", postcode: "4454" },
{ city: "DURHAM DOWNS", state: "QLD", postcode: "4454" },
{ city: "HIGHLAND PLAINS", state: "QLD", postcode: "4454" },
{ city: "HUTTON CREEK", state: "QLD", postcode: "4454" },
{ city: "INJUNE", state: "QLD", postcode: "4454" },
{ city: "MOUNT HUTTON", state: "QLD", postcode: "4454" },
{ city: "PONY HILLS", state: "QLD", postcode: "4454" },
{ city: "SIMMIE", state: "QLD", postcode: "4454" },
{ city: "UPPER DAWSON", state: "QLD", postcode: "4454" },
{ city: "WESTGROVE", state: "QLD", postcode: "4454" },
{ city: "BALLAROO", state: "QLD", postcode: "4455" },
{ city: "BLYTHDALE", state: "QLD", postcode: "4455" },
{ city: "BUNGEWORGORAI", state: "QLD", postcode: "4455" },
{ city: "BUNGIL", state: "QLD", postcode: "4455" },
{ city: "BYMOUNT", state: "QLD", postcode: "4455" },
{ city: "CORNWALL", state: "QLD", postcode: "4455" },
{ city: "DARGAL ROAD", state: "QLD", postcode: "4455" },
{ city: "EUMAMURRIN", state: "QLD", postcode: "4455" },
{ city: "EUTHULLA", state: "QLD", postcode: "4455" },
{ city: "GUNNEWIN", state: "QLD", postcode: "4455" },
{ city: "HODGSON", state: "QLD", postcode: "4455" },
{ city: "MOOGA", state: "QLD", postcode: "4455" },
{ city: "MOUNT ABUNDANCE", state: "QLD", postcode: "4455" },
{ city: "MOUNT BINDANGO", state: "QLD", postcode: "4455" },
{ city: "ORALLO", state: "QLD", postcode: "4455" },
{ city: "ORANGE HILL", state: "QLD", postcode: "4455" },
{ city: "ROMA", state: "QLD", postcode: "4455" },
{ city: "TINGUN", state: "QLD", postcode: "4455" },
{ city: "WYCOMBE", state: "QLD", postcode: "4455" },
{ city: "MUCKADILLA", state: "QLD", postcode: "4461" },
{ city: "AMBY", state: "QLD", postcode: "4462" },
{ city: "DUNKELD", state: "QLD", postcode: "4465" },
{ city: "FORESTVALE", state: "QLD", postcode: "4465" },
{ city: "MITCHELL", state: "QLD", postcode: "4465" },
{ city: "V GATE", state: "QLD", postcode: "4465" },
{ city: "WOMALILLA", state: "QLD", postcode: "4465" },
{ city: "MUNGALLALA", state: "QLD", postcode: "4467" },
{ city: "REDFORD", state: "QLD", postcode: "4467" },
{ city: "TYRCONNEL", state: "QLD", postcode: "4467" },
{ city: "CLARA CREEK", state: "QLD", postcode: "4468" },
{ city: "MORVEN", state: "QLD", postcode: "4468" },
{ city: "BAKERS BEND", state: "QLD", postcode: "4470" },
{ city: "CHARLEVILLE", state: "QLD", postcode: "4470" },
{ city: "GOWRIE STATION", state: "QLD", postcode: "4470" },
{ city: "LANGLO", state: "QLD", postcode: "4470" },
{ city: "MURWEH", state: "QLD", postcode: "4470" },
{ city: "RIVERSLEIGH", state: "QLD", postcode: "4470" },
{ city: "CLAVERTON", state: "QLD", postcode: "4471" },
{ city: "NARDOO SIDING", state: "QLD", postcode: "4471" },
{ city: "BLACKALL", state: "QLD", postcode: "4472" },
{ city: "MOUNT ENNISKILLEN", state: "QLD", postcode: "4472" },
{ city: "ADAVALE", state: "QLD", postcode: "4474" },
{ city: "CHEEPIE", state: "QLD", postcode: "4475" },
{ city: "AUGATHELLA", state: "QLD", postcode: "4477" },
{ city: "UPPER WARREGO", state: "QLD", postcode: "4477" },
{ city: "BAYRICK", state: "QLD", postcode: "4478" },
{ city: "CALDERVALE", state: "QLD", postcode: "4478" },
{ city: "LANSDOWNE", state: "QLD", postcode: "4478" },
{ city: "LUMEAH", state: "QLD", postcode: "4478" },
{ city: "MACFARLANE", state: "QLD", postcode: "4478" },
{ city: "MINNIE DOWNS", state: "QLD", postcode: "4478" },
{ city: "SCRUBBY CREEK", state: "QLD", postcode: "4478" },
{ city: "TAMBO", state: "QLD", postcode: "4478" },
{ city: "WINDEYER", state: "QLD", postcode: "4478" },
{ city: "YANDARLO", state: "QLD", postcode: "4478" },
{ city: "COOLADDI", state: "QLD", postcode: "4479" },
{ city: "EROMANGA", state: "QLD", postcode: "4480" },
{ city: "QUILPIE", state: "QLD", postcode: "4480" },
{ city: "FARRARS CREEK", state: "QLD", postcode: "4481" },
{ city: "TANBAR", state: "QLD", postcode: "4481" },
{ city: "WINDORAH", state: "QLD", postcode: "4481" },
{ city: "BIRDSVILLE", state: "QLD", postcode: "4482" },
{ city: "DIRRANBANDI", state: "QLD", postcode: "4486" },
{ city: "HEBEL", state: "QLD", postcode: "4486" },
{ city: "BEGONIA", state: "QLD", postcode: "4487" },
{ city: "ST GEORGE", state: "QLD", postcode: "4487" },
{ city: "BOLLON", state: "QLD", postcode: "4488" },
{ city: "NEBINE", state: "QLD", postcode: "4488" },
{ city: "WYANDRA", state: "QLD", postcode: "4489" },
{ city: "BARRINGUN", state: "QLD", postcode: "4490" },
{ city: "COONGOOLA", state: "QLD", postcode: "4490" },
{ city: "CUNNAMULLA", state: "QLD", postcode: "4490" },
{ city: "CUTTABURRA", state: "QLD", postcode: "4490" },
{ city: "HUMEBURN", state: "QLD", postcode: "4490" },
{ city: "JOBS GATE", state: "QLD", postcode: "4490" },
{ city: "LINDEN", state: "QLD", postcode: "4490" },
{ city: "NOORAMA", state: "QLD", postcode: "4490" },
{ city: "TUEN", state: "QLD", postcode: "4490" },
{ city: "WIDGEEGOARA", state: "QLD", postcode: "4490" },
{ city: "YOWAH", state: "QLD", postcode: "4490" },
{ city: "EULO", state: "QLD", postcode: "4491" },
{ city: "BULLAWARRA", state: "QLD", postcode: "4492" },
{ city: "BULLOO DOWNS", state: "QLD", postcode: "4492" },
{ city: "DYNEVOR", state: "QLD", postcode: "4492" },
{ city: "NOCKATUNGA", state: "QLD", postcode: "4492" },
{ city: "NORLEY", state: "QLD", postcode: "4492" },
{ city: "THARGOMINDAH", state: "QLD", postcode: "4492" },
{ city: "HUNGERFORD", state: "QLD", postcode: "4493" },
{ city: "BUNGUNYA", state: "QLD", postcode: "4494" },
{ city: "NORTH BUNGUNYA", state: "QLD", postcode: "4494" },
{ city: "TARAWERA", state: "QLD", postcode: "4494" },
{ city: "NORTH TALWOOD", state: "QLD", postcode: "4496" },
{ city: "SOUTH TALWOOD", state: "QLD", postcode: "4496" },
{ city: "TALWOOD", state: "QLD", postcode: "4496" },
{ city: "DAYMAR", state: "QLD", postcode: "4497" },
{ city: "THALLON", state: "QLD", postcode: "4497" },
{ city: "WEENGALLON", state: "QLD", postcode: "4497" },
{ city: "KIOMA", state: "QLD", postcode: "4498" },
{ city: "TOOBEAH", state: "QLD", postcode: "4498" },
{ city: "BRIBIE ISLAND", state: "QLD", postcode: "4507" },
{ city: "BRIBIE ISLAND NORTH", state: "QLD", postcode: "4507" },
{ city: "WELSBY", state: "QLD", postcode: "4507" },
{ city: "WHITE PATCH", state: "QLD", postcode: "4507" },
{ city: "WOORIM", state: "QLD", postcode: "4507" },
{ city: "BRACALBA", state: "QLD", postcode: "4512" },
{ city: "WAMURAN", state: "QLD", postcode: "4512" },
{ city: "WAMURAN BASIN", state: "QLD", postcode: "4512" },
{ city: "MOUNT ARCHER", state: "QLD", postcode: "4514" },
{ city: "JIMNA", state: "QLD", postcode: "4515" },
{ city: "MONSILDALE", state: "QLD", postcode: "4515" },
{ city: "SANDY CREEK", state: "QLD", postcode: "4515" },
{ city: "BEERBURRUM", state: "QLD", postcode: "4517" },
{ city: "GLASS HOUSE MOUNTAINS", state: "QLD", postcode: "4518" },
{ city: "CAMPBELLS POCKET", state: "QLD", postcode: "4521" },
{ city: "DAYBORO", state: "QLD", postcode: "4521" },
{ city: "KING SCRUB", state: "QLD", postcode: "4521" },
{ city: "LACEYS CREEK", state: "QLD", postcode: "4521" },
{ city: "MOUNT MEE", state: "QLD", postcode: "4521" },
{ city: "MOUNT PLEASANT", state: "QLD", postcode: "4521" },
{ city: "OCEAN VIEW", state: "QLD", postcode: "4521" },
{ city: "RUSH CREEK", state: "QLD", postcode: "4521" },
{ city: "LANDSBOROUGH", state: "QLD", postcode: "4550" },
{ city: "MOUNT MELLUM", state: "QLD", postcode: "4550" },
{ city: "BARINGA", state: "QLD", postcode: "4551" },
{ city: "BATTERY HILL", state: "QLD", postcode: "4551" },
{ city: "BELLS CREEK", state: "QLD", postcode: "4551" },
{ city: "DICKY BEACH", state: "QLD", postcode: "4551" },
{ city: "GOLDEN BEACH", state: "QLD", postcode: "4551" },
{ city: "KINGS BEACH", state: "QLD", postcode: "4551" },
{ city: "LITTLE MOUNTAIN", state: "QLD", postcode: "4551" },
{ city: "MERIDAN PLAINS", state: "QLD", postcode: "4551" },
{ city: "MOFFAT BEACH", state: "QLD", postcode: "4551" },
{ city: "PELICAN WATERS", state: "QLD", postcode: "4551" },
{ city: "BALD KNOB", state: "QLD", postcode: "4552" },
{ city: "BALMORAL RIDGE", state: "QLD", postcode: "4552" },
{ city: "BOOROOBIN", state: "QLD", postcode: "4552" },
{ city: "CAMBROON", state: "QLD", postcode: "4552" },
{ city: "CONONDALE", state: "QLD", postcode: "4552" },
{ city: "CRYSTAL WATERS", state: "QLD", postcode: "4552" },
{ city: "CURRAMORE", state: "QLD", postcode: "4552" },
{ city: "ELAMAN CREEK", state: "QLD", postcode: "4552" },
{ city: "HARPER CREEK", state: "QLD", postcode: "4552" },
{ city: "MALENY", state: "QLD", postcode: "4552" },
{ city: "NORTH MALENY", state: "QLD", postcode: "4552" },
{ city: "REESVILLE", state: "QLD", postcode: "4552" },
{ city: "WITTA", state: "QLD", postcode: "4552" },
{ city: "WOOTHA", state: "QLD", postcode: "4552" },
{ city: "DIAMOND VALLEY", state: "QLD", postcode: "4553" },
{ city: "GLENVIEW", state: "QLD", postcode: "4553" },
{ city: "MOOLOOLAH", state: "QLD", postcode: "4553" },
{ city: "MOOLOOLAH VALLEY", state: "QLD", postcode: "4553" },
{ city: "PALMVIEW", state: "QLD", postcode: "4553" },
{ city: "EUDLO", state: "QLD", postcode: "4554" },
{ city: "ILKLEY", state: "QLD", postcode: "4554" },
{ city: "CHEVALLUM", state: "QLD", postcode: "4555" },
{ city: "HUNCHY", state: "QLD", postcode: "4555" },
{ city: "LANDERS SHOOT", state: "QLD", postcode: "4555" },
{ city: "PALMWOODS", state: "QLD", postcode: "4555" },
{ city: "FOREST GLEN", state: "QLD", postcode: "4556" },
{ city: "MONS", state: "QLD", postcode: "4556" },
{ city: "TANAWHA", state: "QLD", postcode: "4556" },
{ city: "MOUNTAIN CREEK", state: "QLD", postcode: "4557" },
{ city: "DIDDILLIBAH", state: "QLD", postcode: "4559" },
{ city: "KIELS MOUNTAIN", state: "QLD", postcode: "4559" },
{ city: "WEST WOOMBYE", state: "QLD", postcode: "4559" },
{ city: "WOOMBYE", state: "QLD", postcode: "4559" },
{ city: "BURNSIDE", state: "QLD", postcode: "4560" },
{ city: "COES CREEK", state: "QLD", postcode: "4560" },
{ city: "COOLOOLABIN", state: "QLD", postcode: "4560" },
{ city: "DULONG", state: "QLD", postcode: "4560" },
{ city: "FLAXTON", state: "QLD", postcode: "4560" },
{ city: "HIGHWORTH", state: "QLD", postcode: "4560" },
{ city: "IMAGE FLAT", state: "QLD", postcode: "4560" },
{ city: "KIAMBA", state: "QLD", postcode: "4560" },
{ city: "KULANGOOR", state: "QLD", postcode: "4560" },
{ city: "KUREELPA", state: "QLD", postcode: "4560" },
{ city: "MAPLETON", state: "QLD", postcode: "4560" },
{ city: "MONTVILLE", state: "QLD", postcode: "4560" },
{ city: "PARKLANDS", state: "QLD", postcode: "4560" },
{ city: "PERWILLOWEN", state: "QLD", postcode: "4560" },
{ city: "ROSEMOUNT", state: "QLD", postcode: "4560" },
{ city: "SUNSHINE COAST MC", state: "QLD", postcode: "4560" },
{ city: "TOWEN MOUNTAIN", state: "QLD", postcode: "4560" },
{ city: "BRIDGES", state: "QLD", postcode: "4561" },
{ city: "MAROOCHY RIVER", state: "QLD", postcode: "4561" },
{ city: "NINDERRY", state: "QLD", postcode: "4561" },
{ city: "NORTH ARM", state: "QLD", postcode: "4561" },
{ city: "VALDORA", state: "QLD", postcode: "4561" },
{ city: "YANDINA", state: "QLD", postcode: "4561" },
{ city: "YANDINA CREEK", state: "QLD", postcode: "4561" },
{ city: "BELLI PARK", state: "QLD", postcode: "4562" },
{ city: "DOONAN", state: "QLD", postcode: "4562" },
{ city: "EERWAH VALE", state: "QLD", postcode: "4562" },
{ city: "EUMUNDI", state: "QLD", postcode: "4562" },
{ city: "VERRIERDALE", state: "QLD", postcode: "4562" },
{ city: "WEYBA DOWNS", state: "QLD", postcode: "4562" },
{ city: "BLACK MOUNTAIN", state: "QLD", postcode: "4563" },
{ city: "CARTERS RIDGE", state: "QLD", postcode: "4563" },
{ city: "COOROY", state: "QLD", postcode: "4563" },
{ city: "COOROY MOUNTAIN", state: "QLD", postcode: "4563" },
{ city: "LAKE MACDONALD", state: "QLD", postcode: "4563" },
{ city: "RIDGEWOOD", state: "QLD", postcode: "4563" },
{ city: "TINBEERWAH", state: "QLD", postcode: "4563" },
{ city: "MARCOOLA", state: "QLD", postcode: "4564" },
{ city: "MUDJIMBA", state: "QLD", postcode: "4564" },
{ city: "PACIFIC PARADISE", state: "QLD", postcode: "4564" },
{ city: "TWIN WATERS", state: "QLD", postcode: "4564" },
{ city: "BOREEN POINT", state: "QLD", postcode: "4565" },
{ city: "COOROIBAH", state: "QLD", postcode: "4565" },
{ city: "COOTHARABA", state: "QLD", postcode: "4565" },
{ city: "NOOSA NORTH SHORE", state: "QLD", postcode: "4565" },
{ city: "RINGTAIL CREEK", state: "QLD", postcode: "4565" },
{ city: "TEWANTIN", state: "QLD", postcode: "4565" },
{ city: "CASTAWAYS BEACH", state: "QLD", postcode: "4567" },
{ city: "SUNRISE BEACH", state: "QLD", postcode: "4567" },
{ city: "FEDERAL", state: "QLD", postcode: "4568" },
{ city: "PINBARREN", state: "QLD", postcode: "4568" },
{ city: "POMONA", state: "QLD", postcode: "4568" },
{ city: "COORAN", state: "QLD", postcode: "4569" },
{ city: "AMAMOOR", state: "QLD", postcode: "4570" },
{ city: "AMAMOOR CREEK", state: "QLD", postcode: "4570" },
{ city: "ANDERLEIGH", state: "QLD", postcode: "4570" },
{ city: "ARALUEN", state: "QLD", postcode: "4570" },
{ city: "BANKS POCKET", state: "QLD", postcode: "4570" },
{ city: "BEENAAM VALLEY", state: "QLD", postcode: "4570" },
{ city: "BELLA CREEK", state: "QLD", postcode: "4570" },
{ city: "BELLS BRIDGE", state: "QLD", postcode: "4570" },
{ city: "BOLLIER", state: "QLD", postcode: "4570" },
{ city: "BROOLOO", state: "QLD", postcode: "4570" },
{ city: "CALGOA", state: "QLD", postcode: "4570" },
{ city: "CALICO CREEK", state: "QLD", postcode: "4570" },
{ city: "CANINA", state: "QLD", postcode: "4570" },
{ city: "CEDAR POCKET", state: "QLD", postcode: "4570" },
{ city: "CHATSWORTH", state: "QLD", postcode: "4570" },
{ city: "COLES CREEK", state: "QLD", postcode: "4570" },
{ city: "COONDOO", state: "QLD", postcode: "4570" },
{ city: "CORELLA", state: "QLD", postcode: "4570" },
{ city: "CURRA", state: "QLD", postcode: "4570" },
{ city: "DAGUN", state: "QLD", postcode: "4570" },
{ city: "DOWNSFIELD", state: "QLD", postcode: "4570" },
{ city: "EAST DEEP CREEK", state: "QLD", postcode: "4570" },
{ city: "FISHERMANS POCKET", state: "QLD", postcode: "4570" },
{ city: "GILLDORA", state: "QLD", postcode: "4570" },
{ city: "GLANMIRE", state: "QLD", postcode: "4570" },
{ city: "GLASTONBURY", state: "QLD", postcode: "4570" },
{ city: "GLEN ECHO", state: "QLD", postcode: "4570" },
{ city: "GLENWOOD", state: "QLD", postcode: "4570" },
{ city: "GOOMBOORIAN", state: "QLD", postcode: "4570" },
{ city: "GREENS CREEK", state: "QLD", postcode: "4570" },
{ city: "GUNALDA", state: "QLD", postcode: "4570" },
{ city: "IMBIL", state: "QLD", postcode: "4570" },
{ city: "JONES HILL", state: "QLD", postcode: "4570" },
{ city: "KANDANGA", state: "QLD", postcode: "4570" },
{ city: "KANDANGA CREEK", state: "QLD", postcode: "4570" },
{ city: "KANIGAN", state: "QLD", postcode: "4570" },
{ city: "KIA ORA", state: "QLD", postcode: "4570" },
{ city: "KYBONG", state: "QLD", postcode: "4570" },
{ city: "LAGOON POCKET", state: "QLD", postcode: "4570" },
{ city: "LAKE BORUMBA", state: "QLD", postcode: "4570" },
{ city: "LANGSHAW", state: "QLD", postcode: "4570" },
{ city: "LONG FLAT", state: "QLD", postcode: "4570" },
{ city: "LOWER WONGA", state: "QLD", postcode: "4570" },
{ city: "MARODIAN", state: "QLD", postcode: "4570" },
{ city: "MARYS CREEK", state: "QLD", postcode: "4570" },
{ city: "MCINTOSH CREEK", state: "QLD", postcode: "4570" },
{ city: "MELAWONDI", state: "QLD", postcode: "4570" },
{ city: "MIVA", state: "QLD", postcode: "4570" },
{ city: "MONKLAND", state: "QLD", postcode: "4570" },
{ city: "MOOLOO", state: "QLD", postcode: "4570" },
{ city: "MOTHAR MOUNTAIN", state: "QLD", postcode: "4570" },
{ city: "MUNNA CREEK", state: "QLD", postcode: "4570" },
{ city: "NAHRUNDA", state: "QLD", postcode: "4570" },
{ city: "NEERDIE", state: "QLD", postcode: "4570" },
{ city: "NEUSA VALE", state: "QLD", postcode: "4570" },
{ city: "NORTH DEEP CREEK", state: "QLD", postcode: "4570" },
{ city: "PATERSON", state: "QLD", postcode: "4570" },
{ city: "PIE CREEK", state: "QLD", postcode: "4570" },
{ city: "ROSS CREEK", state: "QLD", postcode: "4570" },
{ city: "SCOTCHY POCKET", state: "QLD", postcode: "4570" },
{ city: "SCRUBBY CREEK", state: "QLD", postcode: "4570" },
{ city: "SEXTON", state: "QLD", postcode: "4570" },
{ city: "TAMAREE", state: "QLD", postcode: "4570" },
{ city: "TANDUR", state: "QLD", postcode: "4570" },
{ city: "THE DAWN", state: "QLD", postcode: "4570" },
{ city: "THEEBINE", state: "QLD", postcode: "4570" },
{ city: "THE PALMS", state: "QLD", postcode: "4570" },
{ city: "TOOLARA FOREST", state: "QLD", postcode: "4570" },
{ city: "TRAVESTON", state: "QLD", postcode: "4570" },
{ city: "TUCHEKOI", state: "QLD", postcode: "4570" },
{ city: "TWO MILE", state: "QLD", postcode: "4570" },
{ city: "UPPER GLASTONBURY", state: "QLD", postcode: "4570" },
{ city: "UPPER KANDANGA", state: "QLD", postcode: "4570" },
{ city: "VETERAN", state: "QLD", postcode: "4570" },
{ city: "VICTORY HEIGHTS", state: "QLD", postcode: "4570" },
{ city: "WALLU", state: "QLD", postcode: "4570" },
{ city: "WIDGEE", state: "QLD", postcode: "4570" },
{ city: "WIDGEE CROSSING NORTH", state: "QLD", postcode: "4570" },
{ city: "WIDGEE CROSSING SOUTH", state: "QLD", postcode: "4570" },
{ city: "WILSONS POCKET", state: "QLD", postcode: "4570" },
{ city: "WOLVI", state: "QLD", postcode: "4570" },
{ city: "WOOLOOGA", state: "QLD", postcode: "4570" },
{ city: "WOONDUM", state: "QLD", postcode: "4570" },
{ city: "COMO", state: "QLD", postcode: "4571" },
{ city: "KIN KIN", state: "QLD", postcode: "4571" },
{ city: "MARCUS BEACH", state: "QLD", postcode: "4573" },
{ city: "PEREGIAN BEACH SOUTH", state: "QLD", postcode: "4573" },
{ city: "PEREGIAN SPRINGS", state: "QLD", postcode: "4573" },
{ city: "POINT ARKWRIGHT", state: "QLD", postcode: "4573" },
{ city: "YAROOMBA", state: "QLD", postcode: "4573" },
{ city: "COOLABINE", state: "QLD", postcode: "4574" },
{ city: "GHEERULLA", state: "QLD", postcode: "4574" },
{ city: "KENILWORTH", state: "QLD", postcode: "4574" },
{ city: "KIDAMAN CREEK", state: "QLD", postcode: "4574" },
{ city: "MOY POCKET", state: "QLD", postcode: "4574" },
{ city: "OBI OBI", state: "QLD", postcode: "4574" },
{ city: "COOLOOLA", state: "QLD", postcode: "4580" },
{ city: "COOLOOLA COVE", state: "QLD", postcode: "4580" },
{ city: "TIN CAN BAY", state: "QLD", postcode: "4580" },
{ city: "EURONG", state: "QLD", postcode: "4581" },
{ city: "FRASER ISLAND", state: "QLD", postcode: "4581" },
{ city: "INSKIP", state: "QLD", postcode: "4581" },
{ city: "ORCHID BEACH", state: "QLD", postcode: "4581" },
{ city: "RAINBOW BEACH", state: "QLD", postcode: "4581" },
{ city: "BLACK SNAKE", state: "QLD", postcode: "4600" },
{ city: "CINNABAR", state: "QLD", postcode: "4600" },
{ city: "KILKIVAN", state: "QLD", postcode: "4600" },
{ city: "MUDLO", state: "QLD", postcode: "4600" },
{ city: "OAKVIEW", state: "QLD", postcode: "4600" },
{ city: "BARAMBAH", state: "QLD", postcode: "4601" },
{ city: "BOONARA", state: "QLD", postcode: "4601" },
{ city: "BOOUBYJAN", state: "QLD", postcode: "4601" },
{ city: "GOOMERI", state: "QLD", postcode: "4601" },
{ city: "GOOMERIBONG", state: "QLD", postcode: "4601" },
{ city: "KINBOMBI", state: "QLD", postcode: "4601" },
{ city: "MANUMBAR", state: "QLD", postcode: "4601" },
{ city: "TANSEY", state: "QLD", postcode: "4601" },
{ city: "WRATTENS FOREST", state: "QLD", postcode: "4601" },
{ city: "MANYUNG", state: "QLD", postcode: "4605" },
{ city: "ARAMARA", state: "QLD", postcode: "4620" },
{ city: "BROOWEENA", state: "QLD", postcode: "4620" },
{ city: "DOONGUL", state: "QLD", postcode: "4620" },
{ city: "GIGOOMGAN", state: "QLD", postcode: "4620" },
{ city: "GLENBAR", state: "QLD", postcode: "4620" },
{ city: "GUNGALOON", state: "QLD", postcode: "4620" },
{ city: "MALARGA", state: "QLD", postcode: "4620" },
{ city: "NORTH ARAMARA", state: "QLD", postcode: "4620" },
{ city: "TEEBAR", state: "QLD", postcode: "4620" },
{ city: "WOOCOO", state: "QLD", postcode: "4620" },
{ city: "BIGGENDEN", state: "QLD", postcode: "4621" },
{ city: "BOOMPA", state: "QLD", postcode: "4621" },
{ city: "COALSTOUN LAKES", state: "QLD", postcode: "4621" },
{ city: "CORINGA", state: "QLD", postcode: "4621" },
{ city: "DALLARNIL", state: "QLD", postcode: "4621" },
{ city: "DEGILBO", state: "QLD", postcode: "4621" },
{ city: "DIDCOT", state: "QLD", postcode: "4621" },
{ city: "GOLDEN FLEECE", state: "QLD", postcode: "4621" },
{ city: "LAKESIDE", state: "QLD", postcode: "4621" },
{ city: "WATERANGA", state: "QLD", postcode: "4621" },
{ city: "WOOWOONGA", state: "QLD", postcode: "4621" },
{ city: "ARANBANGA", state: "QLD", postcode: "4625" },
{ city: "BAN BAN", state: "QLD", postcode: "4625" },
{ city: "BAN BAN SPRINGS", state: "QLD", postcode: "4625" },
{ city: "BARLYNE", state: "QLD", postcode: "4625" },
{ city: "BINJOUR", state: "QLD", postcode: "4625" },
{ city: "BLAIRMORE", state: "QLD", postcode: "4625" },
{ city: "BON ACCORD", state: "QLD", postcode: "4625" },
{ city: "BRANCH CREEK", state: "QLD", postcode: "4625" },
{ city: "BYRNESTOWN", state: "QLD", postcode: "4625" },
{ city: "CAMPBELL CREEK", state: "QLD", postcode: "4625" },
{ city: "DEEP CREEK", state: "QLD", postcode: "4625" },
{ city: "DIRNBIR", state: "QLD", postcode: "4625" },
{ city: "DUNDARRAH", state: "QLD", postcode: "4625" },
{ city: "GAYNDAH", state: "QLD", postcode: "4625" },
{ city: "GINOONDAN", state: "QLD", postcode: "4625" },
{ city: "GOOROOLBA", state: "QLD", postcode: "4625" },
{ city: "HARRIET", state: "QLD", postcode: "4625" },
{ city: "HUMPHERY", state: "QLD", postcode: "4625" },
{ city: "IDERAWAY", state: "QLD", postcode: "4625" },
{ city: "MINGO", state: "QLD", postcode: "4625" },
{ city: "MOUNT DEBATEABLE", state: "QLD", postcode: "4625" },
{ city: "MOUNT LAWLESS", state: "QLD", postcode: "4625" },
{ city: "MOUNT STEADMAN", state: "QLD", postcode: "4625" },
{ city: "PENWHAUPELL", state: "QLD", postcode: "4625" },
{ city: "PILE GULLY", state: "QLD", postcode: "4625" },
{ city: "REIDS CREEK", state: "QLD", postcode: "4625" },
{ city: "STOCKHAVEN", state: "QLD", postcode: "4625" },
{ city: "THE LIMITS", state: "QLD", postcode: "4625" },
{ city: "TOONDAHRA", state: "QLD", postcode: "4625" },
{ city: "WAHOON", state: "QLD", postcode: "4625" },
{ city: "WETHERON", state: "QLD", postcode: "4625" },
{ city: "WILSON VALLEY", state: "QLD", postcode: "4625" },
{ city: "WOODMILLAR", state: "QLD", postcode: "4625" },
{ city: "YENDA", state: "QLD", postcode: "4625" },
{ city: "BEERON", state: "QLD", postcode: "4626" },
{ city: "BOYNEWOOD", state: "QLD", postcode: "4626" },
{ city: "BROVINIA", state: "QLD", postcode: "4626" },
{ city: "CATTLE CREEK", state: "QLD", postcode: "4626" },
{ city: "COONAMBULA", state: "QLD", postcode: "4626" },
{ city: "DERRI DERRA", state: "QLD", postcode: "4626" },
{ city: "DYKEHEAD", state: "QLD", postcode: "4626" },
{ city: "GLENRAE", state: "QLD", postcode: "4626" },
{ city: "GURGEENA", state: "QLD", postcode: "4626" },
{ city: "HAWKWOOD", state: "QLD", postcode: "4626" },
{ city: "MONOGORILBY", state: "QLD", postcode: "4626" },
{ city: "MUNDOWRAN", state: "QLD", postcode: "4626" },
{ city: "MUNDUBBERA", state: "QLD", postcode: "4626" },
{ city: "O'BIL BIL", state: "QLD", postcode: "4626" },
{ city: "OLD COORANGA", state: "QLD", postcode: "4626" },
{ city: "PHILPOTT", state: "QLD", postcode: "4626" },
{ city: "RIVERLEIGH", state: "QLD", postcode: "4626" },
{ city: "ABERCORN", state: "QLD", postcode: "4627" },
{ city: "CERATODUS", state: "QLD", postcode: "4627" },
{ city: "CHELTENHAM", state: "QLD", postcode: "4627" },
{ city: "CYNTHIA", state: "QLD", postcode: "4627" },
{ city: "EIDSVOLD", state: "QLD", postcode: "4627" },
{ city: "EIDSVOLD EAST", state: "QLD", postcode: "4627" },
{ city: "EIDSVOLD WEST", state: "QLD", postcode: "4627" },
{ city: "GROSVENOR", state: "QLD", postcode: "4627" },
{ city: "MALMOE", state: "QLD", postcode: "4627" },
{ city: "WURUMA DAM", state: "QLD", postcode: "4627" },
{ city: "BANCROFT", state: "QLD", postcode: "4630" },
{ city: "BUKALI", state: "QLD", postcode: "4630" },
{ city: "CANIA", state: "QLD", postcode: "4630" },
{ city: "CANNINDAH", state: "QLD", postcode: "4630" },
{ city: "COOMINGLAH", state: "QLD", postcode: "4630" },
{ city: "COOMINGLAH FOREST", state: "QLD", postcode: "4630" },
{ city: "DALGA", state: "QLD", postcode: "4630" },
{ city: "GLENLEIGH", state: "QLD", postcode: "4630" },
{ city: "HARRAMI", state: "QLD", postcode: "4630" },
{ city: "KALPOWAR", state: "QLD", postcode: "4630" },
{ city: "KAPALDO", state: "QLD", postcode: "4630" },
{ city: "LANGLEY", state: "QLD", postcode: "4630" },
{ city: "MONAL", state: "QLD", postcode: "4630" },
{ city: "MONTO", state: "QLD", postcode: "4630" },
{ city: "MOONFORD", state: "QLD", postcode: "4630" },
{ city: "MULGILDIE", state: "QLD", postcode: "4630" },
{ city: "MUNGUNGO", state: "QLD", postcode: "4630" },
{ city: "RAWBELLE", state: "QLD", postcode: "4630" },
{ city: "SELENE", state: "QLD", postcode: "4630" },
{ city: "SPLINTER CREEK", state: "QLD", postcode: "4630" },
{ city: "TELLEBANG", state: "QLD", postcode: "4630" },
{ city: "THREE MOON", state: "QLD", postcode: "4630" },
{ city: "VENTNOR", state: "QLD", postcode: "4630" },
{ city: "YARROL", state: "QLD", postcode: "4630" },
{ city: "ALDERSHOT", state: "QLD", postcode: "4650" },
{ city: "ANTIGUA", state: "QLD", postcode: "4650" },
{ city: "BAUPLE", state: "QLD", postcode: "4650" },
{ city: "BAUPLE FOREST", state: "QLD", postcode: "4650" },
{ city: "BEAVER ROCK", state: "QLD", postcode: "4650" },
{ city: "BIDWILL", state: "QLD", postcode: "4650" },
{ city: "BOONOOROO", state: "QLD", postcode: "4650" },
{ city: "BOONOOROO PLAINS", state: "QLD", postcode: "4650" },
{ city: "DUCKINWILLA", state: "QLD", postcode: "4650" },
{ city: "DUNDATHU", state: "QLD", postcode: "4650" },
{ city: "DUNMORA", state: "QLD", postcode: "4650" },
{ city: "FERNEY", state: "QLD", postcode: "4650" },
{ city: "GLENORCHY", state: "QLD", postcode: "4650" },
{ city: "GOOTCHIE", state: "QLD", postcode: "4650" },
{ city: "GRAHAMS CREEK", state: "QLD", postcode: "4650" },
{ city: "GRANVILLE", state: "QLD", postcode: "4650" },
{ city: "GUNDIAH", state: "QLD", postcode: "4650" },
{ city: "ISLAND PLANTATION", state: "QLD", postcode: "4650" },
{ city: "MAAROOM", state: "QLD", postcode: "4650" },
{ city: "MAGNOLIA", state: "QLD", postcode: "4650" },
{ city: "MOUNT URAH", state: "QLD", postcode: "4650" },
{ city: "MUNGAR", state: "QLD", postcode: "4650" },
{ city: "NETHERBY", state: "QLD", postcode: "4650" },
{ city: "OAKHURST", state: "QLD", postcode: "4650" },
{ city: "OWANYILLA", state: "QLD", postcode: "4650" },
{ city: "PILERWA", state: "QLD", postcode: "4650" },
{ city: "PIONEERS REST", state: "QLD", postcode: "4650" },
{ city: "POONA", state: "QLD", postcode: "4650" },
{ city: "PRAWLE", state: "QLD", postcode: "4650" },
{ city: "ST HELENS", state: "QLD", postcode: "4650" },
{ city: "ST MARY", state: "QLD", postcode: "4650" },
{ city: "TALEGALLA WEIR", state: "QLD", postcode: "4650" },
{ city: "TANDORA", state: "QLD", postcode: "4650" },
{ city: "TEDDINGTON", state: "QLD", postcode: "4650" },
{ city: "THE DIMONDS", state: "QLD", postcode: "4650" },
{ city: "THINOOMBA", state: "QLD", postcode: "4650" },
{ city: "TIARO", state: "QLD", postcode: "4650" },
{ city: "TINANA", state: "QLD", postcode: "4650" },
{ city: "TINANA SOUTH", state: "QLD", postcode: "4650" },
{ city: "TINNANBAR", state: "QLD", postcode: "4650" },
{ city: "TUAN", state: "QLD", postcode: "4650" },
{ city: "TUAN FOREST", state: "QLD", postcode: "4650" },
{ city: "WALKERS POINT", state: "QLD", postcode: "4650" },
{ city: "YENGARIE", state: "QLD", postcode: "4650" },
{ city: "YERRA", state: "QLD", postcode: "4650" },
{ city: "BOORAL", state: "QLD", postcode: "4655" },
{ city: "BUNYA CREEK", state: "QLD", postcode: "4655" },
{ city: "CRAIGNISH", state: "QLD", postcode: "4655" },
{ city: "DUNDOWRAN", state: "QLD", postcode: "4655" },
{ city: "DUNDOWRAN BEACH", state: "QLD", postcode: "4655" },
{ city: "ELI WATERS", state: "QLD", postcode: "4655" },
{ city: "GREAT SANDY STRAIT", state: "QLD", postcode: "4655" },
{ city: "HAPPY VALLEY", state: "QLD", postcode: "4655" },
{ city: "KAWUNGAN", state: "QLD", postcode: "4655" },
{ city: "KINGFISHER BAY RESORT", state: "QLD", postcode: "4655" },
{ city: "NIKENBAH", state: "QLD", postcode: "4655" },
{ city: "PIALBA", state: "QLD", postcode: "4655" },
{ city: "POINT VERNON", state: "QLD", postcode: "4655" },
{ city: "RIVER HEADS", state: "QLD", postcode: "4655" },
{ city: "SCARNESS", state: "QLD", postcode: "4655" },
{ city: "SUNSHINE ACRES", state: "QLD", postcode: "4655" },
{ city: "SUSAN RIVER", state: "QLD", postcode: "4655" },
{ city: "TAKURA", state: "QLD", postcode: "4655" },
{ city: "TOOGOOM", state: "QLD", postcode: "4655" },
{ city: "URANGAN", state: "QLD", postcode: "4655" },
{ city: "URRAWEEN", state: "QLD", postcode: "4655" },
{ city: "WALLIEBUM", state: "QLD", postcode: "4655" },
{ city: "WALLIGAN", state: "QLD", postcode: "4655" },
{ city: "WONDUNNA", state: "QLD", postcode: "4655" },
{ city: "BEELBI CREEK", state: "QLD", postcode: "4659" },
{ city: "BURGOWAN", state: "QLD", postcode: "4659" },
{ city: "BURRUM", state: "QLD", postcode: "4659" },
{ city: "BURRUM HEADS", state: "QLD", postcode: "4659" },
{ city: "BURRUM RIVER", state: "QLD", postcode: "4659" },
{ city: "BURRUM TOWN", state: "QLD", postcode: "4659" },
{ city: "HOWARD", state: "QLD", postcode: "4659" },
{ city: "PACIFIC HAVEN", state: "QLD", postcode: "4659" },
{ city: "ABINGTON", state: "QLD", postcode: "4660" },
{ city: "APPLE TREE CREEK", state: "QLD", postcode: "4660" },
{ city: "BUXTON", state: "QLD", postcode: "4660" },
{ city: "CHERWELL", state: "QLD", postcode: "4660" },
{ city: "CORDALBA", state: "QLD", postcode: "4660" },
{ city: "DOOLBI", state: "QLD", postcode: "4660" },
{ city: "EUREKA", state: "QLD", postcode: "4660" },
{ city: "FARNSFIELD", state: "QLD", postcode: "4660" },
{ city: "GOODWOOD", state: "QLD", postcode: "4660" },
{ city: "GREGORY RIVER", state: "QLD", postcode: "4660" },
{ city: "HORTON", state: "QLD", postcode: "4660" },
{ city: "ISIS CENTRAL", state: "QLD", postcode: "4660" },
{ city: "ISIS RIVER", state: "QLD", postcode: "4660" },
{ city: "KULLOGUM", state: "QLD", postcode: "4660" },
{ city: "NORTH GREGORY", state: "QLD", postcode: "4660" },
{ city: "NORTH ISIS", state: "QLD", postcode: "4660" },
{ city: "PROMISEDLAND", state: "QLD", postcode: "4660" },
{ city: "REDRIDGE", state: "QLD", postcode: "4660" },
{ city: "SOUTH ISIS", state: "QLD", postcode: "4660" },
{ city: "WOODGATE", state: "QLD", postcode: "4660" },
{ city: "TORBANLEA", state: "QLD", postcode: "4662" },
{ city: "ABBOTSFORD", state: "QLD", postcode: "4670" },
{ city: "ALLOWAY", state: "QLD", postcode: "4670" },
{ city: "ASHFIELD", state: "QLD", postcode: "4670" },
{ city: "AVENELL HEIGHTS", state: "QLD", postcode: "4670" },
{ city: "AVOCA", state: "QLD", postcode: "4670" },
{ city: "AVONDALE", state: "QLD", postcode: "4670" },
{ city: "BARGARA", state: "QLD", postcode: "4670" },
{ city: "BRANYAN", state: "QLD", postcode: "4670" },
{ city: "BUCCA", state: "QLD", postcode: "4670" },
{ city: "BURNETT HEADS", state: "QLD", postcode: "4670" },
{ city: "CALAVOS", state: "QLD", postcode: "4670" },
{ city: "COONARR", state: "QLD", postcode: "4670" },
{ city: "CORAL COVE", state: "QLD", postcode: "4670" },
{ city: "ELECTRA", state: "QLD", postcode: "4670" },
{ city: "ELLIOTT", state: "QLD", postcode: "4670" },
{ city: "ELLIOTT HEADS", state: "QLD", postcode: "4670" },
{ city: "FAIRYMEAD", state: "QLD", postcode: "4670" },
{ city: "GIVELDA", state: "QLD", postcode: "4670" },
{ city: "GOOBURRUM", state: "QLD", postcode: "4670" },
{ city: "INNES PARK", state: "QLD", postcode: "4670" },
{ city: "KALKIE", state: "QLD", postcode: "4670" },
{ city: "KENSINGTON", state: "QLD", postcode: "4670" },
{ city: "KEPNOCK", state: "QLD", postcode: "4670" },
{ city: "KINKUNA", state: "QLD", postcode: "4670" },
{ city: "MEADOWVALE", state: "QLD", postcode: "4670" },
{ city: "MILLBANK", state: "QLD", postcode: "4670" },
{ city: "MON REPOS", state: "QLD", postcode: "4670" },
{ city: "MOORE PARK BEACH", state: "QLD", postcode: "4670" },
{ city: "MOORLAND", state: "QLD", postcode: "4670" },
{ city: "MULLETT CREEK", state: "QLD", postcode: "4670" },
{ city: "NORVILLE", state: "QLD", postcode: "4670" },
{ city: "OAKWOOD", state: "QLD", postcode: "4670" },
{ city: "PINE CREEK", state: "QLD", postcode: "4670" },
{ city: "QUNABA", state: "QLD", postcode: "4670" },
{ city: "RUBYANNA", state: "QLD", postcode: "4670" },
{ city: "SHARON", state: "QLD", postcode: "4670" },
{ city: "SOUTH BINGERA", state: "QLD", postcode: "4670" },
{ city: "SOUTH KOLAN", state: "QLD", postcode: "4670" },
{ city: "SVENSSON HEIGHTS", state: "QLD", postcode: "4670" },
{ city: "THABEBAN", state: "QLD", postcode: "4670" },
{ city: "WALKERVALE", state: "QLD", postcode: "4670" },
{ city: "WATALGAN", state: "QLD", postcode: "4670" },
{ city: "WELCOME CREEK", state: "QLD", postcode: "4670" },
{ city: "WINDERMERE", state: "QLD", postcode: "4670" },
{ city: "WINFIELD", state: "QLD", postcode: "4670" },
{ city: "WOONGARRA", state: "QLD", postcode: "4670" },
{ city: "BAFFLE CREEK", state: "QLD", postcode: "4674" },
{ city: "BERAJONDO", state: "QLD", postcode: "4674" },
{ city: "DEEPWATER", state: "QLD", postcode: "4674" },
{ city: "EULEILAH", state: "QLD", postcode: "4674" },
{ city: "MOUNT MARIA", state: "QLD", postcode: "4674" },
{ city: "OYSTER CREEK", state: "QLD", postcode: "4674" },
{ city: "ROSEDALE", state: "QLD", postcode: "4674" },
{ city: "RULES BEACH", state: "QLD", postcode: "4674" },
{ city: "TAUNTON", state: "QLD", postcode: "4674" },
{ city: "GINDORAN", state: "QLD", postcode: "4676" },
{ city: "LOWMEAD", state: "QLD", postcode: "4676" },
{ city: "AGNES WATER", state: "QLD", postcode: "4677" },
{ city: "CAPTAIN CREEK", state: "QLD", postcode: "4677" },
{ city: "COLOSSEUM", state: "QLD", postcode: "4677" },
{ city: "EURIMBULA", state: "QLD", postcode: "4677" },
{ city: "MIRIAM VALE", state: "QLD", postcode: "4677" },
{ city: "MOUNT TOM", state: "QLD", postcode: "4677" },
{ city: "ROUND HILL", state: "QLD", postcode: "4677" },
{ city: "SEVENTEEN SEVENTY", state: "QLD", postcode: "4677" },
{ city: "BOROREN", state: "QLD", postcode: "4678" },
{ city: "FORESHORES", state: "QLD", postcode: "4678" },
{ city: "RODDS BAY", state: "QLD", postcode: "4678" },
{ city: "TURKEY BEACH", state: "QLD", postcode: "4678" },
{ city: "BARNEY POINT", state: "QLD", postcode: "4680" },
{ city: "BEECHER", state: "QLD", postcode: "4680" },
{ city: "BENARABY", state: "QLD", postcode: "4680" },
{ city: "BOYNEDALE", state: "QLD", postcode: "4680" },
{ city: "BOYNE ISLAND", state: "QLD", postcode: "4680" },
{ city: "BOYNE VALLEY", state: "QLD", postcode: "4680" },
{ city: "BUILYAN", state: "QLD", postcode: "4680" },
{ city: "BURUA", state: "QLD", postcode: "4680" },
{ city: "BYELLEE", state: "QLD", postcode: "4680" },
{ city: "CALLEMONDAH", state: "QLD", postcode: "4680" },
{ city: "CALLIOPE", state: "QLD", postcode: "4680" },
{ city: "CLINTON", state: "QLD", postcode: "4680" },
{ city: "CURTIS ISLAND", state: "QLD", postcode: "4680" },
{ city: "DIGLUM", state: "QLD", postcode: "4680" },
{ city: "GLEN EDEN", state: "QLD", postcode: "4680" },
{ city: "HERON ISLAND", state: "QLD", postcode: "4680" },
{ city: "IVERAGH", state: "QLD", postcode: "4680" },
{ city: "KIN KORA", state: "QLD", postcode: "4680" },
{ city: "KIRKWOOD", state: "QLD", postcode: "4680" },
{ city: "MANY PEAKS", state: "QLD", postcode: "4680" },
{ city: "MOUNT ALMA", state: "QLD", postcode: "4680" },
{ city: "NAGOORIN", state: "QLD", postcode: "4680" },
{ city: "NEW AUCKLAND", state: "QLD", postcode: "4680" },
{ city: "O'CONNELL", state: "QLD", postcode: "4680" },
{ city: "RIVER RANCH", state: "QLD", postcode: "4680" },
{ city: "SOUTH END", state: "QLD", postcode: "4680" },
{ city: "SOUTH TREES", state: "QLD", postcode: "4680" },
{ city: "SUN VALLEY", state: "QLD", postcode: "4680" },
{ city: "TABLELANDS", state: "QLD", postcode: "4680" },
{ city: "TARAGOOLA", state: "QLD", postcode: "4680" },
{ city: "TELINA", state: "QLD", postcode: "4680" },
{ city: "TOOLOOA", state: "QLD", postcode: "4680" },
{ city: "UBOBO", state: "QLD", postcode: "4680" },
{ city: "WEST STOWE", state: "QLD", postcode: "4680" },
{ city: "WOODERSON", state: "QLD", postcode: "4680" },
{ city: "WURDONG HEIGHTS", state: "QLD", postcode: "4680" },
{ city: "ALDOGA", state: "QLD", postcode: "4694" },
{ city: "TARGINIE", state: "QLD", postcode: "4694" },
{ city: "TARGINNIE", state: "QLD", postcode: "4694" },
{ city: "YARWUN", state: "QLD", postcode: "4694" },
{ city: "AMBROSE", state: "QLD", postcode: "4695" },
{ city: "BRACEWELL", state: "QLD", postcode: "4695" },
{ city: "DARTS CREEK", state: "QLD", postcode: "4695" },
{ city: "EAST END", state: "QLD", postcode: "4695" },
{ city: "MACHINE CREEK", state: "QLD", postcode: "4695" },
{ city: "MOUNT LARCOM", state: "QLD", postcode: "4695" },
{ city: "THE NARROWS", state: "QLD", postcode: "4695" },
{ city: "BAJOOL", state: "QLD", postcode: "4699" },
{ city: "PORT ALMA", state: "QLD", postcode: "4699" },
{ city: "ALLENSTOWN", state: "QLD", postcode: "4700" },
{ city: "DEPOT HILL", state: "QLD", postcode: "4700" },
{ city: "FAIRY BOWER", state: "QLD", postcode: "4700" },
{ city: "GREAT KEPPEL ISLAND", state: "QLD", postcode: "4700" },
{ city: "PORT CURTIS", state: "QLD", postcode: "4700" },
{ city: "THE KEPPELS", state: "QLD", postcode: "4700" },
{ city: "THE RANGE", state: "QLD", postcode: "4700" },
{ city: "WANDAL", state: "QLD", postcode: "4700" },
{ city: "BERSERKER", state: "QLD", postcode: "4701" },
{ city: "FRENCHVILLE", state: "QLD", postcode: "4701" },
{ city: "GREENLAKE", state: "QLD", postcode: "4701" },
{ city: "IRONPOT", state: "QLD", postcode: "4701" },
{ city: "KAWANA", state: "QLD", postcode: "4701" },
{ city: "KOONGAL", state: "QLD", postcode: "4701" },
{ city: "LAKES CREEK", state: "QLD", postcode: "4701" },
{ city: "LIMESTONE CREEK", state: "QLD", postcode: "4701" },
{ city: "MOUNT ARCHER", state: "QLD", postcode: "4701" },
{ city: "NANKIN", state: "QLD", postcode: "4701" },
{ city: "NERIMBERA", state: "QLD", postcode: "4701" },
{ city: "NORMAN GARDENS", state: "QLD", postcode: "4701" },
{ city: "ROCKYVIEW", state: "QLD", postcode: "4701" },
{ city: "SANDRINGHAM", state: "QLD", postcode: "4701" },
{ city: "THE COMMON", state: "QLD", postcode: "4701" },
{ city: "ALBERTA", state: "QLD", postcode: "4702" },
{ city: "ALSACE", state: "QLD", postcode: "4702" },
{ city: "ALTON DOWNS", state: "QLD", postcode: "4702" },
{ city: "ANAKIE", state: "QLD", postcode: "4702" },
{ city: "ARGOON", state: "QLD", postcode: "4702" },
{ city: "BALCOMBA", state: "QLD", postcode: "4702" },
{ city: "BANANA", state: "QLD", postcode: "4702" },
{ city: "BARALABA", state: "QLD", postcode: "4702" },
{ city: "BARNARD", state: "QLD", postcode: "4702" },
{ city: "BINGEGANG", state: "QLD", postcode: "4702" },
{ city: "BLACKDOWN", state: "QLD", postcode: "4702" },
{ city: "BLUFF", state: "QLD", postcode: "4702" },
{ city: "BOOLBURRA", state: "QLD", postcode: "4702" },
{ city: "BOULDERCOMBE", state: "QLD", postcode: "4702" },
{ city: "BUSHLEY", state: "QLD", postcode: "4702" },
{ city: "CANAL CREEK", state: "QLD", postcode: "4702" },
{ city: "CANOONA", state: "QLD", postcode: "4702" },
{ city: "CAWARRAL", state: "QLD", postcode: "4702" },
{ city: "CENTRAL QUEENSLAND MC", state: "QLD", postcode: "4702" },
{ city: "COMET", state: "QLD", postcode: "4702" },
{ city: "CONSUELO", state: "QLD", postcode: "4702" },
{ city: "COOMOO", state: "QLD", postcode: "4702" },
{ city: "COOROOMAN", state: "QLD", postcode: "4702" },
{ city: "COORUMBENE", state: "QLD", postcode: "4702" },
{ city: "COOWONGA", state: "QLD", postcode: "4702" },
{ city: "DALMA", state: "QLD", postcode: "4702" },
{ city: "DINGO", state: "QLD", postcode: "4702" },
{ city: "DIXALEA", state: "QLD", postcode: "4702" },
{ city: "DULULU", state: "QLD", postcode: "4702" },
{ city: "DUMPY CREEK", state: "QLD", postcode: "4702" },
{ city: "ETNA CREEK", state: "QLD", postcode: "4702" },
{ city: "FERNLEES", state: "QLD", postcode: "4702" },
{ city: "GAINSFORD", state: "QLD", postcode: "4702" },
{ city: "GARNANT", state: "QLD", postcode: "4702" },
{ city: "GINDIE", state: "QLD", postcode: "4702" },
{ city: "GLENROY", state: "QLD", postcode: "4702" },
{ city: "GOGANGO", state: "QLD", postcode: "4702" },
{ city: "GOOMALLY", state: "QLD", postcode: "4702" },
{ city: "GOOVIGEN", state: "QLD", postcode: "4702" },
{ city: "GOOWARRA", state: "QLD", postcode: "4702" },
{ city: "GRACEMERE", state: "QLD", postcode: "4702" },
{ city: "HUMBOLDT", state: "QLD", postcode: "4702" },
{ city: "JAMBIN", state: "QLD", postcode: "4702" },
{ city: "JARDINE", state: "QLD", postcode: "4702" },
{ city: "JELLINBAH", state: "QLD", postcode: "4702" },
{ city: "JOSKELEIGH", state: "QLD", postcode: "4702" },
{ city: "KABRA", state: "QLD", postcode: "4702" },
{ city: "KALAPA", state: "QLD", postcode: "4702" },
{ city: "KEPPEL SANDS", state: "QLD", postcode: "4702" },
{ city: "KOKOTUNGO", state: "QLD", postcode: "4702" },
{ city: "KUNWARARA", state: "QLD", postcode: "4702" },
{ city: "LOWESBY", state: "QLD", postcode: "4702" },
{ city: "MACKENZIE", state: "QLD", postcode: "4702" },
{ city: "MARMOR", state: "QLD", postcode: "4702" },
{ city: "MIDGEE", state: "QLD", postcode: "4702" },
{ city: "MILMAN", state: "QLD", postcode: "4702" },
{ city: "MIMOSA", state: "QLD", postcode: "4702" },
{ city: "MOONMERA", state: "QLD", postcode: "4702" },
{ city: "MORINISH", state: "QLD", postcode: "4702" },
{ city: "MORINISH SOUTH", state: "QLD", postcode: "4702" },
{ city: "MOUNT CHALMERS", state: "QLD", postcode: "4702" },
{ city: "NINE MILE", state: "QLD", postcode: "4702" },
{ city: "PARKHURST", state: "QLD", postcode: "4702" },
{ city: "PHEASANT CREEK", state: "QLD", postcode: "4702" },
{ city: "PINK LILY", state: "QLD", postcode: "4702" },
{ city: "PLUM TREE", state: "QLD", postcode: "4702" },
{ city: "RIDGELANDS", state: "QLD", postcode: "4702" },
{ city: "ROLLESTON", state: "QLD", postcode: "4702" },
{ city: "ROSSMOYA", state: "QLD", postcode: "4702" },
{ city: "RUBYVALE", state: "QLD", postcode: "4702" },
{ city: "SAPPHIRE", state: "QLD", postcode: "4702" },
{ city: "SHOALWATER", state: "QLD", postcode: "4702" },
{ city: "SMOKY CREEK", state: "QLD", postcode: "4702" },
{ city: "SOUTH YAAMBA", state: "QLD", postcode: "4702" },
{ city: "STANAGE", state: "QLD", postcode: "4702" },
{ city: "STANWELL", state: "QLD", postcode: "4702" },
{ city: "STEWARTON", state: "QLD", postcode: "4702" },
{ city: "THE CAVES", state: "QLD", postcode: "4702" },
{ city: "THE GEMFIELDS", state: "QLD", postcode: "4702" },
{ city: "THOMPSON POINT", state: "QLD", postcode: "4702" },
{ city: "TUNGAMULL", state: "QLD", postcode: "4702" },
{ city: "ULOGIE", state: "QLD", postcode: "4702" },
{ city: "WALLAROO", state: "QLD", postcode: "4702" },
{ city: "WESTWOOD", state: "QLD", postcode: "4702" },
{ city: "WILLOWS", state: "QLD", postcode: "4702" },
{ city: "WILLOWS GEMFIELDS", state: "QLD", postcode: "4702" },
{ city: "WOOLEIN", state: "QLD", postcode: "4702" },
{ city: "WOOROONA", state: "QLD", postcode: "4702" },
{ city: "WOWAN", state: "QLD", postcode: "4702" },
{ city: "WYCARBAH", state: "QLD", postcode: "4702" },
{ city: "YARAKA", state: "QLD", postcode: "4702" },
{ city: "ADELAIDE PARK", state: "QLD", postcode: "4703" },
{ city: "BANGALEE", state: "QLD", postcode: "4703" },
{ city: "BARLOWS HILL", state: "QLD", postcode: "4703" },
{ city: "BARMARYEE", state: "QLD", postcode: "4703" },
{ city: "BARMOYA", state: "QLD", postcode: "4703" },
{ city: "BONDOOLA", state: "QLD", postcode: "4703" },
{ city: "BUNGUNDARRA", state: "QLD", postcode: "4703" },
{ city: "BYFIELD", state: "QLD", postcode: "4703" },
{ city: "CAUSEWAY LAKE", state: "QLD", postcode: "4703" },
{ city: "COBRABALL", state: "QLD", postcode: "4703" },
{ city: "COOEE BAY", state: "QLD", postcode: "4703" },
{ city: "FARNBOROUGH", state: "QLD", postcode: "4703" },
{ city: "HIDDEN VALLEY", state: "QLD", postcode: "4703" },
{ city: "INVERNESS", state: "QLD", postcode: "4703" },
{ city: "KINKA BEACH", state: "QLD", postcode: "4703" },
{ city: "LAKE MARY", state: "QLD", postcode: "4703" },
{ city: "LAMMERMOOR", state: "QLD", postcode: "4703" },
{ city: "MARYVALE", state: "QLD", postcode: "4703" },
{ city: "MEIKLEVILLE HILL", state: "QLD", postcode: "4703" },
{ city: "MULAMBIN", state: "QLD", postcode: "4703" },
{ city: "MULARA", state: "QLD", postcode: "4703" },
{ city: "PACIFIC HEIGHTS", state: "QLD", postcode: "4703" },
{ city: "ROSSLYN", state: "QLD", postcode: "4703" },
{ city: "STOCKYARD", state: "QLD", postcode: "4703" },
{ city: "TANBY", state: "QLD", postcode: "4703" },
{ city: "TARANGANBA", state: "QLD", postcode: "4703" },
{ city: "TAROOMBALL", state: "QLD", postcode: "4703" },
{ city: "WEERRIBA", state: "QLD", postcode: "4703" },
{ city: "WOODBURY", state: "QLD", postcode: "4703" },
{ city: "WATTLEBANK", state: "QLD", postcode: "4704" },
{ city: "YAAMBA", state: "QLD", postcode: "4704" },
{ city: "CLARKE CREEK", state: "QLD", postcode: "4705" },
{ city: "LOTUS CREEK", state: "QLD", postcode: "4705" },
{ city: "MACKENZIE RIVER", state: "QLD", postcode: "4705" },
{ city: "MARLBOROUGH", state: "QLD", postcode: "4705" },
{ city: "MOUNT GARDINER", state: "QLD", postcode: "4705" },
{ city: "OGMORE", state: "QLD", postcode: "4706" },
{ city: "COLLAROY", state: "QLD", postcode: "4707" },
{ city: "ST LAWRENCE", state: "QLD", postcode: "4707" },
{ city: "THE PERCY GROUP", state: "QLD", postcode: "4707" },
{ city: "TIERI", state: "QLD", postcode: "4709" },
{ city: "EMU PARK", state: "QLD", postcode: "4710" },
{ city: "ZILZIE", state: "QLD", postcode: "4710" },
{ city: "GLENDALE", state: "QLD", postcode: "4711" },
{ city: "GLENLEE", state: "QLD", postcode: "4711" },
{ city: "DUARINGA", state: "QLD", postcode: "4712" },
{ city: "WOORABINDA", state: "QLD", postcode: "4713" },
{ city: "BAREE", state: "QLD", postcode: "4714" },
{ city: "BOULDER CREEK", state: "QLD", postcode: "4714" },
{ city: "FLETCHER CREEK", state: "QLD", postcode: "4714" },
{ city: "HAMILTON CREEK", state: "QLD", postcode: "4714" },
{ city: "HORSE CREEK", state: "QLD", postcode: "4714" },
{ city: "JOHNSONS HILL", state: "QLD", postcode: "4714" },
{ city: "LEYDENS HILL", state: "QLD", postcode: "4714" },
{ city: "LIMESTONE", state: "QLD", postcode: "4714" },
{ city: "MOONGAN", state: "QLD", postcode: "4714" },
{ city: "MOUNT MORGAN", state: "QLD", postcode: "4714" },
{ city: "NINE MILE CREEK", state: "QLD", postcode: "4714" },
{ city: "OAKEY CREEK", state: "QLD", postcode: "4714" },
{ city: "STRUCK OIL", state: "QLD", postcode: "4714" },
{ city: "THE MINE", state: "QLD", postcode: "4714" },
{ city: "TROTTER CREEK", state: "QLD", postcode: "4714" },
{ city: "WALMUL", state: "QLD", postcode: "4714" },
{ city: "WALTERHALL", state: "QLD", postcode: "4714" },
{ city: "WURA", state: "QLD", postcode: "4714" },
{ city: "BILOELA", state: "QLD", postcode: "4715" },
{ city: "CALLIDE", state: "QLD", postcode: "4715" },
{ city: "CASTLE CREEK", state: "QLD", postcode: "4715" },
{ city: "DAKENBA", state: "QLD", postcode: "4715" },
{ city: "DUMGREE", state: "QLD", postcode: "4715" },
{ city: "GREYCLIFFE", state: "QLD", postcode: "4715" },
{ city: "MOUNT MURCHISON", state: "QLD", postcode: "4715" },
{ city: "ORANGE CREEK", state: "QLD", postcode: "4715" },
{ city: "PROSPECT", state: "QLD", postcode: "4715" },
{ city: "TARRAMBA", state: "QLD", postcode: "4715" },
{ city: "VALENTINE PLAINS", state: "QLD", postcode: "4715" },
{ city: "LAWGI DAWES", state: "QLD", postcode: "4716" },
{ city: "THANGOOL", state: "QLD", postcode: "4716" },
{ city: "BLACKWATER", state: "QLD", postcode: "4717" },
{ city: "BAUHINIA", state: "QLD", postcode: "4718" },
{ city: "DROMEDARY", state: "QLD", postcode: "4718" },
{ city: "KIANGA", state: "QLD", postcode: "4718" },
{ city: "MOURA", state: "QLD", postcode: "4718" },
{ city: "MUNGABUNDA", state: "QLD", postcode: "4718" },
{ city: "OOMBABEER", state: "QLD", postcode: "4718" },
{ city: "RHYDDING", state: "QLD", postcode: "4718" },
{ city: "ROUNDSTONE", state: "QLD", postcode: "4718" },
{ city: "WARNOAH", state: "QLD", postcode: "4718" },
{ city: "CAMBOON", state: "QLD", postcode: "4719" },
{ city: "CRACOW", state: "QLD", postcode: "4719" },
{ city: "GLENMORAL", state: "QLD", postcode: "4719" },
{ city: "ISLA", state: "QLD", postcode: "4719" },
{ city: "LONESOME CREEK", state: "QLD", postcode: "4719" },
{ city: "THEODORE", state: "QLD", postcode: "4719" },
{ city: "EMERALD", state: "QLD", postcode: "4720" },
{ city: "YAMALA", state: "QLD", postcode: "4720" },
{ city: "ARGYLL", state: "QLD", postcode: "4721" },
{ city: "CLERMONT", state: "QLD", postcode: "4721" },
{ city: "ELGIN", state: "QLD", postcode: "4721" },
{ city: "FRANKFIELD", state: "QLD", postcode: "4721" },
{ city: "GEMINI MOUNTAINS", state: "QLD", postcode: "4721" },
{ city: "KILCUMMIN", state: "QLD", postcode: "4721" },
{ city: "LAGLAN", state: "QLD", postcode: "4721" },
{ city: "MISTAKE CREEK", state: "QLD", postcode: "4721" },
{ city: "PASHA", state: "QLD", postcode: "4721" },
{ city: "THERESA CREEK", state: "QLD", postcode: "4721" },
{ city: "WINCHESTER", state: "QLD", postcode: "4721" },
{ city: "WOLFANG", state: "QLD", postcode: "4721" },
{ city: "ALBINIA", state: "QLD", postcode: "4722" },
{ city: "ARCTURUS", state: "QLD", postcode: "4722" },
{ city: "BUCKLAND", state: "QLD", postcode: "4722" },
{ city: "CAIRDBEIGN", state: "QLD", postcode: "4722" },
{ city: "CONA CREEK", state: "QLD", postcode: "4722" },
{ city: "NANDOWRIE", state: "QLD", postcode: "4722" },
{ city: "ORION", state: "QLD", postcode: "4722" },
{ city: "SPRINGSURE", state: "QLD", postcode: "4722" },
{ city: "WEALWANDANGIE", state: "QLD", postcode: "4722" },
{ city: "BELCONG", state: "QLD", postcode: "4723" },
{ city: "CAPELLA", state: "QLD", postcode: "4723" },
{ city: "CARBINE CREEK", state: "QLD", postcode: "4723" },
{ city: "CHIRNSIDE", state: "QLD", postcode: "4723" },
{ city: "CRINUM", state: "QLD", postcode: "4723" },
{ city: "HIBERNIA", state: "QLD", postcode: "4723" },
{ city: "KHOSH BULDUK", state: "QLD", postcode: "4723" },
{ city: "LILYVALE", state: "QLD", postcode: "4723" },
{ city: "LOWESTOFF", state: "QLD", postcode: "4723" },
{ city: "MOUNT MACARTHUR", state: "QLD", postcode: "4723" },
{ city: "RETRO", state: "QLD", postcode: "4723" },
{ city: "ALPHA", state: "QLD", postcode: "4724" },
{ city: "BEAUFORT", state: "QLD", postcode: "4724" },
{ city: "DRUMMONDSLOPE", state: "QLD", postcode: "4724" },
{ city: "PINE HILL", state: "QLD", postcode: "4724" },
{ city: "PORT WINE", state: "QLD", postcode: "4724" },
{ city: "SEDGEFORD", state: "QLD", postcode: "4724" },
{ city: "SURBITON", state: "QLD", postcode: "4724" },
{ city: "BARCALDINE", state: "QLD", postcode: "4725" },
{ city: "BARCALDINE DOWNS", state: "QLD", postcode: "4725" },
{ city: "PATRICK", state: "QLD", postcode: "4725" },
{ city: "TARA STATION", state: "QLD", postcode: "4725" },
{ city: "ARAMAC", state: "QLD", postcode: "4726" },
{ city: "GALILEE", state: "QLD", postcode: "4726" },
{ city: "PELICAN CREEK", state: "QLD", postcode: "4726" },
{ city: "ILFRACOMBE", state: "QLD", postcode: "4727" },
{ city: "DUNROBIN", state: "QLD", postcode: "4728" },
{ city: "GARFIELD", state: "QLD", postcode: "4728" },
{ city: "JERICHO", state: "QLD", postcode: "4728" },
{ city: "MEXICO", state: "QLD", postcode: "4728" },
{ city: "CAMOOLA", state: "QLD", postcode: "4730" },
{ city: "CHORREGON", state: "QLD", postcode: "4730" },
{ city: "ERNESTINA", state: "QLD", postcode: "4730" },
{ city: "LONGREACH", state: "QLD", postcode: "4730" },
{ city: "MANEROO", state: "QLD", postcode: "4730" },
{ city: "MORELLA", state: "QLD", postcode: "4730" },
{ city: "STONEHENGE", state: "QLD", postcode: "4730" },
{ city: "TOCAL", state: "QLD", postcode: "4730" },
{ city: "VERGEMONT", state: "QLD", postcode: "4730" },
{ city: "ISISFORD", state: "QLD", postcode: "4731" },
{ city: "MUTTABURRA", state: "QLD", postcode: "4732" },
{ city: "TABLEDERRY", state: "QLD", postcode: "4732" },
{ city: "CORFIELD", state: "QLD", postcode: "4733" },
{ city: "DIAMANTINA LAKES", state: "QLD", postcode: "4735" },
{ city: "MIDDLETON", state: "QLD", postcode: "4735" },
{ city: "OPALTON", state: "QLD", postcode: "4735" },
{ city: "WINTON", state: "QLD", postcode: "4735" },
{ city: "JUNDAH", state: "QLD", postcode: "4736" },
{ city: "ARMSTRONG BEACH", state: "QLD", postcode: "4737" },
{ city: "BLUE MOUNTAIN", state: "QLD", postcode: "4737" },
{ city: "CAMPWIN BEACH", state: "QLD", postcode: "4737" },
{ city: "FRESHWATER POINT", state: "QLD", postcode: "4737" },
{ city: "SUNNYSIDE", state: "QLD", postcode: "4737" },
{ city: "ILBILBIE", state: "QLD", postcode: "4738" },
{ city: "KOUMALA", state: "QLD", postcode: "4738" },
{ city: "CARMILA", state: "QLD", postcode: "4739" },
{ city: "ALEXANDRA", state: "QLD", postcode: "4740" },
{ city: "ALLIGATOR CREEK", state: "QLD", postcode: "4740" },
{ city: "ANDERGROVE", state: "QLD", postcode: "4740" },
{ city: "BAKERS CREEK", state: "QLD", postcode: "4740" },
{ city: "BALBERRA", state: "QLD", postcode: "4740" },
{ city: "BALNAGOWAN", state: "QLD", postcode: "4740" },
{ city: "BEACONSFIELD", state: "QLD", postcode: "4740" },
{ city: "BELMUNDA", state: "QLD", postcode: "4740" },
{ city: "BLACKS BEACH", state: "QLD", postcode: "4740" },
{ city: "CAPE HILLSBOROUGH", state: "QLD", postcode: "4740" },
{ city: "CHELONA", state: "QLD", postcode: "4740" },
{ city: "CONINGSBY", state: "QLD", postcode: "4740" },
{ city: "CREMORNE", state: "QLD", postcode: "4740" },
{ city: "DOLPHIN HEADS", state: "QLD", postcode: "4740" },
{ city: "DUMBLETON", state: "QLD", postcode: "4740" },
{ city: "DUNDULA", state: "QLD", postcode: "4740" },
{ city: "DUNNROCK", state: "QLD", postcode: "4740" },
{ city: "EIMEO", state: "QLD", postcode: "4740" },
{ city: "ERAKALA", state: "QLD", postcode: "4740" },
{ city: "FOULDEN", state: "QLD", postcode: "4740" },
{ city: "GLENELLA", state: "QLD", postcode: "4740" },
{ city: "GRASSTREE BEACH", state: "QLD", postcode: "4740" },
{ city: "HABANA", state: "QLD", postcode: "4740" },
{ city: "HALIDAY BAY", state: "QLD", postcode: "4740" },
{ city: "HAY POINT", state: "QLD", postcode: "4740" },
{ city: "HOMEBUSH", state: "QLD", postcode: "4740" },
{ city: "MCEWENS BEACH", state: "QLD", postcode: "4740" },
{ city: "MOUNT JUKES", state: "QLD", postcode: "4740" },
{ city: "MOUNT PLEASANT", state: "QLD", postcode: "4740" },
{ city: "MUNBURA", state: "QLD", postcode: "4740" },
{ city: "NINDAROO", state: "QLD", postcode: "4740" },
{ city: "OORALEA", state: "QLD", postcode: "4740" },
{ city: "RACECOURSE", state: "QLD", postcode: "4740" },
{ city: "RICHMOND", state: "QLD", postcode: "4740" },
{ city: "ROSELLA", state: "QLD", postcode: "4740" },
{ city: "RURAL VIEW", state: "QLD", postcode: "4740" },
{ city: "SANDIFORD", state: "QLD", postcode: "4740" },
{ city: "SLADE POINT", state: "QLD", postcode: "4740" },
{ city: "TE KOWAI", state: "QLD", postcode: "4740" },
{ city: "THE LEAP", state: "QLD", postcode: "4740" },
{ city: "BALL BAY", state: "QLD", postcode: "4741" },
{ city: "BRIGHTLY", state: "QLD", postcode: "4741" },
{ city: "CLAIRVIEW", state: "QLD", postcode: "4741" },
{ city: "COPPABELLA", state: "QLD", postcode: "4741" },
{ city: "DAYDREAM ISLAND", state: "QLD", postcode: "4741" },
{ city: "EPSOM", state: "QLD", postcode: "4741" },
{ city: "ETON", state: "QLD", postcode: "4741" },
{ city: "ETON NORTH", state: "QLD", postcode: "4741" },
{ city: "EUNGELLA HINTERLAND", state: "QLD", postcode: "4741" },
{ city: "FARLEIGH", state: "QLD", postcode: "4741" },
{ city: "GARGETT", state: "QLD", postcode: "4741" },
{ city: "HAMPDEN", state: "QLD", postcode: "4741" },
{ city: "HAZLEDEAN", state: "QLD", postcode: "4741" },
{ city: "HOOK ISLAND", state: "QLD", postcode: "4741" },
{ city: "KALARKA", state: "QLD", postcode: "4741" },
{ city: "KINCHANT DAM", state: "QLD", postcode: "4741" },
{ city: "KUTTABUL", state: "QLD", postcode: "4741" },
{ city: "LINDEMAN ISLAND", state: "QLD", postcode: "4741" },
{ city: "LONG ISLAND", state: "QLD", postcode: "4741" },
{ city: "MOUNT CHARLTON", state: "QLD", postcode: "4741" },
{ city: "MOUNT OSSA", state: "QLD", postcode: "4741" },
{ city: "MOUNT PELION", state: "QLD", postcode: "4741" },
{ city: "NORTH ETON", state: "QLD", postcode: "4741" },
{ city: "OAKENDEN", state: "QLD", postcode: "4741" },
{ city: "ORKABIE", state: "QLD", postcode: "4741" },
{ city: "OWENS CREEK", state: "QLD", postcode: "4741" },
{ city: "PINNACLE", state: "QLD", postcode: "4741" },
{ city: "PLEYSTOWE", state: "QLD", postcode: "4741" },
{ city: "SEAFORTH", state: "QLD", postcode: "4741" },
{ city: "SOUTH MOLLE", state: "QLD", postcode: "4741" },
{ city: "YALBOROO", state: "QLD", postcode: "4741" },
{ city: "BURTON", state: "QLD", postcode: "4742" },
{ city: "EAGLEFIELD", state: "QLD", postcode: "4742" },
{ city: "ELPHINSTONE", state: "QLD", postcode: "4742" },
{ city: "HAIL CREEK", state: "QLD", postcode: "4742" },
{ city: "KEMMIS", state: "QLD", postcode: "4742" },
{ city: "MOUNT BRITTON", state: "QLD", postcode: "4742" },
{ city: "NEBO", state: "QLD", postcode: "4742" },
{ city: "OXFORD", state: "QLD", postcode: "4742" },
{ city: "STRATHFIELD", state: "QLD", postcode: "4742" },
{ city: "TURRAWULLA", state: "QLD", postcode: "4742" },
{ city: "VALKYRIE", state: "QLD", postcode: "4742" },
{ city: "GLENDEN", state: "QLD", postcode: "4743" },
{ city: "SUTTOR", state: "QLD", postcode: "4743" },
{ city: "MORANBAH", state: "QLD", postcode: "4744" },
{ city: "DYSART", state: "QLD", postcode: "4745" },
{ city: "MAY DOWNS", state: "QLD", postcode: "4746" },
{ city: "MIDDLEMOUNT", state: "QLD", postcode: "4746" },
{ city: "BUCASIA", state: "QLD", postcode: "4750" },
{ city: "SHOAL POINT", state: "QLD", postcode: "4750" },
{ city: "GREENMOUNT", state: "QLD", postcode: "4751" },
{ city: "PALMYRA", state: "QLD", postcode: "4751" },
{ city: "VICTORIA PLAINS", state: "QLD", postcode: "4751" },
{ city: "WALKERSTON", state: "QLD", postcode: "4751" },
{ city: "DEVEREUX CREEK", state: "QLD", postcode: "4753" },
{ city: "MARIAN", state: "QLD", postcode: "4753" },
{ city: "BENHOLME", state: "QLD", postcode: "4754" },
{ city: "DOWS CREEK", state: "QLD", postcode: "4754" },
{ city: "MIA MIA", state: "QLD", postcode: "4754" },
{ city: "MIRANI", state: "QLD", postcode: "4754" },
{ city: "MOUNT MARTIN", state: "QLD", postcode: "4754" },
{ city: "PINEVALE", state: "QLD", postcode: "4754" },
{ city: "SEPTIMUS", state: "QLD", postcode: "4754" },
{ city: "FINCH HATTON", state: "QLD", postcode: "4756" },
{ city: "NETHERDALE", state: "QLD", postcode: "4756" },
{ city: "BROKEN RIVER", state: "QLD", postcode: "4757" },
{ city: "CREDITON", state: "QLD", postcode: "4757" },
{ city: "DALRYMPLE HEIGHTS", state: "QLD", postcode: "4757" },
{ city: "EUNGELLA", state: "QLD", postcode: "4757" },
{ city: "EUNGELLA DAM", state: "QLD", postcode: "4757" },
{ city: "CALEN", state: "QLD", postcode: "4798" },
{ city: "MENTMORE", state: "QLD", postcode: "4798" },
{ city: "PINDI PINDI", state: "QLD", postcode: "4798" },
{ city: "ST HELENS BEACH", state: "QLD", postcode: "4798" },
{ city: "BLOOMSBURY", state: "QLD", postcode: "4799" },
{ city: "MIDGE POINT", state: "QLD", postcode: "4799" },
{ city: "ANDROMACHE", state: "QLD", postcode: "4800" },
{ city: "BRANDY CREEK", state: "QLD", postcode: "4800" },
{ city: "BREADALBANE", state: "QLD", postcode: "4800" },
{ city: "CANNON VALLEY", state: "QLD", postcode: "4800" },
{ city: "CAPE CONWAY", state: "QLD", postcode: "4800" },
{ city: "CAPE GLOUCESTER", state: "QLD", postcode: "4800" },
{ city: "CONWAY", state: "QLD", postcode: "4800" },
{ city: "CONWAY BEACH", state: "QLD", postcode: "4800" },
{ city: "CRYSTAL BROOK", state: "QLD", postcode: "4800" },
{ city: "DINGO BEACH", state: "QLD", postcode: "4800" },
{ city: "DITTMER", state: "QLD", postcode: "4800" },
{ city: "FOXDALE", state: "QLD", postcode: "4800" },
{ city: "GLEN ISLA", state: "QLD", postcode: "4800" },
{ city: "GOORGANGA CREEK", state: "QLD", postcode: "4800" },
{ city: "GOORGANGA PLAINS", state: "QLD", postcode: "4800" },
{ city: "GREGORY RIVER", state: "QLD", postcode: "4800" },
{ city: "GUNYARRA", state: "QLD", postcode: "4800" },
{ city: "HAMILTON PLAINS", state: "QLD", postcode: "4800" },
{ city: "HIDEAWAY BAY", state: "QLD", postcode: "4800" },
{ city: "KELSEY CREEK", state: "QLD", postcode: "4800" },
{ city: "LAGUNA QUAYS", state: "QLD", postcode: "4800" },
{ city: "LAKE PROSERPINE", state: "QLD", postcode: "4800" },
{ city: "LETHEBROOK", state: "QLD", postcode: "4800" },
{ city: "MOUNT JULIAN", state: "QLD", postcode: "4800" },
{ city: "MOUNT MARLOW", state: "QLD", postcode: "4800" },
{ city: "MOUNT PLUTO", state: "QLD", postcode: "4800" },
{ city: "MYRTLEVALE", state: "QLD", postcode: "4800" },
{ city: "NORTH GREGORY", state: "QLD", postcode: "4800" },
{ city: "PALM GROVE", state: "QLD", postcode: "4800" },
{ city: "PAULS POCKET", state: "QLD", postcode: "4800" },
{ city: "PRESTON", state: "QLD", postcode: "4800" },
{ city: "PROSERPINE", state: "QLD", postcode: "4800" },
{ city: "RIORDANVALE", state: "QLD", postcode: "4800" },
{ city: "SILVER CREEK", state: "QLD", postcode: "4800" },
{ city: "STRATHDICKIE", state: "QLD", postcode: "4800" },
{ city: "SUGARLOAF", state: "QLD", postcode: "4800" },
{ city: "THOOPARA", state: "QLD", postcode: "4800" },
{ city: "WILSON BEACH", state: "QLD", postcode: "4800" },
{ city: "HAYMAN ISLAND", state: "QLD", postcode: "4801" },
{ city: "AIRLIE BEACH", state: "QLD", postcode: "4802" },
{ city: "CANNONVALE", state: "QLD", postcode: "4802" },
{ city: "FLAMETREE", state: "QLD", postcode: "4802" },
{ city: "JUBILEE POCKET", state: "QLD", postcode: "4802" },
{ city: "MANDALAY", state: "QLD", postcode: "4802" },
{ city: "MOUNT ROOPER", state: "QLD", postcode: "4802" },
{ city: "SHUTE HARBOUR", state: "QLD", postcode: "4802" },
{ city: "WHITSUNDAYS", state: "QLD", postcode: "4802" },
{ city: "WOODWARK", state: "QLD", postcode: "4802" },
{ city: "HAMILTON ISLAND", state: "QLD", postcode: "4803" },
{ city: "COLLINSVILLE", state: "QLD", postcode: "4804" },
{ city: "MOUNT COOLON", state: "QLD", postcode: "4804" },
{ city: "MOUNT WYATT", state: "QLD", postcode: "4804" },
{ city: "NEWLANDS", state: "QLD", postcode: "4804" },
{ city: "SCOTTVILLE", state: "QLD", postcode: "4804" },
{ city: "SPRINGLANDS", state: "QLD", postcode: "4804" },
{ city: "BINBEE", state: "QLD", postcode: "4805" },
{ city: "BOGIE", state: "QLD", postcode: "4805" },
{ city: "BOWEN", state: "QLD", postcode: "4805" },
{ city: "BRISK BAY", state: "QLD", postcode: "4805" },
{ city: "DELTA", state: "QLD", postcode: "4805" },
{ city: "GUMLU", state: "QLD", postcode: "4805" },
{ city: "GUTHALUNGRA", state: "QLD", postcode: "4805" },
{ city: "MERINDA", state: "QLD", postcode: "4805" },
{ city: "QUEENS BEACH", state: "QLD", postcode: "4805" },
{ city: "CARSTAIRS", state: "QLD", postcode: "4806" },
{ city: "FREDERICKSFIELD", state: "QLD", postcode: "4806" },
{ city: "HOME HILL", state: "QLD", postcode: "4806" },
{ city: "INKERMAN", state: "QLD", postcode: "4806" },
{ city: "KIRKNIE", state: "QLD", postcode: "4806" },
{ city: "OSBORNE", state: "QLD", postcode: "4806" },
{ city: "RANGEMORE", state: "QLD", postcode: "4806" },
{ city: "WUNJUNGA", state: "QLD", postcode: "4806" },
{ city: "AIRDMILLAN", state: "QLD", postcode: "4807" },
{ city: "AIRVILLE", state: "QLD", postcode: "4807" },
{ city: "ALVA", state: "QLD", postcode: "4807" },
{ city: "AYR", state: "QLD", postcode: "4807" },
{ city: "CLARE", state: "QLD", postcode: "4807" },
{ city: "CLAREDALE", state: "QLD", postcode: "4807" },
{ city: "DALBEG", state: "QLD", postcode: "4807" },
{ city: "EIGHT MILE CREEK", state: "QLD", postcode: "4807" },
{ city: "JARVISFIELD", state: "QLD", postcode: "4807" },
{ city: "MCDESME", state: "QLD", postcode: "4807" },
{ city: "MILLAROO", state: "QLD", postcode: "4807" },
{ city: "MONA PARK", state: "QLD", postcode: "4807" },
{ city: "MOUNT KELLY", state: "QLD", postcode: "4807" },
{ city: "MULGRAVE", state: "QLD", postcode: "4807" },
{ city: "RITA ISLAND", state: "QLD", postcode: "4807" },
{ city: "SWANS LAGOON", state: "QLD", postcode: "4807" },
{ city: "BRANDON", state: "QLD", postcode: "4808" },
{ city: "ALABAMA HILL", state: "QLD", postcode: "4820" },
{ city: "BALFES CREEK", state: "QLD", postcode: "4820" },
{ city: "BASALT", state: "QLD", postcode: "4820" },
{ city: "BLACK JACK", state: "QLD", postcode: "4820" },
{ city: "BREDDAN", state: "QLD", postcode: "4820" },
{ city: "BROUGHTON", state: "QLD", postcode: "4820" },
{ city: "CAMPASPE", state: "QLD", postcode: "4820" },
{ city: "CHARTERS TOWERS", state: "QLD", postcode: "4820" },
{ city: "CHARTERS TOWERS CITY", state: "QLD", postcode: "4820" },
{ city: "COLUMBIA", state: "QLD", postcode: "4820" },
{ city: "DOTSWOOD", state: "QLD", postcode: "4820" },
{ city: "GRAND SECRET", state: "QLD", postcode: "4820" },
{ city: "LISSNER", state: "QLD", postcode: "4820" },
{ city: "LLANARTH", state: "QLD", postcode: "4820" },
{ city: "MILLCHESTER", state: "QLD", postcode: "4820" },
{ city: "MOSMAN PARK", state: "QLD", postcode: "4820" },
{ city: "QUEENTON", state: "QLD", postcode: "4820" },
{ city: "RICHMOND HILL", state: "QLD", postcode: "4820" },
{ city: "SEVENTY MILE", state: "QLD", postcode: "4820" },
{ city: "SOUTHERN CROSS", state: "QLD", postcode: "4820" },
{ city: "TOLL", state: "QLD", postcode: "4820" },
{ city: "TOWERS HILL", state: "QLD", postcode: "4820" },
{ city: "CARPENTARIA", state: "QLD", postcode: "4823" },
{ city: "JULIA CREEK", state: "QLD", postcode: "4823" },
{ city: "KYNUNA", state: "QLD", postcode: "4823" },
{ city: "MCKINLAY", state: "QLD", postcode: "4823" },
{ city: "SELWYN", state: "QLD", postcode: "4823" },
{ city: "STOKES", state: "QLD", postcode: "4823" },
{ city: "TALDORA", state: "QLD", postcode: "4823" },
{ city: "WARBURTON", state: "QLD", postcode: "4823" },
{ city: "CLONCURRY", state: "QLD", postcode: "4824" },
{ city: "MOUNT ISA", state: "QLD", postcode: "4825" },
{ city: "MOUNT ISA CITY", state: "QLD", postcode: "4825" },
{ city: "MOUNT ISA DC", state: "QLD", postcode: "4825" },
{ city: "MOUNT ISA EAST", state: "QLD", postcode: "4825" },
{ city: "MT ISA", state: "QLD", postcode: "4825" },
{ city: "ABERGOWRIE", state: "QLD", postcode: "4850" },
{ city: "ALLINGHAM", state: "QLD", postcode: "4850" },
{ city: "BAMBAROO", state: "QLD", postcode: "4850" },
{ city: "BEMERSIDE", state: "QLD", postcode: "4850" },
{ city: "BLACKROCK", state: "QLD", postcode: "4850" },
{ city: "BRAEMEADOWS", state: "QLD", postcode: "4850" },
{ city: "COOLBIE", state: "QLD", postcode: "4850" },
{ city: "CORDELIA", state: "QLD", postcode: "4850" },
{ city: "DALRYMPLE CREEK", state: "QLD", postcode: "4850" },
{ city: "FORESTHOME", state: "QLD", postcode: "4850" },
{ city: "FORREST BEACH", state: "QLD", postcode: "4850" },
{ city: "GAIRLOCH", state: "QLD", postcode: "4850" },
{ city: "GARRAWALT", state: "QLD", postcode: "4850" },
{ city: "HALIFAX", state: "QLD", postcode: "4850" },
{ city: "HAWKINS CREEK", state: "QLD", postcode: "4850" },
{ city: "HELENS HILL", state: "QLD", postcode: "4850" },
{ city: "INGHAM", state: "QLD", postcode: "4850" },
{ city: "LANNERCOST", state: "QLD", postcode: "4850" },
{ city: "LONG POCKET", state: "QLD", postcode: "4850" },
{ city: "LUCINDA", state: "QLD", postcode: "4850" },
{ city: "MACKNADE", state: "QLD", postcode: "4850" },
{ city: "MOUNT FOX", state: "QLD", postcode: "4850" },
{ city: "ORIENT", state: "QLD", postcode: "4850" },
{ city: "PEACOCK SIDING", state: "QLD", postcode: "4850" },
{ city: "TAYLORS BEACH", state: "QLD", postcode: "4850" },
{ city: "TOOBANNA", state: "QLD", postcode: "4850" },
{ city: "TREBONNE", state: "QLD", postcode: "4850" },
{ city: "UPPER STONE", state: "QLD", postcode: "4850" },
{ city: "VALLEY OF LAGOONS", state: "QLD", postcode: "4850" },
{ city: "VICTORIA ESTATE", state: "QLD", postcode: "4850" },
{ city: "VICTORIA PLANTATION", state: "QLD", postcode: "4850" },
{ city: "WALLAMAN", state: "QLD", postcode: "4850" },
{ city: "WHARPS", state: "QLD", postcode: "4850" },
{ city: "YURUGA", state: "QLD", postcode: "4850" },
{ city: "BINGIL BAY", state: "QLD", postcode: "4852" },
{ city: "CARMOO", state: "QLD", postcode: "4852" },
{ city: "DJIRU", state: "QLD", postcode: "4852" },
{ city: "DUNK", state: "QLD", postcode: "4852" },
{ city: "GARNERS BEACH", state: "QLD", postcode: "4852" },
{ city: "MIDGEREE BAR", state: "QLD", postcode: "4852" },
{ city: "MISSION BEACH", state: "QLD", postcode: "4852" },
{ city: "SOUTH MISSION BEACH", state: "QLD", postcode: "4852" },
{ city: "TAM O'SHANTER", state: "QLD", postcode: "4852" },
{ city: "WONGALING BEACH", state: "QLD", postcode: "4852" },
{ city: "BILYANA", state: "QLD", postcode: "4854" },
{ city: "BIRKALLA", state: "QLD", postcode: "4854" },
{ city: "BULGUN", state: "QLD", postcode: "4854" },
{ city: "CARDSTONE", state: "QLD", postcode: "4854" },
{ city: "DINGO POCKET", state: "QLD", postcode: "4854" },
{ city: "DJARAWONG", state: "QLD", postcode: "4854" },
{ city: "EAST FELUGA", state: "QLD", postcode: "4854" },
{ city: "EURAMO", state: "QLD", postcode: "4854" },
{ city: "FELUGA", state: "QLD", postcode: "4854" },
{ city: "HULL HEADS", state: "QLD", postcode: "4854" },
{ city: "JARRA CREEK", state: "QLD", postcode: "4854" },
{ city: "KOOROOMOOL", state: "QLD", postcode: "4854" },
{ city: "LOWER TULLY", state: "QLD", postcode: "4854" },
{ city: "MERRYBURN", state: "QLD", postcode: "4854" },
{ city: "MIDGENOO", state: "QLD", postcode: "4854" },
{ city: "MOUNT MACKAY", state: "QLD", postcode: "4854" },
{ city: "MUNRO PLAINS", state: "QLD", postcode: "4854" },
{ city: "MURRAY UPPER", state: "QLD", postcode: "4854" },
{ city: "MURRIGAL", state: "QLD", postcode: "4854" },
{ city: "ROCKINGHAM", state: "QLD", postcode: "4854" },
{ city: "SILKY OAK", state: "QLD", postcode: "4854" },
{ city: "TULLY", state: "QLD", postcode: "4854" },
{ city: "TULLY HEADS", state: "QLD", postcode: "4854" },
{ city: "WALTER HILL", state: "QLD", postcode: "4854" },
{ city: "WARRAMI", state: "QLD", postcode: "4854" },
{ city: "DAVESON", state: "QLD", postcode: "4855" },
{ city: "EL ARISH", state: "QLD", postcode: "4855" },
{ city: "FRIDAY POCKET", state: "QLD", postcode: "4855" },
{ city: "GRANADILLA", state: "QLD", postcode: "4855" },
{ city: "JAFFA", state: "QLD", postcode: "4855" },
{ city: "MAADI", state: "QLD", postcode: "4855" },
{ city: "MARIA CREEKS", state: "QLD", postcode: "4855" },
{ city: "SHELL POCKET", state: "QLD", postcode: "4855" },
{ city: "GOOLBOO", state: "QLD", postcode: "4856" },
{ city: "JAPOONVALE", state: "QLD", postcode: "4856" },
{ city: "MCCUTCHEON", state: "QLD", postcode: "4856" },
{ city: "NO 4 BRANCH", state: "QLD", postcode: "4856" },
{ city: "NO. 4 BRANCH", state: "QLD", postcode: "4856" },
{ city: "NO 5 BRANCH", state: "QLD", postcode: "4856" },
{ city: "NO. 5 BRANCH", state: "QLD", postcode: "4856" },
{ city: "SILKWOOD", state: "QLD", postcode: "4856" },
{ city: "WALTER LEVER ESTATE", state: "QLD", postcode: "4856" },
{ city: "SILKWOOD EAST", state: "QLD", postcode: "4857" },
{ city: "COMOON LOOP", state: "QLD", postcode: "4858" },
{ city: "ETTY BAY", state: "QLD", postcode: "4858" },
{ city: "MARTYVILLE", state: "QLD", postcode: "4858" },
{ city: "MOURILYAN", state: "QLD", postcode: "4858" },
{ city: "MOURILYAN HARBOUR", state: "QLD", postcode: "4858" },
{ city: "NEW HARBOURLINE", state: "QLD", postcode: "4858" },
{ city: "NO 6 BRANCH", state: "QLD", postcode: "4859" },
{ city: "NO. 6 BRANCH", state: "QLD", postcode: "4859" },
{ city: "SOUTH JOHNSTONE", state: "QLD", postcode: "4859" },
{ city: "BAMBOO CREEK", state: "QLD", postcode: "4860" },
{ city: "BELVEDERE", state: "QLD", postcode: "4860" },
{ city: "COCONUTS", state: "QLD", postcode: "4860" },
{ city: "COOROO LANDS", state: "QLD", postcode: "4860" },
{ city: "COORUMBA", state: "QLD", postcode: "4860" },
{ city: "COQUETTE POINT", state: "QLD", postcode: "4860" },
{ city: "CULLINANE", state: "QLD", postcode: "4860" },
{ city: "DARADGEE", state: "QLD", postcode: "4860" },
{ city: "EAST INNISFAIL", state: "QLD", postcode: "4860" },
{ city: "EAST PALMERSTON", state: "QLD", postcode: "4860" },
{ city: "EATON", state: "QLD", postcode: "4860" },
{ city: "EUBENANGEE", state: "QLD", postcode: "4860" },
{ city: "FITZGERALD CREEK", state: "QLD", postcode: "4860" },
{ city: "FLYING FISH POINT", state: "QLD", postcode: "4860" },
{ city: "GARRADUNGA", state: "QLD", postcode: "4860" },
{ city: "GOONDI", state: "QLD", postcode: "4860" },
{ city: "GOONDI BEND", state: "QLD", postcode: "4860" },
{ city: "GOONDI HILL", state: "QLD", postcode: "4860" },
{ city: "HUDSON", state: "QLD", postcode: "4860" },
{ city: "INNISFAIL", state: "QLD", postcode: "4860" },
{ city: "INNISFAIL ESTATE", state: "QLD", postcode: "4860" },
{ city: "JUBILEE HEIGHTS", state: "QLD", postcode: "4860" },
{ city: "MIGHELL", state: "QLD", postcode: "4860" },
{ city: "MUNDOO", state: "QLD", postcode: "4860" },
{ city: "NERADA", state: "QLD", postcode: "4860" },
{ city: "NGATJAN", state: "QLD", postcode: "4860" },
{ city: "O'BRIENS HILL", state: "QLD", postcode: "4860" },
{ city: "PALMERSTON", state: "QLD", postcode: "4860" },
{ city: "PIN GIN HILL", state: "QLD", postcode: "4860" },
{ city: "SOUTH INNISFAIL", state: "QLD", postcode: "4860" },
{ city: "STOTERS HILL", state: "QLD", postcode: "4860" },
{ city: "SUNDOWN", state: "QLD", postcode: "4860" },
{ city: "UPPER DARADGEE", state: "QLD", postcode: "4860" },
{ city: "VASA VIEWS", state: "QLD", postcode: "4860" },
{ city: "WANJURU", state: "QLD", postcode: "4860" },
{ city: "WEBB", state: "QLD", postcode: "4860" },
{ city: "WOOROONOORAN", state: "QLD", postcode: "4860" },
{ city: "BABINDA", state: "QLD", postcode: "4861" },
{ city: "BARTLE FRERE", state: "QLD", postcode: "4861" },
{ city: "EAST RUSSELL", state: "QLD", postcode: "4861" },
{ city: "GOLDSBOROUGH", state: "QLD", postcode: "4865" },
{ city: "GREEN HILL", state: "QLD", postcode: "4865" },
{ city: "KAMMA", state: "QLD", postcode: "4865" },
{ city: "LITTLE MULGRAVE", state: "QLD", postcode: "4865" },
{ city: "PACKERS CAMP", state: "QLD", postcode: "4865" },
{ city: "REDBANK", state: "QLD", postcode: "4865" },
{ city: "BAYVIEW HEIGHTS", state: "QLD", postcode: "4868" },
{ city: "MOUNT SHERIDAN", state: "QLD", postcode: "4868" },
{ city: "WHITE ROCK", state: "QLD", postcode: "4868" },
{ city: "WOREE", state: "QLD", postcode: "4868" },
{ city: "BENTLEY PARK", state: "QLD", postcode: "4869" },
{ city: "MOUNT PETER", state: "QLD", postcode: "4869" },
{ city: "WRIGHTS CREEK", state: "QLD", postcode: "4869" },
{ city: "MARTYNVALE", state: "QLD", postcode: "4870" },
{ city: "REDLYNCH", state: "QLD", postcode: "4870" },
{ city: "WHITFIELD", state: "QLD", postcode: "4870" },
{ city: "ABINGDON DOWNS", state: "QLD", postcode: "4871" },
{ city: "ALMADEN", state: "QLD", postcode: "4871" },
{ city: "ALOOMBA", state: "QLD", postcode: "4871" },
{ city: "AMBER", state: "QLD", postcode: "4871" },
{ city: "ARBOUIN", state: "QLD", postcode: "4871" },
{ city: "ARCHER RIVER", state: "QLD", postcode: "4871" },
{ city: "AURUKUN", state: "QLD", postcode: "4871" },
{ city: "BASILISK", state: "QLD", postcode: "4871" },
{ city: "BELLENDEN KER", state: "QLD", postcode: "4871" },
{ city: "BELLEVUE", state: "QLD", postcode: "4871" },
{ city: "BLACKBULL", state: "QLD", postcode: "4871" },
{ city: "BOLWARRA", state: "QLD", postcode: "4871" },
{ city: "BOMBEETA", state: "QLD", postcode: "4871" },
{ city: "BOOGAN", state: "QLD", postcode: "4871" },
{ city: "BRAMSTON BEACH", state: "QLD", postcode: "4871" },
{ city: "BULLERINGA", state: "QLD", postcode: "4871" },
{ city: "CAMP CREEK", state: "QLD", postcode: "4871" },
{ city: "CHILLAGOE", state: "QLD", postcode: "4871" },
{ city: "CLARAVILLE", state: "QLD", postcode: "4871" },
{ city: "COEN", state: "QLD", postcode: "4871" },
{ city: "CONJUBOY", state: "QLD", postcode: "4871" },
{ city: "CORALIE", state: "QLD", postcode: "4871" },
{ city: "COWLEY", state: "QLD", postcode: "4871" },
{ city: "COWLEY BEACH", state: "QLD", postcode: "4871" },
{ city: "COWLEY CREEK", state: "QLD", postcode: "4871" },
{ city: "CROYDON", state: "QLD", postcode: "4871" },
{ city: "CRYSTALBROOK", state: "QLD", postcode: "4871" },
{ city: "CURRAJAH", state: "QLD", postcode: "4871" },
{ city: "DEERAL", state: "QLD", postcode: "4871" },
{ city: "DESAILLY", state: "QLD", postcode: "4871" },
{ city: "DIXIE", state: "QLD", postcode: "4871" },
{ city: "EAST CREEK", state: "QLD", postcode: "4871" },
{ city: "EAST TRINITY", state: "QLD", postcode: "4871" },
{ city: "EDWARD RIVER", state: "QLD", postcode: "4871" },
{ city: "EINASLEIGH", state: "QLD", postcode: "4871" },
{ city: "ESMERALDA", state: "QLD", postcode: "4871" },
{ city: "FISHERY FALLS", state: "QLD", postcode: "4871" },
{ city: "FITZROY ISLAND", state: "QLD", postcode: "4871" },
{ city: "FORSAYTH", state: "QLD", postcode: "4871" },
{ city: "FOSSILBROOK", state: "QLD", postcode: "4871" },
{ city: "GAMBOOLA", state: "QLD", postcode: "4871" },
{ city: "GEORGETOWN", state: "QLD", postcode: "4871" },
{ city: "GERMANTOWN", state: "QLD", postcode: "4871" },
{ city: "GILBERT RIVER", state: "QLD", postcode: "4871" },
{ city: "GLEN BOUGHTON", state: "QLD", postcode: "4871" },
{ city: "GREEN ISLAND", state: "QLD", postcode: "4871" },
{ city: "GROGANVILLE", state: "QLD", postcode: "4871" },
{ city: "GUNUNA", state: "QLD", postcode: "4871" },
{ city: "HIGHBURY", state: "QLD", postcode: "4871" },
{ city: "HOLROYD RIVER", state: "QLD", postcode: "4871" },
{ city: "HURRICANE", state: "QLD", postcode: "4871" },
{ city: "JULATTEN", state: "QLD", postcode: "4871" },
{ city: "KARRON", state: "QLD", postcode: "4871" },
{ city: "KOWANYAMA", state: "QLD", postcode: "4871" },
{ city: "KURRIMINE BEACH", state: "QLD", postcode: "4871" },
{ city: "LAKEFIELD", state: "QLD", postcode: "4871" },
{ city: "LAKELAND", state: "QLD", postcode: "4871" },
{ city: "LAKELAND DOWNS", state: "QLD", postcode: "4871" },
{ city: "LAURA", state: "QLD", postcode: "4871" },
{ city: "LIZARD", state: "QLD", postcode: "4871" },
{ city: "LOCKHART", state: "QLD", postcode: "4871" },
{ city: "LOWER COWLEY", state: "QLD", postcode: "4871" },
{ city: "LYNDHURST", state: "QLD", postcode: "4871" },
{ city: "LYNDSIDE", state: "QLD", postcode: "4871" },
{ city: "MACALISTER RANGE", state: "QLD", postcode: "4871" },
{ city: "MARAMIE", state: "QLD", postcode: "4871" },
{ city: "MENA CREEK", state: "QLD", postcode: "4871" },
{ city: "MIRIWINNI", state: "QLD", postcode: "4871" },
{ city: "MIRRIWINNI", state: "QLD", postcode: "4871" },
{ city: "MORESBY", state: "QLD", postcode: "4871" },
{ city: "MORNINGTON ISLAND", state: "QLD", postcode: "4871" },
{ city: "MOUNT CARBINE", state: "QLD", postcode: "4871" },
{ city: "MOUNT MOLLOY", state: "QLD", postcode: "4871" },
{ city: "MOUNT MULGRAVE", state: "QLD", postcode: "4871" },
{ city: "MOUNT MULLIGAN", state: "QLD", postcode: "4871" },
{ city: "MOUNT SURPRISE", state: "QLD", postcode: "4871" },
{ city: "NORTHHEAD", state: "QLD", postcode: "4871" },
{ city: "NYCHUM", state: "QLD", postcode: "4871" },
{ city: "PALMER", state: "QLD", postcode: "4871" },
{ city: "PETFORD", state: "QLD", postcode: "4871" },
{ city: "PORMPURAAW", state: "QLD", postcode: "4871" },
{ city: "PORTLAND ROADS", state: "QLD", postcode: "4871" },
{ city: "RAVENSWORTH", state: "QLD", postcode: "4871" },
{ city: "RED RIVER", state: "QLD", postcode: "4871" },
{ city: "ROOKWOOD", state: "QLD", postcode: "4871" },
{ city: "SANDY POCKET", state: "QLD", postcode: "4871" },
{ city: "SOUTHEDGE", state: "QLD", postcode: "4871" },
{ city: "SOUTH WELLESLEY ISLANDS", state: "QLD", postcode: "4871" },
{ city: "SPRINGFIELD", state: "QLD", postcode: "4871" },
{ city: "STAATEN", state: "QLD", postcode: "4871" },
{ city: "STOCKTON", state: "QLD", postcode: "4871" },
{ city: "STRATHMORE", state: "QLD", postcode: "4871" },
{ city: "TALAROO", state: "QLD", postcode: "4871" },
{ city: "THORNBOROUGH", state: "QLD", postcode: "4871" },
{ city: "UTCHEE CREEK", state: "QLD", postcode: "4871" },
{ city: "WANGAN", state: "QLD", postcode: "4871" },
{ city: "WARRUBULLEN", state: "QLD", postcode: "4871" },
{ city: "WAUGH POCKET", state: "QLD", postcode: "4871" },
{ city: "WELLESLEY ISLANDS", state: "QLD", postcode: "4871" },
{ city: "WEST WELLESLEY ISLANDS", state: "QLD", postcode: "4871" },
{ city: "WOOPEN CREEK", state: "QLD", postcode: "4871" },
{ city: "WROTHAM", state: "QLD", postcode: "4871" },
{ city: "YAGOONYA", state: "QLD", postcode: "4871" },
{ city: "YARRABAH", state: "QLD", postcode: "4871" },
{ city: "YARRADEN", state: "QLD", postcode: "4871" },
{ city: "BARRINE", state: "QLD", postcode: "4872" },
{ city: "BARWIDGI", state: "QLD", postcode: "4872" },
{ city: "DANBULLA", state: "QLD", postcode: "4872" },
{ city: "DIMBULAH", state: "QLD", postcode: "4872" },
{ city: "FORTY MILE", state: "QLD", postcode: "4872" },
{ city: "GLEN RUTH", state: "QLD", postcode: "4872" },
{ city: "GUNNAWARRA", state: "QLD", postcode: "4872" },
{ city: "INNOT HOT SPRINGS", state: "QLD", postcode: "4872" },
{ city: "KAIRI", state: "QLD", postcode: "4872" },
{ city: "KIRRAMA", state: "QLD", postcode: "4872" },
{ city: "KOOMBOOLOOMBA", state: "QLD", postcode: "4872" },
{ city: "KOWROWA", state: "QLD", postcode: "4872" },
{ city: "LAKE TINAROO", state: "QLD", postcode: "4872" },
{ city: "MINNAMOOLKA", state: "QLD", postcode: "4872" },
{ city: "MOUNT GARNET", state: "QLD", postcode: "4872" },
{ city: "MUNDERRA", state: "QLD", postcode: "4872" },
{ city: "MUTCHILBA", state: "QLD", postcode: "4872" },
{ city: "SILVER VALLEY", state: "QLD", postcode: "4872" },
{ city: "TINAROO", state: "QLD", postcode: "4872" },
{ city: "WAIRUNA", state: "QLD", postcode: "4872" },
{ city: "WALKAMIN", state: "QLD", postcode: "4872" },
{ city: "BAMBOO", state: "QLD", postcode: "4873" },
{ city: "BONNIE DOON", state: "QLD", postcode: "4873" },
{ city: "CAPE TRIBULATION", state: "QLD", postcode: "4873" },
{ city: "CASSOWARY", state: "QLD", postcode: "4873" },
{ city: "COOYA BEACH", state: "QLD", postcode: "4873" },
{ city: "COW BAY", state: "QLD", postcode: "4873" },
{ city: "DAGMAR", state: "QLD", postcode: "4873" },
{ city: "DAINTREE", state: "QLD", postcode: "4873" },
{ city: "DEDIN", state: "QLD", postcode: "4873" },
{ city: "DIWAN", state: "QLD", postcode: "4873" },
{ city: "FINLAY VALE", state: "QLD", postcode: "4873" },
{ city: "FINLAYVALE", state: "QLD", postcode: "4873" },
{ city: "FOREST CREEK", state: "QLD", postcode: "4873" },
{ city: "KIMBERLEY", state: "QLD", postcode: "4873" },
{ city: "LOWER DAINTREE", state: "QLD", postcode: "4873" },
{ city: "LOW ISLES", state: "QLD", postcode: "4873" },
{ city: "MIALLO", state: "QLD", postcode: "4873" },
{ city: "MOSSMAN", state: "QLD", postcode: "4873" },
{ city: "MOSSMAN GORGE", state: "QLD", postcode: "4873" },
{ city: "NEWELL", state: "QLD", postcode: "4873" },
{ city: "NOAH", state: "QLD", postcode: "4873" },
{ city: "ROCKY POINT", state: "QLD", postcode: "4873" },
{ city: "SHANNONVALE", state: "QLD", postcode: "4873" },
{ city: "SPURGEON", state: "QLD", postcode: "4873" },
{ city: "STEWART CREEK VALLEY", state: "QLD", postcode: "4873" },
{ city: "SYNDICATE", state: "QLD", postcode: "4873" },
{ city: "THORNTON BEACH", state: "QLD", postcode: "4873" },
{ city: "UPPER DAINTREE", state: "QLD", postcode: "4873" },
{ city: "WHYANBEEL", state: "QLD", postcode: "4873" },
{ city: "WONGA", state: "QLD", postcode: "4873" },
{ city: "WONGA BEACH", state: "QLD", postcode: "4873" },
{ city: "EVANS LANDING", state: "QLD", postcode: "4874" },
{ city: "JARDINE RIVER", state: "QLD", postcode: "4874" },
{ city: "MAPOON", state: "QLD", postcode: "4874" },
{ city: "MISSION RIVER", state: "QLD", postcode: "4874" },
{ city: "NANUM", state: "QLD", postcode: "4874" },
{ city: "NAPRANUM", state: "QLD", postcode: "4874" },
{ city: "ROCKY POINT", state: "QLD", postcode: "4874" },
{ city: "SHELBURNE", state: "QLD", postcode: "4874" },
{ city: "TRUNDING", state: "QLD", postcode: "4874" },
{ city: "WEIPA", state: "QLD", postcode: "4874" },
{ city: "WEIPA AIRPORT", state: "QLD", postcode: "4874" },
{ city: "WENLOCK", state: "QLD", postcode: "4874" },
{ city: "BADU ISLAND", state: "QLD", postcode: "4875" },
{ city: "BANKS ISLAND", state: "QLD", postcode: "4875" },
{ city: "BOIGU ISLAND", state: "QLD", postcode: "4875" },
{ city: "COCONUT ISLAND", state: "QLD", postcode: "4875" },
{ city: "DARNLEY ISLAND", state: "QLD", postcode: "4875" },
{ city: "DAUAN ISLAND", state: "QLD", postcode: "4875" },
{ city: "ERUB", state: "QLD", postcode: "4875" },
{ city: "ERUB ISLAND", state: "QLD", postcode: "4875" },
{ city: "HORN", state: "QLD", postcode: "4875" },
{ city: "HORN ISLAND", state: "QLD", postcode: "4875" },
{ city: "IAMA ISLAND", state: "QLD", postcode: "4875" },
{ city: "JERVIS ISLAND", state: "QLD", postcode: "4875" },
{ city: "KERIRI ISLAND", state: "QLD", postcode: "4875" },
{ city: "KUBIN VILLAGE", state: "QLD", postcode: "4875" },
{ city: "MABUIAG ISLAND", state: "QLD", postcode: "4875" },
{ city: "MASIG ISLAND", state: "QLD", postcode: "4875" },
{ city: "MER ISLAND", state: "QLD", postcode: "4875" },
{ city: "MOA ISLAND", state: "QLD", postcode: "4875" },
{ city: "MULGRAVE ISLAND", state: "QLD", postcode: "4875" },
{ city: "MURRAY ISLAND", state: "QLD", postcode: "4875" },
{ city: "PORUMA ISLAND", state: "QLD", postcode: "4875" },
{ city: "PRINCE OF WALES", state: "QLD", postcode: "4875" },
{ city: "SAIBAI ISLAND", state: "QLD", postcode: "4875" },
{ city: "STEPHENS ISLAND", state: "QLD", postcode: "4875" },
{ city: "TALBOT ISLAND", state: "QLD", postcode: "4875" },
{ city: "THURSDAY ISLAND", state: "QLD", postcode: "4875" },
{ city: "WARRABER ISLAND", state: "QLD", postcode: "4875" },
{ city: "WARRABER ISLET", state: "QLD", postcode: "4875" },
{ city: "YAM ISLAND", state: "QLD", postcode: "4875" },
{ city: "YORKE ISLAND", state: "QLD", postcode: "4875" },
{ city: "BAMAGA", state: "QLD", postcode: "4876" },
{ city: "INJINOO", state: "QLD", postcode: "4876" },
{ city: "NEW MAPOON", state: "QLD", postcode: "4876" },
{ city: "PUNSAND", state: "QLD", postcode: "4876" },
{ city: "SEISIA", state: "QLD", postcode: "4876" },
{ city: "SOMERSET", state: "QLD", postcode: "4876" },
{ city: "UMAGICO", state: "QLD", postcode: "4876" },
{ city: "CRAIGLIE", state: "QLD", postcode: "4877" },
{ city: "KILLALOE", state: "QLD", postcode: "4877" },
{ city: "MOWBRAY", state: "QLD", postcode: "4877" },
{ city: "OAK BEACH", state: "QLD", postcode: "4877" },
{ city: "PORT DOUGLAS", state: "QLD", postcode: "4877" },
{ city: "WANGETTI", state: "QLD", postcode: "4877" },
{ city: "BARRON", state: "QLD", postcode: "4878" },
{ city: "CARAVONICA", state: "QLD", postcode: "4878" },
{ city: "HOLLOWAYS BEACH", state: "QLD", postcode: "4878" },
{ city: "MACHANS BEACH", state: "QLD", postcode: "4878" },
{ city: "SMITHFIELD", state: "QLD", postcode: "4878" },
{ city: "YORKEYS KNOB", state: "QLD", postcode: "4878" },
{ city: "CLIFTON BEACH", state: "QLD", postcode: "4879" },
{ city: "ELLIS BEACH", state: "QLD", postcode: "4879" },
{ city: "KEWARRA BEACH", state: "QLD", postcode: "4879" },
{ city: "PALM COVE", state: "QLD", postcode: "4879" },
{ city: "TRINITY BEACH", state: "QLD", postcode: "4879" },
{ city: "TRINITY PARK", state: "QLD", postcode: "4879" },
{ city: "ARRIGA", state: "QLD", postcode: "4880" },
{ city: "BIBOOHRA", state: "QLD", postcode: "4880" },
{ city: "CHEWKO", state: "QLD", postcode: "4880" },
{ city: "GLEN RUSSELL", state: "QLD", postcode: "4880" },
{ city: "MAREEBA", state: "QLD", postcode: "4880" },
{ city: "PADDYS GREEN", state: "QLD", postcode: "4880" },
{ city: "KOAH", state: "QLD", postcode: "4881" },
{ city: "KURANDA", state: "QLD", postcode: "4881" },
{ city: "MONA MONA", state: "QLD", postcode: "4881" },
{ city: "SPEEWAH", state: "QLD", postcode: "4881" },
{ city: "TOLGA", state: "QLD", postcode: "4882" },
{ city: "ATHERTON", state: "QLD", postcode: "4883" },
{ city: "CARRINGTON", state: "QLD", postcode: "4883" },
{ city: "EAST BARRON", state: "QLD", postcode: "4883" },
{ city: "UPPER BARRON", state: "QLD", postcode: "4883" },
{ city: "WONGABEL", state: "QLD", postcode: "4883" },
{ city: "GADGARRA", state: "QLD", postcode: "4884" },
{ city: "LAKE BARRINE", state: "QLD", postcode: "4884" },
{ city: "LAKE EACHAM", state: "QLD", postcode: "4884" },
{ city: "YUNGABURRA", state: "QLD", postcode: "4884" },
{ city: "BUTCHERS CREEK", state: "QLD", postcode: "4885" },
{ city: "GLEN ALLYN", state: "QLD", postcode: "4885" },
{ city: "JAGGAN", state: "QLD", postcode: "4885" },
{ city: "KUREEN", state: "QLD", postcode: "4885" },
{ city: "MALANDA", state: "QLD", postcode: "4885" },
{ city: "NORTH JOHNSTONE", state: "QLD", postcode: "4885" },
{ city: "PEERAMON", state: "QLD", postcode: "4885" },
{ city: "TARZALI", state: "QLD", postcode: "4885" },
{ city: "TOPAZ", state: "QLD", postcode: "4885" },
{ city: "BEATRICE", state: "QLD", postcode: "4886" },
{ city: "ELLINJAA", state: "QLD", postcode: "4886" },
{ city: "MAALAN", state: "QLD", postcode: "4886" },
{ city: "MIDDLEBROOK", state: "QLD", postcode: "4886" },
{ city: "MILLAA MILLAA", state: "QLD", postcode: "4886" },
{ city: "MINBUN", state: "QLD", postcode: "4886" },
{ city: "MOREGATTA", state: "QLD", postcode: "4886" },
{ city: "MUNGALLI", state: "QLD", postcode: "4886" },
{ city: "HERBERTON", state: "QLD", postcode: "4887" },
{ city: "IRVINEBANK", state: "QLD", postcode: "4887" },
{ city: "KALUNGA", state: "QLD", postcode: "4887" },
{ city: "MOOMIN", state: "QLD", postcode: "4887" },
{ city: "WATSONVILLE", state: "QLD", postcode: "4887" },
{ city: "WONDECLA", state: "QLD", postcode: "4887" },
{ city: "EVELYN", state: "QLD", postcode: "4888" },
{ city: "KABAN", state: "QLD", postcode: "4888" },
{ city: "MILLSTREAM", state: "QLD", postcode: "4888" },
{ city: "RAVENSHOE", state: "QLD", postcode: "4888" },
{ city: "TUMOULIN", state: "QLD", postcode: "4888" },
{ city: "HOWITT", state: "QLD", postcode: "4890" },
{ city: "NORMAN", state: "QLD", postcode: "4890" },
{ city: "NORMANTON", state: "QLD", postcode: "4890" },
{ city: "KARUMBA", state: "QLD", postcode: "4891" },
{ city: "ABINGDON DOWNS", state: "QLD", postcode: "4892" },
{ city: "ARBOUIN", state: "QLD", postcode: "4892" },
{ city: "ARCHER RIVER", state: "QLD", postcode: "4892" },
{ city: "AURUKUN", state: "QLD", postcode: "4892" },
{ city: "BELLEVUE", state: "QLD", postcode: "4892" },
{ city: "COEN", state: "QLD", postcode: "4892" },
{ city: "DIXIE", state: "QLD", postcode: "4892" },
{ city: "EDWARD RIVER", state: "QLD", postcode: "4892" },
{ city: "GAMBOOLA", state: "QLD", postcode: "4892" },
{ city: "GROGANVILLE", state: "QLD", postcode: "4892" },
{ city: "HIGHBURY", state: "QLD", postcode: "4892" },
{ city: "HOLROYD RIVER", state: "QLD", postcode: "4892" },
{ city: "KOWANYAMA", state: "QLD", postcode: "4892" },
{ city: "LAKEFIELD", state: "QLD", postcode: "4892" },
{ city: "LAURA", state: "QLD", postcode: "4892" },
{ city: "LIZARD", state: "QLD", postcode: "4892" },
{ city: "LOCKHART", state: "QLD", postcode: "4892" },
{ city: "LOCKHART RIVER", state: "QLD", postcode: "4892" },
{ city: "LYNDSIDE", state: "QLD", postcode: "4892" },
{ city: "MARAMIE", state: "QLD", postcode: "4892" },
{ city: "MOUNT MULGRAVE", state: "QLD", postcode: "4892" },
{ city: "PALMER", state: "QLD", postcode: "4892" },
{ city: "PORMPURAAW", state: "QLD", postcode: "4892" },
{ city: "RAVENSWORTH", state: "QLD", postcode: "4892" },
{ city: "RED RIVER", state: "QLD", postcode: "4892" },
{ city: "SOUTH WELLESLEY ISLANDS", state: "QLD", postcode: "4892" },
{ city: "STAATEN", state: "QLD", postcode: "4892" },
{ city: "WELLESLEY ISLANDS", state: "QLD", postcode: "4892" },
{ city: "WEST WELLESLEY ISLANDS", state: "QLD", postcode: "4892" },
{ city: "WROTHAM", state: "QLD", postcode: "4892" },
{ city: "YAGOONYA", state: "QLD", postcode: "4892" },
{ city: "YARRADEN", state: "QLD", postcode: "4892" },
{ city: "AYTON", state: "QLD", postcode: "4895" },
{ city: "BLOOMFIELD", state: "QLD", postcode: "4895" },
{ city: "COOKTOWN", state: "QLD", postcode: "4895" },
{ city: "DEGARRA", state: "QLD", postcode: "4895" },
{ city: "ENDEAVOUR FALLS", state: "QLD", postcode: "4895" },
{ city: "HELENVALE", state: "QLD", postcode: "4895" },
{ city: "HOPE VALE", state: "QLD", postcode: "4895" },
{ city: "ROSSVILLE", state: "QLD", postcode: "4895" },
{ city: "STARCKE", state: "QLD", postcode: "4895" },
{ city: "WUJAL WUJAL", state: "QLD", postcode: "4895" },
{ city: "AYERS RANGE SOUTH", state: "SA", postcode: "872" },
{ city: "DE ROSE HILL", state: "SA", postcode: "872" },
{ city: "ERNABELLA", state: "SA", postcode: "872" },
{ city: "FREGON", state: "SA", postcode: "872" },
{ city: "INDULKANA", state: "SA", postcode: "872" },
{ city: "LAMBINA", state: "SA", postcode: "872" },
{ city: "MIMILI", state: "SA", postcode: "872" },
{ city: "TIEYON", state: "SA", postcode: "872" },
{ city: "LOWER HERMITAGE", state: "SA", postcode: "5131" },
{ city: "UPPER HERMITAGE", state: "SA", postcode: "5131" },
{ city: "PARACOMBE", state: "SA", postcode: "5132" },
{ city: "CHERRYVILLE", state: "SA", postcode: "5134" },
{ city: "MARBLE HILL", state: "SA", postcode: "5137" },
{ city: "GREENHILL", state: "SA", postcode: "5140" },
{ city: "SUMMERTOWN", state: "SA", postcode: "5141" },
{ city: "CAREY GULLY", state: "SA", postcode: "5144" },
{ city: "EAGLE ON THE HILL", state: "SA", postcode: "5150" },
{ city: "LEAWOOD GARDENS", state: "SA", postcode: "5150" },
{ city: "PICCADILLY", state: "SA", postcode: "5151" },
{ city: "CRAFERS WEST", state: "SA", postcode: "5152" },
{ city: "BIGGS FLAT", state: "SA", postcode: "5153" },
{ city: "LONGWOOD", state: "SA", postcode: "5153" },
{ city: "MACCLESFIELD", state: "SA", postcode: "5153" },
{ city: "MYLOR", state: "SA", postcode: "5153" },
{ city: "SCOTT CREEK", state: "SA", postcode: "5153" },
{ city: "MOUNT GEORGE", state: "SA", postcode: "5155" },
{ city: "BULL CREEK", state: "SA", postcode: "5157" },
{ city: "CLARENDON", state: "SA", postcode: "5157" },
{ city: "DORSET VALE", state: "SA", postcode: "5157" },
{ city: "KANGARILLA", state: "SA", postcode: "5157" },
{ city: "MCHARG CREEK", state: "SA", postcode: "5157" },
{ city: "BLEWITT SPRINGS", state: "SA", postcode: "5171" },
{ city: "MCLAREN FLAT", state: "SA", postcode: "5171" },
{ city: "MCLAREN VALE", state: "SA", postcode: "5171" },
{ city: "PEDLER CREEK", state: "SA", postcode: "5171" },
{ city: "TATACHILLA", state: "SA", postcode: "5171" },
{ city: "DINGABLEDINGA", state: "SA", postcode: "5172" },
{ city: "HOPE FOREST", state: "SA", postcode: "5172" },
{ city: "KUITPO", state: "SA", postcode: "5172" },
{ city: "KUITPO COLONY", state: "SA", postcode: "5172" },
{ city: "KYEEMA", state: "SA", postcode: "5172" },
{ city: "MONTARRA", state: "SA", postcode: "5172" },
{ city: "PAGES FLAT", state: "SA", postcode: "5172" },
{ city: "THE RANGE", state: "SA", postcode: "5172" },
{ city: "WHITES VALLEY", state: "SA", postcode: "5172" },
{ city: "WILLUNGA", state: "SA", postcode: "5172" },
{ city: "WILLUNGA HILL", state: "SA", postcode: "5172" },
{ city: "WILLUNGA SOUTH", state: "SA", postcode: "5172" },
{ city: "YUNDI", state: "SA", postcode: "5172" },
{ city: "ALDINGA", state: "SA", postcode: "5173" },
{ city: "ALDINGA BEACH", state: "SA", postcode: "5173" },
{ city: "PORT WILLUNGA", state: "SA", postcode: "5173" },
{ city: "SILVER SANDS", state: "SA", postcode: "5173" },
{ city: "SELLICKS BEACH", state: "SA", postcode: "5174" },
{ city: "SELLICKS HILL", state: "SA", postcode: "5174" },
{ city: "BLACKFELLOWS CREEK", state: "SA", postcode: "5201" },
{ city: "KUITPO", state: "SA", postcode: "5201" },
{ city: "MEADOWS", state: "SA", postcode: "5201" },
{ city: "PARIS CREEK", state: "SA", postcode: "5201" },
{ city: "PROSPECT HILL", state: "SA", postcode: "5201" },
{ city: "HINDMARSH TIERS", state: "SA", postcode: "5202" },
{ city: "MYPONGA", state: "SA", postcode: "5202" },
{ city: "MYPONGA BEACH", state: "SA", postcode: "5202" },
{ city: "BALD HILLS", state: "SA", postcode: "5203" },
{ city: "PARAWA", state: "SA", postcode: "5203" },
{ city: "TORRENS VALE", state: "SA", postcode: "5203" },
{ city: "TUNKALILLA", state: "SA", postcode: "5203" },
{ city: "WATTLE FLAT", state: "SA", postcode: "5203" },
{ city: "YANKALILLA", state: "SA", postcode: "5203" },
{ city: "CAPE JERVIS", state: "SA", postcode: "5204" },
{ city: "CARRICKALINGA", state: "SA", postcode: "5204" },
{ city: "DEEP CREEK", state: "SA", postcode: "5204" },
{ city: "DELAMERE", state: "SA", postcode: "5204" },
{ city: "HAY FLAT", state: "SA", postcode: "5204" },
{ city: "NORMANVILLE", state: "SA", postcode: "5204" },
{ city: "RAPID BAY", state: "SA", postcode: "5204" },
{ city: "SECOND VALLEY", state: "SA", postcode: "5204" },
{ city: "SILVERTON", state: "SA", postcode: "5204" },
{ city: "WIRRINA COVE", state: "SA", postcode: "5204" },
{ city: "MOUNT COMPASS", state: "SA", postcode: "5210" },
{ city: "MOUNT MAGNIFICENT", state: "SA", postcode: "5210" },
{ city: "NANGKITA", state: "SA", postcode: "5210" },
{ city: "BACK VALLEY", state: "SA", postcode: "5211" },
{ city: "ENCOUNTER BAY", state: "SA", postcode: "5211" },
{ city: "HAYBOROUGH", state: "SA", postcode: "5211" },
{ city: "HINDMARSH VALLEY", state: "SA", postcode: "5211" },
{ city: "INMAN VALLEY", state: "SA", postcode: "5211" },
{ city: "LOWER INMAN VALLEY", state: "SA", postcode: "5211" },
{ city: "MCCRACKEN", state: "SA", postcode: "5211" },
{ city: "MOUNT JAGGED", state: "SA", postcode: "5211" },
{ city: "VICTOR HARBOR", state: "SA", postcode: "5211" },
{ city: "VICTOR HARBOR CENTRAL", state: "SA", postcode: "5211" },
{ city: "WAITPINGA", state: "SA", postcode: "5211" },
{ city: "WILLOW CREEK", state: "SA", postcode: "5211" },
{ city: "YILKI", state: "SA", postcode: "5211" },
{ city: "PORT ELLIOT", state: "SA", postcode: "5212" },
{ city: "MIDDLETON", state: "SA", postcode: "5213" },
{ city: "CURRENCY CREEK", state: "SA", postcode: "5214" },
{ city: "GOOLWA BEACH", state: "SA", postcode: "5214" },
{ city: "GOOLWA NORTH", state: "SA", postcode: "5214" },
{ city: "GOOLWA SOUTH", state: "SA", postcode: "5214" },
{ city: "HINDMARSH ISLAND", state: "SA", postcode: "5214" },
{ city: "MOSQUITO HILL", state: "SA", postcode: "5214" },
{ city: "MUNDOO ISLAND", state: "SA", postcode: "5214" },
{ city: "PARNDANA", state: "SA", postcode: "5220" },
{ city: "AMERICAN RIVER", state: "SA", postcode: "5221" },
{ city: "BALLAST HEAD", state: "SA", postcode: "5221" },
{ city: "MUSTON", state: "SA", postcode: "5221" },
{ city: "AMERICAN BEACH", state: "SA", postcode: "5222" },
{ city: "ANTECHAMBER BAY", state: "SA", postcode: "5222" },
{ city: "BAUDIN BEACH", state: "SA", postcode: "5222" },
{ city: "BROWN BEACH", state: "SA", postcode: "5222" },
{ city: "BROWNS BEACH", state: "SA", postcode: "5222" },
{ city: "CUTTLEFISH BAY", state: "SA", postcode: "5222" },
{ city: "DUDLEY EAST", state: "SA", postcode: "5222" },
{ city: "DUDLEY WEST", state: "SA", postcode: "5222" },
{ city: "HUNGERFORD", state: "SA", postcode: "5222" },
{ city: "IRONSTONE", state: "SA", postcode: "5222" },
{ city: "ISLAND BEACH", state: "SA", postcode: "5222" },
{ city: "KANGAROO HEAD", state: "SA", postcode: "5222" },
{ city: "PELICAN LAGOON", state: "SA", postcode: "5222" },
{ city: "PENNESHAW", state: "SA", postcode: "5222" },
{ city: "PORKY FLAT", state: "SA", postcode: "5222" },
{ city: "SAPPHIRETOWN", state: "SA", postcode: "5222" },
{ city: "WILLOUGHBY", state: "SA", postcode: "5222" },
{ city: "WILLSON RIVER", state: "SA", postcode: "5222" },
{ city: "BAY OF SHOALS", state: "SA", postcode: "5223" },
{ city: "BIRCHMORE", state: "SA", postcode: "5223" },
{ city: "BROWNLOW KI", state: "SA", postcode: "5223" },
{ city: "CAPE BORDA", state: "SA", postcode: "5223" },
{ city: "CASSINI", state: "SA", postcode: "5223" },
{ city: "CYGNET RIVER", state: "SA", postcode: "5223" },
{ city: "DE MOLE RIVER", state: "SA", postcode: "5223" },
{ city: "D'ESTREES BAY", state: "SA", postcode: "5223" },
{ city: "DUNCAN", state: "SA", postcode: "5223" },
{ city: "EMU BAY", state: "SA", postcode: "5223" },
{ city: "FLINDERS CHASE", state: "SA", postcode: "5223" },
{ city: "GOSSE", state: "SA", postcode: "5223" },
{ city: "HAINES", state: "SA", postcode: "5223" },
{ city: "HARRIET RIVER", state: "SA", postcode: "5223" },
{ city: "KARATTA", state: "SA", postcode: "5223" },
{ city: "KINGSCOTE", state: "SA", postcode: "5223" },
{ city: "KOHINOOR", state: "SA", postcode: "5223" },
{ city: "MACGILLIVRAY", state: "SA", postcode: "5223" },
{ city: "MENZIES", state: "SA", postcode: "5223" },
{ city: "MIDDLE RIVER", state: "SA", postcode: "5223" },
{ city: "NEPEAN BAY", state: "SA", postcode: "5223" },
{ city: "NEWLAND", state: "SA", postcode: "5223" },
{ city: "NORTH CAPE", state: "SA", postcode: "5223" },
{ city: "SEAL BAY", state: "SA", postcode: "5223" },
{ city: "SEDDON", state: "SA", postcode: "5223" },
{ city: "STOKES BAY", state: "SA", postcode: "5223" },
{ city: "STUN'SAIL BOOM", state: "SA", postcode: "5223" },
{ city: "VIVONNE BAY", state: "SA", postcode: "5223" },
{ city: "WESTERN RIVER", state: "SA", postcode: "5223" },
{ city: "WISANGER", state: "SA", postcode: "5223" },
{ city: "CHAIN OF PONDS", state: "SA", postcode: "5231" },
{ city: "KERSBROOK", state: "SA", postcode: "5231" },
{ city: "MILLBROOK", state: "SA", postcode: "5231" },
{ city: "CUDLEE CREEK", state: "SA", postcode: "5232" },
{ city: "FORRESTON", state: "SA", postcode: "5233" },
{ city: "GUMERACHA", state: "SA", postcode: "5233" },
{ city: "KENTON VALLEY", state: "SA", postcode: "5233" },
{ city: "WARREN", state: "SA", postcode: "5233" },
{ city: "BIRDWOOD", state: "SA", postcode: "5234" },
{ city: "CROMER", state: "SA", postcode: "5235" },
{ city: "EDEN VALLEY", state: "SA", postcode: "5235" },
{ city: "FLAXMAN VALLEY", state: "SA", postcode: "5235" },
{ city: "MOUNT PLEASANT", state: "SA", postcode: "5235" },
{ city: "SPRINGTON", state: "SA", postcode: "5235" },
{ city: "TAUNTON", state: "SA", postcode: "5235" },
{ city: "TUNGKILLO", state: "SA", postcode: "5236" },
{ city: "APAMURRA", state: "SA", postcode: "5237" },
{ city: "MILENDELLA", state: "SA", postcode: "5237" },
{ city: "PALMER", state: "SA", postcode: "5237" },
{ city: "SANDERSTON", state: "SA", postcode: "5237" },
{ city: "ANGAS VALLEY", state: "SA", postcode: "5238" },
{ city: "BOWHILL", state: "SA", postcode: "5238" },
{ city: "CLAYPANS", state: "SA", postcode: "5238" },
{ city: "COWIRRA", state: "SA", postcode: "5238" },
{ city: "FORSTER", state: "SA", postcode: "5238" },
{ city: "MANNUM", state: "SA", postcode: "5238" },
{ city: "NILDOTTIE", state: "SA", postcode: "5238" },
{ city: "POMPOOTA", state: "SA", postcode: "5238" },
{ city: "PONDE", state: "SA", postcode: "5238" },
{ city: "PUNTHARI", state: "SA", postcode: "5238" },
{ city: "PURNONG LANDING", state: "SA", postcode: "5238" },
{ city: "WALKER FLAT", state: "SA", postcode: "5238" },
{ city: "WONGULLA", state: "SA", postcode: "5238" },
{ city: "WOODLANE", state: "SA", postcode: "5238" },
{ city: "CHARLESTON", state: "SA", postcode: "5244" },
{ city: "MOUNT TORRENS", state: "SA", postcode: "5244" },
{ city: "WISTOW", state: "SA", postcode: "5251" },
{ city: "BRUKUNGA", state: "SA", postcode: "5252" },
{ city: "DAWESLEY", state: "SA", postcode: "5252" },
{ city: "HAY VALLEY", state: "SA", postcode: "5252" },
{ city: "KANMANTOO", state: "SA", postcode: "5252" },
{ city: "NAIRNE", state: "SA", postcode: "5252" },
{ city: "ST IVES", state: "SA", postcode: "5252" },
{ city: "AVOCA DELL", state: "SA", postcode: "5253" },
{ city: "BRINKLEY", state: "SA", postcode: "5253" },
{ city: "BURDETT", state: "SA", postcode: "5253" },
{ city: "CHAPMAN BORE", state: "SA", postcode: "5253" },
{ city: "ETTRICK", state: "SA", postcode: "5253" },
{ city: "GIFFORD HILL", state: "SA", postcode: "5253" },
{ city: "GREENBANKS", state: "SA", postcode: "5253" },
{ city: "LONG FLAT", state: "SA", postcode: "5253" },
{ city: "MOBILONG", state: "SA", postcode: "5253" },
{ city: "MONTEITH", state: "SA", postcode: "5253" },
{ city: "MURRAWONG", state: "SA", postcode: "5253" },
{ city: "MURRAY BRIDGE", state: "SA", postcode: "5253" },
{ city: "MURRAY BRIDGE EAST", state: "SA", postcode: "5253" },
{ city: "MURRAY BRIDGE NORTH", state: "SA", postcode: "5253" },
{ city: "MURRAY BRIDGE SOUTH", state: "SA", postcode: "5253" },
{ city: "NORTHERN HEIGHTS", state: "SA", postcode: "5253" },
{ city: "RIVERGLADES", state: "SA", postcode: "5253" },
{ city: "RIVERGLEN", state: "SA", postcode: "5253" },
{ city: "ROCKY GULLY", state: "SA", postcode: "5253" },
{ city: "SUNNYSIDE", state: "SA", postcode: "5253" },
{ city: "SWANPORT", state: "SA", postcode: "5253" },
{ city: "TOORA", state: "SA", postcode: "5253" },
{ city: "WHITE HILL", state: "SA", postcode: "5253" },
{ city: "WHITE SANDS", state: "SA", postcode: "5253" },
{ city: "WILLOW BANKS", state: "SA", postcode: "5253" },
{ city: "WOODS POINT", state: "SA", postcode: "5253" },
{ city: "CALLINGTON", state: "SA", postcode: "5254" },
{ city: "CALOOTE", state: "SA", postcode: "5254" },
{ city: "MONARTO", state: "SA", postcode: "5254" },
{ city: "MONARTO SOUTH", state: "SA", postcode: "5254" },
{ city: "MONTEITH", state: "SA", postcode: "5254" },
{ city: "MURRAY BRIDGE", state: "SA", postcode: "5254" },
{ city: "MYPOLONGA", state: "SA", postcode: "5254" },
{ city: "PALLAMANA", state: "SA", postcode: "5254" },
{ city: "PETWOOD", state: "SA", postcode: "5254" },
{ city: "ROCKLEIGH", state: "SA", postcode: "5254" },
{ city: "ROCKY GULLY", state: "SA", postcode: "5254" },
{ city: "TEPKO", state: "SA", postcode: "5254" },
{ city: "WALL FLAT", state: "SA", postcode: "5254" },
{ city: "WHITE HILL", state: "SA", postcode: "5254" },
{ city: "WOODLANE", state: "SA", postcode: "5254" },
{ city: "ZADOWS LANDING", state: "SA", postcode: "5254" },
{ city: "ANGAS PLAINS", state: "SA", postcode: "5255" },
{ city: "BELVIDERE", state: "SA", postcode: "5255" },
{ city: "BLETCHLEY", state: "SA", postcode: "5255" },
{ city: "FINNISS", state: "SA", postcode: "5255" },
{ city: "GEMMELLS", state: "SA", postcode: "5255" },
{ city: "HARTLEY", state: "SA", postcode: "5255" },
{ city: "HIGHLAND VALLEY", state: "SA", postcode: "5255" },
{ city: "LAKE PLAINS", state: "SA", postcode: "5255" },
{ city: "LANGHORNE CREEK", state: "SA", postcode: "5255" },
{ city: "MOUNT OBSERVATION", state: "SA", postcode: "5255" },
{ city: "MULGUNDAWA", state: "SA", postcode: "5255" },
{ city: "NALPA", state: "SA", postcode: "5255" },
{ city: "RED CREEK", state: "SA", postcode: "5255" },
{ city: "SALEM", state: "SA", postcode: "5255" },
{ city: "SANDERGROVE", state: "SA", postcode: "5255" },
{ city: "STRATHALBYN", state: "SA", postcode: "5255" },
{ city: "TOOPERANG", state: "SA", postcode: "5255" },
{ city: "WILLYAROO", state: "SA", postcode: "5255" },
{ city: "WOODCHESTER", state: "SA", postcode: "5255" },
{ city: "CLAYTON BAY", state: "SA", postcode: "5256" },
{ city: "MILANG", state: "SA", postcode: "5256" },
{ city: "NURRAGI", state: "SA", postcode: "5256" },
{ city: "POINT STURT", state: "SA", postcode: "5256" },
{ city: "TOLDEROL", state: "SA", postcode: "5256" },
{ city: "ASHVILLE", state: "SA", postcode: "5259" },
{ city: "JERVOIS", state: "SA", postcode: "5259" },
{ city: "KEPA", state: "SA", postcode: "5259" },
{ city: "MALINONG", state: "SA", postcode: "5259" },
{ city: "NARRUNG", state: "SA", postcode: "5259" },
{ city: "NATURI", state: "SA", postcode: "5259" },
{ city: "POINT MCLEAY", state: "SA", postcode: "5259" },
{ city: "POLTALLOCH", state: "SA", postcode: "5259" },
{ city: "RAUKKAN", state: "SA", postcode: "5259" },
{ city: "TAILEM BEND", state: "SA", postcode: "5259" },
{ city: "WELLINGTON", state: "SA", postcode: "5259" },
{ city: "WELLINGTON EAST", state: "SA", postcode: "5259" },
{ city: "ELWOMPLE", state: "SA", postcode: "5260" },
{ city: "TAILEM BEND", state: "SA", postcode: "5260" },
{ city: "COOKE PLAINS", state: "SA", postcode: "5261" },
{ city: "COOMANDOOK", state: "SA", postcode: "5261" },
{ city: "CULBURRA", state: "SA", postcode: "5261" },
{ city: "KI KI", state: "SA", postcode: "5261" },
{ city: "YUMALI", state: "SA", postcode: "5261" },
{ city: "BINNUM", state: "SA", postcode: "5262" },
{ city: "FRANCES", state: "SA", postcode: "5262" },
{ city: "HYNAM", state: "SA", postcode: "5262" },
{ city: "KYBYBOLITE", state: "SA", postcode: "5262" },
{ city: "COONAWARRA", state: "SA", postcode: "5263" },
{ city: "COORONG", state: "SA", postcode: "5264" },
{ city: "MENINGIE", state: "SA", postcode: "5264" },
{ city: "MENINGIE EAST", state: "SA", postcode: "5264" },
{ city: "MENINGIE WEST", state: "SA", postcode: "5264" },
{ city: "POLICEMAN POINT", state: "SA", postcode: "5264" },
{ city: "SALT CREEK", state: "SA", postcode: "5264" },
{ city: "WALTOWA", state: "SA", postcode: "5264" },
{ city: "COONALPYN", state: "SA", postcode: "5265" },
{ city: "FIELD", state: "SA", postcode: "5265" },
{ city: "BUNBURY", state: "SA", postcode: "5266" },
{ city: "COLEBATCH", state: "SA", postcode: "5266" },
{ city: "DEEPWATER", state: "SA", postcode: "5266" },
{ city: "TINTINARA", state: "SA", postcode: "5266" },
{ city: "BRIMBAGO", state: "SA", postcode: "5267" },
{ city: "COOMBE", state: "SA", postcode: "5267" },
{ city: "KEITH", state: "SA", postcode: "5267" },
{ city: "LAFFER", state: "SA", postcode: "5267" },
{ city: "MAKIN", state: "SA", postcode: "5267" },
{ city: "MCCALLUM", state: "SA", postcode: "5267" },
{ city: "MOUNT CHARLES", state: "SA", postcode: "5267" },
{ city: "PETHERICK", state: "SA", postcode: "5267" },
{ city: "SHAUGH", state: "SA", postcode: "5267" },
{ city: "SHERWOOD", state: "SA", postcode: "5267" },
{ city: "WILLALOOKA", state: "SA", postcode: "5267" },
{ city: "WIRREGA", state: "SA", postcode: "5267" },
{ city: "BANGHAM", state: "SA", postcode: "5268" },
{ city: "BORDERTOWN", state: "SA", postcode: "5268" },
{ city: "BORDERTOWN SOUTH", state: "SA", postcode: "5268" },
{ city: "CANNAWIGARA", state: "SA", postcode: "5268" },
{ city: "LOWAN VALE", state: "SA", postcode: "5268" },
{ city: "POOGINAGORIC", state: "SA", postcode: "5268" },
{ city: "SENIOR", state: "SA", postcode: "5268" },
{ city: "WESTERN FLAT", state: "SA", postcode: "5268" },
{ city: "CUSTON", state: "SA", postcode: "5269" },
{ city: "PINE HILL", state: "SA", postcode: "5269" },
{ city: "WOLSELEY", state: "SA", postcode: "5269" },
{ city: "BUCKINGHAM", state: "SA", postcode: "5270" },
{ city: "CAREW", state: "SA", postcode: "5270" },
{ city: "KONGAL", state: "SA", postcode: "5270" },
{ city: "MUNDULLA", state: "SA", postcode: "5270" },
{ city: "MUNDULLA WEST", state: "SA", postcode: "5270" },
{ city: "SWEDE FLAT", state: "SA", postcode: "5270" },
{ city: "BOOL LAGOON", state: "SA", postcode: "5271" },
{ city: "CADGEE", state: "SA", postcode: "5271" },
{ city: "JOANNA", state: "SA", postcode: "5271" },
{ city: "KEPPOCH", state: "SA", postcode: "5271" },
{ city: "KOPPAMURRA", state: "SA", postcode: "5271" },
{ city: "LAURIE PARK", state: "SA", postcode: "5271" },
{ city: "LOCHABER", state: "SA", postcode: "5271" },
{ city: "MARCOLLAT", state: "SA", postcode: "5271" },
{ city: "MOUNT LIGHT", state: "SA", postcode: "5271" },
{ city: "MOYHALL", state: "SA", postcode: "5271" },
{ city: "NARACOORTE", state: "SA", postcode: "5271" },
{ city: "PADTHAWAY", state: "SA", postcode: "5271" },
{ city: "SPENCE", state: "SA", postcode: "5271" },
{ city: "STEWART RANGE", state: "SA", postcode: "5271" },
{ city: "STRUAN", state: "SA", postcode: "5271" },
{ city: "THE GAP", state: "SA", postcode: "5271" },
{ city: "WILD DOG VALLEY", state: "SA", postcode: "5271" },
{ city: "WRATTONBULLY", state: "SA", postcode: "5271" },
{ city: "COLES", state: "SA", postcode: "5272" },
{ city: "CONMURRA", state: "SA", postcode: "5272" },
{ city: "FOX", state: "SA", postcode: "5272" },
{ city: "GREENWAYS", state: "SA", postcode: "5272" },
{ city: "LUCINDALE", state: "SA", postcode: "5272" },
{ city: "WOOLUMBOOL", state: "SA", postcode: "5272" },
{ city: "AVENUE RANGE", state: "SA", postcode: "5273" },
{ city: "BLACKFORD", state: "SA", postcode: "5275" },
{ city: "BOATSWAIN POINT", state: "SA", postcode: "5275" },
{ city: "CAPE JAFFA", state: "SA", postcode: "5275" },
{ city: "KEILIRA", state: "SA", postcode: "5275" },
{ city: "KINGSTON SE", state: "SA", postcode: "5275" },
{ city: "MOUNT BENSON", state: "SA", postcode: "5275" },
{ city: "PINKS BEACH", state: "SA", postcode: "5275" },
{ city: "REEDY CREEK", state: "SA", postcode: "5275" },
{ city: "ROSETOWN", state: "SA", postcode: "5275" },
{ city: "SANDY GROVE", state: "SA", postcode: "5275" },
{ city: "TARATAP", state: "SA", postcode: "5275" },
{ city: "TILLEY SWAMP", state: "SA", postcode: "5275" },
{ city: "WANGOLINA", state: "SA", postcode: "5275" },
{ city: "WEST RANGE", state: "SA", postcode: "5275" },
{ city: "WYOMI", state: "SA", postcode: "5275" },
{ city: "BRAY", state: "SA", postcode: "5276" },
{ city: "NORA CREINA", state: "SA", postcode: "5276" },
{ city: "ROBE", state: "SA", postcode: "5276" },
{ city: "COMAUM", state: "SA", postcode: "5277" },
{ city: "GLENROY", state: "SA", postcode: "5277" },
{ city: "MAAOUPE", state: "SA", postcode: "5277" },
{ city: "MONBULLA", state: "SA", postcode: "5277" },
{ city: "NANGWARRY", state: "SA", postcode: "5277" },
{ city: "PENOLA", state: "SA", postcode: "5277" },
{ city: "PLEASANT PARK", state: "SA", postcode: "5277" },
{ city: "TARPEENA", state: "SA", postcode: "5277" },
{ city: "KALANGADOO", state: "SA", postcode: "5278" },
{ city: "KRONGART", state: "SA", postcode: "5278" },
{ city: "MOERLONG", state: "SA", postcode: "5278" },
{ city: "WEPAR", state: "SA", postcode: "5278" },
{ city: "KOORINE", state: "SA", postcode: "5279" },
{ city: "MOUNT BURR", state: "SA", postcode: "5279" },
{ city: "MOUNT MCINTYRE", state: "SA", postcode: "5279" },
{ city: "SHORT", state: "SA", postcode: "5279" },
{ city: "TRIHI", state: "SA", postcode: "5279" },
{ city: "WATTLE RANGE EAST", state: "SA", postcode: "5279" },
{ city: "BEACHPORT", state: "SA", postcode: "5280" },
{ city: "CANUNDA", state: "SA", postcode: "5280" },
{ city: "CLAY WELLS", state: "SA", postcode: "5280" },
{ city: "FURNER", state: "SA", postcode: "5280" },
{ city: "GERMAN CREEK", state: "SA", postcode: "5280" },
{ city: "GERMAN FLAT", state: "SA", postcode: "5280" },
{ city: "HATHERLEIGH", state: "SA", postcode: "5280" },
{ city: "KANGAROO INN", state: "SA", postcode: "5280" },
{ city: "MAGAREY", state: "SA", postcode: "5280" },
{ city: "MILLICENT", state: "SA", postcode: "5280" },
{ city: "RENDELSHAM", state: "SA", postcode: "5280" },
{ city: "ROCKY CAMP", state: "SA", postcode: "5280" },
{ city: "SEBASTOPOL", state: "SA", postcode: "5280" },
{ city: "SOUTHEND", state: "SA", postcode: "5280" },
{ city: "TANTANOOLA", state: "SA", postcode: "5280" },
{ city: "THORNLEA", state: "SA", postcode: "5280" },
{ city: "WATTLE RANGE", state: "SA", postcode: "5280" },
{ city: "ALLENDALE EAST", state: "SA", postcode: "5291" },
{ city: "BLACKFELLOWS CAVES", state: "SA", postcode: "5291" },
{ city: "BURRUNGULE", state: "SA", postcode: "5291" },
{ city: "CANUNDA", state: "SA", postcode: "5291" },
{ city: "CAPE DOUGLAS", state: "SA", postcode: "5291" },
{ city: "CAROLINE", state: "SA", postcode: "5291" },
{ city: "CARPENTER ROCKS", state: "SA", postcode: "5291" },
{ city: "CAVETON", state: "SA", postcode: "5291" },
{ city: "COMPTON", state: "SA", postcode: "5291" },
{ city: "DISMAL SWAMP", state: "SA", postcode: "5291" },
{ city: "DONOVANS", state: "SA", postcode: "5291" },
{ city: "EIGHT MILE CREEK", state: "SA", postcode: "5291" },
{ city: "GERMAN CREEK", state: "SA", postcode: "5291" },
{ city: "GLENBURNIE", state: "SA", postcode: "5291" },
{ city: "GLENCOE", state: "SA", postcode: "5291" },
{ city: "GLENCOE WEST", state: "SA", postcode: "5291" },
{ city: "KONGORONG", state: "SA", postcode: "5291" },
{ city: "MIL LEL", state: "SA", postcode: "5291" },
{ city: "MIL-LEL", state: "SA", postcode: "5291" },
{ city: "MINGBOOL", state: "SA", postcode: "5291" },
{ city: "MOORAK", state: "SA", postcode: "5291" },
{ city: "MOUNT SCHANK", state: "SA", postcode: "5291" },
{ city: "NENE VALLEY", state: "SA", postcode: "5291" },
{ city: "OB FLAT", state: "SA", postcode: "5291" },
{ city: "PELICAN POINT", state: "SA", postcode: "5291" },
{ city: "PORT MACDONNELL", state: "SA", postcode: "5291" },
{ city: "RACECOURSE BAY", state: "SA", postcode: "5291" },
{ city: "SQUARE MILE", state: "SA", postcode: "5291" },
{ city: "SUTTONTOWN", state: "SA", postcode: "5291" },
{ city: "WANDILO", state: "SA", postcode: "5291" },
{ city: "WORROLONG", state: "SA", postcode: "5291" },
{ city: "WYE", state: "SA", postcode: "5291" },
{ city: "YAHL", state: "SA", postcode: "5291" },
{ city: "CARCUMA", state: "SA", postcode: "5301" },
{ city: "GERANIUM", state: "SA", postcode: "5301" },
{ city: "JABUK", state: "SA", postcode: "5301" },
{ city: "MOORLANDS", state: "SA", postcode: "5301" },
{ city: "NETHERTON", state: "SA", postcode: "5301" },
{ city: "PARRAKIE", state: "SA", postcode: "5301" },
{ city: "PEAKE", state: "SA", postcode: "5301" },
{ city: "SHERLOCK", state: "SA", postcode: "5301" },
{ city: "WILKAWATT", state: "SA", postcode: "5301" },
{ city: "LAMEROO", state: "SA", postcode: "5302" },
{ city: "NGARKAT", state: "SA", postcode: "5302" },
{ city: "PARILLA", state: "SA", postcode: "5303" },
{ city: "KARTE", state: "SA", postcode: "5304" },
{ city: "KRINGIN", state: "SA", postcode: "5304" },
{ city: "PEEBINGA", state: "SA", postcode: "5304" },
{ city: "PINNAROO", state: "SA", postcode: "5304" },
{ city: "WYNARKA", state: "SA", postcode: "5306" },
{ city: "KAROONDA", state: "SA", postcode: "5307" },
{ city: "KARTE", state: "SA", postcode: "5307" },
{ city: "KULKAMI", state: "SA", postcode: "5307" },
{ city: "MARAMA", state: "SA", postcode: "5307" },
{ city: "MOOTATUNGA", state: "SA", postcode: "5307" },
{ city: "COPEVILLE", state: "SA", postcode: "5308" },
{ city: "GALGA", state: "SA", postcode: "5308" },
{ city: "KALYAN", state: "SA", postcode: "5308" },
{ city: "MANTUNG", state: "SA", postcode: "5308" },
{ city: "MERCUNDA", state: "SA", postcode: "5308" },
{ city: "PERPONDA", state: "SA", postcode: "5308" },
{ city: "BORRIKA", state: "SA", postcode: "5309" },
{ city: "HALIDON", state: "SA", postcode: "5309" },
{ city: "MINDARIE", state: "SA", postcode: "5309" },
{ city: "SANDALWOOD", state: "SA", postcode: "5309" },
{ city: "CALIPH", state: "SA", postcode: "5310" },
{ city: "WANBI", state: "SA", postcode: "5310" },
{ city: "ALAWOONA", state: "SA", postcode: "5311" },
{ city: "BILLIATT", state: "SA", postcode: "5311" },
{ city: "BUGLE HUT", state: "SA", postcode: "5311" },
{ city: "MAGGEA", state: "SA", postcode: "5311" },
{ city: "MALPAS", state: "SA", postcode: "5311" },
{ city: "MERIBAH", state: "SA", postcode: "5311" },
{ city: "PARUNA", state: "SA", postcode: "5311" },
{ city: "SCHELL WELL", state: "SA", postcode: "5311" },
{ city: "TALDRA", state: "SA", postcode: "5311" },
{ city: "TAPLAN", state: "SA", postcode: "5311" },
{ city: "VEITCH", state: "SA", postcode: "5311" },
{ city: "WOODLEIGH", state: "SA", postcode: "5311" },
{ city: "WUNKAR", state: "SA", postcode: "5311" },
{ city: "BEATTY", state: "SA", postcode: "5320" },
{ city: "BEAUMONTS", state: "SA", postcode: "5320" },
{ city: "BRENDA PARK", state: "SA", postcode: "5320" },
{ city: "BUNDEY", state: "SA", postcode: "5320" },
{ city: "EBA", state: "SA", postcode: "5320" },
{ city: "LINDLEY", state: "SA", postcode: "5320" },
{ city: "MAUDE", state: "SA", postcode: "5320" },
{ city: "MORGAN", state: "SA", postcode: "5320" },
{ city: "MORPHETTS FLAT", state: "SA", postcode: "5320" },
{ city: "MURBKO", state: "SA", postcode: "5320" },
{ city: "NORTH WEST BEND", state: "SA", postcode: "5320" },
{ city: "STUART", state: "SA", postcode: "5320" },
{ city: "WESTONS FLAT", state: "SA", postcode: "5320" },
{ city: "WOMBATS REST", state: "SA", postcode: "5320" },
{ city: "CADELL", state: "SA", postcode: "5321" },
{ city: "CADELL LAGOON", state: "SA", postcode: "5321" },
{ city: "GOLDEN HEIGHTS", state: "SA", postcode: "5322" },
{ city: "QUALCO", state: "SA", postcode: "5322" },
{ city: "RAMCO", state: "SA", postcode: "5322" },
{ city: "RAMCO HEIGHTS", state: "SA", postcode: "5322" },
{ city: "SUNLANDS", state: "SA", postcode: "5322" },
{ city: "BOOLGUN", state: "SA", postcode: "5330" },
{ city: "DEVLINS POUND", state: "SA", postcode: "5330" },
{ city: "GOOD HOPE LANDING", state: "SA", postcode: "5330" },
{ city: "HAWKS NEST STATION", state: "SA", postcode: "5330" },
{ city: "HOLDER", state: "SA", postcode: "5330" },
{ city: "HOLDER SIDING", state: "SA", postcode: "5330" },
{ city: "KANNI", state: "SA", postcode: "5330" },
{ city: "LOWBANK", state: "SA", postcode: "5330" },
{ city: "MARKARANKA", state: "SA", postcode: "5330" },
{ city: "OVERLAND CORNER", state: "SA", postcode: "5330" },
{ city: "POOGINOOK", state: "SA", postcode: "5330" },
{ city: "STOCKYARD PLAIN", state: "SA", postcode: "5330" },
{ city: "TAYLORVILLE", state: "SA", postcode: "5330" },
{ city: "TAYLORVILLE STATION", state: "SA", postcode: "5330" },
{ city: "WAIKERIE", state: "SA", postcode: "5330" },
{ city: "WIGLEY FLAT", state: "SA", postcode: "5330" },
{ city: "WOOLPUNDA", state: "SA", postcode: "5330" },
{ city: "KINGSTON ON MURRAY", state: "SA", postcode: "5331" },
{ city: "MOOROOK", state: "SA", postcode: "5332" },
{ city: "MOOROOK SOUTH", state: "SA", postcode: "5332" },
{ city: "WAPPILKA", state: "SA", postcode: "5332" },
{ city: "YINKANIE", state: "SA", postcode: "5332" },
{ city: "BOOKPURNONG", state: "SA", postcode: "5333" },
{ city: "LOXTON", state: "SA", postcode: "5333" },
{ city: "LOXTON NORTH", state: "SA", postcode: "5333" },
{ city: "NEW RESIDENCE", state: "SA", postcode: "5333" },
{ city: "PATA", state: "SA", postcode: "5333" },
{ city: "PYAP", state: "SA", postcode: "5333" },
{ city: "PYAP WEST", state: "SA", postcode: "5333" },
{ city: "MUNDIC CREEK", state: "SA", postcode: "5340" },
{ city: "MURTHO", state: "SA", postcode: "5340" },
{ city: "PARINGA", state: "SA", postcode: "5340" },
{ city: "PIKE RIVER", state: "SA", postcode: "5340" },
{ city: "WONUARRA", state: "SA", postcode: "5340" },
{ city: "YAMBA", state: "SA", postcode: "5340" },
{ city: "CALPERUM STATION", state: "SA", postcode: "5341" },
{ city: "CHAFFEY", state: "SA", postcode: "5341" },
{ city: "CHOWILLA", state: "SA", postcode: "5341" },
{ city: "COOLTONG", state: "SA", postcode: "5341" },
{ city: "CRESCENT", state: "SA", postcode: "5341" },
{ city: "OLD CALPERUM", state: "SA", postcode: "5341" },
{ city: "RENMARK", state: "SA", postcode: "5341" },
{ city: "RENMARK NORTH", state: "SA", postcode: "5341" },
{ city: "RENMARK SOUTH", state: "SA", postcode: "5341" },
{ city: "RENMARK WEST", state: "SA", postcode: "5341" },
{ city: "MONASH", state: "SA", postcode: "5342" },
{ city: "BERRI", state: "SA", postcode: "5343" },
{ city: "GERARD", state: "SA", postcode: "5343" },
{ city: "GURRA GURRA", state: "SA", postcode: "5343" },
{ city: "KATARAPKO", state: "SA", postcode: "5343" },
{ city: "LYRUP", state: "SA", postcode: "5343" },
{ city: "WINKIE", state: "SA", postcode: "5343" },
{ city: "GLOSSOP", state: "SA", postcode: "5344" },
{ city: "BARMERA", state: "SA", postcode: "5345" },
{ city: "LOVEDAY", state: "SA", postcode: "5345" },
{ city: "SPECTACLE LAKE", state: "SA", postcode: "5345" },
{ city: "COBDOGLA", state: "SA", postcode: "5346" },
{ city: "ROSEDALE", state: "SA", postcode: "5350" },
{ city: "SANDY CREEK", state: "SA", postcode: "5350" },
{ city: "ALTONA", state: "SA", postcode: "5351" },
{ city: "BAROSSA GOLDFIELDS", state: "SA", postcode: "5351" },
{ city: "COCKATOO VALLEY", state: "SA", postcode: "5351" },
{ city: "LYNDOCH", state: "SA", postcode: "5351" },
{ city: "MOUNT CRAWFORD", state: "SA", postcode: "5351" },
{ city: "PEWSEY VALE", state: "SA", postcode: "5351" },
{ city: "WILLIAMSTOWN", state: "SA", postcode: "5351" },
{ city: "BETHANY", state: "SA", postcode: "5352" },
{ city: "GOMERSAL", state: "SA", postcode: "5352" },
{ city: "KRONDORF", state: "SA", postcode: "5352" },
{ city: "ROWLAND FLAT", state: "SA", postcode: "5352" },
{ city: "STONE WELL", state: "SA", postcode: "5352" },
{ city: "TANUNDA", state: "SA", postcode: "5352" },
{ city: "VINE VALE", state: "SA", postcode: "5352" },
{ city: "ANGASTON", state: "SA", postcode: "5353" },
{ city: "BLACK HILL", state: "SA", postcode: "5353" },
{ city: "CAMBRAI", state: "SA", postcode: "5353" },
{ city: "FLAXMAN VALLEY", state: "SA", postcode: "5353" },
{ city: "KEYNETON", state: "SA", postcode: "5353" },
{ city: "KONGOLIA", state: "SA", postcode: "5353" },
{ city: "LANGS LANDING", state: "SA", postcode: "5353" },
{ city: "MARKS LANDING", state: "SA", postcode: "5353" },
{ city: "MOCULTA", state: "SA", postcode: "5353" },
{ city: "MOUNT MCKENZIE", state: "SA", postcode: "5353" },
{ city: "PENRICE", state: "SA", postcode: "5353" },
{ city: "PUNYELROO", state: "SA", postcode: "5353" },
{ city: "SEDAN", state: "SA", postcode: "5353" },
{ city: "SUNNYDALE", state: "SA", postcode: "5353" },
{ city: "TOWITTA", state: "SA", postcode: "5353" },
{ city: "BAKARA", state: "SA", postcode: "5354" },
{ city: "BAKARA WELL", state: "SA", postcode: "5354" },
{ city: "FISHER", state: "SA", postcode: "5354" },
{ city: "GREENWAYS LANDING", state: "SA", postcode: "5354" },
{ city: "LANGS LANDING", state: "SA", postcode: "5354" },
{ city: "MARKS LANDING", state: "SA", postcode: "5354" },
{ city: "NAIDIA", state: "SA", postcode: "5354" },
{ city: "PUNYELROO", state: "SA", postcode: "5354" },
{ city: "SUNNYDALE", state: "SA", postcode: "5354" },
{ city: "SWAN REACH", state: "SA", postcode: "5354" },
{ city: "DAVEYSTON", state: "SA", postcode: "5355" },
{ city: "EBENEZER", state: "SA", postcode: "5355" },
{ city: "LIGHT PASS", state: "SA", postcode: "5355" },
{ city: "MARANANGA", state: "SA", postcode: "5355" },
{ city: "MOPPA", state: "SA", postcode: "5355" },
{ city: "NURIOOTPA", state: "SA", postcode: "5355" },
{ city: "SEPPELTSFIELD", state: "SA", postcode: "5355" },
{ city: "STOCKWELL", state: "SA", postcode: "5355" },
{ city: "ANNADALE", state: "SA", postcode: "5356" },
{ city: "DUTTON", state: "SA", postcode: "5356" },
{ city: "DUTTON EAST", state: "SA", postcode: "5356" },
{ city: "SANDLETON", state: "SA", postcode: "5356" },
{ city: "STEINFELD", state: "SA", postcode: "5356" },
{ city: "ST KITTS", state: "SA", postcode: "5356" },
{ city: "STONEFIELD", state: "SA", postcode: "5356" },
{ city: "TRURO", state: "SA", postcode: "5356" },
{ city: "BLANCHETOWN", state: "SA", postcode: "5357" },
{ city: "MCBEAN POUND", state: "SA", postcode: "5357" },
{ city: "NEW WELL", state: "SA", postcode: "5357" },
{ city: "NOTTS WELL", state: "SA", postcode: "5357" },
{ city: "PAISLEY", state: "SA", postcode: "5357" },
{ city: "WIGLEY FLAT", state: "SA", postcode: "5357" },
{ city: "GREENOCK", state: "SA", postcode: "5360" },
{ city: "NAIN", state: "SA", postcode: "5360" },
{ city: "MORN HILL", state: "SA", postcode: "5371" },
{ city: "ROSEWORTHY", state: "SA", postcode: "5371" },
{ city: "TEMPLERS", state: "SA", postcode: "5371" },
{ city: "FREELING", state: "SA", postcode: "5372" },
{ city: "ALLENDALE NORTH", state: "SA", postcode: "5373" },
{ city: "BAGOT WELL", state: "SA", postcode: "5373" },
{ city: "BETHEL", state: "SA", postcode: "5373" },
{ city: "FORDS", state: "SA", postcode: "5373" },
{ city: "HAMILTON", state: "SA", postcode: "5373" },
{ city: "KAPUNDA", state: "SA", postcode: "5373" },
{ city: "KOONUNGA", state: "SA", postcode: "5373" },
{ city: "ST JOHNS", state: "SA", postcode: "5373" },
{ city: "AUSTRALIA PLAINS", state: "SA", postcode: "5374" },
{ city: "BOWER", state: "SA", postcode: "5374" },
{ city: "BROWNLOW", state: "SA", postcode: "5374" },
{ city: "BUCHANAN", state: "SA", postcode: "5374" },
{ city: "EUDUNDA", state: "SA", postcode: "5374" },
{ city: "FRANKTON", state: "SA", postcode: "5374" },
{ city: "HAMPDEN", state: "SA", postcode: "5374" },
{ city: "HANSBOROUGH", state: "SA", postcode: "5374" },
{ city: "JULIA", state: "SA", postcode: "5374" },
{ city: "MOUNT MARY", state: "SA", postcode: "5374" },
{ city: "NEALES FLAT", state: "SA", postcode: "5374" },
{ city: "NGAPALA", state: "SA", postcode: "5374" },
{ city: "PEEP HILL", state: "SA", postcode: "5374" },
{ city: "POINT PASS", state: "SA", postcode: "5374" },
{ city: "SUTHERLANDS", state: "SA", postcode: "5374" },
{ city: "BRADY CREEK", state: "SA", postcode: "5381" },
{ city: "BRIGHT", state: "SA", postcode: "5381" },
{ city: "EMU DOWNS", state: "SA", postcode: "5381" },
{ city: "GERANIUM PLAINS", state: "SA", postcode: "5381" },
{ city: "HALLELUJAH HILLS", state: "SA", postcode: "5381" },
{ city: "ROBERTSTOWN", state: "SA", postcode: "5381" },
{ city: "ROCKY PLAIN", state: "SA", postcode: "5381" },
{ city: "WORLDS END", state: "SA", postcode: "5381" },
{ city: "WORLDS END CREEK", state: "SA", postcode: "5381" },
{ city: "ALMA", state: "SA", postcode: "5401" },
{ city: "HAMLEY BRIDGE", state: "SA", postcode: "5401" },
{ city: "SALTER SPRINGS", state: "SA", postcode: "5401" },
{ city: "LINWOOD", state: "SA", postcode: "5410" },
{ city: "STOCKPORT", state: "SA", postcode: "5410" },
{ city: "GILES CORNER", state: "SA", postcode: "5411" },
{ city: "TARLEE", state: "SA", postcode: "5411" },
{ city: "NAVAN", state: "SA", postcode: "5412" },
{ city: "RHYNIE", state: "SA", postcode: "5412" },
{ city: "RIVERTON", state: "SA", postcode: "5412" },
{ city: "WOOLSHED FLAT", state: "SA", postcode: "5412" },
{ city: "APOINGA", state: "SA", postcode: "5413" },
{ city: "BLACK SPRINGS", state: "SA", postcode: "5413" },
{ city: "MARRABEL", state: "SA", postcode: "5413" },
{ city: "SADDLEWORTH", state: "SA", postcode: "5413" },
{ city: "STEELTON", state: "SA", postcode: "5413" },
{ city: "TARNMA", state: "SA", postcode: "5413" },
{ city: "TOTHILL BELT", state: "SA", postcode: "5413" },
{ city: "TOTHILL CREEK", state: "SA", postcode: "5413" },
{ city: "WATERLOO", state: "SA", postcode: "5413" },
{ city: "MANOORA", state: "SA", postcode: "5414" },
{ city: "MINTARO", state: "SA", postcode: "5415" },
{ city: "STANLEY", state: "SA", postcode: "5415" },
{ city: "FARRELL FLAT", state: "SA", postcode: "5416" },
{ city: "PORTER LAGOON", state: "SA", postcode: "5416" },
{ city: "BALAH", state: "SA", postcode: "5417" },
{ city: "BALDINA", state: "SA", postcode: "5417" },
{ city: "BOOBOROWIE", state: "SA", postcode: "5417" },
{ city: "BUNYUNG", state: "SA", postcode: "5417" },
{ city: "BURRA", state: "SA", postcode: "5417" },
{ city: "BURRA EASTERN DISTRICTS", state: "SA", postcode: "5417" },
{ city: "CANEGRASS", state: "SA", postcode: "5417" },
{ city: "DANGGALI", state: "SA", postcode: "5417" },
{ city: "FARAWAY HILL", state: "SA", postcode: "5417" },
{ city: "GLUEPOT", state: "SA", postcode: "5417" },
{ city: "GUM CREEK", state: "SA", postcode: "5417" },
{ city: "HANSON", state: "SA", postcode: "5417" },
{ city: "KOONOONA", state: "SA", postcode: "5417" },
{ city: "LEIGHTON", state: "SA", postcode: "5417" },
{ city: "MONGOLATA", state: "SA", postcode: "5417" },
{ city: "NORTH BOOBOROWIE", state: "SA", postcode: "5417" },
{ city: "OAKVALE STATION", state: "SA", postcode: "5417" },
{ city: "OLD KOOMOOLOO", state: "SA", postcode: "5417" },
{ city: "PARCOOLA", state: "SA", postcode: "5417" },
{ city: "PINE VALLEY STATION", state: "SA", postcode: "5417" },
{ city: "QUONDONG", state: "SA", postcode: "5417" },
{ city: "STURT VALE", state: "SA", postcode: "5417" },
{ city: "WARNES", state: "SA", postcode: "5417" },
{ city: "COLLINSVILLE", state: "SA", postcode: "5418" },
{ city: "MOUNT BRYAN", state: "SA", postcode: "5418" },
{ city: "CANOWIE", state: "SA", postcode: "5419" },
{ city: "HALLETT", state: "SA", postcode: "5419" },
{ city: "MOUNT BRYAN EAST", state: "SA", postcode: "5419" },
{ city: "PINE CREEK", state: "SA", postcode: "5419" },
{ city: "ULOOLOO", state: "SA", postcode: "5419" },
{ city: "WILLALO", state: "SA", postcode: "5419" },
{ city: "WONNA", state: "SA", postcode: "5419" },
{ city: "CANOWIE BELT", state: "SA", postcode: "5420" },
{ city: "WHYTE YARCOWIE", state: "SA", postcode: "5420" },
{ city: "FRANKLYN", state: "SA", postcode: "5421" },
{ city: "TEROWIE", state: "SA", postcode: "5421" },
{ city: "CAVENAGH", state: "SA", postcode: "5422" },
{ city: "DAWSON", state: "SA", postcode: "5422" },
{ city: "ERSKINE", state: "SA", postcode: "5422" },
{ city: "HARDY", state: "SA", postcode: "5422" },
{ city: "MANNANARIE", state: "SA", postcode: "5422" },
{ city: "MINVALARA", state: "SA", postcode: "5422" },
{ city: "OODLA WIRRA", state: "SA", postcode: "5422" },
{ city: "PARATOO", state: "SA", postcode: "5422" },
{ city: "PARNAROO", state: "SA", postcode: "5422" },
{ city: "PETERBOROUGH", state: "SA", postcode: "5422" },
{ city: "SUNNYBRAE", state: "SA", postcode: "5422" },
{ city: "UCOLTA", state: "SA", postcode: "5422" },
{ city: "WAROONEE", state: "SA", postcode: "5422" },
{ city: "YATINA", state: "SA", postcode: "5422" },
{ city: "AMYTON", state: "SA", postcode: "5431" },
{ city: "BLACK ROCK", state: "SA", postcode: "5431" },
{ city: "COOMOOROO", state: "SA", postcode: "5431" },
{ city: "EURELIA", state: "SA", postcode: "5431" },
{ city: "HAMMOND", state: "SA", postcode: "5431" },
{ city: "JOHNBURGH", state: "SA", postcode: "5431" },
{ city: "MINBURRA", state: "SA", postcode: "5431" },
{ city: "MINBURRA PLAIN", state: "SA", postcode: "5431" },
{ city: "MINBURRA STATION", state: "SA", postcode: "5431" },
{ city: "MORCHARD", state: "SA", postcode: "5431" },
{ city: "NORTH HILLS", state: "SA", postcode: "5431" },
{ city: "ORROROO", state: "SA", postcode: "5431" },
{ city: "PEKINA", state: "SA", postcode: "5431" },
{ city: "TARCOWIE", state: "SA", postcode: "5431" },
{ city: "WALLOWAY", state: "SA", postcode: "5431" },
{ city: "WILLOWIE", state: "SA", postcode: "5431" },
{ city: "YALPARA", state: "SA", postcode: "5431" },
{ city: "BARATTA", state: "SA", postcode: "5432" },
{ city: "BELTON", state: "SA", postcode: "5432" },
{ city: "BIBLIANDO", state: "SA", postcode: "5432" },
{ city: "CARRIETON", state: "SA", postcode: "5432" },
{ city: "CRADOCK", state: "SA", postcode: "5432" },
{ city: "HOLOWILIENA", state: "SA", postcode: "5432" },
{ city: "HOLOWILIENA SOUTH", state: "SA", postcode: "5432" },
{ city: "MOOCKRA", state: "SA", postcode: "5432" },
{ city: "THREE CREEKS", state: "SA", postcode: "5432" },
{ city: "WILCOWIE", state: "SA", postcode: "5432" },
{ city: "WILLIPPA", state: "SA", postcode: "5432" },
{ city: "WITCHITIE", state: "SA", postcode: "5432" },
{ city: "YANYARRIE", state: "SA", postcode: "5432" },
{ city: "BRUCE", state: "SA", postcode: "5433" },
{ city: "QUORN", state: "SA", postcode: "5433" },
{ city: "SALTIA", state: "SA", postcode: "5433" },
{ city: "STEPHENSTON", state: "SA", postcode: "5433" },
{ city: "WILLOCHRA", state: "SA", postcode: "5433" },
{ city: "YARRAH", state: "SA", postcode: "5433" },
{ city: "BARNDIOOTA", state: "SA", postcode: "5434" },
{ city: "BLACK HILL STATION", state: "SA", postcode: "5434" },
{ city: "FLINDERS RANGES", state: "SA", postcode: "5434" },
{ city: "HAWKER", state: "SA", postcode: "5434" },
{ city: "KANYAKA", state: "SA", postcode: "5434" },
{ city: "MOUNT HAVELOCK", state: "SA", postcode: "5434" },
{ city: "PRELINNA", state: "SA", postcode: "5434" },
{ city: "SHAGGY RIDGE", state: "SA", postcode: "5434" },
{ city: "UPALINNA", state: "SA", postcode: "5434" },
{ city: "WILLOW SPRINGS", state: "SA", postcode: "5434" },
{ city: "WORUMBA", state: "SA", postcode: "5434" },
{ city: "ABMINGA STATION", state: "SA", postcode: "5440" },
{ city: "BENDA", state: "SA", postcode: "5440" },
{ city: "BIMBOWRIE", state: "SA", postcode: "5440" },
{ city: "BINDARRAH", state: "SA", postcode: "5440" },
{ city: "BOOLCOOMATTA", state: "SA", postcode: "5440" },
{ city: "BULLOO CREEK", state: "SA", postcode: "5440" },
{ city: "COCKBURN", state: "SA", postcode: "5440" },
{ city: "CURNAMONA", state: "SA", postcode: "5440" },
{ city: "DEVONBOROUGH DOWNS", state: "SA", postcode: "5440" },
{ city: "ERUDINA", state: "SA", postcode: "5440" },
{ city: "FLORINA STATION", state: "SA", postcode: "5440" },
{ city: "FROME DOWNS", state: "SA", postcode: "5440" },
{ city: "GRAMPUS", state: "SA", postcode: "5440" },
{ city: "KALABITY", state: "SA", postcode: "5440" },
{ city: "KALKAROO", state: "SA", postcode: "5440" },
{ city: "KOONAMORE", state: "SA", postcode: "5440" },
{ city: "LAKE FROME", state: "SA", postcode: "5440" },
{ city: "MANNA HILL", state: "SA", postcode: "5440" },
{ city: "MANUNDA STATION", state: "SA", postcode: "5440" },
{ city: "MARTINS WELL", state: "SA", postcode: "5440" },
{ city: "MELTON STATION", state: "SA", postcode: "5440" },
{ city: "MINGARY", state: "SA", postcode: "5440" },
{ city: "MOOLEULOOLOO", state: "SA", postcode: "5440" },
{ city: "MOUNT VICTOR STATION", state: "SA", postcode: "5440" },
{ city: "MULYUNGARIE", state: "SA", postcode: "5440" },
{ city: "MUNDI MUNDI", state: "SA", postcode: "5440" },
{ city: "MUTOOROO", state: "SA", postcode: "5440" },
{ city: "NACKARA", state: "SA", postcode: "5440" },
{ city: "NETLEY GAP", state: "SA", postcode: "5440" },
{ city: "OLARY", state: "SA", postcode: "5440" },
{ city: "OULNINA", state: "SA", postcode: "5440" },
{ city: "OULNINA PARK", state: "SA", postcode: "5440" },
{ city: "OUTALPA", state: "SA", postcode: "5440" },
{ city: "PINE CREEK STATION", state: "SA", postcode: "5440" },
{ city: "PLUMBAGO", state: "SA", postcode: "5440" },
{ city: "PUALCO RANGE", state: "SA", postcode: "5440" },
{ city: "QUINYAMBIE", state: "SA", postcode: "5440" },
{ city: "TEPCO STATION", state: "SA", postcode: "5440" },
{ city: "TIKALINA", state: "SA", postcode: "5440" },
{ city: "WADNAMINGA", state: "SA", postcode: "5440" },
{ city: "WAUKARINGA", state: "SA", postcode: "5440" },
{ city: "WEEKEROO", state: "SA", postcode: "5440" },
{ city: "WIAWERA", state: "SA", postcode: "5440" },
{ city: "WINNININNIE", state: "SA", postcode: "5440" },
{ city: "WOMPINIE", state: "SA", postcode: "5440" },
{ city: "YARRAMBA", state: "SA", postcode: "5440" },
{ city: "YUNTA", state: "SA", postcode: "5440" },
{ city: "BARUNGA GAP", state: "SA", postcode: "5520" },
{ city: "BUMBUNGA", state: "SA", postcode: "5520" },
{ city: "BURNSFIELD", state: "SA", postcode: "5520" },
{ city: "GLEESON HILL", state: "SA", postcode: "5520" },
{ city: "SNOWTOWN", state: "SA", postcode: "5520" },
{ city: "WOKURNA", state: "SA", postcode: "5520" },
{ city: "REDHILL", state: "SA", postcode: "5521" },
{ city: "FISHERMAN BAY", state: "SA", postcode: "5522" },
{ city: "LOWER BROUGHTON", state: "SA", postcode: "5522" },
{ city: "PORT BROUGHTON", state: "SA", postcode: "5522" },
{ city: "WARD HILL", state: "SA", postcode: "5522" },
{ city: "BEETALOO", state: "SA", postcode: "5523" },
{ city: "BEETALOO VALLEY", state: "SA", postcode: "5523" },
{ city: "CLEMENTS GAP", state: "SA", postcode: "5523" },
{ city: "CRYSTAL BROOK", state: "SA", postcode: "5523" },
{ city: "HUDDLESTON", state: "SA", postcode: "5523" },
{ city: "MERRITON", state: "SA", postcode: "5523" },
{ city: "NARRIDY", state: "SA", postcode: "5523" },
{ city: "NUROM", state: "SA", postcode: "5523" },
{ city: "WANDEARAH", state: "SA", postcode: "5523" },
{ city: "WANDEARAH EAST", state: "SA", postcode: "5523" },
{ city: "WANDEARAH WEST", state: "SA", postcode: "5523" },
{ city: "BUNGAMA", state: "SA", postcode: "5540" },
{ city: "COONAMIA", state: "SA", postcode: "5540" },
{ city: "LOWER BROUGHTON", state: "SA", postcode: "5540" },
{ city: "NAPPERBY", state: "SA", postcode: "5540" },
{ city: "NELSHABY", state: "SA", postcode: "5540" },
{ city: "PORT DAVIS", state: "SA", postcode: "5540" },
{ city: "PORT PIRIE", state: "SA", postcode: "5540" },
{ city: "PORT PIRIE SOUTH", state: "SA", postcode: "5540" },
{ city: "PORT PIRIE WEST", state: "SA", postcode: "5540" },
{ city: "RISDON PARK", state: "SA", postcode: "5540" },
{ city: "RISDON PARK SOUTH", state: "SA", postcode: "5540" },
{ city: "SOLOMONTOWN", state: "SA", postcode: "5540" },
{ city: "TELOWIE", state: "SA", postcode: "5540" },
{ city: "WARNERTOWN", state: "SA", postcode: "5540" },
{ city: "BLACKY POINT", state: "SA", postcode: "5600" },
{ city: "CORUNNA STATION", state: "SA", postcode: "5600" },
{ city: "CULTANA", state: "SA", postcode: "5600" },
{ city: "DOUGLAS POINT", state: "SA", postcode: "5600" },
{ city: "DOUGLAS POINT SOUTH", state: "SA", postcode: "5600" },
{ city: "FALSE BAY", state: "SA", postcode: "5600" },
{ city: "FITZGERALD BAY", state: "SA", postcode: "5600" },
{ city: "GILLES DOWNS", state: "SA", postcode: "5600" },
{ city: "IRON BARON", state: "SA", postcode: "5600" },
{ city: "KATUNGA STATION", state: "SA", postcode: "5600" },
{ city: "LAKE GILLES", state: "SA", postcode: "5600" },
{ city: "LAKE HARRIS", state: "SA", postcode: "5600" },
{ city: "MIDDLEBACK RANGE", state: "SA", postcode: "5600" },
{ city: "MULLAQUANA", state: "SA", postcode: "5600" },
{ city: "MYOLA STATION", state: "SA", postcode: "5600" },
{ city: "POINT LOWLY", state: "SA", postcode: "5600" },
{ city: "POINT LOWLY NORTH", state: "SA", postcode: "5600" },
{ city: "PORT BONYTHON", state: "SA", postcode: "5600" },
{ city: "SECRET ROCKS", state: "SA", postcode: "5600" },
{ city: "WHYALLA", state: "SA", postcode: "5600" },
{ city: "WHYALLA DC", state: "SA", postcode: "5600" },
{ city: "WHYALLA PLAYFORD", state: "SA", postcode: "5600" },
{ city: "BACKY POINT", state: "SA", postcode: "5601" },
{ city: "COWLEDS LANDING", state: "SA", postcode: "5601" },
{ city: "CULTANA", state: "SA", postcode: "5601" },
{ city: "DOUGLAS POINT", state: "SA", postcode: "5601" },
{ city: "DOUGLAS POINT SOUTH", state: "SA", postcode: "5601" },
{ city: "FALSE BAY", state: "SA", postcode: "5601" },
{ city: "FITZGERALD BAY", state: "SA", postcode: "5601" },
{ city: "IRON BARON", state: "SA", postcode: "5601" },
{ city: "IRON KNOB", state: "SA", postcode: "5601" },
{ city: "MULLAQUANA", state: "SA", postcode: "5601" },
{ city: "MURNINNIE BEACH", state: "SA", postcode: "5601" },
{ city: "POINT LOWLY", state: "SA", postcode: "5601" },
{ city: "POINT LOWLY NORTH", state: "SA", postcode: "5601" },
{ city: "PORT BONYTHON", state: "SA", postcode: "5601" },
{ city: "WHYALLA BARSON", state: "SA", postcode: "5601" },
{ city: "COWELL", state: "SA", postcode: "5602" },
{ city: "LUCKY BAY", state: "SA", postcode: "5602" },
{ city: "MANGALO", state: "SA", postcode: "5602" },
{ city: "MIDGEE", state: "SA", postcode: "5602" },
{ city: "MILTALIE", state: "SA", postcode: "5602" },
{ city: "MINBRIE", state: "SA", postcode: "5602" },
{ city: "MITCHELLVILLE", state: "SA", postcode: "5602" },
{ city: "PORT GIBBON", state: "SA", postcode: "5602" },
{ city: "ARNO BAY", state: "SA", postcode: "5603" },
{ city: "HINCKS", state: "SA", postcode: "5603" },
{ city: "VERRAN", state: "SA", postcode: "5603" },
{ city: "WHARMINDA", state: "SA", postcode: "5603" },
{ city: "PORT NEILL", state: "SA", postcode: "5604" },
{ city: "BUTLER", state: "SA", postcode: "5605" },
{ city: "TUMBY BAY", state: "SA", postcode: "5605" },
{ city: "KIRTON POINT", state: "SA", postcode: "5606" },
{ city: "PORT LINCOLN", state: "SA", postcode: "5606" },
{ city: "WEDGE ISLAND", state: "SA", postcode: "5606" },
{ city: "BOSTON", state: "SA", postcode: "5607" },
{ city: "BROOKER", state: "SA", postcode: "5607" },
{ city: "CHARLTON GULLY", state: "SA", postcode: "5607" },
{ city: "COFFIN BAY", state: "SA", postcode: "5607" },
{ city: "COOMUNGA", state: "SA", postcode: "5607" },
{ city: "COULTA", state: "SA", postcode: "5607" },
{ city: "DUCK PONDS", state: "SA", postcode: "5607" },
{ city: "FARM BEACH", state: "SA", postcode: "5607" },
{ city: "FOUNTAIN", state: "SA", postcode: "5607" },
{ city: "GREEN PATCH", state: "SA", postcode: "5607" },
{ city: "HAWSON", state: "SA", postcode: "5607" },
{ city: "HORSE PENINSULA", state: "SA", postcode: "5607" },
{ city: "KARKOO", state: "SA", postcode: "5607" },
{ city: "KELLIDIE BAY", state: "SA", postcode: "5607" },
{ city: "KIANA", state: "SA", postcode: "5607" },
{ city: "KOPPIO", state: "SA", postcode: "5607" },
{ city: "LINCOLN NATIONAL PARK", state: "SA", postcode: "5607" },
{ city: "LIPSON", state: "SA", postcode: "5607" },
{ city: "LITTLE DOUGLAS", state: "SA", postcode: "5607" },
{ city: "LOUTH BAY", state: "SA", postcode: "5607" },
{ city: "MITCHELL", state: "SA", postcode: "5607" },
{ city: "MOODY", state: "SA", postcode: "5607" },
{ city: "MOUNT DRUMMOND", state: "SA", postcode: "5607" },
{ city: "MOUNT DUTTON BAY", state: "SA", postcode: "5607" },
{ city: "MOUNT HOPE", state: "SA", postcode: "5607" },
{ city: "MURDINGA", state: "SA", postcode: "5607" },
{ city: "NORTH SHIELDS", state: "SA", postcode: "5607" },
{ city: "PEACHNA", state: "SA", postcode: "5607" },
{ city: "PEARLAH", state: "SA", postcode: "5607" },
{ city: "POINT BOSTON", state: "SA", postcode: "5607" },
{ city: "POONINDIE", state: "SA", postcode: "5607" },
{ city: "PORT LINCOLN", state: "SA", postcode: "5607" },
{ city: "SHERINGA", state: "SA", postcode: "5607" },
{ city: "SLEAFORD", state: "SA", postcode: "5607" },
{ city: "SULLIVAN", state: "SA", postcode: "5607" },
{ city: "THISTLE ISLAND", state: "SA", postcode: "5607" },
{ city: "TIATUKIA", state: "SA", postcode: "5607" },
{ city: "TOOLIGIE", state: "SA", postcode: "5607" },
{ city: "TOOTENILLA", state: "SA", postcode: "5607" },
{ city: "TULKA", state: "SA", postcode: "5607" },
{ city: "TULKA NORTH", state: "SA", postcode: "5607" },
{ city: "ULEY", state: "SA", postcode: "5607" },
{ city: "UNGARRA", state: "SA", postcode: "5607" },
{ city: "VENUS BAY", state: "SA", postcode: "5607" },
{ city: "WANGARY", state: "SA", postcode: "5607" },
{ city: "WANILLA", state: "SA", postcode: "5607" },
{ city: "WARRACHIE", state: "SA", postcode: "5607" },
{ city: "WARROW", state: "SA", postcode: "5607" },
{ city: "WARUNDA", state: "SA", postcode: "5607" },
{ city: "WHITES FLAT", state: "SA", postcode: "5607" },
{ city: "WHITES RIVER", state: "SA", postcode: "5607" },
{ city: "YALLUNDA FLAT", state: "SA", postcode: "5607" },
{ city: "WHYALLA NORRIE", state: "SA", postcode: "5608" },
{ city: "WHYALLA NORRIE EAST", state: "SA", postcode: "5608" },
{ city: "WHYALLA NORRIE NORTH", state: "SA", postcode: "5608" },
{ city: "WHYALLA STUART", state: "SA", postcode: "5608" },
{ city: "WHYALLA JENKINS", state: "SA", postcode: "5609" },
{ city: "EDILLILIE", state: "SA", postcode: "5630" },
{ city: "COCKALEECHIE", state: "SA", postcode: "5631" },
{ city: "CUMMINS", state: "SA", postcode: "5631" },
{ city: "KAPINNIE", state: "SA", postcode: "5632" },
{ city: "KARKOO", state: "SA", postcode: "5632" },
{ city: "MITCHELL", state: "SA", postcode: "5632" },
{ city: "YEELANNA", state: "SA", postcode: "5632" },
{ city: "BOONERDO", state: "SA", postcode: "5633" },
{ city: "LOCK", state: "SA", postcode: "5633" },
{ city: "CAMPOONA", state: "SA", postcode: "5640" },
{ city: "CLEVE", state: "SA", postcode: "5640" },
{ city: "JAMIESON", state: "SA", postcode: "5640" },
{ city: "WADDIKEE", state: "SA", postcode: "5640" },
{ city: "BARNA", state: "SA", postcode: "5641" },
{ city: "BUCKLEBOO", state: "SA", postcode: "5641" },
{ city: "BUNGEROO", state: "SA", postcode: "5641" },
{ city: "CARALUE", state: "SA", postcode: "5641" },
{ city: "CORTLINYE", state: "SA", postcode: "5641" },
{ city: "CUNYARIE", state: "SA", postcode: "5641" },
{ city: "KELLY", state: "SA", postcode: "5641" },
{ city: "KIMBA", state: "SA", postcode: "5641" },
{ city: "MOSELEY", state: "SA", postcode: "5641" },
{ city: "PANITYA", state: "SA", postcode: "5641" },
{ city: "PINKAWILLINIE", state: "SA", postcode: "5641" },
{ city: "SOLOMON", state: "SA", postcode: "5641" },
{ city: "WILCHERRY", state: "SA", postcode: "5641" },
{ city: "YALANDA", state: "SA", postcode: "5641" },
{ city: "YELTANA", state: "SA", postcode: "5641" },
{ city: "DARKE PEAK", state: "SA", postcode: "5642" },
{ city: "HAMBIDGE", state: "SA", postcode: "5642" },
{ city: "KIELPA", state: "SA", postcode: "5642" },
{ city: "MURLONG", state: "SA", postcode: "5642" },
{ city: "RUDALL", state: "SA", postcode: "5642" },
{ city: "COOTRA", state: "SA", postcode: "5650" },
{ city: "KOONGAWA", state: "SA", postcode: "5650" },
{ city: "WARRAMBOO", state: "SA", postcode: "5650" },
{ city: "KYANCUTTA", state: "SA", postcode: "5651" },
{ city: "PANEY", state: "SA", postcode: "5652" },
{ city: "PYGERY", state: "SA", postcode: "5652" },
{ city: "WUDINNA", state: "SA", postcode: "5652" },
{ city: "YANINEE", state: "SA", postcode: "5653" },
{ city: "COCATA", state: "SA", postcode: "5654" },
{ city: "KARCULTABY", state: "SA", postcode: "5654" },
{ city: "MINNIPA", state: "SA", postcode: "5654" },
{ city: "MOUNT DAMPER", state: "SA", postcode: "5654" },
{ city: "BOCKELBERG", state: "SA", postcode: "5655" },
{ city: "GAWLER RANGES", state: "SA", postcode: "5655" },
{ city: "KALDOONERA", state: "SA", postcode: "5655" },
{ city: "LOCKES CLAYPAN", state: "SA", postcode: "5655" },
{ city: "NARLABY", state: "SA", postcode: "5655" },
{ city: "POOCHERA", state: "SA", postcode: "5655" },
{ city: "PYGERY", state: "SA", postcode: "5655" },
{ city: "CHILPENUNDA", state: "SA", postcode: "5660" },
{ city: "CUNGENA", state: "SA", postcode: "5660" },
{ city: "KOOLGERA", state: "SA", postcode: "5661" },
{ city: "PIMBAACLA", state: "SA", postcode: "5661" },
{ city: "WALLALA", state: "SA", postcode: "5661" },
{ city: "WIRRULLA", state: "SA", postcode: "5661" },
{ city: "YANTANABIE", state: "SA", postcode: "5661" },
{ city: "BRAMFIELD", state: "SA", postcode: "5670" },
{ city: "COLTON", state: "SA", postcode: "5670" },
{ city: "COOLILLIE", state: "SA", postcode: "5670" },
{ city: "ELLISTON", state: "SA", postcode: "5670" },
{ city: "KAPPAWANTA", state: "SA", postcode: "5670" },
{ city: "MOUNT JOY", state: "SA", postcode: "5670" },
{ city: "MOUNT WEDGE", state: "SA", postcode: "5670" },
{ city: "PALKAGEE", state: "SA", postcode: "5670" },
{ city: "POLDA", state: "SA", postcode: "5670" },
{ city: "TALIA", state: "SA", postcode: "5670" },
{ city: "ULYERRA", state: "SA", postcode: "5670" },
{ city: "BAIRD BAY", state: "SA", postcode: "5671" },
{ city: "CALCA", state: "SA", postcode: "5671" },
{ city: "COLLEY", state: "SA", postcode: "5671" },
{ city: "MORTANA", state: "SA", postcode: "5671" },
{ city: "MOUNT COOPER", state: "SA", postcode: "5671" },
{ city: "PORT KENNY", state: "SA", postcode: "5671" },
{ city: "TYRINGA", state: "SA", postcode: "5671" },
{ city: "WITERA", state: "SA", postcode: "5671" },
{ city: "CARAWA", state: "SA", postcode: "5680" },
{ city: "CHANDADA", state: "SA", postcode: "5680" },
{ city: "CHINBINGINA", state: "SA", postcode: "5680" },
{ city: "EBA ANCHORAGE", state: "SA", postcode: "5680" },
{ city: "HASLAM", state: "SA", postcode: "5680" },
{ city: "INKSTER", state: "SA", postcode: "5680" },
{ city: "LAURA BAY", state: "SA", postcode: "5680" },
{ city: "MARYVALE", state: "SA", postcode: "5680" },
{ city: "MUDAMUCKLA", state: "SA", postcode: "5680" },
{ city: "NUNJIKOMPITA", state: "SA", postcode: "5680" },
{ city: "PERLUBIE", state: "SA", postcode: "5680" },
{ city: "PETINA", state: "SA", postcode: "5680" },
{ city: "PIEDNIPPIE", state: "SA", postcode: "5680" },
{ city: "PINJARRA STATION", state: "SA", postcode: "5680" },
{ city: "PUNTABIE", state: "SA", postcode: "5680" },
{ city: "PUREBA", state: "SA", postcode: "5680" },
{ city: "SCEALE BAY", state: "SA", postcode: "5680" },
{ city: "SMOKY BAY", state: "SA", postcode: "5680" },
{ city: "STREAKY BAY", state: "SA", postcode: "5680" },
{ city: "WESTALL", state: "SA", postcode: "5680" },
{ city: "YANERBIE", state: "SA", postcode: "5680" },
{ city: "BOOKABIE", state: "SA", postcode: "5690" },
{ city: "CEDUNA", state: "SA", postcode: "5690" },
{ city: "CEDUNA WATERS", state: "SA", postcode: "5690" },
{ city: "CHARRA", state: "SA", postcode: "5690" },
{ city: "CHUNDARIA", state: "SA", postcode: "5690" },
{ city: "COORABIE", state: "SA", postcode: "5690" },
{ city: "DENIAL BAY", state: "SA", postcode: "5690" },
{ city: "FOWLERS BAY", state: "SA", postcode: "5690" },
{ city: "KALANBI", state: "SA", postcode: "5690" },
{ city: "KOONIBBA", state: "SA", postcode: "5690" },
{ city: "MALTEE", state: "SA", postcode: "5690" },
{ city: "MERGHINY", state: "SA", postcode: "5690" },
{ city: "MITCHIDY MOOLA", state: "SA", postcode: "5690" },
{ city: "NADIA", state: "SA", postcode: "5690" },
{ city: "NANBONA", state: "SA", postcode: "5690" },
{ city: "NULLARBOR", state: "SA", postcode: "5690" },
{ city: "NUNDROO", state: "SA", postcode: "5690" },
{ city: "PENONG", state: "SA", postcode: "5690" },
{ city: "THEVENARD", state: "SA", postcode: "5690" },
{ city: "UWORRA", state: "SA", postcode: "5690" },
{ city: "WANDANA", state: "SA", postcode: "5690" },
{ city: "WATRABA", state: "SA", postcode: "5690" },
{ city: "WHITE WELL CORNER", state: "SA", postcode: "5690" },
{ city: "YALATA", state: "SA", postcode: "5690" },
{ city: "YELLABINNA", state: "SA", postcode: "5690" },
{ city: "YUMBARRA", state: "SA", postcode: "5690" },
{ city: "MIRANDA", state: "SA", postcode: "5700" },
{ city: "ARKAROOLA VILLAGE", state: "SA", postcode: "5701" },
{ city: "COOK", state: "SA", postcode: "5701" },
{ city: "TARCOOLA", state: "SA", postcode: "5701" },
{ city: "WOOLUNDUNGA", state: "SA", postcode: "5701" },
{ city: "ARKAROOLA VILLAGE", state: "SA", postcode: "5710" },
{ city: "COMMISSARIAT POINT", state: "SA", postcode: "5710" },
{ city: "COOK", state: "SA", postcode: "5710" },
{ city: "GLENDAMBO", state: "SA", postcode: "5710" },
{ city: "KINGOONYA", state: "SA", postcode: "5710" },
{ city: "NONNING", state: "SA", postcode: "5710" },
{ city: "STIRLING NORTH", state: "SA", postcode: "5710" },
{ city: "TARCOOLA", state: "SA", postcode: "5710" },
{ city: "WINNINOWIE", state: "SA", postcode: "5710" },
{ city: "WOOLUNDUNGA", state: "SA", postcode: "5710" },
{ city: "EMEROO", state: "SA", postcode: "5713" },
{ city: "ISLAND LAGOON", state: "SA", postcode: "5713" },
{ city: "KOOTABERRA", state: "SA", postcode: "5713" },
{ city: "LAKE TORRENS", state: "SA", postcode: "5713" },
{ city: "LAKE TORRENS STATION", state: "SA", postcode: "5713" },
{ city: "MOUNT ARDEN", state: "SA", postcode: "5713" },
{ city: "OAKDEN HILLS", state: "SA", postcode: "5713" },
{ city: "PERNATTY", state: "SA", postcode: "5713" },
{ city: "SOUTH GAP", state: "SA", postcode: "5713" },
{ city: "WALLERBERDINA", state: "SA", postcode: "5713" },
{ city: "WILKATANA STATION", state: "SA", postcode: "5713" },
{ city: "WINTABATINYANA", state: "SA", postcode: "5713" },
{ city: "YADLAMALKA", state: "SA", postcode: "5713" },
{ city: "CARRIEWERLOO", state: "SA", postcode: "5715" },
{ city: "ILLEROO", state: "SA", postcode: "5715" },
{ city: "LINCOLN GAP", state: "SA", postcode: "5715" },
{ city: "PANDURRA", state: "SA", postcode: "5715" },
{ city: "WARTAKA", state: "SA", postcode: "5715" },
{ city: "YALYMBOO", state: "SA", postcode: "5715" },
{ city: "YUDNAPINNA", state: "SA", postcode: "5715" },
{ city: "HILTABA", state: "SA", postcode: "5717" },
{ city: "KOKATHA", state: "SA", postcode: "5717" },
{ city: "KOLENDO", state: "SA", postcode: "5717" },
{ city: "KONDOOLKA", state: "SA", postcode: "5717" },
{ city: "LAKE EVERARD", state: "SA", postcode: "5717" },
{ city: "LAKE GAIRDNER", state: "SA", postcode: "5717" },
{ city: "LAKE MACFARLANE", state: "SA", postcode: "5717" },
{ city: "MAHANEWO", state: "SA", postcode: "5717" },
{ city: "MOONAREE", state: "SA", postcode: "5717" },
{ city: "MOUNT IVE", state: "SA", postcode: "5717" },
{ city: "NONNING", state: "SA", postcode: "5717" },
{ city: "SIAM", state: "SA", postcode: "5717" },
{ city: "THURLGA", state: "SA", postcode: "5717" },
{ city: "UNO", state: "SA", postcode: "5717" },
{ city: "YARDEA", state: "SA", postcode: "5717" },
{ city: "BON BON", state: "SA", postcode: "5719" },
{ city: "BULGUNNIA", state: "SA", postcode: "5719" },
{ city: "COMMONWEALTH HILL", state: "SA", postcode: "5719" },
{ city: "COONDAMBO", state: "SA", postcode: "5719" },
{ city: "GLENDAMBO", state: "SA", postcode: "5719" },
{ city: "KINGOONYA", state: "SA", postcode: "5719" },
{ city: "MULGATHING", state: "SA", postcode: "5719" },
{ city: "WILGENA", state: "SA", postcode: "5719" },
{ city: "WIRRAMINNA", state: "SA", postcode: "5719" },
{ city: "ARCOONA", state: "SA", postcode: "5720" },
{ city: "BILLA KALINA", state: "SA", postcode: "5720" },
{ city: "BOSWORTH", state: "SA", postcode: "5720" },
{ city: "MILLERS CREEK", state: "SA", postcode: "5720" },
{ city: "MOUNT EBA", state: "SA", postcode: "5720" },
{ city: "MOUNT VIVIAN", state: "SA", postcode: "5720" },
{ city: "PARAKYLIA", state: "SA", postcode: "5720" },
{ city: "PIMBA", state: "SA", postcode: "5720" },
{ city: "PURPLE DOWNS", state: "SA", postcode: "5720" },
{ city: "STUARTS CREEK", state: "SA", postcode: "5720" },
{ city: "WOOMERA", state: "SA", postcode: "5720" },
{ city: "ANDAMOOKA", state: "SA", postcode: "5722" },
{ city: "ANDAMOOKA STATION", state: "SA", postcode: "5722" },
{ city: "ALLANDALE STATION", state: "SA", postcode: "5723" },
{ city: "ANNA CREEK", state: "SA", postcode: "5723" },
{ city: "ARCKARINGA", state: "SA", postcode: "5723" },
{ city: "COOBER PEDY", state: "SA", postcode: "5723" },
{ city: "EVELYN DOWNS", state: "SA", postcode: "5723" },
{ city: "INGOMAR", state: "SA", postcode: "5723" },
{ city: "MABEL CREEK", state: "SA", postcode: "5723" },
{ city: "MCDOUALL PEAK", state: "SA", postcode: "5723" },
{ city: "MOUNT BARRY", state: "SA", postcode: "5723" },
{ city: "MOUNT CLARENCE STATION", state: "SA", postcode: "5723" },
{ city: "MOUNT WILLOUGHBY", state: "SA", postcode: "5723" },
{ city: "NILPINNA STATION", state: "SA", postcode: "5723" },
{ city: "WILLIAM CREEK", state: "SA", postcode: "5723" },
{ city: "WINTINNA", state: "SA", postcode: "5723" },
{ city: "MARLA", state: "SA", postcode: "5724" },
{ city: "MINTABIE", state: "SA", postcode: "5724" },
{ city: "WELBOURN HILL", state: "SA", postcode: "5724" },
{ city: "OLYMPIC DAM", state: "SA", postcode: "5725" },
{ city: "ROXBY DOWNS", state: "SA", postcode: "5725" },
{ city: "ROXBY DOWNS STATION", state: "SA", postcode: "5725" },
{ city: "ALPANA", state: "SA", postcode: "5730" },
{ city: "ANGORIGINA", state: "SA", postcode: "5730" },
{ city: "BELTANA", state: "SA", postcode: "5730" },
{ city: "BELTANA STATION", state: "SA", postcode: "5730" },
{ city: "BLINMAN", state: "SA", postcode: "5730" },
{ city: "EDIACARA", state: "SA", postcode: "5730" },
{ city: "GUM CREEK STATION", state: "SA", postcode: "5730" },
{ city: "MOOLOOLOO", state: "SA", postcode: "5730" },
{ city: "MOORILLAH", state: "SA", postcode: "5730" },
{ city: "MOTPENA", state: "SA", postcode: "5730" },
{ city: "MOUNT FALKLAND", state: "SA", postcode: "5730" },
{ city: "NARRINA", state: "SA", postcode: "5730" },
{ city: "NILPENA", state: "SA", postcode: "5730" },
{ city: "ORATUNGA STATION", state: "SA", postcode: "5730" },
{ city: "PARACHILNA", state: "SA", postcode: "5730" },
{ city: "PUTTAPA", state: "SA", postcode: "5730" },
{ city: "WARRAWEENA", state: "SA", postcode: "5730" },
{ city: "WIRREALPA", state: "SA", postcode: "5730" },
{ city: "BOLLARDS LAGOON", state: "SA", postcode: "5731" },
{ city: "COOPERS CREEK", state: "SA", postcode: "5731" },
{ city: "CORDILLO DOWNS", state: "SA", postcode: "5731" },
{ city: "DURHAM DOWNS", state: "SA", postcode: "5731" },
{ city: "GIDGEALPA", state: "SA", postcode: "5731" },
{ city: "INNAMINCKA", state: "SA", postcode: "5731" },
{ city: "LEIGH CREEK", state: "SA", postcode: "5731" },
{ city: "LEIGH CREEK STATION", state: "SA", postcode: "5731" },
{ city: "LINDON", state: "SA", postcode: "5731" },
{ city: "LYNDHURST", state: "SA", postcode: "5731" },
{ city: "MERTY MERTY", state: "SA", postcode: "5731" },
{ city: "MOOLAWATANA", state: "SA", postcode: "5731" },
{ city: "MOUNT FREELING", state: "SA", postcode: "5731" },
{ city: "MOUNT LYNDHURST", state: "SA", postcode: "5731" },
{ city: "MULGARIA", state: "SA", postcode: "5731" },
{ city: "MURNPEOWIE", state: "SA", postcode: "5731" },
{ city: "MYRTLE SPRINGS", state: "SA", postcode: "5731" },
{ city: "STRZELECKI DESERT", state: "SA", postcode: "5731" },
{ city: "WITCHELINA", state: "SA", postcode: "5731" },
{ city: "ANGEPENA", state: "SA", postcode: "5732" },
{ city: "ARKAROOLA", state: "SA", postcode: "5732" },
{ city: "BURR WELL", state: "SA", postcode: "5732" },
{ city: "COPLEY", state: "SA", postcode: "5732" },
{ city: "GAMMON RANGES", state: "SA", postcode: "5732" },
{ city: "MANNERS WELL", state: "SA", postcode: "5732" },
{ city: "MOOLAWATANA", state: "SA", postcode: "5732" },
{ city: "MOUNT SERLE", state: "SA", postcode: "5732" },
{ city: "MULGA VIEW", state: "SA", postcode: "5732" },
{ city: "NEPABUNNA", state: "SA", postcode: "5732" },
{ city: "NORTH MOOLOOLOO", state: "SA", postcode: "5732" },
{ city: "PINDA SPRINGS", state: "SA", postcode: "5732" },
{ city: "UMBERATANA", state: "SA", postcode: "5732" },
{ city: "WERTALOONA", state: "SA", postcode: "5732" },
{ city: "WOOLTANA", state: "SA", postcode: "5732" },
{ city: "YANKANINNA", state: "SA", postcode: "5732" },
{ city: "ALTON DOWNS STATION", state: "SA", postcode: "5733" },
{ city: "CALLANNA", state: "SA", postcode: "5733" },
{ city: "CLAYTON STATION", state: "SA", postcode: "5733" },
{ city: "CLIFTON HILLS STATION", state: "SA", postcode: "5733" },
{ city: "COWARIE", state: "SA", postcode: "5733" },
{ city: "DULKANINNA", state: "SA", postcode: "5733" },
{ city: "ETADUNNA", state: "SA", postcode: "5733" },
{ city: "FARINA", state: "SA", postcode: "5733" },
{ city: "FARINA STATION", state: "SA", postcode: "5733" },
{ city: "KALAMURINA", state: "SA", postcode: "5733" },
{ city: "LAKE EYRE", state: "SA", postcode: "5733" },
{ city: "MARREE", state: "SA", postcode: "5733" },
{ city: "MARREE STATION", state: "SA", postcode: "5733" },
{ city: "MULKA", state: "SA", postcode: "5733" },
{ city: "MULOORINA", state: "SA", postcode: "5733" },
{ city: "MUNDOWDNA", state: "SA", postcode: "5733" },
{ city: "MUNGERANIE", state: "SA", postcode: "5733" },
{ city: "PANDIE PANDIE", state: "SA", postcode: "5733" },
{ city: "CROWN POINT", state: "SA", postcode: "5734" },
{ city: "ERINGA", state: "SA", postcode: "5734" },
{ city: "MACUMBA", state: "SA", postcode: "5734" },
{ city: "MOUNT SARAH", state: "SA", postcode: "5734" },
{ city: "OODNADATTA", state: "SA", postcode: "5734" },
{ city: "SIMPSON DESERT", state: "SA", postcode: "5734" },
{ city: "TODMORDEN", state: "SA", postcode: "5734" },
{ city: "WITJIRA", state: "SA", postcode: "5734" },
{ city: "BATTERY POINT", state: "TAS", postcode: "7004" },
{ city: "SOUTH HOBART", state: "TAS", postcode: "7004" },
{ city: "DYNNYRNE", state: "TAS", postcode: "7005" },
{ city: "LOWER SANDY BAY", state: "TAS", postcode: "7005" },
{ city: "UNIVERSITY OF TASMANIA", state: "TAS", postcode: "7005" },
{ city: "MOUNT NELSON", state: "TAS", postcode: "7007" },
{ city: "TOLMANS HILL", state: "TAS", postcode: "7007" },
{ city: "LENAH VALLEY", state: "TAS", postcode: "7008" },
{ city: "LUTANA", state: "TAS", postcode: "7009" },
{ city: "MOONAH", state: "TAS", postcode: "7009" },
{ city: "WEST MOONAH", state: "TAS", postcode: "7009" },
{ city: "DOWSING POINT", state: "TAS", postcode: "7010" },
{ city: "GOODWOOD", state: "TAS", postcode: "7010" },
{ city: "MONTROSE", state: "TAS", postcode: "7010" },
{ city: "ROSETTA", state: "TAS", postcode: "7010" },
{ city: "AUSTINS FERRY", state: "TAS", postcode: "7011" },
{ city: "BERRIEDALE", state: "TAS", postcode: "7011" },
{ city: "CHIGWELL", state: "TAS", postcode: "7011" },
{ city: "CLAREMONT", state: "TAS", postcode: "7011" },
{ city: "COLLINSVALE", state: "TAS", postcode: "7012" },
{ city: "GLENLUSK", state: "TAS", postcode: "7012" },
{ city: "GEILSTON BAY", state: "TAS", postcode: "7015" },
{ city: "LINDISFARNE", state: "TAS", postcode: "7015" },
{ city: "ROSE BAY", state: "TAS", postcode: "7015" },
{ city: "RISDON VALE", state: "TAS", postcode: "7016" },
{ city: "GRASSTREE HILL", state: "TAS", postcode: "7017" },
{ city: "HONEYWOOD", state: "TAS", postcode: "7017" },
{ city: "OLD BEACH", state: "TAS", postcode: "7017" },
{ city: "OTAGO", state: "TAS", postcode: "7017" },
{ city: "RISDON", state: "TAS", postcode: "7017" },
{ city: "TEA TREE", state: "TAS", postcode: "7017" },
{ city: "BELLERIVE", state: "TAS", postcode: "7018" },
{ city: "HOWRAH", state: "TAS", postcode: "7018" },
{ city: "MONTAGU BAY", state: "TAS", postcode: "7018" },
{ city: "ROSNY", state: "TAS", postcode: "7018" },
{ city: "TRANMERE", state: "TAS", postcode: "7018" },
{ city: "WARRANE", state: "TAS", postcode: "7018" },
{ city: "CLARENDON VALE", state: "TAS", postcode: "7019" },
{ city: "OAKDOWNS", state: "TAS", postcode: "7019" },
{ city: "ROKEBY", state: "TAS", postcode: "7019" },
{ city: "CLIFTON BEACH", state: "TAS", postcode: "7020" },
{ city: "SANDFORD", state: "TAS", postcode: "7020" },
{ city: "LAUDERDALE", state: "TAS", postcode: "7021" },
{ city: "SOUTH ARM", state: "TAS", postcode: "7022" },
{ city: "OPOSSUM BAY", state: "TAS", postcode: "7023" },
{ city: "CREMORNE", state: "TAS", postcode: "7024" },
{ city: "DULCOT", state: "TAS", postcode: "7025" },
{ city: "RICHMOND", state: "TAS", postcode: "7025" },
{ city: "CAMPANIA", state: "TAS", postcode: "7026" },
{ city: "COLEBROOK", state: "TAS", postcode: "7027" },
{ city: "APSLEY", state: "TAS", postcode: "7030" },
{ city: "ARTHURS LAKE", state: "TAS", postcode: "7030" },
{ city: "BAGDAD", state: "TAS", postcode: "7030" },
{ city: "BAGDAD NORTH", state: "TAS", postcode: "7030" },
{ city: "BOTHWELL", state: "TAS", postcode: "7030" },
{ city: "BRIDGEWATER", state: "TAS", postcode: "7030" },
{ city: "BRIGHTON", state: "TAS", postcode: "7030" },
{ city: "BROADMARSH", state: "TAS", postcode: "7030" },
{ city: "CRAMPS BAY", state: "TAS", postcode: "7030" },
{ city: "DROMEDARY", state: "TAS", postcode: "7030" },
{ city: "DYSART", state: "TAS", postcode: "7030" },
{ city: "ELDERSLIE", state: "TAS", postcode: "7030" },
{ city: "FLINTSTONE", state: "TAS", postcode: "7030" },
{ city: "GAGEBROOK", state: "TAS", postcode: "7030" },
{ city: "GRANTON", state: "TAS", postcode: "7030" },
{ city: "HERDSMANS COVE", state: "TAS", postcode: "7030" },
{ city: "HERMITAGE", state: "TAS", postcode: "7030" },
{ city: "INTERLAKEN", state: "TAS", postcode: "7030" },
{ city: "JERICHO", state: "TAS", postcode: "7030" },
{ city: "KEMPTON", state: "TAS", postcode: "7030" },
{ city: "LAKE SORELL", state: "TAS", postcode: "7030" },
{ city: "LIAWENEE", state: "TAS", postcode: "7030" },
{ city: "LOWER MARSHES", state: "TAS", postcode: "7030" },
{ city: "MANGALORE", state: "TAS", postcode: "7030" },
{ city: "MELTON MOWBRAY", state: "TAS", postcode: "7030" },
{ city: "MIENA", state: "TAS", postcode: "7030" },
{ city: "MILLERS BLUFF", state: "TAS", postcode: "7030" },
{ city: "MORASS BAY", state: "TAS", postcode: "7030" },
{ city: "PELHAM", state: "TAS", postcode: "7030" },
{ city: "PONTVILLE", state: "TAS", postcode: "7030" },
{ city: "SHANNON", state: "TAS", postcode: "7030" },
{ city: "STEPPES", state: "TAS", postcode: "7030" },
{ city: "TODS CORNER", state: "TAS", postcode: "7030" },
{ city: "WADDAMANA", state: "TAS", postcode: "7030" },
{ city: "WILBURVILLE", state: "TAS", postcode: "7030" },
{ city: "ALBION HEIGHTS", state: "TAS", postcode: "7050" },
{ city: "KINGSTON BEACH", state: "TAS", postcode: "7050" },
{ city: "BLACKMANS BAY", state: "TAS", postcode: "7052" },
{ city: "BONNET HILL", state: "TAS", postcode: "7053" },
{ city: "TAROONA", state: "TAS", postcode: "7053" },
{ city: "BARRETTA", state: "TAS", postcode: "7054" },
{ city: "CONINGHAM", state: "TAS", postcode: "7054" },
{ city: "ELECTRONA", state: "TAS", postcode: "7054" },
{ city: "FERN TREE", state: "TAS", postcode: "7054" },
{ city: "HOWDEN", state: "TAS", postcode: "7054" },
{ city: "LESLIE VALE", state: "TAS", postcode: "7054" },
{ city: "LOWER SNUG", state: "TAS", postcode: "7054" },
{ city: "MARGATE", state: "TAS", postcode: "7054" },
{ city: "NEIKA", state: "TAS", postcode: "7054" },
{ city: "RIDGEWAY", state: "TAS", postcode: "7054" },
{ city: "SNUG", state: "TAS", postcode: "7054" },
{ city: "TINDERBOX", state: "TAS", postcode: "7054" },
{ city: "WELLINGTON PARK", state: "TAS", postcode: "7054" },
{ city: "HUNTINGFIELD", state: "TAS", postcode: "7055" },
{ city: "CRABTREE", state: "TAS", postcode: "7109" },
{ city: "CRADOC", state: "TAS", postcode: "7109" },
{ city: "GLAZIERS BAY", state: "TAS", postcode: "7109" },
{ city: "GLENDEVIE", state: "TAS", postcode: "7109" },
{ city: "GLEN HUON", state: "TAS", postcode: "7109" },
{ city: "GROVE", state: "TAS", postcode: "7109" },
{ city: "HASTINGS", state: "TAS", postcode: "7109" },
{ city: "HUONVILLE", state: "TAS", postcode: "7109" },
{ city: "IDA BAY", state: "TAS", postcode: "7109" },
{ city: "JUDBURY", state: "TAS", postcode: "7109" },
{ city: "LONNAVALE", state: "TAS", postcode: "7109" },
{ city: "LOWER LONGLEY", state: "TAS", postcode: "7109" },
{ city: "LOWER WATTLE GROVE", state: "TAS", postcode: "7109" },
{ city: "LUCASTON", state: "TAS", postcode: "7109" },
{ city: "LUNE RIVER", state: "TAS", postcode: "7109" },
{ city: "LYMINGTON", state: "TAS", postcode: "7109" },
{ city: "MOUNTAIN RIVER", state: "TAS", postcode: "7109" },
{ city: "PETCHEYS BAY", state: "TAS", postcode: "7109" },
{ city: "RAMINEA", state: "TAS", postcode: "7109" },
{ city: "RANELAGH", state: "TAS", postcode: "7109" },
{ city: "RECHERCHE", state: "TAS", postcode: "7109" },
{ city: "SOUTHPORT", state: "TAS", postcode: "7109" },
{ city: "SOUTHPORT LAGOON", state: "TAS", postcode: "7109" },
{ city: "STRATHBLANE", state: "TAS", postcode: "7109" },
{ city: "WATERLOO", state: "TAS", postcode: "7109" },
{ city: "WATTLE GROVE", state: "TAS", postcode: "7109" },
{ city: "WOODSTOCK", state: "TAS", postcode: "7109" },
{ city: "ABELS BAY", state: "TAS", postcode: "7112" },
{ city: "CHARLOTTE COVE", state: "TAS", postcode: "7112" },
{ city: "CYGNET", state: "TAS", postcode: "7112" },
{ city: "DEEP BAY", state: "TAS", postcode: "7112" },
{ city: "EGGS AND BACON BAY", state: "TAS", postcode: "7112" },
{ city: "GARDEN ISLAND CREEK", state: "TAS", postcode: "7112" },
{ city: "GARDNERS BAY", state: "TAS", postcode: "7112" },
{ city: "NICHOLLS RIVULET", state: "TAS", postcode: "7112" },
{ city: "RANDALLS BAY", state: "TAS", postcode: "7112" },
{ city: "VERONA SANDS", state: "TAS", postcode: "7112" },
{ city: "FRANKLIN", state: "TAS", postcode: "7113" },
{ city: "BROOKS BAY", state: "TAS", postcode: "7116" },
{ city: "CAIRNS BAY", state: "TAS", postcode: "7116" },
{ city: "CASTLE FORBES BAY", state: "TAS", postcode: "7116" },
{ city: "GEEVESTON", state: "TAS", postcode: "7116" },
{ city: "POLICE POINT", state: "TAS", postcode: "7116" },
{ city: "PORT HUON", state: "TAS", postcode: "7116" },
{ city: "SURGES BAY", state: "TAS", postcode: "7116" },
{ city: "SURVEYORS BAY", state: "TAS", postcode: "7116" },
{ city: "DOVER", state: "TAS", postcode: "7117" },
{ city: "STONOR", state: "TAS", postcode: "7119" },
{ city: "ANDOVER", state: "TAS", postcode: "7120" },
{ city: "ANTILL PONDS", state: "TAS", postcode: "7120" },
{ city: "BADEN", state: "TAS", postcode: "7120" },
{ city: "LEMONT", state: "TAS", postcode: "7120" },
{ city: "LEVENDALE", state: "TAS", postcode: "7120" },
{ city: "MOUNT SEYMOUR", state: "TAS", postcode: "7120" },
{ city: "OATLANDS", state: "TAS", postcode: "7120" },
{ city: "PARATTAH", state: "TAS", postcode: "7120" },
{ city: "PAWTELLA", state: "TAS", postcode: "7120" },
{ city: "RHYNDASTON", state: "TAS", postcode: "7120" },
{ city: "STONEHENGE", state: "TAS", postcode: "7120" },
{ city: "SWANSTON", state: "TAS", postcode: "7120" },
{ city: "TIBERIAS", state: "TAS", postcode: "7120" },
{ city: "TUNBRIDGE", state: "TAS", postcode: "7120" },
{ city: "TUNNACK", state: "TAS", postcode: "7120" },
{ city: "WHITEFOORD", state: "TAS", postcode: "7120" },
{ city: "WOODBURY", state: "TAS", postcode: "7120" },
{ city: "WOODSDALE", state: "TAS", postcode: "7120" },
{ city: "YORK PLAINS", state: "TAS", postcode: "7120" },
{ city: "STRATHGORDON", state: "TAS", postcode: "7139" },
{ city: "BLACK HILLS", state: "TAS", postcode: "7140" },
{ city: "BOYER", state: "TAS", postcode: "7140" },
{ city: "BRADYS LAKE", state: "TAS", postcode: "7140" },
{ city: "BRONTE PARK", state: "TAS", postcode: "7140" },
{ city: "BUSHY PARK", state: "TAS", postcode: "7140" },
{ city: "BUTLERS GORGE", state: "TAS", postcode: "7140" },
{ city: "DEE", state: "TAS", postcode: "7140" },
{ city: "DERWENT BRIDGE", state: "TAS", postcode: "7140" },
{ city: "ELLENDALE", state: "TAS", postcode: "7140" },
{ city: "FENTONBURY", state: "TAS", postcode: "7140" },
{ city: "FITZGERALD", state: "TAS", postcode: "7140" },
{ city: "FLORENTINE", state: "TAS", postcode: "7140" },
{ city: "GLENFERN", state: "TAS", postcode: "7140" },
{ city: "GLENORA", state: "TAS", postcode: "7140" },
{ city: "GRETNA", state: "TAS", postcode: "7140" },
{ city: "HAMILTON", state: "TAS", postcode: "7140" },
{ city: "HAYES", state: "TAS", postcode: "7140" },
{ city: "HOLLOW TREE", state: "TAS", postcode: "7140" },
{ city: "KARANJA", state: "TAS", postcode: "7140" },
{ city: "LACHLAN", state: "TAS", postcode: "7140" },
{ city: "LAKE ST CLAIR", state: "TAS", postcode: "7140" },
{ city: "LAWITTA", state: "TAS", postcode: "7140" },
{ city: "LITTLE PINE LAGOON", state: "TAS", postcode: "7140" },
{ city: "LONDON LAKES", state: "TAS", postcode: "7140" },
{ city: "MACQUARIE PLAINS", state: "TAS", postcode: "7140" },
{ city: "MAGRA", state: "TAS", postcode: "7140" },
{ city: "MALBINA", state: "TAS", postcode: "7140" },
{ city: "MAYDENA", state: "TAS", postcode: "7140" },
{ city: "MEADOWBANK", state: "TAS", postcode: "7140" },
{ city: "MOLESWORTH", state: "TAS", postcode: "7140" },
{ city: "MOOGARA", state: "TAS", postcode: "7140" },
{ city: "MOUNT FIELD", state: "TAS", postcode: "7140" },
{ city: "MOUNT LLOYD", state: "TAS", postcode: "7140" },
{ city: "NATIONAL PARK", state: "TAS", postcode: "7140" },
{ city: "NEW NORFOLK", state: "TAS", postcode: "7140" },
{ city: "OSTERLEY", state: "TAS", postcode: "7140" },
{ city: "OUSE", state: "TAS", postcode: "7140" },
{ city: "PLENTY", state: "TAS", postcode: "7140" },
{ city: "ROSEGARLAND", state: "TAS", postcode: "7140" },
{ city: "SORELL CREEK", state: "TAS", postcode: "7140" },
{ city: "STRICKLAND", state: "TAS", postcode: "7140" },
{ city: "STYX", state: "TAS", postcode: "7140" },
{ city: "TARRALEAH", state: "TAS", postcode: "7140" },
{ city: "TYENNA", state: "TAS", postcode: "7140" },
{ city: "UXBRIDGE", state: "TAS", postcode: "7140" },
{ city: "VICTORIA VALLEY", state: "TAS", postcode: "7140" },
{ city: "WAYATINAH", state: "TAS", postcode: "7140" },
{ city: "WESTERWAY", state: "TAS", postcode: "7140" },
{ city: "ADVENTURE BAY", state: "TAS", postcode: "7150" },
{ city: "ALLENS RIVULET", state: "TAS", postcode: "7150" },
{ city: "ALONNAH", state: "TAS", postcode: "7150" },
{ city: "APOLLO BAY", state: "TAS", postcode: "7150" },
{ city: "BARNES BAY", state: "TAS", postcode: "7150" },
{ city: "DENNES POINT", state: "TAS", postcode: "7150" },
{ city: "GORDON", state: "TAS", postcode: "7150" },
{ city: "GREAT BAY", state: "TAS", postcode: "7150" },
{ city: "KAOOTA", state: "TAS", postcode: "7150" },
{ city: "KILLORA", state: "TAS", postcode: "7150" },
{ city: "LONGLEY", state: "TAS", postcode: "7150" },
{ city: "LUNAWANNA", state: "TAS", postcode: "7150" },
{ city: "NORTH BRUNY", state: "TAS", postcode: "7150" },
{ city: "OYSTER COVE", state: "TAS", postcode: "7150" },
{ city: "PELVERATA", state: "TAS", postcode: "7150" },
{ city: "SANDFLY", state: "TAS", postcode: "7150" },
{ city: "SIMPSONS BAY", state: "TAS", postcode: "7150" },
{ city: "SOUTH BRUNY", state: "TAS", postcode: "7150" },
{ city: "UPPER WOODSTOCK", state: "TAS", postcode: "7150" },
{ city: "CASEY", state: "TAS", postcode: "7151" },
{ city: "DAVIS", state: "TAS", postcode: "7151" },
{ city: "HEARD ISLAND", state: "TAS", postcode: "7151" },
{ city: "MACQUARIE", state: "TAS", postcode: "7151" },
{ city: "MACQUARIE ISLAND", state: "TAS", postcode: "7151" },
{ city: "MAWSON", state: "TAS", postcode: "7151" },
{ city: "MCDONALD ISLANDS", state: "TAS", postcode: "7151" },
{ city: "KETTERING", state: "TAS", postcode: "7155" },
{ city: "BIRCHS BAY", state: "TAS", postcode: "7162" },
{ city: "WOODBRIDGE", state: "TAS", postcode: "7162" },
{ city: "FLOWERPOT", state: "TAS", postcode: "7163" },
{ city: "MIDDLETON", state: "TAS", postcode: "7163" },
{ city: "MIDWAY POINT", state: "TAS", postcode: "7171" },
{ city: "PENNA", state: "TAS", postcode: "7171" },
{ city: "NUGENT", state: "TAS", postcode: "7172" },
{ city: "ORIELTON", state: "TAS", postcode: "7172" },
{ city: "PAWLEENA", state: "TAS", postcode: "7172" },
{ city: "SORELL", state: "TAS", postcode: "7172" },
{ city: "WATTLE HILL", state: "TAS", postcode: "7172" },
{ city: "CARLTON", state: "TAS", postcode: "7173" },
{ city: "CARLTON RIVER", state: "TAS", postcode: "7173" },
{ city: "CONNELLYS MARSH", state: "TAS", postcode: "7173" },
{ city: "DODGES FERRY", state: "TAS", postcode: "7173" },
{ city: "FORCETT", state: "TAS", postcode: "7173" },
{ city: "LEWISHAM", state: "TAS", postcode: "7173" },
{ city: "PRIMROSE SANDS", state: "TAS", postcode: "7173" },
{ city: "COPPING", state: "TAS", postcode: "7174" },
{ city: "BREAM CREEK", state: "TAS", postcode: "7175" },
{ city: "MARION BAY", state: "TAS", postcode: "7175" },
{ city: "KELLEVIE", state: "TAS", postcode: "7176" },
{ city: "BOOMER BAY", state: "TAS", postcode: "7177" },
{ city: "DUNALLEY", state: "TAS", postcode: "7177" },
{ city: "MURDUNNA", state: "TAS", postcode: "7178" },
{ city: "EAGLEHAWK NECK", state: "TAS", postcode: "7179" },
{ city: "TARANNA", state: "TAS", postcode: "7180" },
{ city: "CAPE PILLAR", state: "TAS", postcode: "7182" },
{ city: "FORTESCUE", state: "TAS", postcode: "7182" },
{ city: "PORT ARTHUR", state: "TAS", postcode: "7182" },
{ city: "HIGHCROFT", state: "TAS", postcode: "7183" },
{ city: "CAPE RAOUL", state: "TAS", postcode: "7184" },
{ city: "NUBEENA", state: "TAS", postcode: "7184" },
{ city: "STORMLEA", state: "TAS", postcode: "7184" },
{ city: "WHITE BEACH", state: "TAS", postcode: "7184" },
{ city: "PREMAYDENA", state: "TAS", postcode: "7185" },
{ city: "SALTWATER RIVER", state: "TAS", postcode: "7186" },
{ city: "SLOPING MAIN", state: "TAS", postcode: "7186" },
{ city: "KOONYA", state: "TAS", postcode: "7187" },
{ city: "APSLAWN", state: "TAS", postcode: "7190" },
{ city: "BUCKLAND", state: "TAS", postcode: "7190" },
{ city: "CRANBROOK", state: "TAS", postcode: "7190" },
{ city: "DOLPHIN SANDS", state: "TAS", postcode: "7190" },
{ city: "LITTLE SWANPORT", state: "TAS", postcode: "7190" },
{ city: "ORFORD", state: "TAS", postcode: "7190" },
{ city: "PONTYPOOL", state: "TAS", postcode: "7190" },
{ city: "RHEBAN", state: "TAS", postcode: "7190" },
{ city: "ROCKY HILLS", state: "TAS", postcode: "7190" },
{ city: "RUNNYMEDE", state: "TAS", postcode: "7190" },
{ city: "SPRING BEACH", state: "TAS", postcode: "7190" },
{ city: "SWANSEA", state: "TAS", postcode: "7190" },
{ city: "TRIABUNNA", state: "TAS", postcode: "7190" },
{ city: "ROSS", state: "TAS", postcode: "7209" },
{ city: "TOOMS LAKE", state: "TAS", postcode: "7209" },
{ city: "CAMPBELL TOWN", state: "TAS", postcode: "7210" },
{ city: "LAKE LEAKE", state: "TAS", postcode: "7210" },
{ city: "CLEVELAND", state: "TAS", postcode: "7211" },
{ city: "CONARA", state: "TAS", postcode: "7211" },
{ city: "EPPING FOREST", state: "TAS", postcode: "7211" },
{ city: "BEN LOMOND", state: "TAS", postcode: "7212" },
{ city: "BLESSINGTON", state: "TAS", postcode: "7212" },
{ city: "BURNS CREEK", state: "TAS", postcode: "7212" },
{ city: "DEDDINGTON", state: "TAS", postcode: "7212" },
{ city: "EVANDALE", state: "TAS", postcode: "7212" },
{ city: "NILE", state: "TAS", postcode: "7212" },
{ city: "UPPER BLESSINGTON", state: "TAS", postcode: "7212" },
{ city: "AVOCA", state: "TAS", postcode: "7213" },
{ city: "ROSSARDEN", state: "TAS", postcode: "7213" },
{ city: "ROYAL GEORGE", state: "TAS", postcode: "7213" },
{ city: "STORYS CREEK", state: "TAS", postcode: "7213" },
{ city: "FINGAL", state: "TAS", postcode: "7214" },
{ city: "MANGANA", state: "TAS", postcode: "7214" },
{ city: "UPPER ESK", state: "TAS", postcode: "7214" },
{ city: "BEAUMARIS", state: "TAS", postcode: "7215" },
{ city: "BICHENO", state: "TAS", postcode: "7215" },
{ city: "CHAIN OF LAGOONS", state: "TAS", postcode: "7215" },
{ city: "COLES BAY", state: "TAS", postcode: "7215" },
{ city: "CORNWALL", state: "TAS", postcode: "7215" },
{ city: "DOUGLAS-APSLEY", state: "TAS", postcode: "7215" },
{ city: "DOUGLAS RIVER", state: "TAS", postcode: "7215" },
{ city: "FALMOUTH", state: "TAS", postcode: "7215" },
{ city: "FOUR MILE CREEK", state: "TAS", postcode: "7215" },
{ city: "FREYCINET", state: "TAS", postcode: "7215" },
{ city: "FRIENDLY BEACHES", state: "TAS", postcode: "7215" },
{ city: "GRAY", state: "TAS", postcode: "7215" },
{ city: "SCAMANDER", state: "TAS", postcode: "7215" },
{ city: "SEYMOUR", state: "TAS", postcode: "7215" },
{ city: "ST MARYS", state: "TAS", postcode: "7215" },
{ city: "UPPER SCAMANDER", state: "TAS", postcode: "7215" },
{ city: "AKAROA", state: "TAS", postcode: "7216" },
{ city: "BINALONG BAY", state: "TAS", postcode: "7216" },
{ city: "GOSHEN", state: "TAS", postcode: "7216" },
{ city: "GOULDS COUNTRY", state: "TAS", postcode: "7216" },
{ city: "LOTTAH", state: "TAS", postcode: "7216" },
{ city: "PYENGANA", state: "TAS", postcode: "7216" },
{ city: "ST HELENS", state: "TAS", postcode: "7216" },
{ city: "STIEGLITZ", state: "TAS", postcode: "7216" },
{ city: "THE GARDENS", state: "TAS", postcode: "7216" },
{ city: "MAYFIELD", state: "TAS", postcode: "7248" },
{ city: "MOWBRAY", state: "TAS", postcode: "7248" },
{ city: "ROCHERLEA", state: "TAS", postcode: "7248" },
{ city: "KINGS MEADOWS", state: "TAS", postcode: "7249" },
{ city: "PUNCHBOWL", state: "TAS", postcode: "7249" },
{ city: "SOUTH LAUNCESTON", state: "TAS", postcode: "7249" },
{ city: "YOUNGTOWN", state: "TAS", postcode: "7249" },
{ city: "BEECHFORD", state: "TAS", postcode: "7252" },
{ city: "DILSTON", state: "TAS", postcode: "7252" },
{ city: "HILLWOOD", state: "TAS", postcode: "7252" },
{ city: "LEFROY", state: "TAS", postcode: "7252" },
{ city: "LULWORTH", state: "TAS", postcode: "7252" },
{ city: "MOUNT DIRECTION", state: "TAS", postcode: "7252" },
{ city: "PIPERS RIVER", state: "TAS", postcode: "7252" },
{ city: "STONY HEAD", state: "TAS", postcode: "7252" },
{ city: "SWAN BAY", state: "TAS", postcode: "7252" },
{ city: "WEYMOUTH", state: "TAS", postcode: "7252" },
{ city: "WINDERMERE", state: "TAS", postcode: "7252" },
{ city: "BELL BAY", state: "TAS", postcode: "7253" },
{ city: "GEORGE TOWN", state: "TAS", postcode: "7253" },
{ city: "LONG REACH", state: "TAS", postcode: "7253" },
{ city: "LOW HEAD", state: "TAS", postcode: "7253" },
{ city: "BELLINGHAM", state: "TAS", postcode: "7254" },
{ city: "GOLCONDA", state: "TAS", postcode: "7254" },
{ city: "LEBRINA", state: "TAS", postcode: "7254" },
{ city: "PIPERS BROOK", state: "TAS", postcode: "7254" },
{ city: "RETREAT", state: "TAS", postcode: "7254" },
{ city: "TUNNEL", state: "TAS", postcode: "7254" },
{ city: "WYENA", state: "TAS", postcode: "7254" },
{ city: "BLUE ROCKS", state: "TAS", postcode: "7255" },
{ city: "EMITA", state: "TAS", postcode: "7255" },
{ city: "KILLIECRANKIE", state: "TAS", postcode: "7255" },
{ city: "LACKRANA", state: "TAS", postcode: "7255" },
{ city: "LADY BARRON", state: "TAS", postcode: "7255" },
{ city: "LEEKA", state: "TAS", postcode: "7255" },
{ city: "LOCCOTA", state: "TAS", postcode: "7255" },
{ city: "LUGHRATA", state: "TAS", postcode: "7255" },
{ city: "MEMANA", state: "TAS", postcode: "7255" },
{ city: "PALANA", state: "TAS", postcode: "7255" },
{ city: "RANGA", state: "TAS", postcode: "7255" },
{ city: "STRZELECKI", state: "TAS", postcode: "7255" },
{ city: "WHITEMARK", state: "TAS", postcode: "7255" },
{ city: "WINGAROO", state: "TAS", postcode: "7255" },
{ city: "BUNGAREE", state: "TAS", postcode: "7256" },
{ city: "CURRIE", state: "TAS", postcode: "7256" },
{ city: "EGG LAGOON", state: "TAS", postcode: "7256" },
{ city: "GRASSY", state: "TAS", postcode: "7256" },
{ city: "LOORANA", state: "TAS", postcode: "7256" },
{ city: "LYMWOOD", state: "TAS", postcode: "7256" },
{ city: "NARACOOPA", state: "TAS", postcode: "7256" },
{ city: "NUGARA", state: "TAS", postcode: "7256" },
{ city: "PEARSHAPE", state: "TAS", postcode: "7256" },
{ city: "PEGARAH", state: "TAS", postcode: "7256" },
{ city: "REEKARA", state: "TAS", postcode: "7256" },
{ city: "SEA ELEPHANT", state: "TAS", postcode: "7256" },
{ city: "SURPRISE BAY", state: "TAS", postcode: "7256" },
{ city: "WICKHAM", state: "TAS", postcode: "7256" },
{ city: "YAMBACOONA", state: "TAS", postcode: "7256" },
{ city: "YARRA CREEK", state: "TAS", postcode: "7256" },
{ city: "CAPE BARREN ISLAND", state: "TAS", postcode: "7257" },
{ city: "BREADALBANE", state: "TAS", postcode: "7258" },
{ city: "RELBIA", state: "TAS", postcode: "7258" },
{ city: "WHITE HILLS", state: "TAS", postcode: "7258" },
{ city: "MYRTLE BANK", state: "TAS", postcode: "7259" },
{ city: "NUNAMARA", state: "TAS", postcode: "7259" },
{ city: "PATERSONIA", state: "TAS", postcode: "7259" },
{ city: "TARGA", state: "TAS", postcode: "7259" },
{ city: "TAYENE", state: "TAS", postcode: "7259" },
{ city: "BLUMONT", state: "TAS", postcode: "7260" },
{ city: "CUCKOO", state: "TAS", postcode: "7260" },
{ city: "FORESTER", state: "TAS", postcode: "7260" },
{ city: "JETSONVILLE", state: "TAS", postcode: "7260" },
{ city: "KAMONA", state: "TAS", postcode: "7260" },
{ city: "LIETINNA", state: "TAS", postcode: "7260" },
{ city: "LISLE", state: "TAS", postcode: "7260" },
{ city: "NABOWLA", state: "TAS", postcode: "7260" },
{ city: "NORTH SCOTTSDALE", state: "TAS", postcode: "7260" },
{ city: "SCOTTSDALE", state: "TAS", postcode: "7260" },
{ city: "SOUTH SPRINGFIELD", state: "TAS", postcode: "7260" },
{ city: "SPRINGFIELD", state: "TAS", postcode: "7260" },
{ city: "TONGANAH", state: "TAS", postcode: "7260" },
{ city: "TULENDEENA", state: "TAS", postcode: "7260" },
{ city: "WEST SCOTTSDALE", state: "TAS", postcode: "7260" },
{ city: "BRANXHOLM", state: "TAS", postcode: "7261" },
{ city: "WARRENTINNA", state: "TAS", postcode: "7261" },
{ city: "BRIDPORT", state: "TAS", postcode: "7262" },
{ city: "TOMAHAWK", state: "TAS", postcode: "7262" },
{ city: "WATERHOUSE", state: "TAS", postcode: "7262" },
{ city: "ALBERTON", state: "TAS", postcode: "7263" },
{ city: "LEGERWOOD", state: "TAS", postcode: "7263" },
{ city: "RINGAROOMA", state: "TAS", postcode: "7263" },
{ city: "TALAWA", state: "TAS", postcode: "7263" },
{ city: "TRENAH", state: "TAS", postcode: "7263" },
{ city: "ANSONS BAY", state: "TAS", postcode: "7264" },
{ city: "BOOBYALLA", state: "TAS", postcode: "7264" },
{ city: "CAPE PORTLAND", state: "TAS", postcode: "7264" },
{ city: "DERBY", state: "TAS", postcode: "7264" },
{ city: "EDDYSTONE", state: "TAS", postcode: "7264" },
{ city: "EDDYSTONE POINT", state: "TAS", postcode: "7264" },
{ city: "GLADSTONE", state: "TAS", postcode: "7264" },
{ city: "HERRICK", state: "TAS", postcode: "7264" },
{ city: "MOORINA", state: "TAS", postcode: "7264" },
{ city: "MOUNT WILLIAM", state: "TAS", postcode: "7264" },
{ city: "MUSSELROE BAY", state: "TAS", postcode: "7264" },
{ city: "PIONEER", state: "TAS", postcode: "7264" },
{ city: "RUSHY LAGOON", state: "TAS", postcode: "7264" },
{ city: "SOUTH MOUNT CAMERON", state: "TAS", postcode: "7264" },
{ city: "TELITA", state: "TAS", postcode: "7264" },
{ city: "WELDBOROUGH", state: "TAS", postcode: "7264" },
{ city: "BANCA", state: "TAS", postcode: "7265" },
{ city: "WINNALEAH", state: "TAS", postcode: "7265" },
{ city: "BANGOR", state: "TAS", postcode: "7267" },
{ city: "KAROOLA", state: "TAS", postcode: "7267" },
{ city: "LALLA", state: "TAS", postcode: "7267" },
{ city: "LOWER TURNERS MARSH", state: "TAS", postcode: "7267" },
{ city: "TURNERS MARSH", state: "TAS", postcode: "7267" },
{ city: "LILYDALE", state: "TAS", postcode: "7268" },
{ city: "NORTH LILYDALE", state: "TAS", postcode: "7268" },
{ city: "UNDERWOOD", state: "TAS", postcode: "7268" },
{ city: "BADGER HEAD", state: "TAS", postcode: "7270" },
{ city: "BEACONSFIELD", state: "TAS", postcode: "7270" },
{ city: "BEAUTY POINT", state: "TAS", postcode: "7270" },
{ city: "CLARENCE POINT", state: "TAS", postcode: "7270" },
{ city: "FLOWERY GULLY", state: "TAS", postcode: "7270" },
{ city: "GREENS BEACH", state: "TAS", postcode: "7270" },
{ city: "KAYENA", state: "TAS", postcode: "7270" },
{ city: "KELSO", state: "TAS", postcode: "7270" },
{ city: "ROWELLA", state: "TAS", postcode: "7270" },
{ city: "SIDMOUTH", state: "TAS", postcode: "7270" },
{ city: "YORK TOWN", state: "TAS", postcode: "7270" },
{ city: "BLACKWALL", state: "TAS", postcode: "7275" },
{ city: "DEVIOT", state: "TAS", postcode: "7275" },
{ city: "EXETER", state: "TAS", postcode: "7275" },
{ city: "FRANKFORD", state: "TAS", postcode: "7275" },
{ city: "GLENGARRY", state: "TAS", postcode: "7275" },
{ city: "HOLWELL", state: "TAS", postcode: "7275" },
{ city: "LANENA", state: "TAS", postcode: "7275" },
{ city: "LOIRA", state: "TAS", postcode: "7275" },
{ city: "NOTLEY HILLS", state: "TAS", postcode: "7275" },
{ city: "ROBIGANA", state: "TAS", postcode: "7275" },
{ city: "SWAN POINT", state: "TAS", postcode: "7275" },
{ city: "WINKLEIGH", state: "TAS", postcode: "7275" },
{ city: "GRAVELLY BEACH", state: "TAS", postcode: "7276" },
{ city: "BRIDGENORTH", state: "TAS", postcode: "7277" },
{ city: "GRINDELWALD", state: "TAS", postcode: "7277" },
{ city: "LEGANA", state: "TAS", postcode: "7277" },
{ city: "ROSEVEARS", state: "TAS", postcode: "7277" },
{ city: "HADSPEN", state: "TAS", postcode: "7290" },
{ city: "CARRICK", state: "TAS", postcode: "7291" },
{ city: "HAGLEY", state: "TAS", postcode: "7292" },
{ city: "QUAMBY BEND", state: "TAS", postcode: "7292" },
{ city: "ROSEVALE", state: "TAS", postcode: "7292" },
{ city: "SELBOURNE", state: "TAS", postcode: "7292" },
{ city: "WESTWOOD", state: "TAS", postcode: "7292" },
{ city: "DEVON HILLS", state: "TAS", postcode: "7300" },
{ city: "PERTH", state: "TAS", postcode: "7300" },
{ city: "POWRANNA", state: "TAS", postcode: "7300" },
{ city: "BISHOPSBOURNE", state: "TAS", postcode: "7301" },
{ city: "BLACKWOOD CREEK", state: "TAS", postcode: "7301" },
{ city: "LIFFEY", state: "TAS", postcode: "7301" },
{ city: "LONGFORD", state: "TAS", postcode: "7301" },
{ city: "TOIBERRY", state: "TAS", postcode: "7301" },
{ city: "BRACKNELL", state: "TAS", postcode: "7302" },
{ city: "CRESSY", state: "TAS", postcode: "7302" },
{ city: "POATINA", state: "TAS", postcode: "7302" },
{ city: "BIRRALEE", state: "TAS", postcode: "7303" },
{ city: "CLUAN", state: "TAS", postcode: "7303" },
{ city: "EXTON", state: "TAS", postcode: "7303" },
{ city: "OAKS", state: "TAS", postcode: "7303" },
{ city: "OSMASTON", state: "TAS", postcode: "7303" },
{ city: "WESTBURY", state: "TAS", postcode: "7303" },
{ city: "WHITEMORE", state: "TAS", postcode: "7303" },
{ city: "BRANDUM", state: "TAS", postcode: "7304" },
{ city: "BREONA", state: "TAS", postcode: "7304" },
{ city: "CAVESIDE", state: "TAS", postcode: "7304" },
{ city: "CENTRAL PLATEAU", state: "TAS", postcode: "7304" },
{ city: "CHUDLEIGH", state: "TAS", postcode: "7304" },
{ city: "DAIRY PLAINS", state: "TAS", postcode: "7304" },
{ city: "DELORAINE", state: "TAS", postcode: "7304" },
{ city: "DOCTORS POINT", state: "TAS", postcode: "7304" },
{ city: "DUNORLAN", state: "TAS", postcode: "7304" },
{ city: "ELIZABETH TOWN", state: "TAS", postcode: "7304" },
{ city: "GOLDEN VALLEY", state: "TAS", postcode: "7304" },
{ city: "JACKEYS MARSH", state: "TAS", postcode: "7304" },
{ city: "KIMBERLEY", state: "TAS", postcode: "7304" },
{ city: "LIENA", state: "TAS", postcode: "7304" },
{ city: "MAYBERRY", state: "TAS", postcode: "7304" },
{ city: "MEANDER", state: "TAS", postcode: "7304" },
{ city: "MERSEY FOREST", state: "TAS", postcode: "7304" },
{ city: "MOLE CREEK", state: "TAS", postcode: "7304" },
{ city: "MOLTEMA", state: "TAS", postcode: "7304" },
{ city: "MONTANA", state: "TAS", postcode: "7304" },
{ city: "NEEDLES", state: "TAS", postcode: "7304" },
{ city: "PARKHAM", state: "TAS", postcode: "7304" },
{ city: "QUAMBY BROOK", state: "TAS", postcode: "7304" },
{ city: "RED HILLS", state: "TAS", postcode: "7304" },
{ city: "REEDY MARSH", state: "TAS", postcode: "7304" },
{ city: "REYNOLDS NECK", state: "TAS", postcode: "7304" },
{ city: "WALLS OF JERUSALEM", state: "TAS", postcode: "7304" },
{ city: "WEEGENA", state: "TAS", postcode: "7304" },
{ city: "WEETAH", state: "TAS", postcode: "7304" },
{ city: "WESTERN CREEK", state: "TAS", postcode: "7304" },
{ city: "MERSEYLEA", state: "TAS", postcode: "7305" },
{ city: "RAILTON", state: "TAS", postcode: "7305" },
{ city: "SUNNYSIDE", state: "TAS", postcode: "7305" },
{ city: "ACACIA HILLS", state: "TAS", postcode: "7306" },
{ city: "BARRINGTON", state: "TAS", postcode: "7306" },
{ city: "BEULAH", state: "TAS", postcode: "7306" },
{ city: "CETHANA", state: "TAS", postcode: "7306" },
{ city: "CLAUDE ROAD", state: "TAS", postcode: "7306" },
{ city: "CRADLE MOUNTAIN", state: "TAS", postcode: "7306" },
{ city: "GOWRIE PARK", state: "TAS", postcode: "7306" },
{ city: "LORINNA", state: "TAS", postcode: "7306" },
{ city: "LOWER BARRINGTON", state: "TAS", postcode: "7306" },
{ city: "LOWER BEULAH", state: "TAS", postcode: "7306" },
{ city: "MIDDLESEX", state: "TAS", postcode: "7306" },
{ city: "MOUNT ROLAND", state: "TAS", postcode: "7306" },
{ city: "NOOK", state: "TAS", postcode: "7306" },
{ city: "NOWHERE ELSE", state: "TAS", postcode: "7306" },
{ city: "PARADISE", state: "TAS", postcode: "7306" },
{ city: "PROMISED LAND", state: "TAS", postcode: "7306" },
{ city: "ROLAND", state: "TAS", postcode: "7306" },
{ city: "SHEFFIELD", state: "TAS", postcode: "7306" },
{ city: "STAVERTON", state: "TAS", postcode: "7306" },
{ city: "STOODLEY", state: "TAS", postcode: "7306" },
{ city: "WEST KENTISH", state: "TAS", postcode: "7306" },
{ city: "BAKERS BEACH", state: "TAS", postcode: "7307" },
{ city: "HARFORD", state: "TAS", postcode: "7307" },
{ city: "HAWLEY BEACH", state: "TAS", postcode: "7307" },
{ city: "LATROBE", state: "TAS", postcode: "7307" },
{ city: "MORIARTY", state: "TAS", postcode: "7307" },
{ city: "NORTHDOWN", state: "TAS", postcode: "7307" },
{ city: "PORT SORELL", state: "TAS", postcode: "7307" },
{ city: "SASSAFRAS", state: "TAS", postcode: "7307" },
{ city: "SHEARWATER", state: "TAS", postcode: "7307" },
{ city: "SQUEAKING POINT", state: "TAS", postcode: "7307" },
{ city: "THIRLSTANE", state: "TAS", postcode: "7307" },
{ city: "WESLEY VALE", state: "TAS", postcode: "7307" },
{ city: "ABERDEEN", state: "TAS", postcode: "7310" },
{ city: "AMBLESIDE", state: "TAS", postcode: "7310" },
{ city: "DON", state: "TAS", postcode: "7310" },
{ city: "EAST DEVONPORT", state: "TAS", postcode: "7310" },
{ city: "ERRIBA", state: "TAS", postcode: "7310" },
{ city: "EUGENANA", state: "TAS", postcode: "7310" },
{ city: "FORTH", state: "TAS", postcode: "7310" },
{ city: "FORTHSIDE", state: "TAS", postcode: "7310" },
{ city: "KINDRED", state: "TAS", postcode: "7310" },
{ city: "LILLICO", state: "TAS", postcode: "7310" },
{ city: "LOWER WILMOT", state: "TAS", postcode: "7310" },
{ city: "MELROSE", state: "TAS", postcode: "7310" },
{ city: "MIANDETTA", state: "TAS", postcode: "7310" },
{ city: "MOINA", state: "TAS", postcode: "7310" },
{ city: "PALOONA", state: "TAS", postcode: "7310" },
{ city: "QUOIBA", state: "TAS", postcode: "7310" },
{ city: "SOUTH SPREYTON", state: "TAS", postcode: "7310" },
{ city: "SPREYTON", state: "TAS", postcode: "7310" },
{ city: "STONY RISE", state: "TAS", postcode: "7310" },
{ city: "TARLETON", state: "TAS", postcode: "7310" },
{ city: "TUGRAH", state: "TAS", postcode: "7310" },
{ city: "WEST DEVONPORT", state: "TAS", postcode: "7310" },
{ city: "WILMOT", state: "TAS", postcode: "7310" },
{ city: "ABBOTSHAM", state: "TAS", postcode: "7315" },
{ city: "CASTRA", state: "TAS", postcode: "7315" },
{ city: "GAWLER", state: "TAS", postcode: "7315" },
{ city: "GUNNS PLAINS", state: "TAS", postcode: "7315" },
{ city: "LEITH", state: "TAS", postcode: "7315" },
{ city: "LOONGANA", state: "TAS", postcode: "7315" },
{ city: "NIETTA", state: "TAS", postcode: "7315" },
{ city: "NORTH MOTTON", state: "TAS", postcode: "7315" },
{ city: "PRESTON", state: "TAS", postcode: "7315" },
{ city: "SOUTH NIETTA", state: "TAS", postcode: "7315" },
{ city: "SOUTH PRESTON", state: "TAS", postcode: "7315" },
{ city: "SPALFORD", state: "TAS", postcode: "7315" },
{ city: "SPRENT", state: "TAS", postcode: "7315" },
{ city: "TURNERS BEACH", state: "TAS", postcode: "7315" },
{ city: "ULVERSTONE", state: "TAS", postcode: "7315" },
{ city: "UPPER CASTRA", state: "TAS", postcode: "7315" },
{ city: "WEST ULVERSTONE", state: "TAS", postcode: "7315" },
{ city: "CAMENA", state: "TAS", postcode: "7316" },
{ city: "CUPRONA", state: "TAS", postcode: "7316" },
{ city: "HEYBRIDGE", state: "TAS", postcode: "7316" },
{ city: "HOWTH", state: "TAS", postcode: "7316" },
{ city: "LOYETEA", state: "TAS", postcode: "7316" },
{ city: "PENGUIN", state: "TAS", postcode: "7316" },
{ city: "PRESERVATION BAY", state: "TAS", postcode: "7316" },
{ city: "RIANA", state: "TAS", postcode: "7316" },
{ city: "SOUTH RIANA", state: "TAS", postcode: "7316" },
{ city: "SULPHUR CREEK", state: "TAS", postcode: "7316" },
{ city: "WEST PINE", state: "TAS", postcode: "7316" },
{ city: "ACTON", state: "TAS", postcode: "7320" },
{ city: "BROOKLYN", state: "TAS", postcode: "7320" },
{ city: "BURNIE", state: "TAS", postcode: "7320" },
{ city: "CAMDALE", state: "TAS", postcode: "7320" },
{ city: "COOEE", state: "TAS", postcode: "7320" },
{ city: "DOWNLANDS", state: "TAS", postcode: "7320" },
{ city: "EMU HEIGHTS", state: "TAS", postcode: "7320" },
{ city: "HAVENVIEW", state: "TAS", postcode: "7320" },
{ city: "HILLCREST", state: "TAS", postcode: "7320" },
{ city: "MONTELLO", state: "TAS", postcode: "7320" },
{ city: "OCEAN VISTA", state: "TAS", postcode: "7320" },
{ city: "PARK GROVE", state: "TAS", postcode: "7320" },
{ city: "PARKLANDS", state: "TAS", postcode: "7320" },
{ city: "ROMAINE", state: "TAS", postcode: "7320" },
{ city: "ROUND HILL", state: "TAS", postcode: "7320" },
{ city: "SHOREWELL PARK", state: "TAS", postcode: "7320" },
{ city: "SOUTH BURNIE", state: "TAS", postcode: "7320" },
{ city: "UPPER BURNIE", state: "TAS", postcode: "7320" },
{ city: "WIVENHOE", state: "TAS", postcode: "7320" },
{ city: "BLACK RIVER", state: "TAS", postcode: "7321" },
{ city: "BOAT HARBOUR", state: "TAS", postcode: "7321" },
{ city: "BOAT HARBOUR BEACH", state: "TAS", postcode: "7321" },
{ city: "CHASM CREEK", state: "TAS", postcode: "7321" },
{ city: "CORINNA", state: "TAS", postcode: "7321" },
{ city: "COWRIE POINT", state: "TAS", postcode: "7321" },
{ city: "CRAYFISH CREEK", state: "TAS", postcode: "7321" },
{ city: "DETENTION", state: "TAS", postcode: "7321" },
{ city: "EAST CAM", state: "TAS", postcode: "7321" },
{ city: "EAST RIDGLEY", state: "TAS", postcode: "7321" },
{ city: "EDGCUMBE BEACH", state: "TAS", postcode: "7321" },
{ city: "GUILDFORD", state: "TAS", postcode: "7321" },
{ city: "HAMPSHIRE", state: "TAS", postcode: "7321" },
{ city: "HELLYER", state: "TAS", postcode: "7321" },
{ city: "HIGHCLERE", state: "TAS", postcode: "7321" },
{ city: "LUINA", state: "TAS", postcode: "7321" },
{ city: "MAWBANNA", state: "TAS", postcode: "7321" },
{ city: "MONTUMANA", state: "TAS", postcode: "7321" },
{ city: "MOOREVILLE", state: "TAS", postcode: "7321" },
{ city: "NATONE", state: "TAS", postcode: "7321" },
{ city: "PARRAWE", state: "TAS", postcode: "7321" },
{ city: "PORT LATTA", state: "TAS", postcode: "7321" },
{ city: "RIDGLEY", state: "TAS", postcode: "7321" },
{ city: "ROCKY CAPE", state: "TAS", postcode: "7321" },
{ city: "SAVAGE RIVER", state: "TAS", postcode: "7321" },
{ city: "SISTERS BEACH", state: "TAS", postcode: "7321" },
{ city: "STOWPORT", state: "TAS", postcode: "7321" },
{ city: "TEWKESBURY", state: "TAS", postcode: "7321" },
{ city: "TULLAH", state: "TAS", postcode: "7321" },
{ city: "UPPER NATONE", state: "TAS", postcode: "7321" },
{ city: "UPPER STOWPORT", state: "TAS", postcode: "7321" },
{ city: "WARATAH", state: "TAS", postcode: "7321" },
{ city: "WEST MOOREVILLE", state: "TAS", postcode: "7321" },
{ city: "WEST RIDGLEY", state: "TAS", postcode: "7321" },
{ city: "WILTSHIRE", state: "TAS", postcode: "7321" },
{ city: "SOMERSET", state: "TAS", postcode: "7322" },
{ city: "CALDER", state: "TAS", postcode: "7325" },
{ city: "DOCTORS ROCKS", state: "TAS", postcode: "7325" },
{ city: "ELLIOTT", state: "TAS", postcode: "7325" },
{ city: "FLOWERDALE", state: "TAS", postcode: "7325" },
{ city: "HENRIETTA", state: "TAS", postcode: "7325" },
{ city: "LAPOINYA", state: "TAS", postcode: "7325" },
{ city: "MEUNNA", state: "TAS", postcode: "7325" },
{ city: "MILABENA", state: "TAS", postcode: "7325" },
{ city: "MOORLEAH", state: "TAS", postcode: "7325" },
{ city: "MOUNT HICKS", state: "TAS", postcode: "7325" },
{ city: "MYALLA", state: "TAS", postcode: "7325" },
{ city: "OLDINA", state: "TAS", postcode: "7325" },
{ city: "OONAH", state: "TAS", postcode: "7325" },
{ city: "PREOLENNA", state: "TAS", postcode: "7325" },
{ city: "SISTERS CREEK", state: "TAS", postcode: "7325" },
{ city: "TABLE CAPE", state: "TAS", postcode: "7325" },
{ city: "TAKONE", state: "TAS", postcode: "7325" },
{ city: "WEST TAKONE", state: "TAS", postcode: "7325" },
{ city: "WYNYARD", state: "TAS", postcode: "7325" },
{ city: "YOLLA", state: "TAS", postcode: "7325" },
{ city: "ALCOMIE", state: "TAS", postcode: "7330" },
{ city: "ARTHUR RIVER", state: "TAS", postcode: "7330" },
{ city: "BRITTONS SWAMP", state: "TAS", postcode: "7330" },
{ city: "BROADMEADOWS", state: "TAS", postcode: "7330" },
{ city: "CHRISTMAS HILLS", state: "TAS", postcode: "7330" },
{ city: "COUTA ROCKS", state: "TAS", postcode: "7330" },
{ city: "EDITH CREEK", state: "TAS", postcode: "7330" },
{ city: "FOREST", state: "TAS", postcode: "7330" },
{ city: "IRISHTOWN", state: "TAS", postcode: "7330" },
{ city: "LILEAH", state: "TAS", postcode: "7330" },
{ city: "MARRAWAH", state: "TAS", postcode: "7330" },
{ city: "MELLA", state: "TAS", postcode: "7330" },
{ city: "MENGHA", state: "TAS", postcode: "7330" },
{ city: "MONTAGU", state: "TAS", postcode: "7330" },
{ city: "NABAGEENA", state: "TAS", postcode: "7330" },
{ city: "NELSON BAY", state: "TAS", postcode: "7330" },
{ city: "REDPA", state: "TAS", postcode: "7330" },
{ city: "ROGER RIVER", state: "TAS", postcode: "7330" },
{ city: "SCOPUS", state: "TAS", postcode: "7330" },
{ city: "SCOTCHTOWN", state: "TAS", postcode: "7330" },
{ city: "SMITHTON", state: "TAS", postcode: "7330" },
{ city: "SOUTH FOREST", state: "TAS", postcode: "7330" },
{ city: "TEMMA", state: "TAS", postcode: "7330" },
{ city: "THREE HUMMOCK ISLAND", state: "TAS", postcode: "7330" },
{ city: "TOGARI", state: "TAS", postcode: "7330" },
{ city: "TROWUTTA", state: "TAS", postcode: "7330" },
{ city: "WEST MONTAGU", state: "TAS", postcode: "7330" },
{ city: "WOOLNORTH", state: "TAS", postcode: "7330" },
{ city: "STANLEY", state: "TAS", postcode: "7331" },
{ city: "GORMANSTON", state: "TAS", postcode: "7466" },
{ city: "LAKE MARGARET", state: "TAS", postcode: "7467" },
{ city: "QUEENSTOWN", state: "TAS", postcode: "7467" },
{ city: "MACQUARIE HEADS", state: "TAS", postcode: "7468" },
{ city: "STRAHAN", state: "TAS", postcode: "7468" },
{ city: "GRANVILLE HARBOUR", state: "TAS", postcode: "7469" },
{ city: "RENISON BELL", state: "TAS", postcode: "7469" },
{ city: "TRIAL HARBOUR", state: "TAS", postcode: "7469" },
{ city: "ZEEHAN", state: "TAS", postcode: "7469" },
{ city: "ROSEBERY", state: "TAS", postcode: "7470" },
{ city: "OAKLANDS JUNCTION", state: "VIC", postcode: "3063" },
{ city: "YUROKE", state: "VIC", postcode: "3063" },
{ city: "ARTHURS CREEK", state: "VIC", postcode: "3099" },
{ city: "COTTLES BRIDGE", state: "VIC", postcode: "3099" },
{ city: "HURSTBRIDGE", state: "VIC", postcode: "3099" },
{ city: "NUTFIELD", state: "VIC", postcode: "3099" },
{ city: "STRATHEWEN", state: "VIC", postcode: "3099" },
{ city: "BEENAK", state: "VIC", postcode: "3139" },
{ city: "DON VALLEY", state: "VIC", postcode: "3139" },
{ city: "HODDLES CREEK", state: "VIC", postcode: "3139" },
{ city: "LAUNCHING PLACE", state: "VIC", postcode: "3139" },
{ city: "SEVILLE", state: "VIC", postcode: "3139" },
{ city: "SEVILLE EAST", state: "VIC", postcode: "3139" },
{ city: "WANDIN EAST", state: "VIC", postcode: "3139" },
{ city: "WANDIN NORTH", state: "VIC", postcode: "3139" },
{ city: "WOORI YALLOCK", state: "VIC", postcode: "3139" },
{ city: "YELLINGBO", state: "VIC", postcode: "3139" },
{ city: "ANAKIE", state: "VIC", postcode: "3221" },
{ city: "BARRABOOL", state: "VIC", postcode: "3221" },
{ city: "BELLARINE", state: "VIC", postcode: "3221" },
{ city: "CERES", state: "VIC", postcode: "3221" },
{ city: "FYANSFORD", state: "VIC", postcode: "3221" },
{ city: "GNARWARRE", state: "VIC", postcode: "3221" },
{ city: "GREY RIVER", state: "VIC", postcode: "3221" },
{ city: "KENNETT RIVER", state: "VIC", postcode: "3221" },
{ city: "MOOLAP", state: "VIC", postcode: "3221" },
{ city: "MOORABOOL", state: "VIC", postcode: "3221" },
{ city: "MURGHEBOLUC", state: "VIC", postcode: "3221" },
{ city: "SEPARATION CREEK", state: "VIC", postcode: "3221" },
{ city: "STAUGHTON VALE", state: "VIC", postcode: "3221" },
{ city: "STONEHAVEN", state: "VIC", postcode: "3221" },
{ city: "SUGARLOAF", state: "VIC", postcode: "3221" },
{ city: "WALLINGTON", state: "VIC", postcode: "3221" },
{ city: "WONGARRA", state: "VIC", postcode: "3221" },
{ city: "WYE RIVER", state: "VIC", postcode: "3221" },
{ city: "CLIFTON SPRINGS", state: "VIC", postcode: "3222" },
{ city: "CURLEWIS", state: "VIC", postcode: "3222" },
{ city: "DRYSDALE", state: "VIC", postcode: "3222" },
{ city: "MANNERIM", state: "VIC", postcode: "3222" },
{ city: "MARCUS HILL", state: "VIC", postcode: "3222" },
{ city: "WALLINGTON", state: "VIC", postcode: "3222" },
{ city: "BELLARINE", state: "VIC", postcode: "3223" },
{ city: "INDENTED HEAD", state: "VIC", postcode: "3223" },
{ city: "PORTARLINGTON", state: "VIC", postcode: "3223" },
{ city: "ST LEONARDS", state: "VIC", postcode: "3223" },
{ city: "LEOPOLD", state: "VIC", postcode: "3224" },
{ city: "MOOLAP", state: "VIC", postcode: "3224" },
{ city: "POINT LONSDALE", state: "VIC", postcode: "3225" },
{ city: "QUEENSCLIFF", state: "VIC", postcode: "3225" },
{ city: "SWAN BAY", state: "VIC", postcode: "3225" },
{ city: "SWAN ISLAND", state: "VIC", postcode: "3225" },
{ city: "OCEAN GROVE", state: "VIC", postcode: "3226" },
{ city: "BARWON HEADS", state: "VIC", postcode: "3227" },
{ city: "BREAMLEA", state: "VIC", postcode: "3227" },
{ city: "CONNEWARRE", state: "VIC", postcode: "3227" },
{ city: "BELLBRAE", state: "VIC", postcode: "3228" },
{ city: "BELLS BEACH", state: "VIC", postcode: "3228" },
{ city: "JAN JUC", state: "VIC", postcode: "3228" },
{ city: "ANGLESEA", state: "VIC", postcode: "3230" },
{ city: "AIREYS INLET", state: "VIC", postcode: "3231" },
{ city: "BIG HILL", state: "VIC", postcode: "3231" },
{ city: "EASTERN VIEW", state: "VIC", postcode: "3231" },
{ city: "FAIRHAVEN", state: "VIC", postcode: "3231" },
{ city: "MOGGS CREEK", state: "VIC", postcode: "3231" },
{ city: "LORNE", state: "VIC", postcode: "3232" },
{ city: "APOLLO BAY", state: "VIC", postcode: "3233" },
{ city: "CAPE OTWAY", state: "VIC", postcode: "3233" },
{ city: "MARENGO", state: "VIC", postcode: "3233" },
{ city: "PETTICOAT CREEK", state: "VIC", postcode: "3233" },
{ city: "SKENES CREEK", state: "VIC", postcode: "3233" },
{ city: "SKENES CREEK NORTH", state: "VIC", postcode: "3233" },
{ city: "GREY RIVER", state: "VIC", postcode: "3234" },
{ city: "KENNETT RIVER", state: "VIC", postcode: "3234" },
{ city: "SEPARATION CREEK", state: "VIC", postcode: "3234" },
{ city: "SUGARLOAF", state: "VIC", postcode: "3234" },
{ city: "WONGARRA", state: "VIC", postcode: "3234" },
{ city: "WYE RIVER", state: "VIC", postcode: "3234" },
{ city: "BENWERRIN", state: "VIC", postcode: "3235" },
{ city: "BOONAH", state: "VIC", postcode: "3235" },
{ city: "DEANS MARSH", state: "VIC", postcode: "3235" },
{ city: "PENNYROYAL", state: "VIC", postcode: "3235" },
{ city: "FORREST", state: "VIC", postcode: "3236" },
{ city: "MOUNT SABINE", state: "VIC", postcode: "3236" },
{ city: "AIRE VALLEY", state: "VIC", postcode: "3237" },
{ city: "BEECH FOREST", state: "VIC", postcode: "3237" },
{ city: "FERGUSON", state: "VIC", postcode: "3237" },
{ city: "GELLIBRAND LOWER", state: "VIC", postcode: "3237" },
{ city: "WATTLE HILL", state: "VIC", postcode: "3237" },
{ city: "WEEAPROINAH", state: "VIC", postcode: "3237" },
{ city: "WYELANGTA", state: "VIC", postcode: "3237" },
{ city: "YUULONG", state: "VIC", postcode: "3237" },
{ city: "GLENAIRE", state: "VIC", postcode: "3238" },
{ city: "HORDERN VALE", state: "VIC", postcode: "3238" },
{ city: "JOHANNA", state: "VIC", postcode: "3238" },
{ city: "LAVERS HILL", state: "VIC", postcode: "3238" },
{ city: "CARLISLE RIVER", state: "VIC", postcode: "3239" },
{ city: "CHAPPLE VALE", state: "VIC", postcode: "3239" },
{ city: "GELLIBRAND", state: "VIC", postcode: "3239" },
{ city: "KENNEDYS CREEK", state: "VIC", postcode: "3239" },
{ city: "BUCKLEY", state: "VIC", postcode: "3240" },
{ city: "GHERANG", state: "VIC", postcode: "3240" },
{ city: "MODEWARRE", state: "VIC", postcode: "3240" },
{ city: "MORIAC", state: "VIC", postcode: "3240" },
{ city: "MOUNT MORIAC", state: "VIC", postcode: "3240" },
{ city: "PARAPARAP", state: "VIC", postcode: "3240" },
{ city: "BAMBRA", state: "VIC", postcode: "3241" },
{ city: "OMBERSLEY", state: "VIC", postcode: "3241" },
{ city: "WENSLEYDALE", state: "VIC", postcode: "3241" },
{ city: "WINCHELSEA", state: "VIC", postcode: "3241" },
{ city: "WINCHELSEA SOUTH", state: "VIC", postcode: "3241" },
{ city: "WURDIBOLUC", state: "VIC", postcode: "3241" },
{ city: "BIRREGURRA", state: "VIC", postcode: "3242" },
{ city: "BARWON DOWNS", state: "VIC", postcode: "3243" },
{ city: "MURROON", state: "VIC", postcode: "3243" },
{ city: "WARNCOORT", state: "VIC", postcode: "3243" },
{ city: "WHOOREL", state: "VIC", postcode: "3243" },
{ city: "ALVIE", state: "VIC", postcode: "3249" },
{ city: "BALINTORE", state: "VIC", postcode: "3249" },
{ city: "BARONGAROOK", state: "VIC", postcode: "3249" },
{ city: "BARONGAROOK WEST", state: "VIC", postcode: "3249" },
{ city: "BARRAMUNGA", state: "VIC", postcode: "3249" },
{ city: "CORAGULAC", state: "VIC", postcode: "3249" },
{ city: "CORUNNUN", state: "VIC", postcode: "3249" },
{ city: "DREEITE", state: "VIC", postcode: "3249" },
{ city: "DREEITE SOUTH", state: "VIC", postcode: "3249" },
{ city: "GERANGAMETE", state: "VIC", postcode: "3249" },
{ city: "IRREWARRA", state: "VIC", postcode: "3249" },
{ city: "IRREWILLIPE", state: "VIC", postcode: "3249" },
{ city: "IRREWILLIPE EAST", state: "VIC", postcode: "3249" },
{ city: "KAWARREN", state: "VIC", postcode: "3249" },
{ city: "LARPENT", state: "VIC", postcode: "3249" },
{ city: "NALANGIL", state: "VIC", postcode: "3249" },
{ city: "ONDIT", state: "VIC", postcode: "3249" },
{ city: "PIRRON YALLOCK", state: "VIC", postcode: "3249" },
{ city: "POMBORNEIT EAST", state: "VIC", postcode: "3249" },
{ city: "SWAN MARSH", state: "VIC", postcode: "3249" },
{ city: "TANYBRYN", state: "VIC", postcode: "3249" },
{ city: "WARRION", state: "VIC", postcode: "3249" },
{ city: "WOOL WOOL", state: "VIC", postcode: "3249" },
{ city: "YEO", state: "VIC", postcode: "3249" },
{ city: "YEODENE", state: "VIC", postcode: "3249" },
{ city: "ELLIMINYT", state: "VIC", postcode: "3250" },
{ city: "BEEAC", state: "VIC", postcode: "3251" },
{ city: "CUNDARE", state: "VIC", postcode: "3251" },
{ city: "CUNDARE NORTH", state: "VIC", postcode: "3251" },
{ city: "EURACK", state: "VIC", postcode: "3251" },
{ city: "WEERING", state: "VIC", postcode: "3251" },
{ city: "COROROOKE", state: "VIC", postcode: "3254" },
{ city: "BOOKAAR", state: "VIC", postcode: "3260" },
{ city: "BOSTOCKS CREEK", state: "VIC", postcode: "3260" },
{ city: "BUNGADOR", state: "VIC", postcode: "3260" },
{ city: "CAMPERDOWN", state: "VIC", postcode: "3260" },
{ city: "CARPENDEIT", state: "VIC", postcode: "3260" },
{ city: "CHOCOLYN", state: "VIC", postcode: "3260" },
{ city: "GNOTUK", state: "VIC", postcode: "3260" },
{ city: "KARIAH", state: "VIC", postcode: "3260" },
{ city: "KOALLAH", state: "VIC", postcode: "3260" },
{ city: "LESLIE MANOR", state: "VIC", postcode: "3260" },
{ city: "POMBORNEIT", state: "VIC", postcode: "3260" },
{ city: "POMBORNEIT NORTH", state: "VIC", postcode: "3260" },
{ city: "SKIBO", state: "VIC", postcode: "3260" },
{ city: "SOUTH PURRUMBETE", state: "VIC", postcode: "3260" },
{ city: "STONYFORD", state: "VIC", postcode: "3260" },
{ city: "TANDAROOK", state: "VIC", postcode: "3260" },
{ city: "TESBURY", state: "VIC", postcode: "3260" },
{ city: "WEERITE", state: "VIC", postcode: "3260" },
{ city: "TERANG", state: "VIC", postcode: "3264" },
{ city: "BOORCAN", state: "VIC", postcode: "3265" },
{ city: "CUDGEE", state: "VIC", postcode: "3265" },
{ city: "DIXIE", state: "VIC", postcode: "3265" },
{ city: "ECKLIN SOUTH", state: "VIC", postcode: "3265" },
{ city: "ELLERSLIE", state: "VIC", postcode: "3265" },
{ city: "FRAMLINGHAM", state: "VIC", postcode: "3265" },
{ city: "FRAMLINGHAM EAST", state: "VIC", postcode: "3265" },
{ city: "GARVOC", state: "VIC", postcode: "3265" },
{ city: "GLENORMISTON", state: "VIC", postcode: "3265" },
{ city: "GLENORMISTON NORTH", state: "VIC", postcode: "3265" },
{ city: "GLENORMISTON SOUTH", state: "VIC", postcode: "3265" },
{ city: "KOLORA", state: "VIC", postcode: "3265" },
{ city: "LAANG", state: "VIC", postcode: "3265" },
{ city: "NOORAT", state: "VIC", postcode: "3265" },
{ city: "NOORAT EAST", state: "VIC", postcode: "3265" },
{ city: "PANMURE", state: "VIC", postcode: "3265" },
{ city: "TAROON", state: "VIC", postcode: "3265" },
{ city: "THE SISTERS", state: "VIC", postcode: "3265" },
{ city: "BULLAHARRE", state: "VIC", postcode: "3266" },
{ city: "COBDEN", state: "VIC", postcode: "3266" },
{ city: "COBRICO", state: "VIC", postcode: "3266" },
{ city: "ELINGAMITE", state: "VIC", postcode: "3266" },
{ city: "ELINGAMITE NORTH", state: "VIC", postcode: "3266" },
{ city: "GLENFYNE", state: "VIC", postcode: "3266" },
{ city: "JANCOURT", state: "VIC", postcode: "3266" },
{ city: "JANCOURT EAST", state: "VIC", postcode: "3266" },
{ city: "NAROGHID", state: "VIC", postcode: "3266" },
{ city: "SIMPSON", state: "VIC", postcode: "3266" },
{ city: "SCOTTS CREEK", state: "VIC", postcode: "3267" },
{ city: "AYRFORD", state: "VIC", postcode: "3268" },
{ city: "BRUCKNELL", state: "VIC", postcode: "3268" },
{ city: "COORIEMUNGLE", state: "VIC", postcode: "3268" },
{ city: "COWLEYS CREEK", state: "VIC", postcode: "3268" },
{ city: "CURDIES RIVER", state: "VIC", postcode: "3268" },
{ city: "CURDIEVALE", state: "VIC", postcode: "3268" },
{ city: "HEYTESBURY LOWER", state: "VIC", postcode: "3268" },
{ city: "NEWFIELD", state: "VIC", postcode: "3268" },
{ city: "NIRRANDA", state: "VIC", postcode: "3268" },
{ city: "NIRRANDA EAST", state: "VIC", postcode: "3268" },
{ city: "NIRRANDA SOUTH", state: "VIC", postcode: "3268" },
{ city: "NULLAWARRE", state: "VIC", postcode: "3268" },
{ city: "NULLAWARRE NORTH", state: "VIC", postcode: "3268" },
{ city: "PAARATTE", state: "VIC", postcode: "3268" },
{ city: "THE COVE", state: "VIC", postcode: "3268" },
{ city: "TIMBOON", state: "VIC", postcode: "3268" },
{ city: "TIMBOON WEST", state: "VIC", postcode: "3268" },
{ city: "PORT CAMPBELL", state: "VIC", postcode: "3269" },
{ city: "PRINCETOWN", state: "VIC", postcode: "3269" },
{ city: "WAARRE", state: "VIC", postcode: "3269" },
{ city: "PETERBOROUGH", state: "VIC", postcode: "3270" },
{ city: "DARLINGTON", state: "VIC", postcode: "3271" },
{ city: "DUNDONNELL", state: "VIC", postcode: "3271" },
{ city: "PURA PURA", state: "VIC", postcode: "3271" },
{ city: "MORTLAKE", state: "VIC", postcode: "3272" },
{ city: "WOORNDOO", state: "VIC", postcode: "3272" },
{ city: "HEXHAM", state: "VIC", postcode: "3273" },
{ city: "CARAMUT", state: "VIC", postcode: "3274" },
{ city: "MAILORS FLAT", state: "VIC", postcode: "3275" },
{ city: "MINJAH", state: "VIC", postcode: "3276" },
{ city: "WOOLSTHORPE", state: "VIC", postcode: "3276" },
{ city: "ALLANSFORD", state: "VIC", postcode: "3277" },
{ city: "MEPUNGA", state: "VIC", postcode: "3277" },
{ city: "MEPUNGA EAST", state: "VIC", postcode: "3277" },
{ city: "MEPUNGA WEST", state: "VIC", postcode: "3277" },
{ city: "NARINGAL", state: "VIC", postcode: "3277" },
{ city: "NARINGAL EAST", state: "VIC", postcode: "3277" },
{ city: "PURNIM", state: "VIC", postcode: "3278" },
{ city: "PURNIM WEST", state: "VIC", postcode: "3278" },
{ city: "BALLANGEICH", state: "VIC", postcode: "3279" },
{ city: "WANGOOM", state: "VIC", postcode: "3279" },
{ city: "DENNINGTON", state: "VIC", postcode: "3280" },
{ city: "BUSHFIELD", state: "VIC", postcode: "3281" },
{ city: "GRASSMERE", state: "VIC", postcode: "3281" },
{ city: "WINSLOW", state: "VIC", postcode: "3281" },
{ city: "WOODFORD", state: "VIC", postcode: "3281" },
{ city: "ILLOWA", state: "VIC", postcode: "3282" },
{ city: "KOROIT", state: "VIC", postcode: "3282" },
{ city: "CROSSLEY", state: "VIC", postcode: "3283" },
{ city: "KILLARNEY", state: "VIC", postcode: "3283" },
{ city: "KIRKSTALL", state: "VIC", postcode: "3283" },
{ city: "SOUTHERN CROSS", state: "VIC", postcode: "3283" },
{ city: "TARRONE", state: "VIC", postcode: "3283" },
{ city: "TOWER HILL", state: "VIC", postcode: "3283" },
{ city: "WARRONG", state: "VIC", postcode: "3283" },
{ city: "WILLATOOK", state: "VIC", postcode: "3283" },
{ city: "YANGERY", state: "VIC", postcode: "3283" },
{ city: "YARPTURK", state: "VIC", postcode: "3283" },
{ city: "ORFORD", state: "VIC", postcode: "3284" },
{ city: "PORT FAIRY", state: "VIC", postcode: "3284" },
{ city: "CODRINGTON", state: "VIC", postcode: "3285" },
{ city: "NARRAWONG", state: "VIC", postcode: "3285" },
{ city: "ROSEBROOK", state: "VIC", postcode: "3285" },
{ city: "ST HELENS", state: "VIC", postcode: "3285" },
{ city: "TOOLONG", state: "VIC", postcode: "3285" },
{ city: "TYRENDARRA", state: "VIC", postcode: "3285" },
{ city: "TYRENDARRA EAST", state: "VIC", postcode: "3285" },
{ city: "YAMBUK", state: "VIC", postcode: "3285" },
{ city: "CONDAH SWAMP", state: "VIC", postcode: "3286" },
{ city: "KNEBSWORTH", state: "VIC", postcode: "3286" },
{ city: "MACARTHUR", state: "VIC", postcode: "3286" },
{ city: "WARRABKOOK", state: "VIC", postcode: "3286" },
{ city: "HAWKESDALE", state: "VIC", postcode: "3287" },
{ city: "MINHAMITE", state: "VIC", postcode: "3287" },
{ city: "GAZETTE", state: "VIC", postcode: "3289" },
{ city: "GERRIGERRUP", state: "VIC", postcode: "3289" },
{ city: "PENSHURST", state: "VIC", postcode: "3289" },
{ city: "PURDEET", state: "VIC", postcode: "3289" },
{ city: "TABOR", state: "VIC", postcode: "3289" },
{ city: "NELSON", state: "VIC", postcode: "3292" },
{ city: "GLENTHOMPSON", state: "VIC", postcode: "3293" },
{ city: "NAREEB", state: "VIC", postcode: "3293" },
{ city: "NARRAPUMELAP SOUTH", state: "VIC", postcode: "3293" },
{ city: "DUNKELD", state: "VIC", postcode: "3294" },
{ city: "KARABEAL", state: "VIC", postcode: "3294" },
{ city: "MIRRANATWA", state: "VIC", postcode: "3294" },
{ city: "MOUTAJUP", state: "VIC", postcode: "3294" },
{ city: "VICTORIA POINT", state: "VIC", postcode: "3294" },
{ city: "VICTORIA VALLEY", state: "VIC", postcode: "3294" },
{ city: "WOODHOUSE", state: "VIC", postcode: "3294" },
{ city: "BYADUK NORTH", state: "VIC", postcode: "3300" },
{ city: "BOCHARA", state: "VIC", postcode: "3301" },
{ city: "BROADWATER", state: "VIC", postcode: "3301" },
{ city: "BUCKLEY SWAMP", state: "VIC", postcode: "3301" },
{ city: "BYADUK", state: "VIC", postcode: "3301" },
{ city: "CROXTON EAST", state: "VIC", postcode: "3301" },
{ city: "HENSLEY PARK", state: "VIC", postcode: "3301" },
{ city: "MORGIANA", state: "VIC", postcode: "3301" },
{ city: "MOUNT NAPIER", state: "VIC", postcode: "3301" },
{ city: "STRATHKELLAR", state: "VIC", postcode: "3301" },
{ city: "TAHARA", state: "VIC", postcode: "3301" },
{ city: "TARRINGTON", state: "VIC", postcode: "3301" },
{ city: "WANNON", state: "VIC", postcode: "3301" },
{ city: "WARRAYURE", state: "VIC", postcode: "3301" },
{ city: "YATCHAW", state: "VIC", postcode: "3301" },
{ city: "YULECART", state: "VIC", postcode: "3301" },
{ city: "BRANXHOLME", state: "VIC", postcode: "3302" },
{ city: "GRASSDALE", state: "VIC", postcode: "3302" },
{ city: "BREAKAWAY CREEK", state: "VIC", postcode: "3303" },
{ city: "CONDAH", state: "VIC", postcode: "3303" },
{ city: "HOTSPUR", state: "VIC", postcode: "3303" },
{ city: "LAKE CONDAH", state: "VIC", postcode: "3303" },
{ city: "WALLACEDALE", state: "VIC", postcode: "3303" },
{ city: "BESSIEBELLE", state: "VIC", postcode: "3304" },
{ city: "DARTMOOR", state: "VIC", postcode: "3304" },
{ city: "DRIK DRIK", state: "VIC", postcode: "3304" },
{ city: "DRUMBORG", state: "VIC", postcode: "3304" },
{ city: "GREENWALD", state: "VIC", postcode: "3304" },
{ city: "HEYWOOD", state: "VIC", postcode: "3304" },
{ city: "HOMERTON", state: "VIC", postcode: "3304" },
{ city: "LYONS", state: "VIC", postcode: "3304" },
{ city: "MILLTOWN", state: "VIC", postcode: "3304" },
{ city: "MUMBANNAR", state: "VIC", postcode: "3304" },
{ city: "MYAMYN", state: "VIC", postcode: "3304" },
{ city: "WINNAP", state: "VIC", postcode: "3304" },
{ city: "ALLESTREE", state: "VIC", postcode: "3305" },
{ city: "BOLWARRA", state: "VIC", postcode: "3305" },
{ city: "CAPE BRIDGEWATER", state: "VIC", postcode: "3305" },
{ city: "CASHMORE", state: "VIC", postcode: "3305" },
{ city: "DUTTON WAY", state: "VIC", postcode: "3305" },
{ city: "GORAE", state: "VIC", postcode: "3305" },
{ city: "GORAE WEST", state: "VIC", postcode: "3305" },
{ city: "HEATHMERE", state: "VIC", postcode: "3305" },
{ city: "MOUNT RICHMOND", state: "VIC", postcode: "3305" },
{ city: "DIGBY", state: "VIC", postcode: "3309" },
{ city: "MERINO", state: "VIC", postcode: "3310" },
{ city: "TAHARA WEST", state: "VIC", postcode: "3310" },
{ city: "CASTERTON", state: "VIC", postcode: "3311" },
{ city: "CORNDALE", state: "VIC", postcode: "3311" },
{ city: "BAHGALLAH", state: "VIC", postcode: "3312" },
{ city: "BRIMBOAL", state: "VIC", postcode: "3312" },
{ city: "CARAPOOK", state: "VIC", postcode: "3312" },
{ city: "CHETWYND", state: "VIC", postcode: "3312" },
{ city: "DERGHOLM", state: "VIC", postcode: "3312" },
{ city: "DORODONG", state: "VIC", postcode: "3312" },
{ city: "DUNROBIN", state: "VIC", postcode: "3312" },
{ city: "HENTY", state: "VIC", postcode: "3312" },
{ city: "KILLARA", state: "VIC", postcode: "3312" },
{ city: "LAKE MUNDI", state: "VIC", postcode: "3312" },
{ city: "LINDSAY", state: "VIC", postcode: "3312" },
{ city: "NANGEELA", state: "VIC", postcode: "3312" },
{ city: "POOLAIJELO", state: "VIC", postcode: "3312" },
{ city: "POWERS CREEK", state: "VIC", postcode: "3312" },
{ city: "SANDFORD", state: "VIC", postcode: "3312" },
{ city: "STRATHDOWNIE", state: "VIC", postcode: "3312" },
{ city: "WANDO BRIDGE", state: "VIC", postcode: "3312" },
{ city: "WANDO VALE", state: "VIC", postcode: "3312" },
{ city: "WARROCK", state: "VIC", postcode: "3312" },
{ city: "BULART", state: "VIC", postcode: "3314" },
{ city: "CAVENDISH", state: "VIC", postcode: "3314" },
{ city: "GLENISLA", state: "VIC", postcode: "3314" },
{ city: "GRAMPIANS", state: "VIC", postcode: "3314" },
{ city: "MOORALLA", state: "VIC", postcode: "3314" },
{ city: "BRIT BRIT", state: "VIC", postcode: "3315" },
{ city: "CLOVER FLAT", state: "VIC", postcode: "3315" },
{ city: "COLERAINE", state: "VIC", postcode: "3315" },
{ city: "COOJAR", state: "VIC", postcode: "3315" },
{ city: "CULLA", state: "VIC", postcode: "3315" },
{ city: "GRINGEGALGONA", state: "VIC", postcode: "3315" },
{ city: "GRITJURK", state: "VIC", postcode: "3315" },
{ city: "HILGAY", state: "VIC", postcode: "3315" },
{ city: "KONONGWOOTONG", state: "VIC", postcode: "3315" },
{ city: "MELVILLE FOREST", state: "VIC", postcode: "3315" },
{ city: "MUNTHAM", state: "VIC", postcode: "3315" },
{ city: "NAREEN", state: "VIC", postcode: "3315" },
{ city: "PASCHENDALE", state: "VIC", postcode: "3315" },
{ city: "TAHARA BRIDGE", state: "VIC", postcode: "3315" },
{ city: "TARRAYOUKYAN", state: "VIC", postcode: "3315" },
{ city: "TARRENLEA", state: "VIC", postcode: "3315" },
{ city: "WOOTONG VALE", state: "VIC", postcode: "3315" },
{ city: "HARROW", state: "VIC", postcode: "3317" },
{ city: "CHARAM", state: "VIC", postcode: "3318" },
{ city: "CONNEWIRRICOO", state: "VIC", postcode: "3318" },
{ city: "EDENHOPE", state: "VIC", postcode: "3318" },
{ city: "KADNOOK", state: "VIC", postcode: "3318" },
{ city: "LANGKOOP", state: "VIC", postcode: "3318" },
{ city: "PATYAH", state: "VIC", postcode: "3318" },
{ city: "ULLSWATER", state: "VIC", postcode: "3318" },
{ city: "APSLEY", state: "VIC", postcode: "3319" },
{ city: "BENAYEO", state: "VIC", postcode: "3319" },
{ city: "BRINGALBERT", state: "VIC", postcode: "3319" },
{ city: "HESSE", state: "VIC", postcode: "3321" },
{ city: "INVERLEIGH", state: "VIC", postcode: "3321" },
{ city: "WINGEEL", state: "VIC", postcode: "3321" },
{ city: "CRESSY", state: "VIC", postcode: "3322" },
{ city: "BERRYBANK", state: "VIC", postcode: "3323" },
{ city: "DUVERNEY", state: "VIC", postcode: "3323" },
{ city: "FOXHOW", state: "VIC", postcode: "3323" },
{ city: "LISMORE", state: "VIC", postcode: "3324" },
{ city: "MINGAY", state: "VIC", postcode: "3324" },
{ city: "MOUNT BUTE", state: "VIC", postcode: "3324" },
{ city: "DERRINALLUM", state: "VIC", postcode: "3325" },
{ city: "LARRALEA", state: "VIC", postcode: "3325" },
{ city: "VITE VITE", state: "VIC", postcode: "3325" },
{ city: "VITE VITE NORTH", state: "VIC", postcode: "3325" },
{ city: "TEESDALE", state: "VIC", postcode: "3328" },
{ city: "BARUNAH PARK", state: "VIC", postcode: "3329" },
{ city: "BARUNAH PLAINS", state: "VIC", postcode: "3329" },
{ city: "SHELFORD", state: "VIC", postcode: "3329" },
{ city: "ROKEWOOD", state: "VIC", postcode: "3330" },
{ city: "BANNOCKBURN", state: "VIC", postcode: "3331" },
{ city: "GHERINGHAP", state: "VIC", postcode: "3331" },
{ city: "MAUDE", state: "VIC", postcode: "3331" },
{ city: "RUSSELLS BRIDGE", state: "VIC", postcode: "3331" },
{ city: "SHE OAKS", state: "VIC", postcode: "3331" },
{ city: "STEIGLITZ", state: "VIC", postcode: "3331" },
{ city: "SUTHERLANDS CREEK", state: "VIC", postcode: "3331" },
{ city: "LETHBRIDGE", state: "VIC", postcode: "3332" },
{ city: "BAMGANIE", state: "VIC", postcode: "3333" },
{ city: "MEREDITH", state: "VIC", postcode: "3333" },
{ city: "BUNGAL", state: "VIC", postcode: "3334" },
{ city: "CARGERIE", state: "VIC", postcode: "3334" },
{ city: "ELAINE", state: "VIC", postcode: "3334" },
{ city: "MORRISONS", state: "VIC", postcode: "3334" },
{ city: "MOUNT DORAN", state: "VIC", postcode: "3334" },
{ city: "BONNIE BROOK", state: "VIC", postcode: "3335" },
{ city: "PLUMPTON", state: "VIC", postcode: "3335" },
{ city: "ROCKBANK", state: "VIC", postcode: "3335" },
{ city: "THORNHILL PARK", state: "VIC", postcode: "3335" },
{ city: "KURUNJANG", state: "VIC", postcode: "3337" },
{ city: "TOOLERN VALE", state: "VIC", postcode: "3337" },
{ city: "BROOKFIELD", state: "VIC", postcode: "3338" },
{ city: "COBBLEBANK", state: "VIC", postcode: "3338" },
{ city: "EXFORD", state: "VIC", postcode: "3338" },
{ city: "EYNESBURY", state: "VIC", postcode: "3338" },
{ city: "STRATHTULLOH", state: "VIC", postcode: "3338" },
{ city: "WEIR VIEWS", state: "VIC", postcode: "3338" },
{ city: "BALLIANG", state: "VIC", postcode: "3340" },
{ city: "BALLIANG EAST", state: "VIC", postcode: "3340" },
{ city: "COIMADAI", state: "VIC", postcode: "3340" },
{ city: "DARLEY", state: "VIC", postcode: "3340" },
{ city: "GLENMORE", state: "VIC", postcode: "3340" },
{ city: "HOPETOUN PARK", state: "VIC", postcode: "3340" },
{ city: "LONG FOREST", state: "VIC", postcode: "3340" },
{ city: "MADDINGLEY", state: "VIC", postcode: "3340" },
{ city: "MERRIMU", state: "VIC", postcode: "3340" },
{ city: "PARWAN", state: "VIC", postcode: "3340" },
{ city: "ROWSLEY", state: "VIC", postcode: "3340" },
{ city: "STAUGHTON VALE", state: "VIC", postcode: "3340" },
{ city: "DALES CREEK", state: "VIC", postcode: "3341" },
{ city: "GREENDALE", state: "VIC", postcode: "3341" },
{ city: "KOROBEIT", state: "VIC", postcode: "3341" },
{ city: "MYRNIONG", state: "VIC", postcode: "3341" },
{ city: "PENTLAND HILLS", state: "VIC", postcode: "3341" },
{ city: "BALLAN", state: "VIC", postcode: "3342" },
{ city: "BEREMBOKE", state: "VIC", postcode: "3342" },
{ city: "BLAKEVILLE", state: "VIC", postcode: "3342" },
{ city: "BUNDING", state: "VIC", postcode: "3342" },
{ city: "COLBROOK", state: "VIC", postcode: "3342" },
{ city: "DURDIDWARRAH", state: "VIC", postcode: "3342" },
{ city: "FISKVILLE", state: "VIC", postcode: "3342" },
{ city: "INGLISTON", state: "VIC", postcode: "3342" },
{ city: "MOUNT WALLACE", state: "VIC", postcode: "3342" },
{ city: "GORDON", state: "VIC", postcode: "3345" },
{ city: "ALFREDTON", state: "VIC", postcode: "3350" },
{ city: "BLACK HILL", state: "VIC", postcode: "3350" },
{ city: "BROWN HILL", state: "VIC", postcode: "3350" },
{ city: "CANADIAN", state: "VIC", postcode: "3350" },
{ city: "EUREKA", state: "VIC", postcode: "3350" },
{ city: "INVERMAY PARK", state: "VIC", postcode: "3350" },
{ city: "LAKE WENDOUREE", state: "VIC", postcode: "3350" },
{ city: "LUCAS", state: "VIC", postcode: "3350" },
{ city: "MOUNT CLEAR", state: "VIC", postcode: "3350" },
{ city: "MOUNT HELEN", state: "VIC", postcode: "3350" },
{ city: "MOUNT PLEASANT", state: "VIC", postcode: "3350" },
{ city: "NERRINA", state: "VIC", postcode: "3350" },
{ city: "NEWINGTON", state: "VIC", postcode: "3350" },
{ city: "REDAN", state: "VIC", postcode: "3350" },
{ city: "SOLDIERS HILL", state: "VIC", postcode: "3350" },
{ city: "SOVEREIGN HILL", state: "VIC", postcode: "3350" },
{ city: "BERRINGA", state: "VIC", postcode: "3351" },
{ city: "BO PEEP", state: "VIC", postcode: "3351" },
{ city: "CAPE CLEAR", state: "VIC", postcode: "3351" },
{ city: "CARNGHAM", state: "VIC", postcode: "3351" },
{ city: "CHEPSTOWE", state: "VIC", postcode: "3351" },
{ city: "HADDON", state: "VIC", postcode: "3351" },
{ city: "HILLCREST", state: "VIC", postcode: "3351" },
{ city: "ILLABAROOK", state: "VIC", postcode: "3351" },
{ city: "LAKE BOLAC", state: "VIC", postcode: "3351" },
{ city: "MININERA", state: "VIC", postcode: "3351" },
{ city: "MOUNT EMU", state: "VIC", postcode: "3351" },
{ city: "NERRIN NERRIN", state: "VIC", postcode: "3351" },
{ city: "NEWTOWN", state: "VIC", postcode: "3351" },
{ city: "NINTINGBOOL", state: "VIC", postcode: "3351" },
{ city: "PIGGOREET", state: "VIC", postcode: "3351" },
{ city: "PITFIELD", state: "VIC", postcode: "3351" },
{ city: "ROKEWOOD JUNCTION", state: "VIC", postcode: "3351" },
{ city: "ROSS CREEK", state: "VIC", postcode: "3351" },
{ city: "SCARSDALE", state: "VIC", postcode: "3351" },
{ city: "SMYTHES CREEK", state: "VIC", postcode: "3351" },
{ city: "SMYTHESDALE", state: "VIC", postcode: "3351" },
{ city: "SNAKE VALLEY", state: "VIC", postcode: "3351" },
{ city: "SPRINGDALLAH", state: "VIC", postcode: "3351" },
{ city: "STAFFORDSHIRE REEF", state: "VIC", postcode: "3351" },
{ city: "STREATHAM", state: "VIC", postcode: "3351" },
{ city: "WALLINDUC", state: "VIC", postcode: "3351" },
{ city: "WESTMERE", state: "VIC", postcode: "3351" },
{ city: "ADDINGTON", state: "VIC", postcode: "3352" },
{ city: "BLOWHARD", state: "VIC", postcode: "3352" },
{ city: "BOLWARRAH", state: "VIC", postcode: "3352" },
{ city: "BONSHAW", state: "VIC", postcode: "3352" },
{ city: "BREWSTER", state: "VIC", postcode: "3352" },
{ city: "BULLAROOK", state: "VIC", postcode: "3352" },
{ city: "BUNGAREE", state: "VIC", postcode: "3352" },
{ city: "BUNKERS HILL", state: "VIC", postcode: "3352" },
{ city: "BURRUMBEET", state: "VIC", postcode: "3352" },
{ city: "CAMBRIAN HILL", state: "VIC", postcode: "3352" },
{ city: "CARDIGAN", state: "VIC", postcode: "3352" },
{ city: "CARDIGAN VILLAGE", state: "VIC", postcode: "3352" },
{ city: "CHAPEL FLAT", state: "VIC", postcode: "3352" },
{ city: "CLARENDON", state: "VIC", postcode: "3352" },
{ city: "CLARETOWN", state: "VIC", postcode: "3352" },
{ city: "CLARKES HILL", state: "VIC", postcode: "3352" },
{ city: "CORINDHAP", state: "VIC", postcode: "3352" },
{ city: "DEREEL", state: "VIC", postcode: "3352" },
{ city: "DUNNSTOWN", state: "VIC", postcode: "3352" },
{ city: "DURHAM LEAD", state: "VIC", postcode: "3352" },
{ city: "ENFIELD", state: "VIC", postcode: "3352" },
{ city: "ERCILDOUNE", state: "VIC", postcode: "3352" },
{ city: "GARIBALDI", state: "VIC", postcode: "3352" },
{ city: "GLENBRAE", state: "VIC", postcode: "3352" },
{ city: "GLEN PARK", state: "VIC", postcode: "3352" },
{ city: "GONG GONG", state: "VIC", postcode: "3352" },
{ city: "GRENVILLE", state: "VIC", postcode: "3352" },
{ city: "INVERMAY", state: "VIC", postcode: "3352" },
{ city: "LAL LAL", state: "VIC", postcode: "3352" },
{ city: "LAMPLOUGH", state: "VIC", postcode: "3352" },
{ city: "LANGI KAL KAL", state: "VIC", postcode: "3352" },
{ city: "LEARMONTH", state: "VIC", postcode: "3352" },
{ city: "LEIGH CREEK", state: "VIC", postcode: "3352" },
{ city: "LEXTON", state: "VIC", postcode: "3352" },
{ city: "MAGPIE", state: "VIC", postcode: "3352" },
{ city: "MILLBROOK", state: "VIC", postcode: "3352" },
{ city: "MINERS REST", state: "VIC", postcode: "3352" },
{ city: "MITCHELL PARK", state: "VIC", postcode: "3352" },
{ city: "MOLLONGGHIP", state: "VIC", postcode: "3352" },
{ city: "MOUNT BOLTON", state: "VIC", postcode: "3352" },
{ city: "MOUNT EGERTON", state: "VIC", postcode: "3352" },
{ city: "MOUNT MERCER", state: "VIC", postcode: "3352" },
{ city: "MOUNT MITCHELL", state: "VIC", postcode: "3352" },
{ city: "MOUNT ROWAN", state: "VIC", postcode: "3352" },
{ city: "NAPOLEONS", state: "VIC", postcode: "3352" },
{ city: "NAVIGATORS", state: "VIC", postcode: "3352" },
{ city: "POOTILLA", state: "VIC", postcode: "3352" },
{ city: "SCOTCHMANS LEAD", state: "VIC", postcode: "3352" },
{ city: "SCOTSBURN", state: "VIC", postcode: "3352" },
{ city: "SPRINGBANK", state: "VIC", postcode: "3352" },
{ city: "SULKY", state: "VIC", postcode: "3352" },
{ city: "WALLACE", state: "VIC", postcode: "3352" },
{ city: "WARRENHEIP", state: "VIC", postcode: "3352" },
{ city: "WATTLE FLAT", state: "VIC", postcode: "3352" },
{ city: "WAUBRA", state: "VIC", postcode: "3352" },
{ city: "WEATHERBOARD", state: "VIC", postcode: "3352" },
{ city: "WERNETH", state: "VIC", postcode: "3352" },
{ city: "WINDERMERE", state: "VIC", postcode: "3352" },
{ city: "YENDON", state: "VIC", postcode: "3352" },
{ city: "LAKE GARDENS", state: "VIC", postcode: "3355" },
{ city: "MITCHELL PARK", state: "VIC", postcode: "3355" },
{ city: "WENDOUREE VILLAGE", state: "VIC", postcode: "3355" },
{ city: "DELACOMBE", state: "VIC", postcode: "3356" },
{ city: "SEBASTOPOL", state: "VIC", postcode: "3356" },
{ city: "BUNINYONG", state: "VIC", postcode: "3357" },
{ city: "SCOTSMANS LEAD", state: "VIC", postcode: "3357" },
{ city: "WINTER VALLEY", state: "VIC", postcode: "3358" },
{ city: "HAPPY VALLEY", state: "VIC", postcode: "3360" },
{ city: "LINTON", state: "VIC", postcode: "3360" },
{ city: "MANNIBADAR", state: "VIC", postcode: "3360" },
{ city: "PITTONG", state: "VIC", postcode: "3360" },
{ city: "WILLOWVALE", state: "VIC", postcode: "3360" },
{ city: "BRADVALE", state: "VIC", postcode: "3361" },
{ city: "CARRANBALLAC", state: "VIC", postcode: "3361" },
{ city: "SKIPTON", state: "VIC", postcode: "3361" },
{ city: "CRESWICK", state: "VIC", postcode: "3363" },
{ city: "CRESWICK NORTH", state: "VIC", postcode: "3363" },
{ city: "DEAN", state: "VIC", postcode: "3363" },
{ city: "GLENDARUEL", state: "VIC", postcode: "3363" },
{ city: "LANGDONS HILL", state: "VIC", postcode: "3363" },
{ city: "MOUNT BECKWORTH", state: "VIC", postcode: "3363" },
{ city: "TOURELLO", state: "VIC", postcode: "3363" },
{ city: "ALLENDALE", state: "VIC", postcode: "3364" },
{ city: "ASCOT", state: "VIC", postcode: "3364" },
{ city: "BALD HILLS", state: "VIC", postcode: "3364" },
{ city: "BARKSTEAD", state: "VIC", postcode: "3364" },
{ city: "BLAMPIED", state: "VIC", postcode: "3364" },
{ city: "BROOMFIELD", state: "VIC", postcode: "3364" },
{ city: "CABBAGE TREE", state: "VIC", postcode: "3364" },
{ city: "CAMPBELLTOWN", state: "VIC", postcode: "3364" },
{ city: "COGHILLS CREEK", state: "VIC", postcode: "3364" },
{ city: "GLENDONALD", state: "VIC", postcode: "3364" },
{ city: "JOYCES CREEK", state: "VIC", postcode: "3364" },
{ city: "KINGSTON", state: "VIC", postcode: "3364" },
{ city: "KOOROOCHEANG", state: "VIC", postcode: "3364" },
{ city: "LAWRENCE", state: "VIC", postcode: "3364" },
{ city: "MOUNT PROSPECT", state: "VIC", postcode: "3364" },
{ city: "NEWLYN", state: "VIC", postcode: "3364" },
{ city: "NEWLYN NORTH", state: "VIC", postcode: "3364" },
{ city: "ROCKLYN", state: "VIC", postcode: "3364" },
{ city: "SMEATON", state: "VIC", postcode: "3364" },
{ city: "SMOKEYTOWN", state: "VIC", postcode: "3364" },
{ city: "SPRINGMOUNT", state: "VIC", postcode: "3364" },
{ city: "STRATHLEA", state: "VIC", postcode: "3364" },
{ city: "WERONA", state: "VIC", postcode: "3364" },
{ city: "CLUNES", state: "VIC", postcode: "3370" },
{ city: "GLENGOWER", state: "VIC", postcode: "3370" },
{ city: "MOUNT CAMERON", state: "VIC", postcode: "3370" },
{ city: "ULLINA", state: "VIC", postcode: "3370" },
{ city: "AMHERST", state: "VIC", postcode: "3371" },
{ city: "BURNBANK", state: "VIC", postcode: "3371" },
{ city: "CARALULUP", state: "VIC", postcode: "3371" },
{ city: "DUNACH", state: "VIC", postcode: "3371" },
{ city: "EVANSFORD", state: "VIC", postcode: "3371" },
{ city: "LILLICUR", state: "VIC", postcode: "3371" },
{ city: "MOUNT GLASGOW", state: "VIC", postcode: "3371" },
{ city: "RED LION", state: "VIC", postcode: "3371" },
{ city: "STONY CREEK", state: "VIC", postcode: "3371" },
{ city: "TALBOT", state: "VIC", postcode: "3371" },
{ city: "BEAUFORT", state: "VIC", postcode: "3373" },
{ city: "CHUTE", state: "VIC", postcode: "3373" },
{ city: "CROSS ROADS", state: "VIC", postcode: "3373" },
{ city: "LAKE GOLDSMITH", state: "VIC", postcode: "3373" },
{ city: "LAKE WONGAN", state: "VIC", postcode: "3373" },
{ city: "MAIN LEAD", state: "VIC", postcode: "3373" },
{ city: "MENA PARK", state: "VIC", postcode: "3373" },
{ city: "NERRING", state: "VIC", postcode: "3373" },
{ city: "RAGLAN", state: "VIC", postcode: "3373" },
{ city: "SHIRLEY", state: "VIC", postcode: "3373" },
{ city: "STOCKYARD HILL", state: "VIC", postcode: "3373" },
{ city: "STONELEIGH", state: "VIC", postcode: "3373" },
{ city: "TRAWALLA", state: "VIC", postcode: "3373" },
{ city: "WATERLOO", state: "VIC", postcode: "3373" },
{ city: "GREAT WESTERN", state: "VIC", postcode: "3374" },
{ city: "BALLYROGAN", state: "VIC", postcode: "3375" },
{ city: "BAYINDEEN", state: "VIC", postcode: "3375" },
{ city: "BUANGOR", state: "VIC", postcode: "3375" },
{ city: "MIDDLE CREEK", state: "VIC", postcode: "3375" },
{ city: "ARMSTRONG", state: "VIC", postcode: "3377" },
{ city: "BULGANA", state: "VIC", postcode: "3377" },
{ city: "CATHCART", state: "VIC", postcode: "3377" },
{ city: "CROWLANDS", state: "VIC", postcode: "3377" },
{ city: "DENICULL CREEK", state: "VIC", postcode: "3377" },
{ city: "DOBIE", state: "VIC", postcode: "3377" },
{ city: "DUNNEWORTHY", state: "VIC", postcode: "3377" },
{ city: "EVERSLEY", state: "VIC", postcode: "3377" },
{ city: "LANGI LOGAN", state: "VIC", postcode: "3377" },
{ city: "MAROONA", state: "VIC", postcode: "3377" },
{ city: "MOUNT COLE", state: "VIC", postcode: "3377" },
{ city: "MOUNT COLE CREEK", state: "VIC", postcode: "3377" },
{ city: "MOYSTON", state: "VIC", postcode: "3377" },
{ city: "NORVAL", state: "VIC", postcode: "3377" },
{ city: "RHYMNEY", state: "VIC", postcode: "3377" },
{ city: "ROCKY POINT", state: "VIC", postcode: "3377" },
{ city: "ROSSBRIDGE", state: "VIC", postcode: "3377" },
{ city: "SHAYS FLAT", state: "VIC", postcode: "3377" },
{ city: "WARRAK", state: "VIC", postcode: "3377" },
{ city: "TATYOON", state: "VIC", postcode: "3378" },
{ city: "YALLA-Y-POORA", state: "VIC", postcode: "3378" },
{ city: "BORNES HILL", state: "VIC", postcode: "3379" },
{ city: "CHATSWORTH", state: "VIC", postcode: "3379" },
{ city: "MAFEKING", state: "VIC", postcode: "3379" },
{ city: "STAVELY", state: "VIC", postcode: "3379" },
{ city: "WICKLIFFE", state: "VIC", postcode: "3379" },
{ city: "WILLAURA", state: "VIC", postcode: "3379" },
{ city: "WILLAURA NORTH", state: "VIC", postcode: "3379" },
{ city: "STAWELL", state: "VIC", postcode: "3380" },
{ city: "STAWELL WEST", state: "VIC", postcode: "3380" },
{ city: "BELLELLEN", state: "VIC", postcode: "3381" },
{ city: "BELLFIELD", state: "VIC", postcode: "3381" },
{ city: "BLACK RANGE", state: "VIC", postcode: "3381" },
{ city: "FYANS CREEK", state: "VIC", postcode: "3381" },
{ city: "HALLS GAP", state: "VIC", postcode: "3381" },
{ city: "ILLAWARRA", state: "VIC", postcode: "3381" },
{ city: "LAKE FYANS", state: "VIC", postcode: "3381" },
{ city: "LAKE LONSDALE", state: "VIC", postcode: "3381" },
{ city: "MOKEPILLY", state: "VIC", postcode: "3381" },
{ city: "MOUNT DRYDEN", state: "VIC", postcode: "3381" },
{ city: "POMONAL", state: "VIC", postcode: "3381" },
{ city: "BARKLY", state: "VIC", postcode: "3384" },
{ city: "CONCONGELLA", state: "VIC", postcode: "3384" },
{ city: "FRENCHMANS", state: "VIC", postcode: "3384" },
{ city: "JOEL JOEL", state: "VIC", postcode: "3384" },
{ city: "JOEL SOUTH", state: "VIC", postcode: "3384" },
{ city: "LANDSBOROUGH", state: "VIC", postcode: "3384" },
{ city: "LANDSBOROUGH WEST", state: "VIC", postcode: "3384" },
{ city: "NAVARRE", state: "VIC", postcode: "3384" },
{ city: "TULKARA", state: "VIC", postcode: "3384" },
{ city: "WATTLE CREEK", state: "VIC", postcode: "3384" },
{ city: "DADSWELLS BRIDGE", state: "VIC", postcode: "3385" },
{ city: "DEEP LEAD", state: "VIC", postcode: "3385" },
{ city: "GLENORCHY", state: "VIC", postcode: "3385" },
{ city: "LEDCOURT", state: "VIC", postcode: "3385" },
{ city: "LUBECK", state: "VIC", postcode: "3385" },
{ city: "RIACHELLA", state: "VIC", postcode: "3385" },
{ city: "ROSES GAP", state: "VIC", postcode: "3385" },
{ city: "WAL WAL", state: "VIC", postcode: "3385" },
{ city: "BOLANGUM", state: "VIC", postcode: "3387" },
{ city: "CALLAWADDA", state: "VIC", postcode: "3387" },
{ city: "CAMPBELLS BRIDGE", state: "VIC", postcode: "3387" },
{ city: "GERMANIA", state: "VIC", postcode: "3387" },
{ city: "GREENS CREEK", state: "VIC", postcode: "3387" },
{ city: "KANYA", state: "VIC", postcode: "3387" },
{ city: "MARNOO", state: "VIC", postcode: "3387" },
{ city: "MARNOO WEST", state: "VIC", postcode: "3387" },
{ city: "MORRL MORRL", state: "VIC", postcode: "3387" },
{ city: "WALLALOO", state: "VIC", postcode: "3387" },
{ city: "WALLALOO EAST", state: "VIC", postcode: "3387" },
{ city: "BANYENA", state: "VIC", postcode: "3388" },
{ city: "RUPANYUP", state: "VIC", postcode: "3388" },
{ city: "KEWELL", state: "VIC", postcode: "3390" },
{ city: "MURTOA", state: "VIC", postcode: "3390" },
{ city: "BRIM", state: "VIC", postcode: "3391" },
{ city: "BOOLITE", state: "VIC", postcode: "3392" },
{ city: "MINYIP", state: "VIC", postcode: "3392" },
{ city: "SHEEP HILLS", state: "VIC", postcode: "3392" },
{ city: "AUBREY", state: "VIC", postcode: "3393" },
{ city: "BANGERANG", state: "VIC", postcode: "3393" },
{ city: "CANNUM", state: "VIC", postcode: "3393" },
{ city: "CRYMELON", state: "VIC", postcode: "3393" },
{ city: "KELLALAC", state: "VIC", postcode: "3393" },
{ city: "LAH", state: "VIC", postcode: "3393" },
{ city: "WILKUR", state: "VIC", postcode: "3393" },
{ city: "WILLENABRINA", state: "VIC", postcode: "3393" },
{ city: "BEULAH", state: "VIC", postcode: "3395" },
{ city: "KENMARE", state: "VIC", postcode: "3395" },
{ city: "REEDY DAM", state: "VIC", postcode: "3395" },
{ city: "ROSEBERY", state: "VIC", postcode: "3395" },
{ city: "HOPETOUN", state: "VIC", postcode: "3396" },
{ city: "BLACKHEATH", state: "VIC", postcode: "3401" },
{ city: "BRIMPAEN", state: "VIC", postcode: "3401" },
{ city: "BUNGALALLY", state: "VIC", postcode: "3401" },
{ city: "CHERRYPOOL", state: "VIC", postcode: "3401" },
{ city: "DOOEN", state: "VIC", postcode: "3401" },
{ city: "DRUNG", state: "VIC", postcode: "3401" },
{ city: "GYMBOWEN", state: "VIC", postcode: "3401" },
{ city: "HAVEN", state: "VIC", postcode: "3401" },
{ city: "JUNG", state: "VIC", postcode: "3401" },
{ city: "KALKEE", state: "VIC", postcode: "3401" },
{ city: "KANAGULK", state: "VIC", postcode: "3401" },
{ city: "KARNAK", state: "VIC", postcode: "3401" },
{ city: "LAHARUM", state: "VIC", postcode: "3401" },
{ city: "LONGERENONG", state: "VIC", postcode: "3401" },
{ city: "LOWER NORTON", state: "VIC", postcode: "3401" },
{ city: "MCKENZIE CREEK", state: "VIC", postcode: "3401" },
{ city: "MOCKINYA", state: "VIC", postcode: "3401" },
{ city: "MURRA WARRA", state: "VIC", postcode: "3401" },
{ city: "NURCOUNG", state: "VIC", postcode: "3401" },
{ city: "NURRABIEL", state: "VIC", postcode: "3401" },
{ city: "PIMPINIO", state: "VIC", postcode: "3401" },
{ city: "QUANTONG", state: "VIC", postcode: "3401" },
{ city: "RIVERSIDE", state: "VIC", postcode: "3401" },
{ city: "ROCKLANDS", state: "VIC", postcode: "3401" },
{ city: "ST HELENS PLAINS", state: "VIC", postcode: "3401" },
{ city: "TELANGATUK EAST", state: "VIC", postcode: "3401" },
{ city: "TOOLONDO", state: "VIC", postcode: "3401" },
{ city: "VECTIS", state: "VIC", postcode: "3401" },
{ city: "WAIL", state: "VIC", postcode: "3401" },
{ city: "WALLUP", state: "VIC", postcode: "3401" },
{ city: "WARTOOK", state: "VIC", postcode: "3401" },
{ city: "WONWONDAH", state: "VIC", postcode: "3401" },
{ city: "ZUMSTEINS", state: "VIC", postcode: "3401" },
{ city: "BALMORAL", state: "VIC", postcode: "3407" },
{ city: "ENGLEFIELD", state: "VIC", postcode: "3407" },
{ city: "GATUM", state: "VIC", postcode: "3407" },
{ city: "PIGEON PONDS", state: "VIC", postcode: "3407" },
{ city: "VASEY", state: "VIC", postcode: "3407" },
{ city: "ARAPILES", state: "VIC", postcode: "3409" },
{ city: "CLEAR LAKE", state: "VIC", postcode: "3409" },
{ city: "DOUGLAS", state: "VIC", postcode: "3409" },
{ city: "DUCHEMBEGARRA", state: "VIC", postcode: "3409" },
{ city: "GRASS FLAT", state: "VIC", postcode: "3409" },
{ city: "JILPANGER", state: "VIC", postcode: "3409" },
{ city: "MIGA LAKE", state: "VIC", postcode: "3409" },
{ city: "MITRE", state: "VIC", postcode: "3409" },
{ city: "NATIMUK", state: "VIC", postcode: "3409" },
{ city: "NORADJUHA", state: "VIC", postcode: "3409" },
{ city: "TOOAN", state: "VIC", postcode: "3409" },
{ city: "WOMBELANO", state: "VIC", postcode: "3409" },
{ city: "GOROKE", state: "VIC", postcode: "3412" },
{ city: "MINIMAY", state: "VIC", postcode: "3413" },
{ city: "NEUARPURR", state: "VIC", postcode: "3413" },
{ city: "OZENKADNOOK", state: "VIC", postcode: "3413" },
{ city: "PERONNE", state: "VIC", postcode: "3413" },
{ city: "ANTWERP", state: "VIC", postcode: "3414" },
{ city: "DIMBOOLA", state: "VIC", postcode: "3414" },
{ city: "TARRANYURK", state: "VIC", postcode: "3414" },
{ city: "MIRAM", state: "VIC", postcode: "3415" },
{ city: "BROUGHTON", state: "VIC", postcode: "3418" },
{ city: "GERANG GERUNG", state: "VIC", postcode: "3418" },
{ city: "GLENLEE", state: "VIC", postcode: "3418" },
{ city: "KIATA", state: "VIC", postcode: "3418" },
{ city: "LAWLOIT", state: "VIC", postcode: "3418" },
{ city: "LITTLE DESERT", state: "VIC", postcode: "3418" },
{ city: "LORQUON", state: "VIC", postcode: "3418" },
{ city: "NETHERBY", state: "VIC", postcode: "3418" },
{ city: "NHILL", state: "VIC", postcode: "3418" },
{ city: "YANAC", state: "VIC", postcode: "3418" },
{ city: "KANIVA", state: "VIC", postcode: "3419" },
{ city: "LILLIMUR", state: "VIC", postcode: "3420" },
{ city: "SERVICETON", state: "VIC", postcode: "3420" },
{ city: "TELOPEA DOWNS", state: "VIC", postcode: "3420" },
{ city: "JEPARIT", state: "VIC", postcode: "3423" },
{ city: "ALBACUTYA", state: "VIC", postcode: "3424" },
{ city: "RAINBOW", state: "VIC", postcode: "3424" },
{ city: "YAAPEET", state: "VIC", postcode: "3424" },
{ city: "DIGGERS REST", state: "VIC", postcode: "3427" },
{ city: "BULLA", state: "VIC", postcode: "3428" },
{ city: "SUNBURY", state: "VIC", postcode: "3429" },
{ city: "WILDWOOD", state: "VIC", postcode: "3429" },
{ city: "CLARKEFIELD", state: "VIC", postcode: "3430" },
{ city: "RIDDELLS CREEK", state: "VIC", postcode: "3431" },
{ city: "BOLINDA", state: "VIC", postcode: "3432" },
{ city: "MONEGEETTA", state: "VIC", postcode: "3433" },
{ city: "CHEROKEE", state: "VIC", postcode: "3434" },
{ city: "KERRIE", state: "VIC", postcode: "3434" },
{ city: "ROMSEY", state: "VIC", postcode: "3434" },
{ city: "SPRINGFIELD", state: "VIC", postcode: "3434" },
{ city: "BENLOCH", state: "VIC", postcode: "3435" },
{ city: "GOLDIE", state: "VIC", postcode: "3435" },
{ city: "LANCEFIELD", state: "VIC", postcode: "3435" },
{ city: "NULLA VALE", state: "VIC", postcode: "3435" },
{ city: "BULLENGAROOK", state: "VIC", postcode: "3437" },
{ city: "GISBORNE", state: "VIC", postcode: "3437" },
{ city: "GISBORNE SOUTH", state: "VIC", postcode: "3437" },
{ city: "NEW GISBORNE", state: "VIC", postcode: "3438" },
{ city: "MACEDON", state: "VIC", postcode: "3440" },
{ city: "MOUNT MACEDON", state: "VIC", postcode: "3441" },
{ city: "ASHBOURNE", state: "VIC", postcode: "3442" },
{ city: "CADELLO", state: "VIC", postcode: "3442" },
{ city: "CARLSRUHE", state: "VIC", postcode: "3442" },
{ city: "COBAW", state: "VIC", postcode: "3442" },
{ city: "HESKET", state: "VIC", postcode: "3442" },
{ city: "NEWHAM", state: "VIC", postcode: "3442" },
{ city: "ROCHFORD", state: "VIC", postcode: "3442" },
{ city: "WOODEND", state: "VIC", postcode: "3442" },
{ city: "WOODEND NORTH", state: "VIC", postcode: "3442" },
{ city: "BARFOLD", state: "VIC", postcode: "3444" },
{ city: "BAYNTON", state: "VIC", postcode: "3444" },
{ city: "BAYNTON EAST", state: "VIC", postcode: "3444" },
{ city: "EDGECOMBE", state: "VIC", postcode: "3444" },
{ city: "GLENHOPE", state: "VIC", postcode: "3444" },
{ city: "GREENHILL", state: "VIC", postcode: "3444" },
{ city: "LANGLEY", state: "VIC", postcode: "3444" },
{ city: "LAURISTON", state: "VIC", postcode: "3444" },
{ city: "LYAL", state: "VIC", postcode: "3444" },
{ city: "METCALFE EAST", state: "VIC", postcode: "3444" },
{ city: "MIA MIA", state: "VIC", postcode: "3444" },
{ city: "MYRTLE CREEK", state: "VIC", postcode: "3444" },
{ city: "PASTORIA", state: "VIC", postcode: "3444" },
{ city: "PASTORIA EAST", state: "VIC", postcode: "3444" },
{ city: "PIPERS CREEK", state: "VIC", postcode: "3444" },
{ city: "REDESDALE", state: "VIC", postcode: "3444" },
{ city: "SIDONIA", state: "VIC", postcode: "3444" },
{ city: "SPRING HILL", state: "VIC", postcode: "3444" },
{ city: "TYLDEN", state: "VIC", postcode: "3444" },
{ city: "TYLDEN SOUTH", state: "VIC", postcode: "3444" },
{ city: "DRUMMOND NORTH", state: "VIC", postcode: "3446" },
{ city: "MALMSBURY", state: "VIC", postcode: "3446" },
{ city: "TARADALE", state: "VIC", postcode: "3447" },
{ city: "ELPHINSTONE", state: "VIC", postcode: "3448" },
{ city: "METCALFE", state: "VIC", postcode: "3448" },
{ city: "SUTTON GRANGE", state: "VIC", postcode: "3448" },
{ city: "CASTLEMAINE", state: "VIC", postcode: "3450" },
{ city: "MOONLIGHT FLAT", state: "VIC", postcode: "3450" },
{ city: "BARKERS CREEK", state: "VIC", postcode: "3451" },
{ city: "CAMPBELLS CREEK", state: "VIC", postcode: "3451" },
{ city: "CHEWTON", state: "VIC", postcode: "3451" },
{ city: "CHEWTON BUSHLANDS", state: "VIC", postcode: "3451" },
{ city: "FARADAY", state: "VIC", postcode: "3451" },
{ city: "FRYERSTOWN", state: "VIC", postcode: "3451" },
{ city: "GLENLUCE", state: "VIC", postcode: "3451" },
{ city: "GOLDEN POINT", state: "VIC", postcode: "3451" },
{ city: "GOWER", state: "VIC", postcode: "3451" },
{ city: "GUILDFORD", state: "VIC", postcode: "3451" },
{ city: "IRISHTOWN", state: "VIC", postcode: "3451" },
{ city: "MCKENZIE HILL", state: "VIC", postcode: "3451" },
{ city: "MUCKLEFORD", state: "VIC", postcode: "3451" },
{ city: "TARILTA", state: "VIC", postcode: "3451" },
{ city: "VAUGHAN", state: "VIC", postcode: "3451" },
{ city: "YAPEEN", state: "VIC", postcode: "3451" },
{ city: "HARCOURT", state: "VIC", postcode: "3453" },
{ city: "HARCOURT NORTH", state: "VIC", postcode: "3453" },
{ city: "RAVENSWOOD", state: "VIC", postcode: "3453" },
{ city: "RAVENSWOOD SOUTH", state: "VIC", postcode: "3453" },
{ city: "BARRYS REEF", state: "VIC", postcode: "3458" },
{ city: "BLACKWOOD", state: "VIC", postcode: "3458" },
{ city: "FERN HILL", state: "VIC", postcode: "3458" },
{ city: "LERDERDERG", state: "VIC", postcode: "3458" },
{ city: "LITTLE HAMPTON", state: "VIC", postcode: "3458" },
{ city: "NEWBURY", state: "VIC", postcode: "3458" },
{ city: "NORTH BLACKWOOD", state: "VIC", postcode: "3458" },
{ city: "TRENTHAM", state: "VIC", postcode: "3458" },
{ city: "TRENTHAM EAST", state: "VIC", postcode: "3458" },
{ city: "BASALT", state: "VIC", postcode: "3460" },
{ city: "DAYLESFORD", state: "VIC", postcode: "3460" },
{ city: "BULLARTO", state: "VIC", postcode: "3461" },
{ city: "BULLARTO SOUTH", state: "VIC", postcode: "3461" },
{ city: "CLYDESDALE", state: "VIC", postcode: "3461" },
{ city: "COOMOORA", state: "VIC", postcode: "3461" },
{ city: "DENVER", state: "VIC", postcode: "3461" },
{ city: "DRUMMOND", state: "VIC", postcode: "3461" },
{ city: "DRY DIGGINGS", state: "VIC", postcode: "3461" },
{ city: "EGANSTOWN", state: "VIC", postcode: "3461" },
{ city: "ELEVATED PLAINS", state: "VIC", postcode: "3461" },
{ city: "FRANKLINFORD", state: "VIC", postcode: "3461" },
{ city: "GLENLYON", state: "VIC", postcode: "3461" },
{ city: "HEPBURN", state: "VIC", postcode: "3461" },
{ city: "HEPBURN SPRINGS", state: "VIC", postcode: "3461" },
{ city: "KORWEINGUBOORA", state: "VIC", postcode: "3461" },
{ city: "LEONARDS HILL", state: "VIC", postcode: "3461" },
{ city: "LYONVILLE", state: "VIC", postcode: "3461" },
{ city: "MOUNT FRANKLIN", state: "VIC", postcode: "3461" },
{ city: "MUSK", state: "VIC", postcode: "3461" },
{ city: "MUSK VALE", state: "VIC", postcode: "3461" },
{ city: "PORCUPINE RIDGE", state: "VIC", postcode: "3461" },
{ city: "SAILORS FALLS", state: "VIC", postcode: "3461" },
{ city: "SAILORS HILL", state: "VIC", postcode: "3461" },
{ city: "SHEPHERDS FLAT", state: "VIC", postcode: "3461" },
{ city: "SPARGO CREEK", state: "VIC", postcode: "3461" },
{ city: "STRANGWAYS", state: "VIC", postcode: "3461" },
{ city: "WHEATSHEAF", state: "VIC", postcode: "3461" },
{ city: "YANDOIT", state: "VIC", postcode: "3461" },
{ city: "YANDOIT HILLS", state: "VIC", postcode: "3461" },
{ city: "GREEN GULLY", state: "VIC", postcode: "3462" },
{ city: "JOYCES CREEK", state: "VIC", postcode: "3462" },
{ city: "MUCKLEFORD SOUTH", state: "VIC", postcode: "3462" },
{ city: "NEWSTEAD", state: "VIC", postcode: "3462" },
{ city: "SANDON", state: "VIC", postcode: "3462" },
{ city: "WELSHMANS REEF", state: "VIC", postcode: "3462" },
{ city: "BARINGHUP", state: "VIC", postcode: "3463" },
{ city: "BARINGHUP WEST", state: "VIC", postcode: "3463" },
{ city: "BRADFORD", state: "VIC", postcode: "3463" },
{ city: "EASTVILLE", state: "VIC", postcode: "3463" },
{ city: "LAANECOORIE", state: "VIC", postcode: "3463" },
{ city: "MALDON", state: "VIC", postcode: "3463" },
{ city: "NEEREMAN", state: "VIC", postcode: "3463" },
{ city: "NUGGETTY", state: "VIC", postcode: "3463" },
{ city: "PERKINS REEF", state: "VIC", postcode: "3463" },
{ city: "PORCUPINE FLAT", state: "VIC", postcode: "3463" },
{ city: "SHELBOURNE", state: "VIC", postcode: "3463" },
{ city: "TARRENGOWER", state: "VIC", postcode: "3463" },
{ city: "WALMER", state: "VIC", postcode: "3463" },
{ city: "WOODSTOCK WEST", state: "VIC", postcode: "3463" },
{ city: "CARISBROOK", state: "VIC", postcode: "3464" },
{ city: "MOOLORT", state: "VIC", postcode: "3465" },
{ city: "AVOCA", state: "VIC", postcode: "3467" },
{ city: "AMPHITHEATRE", state: "VIC", postcode: "3468" },
{ city: "MOUNT LONARCH", state: "VIC", postcode: "3468" },
{ city: "ELMHURST", state: "VIC", postcode: "3469" },
{ city: "GLENLOFTY", state: "VIC", postcode: "3469" },
{ city: "GLENLOGIE", state: "VIC", postcode: "3469" },
{ city: "GLENPATRICK", state: "VIC", postcode: "3469" },
{ city: "NOWHERE CREEK", state: "VIC", postcode: "3469" },
{ city: "BET BET", state: "VIC", postcode: "3472" },
{ city: "BETLEY", state: "VIC", postcode: "3472" },
{ city: "BROMLEY", state: "VIC", postcode: "3472" },
{ city: "DUNLUCE", state: "VIC", postcode: "3472" },
{ city: "DUNOLLY", state: "VIC", postcode: "3472" },
{ city: "EDDINGTON", state: "VIC", postcode: "3472" },
{ city: "GOLDSBOROUGH", state: "VIC", postcode: "3472" },
{ city: "INKERMAN", state: "VIC", postcode: "3472" },
{ city: "MCINTYRE", state: "VIC", postcode: "3472" },
{ city: "MOLIAGUL", state: "VIC", postcode: "3472" },
{ city: "MOUNT HOOGHLY", state: "VIC", postcode: "3472" },
{ city: "ARCHDALE", state: "VIC", postcode: "3475" },
{ city: "ARCHDALE JUNCTION", state: "VIC", postcode: "3475" },
{ city: "BEALIBA", state: "VIC", postcode: "3475" },
{ city: "BURKES FLAT", state: "VIC", postcode: "3475" },
{ city: "COCHRANES CREEK", state: "VIC", postcode: "3475" },
{ city: "EMU", state: "VIC", postcode: "3475" },
{ city: "LOGAN", state: "VIC", postcode: "3475" },
{ city: "AVON PLAINS", state: "VIC", postcode: "3477" },
{ city: "BEAZLEYS BRIDGE", state: "VIC", postcode: "3477" },
{ city: "CARAPOOEE", state: "VIC", postcode: "3477" },
{ city: "CARAPOOEE WEST", state: "VIC", postcode: "3477" },
{ city: "COONOOER BRIDGE", state: "VIC", postcode: "3477" },
{ city: "COONOOER WEST", state: "VIC", postcode: "3477" },
{ city: "DALYENONG", state: "VIC", postcode: "3477" },
{ city: "GOOROC", state: "VIC", postcode: "3477" },
{ city: "GOWAR EAST", state: "VIC", postcode: "3477" },
{ city: "GRAYS BRIDGE", state: "VIC", postcode: "3477" },
{ city: "GRE GRE", state: "VIC", postcode: "3477" },
{ city: "GRE GRE NORTH", state: "VIC", postcode: "3477" },
{ city: "GRE GRE SOUTH", state: "VIC", postcode: "3477" },
{ city: "KOOREH", state: "VIC", postcode: "3477" },
{ city: "MARNOO EAST", state: "VIC", postcode: "3477" },
{ city: "MOOLERR", state: "VIC", postcode: "3477" },
{ city: "MOYREISK", state: "VIC", postcode: "3477" },
{ city: "PARADISE", state: "VIC", postcode: "3477" },
{ city: "REDBANK", state: "VIC", postcode: "3477" },
{ city: "ROSTRON", state: "VIC", postcode: "3477" },
{ city: "SLATY CREEK", state: "VIC", postcode: "3477" },
{ city: "ST ARNAUD EAST", state: "VIC", postcode: "3477" },
{ city: "ST ARNAUD NORTH", state: "VIC", postcode: "3477" },
{ city: "STUART MILL", state: "VIC", postcode: "3477" },
{ city: "SUTHERLAND", state: "VIC", postcode: "3477" },
{ city: "SWANWATER", state: "VIC", postcode: "3477" },
{ city: "TOTTINGTON", state: "VIC", postcode: "3477" },
{ city: "TRAYNORS LAGOON", state: "VIC", postcode: "3477" },
{ city: "WINJALLOK", state: "VIC", postcode: "3477" },
{ city: "YORK PLAINS", state: "VIC", postcode: "3477" },
{ city: "DARKBONEE", state: "VIC", postcode: "3478" },
{ city: "DOOBOOBETIC", state: "VIC", postcode: "3478" },
{ city: "ELBERTON", state: "VIC", postcode: "3478" },
{ city: "MEDLYN", state: "VIC", postcode: "3478" },
{ city: "MITCHELLS HILL", state: "VIC", postcode: "3478" },
{ city: "MOONAMBEL", state: "VIC", postcode: "3478" },
{ city: "PERCYDALE", state: "VIC", postcode: "3478" },
{ city: "ST ARNAUD", state: "VIC", postcode: "3478" },
{ city: "TANWOOD", state: "VIC", postcode: "3478" },
{ city: "WARRENMANG", state: "VIC", postcode: "3478" },
{ city: "YAWONG HILLS", state: "VIC", postcode: "3478" },
{ city: "AREEGRA", state: "VIC", postcode: "3480" },
{ city: "CARRON", state: "VIC", postcode: "3480" },
{ city: "COPE COPE", state: "VIC", postcode: "3480" },
{ city: "CORACK", state: "VIC", postcode: "3480" },
{ city: "CORACK EAST", state: "VIC", postcode: "3480" },
{ city: "DONALD", state: "VIC", postcode: "3480" },
{ city: "GIL GIL", state: "VIC", postcode: "3480" },
{ city: "JEFFCOTT", state: "VIC", postcode: "3480" },
{ city: "JEFFCOTT NORTH", state: "VIC", postcode: "3480" },
{ city: "LAEN", state: "VIC", postcode: "3480" },
{ city: "LAEN EAST", state: "VIC", postcode: "3480" },
{ city: "LAEN NORTH", state: "VIC", postcode: "3480" },
{ city: "LAKE BULOKE", state: "VIC", postcode: "3480" },
{ city: "LAWLER", state: "VIC", postcode: "3480" },
{ city: "LITCHFIELD", state: "VIC", postcode: "3480" },
{ city: "RICH AVON", state: "VIC", postcode: "3480" },
{ city: "RICH AVON EAST", state: "VIC", postcode: "3480" },
{ city: "RICH AVON WEST", state: "VIC", postcode: "3480" },
{ city: "SWANWATER WEST", state: "VIC", postcode: "3480" },
{ city: "MASSEY", state: "VIC", postcode: "3482" },
{ city: "MORTON PLAINS", state: "VIC", postcode: "3482" },
{ city: "WARMUR", state: "VIC", postcode: "3482" },
{ city: "WATCHEM", state: "VIC", postcode: "3482" },
{ city: "WATCHEM WEST", state: "VIC", postcode: "3482" },
{ city: "BALLAPUR", state: "VIC", postcode: "3483" },
{ city: "BIRCHIP", state: "VIC", postcode: "3483" },
{ city: "BIRCHIP WEST", state: "VIC", postcode: "3483" },
{ city: "CURYO", state: "VIC", postcode: "3483" },
{ city: "JIL JIL", state: "VIC", postcode: "3483" },
{ city: "KARYRIE", state: "VIC", postcode: "3483" },
{ city: "KINNABULLA", state: "VIC", postcode: "3483" },
{ city: "MARLBED", state: "VIC", postcode: "3483" },
{ city: "NARRAPORT", state: "VIC", postcode: "3483" },
{ city: "WHIRILY", state: "VIC", postcode: "3483" },
{ city: "BANYAN", state: "VIC", postcode: "3485" },
{ city: "WATCHUPGA", state: "VIC", postcode: "3485" },
{ city: "WILLANGIE", state: "VIC", postcode: "3485" },
{ city: "WOOMELANG", state: "VIC", postcode: "3485" },
{ city: "LASCELLES", state: "VIC", postcode: "3487" },
{ city: "SPEED", state: "VIC", postcode: "3488" },
{ city: "TURRIFF", state: "VIC", postcode: "3488" },
{ city: "TURRIFF EAST", state: "VIC", postcode: "3488" },
{ city: "TEMPY", state: "VIC", postcode: "3489" },
{ city: "BIG DESERT", state: "VIC", postcode: "3490" },
{ city: "BOINKA", state: "VIC", postcode: "3490" },
{ city: "KULWIN", state: "VIC", postcode: "3490" },
{ city: "MITTYACK", state: "VIC", postcode: "3490" },
{ city: "MURRAY-SUNSET", state: "VIC", postcode: "3490" },
{ city: "OUYEN", state: "VIC", postcode: "3490" },
{ city: "TORRITA", state: "VIC", postcode: "3490" },
{ city: "TUTYE", state: "VIC", postcode: "3490" },
{ city: "PATCHEWOLLOCK", state: "VIC", postcode: "3491" },
{ city: "CARWARP", state: "VIC", postcode: "3494" },
{ city: "COLIGNAN", state: "VIC", postcode: "3494" },
{ city: "IRAAK", state: "VIC", postcode: "3494" },
{ city: "NANGILOC", state: "VIC", postcode: "3494" },
{ city: "CARDROSS", state: "VIC", postcode: "3496" },
{ city: "CULLULLERAINE", state: "VIC", postcode: "3496" },
{ city: "LINDSAY POINT", state: "VIC", postcode: "3496" },
{ city: "MERINGUR", state: "VIC", postcode: "3496" },
{ city: "MERRINEE", state: "VIC", postcode: "3496" },
{ city: "NEDS CORNER", state: "VIC", postcode: "3496" },
{ city: "RED CLIFFS", state: "VIC", postcode: "3496" },
{ city: "SUNNYCLIFFS", state: "VIC", postcode: "3496" },
{ city: "WERRIMULL", state: "VIC", postcode: "3496" },
{ city: "IRYMPLE", state: "VIC", postcode: "3498" },
{ city: "MILDURA", state: "VIC", postcode: "3500" },
{ city: "MILDURA EAST", state: "VIC", postcode: "3500" },
{ city: "MILDURA WEST", state: "VIC", postcode: "3500" },
{ city: "HATTAH", state: "VIC", postcode: "3501" },
{ city: "KOORLONG", state: "VIC", postcode: "3501" },
{ city: "MILDURA CENTRE PLAZA", state: "VIC", postcode: "3501" },
{ city: "MILDURA SOUTH", state: "VIC", postcode: "3501" },
{ city: "NICHOLS POINT", state: "VIC", postcode: "3501" },
{ city: "BIRDWOODTON", state: "VIC", postcode: "3505" },
{ city: "CABARITA", state: "VIC", postcode: "3505" },
{ city: "MERBEIN", state: "VIC", postcode: "3505" },
{ city: "MERBEIN SOUTH", state: "VIC", postcode: "3505" },
{ city: "MERBEIN WEST", state: "VIC", postcode: "3505" },
{ city: "WARGAN", state: "VIC", postcode: "3505" },
{ city: "YELTA", state: "VIC", postcode: "3505" },
{ city: "COWANGIE", state: "VIC", postcode: "3506" },
{ city: "WALPEUP", state: "VIC", postcode: "3507" },
{ city: "LINGA", state: "VIC", postcode: "3509" },
{ city: "UNDERBOOL", state: "VIC", postcode: "3509" },
{ city: "CARINA", state: "VIC", postcode: "3512" },
{ city: "MURRAYVILLE", state: "VIC", postcode: "3512" },
{ city: "PANITYA", state: "VIC", postcode: "3512" },
{ city: "MARONG", state: "VIC", postcode: "3515" },
{ city: "SHELBOURNE", state: "VIC", postcode: "3515" },
{ city: "WILSONS HILL", state: "VIC", postcode: "3515" },
{ city: "BRIDGEWATER", state: "VIC", postcode: "3516" },
{ city: "BRIDGEWATER NORTH", state: "VIC", postcode: "3516" },
{ city: "BRIDGEWATER ON LODDON", state: "VIC", postcode: "3516" },
{ city: "DERBY", state: "VIC", postcode: "3516" },
{ city: "LEICHARDT", state: "VIC", postcode: "3516" },
{ city: "YARRABERB", state: "VIC", postcode: "3516" },
{ city: "BEARS LAGOON", state: "VIC", postcode: "3517" },
{ city: "BRENANAH", state: "VIC", postcode: "3517" },
{ city: "GLENALBYN", state: "VIC", postcode: "3517" },
{ city: "INGLEWOOD", state: "VIC", postcode: "3517" },
{ city: "JARKLIN", state: "VIC", postcode: "3517" },
{ city: "KINGOWER", state: "VIC", postcode: "3517" },
{ city: "KURTING", state: "VIC", postcode: "3517" },
{ city: "POWLETT PLAINS", state: "VIC", postcode: "3517" },
{ city: "RHEOLA", state: "VIC", postcode: "3517" },
{ city: "SALISBURY WEST", state: "VIC", postcode: "3517" },
{ city: "SERPENTINE", state: "VIC", postcode: "3517" },
{ city: "BERRIMAL", state: "VIC", postcode: "3518" },
{ city: "BORUNG", state: "VIC", postcode: "3518" },
{ city: "FENTONS CREEK", state: "VIC", postcode: "3518" },
{ city: "FERNIHURST", state: "VIC", postcode: "3518" },
{ city: "FIERY FLAT", state: "VIC", postcode: "3518" },
{ city: "KURRACA", state: "VIC", postcode: "3518" },
{ city: "KURRACA WEST", state: "VIC", postcode: "3518" },
{ city: "MYSIA", state: "VIC", postcode: "3518" },
{ city: "NINE MILE", state: "VIC", postcode: "3518" },
{ city: "RICHMOND PLAINS", state: "VIC", postcode: "3518" },
{ city: "SKINNERS FLAT", state: "VIC", postcode: "3518" },
{ city: "WEHLA", state: "VIC", postcode: "3518" },
{ city: "WOOLSHED FLAT", state: "VIC", postcode: "3518" },
{ city: "WOOSANG", state: "VIC", postcode: "3518" },
{ city: "KINYPANIAL", state: "VIC", postcode: "3520" },
{ city: "KORONG VALE", state: "VIC", postcode: "3520" },
{ city: "PYALONG", state: "VIC", postcode: "3521" },
{ city: "GLENHOPE EAST", state: "VIC", postcode: "3522" },
{ city: "TOOBORAC", state: "VIC", postcode: "3522" },
{ city: "ARGYLE", state: "VIC", postcode: "3523" },
{ city: "COSTERFIELD", state: "VIC", postcode: "3523" },
{ city: "DERRINAL", state: "VIC", postcode: "3523" },
{ city: "HEATHCOTE", state: "VIC", postcode: "3523" },
{ city: "HEATHCOTE SOUTH", state: "VIC", postcode: "3523" },
{ city: "KNOWSLEY", state: "VIC", postcode: "3523" },
{ city: "LADYS PASS", state: "VIC", postcode: "3523" },
{ city: "MOORMBOOL WEST", state: "VIC", postcode: "3523" },
{ city: "MOUNT CAMEL", state: "VIC", postcode: "3523" },
{ city: "REDCASTLE", state: "VIC", postcode: "3523" },
{ city: "BARRAKEE", state: "VIC", postcode: "3525" },
{ city: "BUCKRABANYULE", state: "VIC", postcode: "3525" },
{ city: "CHARLTON", state: "VIC", postcode: "3525" },
{ city: "CHIRRIP", state: "VIC", postcode: "3525" },
{ city: "GRANITE FLAT", state: "VIC", postcode: "3525" },
{ city: "LAKE MARMAL", state: "VIC", postcode: "3525" },
{ city: "NAREEWILLOCK", state: "VIC", postcode: "3525" },
{ city: "TERRAPPEE", state: "VIC", postcode: "3525" },
{ city: "WOOROONOOK", state: "VIC", postcode: "3525" },
{ city: "WYCHITELLA", state: "VIC", postcode: "3525" },
{ city: "WYCHITELLA NORTH", state: "VIC", postcode: "3525" },
{ city: "YEUNGROON", state: "VIC", postcode: "3525" },
{ city: "YEUNGROON EAST", state: "VIC", postcode: "3525" },
{ city: "BUNGULUKE", state: "VIC", postcode: "3527" },
{ city: "DUMOSA", state: "VIC", postcode: "3527" },
{ city: "GLENLOTH", state: "VIC", postcode: "3527" },
{ city: "GLENLOTH EAST", state: "VIC", postcode: "3527" },
{ city: "JERUK", state: "VIC", postcode: "3527" },
{ city: "NINYEUNOOK", state: "VIC", postcode: "3527" },
{ city: "TEDDYWADDY", state: "VIC", postcode: "3527" },
{ city: "TEDDYWADDY WEST", state: "VIC", postcode: "3527" },
{ city: "THALIA", state: "VIC", postcode: "3527" },
{ city: "TOWANINNY", state: "VIC", postcode: "3527" },
{ city: "TOWANINNY SOUTH", state: "VIC", postcode: "3527" },
{ city: "WYCHEPROOF", state: "VIC", postcode: "3527" },
{ city: "WYCHEPROOF SOUTH", state: "VIC", postcode: "3527" },
{ city: "KALPIENUNG", state: "VIC", postcode: "3529" },
{ city: "NULLAWIL", state: "VIC", postcode: "3529" },
{ city: "CULGOA", state: "VIC", postcode: "3530" },
{ city: "SUTTON", state: "VIC", postcode: "3530" },
{ city: "WANGIE", state: "VIC", postcode: "3530" },
{ city: "WARNE", state: "VIC", postcode: "3530" },
{ city: "BERRIWILLOCK", state: "VIC", postcode: "3531" },
{ city: "BOIGBEAT", state: "VIC", postcode: "3531" },
{ city: "BIMBOURIE", state: "VIC", postcode: "3533" },
{ city: "LAKE TYRRELL", state: "VIC", postcode: "3533" },
{ city: "MITTYACK", state: "VIC", postcode: "3533" },
{ city: "MYALL", state: "VIC", postcode: "3533" },
{ city: "NANDALY", state: "VIC", postcode: "3533" },
{ city: "NINDA", state: "VIC", postcode: "3533" },
{ city: "NYARRIN", state: "VIC", postcode: "3533" },
{ city: "PIER MILAN", state: "VIC", postcode: "3533" },
{ city: "SEA LAKE", state: "VIC", postcode: "3533" },
{ city: "STRATEN", state: "VIC", postcode: "3533" },
{ city: "TYENNA", state: "VIC", postcode: "3533" },
{ city: "TYRRELL", state: "VIC", postcode: "3533" },
{ city: "TYRRELL DOWNS", state: "VIC", postcode: "3533" },
{ city: "BARRAPORT", state: "VIC", postcode: "3537" },
{ city: "BARRAPORT WEST", state: "VIC", postcode: "3537" },
{ city: "BOORT", state: "VIC", postcode: "3537" },
{ city: "CANARY ISLAND", state: "VIC", postcode: "3537" },
{ city: "CATUMNAL", state: "VIC", postcode: "3537" },
{ city: "GREDGWIN", state: "VIC", postcode: "3537" },
{ city: "LEAGHUR", state: "VIC", postcode: "3537" },
{ city: "MINMINDIE", state: "VIC", postcode: "3537" },
{ city: "YANDO", state: "VIC", postcode: "3537" },
{ city: "CANNIE", state: "VIC", postcode: "3540" },
{ city: "OAKVALE", state: "VIC", postcode: "3540" },
{ city: "QUAMBATOOK", state: "VIC", postcode: "3540" },
{ city: "COKUM", state: "VIC", postcode: "3542" },
{ city: "LALBERT", state: "VIC", postcode: "3542" },
{ city: "TITTYBONG", state: "VIC", postcode: "3542" },
{ city: "CHINANGIN", state: "VIC", postcode: "3544" },
{ city: "GOWANFORD", state: "VIC", postcode: "3544" },
{ city: "MURNUNGIN", state: "VIC", postcode: "3544" },
{ city: "SPRINGFIELD", state: "VIC", postcode: "3544" },
{ city: "ULTIMA", state: "VIC", postcode: "3544" },
{ city: "ULTIMA EAST", state: "VIC", postcode: "3544" },
{ city: "WAITCHIE", state: "VIC", postcode: "3544" },
{ city: "BOLTON", state: "VIC", postcode: "3546" },
{ city: "CHINKAPOOK", state: "VIC", postcode: "3546" },
{ city: "COCAMBA", state: "VIC", postcode: "3546" },
{ city: "GERAHMIN", state: "VIC", postcode: "3546" },
{ city: "MANANGATANG", state: "VIC", postcode: "3546" },
{ city: "TUROAR", state: "VIC", postcode: "3546" },
{ city: "WINNAMBOOL", state: "VIC", postcode: "3546" },
{ city: "ANNUELLO", state: "VIC", postcode: "3549" },
{ city: "BANNERTON", state: "VIC", postcode: "3549" },
{ city: "HAPPY VALLEY", state: "VIC", postcode: "3549" },
{ city: "LIPAROO", state: "VIC", postcode: "3549" },
{ city: "ROBINVALE", state: "VIC", postcode: "3549" },
{ city: "ROBINVALE IRRIGATION DISTRICT SECTION B", state: "VIC", postcode: "3549" },
{ city: "ROBINVALE IRRIGATION DISTRICT SECTION C", state: "VIC", postcode: "3549" },
{ city: "ROBINVALE IRRIGATION DISTRICT SECTION D", state: "VIC", postcode: "3549" },
{ city: "ROBINVALE IRRIGATION DISTRICT SECTION E", state: "VIC", postcode: "3549" },
{ city: "TOL TOL", state: "VIC", postcode: "3549" },
{ city: "WANDOWN", state: "VIC", postcode: "3549" },
{ city: "WEMEN", state: "VIC", postcode: "3549" },
{ city: "ARNOLD", state: "VIC", postcode: "3551" },
{ city: "ARNOLD WEST", state: "VIC", postcode: "3551" },
{ city: "ASCOT", state: "VIC", postcode: "3551" },
{ city: "AXE CREEK", state: "VIC", postcode: "3551" },
{ city: "AXEDALE", state: "VIC", postcode: "3551" },
{ city: "BAGSHOT", state: "VIC", postcode: "3551" },
{ city: "BAGSHOT NORTH", state: "VIC", postcode: "3551" },
{ city: "BENDIGO FORWARD", state: "VIC", postcode: "3551" },
{ city: "CORNELLA", state: "VIC", postcode: "3551" },
{ city: "EMU CREEK", state: "VIC", postcode: "3551" },
{ city: "EPPALOCK", state: "VIC", postcode: "3551" },
{ city: "EPSOM", state: "VIC", postcode: "3551" },
{ city: "HUNTLY", state: "VIC", postcode: "3551" },
{ city: "HUNTLY NORTH", state: "VIC", postcode: "3551" },
{ city: "JUNORTOUN", state: "VIC", postcode: "3551" },
{ city: "KIMBOLTON", state: "VIC", postcode: "3551" },
{ city: "LAKE EPPALOCK", state: "VIC", postcode: "3551" },
{ city: "LLANELLY", state: "VIC", postcode: "3551" },
{ city: "LOCKWOOD", state: "VIC", postcode: "3551" },
{ city: "LOCKWOOD SOUTH", state: "VIC", postcode: "3551" },
{ city: "LONGLEA", state: "VIC", postcode: "3551" },
{ city: "MAIDEN GULLY", state: "VIC", postcode: "3551" },
{ city: "MANDURANG", state: "VIC", postcode: "3551" },
{ city: "MANDURANG SOUTH", state: "VIC", postcode: "3551" },
{ city: "MINTO", state: "VIC", postcode: "3551" },
{ city: "MURPHYS CREEK", state: "VIC", postcode: "3551" },
{ city: "MYOLA", state: "VIC", postcode: "3551" },
{ city: "MYOLA EAST", state: "VIC", postcode: "3551" },
{ city: "MYRTLE CREEK", state: "VIC", postcode: "3551" },
{ city: "NEWBRIDGE", state: "VIC", postcode: "3551" },
{ city: "PAINSWICK", state: "VIC", postcode: "3551" },
{ city: "PILCHERS BRIDGE", state: "VIC", postcode: "3551" },
{ city: "SEDGWICK", state: "VIC", postcode: "3551" },
{ city: "STRATHFIELDSAYE", state: "VIC", postcode: "3551" },
{ city: "TARNAGULLA", state: "VIC", postcode: "3551" },
{ city: "TOOLLEEN", state: "VIC", postcode: "3551" },
{ city: "WAANYARRA", state: "VIC", postcode: "3551" },
{ city: "WELLSFORD", state: "VIC", postcode: "3551" },
{ city: "WOODSTOCK ON LODDON", state: "VIC", postcode: "3551" },
{ city: "BIG HILL", state: "VIC", postcode: "3555" },
{ city: "GOLDEN GULLY", state: "VIC", postcode: "3555" },
{ city: "KANGAROO FLAT", state: "VIC", postcode: "3555" },
{ city: "LANSELL PLAZA", state: "VIC", postcode: "3555" },
{ city: "CALIFORNIA GULLY", state: "VIC", postcode: "3556" },
{ city: "CAMPBELLS FOREST", state: "VIC", postcode: "3556" },
{ city: "EAGLEHAWK", state: "VIC", postcode: "3556" },
{ city: "EAGLEHAWK NORTH", state: "VIC", postcode: "3556" },
{ city: "JACKASS FLAT", state: "VIC", postcode: "3556" },
{ city: "MYERS FLAT", state: "VIC", postcode: "3556" },
{ city: "SAILORS GULLY", state: "VIC", postcode: "3556" },
{ city: "SEBASTIAN", state: "VIC", postcode: "3556" },
{ city: "WHIPSTICK", state: "VIC", postcode: "3556" },
{ city: "WOODVALE", state: "VIC", postcode: "3556" },
{ city: "BARNADOWN", state: "VIC", postcode: "3557" },
{ city: "FOSTERVILLE", state: "VIC", postcode: "3557" },
{ city: "GOORNONG", state: "VIC", postcode: "3557" },
{ city: "MUSKERRY", state: "VIC", postcode: "3557" },
{ city: "MUSKERRY EAST", state: "VIC", postcode: "3557" },
{ city: "BURNEWANG", state: "VIC", postcode: "3558" },
{ city: "COROP WEST", state: "VIC", postcode: "3558" },
{ city: "CREEK VIEW", state: "VIC", postcode: "3558" },
{ city: "ELMORE", state: "VIC", postcode: "3558" },
{ city: "HUNTER", state: "VIC", postcode: "3558" },
{ city: "RUNNYMEDE", state: "VIC", postcode: "3558" },
{ city: "AVONMORE", state: "VIC", postcode: "3559" },
{ city: "BURRAMBOOT", state: "VIC", postcode: "3559" },
{ city: "COLBINABBIN", state: "VIC", postcode: "3559" },
{ city: "COROP", state: "VIC", postcode: "3559" },
{ city: "GOBARUP", state: "VIC", postcode: "3559" },
{ city: "RUNNYMEDE", state: "VIC", postcode: "3559" },
{ city: "BALLENDELLA", state: "VIC", postcode: "3561" },
{ city: "BAMAWM", state: "VIC", postcode: "3561" },
{ city: "BAMAWM EXTENSION", state: "VIC", postcode: "3561" },
{ city: "BONN", state: "VIC", postcode: "3561" },
{ city: "DIGGORA", state: "VIC", postcode: "3561" },
{ city: "DIGGORA WEST", state: "VIC", postcode: "3561" },
{ city: "FAIRY DELL", state: "VIC", postcode: "3561" },
{ city: "NANNEELLA", state: "VIC", postcode: "3561" },
{ city: "ROCHESTER", state: "VIC", postcode: "3561" },
{ city: "ROCHESTER WEST", state: "VIC", postcode: "3561" },
{ city: "THE SETTLEMENT", state: "VIC", postcode: "3561" },
{ city: "TIMMERING", state: "VIC", postcode: "3561" },
{ city: "TORRUMBARRY", state: "VIC", postcode: "3562" },
{ city: "LOCKINGTON", state: "VIC", postcode: "3563" },
{ city: "BAMAWM EXTENSION", state: "VIC", postcode: "3564" },
{ city: "CAMPASPE WEST", state: "VIC", postcode: "3564" },
{ city: "KANYAPELLA", state: "VIC", postcode: "3564" },
{ city: "MCEVOYS", state: "VIC", postcode: "3564" },
{ city: "PATHO", state: "VIC", postcode: "3564" },
{ city: "PATHO WEST", state: "VIC", postcode: "3564" },
{ city: "ROSLYNMEAD", state: "VIC", postcode: "3564" },
{ city: "SIMMIE", state: "VIC", postcode: "3564" },
{ city: "WHARPARILLA", state: "VIC", postcode: "3564" },
{ city: "KOTTA", state: "VIC", postcode: "3565" },
{ city: "GUNBOWER", state: "VIC", postcode: "3566" },
{ city: "HORFIELD", state: "VIC", postcode: "3567" },
{ city: "LEITCHVILLE", state: "VIC", postcode: "3567" },
{ city: "BURKES BRIDGE", state: "VIC", postcode: "3568" },
{ city: "COHUNA", state: "VIC", postcode: "3568" },
{ city: "CULLEN", state: "VIC", postcode: "3568" },
{ city: "DALTONS BRIDGE", state: "VIC", postcode: "3568" },
{ city: "GANNAWARRA", state: "VIC", postcode: "3568" },
{ city: "KEELY", state: "VIC", postcode: "3568" },
{ city: "MACORNA NORTH", state: "VIC", postcode: "3568" },
{ city: "MCMILLANS", state: "VIC", postcode: "3568" },
{ city: "MEAD", state: "VIC", postcode: "3568" },
{ city: "MINCHA WEST", state: "VIC", postcode: "3568" },
{ city: "WEE WEE RUP", state: "VIC", postcode: "3568" },
{ city: "AUCHMORE", state: "VIC", postcode: "3570" },
{ city: "DRUMMARTIN", state: "VIC", postcode: "3570" },
{ city: "KAMAROOKA", state: "VIC", postcode: "3570" },
{ city: "NEILBOROUGH", state: "VIC", postcode: "3570" },
{ city: "RAYWOOD", state: "VIC", postcode: "3570" },
{ city: "SUMMERFIELD", state: "VIC", postcode: "3570" },
{ city: "DINGEE", state: "VIC", postcode: "3571" },
{ city: "KAMAROOKA NORTH", state: "VIC", postcode: "3571" },
{ city: "POMPAPIEL", state: "VIC", postcode: "3571" },
{ city: "TANDARRA", state: "VIC", postcode: "3571" },
{ city: "MILLOO", state: "VIC", postcode: "3572" },
{ city: "PIAVELLA", state: "VIC", postcode: "3572" },
{ city: "PRAIRIE", state: "VIC", postcode: "3572" },
{ city: "TENNYSON", state: "VIC", postcode: "3572" },
{ city: "CALIVIL", state: "VIC", postcode: "3573" },
{ city: "MITIAMO", state: "VIC", postcode: "3573" },
{ city: "PINE GROVE", state: "VIC", postcode: "3573" },
{ city: "PINE GROVE EAST", state: "VIC", postcode: "3573" },
{ city: "TERRICK TERRICK EAST", state: "VIC", postcode: "3573" },
{ city: "GLADFIELD", state: "VIC", postcode: "3575" },
{ city: "JUNGABURRA", state: "VIC", postcode: "3575" },
{ city: "LODDON VALE", state: "VIC", postcode: "3575" },
{ city: "MINCHA", state: "VIC", postcode: "3575" },
{ city: "MOLOGA", state: "VIC", postcode: "3575" },
{ city: "PYRAMID HILL", state: "VIC", postcode: "3575" },
{ city: "SYLVATERRE", state: "VIC", postcode: "3575" },
{ city: "TERRICK TERRICK", state: "VIC", postcode: "3575" },
{ city: "YARRAWALLA", state: "VIC", postcode: "3575" },
{ city: "DURHAM OX", state: "VIC", postcode: "3576" },
{ city: "APPIN", state: "VIC", postcode: "3579" },
{ city: "APPIN SOUTH", state: "VIC", postcode: "3579" },
{ city: "BAEL BAEL", state: "VIC", postcode: "3579" },
{ city: "BEAUCHAMP", state: "VIC", postcode: "3579" },
{ city: "BENJEROOP", state: "VIC", postcode: "3579" },
{ city: "BUDGERUM EAST", state: "VIC", postcode: "3579" },
{ city: "CAPELS CROSSING", state: "VIC", postcode: "3579" },
{ city: "DINGWALL", state: "VIC", postcode: "3579" },
{ city: "FAIRLEY", state: "VIC", postcode: "3579" },
{ city: "GONN CROSSING", state: "VIC", postcode: "3579" },
{ city: "KERANG", state: "VIC", postcode: "3579" },
{ city: "KERANG EAST", state: "VIC", postcode: "3579" },
{ city: "KOROOP", state: "VIC", postcode: "3579" },
{ city: "LAKE MERAN", state: "VIC", postcode: "3579" },
{ city: "MACORNA", state: "VIC", postcode: "3579" },
{ city: "MEERING WEST", state: "VIC", postcode: "3579" },
{ city: "MILNES BRIDGE", state: "VIC", postcode: "3579" },
{ city: "MURRABIT", state: "VIC", postcode: "3579" },
{ city: "MURRABIT WEST", state: "VIC", postcode: "3579" },
{ city: "MYALL", state: "VIC", postcode: "3579" },
{ city: "MYSTIC PARK", state: "VIC", postcode: "3579" },
{ city: "NORMANVILLE", state: "VIC", postcode: "3579" },
{ city: "PINE VIEW", state: "VIC", postcode: "3579" },
{ city: "REEDY LAKE", state: "VIC", postcode: "3579" },
{ city: "SANDHILL LAKE", state: "VIC", postcode: "3579" },
{ city: "TEAL POINT", state: "VIC", postcode: "3579" },
{ city: "TRAGOWEL", state: "VIC", postcode: "3579" },
{ city: "WANDELLA", state: "VIC", postcode: "3579" },
{ city: "WESTBY", state: "VIC", postcode: "3579" },
{ city: "KOONDROOK", state: "VIC", postcode: "3580" },
{ city: "LAKE CHARM", state: "VIC", postcode: "3581" },
{ city: "TRESCO", state: "VIC", postcode: "3583" },
{ city: "LAKE BOGA", state: "VIC", postcode: "3584" },
{ city: "TRESCO WEST", state: "VIC", postcode: "3584" },
{ city: "CASTLE DONNINGTON", state: "VIC", postcode: "3585" },
{ city: "CHILLINGOLLAH", state: "VIC", postcode: "3585" },
{ city: "FISH POINT", state: "VIC", postcode: "3585" },
{ city: "GOSCHEN", state: "VIC", postcode: "3585" },
{ city: "KUNAT", state: "VIC", postcode: "3585" },
{ city: "MEATIAN", state: "VIC", postcode: "3585" },
{ city: "NOWIE", state: "VIC", postcode: "3585" },
{ city: "NYRRABY", state: "VIC", postcode: "3585" },
{ city: "PIRA", state: "VIC", postcode: "3585" },
{ city: "POLISBET", state: "VIC", postcode: "3585" },
{ city: "SPEEWA", state: "VIC", postcode: "3585" },
{ city: "SWAN HILL", state: "VIC", postcode: "3585" },
{ city: "SWAN HILL PIONEER", state: "VIC", postcode: "3585" },
{ city: "SWAN HILL WEST", state: "VIC", postcode: "3585" },
{ city: "WINLATON", state: "VIC", postcode: "3585" },
{ city: "BULGA", state: "VIC", postcode: "3586" },
{ city: "MURRAWEE", state: "VIC", postcode: "3586" },
{ city: "MURRAYDALE", state: "VIC", postcode: "3586" },
{ city: "PENTAL ISLAND", state: "VIC", postcode: "3586" },
{ city: "TYNTYNDER", state: "VIC", postcode: "3586" },
{ city: "TYNTYNDER SOUTH", state: "VIC", postcode: "3586" },
{ city: "WOORINEN SOUTH", state: "VIC", postcode: "3588" },
{ city: "WOORINEN", state: "VIC", postcode: "3589" },
{ city: "WOORINEN NORTH", state: "VIC", postcode: "3589" },
{ city: "BEVERFORD", state: "VIC", postcode: "3590" },
{ city: "VINIFERA", state: "VIC", postcode: "3591" },
{ city: "NYAH", state: "VIC", postcode: "3594" },
{ city: "NYAH WEST", state: "VIC", postcode: "3595" },
{ city: "MIRALIE", state: "VIC", postcode: "3596" },
{ city: "TOWAN", state: "VIC", postcode: "3596" },
{ city: "WOOD WOOD", state: "VIC", postcode: "3596" },
{ city: "KENLEY", state: "VIC", postcode: "3597" },
{ city: "KOOLOONONG", state: "VIC", postcode: "3597" },
{ city: "LAKE POWELL", state: "VIC", postcode: "3597" },
{ city: "NARRUNG", state: "VIC", postcode: "3597" },
{ city: "NATYA", state: "VIC", postcode: "3597" },
{ city: "PIANGIL", state: "VIC", postcode: "3597" },
{ city: "BOUNDARY BEND", state: "VIC", postcode: "3599" },
{ city: "TABILK", state: "VIC", postcode: "3607" },
{ city: "BAILIESTON", state: "VIC", postcode: "3608" },
{ city: "GOULBURN WEIR", state: "VIC", postcode: "3608" },
{ city: "GRAYTOWN", state: "VIC", postcode: "3608" },
{ city: "KIRWANS BRIDGE", state: "VIC", postcode: "3608" },
{ city: "MITCHELLSTOWN", state: "VIC", postcode: "3608" },
{ city: "NAGAMBIE", state: "VIC", postcode: "3608" },
{ city: "WAHRING", state: "VIC", postcode: "3608" },
{ city: "WIRRATE", state: "VIC", postcode: "3608" },
{ city: "DHURRINGILE", state: "VIC", postcode: "3610" },
{ city: "MOORILIM", state: "VIC", postcode: "3610" },
{ city: "MURCHISON", state: "VIC", postcode: "3610" },
{ city: "MURCHISON EAST", state: "VIC", postcode: "3610" },
{ city: "MURCHISON NORTH", state: "VIC", postcode: "3610" },
{ city: "MOORA", state: "VIC", postcode: "3612" },
{ city: "RUSHWORTH", state: "VIC", postcode: "3612" },
{ city: "WANALTA", state: "VIC", postcode: "3612" },
{ city: "WARANGA SHORES", state: "VIC", postcode: "3612" },
{ city: "WHROO", state: "VIC", postcode: "3612" },
{ city: "TOOLAMBA", state: "VIC", postcode: "3614" },
{ city: "TOOLAMBA WEST", state: "VIC", postcode: "3614" },
{ city: "COOMA", state: "VIC", postcode: "3616" },
{ city: "GILLIESTON", state: "VIC", postcode: "3616" },
{ city: "GIRGARRE EAST", state: "VIC", postcode: "3616" },
{ city: "HARSTON", state: "VIC", postcode: "3616" },
{ city: "MOOROOPNA NORTH WEST", state: "VIC", postcode: "3616" },
{ city: "TATURA", state: "VIC", postcode: "3616" },
{ city: "TATURA EAST", state: "VIC", postcode: "3616" },
{ city: "WARANGA", state: "VIC", postcode: "3616" },
{ city: "BYRNESIDE", state: "VIC", postcode: "3617" },
{ city: "MERRIGUM", state: "VIC", postcode: "3618" },
{ city: "KYABRAM", state: "VIC", postcode: "3620" },
{ city: "KYABRAM SOUTH", state: "VIC", postcode: "3620" },
{ city: "LANCASTER", state: "VIC", postcode: "3620" },
{ city: "MOUNT SCOBIE", state: "VIC", postcode: "3620" },
{ city: "ST GERMAINS", state: "VIC", postcode: "3620" },
{ city: "TARIPTA", state: "VIC", postcode: "3620" },
{ city: "WYUNA", state: "VIC", postcode: "3620" },
{ city: "WYUNA EAST", state: "VIC", postcode: "3620" },
{ city: "KOYUGA SOUTH", state: "VIC", postcode: "3621" },
{ city: "KYVALLEY", state: "VIC", postcode: "3621" },
{ city: "KY WEST", state: "VIC", postcode: "3621" },
{ city: "TONGALA", state: "VIC", postcode: "3621" },
{ city: "YAMBUNA", state: "VIC", postcode: "3621" },
{ city: "KOYUGA", state: "VIC", postcode: "3622" },
{ city: "STRATHALLAN", state: "VIC", postcode: "3622" },
{ city: "CARAG CARAG", state: "VIC", postcode: "3623" },
{ city: "STANHOPE", state: "VIC", postcode: "3623" },
{ city: "STANHOPE SOUTH", state: "VIC", postcode: "3623" },
{ city: "GIRGARRE", state: "VIC", postcode: "3624" },
{ city: "ARCADIA", state: "VIC", postcode: "3631" },
{ city: "ARCADIA SOUTH", state: "VIC", postcode: "3631" },
{ city: "COSGROVE", state: "VIC", postcode: "3631" },
{ city: "COSGROVE SOUTH", state: "VIC", postcode: "3631" },
{ city: "GRAHAMVALE", state: "VIC", postcode: "3631" },
{ city: "KARRAMOMUS", state: "VIC", postcode: "3631" },
{ city: "KIALLA", state: "VIC", postcode: "3631" },
{ city: "KIALLA EAST", state: "VIC", postcode: "3631" },
{ city: "KIALLA WEST", state: "VIC", postcode: "3631" },
{ city: "LEMNOS", state: "VIC", postcode: "3631" },
{ city: "ORRVALE", state: "VIC", postcode: "3631" },
{ city: "PINE LODGE", state: "VIC", postcode: "3631" },
{ city: "CONGUPNA", state: "VIC", postcode: "3633" },
{ city: "BUNBARTHA", state: "VIC", postcode: "3634" },
{ city: "INVERGORDON SOUTH", state: "VIC", postcode: "3634" },
{ city: "KATANDRA", state: "VIC", postcode: "3634" },
{ city: "KATANDRA WEST", state: "VIC", postcode: "3634" },
{ city: "MARIONVALE", state: "VIC", postcode: "3634" },
{ city: "MARUNGI", state: "VIC", postcode: "3634" },
{ city: "TALLYGAROOPNA", state: "VIC", postcode: "3634" },
{ city: "ZEERUST", state: "VIC", postcode: "3634" },
{ city: "KAARIMBA", state: "VIC", postcode: "3635" },
{ city: "MUNDOONA", state: "VIC", postcode: "3635" },
{ city: "WUNGHNU", state: "VIC", postcode: "3635" },
{ city: "DRUMANURE", state: "VIC", postcode: "3636" },
{ city: "INVERGORDON", state: "VIC", postcode: "3636" },
{ city: "NARING", state: "VIC", postcode: "3636" },
{ city: "NUMURKAH", state: "VIC", postcode: "3636" },
{ city: "WAAIA", state: "VIC", postcode: "3637" },
{ city: "YALCA", state: "VIC", postcode: "3637" },
{ city: "KOTUPNA", state: "VIC", postcode: "3638" },
{ city: "NATHALIA", state: "VIC", postcode: "3638" },
{ city: "YIELIMA", state: "VIC", postcode: "3638" },
{ city: "BARMAH", state: "VIC", postcode: "3639" },
{ city: "LOWER MOIRA", state: "VIC", postcode: "3639" },
{ city: "PICOLA", state: "VIC", postcode: "3639" },
{ city: "PICOLA WEST", state: "VIC", postcode: "3639" },
{ city: "KATUNGA", state: "VIC", postcode: "3640" },
{ city: "BEARII", state: "VIC", postcode: "3641" },
{ city: "MYWEE", state: "VIC", postcode: "3641" },
{ city: "STRATHMERTON", state: "VIC", postcode: "3641" },
{ city: "ULUPNA", state: "VIC", postcode: "3641" },
{ city: "COBRAM", state: "VIC", postcode: "3644" },
{ city: "COBRAM EAST", state: "VIC", postcode: "3644" },
{ city: "KOONOOMOO", state: "VIC", postcode: "3644" },
{ city: "MUCKATAH", state: "VIC", postcode: "3644" },
{ city: "YARROWEYAH", state: "VIC", postcode: "3644" },
{ city: "DOOKIE", state: "VIC", postcode: "3646" },
{ city: "MOUNT MAJOR", state: "VIC", postcode: "3646" },
{ city: "NALINGA", state: "VIC", postcode: "3646" },
{ city: "WAGGARANDALL", state: "VIC", postcode: "3646" },
{ city: "YABBA NORTH", state: "VIC", postcode: "3646" },
{ city: "YABBA SOUTH", state: "VIC", postcode: "3646" },
{ city: "YOUANMITE", state: "VIC", postcode: "3646" },
{ city: "KATAMATITE", state: "VIC", postcode: "3649" },
{ city: "KATAMATITE EAST", state: "VIC", postcode: "3649" },
{ city: "BROADFORD", state: "VIC", postcode: "3658" },
{ city: "CLONBINANE", state: "VIC", postcode: "3658" },
{ city: "FLOWERDALE", state: "VIC", postcode: "3658" },
{ city: "HAZELDENE", state: "VIC", postcode: "3658" },
{ city: "REEDY CREEK", state: "VIC", postcode: "3658" },
{ city: "STRATH CREEK", state: "VIC", postcode: "3658" },
{ city: "SUGARLOAF CREEK", state: "VIC", postcode: "3658" },
{ city: "SUNDAY CREEK", state: "VIC", postcode: "3658" },
{ city: "TYAAK", state: "VIC", postcode: "3658" },
{ city: "WATERFORD PARK", state: "VIC", postcode: "3658" },
{ city: "TALLAROOK", state: "VIC", postcode: "3659" },
{ city: "CAVEAT", state: "VIC", postcode: "3660" },
{ city: "DROPMORE", state: "VIC", postcode: "3660" },
{ city: "HIGHLANDS", state: "VIC", postcode: "3660" },
{ city: "HILLDENE", state: "VIC", postcode: "3660" },
{ city: "KERRISDALE", state: "VIC", postcode: "3660" },
{ city: "NORTHWOOD", state: "VIC", postcode: "3660" },
{ city: "TRAWOOL", state: "VIC", postcode: "3660" },
{ city: "WHITEHEADS CREEK", state: "VIC", postcode: "3660" },
{ city: "PUCKAPUNYAL", state: "VIC", postcode: "3662" },
{ city: "MANGALORE", state: "VIC", postcode: "3663" },
{ city: "AVENEL", state: "VIC", postcode: "3664" },
{ city: "UPTON HILL", state: "VIC", postcode: "3664" },
{ city: "LOCKSLEY", state: "VIC", postcode: "3665" },
{ city: "LONGWOOD", state: "VIC", postcode: "3665" },
{ city: "BALMATTUM", state: "VIC", postcode: "3666" },
{ city: "CREIGHTONS CREEK", state: "VIC", postcode: "3666" },
{ city: "EUROA", state: "VIC", postcode: "3666" },
{ city: "GOORAM", state: "VIC", postcode: "3666" },
{ city: "KELVIN VIEW", state: "VIC", postcode: "3666" },
{ city: "KITHBROOK", state: "VIC", postcode: "3666" },
{ city: "LONGWOOD EAST", state: "VIC", postcode: "3666" },
{ city: "MIEPOLL", state: "VIC", postcode: "3666" },
{ city: "MOGLONEMBY", state: "VIC", postcode: "3666" },
{ city: "MOLKA", state: "VIC", postcode: "3666" },
{ city: "PRANJIP", state: "VIC", postcode: "3666" },
{ city: "RIGGS CREEK", state: "VIC", postcode: "3666" },
{ city: "RUFFY", state: "VIC", postcode: "3666" },
{ city: "SHEANS CREEK", state: "VIC", postcode: "3666" },
{ city: "STRATHBOGIE", state: "VIC", postcode: "3666" },
{ city: "TARCOMBE", state: "VIC", postcode: "3666" },
{ city: "BOHO", state: "VIC", postcode: "3669" },
{ city: "BOHO SOUTH", state: "VIC", postcode: "3669" },
{ city: "CREEK JUNCTION", state: "VIC", postcode: "3669" },
{ city: "EARLSTON", state: "VIC", postcode: "3669" },
{ city: "GOWANGARDIE", state: "VIC", postcode: "3669" },
{ city: "KOONDA", state: "VIC", postcode: "3669" },
{ city: "MARRAWEENEY", state: "VIC", postcode: "3669" },
{ city: "TAMLEUGH", state: "VIC", postcode: "3669" },
{ city: "TAMLEUGH NORTH", state: "VIC", postcode: "3669" },
{ city: "UPOTIPOTPON", state: "VIC", postcode: "3669" },
{ city: "VIOLET TOWN", state: "VIC", postcode: "3669" },
{ city: "BADDAGINNIE", state: "VIC", postcode: "3670" },
{ city: "TARNOOK", state: "VIC", postcode: "3670" },
{ city: "WARRENBAYNE", state: "VIC", postcode: "3670" },
{ city: "BROKEN CREEK", state: "VIC", postcode: "3673" },
{ city: "GOOMALIBEE", state: "VIC", postcode: "3673" },
{ city: "LIMA", state: "VIC", postcode: "3673" },
{ city: "LIMA EAST", state: "VIC", postcode: "3673" },
{ city: "LIMA SOUTH", state: "VIC", postcode: "3673" },
{ city: "LURG", state: "VIC", postcode: "3673" },
{ city: "MOLYULLAH", state: "VIC", postcode: "3673" },
{ city: "MOORNGAG", state: "VIC", postcode: "3673" },
{ city: "SAMARIA", state: "VIC", postcode: "3673" },
{ city: "SWANPOOL", state: "VIC", postcode: "3673" },
{ city: "TATONG", state: "VIC", postcode: "3673" },
{ city: "UPPER LURG", state: "VIC", postcode: "3673" },
{ city: "UPPER RYANS CREEK", state: "VIC", postcode: "3673" },
{ city: "WINTON", state: "VIC", postcode: "3673" },
{ city: "WINTON NORTH", state: "VIC", postcode: "3673" },
{ city: "BOWEYA", state: "VIC", postcode: "3675" },
{ city: "BOWEYA NORTH", state: "VIC", postcode: "3675" },
{ city: "GLENROWAN", state: "VIC", postcode: "3675" },
{ city: "GLENROWAN WEST", state: "VIC", postcode: "3675" },
{ city: "GRETA", state: "VIC", postcode: "3675" },
{ city: "GRETA SOUTH", state: "VIC", postcode: "3675" },
{ city: "GRETA WEST", state: "VIC", postcode: "3675" },
{ city: "HANSONVILLE", state: "VIC", postcode: "3675" },
{ city: "MOUNT BRUNO", state: "VIC", postcode: "3675" },
{ city: "TAMINICK", state: "VIC", postcode: "3675" },
{ city: "APPIN PARK", state: "VIC", postcode: "3677" },
{ city: "YARRUNGA", state: "VIC", postcode: "3677" },
{ city: "BOBINAWARRAH", state: "VIC", postcode: "3678" },
{ city: "BOORHAMAN", state: "VIC", postcode: "3678" },
{ city: "BOORHAMAN EAST", state: "VIC", postcode: "3678" },
{ city: "BOWSER", state: "VIC", postcode: "3678" },
{ city: "BYAWATHA", state: "VIC", postcode: "3678" },
{ city: "CARBOOR", state: "VIC", postcode: "3678" },
{ city: "CHESHUNT", state: "VIC", postcode: "3678" },
{ city: "CHESHUNT SOUTH", state: "VIC", postcode: "3678" },
{ city: "DOCKER", state: "VIC", postcode: "3678" },
{ city: "DOCKERS PLAINS", state: "VIC", postcode: "3678" },
{ city: "EDI", state: "VIC", postcode: "3678" },
{ city: "EDI UPPER", state: "VIC", postcode: "3678" },
{ city: "EVERTON", state: "VIC", postcode: "3678" },
{ city: "EVERTON UPPER", state: "VIC", postcode: "3678" },
{ city: "KILLAWARRA", state: "VIC", postcode: "3678" },
{ city: "KING VALLEY", state: "VIC", postcode: "3678" },
{ city: "LACEBY", state: "VIC", postcode: "3678" },
{ city: "LONDRIGAN", state: "VIC", postcode: "3678" },
{ city: "MARKWOOD", state: "VIC", postcode: "3678" },
{ city: "MEADOW CREEK", state: "VIC", postcode: "3678" },
{ city: "MILAWA", state: "VIC", postcode: "3678" },
{ city: "OXLEY", state: "VIC", postcode: "3678" },
{ city: "OXLEY FLATS", state: "VIC", postcode: "3678" },
{ city: "PEECHELBA", state: "VIC", postcode: "3678" },
{ city: "PEECHELBA EAST", state: "VIC", postcode: "3678" },
{ city: "ROSE RIVER", state: "VIC", postcode: "3678" },
{ city: "TARRAWINGEE", state: "VIC", postcode: "3678" },
{ city: "WABONGA", state: "VIC", postcode: "3678" },
{ city: "WALDARA", state: "VIC", postcode: "3678" },
{ city: "WANGANDARY", state: "VIC", postcode: "3678" },
{ city: "WHITLANDS", state: "VIC", postcode: "3678" },
{ city: "BORALMA", state: "VIC", postcode: "3682" },
{ city: "LILLIPUT", state: "VIC", postcode: "3682" },
{ city: "NORONG", state: "VIC", postcode: "3682" },
{ city: "SPRINGHURST", state: "VIC", postcode: "3682" },
{ city: "CHILTERN", state: "VIC", postcode: "3683" },
{ city: "CHILTERN VALLEY", state: "VIC", postcode: "3683" },
{ city: "CORNISHTOWN", state: "VIC", postcode: "3683" },
{ city: "BOORHAMAN NORTH", state: "VIC", postcode: "3685" },
{ city: "BRIMIN", state: "VIC", postcode: "3685" },
{ city: "BROWNS PLAINS", state: "VIC", postcode: "3685" },
{ city: "CARLYLE", state: "VIC", postcode: "3685" },
{ city: "GOORAMADDA", state: "VIC", postcode: "3685" },
{ city: "GREAT SOUTHERN", state: "VIC", postcode: "3685" },
{ city: "LAKE MOODEMERE", state: "VIC", postcode: "3685" },
{ city: "PRENTICE NORTH", state: "VIC", postcode: "3685" },
{ city: "RUTHERGLEN", state: "VIC", postcode: "3685" },
{ city: "WAHGUNYAH", state: "VIC", postcode: "3687" },
{ city: "BARNAWARTHA", state: "VIC", postcode: "3688" },
{ city: "INDIGO VALLEY", state: "VIC", postcode: "3688" },
{ city: "ALLANS FLAT", state: "VIC", postcode: "3691" },
{ city: "BANDIANA", state: "VIC", postcode: "3691" },
{ city: "BARANDUDA", state: "VIC", postcode: "3691" },
{ city: "BARNAWARTHA NORTH", state: "VIC", postcode: "3691" },
{ city: "BELLBRIDGE", state: "VIC", postcode: "3691" },
{ city: "BERRINGAMA", state: "VIC", postcode: "3691" },
{ city: "BETHANGA", state: "VIC", postcode: "3691" },
{ city: "BONEGILLA", state: "VIC", postcode: "3691" },
{ city: "BUNGIL", state: "VIC", postcode: "3691" },
{ city: "CASTLE CREEK", state: "VIC", postcode: "3691" },
{ city: "CORAL BANK", state: "VIC", postcode: "3691" },
{ city: "DEDERANG", state: "VIC", postcode: "3691" },
{ city: "EBDEN", state: "VIC", postcode: "3691" },
{ city: "GATEWAY ISLAND", state: "VIC", postcode: "3691" },
{ city: "GLEN CREEK", state: "VIC", postcode: "3691" },
{ city: "GUNDOWRING", state: "VIC", postcode: "3691" },
{ city: "HUON CREEK", state: "VIC", postcode: "3691" },
{ city: "KANCOONA", state: "VIC", postcode: "3691" },
{ city: "KERGUNYAH", state: "VIC", postcode: "3691" },
{ city: "KERGUNYAH SOUTH", state: "VIC", postcode: "3691" },
{ city: "KIEWA", state: "VIC", postcode: "3691" },
{ city: "KILLARA", state: "VIC", postcode: "3691" },
{ city: "LENEVA", state: "VIC", postcode: "3691" },
{ city: "LUCYVALE", state: "VIC", postcode: "3691" },
{ city: "MONGANS BRIDGE", state: "VIC", postcode: "3691" },
{ city: "OSBORNES FLAT", state: "VIC", postcode: "3691" },
{ city: "RUNNING CREEK", state: "VIC", postcode: "3691" },
{ city: "STAGHORN FLAT", state: "VIC", postcode: "3691" },
{ city: "TALGARNO", state: "VIC", postcode: "3691" },
{ city: "TANGAMBALANGA", state: "VIC", postcode: "3691" },
{ city: "THOLOGOLONG", state: "VIC", postcode: "3691" },
{ city: "UPPER GUNDOWRING", state: "VIC", postcode: "3691" },
{ city: "BANDIANA MILPO", state: "VIC", postcode: "3694" },
{ city: "CHARLEROI", state: "VIC", postcode: "3695" },
{ city: "HUON", state: "VIC", postcode: "3695" },
{ city: "SANDY CREEK", state: "VIC", postcode: "3695" },
{ city: "TAWONGA", state: "VIC", postcode: "3697" },
{ city: "TAWONGA SOUTH", state: "VIC", postcode: "3698" },
{ city: "BOGONG", state: "VIC", postcode: "3699" },
{ city: "FALLS CREEK", state: "VIC", postcode: "3699" },
{ city: "MOUNT BEAUTY", state: "VIC", postcode: "3699" },
{ city: "NELSE", state: "VIC", postcode: "3699" },
{ city: "BULLIOH", state: "VIC", postcode: "3700" },
{ city: "GEORGES CREEK", state: "VIC", postcode: "3700" },
{ city: "JARVIS CREEK", state: "VIC", postcode: "3700" },
{ city: "TALLANGATTA", state: "VIC", postcode: "3700" },
{ city: "TALLANGATTA EAST", state: "VIC", postcode: "3700" },
{ city: "DARTMOUTH", state: "VIC", postcode: "3701" },
{ city: "ESKDALE", state: "VIC", postcode: "3701" },
{ city: "GRANYA", state: "VIC", postcode: "3701" },
{ city: "MITTA MITTA", state: "VIC", postcode: "3701" },
{ city: "OLD TALLANGATTA", state: "VIC", postcode: "3701" },
{ city: "SHELLEY", state: "VIC", postcode: "3701" },
{ city: "TALLANDOON", state: "VIC", postcode: "3701" },
{ city: "TALLANGATTA SOUTH", state: "VIC", postcode: "3701" },
{ city: "TALLANGATTA VALLEY", state: "VIC", postcode: "3701" },
{ city: "KOETONG", state: "VIC", postcode: "3704" },
{ city: "CUDGEWA", state: "VIC", postcode: "3705" },
{ city: "BIGGARA", state: "VIC", postcode: "3707" },
{ city: "COLAC COLAC", state: "VIC", postcode: "3707" },
{ city: "CORRYONG", state: "VIC", postcode: "3707" },
{ city: "NARIEL VALLEY", state: "VIC", postcode: "3707" },
{ city: "THOWGLA VALLEY", state: "VIC", postcode: "3707" },
{ city: "TOM GROGGIN", state: "VIC", postcode: "3707" },
{ city: "TOWONG", state: "VIC", postcode: "3707" },
{ city: "TOWONG UPPER", state: "VIC", postcode: "3707" },
{ city: "TINTALDRA", state: "VIC", postcode: "3708" },
{ city: "BURROWYE", state: "VIC", postcode: "3709" },
{ city: "GUYS FOREST", state: "VIC", postcode: "3709" },
{ city: "MOUNT ALFRED", state: "VIC", postcode: "3709" },
{ city: "PINE MOUNTAIN", state: "VIC", postcode: "3709" },
{ city: "WALWA", state: "VIC", postcode: "3709" },
{ city: "BUXTON", state: "VIC", postcode: "3711" },
{ city: "RUBICON", state: "VIC", postcode: "3712" },
{ city: "THORNTON", state: "VIC", postcode: "3712" },
{ city: "EILDON", state: "VIC", postcode: "3713" },
{ city: "LAKE EILDON", state: "VIC", postcode: "3713" },
{ city: "TAYLOR BAY", state: "VIC", postcode: "3713" },
{ city: "ACHERON", state: "VIC", postcode: "3714" },
{ city: "ALEXANDRA", state: "VIC", postcode: "3714" },
{ city: "CATHKIN", state: "VIC", postcode: "3714" },
{ city: "CRYSTAL CREEK", state: "VIC", postcode: "3714" },
{ city: "DEVILS RIVER", state: "VIC", postcode: "3714" },
{ city: "FAWCETT", state: "VIC", postcode: "3714" },
{ city: "KORIELLA", state: "VIC", postcode: "3714" },
{ city: "MAINTONGOON", state: "VIC", postcode: "3714" },
{ city: "TAGGERTY", state: "VIC", postcode: "3714" },
{ city: "WHANREGARWEN", state: "VIC", postcode: "3714" },
{ city: "ANCONA", state: "VIC", postcode: "3715" },
{ city: "MERTON", state: "VIC", postcode: "3715" },
{ city: "WOODFIELD", state: "VIC", postcode: "3715" },
{ city: "FLOWERDALE", state: "VIC", postcode: "3717" },
{ city: "GHIN GHIN", state: "VIC", postcode: "3717" },
{ city: "GLENBURN", state: "VIC", postcode: "3717" },
{ city: "HOMEWOOD", state: "VIC", postcode: "3717" },
{ city: "KILLINGWORTH", state: "VIC", postcode: "3717" },
{ city: "LIMESTONE", state: "VIC", postcode: "3717" },
{ city: "MURRINDINDI", state: "VIC", postcode: "3717" },
{ city: "YEA", state: "VIC", postcode: "3717" },
{ city: "MOLESWORTH", state: "VIC", postcode: "3718" },
{ city: "GOBUR", state: "VIC", postcode: "3719" },
{ city: "KANUMBRA", state: "VIC", postcode: "3719" },
{ city: "TERIP TERIP", state: "VIC", postcode: "3719" },
{ city: "YARCK", state: "VIC", postcode: "3719" },
{ city: "BONNIE DOON", state: "VIC", postcode: "3720" },
{ city: "BARWITE", state: "VIC", postcode: "3722" },
{ city: "MANSFIELD", state: "VIC", postcode: "3722" },
{ city: "MIRIMBAH", state: "VIC", postcode: "3722" },
{ city: "ARCHERTON", state: "VIC", postcode: "3723" },
{ city: "BARJARG", state: "VIC", postcode: "3723" },
{ city: "BOOROLITE", state: "VIC", postcode: "3723" },
{ city: "BRIDGE CREEK", state: "VIC", postcode: "3723" },
{ city: "DELATITE", state: "VIC", postcode: "3723" },
{ city: "ENOCHS POINT", state: "VIC", postcode: "3723" },
{ city: "GAFFNEYS CREEK", state: "VIC", postcode: "3723" },
{ city: "GOUGHS BAY", state: "VIC", postcode: "3723" },
{ city: "HOWES CREEK", state: "VIC", postcode: "3723" },
{ city: "HOWQUA", state: "VIC", postcode: "3723" },
{ city: "HOWQUA HILLS", state: "VIC", postcode: "3723" },
{ city: "HOWQUA INLET", state: "VIC", postcode: "3723" },
{ city: "JAMIESON", state: "VIC", postcode: "3723" },
{ city: "KEVINGTON", state: "VIC", postcode: "3723" },
{ city: "KNOCKWOOD", state: "VIC", postcode: "3723" },
{ city: "MACS COVE", state: "VIC", postcode: "3723" },
{ city: "MAINDAMPLE", state: "VIC", postcode: "3723" },
{ city: "MATLOCK", state: "VIC", postcode: "3723" },
{ city: "MERRIJIG", state: "VIC", postcode: "3723" },
{ city: "MOUNTAIN BAY", state: "VIC", postcode: "3723" },
{ city: "MOUNT BULLER", state: "VIC", postcode: "3723" },
{ city: "PIRIES", state: "VIC", postcode: "3723" },
{ city: "SAWMILL SETTLEMENT", state: "VIC", postcode: "3723" },
{ city: "TOLMIE", state: "VIC", postcode: "3723" },
{ city: "WOODS POINT", state: "VIC", postcode: "3723" },
{ city: "BOXWOOD", state: "VIC", postcode: "3725" },
{ city: "CHESNEY VALE", state: "VIC", postcode: "3725" },
{ city: "GOORAMBAT", state: "VIC", postcode: "3725" },
{ city: "MAJOR PLAINS", state: "VIC", postcode: "3725" },
{ city: "STEWARTON", state: "VIC", postcode: "3725" },
{ city: "BUNGEET", state: "VIC", postcode: "3726" },
{ city: "BUNGEET WEST", state: "VIC", postcode: "3726" },
{ city: "DEVENISH", state: "VIC", postcode: "3726" },
{ city: "THOONA", state: "VIC", postcode: "3726" },
{ city: "ALMONDS", state: "VIC", postcode: "3727" },
{ city: "LAKE ROWAN", state: "VIC", postcode: "3727" },
{ city: "PELLUEBLA", state: "VIC", postcode: "3727" },
{ city: "ST JAMES", state: "VIC", postcode: "3727" },
{ city: "YUNDOOL", state: "VIC", postcode: "3727" },
{ city: "BOOMAHNOOMOONAH", state: "VIC", postcode: "3728" },
{ city: "TUNGAMAH", state: "VIC", postcode: "3728" },
{ city: "WILBY", state: "VIC", postcode: "3728" },
{ city: "YOUARANG", state: "VIC", postcode: "3728" },
{ city: "BATHUMI", state: "VIC", postcode: "3730" },
{ city: "BOOSEY", state: "VIC", postcode: "3730" },
{ city: "BUNDALONG", state: "VIC", postcode: "3730" },
{ city: "BUNDALONG SOUTH", state: "VIC", postcode: "3730" },
{ city: "BURRAMINE", state: "VIC", postcode: "3730" },
{ city: "BURRAMINE SOUTH", state: "VIC", postcode: "3730" },
{ city: "ESMOND", state: "VIC", postcode: "3730" },
{ city: "TELFORD", state: "VIC", postcode: "3730" },
{ city: "YARRAWONGA", state: "VIC", postcode: "3730" },
{ city: "YARRAWONGA SOUTH", state: "VIC", postcode: "3730" },
{ city: "MOYHU", state: "VIC", postcode: "3732" },
{ city: "MYRRHEE", state: "VIC", postcode: "3732" },
{ city: "WHITFIELD", state: "VIC", postcode: "3733" },
{ city: "BOWMANS FOREST", state: "VIC", postcode: "3735" },
{ city: "WHOROULY", state: "VIC", postcode: "3735" },
{ city: "WHOROULY EAST", state: "VIC", postcode: "3735" },
{ city: "WHOROULY SOUTH", state: "VIC", postcode: "3735" },
{ city: "ABBEYARD", state: "VIC", postcode: "3737" },
{ city: "BARWIDGEE", state: "VIC", postcode: "3737" },
{ city: "BUFFALO RIVER", state: "VIC", postcode: "3737" },
{ city: "DANDONGADALE", state: "VIC", postcode: "3737" },
{ city: "GAPSTED", state: "VIC", postcode: "3737" },
{ city: "HAVILAH", state: "VIC", postcode: "3737" },
{ city: "MERRIANG", state: "VIC", postcode: "3737" },
{ city: "MERRIANG SOUTH", state: "VIC", postcode: "3737" },
{ city: "MUDGEGONGA", state: "VIC", postcode: "3737" },
{ city: "MYRTLEFORD", state: "VIC", postcode: "3737" },
{ city: "NUG NUG", state: "VIC", postcode: "3737" },
{ city: "ROSEWHITE", state: "VIC", postcode: "3737" },
{ city: "SELWYN", state: "VIC", postcode: "3737" },
{ city: "WONNANGATTA", state: "VIC", postcode: "3737" },
{ city: "OVENS", state: "VIC", postcode: "3738" },
{ city: "EUROBIN", state: "VIC", postcode: "3739" },
{ city: "BUCKLAND", state: "VIC", postcode: "3740" },
{ city: "MOUNT BUFFALO", state: "VIC", postcode: "3740" },
{ city: "POREPUNKAH", state: "VIC", postcode: "3740" },
{ city: "BRIGHT", state: "VIC", postcode: "3741" },
{ city: "FREEBURGH", state: "VIC", postcode: "3741" },
{ city: "GERMANTOWN", state: "VIC", postcode: "3741" },
{ city: "HARRIETVILLE", state: "VIC", postcode: "3741" },
{ city: "HOTHAM HEIGHTS", state: "VIC", postcode: "3741" },
{ city: "MOUNT HOTHAM", state: "VIC", postcode: "3741" },
{ city: "SMOKO", state: "VIC", postcode: "3741" },
{ city: "WANDILIGONG", state: "VIC", postcode: "3744" },
{ city: "ELDORADO", state: "VIC", postcode: "3746" },
{ city: "BEECHWORTH", state: "VIC", postcode: "3747" },
{ city: "MURMUNGEE", state: "VIC", postcode: "3747" },
{ city: "STANLEY", state: "VIC", postcode: "3747" },
{ city: "WOOLSHED", state: "VIC", postcode: "3747" },
{ city: "WOORAGEE", state: "VIC", postcode: "3747" },
{ city: "BRUARONG", state: "VIC", postcode: "3749" },
{ city: "YACKANDANDAH", state: "VIC", postcode: "3749" },
{ city: "WOLLERT", state: "VIC", postcode: "3750" },
{ city: "WOODSTOCK", state: "VIC", postcode: "3751" },
{ city: "BEVERIDGE", state: "VIC", postcode: "3753" },
{ city: "DOREEN", state: "VIC", postcode: "3754" },
{ city: "MERNDA", state: "VIC", postcode: "3754" },
{ city: "YAN YEAN", state: "VIC", postcode: "3755" },
{ city: "CHINTIN", state: "VIC", postcode: "3756" },
{ city: "DARRAWEIT GUIM", state: "VIC", postcode: "3756" },
{ city: "HIDDEN VALLEY", state: "VIC", postcode: "3756" },
{ city: "UPPER PLENTY", state: "VIC", postcode: "3756" },
{ city: "BRUCES CREEK", state: "VIC", postcode: "3757" },
{ city: "EDEN PARK", state: "VIC", postcode: "3757" },
{ city: "HUMEVALE", state: "VIC", postcode: "3757" },
{ city: "KINGLAKE CENTRAL", state: "VIC", postcode: "3757" },
{ city: "KINGLAKE WEST", state: "VIC", postcode: "3757" },
{ city: "PHEASANT CREEK", state: "VIC", postcode: "3757" },
{ city: "HEATHCOTE JUNCTION", state: "VIC", postcode: "3758" },
{ city: "WANDONG", state: "VIC", postcode: "3758" },
{ city: "PANTON HILL", state: "VIC", postcode: "3759" },
{ city: "SMITHS GULLY", state: "VIC", postcode: "3760" },
{ city: "ST ANDREWS", state: "VIC", postcode: "3761" },
{ city: "BYLANDS", state: "VIC", postcode: "3762" },
{ city: "KINGLAKE", state: "VIC", postcode: "3763" },
{ city: "MOUNT SLIDE", state: "VIC", postcode: "3763" },
{ city: "FORBES", state: "VIC", postcode: "3764" },
{ city: "GLENAROUA", state: "VIC", postcode: "3764" },
{ city: "HIGH CAMP", state: "VIC", postcode: "3764" },
{ city: "MORANDING", state: "VIC", postcode: "3764" },
{ city: "TANTARABOO", state: "VIC", postcode: "3764" },
{ city: "WILLOWMAVIN", state: "VIC", postcode: "3764" },
{ city: "MONTROSE", state: "VIC", postcode: "3765" },
{ city: "KALORAMA", state: "VIC", postcode: "3766" },
{ city: "MOUNT DANDENONG", state: "VIC", postcode: "3767" },
{ city: "COLDSTREAM", state: "VIC", postcode: "3770" },
{ city: "GRUYERE", state: "VIC", postcode: "3770" },
{ city: "YERING", state: "VIC", postcode: "3770" },
{ city: "CHRISTMAS HILLS", state: "VIC", postcode: "3775" },
{ city: "DIXONS CREEK", state: "VIC", postcode: "3775" },
{ city: "STEELS CREEK", state: "VIC", postcode: "3775" },
{ city: "TARRAWARRA", state: "VIC", postcode: "3775" },
{ city: "YARRA GLEN", state: "VIC", postcode: "3775" },
{ city: "BADGER CREEK", state: "VIC", postcode: "3777" },
{ city: "CASTELLA", state: "VIC", postcode: "3777" },
{ city: "CHUM CREEK", state: "VIC", postcode: "3777" },
{ city: "HEALESVILLE", state: "VIC", postcode: "3777" },
{ city: "HEALESVILLE MAIN STREET", state: "VIC", postcode: "3777" },
{ city: "HEALESVILLE POST SHOP", state: "VIC", postcode: "3777" },
{ city: "MOUNT TOOLEBEWONG", state: "VIC", postcode: "3777" },
{ city: "TOOLANGI", state: "VIC", postcode: "3777" },
{ city: "FERNSHAW", state: "VIC", postcode: "3778" },
{ city: "NARBETHONG", state: "VIC", postcode: "3778" },
{ city: "CAMBARVILLE", state: "VIC", postcode: "3779" },
{ city: "MARYSVILLE", state: "VIC", postcode: "3779" },
{ city: "COCKATOO", state: "VIC", postcode: "3781" },
{ city: "MOUNT BURNETT", state: "VIC", postcode: "3781" },
{ city: "NANGANA", state: "VIC", postcode: "3781" },
{ city: "AVONSLEIGH", state: "VIC", postcode: "3782" },
{ city: "CLEMATIS", state: "VIC", postcode: "3782" },
{ city: "EMERALD", state: "VIC", postcode: "3782" },
{ city: "MACCLESFIELD", state: "VIC", postcode: "3782" },
{ city: "GEMBROOK", state: "VIC", postcode: "3783" },
{ city: "TREMONT", state: "VIC", postcode: "3785" },
{ city: "FERNY CREEK", state: "VIC", postcode: "3786" },
{ city: "SASSAFRAS", state: "VIC", postcode: "3787" },
{ city: "SASSAFRAS GULLY", state: "VIC", postcode: "3787" },
{ city: "OLINDA", state: "VIC", postcode: "3788" },
{ city: "SHERBROOKE", state: "VIC", postcode: "3789" },
{ city: "KALLISTA", state: "VIC", postcode: "3791" },
{ city: "THE PATCH", state: "VIC", postcode: "3792" },
{ city: "MONBULK", state: "VIC", postcode: "3793" },
{ city: "SILVAN", state: "VIC", postcode: "3795" },
{ city: "MOUNT EVELYN", state: "VIC", postcode: "3796" },
{ city: "GILDEROY", state: "VIC", postcode: "3797" },
{ city: "GLADYSDALE", state: "VIC", postcode: "3797" },
{ city: "POWELLTOWN", state: "VIC", postcode: "3797" },
{ city: "THREE BRIDGES", state: "VIC", postcode: "3797" },
{ city: "YARRA JUNCTION", state: "VIC", postcode: "3797" },
{ city: "BIG PATS CREEK", state: "VIC", postcode: "3799" },
{ city: "EAST WARBURTON", state: "VIC", postcode: "3799" },
{ city: "MCMAHONS CREEK", state: "VIC", postcode: "3799" },
{ city: "MILLGROVE", state: "VIC", postcode: "3799" },
{ city: "REEFTON", state: "VIC", postcode: "3799" },
{ city: "WARBURTON", state: "VIC", postcode: "3799" },
{ city: "WESBURN", state: "VIC", postcode: "3799" },
{ city: "HARKAWAY", state: "VIC", postcode: "3806" },
{ city: "GUYS HILL", state: "VIC", postcode: "3807" },
{ city: "BEACONSFIELD UPPER", state: "VIC", postcode: "3808" },
{ city: "DEWHURST", state: "VIC", postcode: "3808" },
{ city: "OFFICER", state: "VIC", postcode: "3809" },
{ city: "OFFICER SOUTH", state: "VIC", postcode: "3809" },
{ city: "RYTHDALE", state: "VIC", postcode: "3810" },
{ city: "MARYKNOLL", state: "VIC", postcode: "3812" },
{ city: "NAR NAR GOON", state: "VIC", postcode: "3812" },
{ city: "NAR NAR GOON NORTH", state: "VIC", postcode: "3812" },
{ city: "TYNONG", state: "VIC", postcode: "3813" },
{ city: "TYNONG NORTH", state: "VIC", postcode: "3813" },
{ city: "CORA LYNN", state: "VIC", postcode: "3814" },
{ city: "GARFIELD", state: "VIC", postcode: "3814" },
{ city: "GARFIELD NORTH", state: "VIC", postcode: "3814" },
{ city: "VERVALE", state: "VIC", postcode: "3814" },
{ city: "BUNYIP", state: "VIC", postcode: "3815" },
{ city: "BUNYIP NORTH", state: "VIC", postcode: "3815" },
{ city: "IONA", state: "VIC", postcode: "3815" },
{ city: "TONIMBUK", state: "VIC", postcode: "3815" },
{ city: "LABERTOUCHE", state: "VIC", postcode: "3816" },
{ city: "LONGWARRY", state: "VIC", postcode: "3816" },
{ city: "LONGWARRY NORTH", state: "VIC", postcode: "3816" },
{ city: "MODELLA", state: "VIC", postcode: "3816" },
{ city: "ATHLONE", state: "VIC", postcode: "3818" },
{ city: "DROUIN", state: "VIC", postcode: "3818" },
{ city: "DROUIN EAST", state: "VIC", postcode: "3818" },
{ city: "DROUIN SOUTH", state: "VIC", postcode: "3818" },
{ city: "DROUIN WEST", state: "VIC", postcode: "3818" },
{ city: "HALLORA", state: "VIC", postcode: "3818" },
{ city: "JINDIVICK", state: "VIC", postcode: "3818" },
{ city: "RIPPLEBROOK", state: "VIC", postcode: "3818" },
{ city: "BONA VISTA", state: "VIC", postcode: "3820" },
{ city: "LILLICO", state: "VIC", postcode: "3820" },
{ city: "BRANDY CREEK", state: "VIC", postcode: "3821" },
{ city: "BRAVINGTON", state: "VIC", postcode: "3821" },
{ city: "BULN BULN", state: "VIC", postcode: "3821" },
{ city: "BULN BULN EAST", state: "VIC", postcode: "3821" },
{ city: "CROSSOVER", state: "VIC", postcode: "3821" },
{ city: "ELLINBANK", state: "VIC", postcode: "3821" },
{ city: "FERNDALE", state: "VIC", postcode: "3821" },
{ city: "LARDNER", state: "VIC", postcode: "3821" },
{ city: "NILMA", state: "VIC", postcode: "3821" },
{ city: "NILMA NORTH", state: "VIC", postcode: "3821" },
{ city: "ROKEBY", state: "VIC", postcode: "3821" },
{ city: "SEAVIEW", state: "VIC", postcode: "3821" },
{ city: "SHADY CREEK", state: "VIC", postcode: "3821" },
{ city: "TETOORA ROAD", state: "VIC", postcode: "3821" },
{ city: "TORWOOD", state: "VIC", postcode: "3821" },
{ city: "CLOVERLEA", state: "VIC", postcode: "3822" },
{ city: "DARNUM", state: "VIC", postcode: "3822" },
{ city: "GAINSBOROUGH", state: "VIC", postcode: "3822" },
{ city: "ALLAMBEE", state: "VIC", postcode: "3823" },
{ city: "YARRAGON", state: "VIC", postcode: "3823" },
{ city: "YARRAGON SOUTH", state: "VIC", postcode: "3823" },
{ city: "CHILDERS", state: "VIC", postcode: "3824" },
{ city: "NARRACAN", state: "VIC", postcode: "3824" },
{ city: "THORPDALE SOUTH", state: "VIC", postcode: "3824" },
{ city: "ABERFELDY", state: "VIC", postcode: "3825" },
{ city: "AMOR", state: "VIC", postcode: "3825" },
{ city: "BOOLA", state: "VIC", postcode: "3825" },
{ city: "CARINGAL", state: "VIC", postcode: "3825" },
{ city: "COALVILLE", state: "VIC", postcode: "3825" },
{ city: "COOPERS CREEK", state: "VIC", postcode: "3825" },
{ city: "ERICA", state: "VIC", postcode: "3825" },
{ city: "FUMINA", state: "VIC", postcode: "3825" },
{ city: "FUMINA SOUTH", state: "VIC", postcode: "3825" },
{ city: "HERNES OAK", state: "VIC", postcode: "3825" },
{ city: "HILL END", state: "VIC", postcode: "3825" },
{ city: "JACOB CREEK", state: "VIC", postcode: "3825" },
{ city: "JERICHO", state: "VIC", postcode: "3825" },
{ city: "MOONDARRA", state: "VIC", postcode: "3825" },
{ city: "NEWBOROUGH", state: "VIC", postcode: "3825" },
{ city: "NEWBOROUGH EAST", state: "VIC", postcode: "3825" },
{ city: "RAWSON", state: "VIC", postcode: "3825" },
{ city: "TANJIL", state: "VIC", postcode: "3825" },
{ city: "TANJIL SOUTH", state: "VIC", postcode: "3825" },
{ city: "THALLOO", state: "VIC", postcode: "3825" },
{ city: "THOMSON", state: "VIC", postcode: "3825" },
{ city: "TOOMBON", state: "VIC", postcode: "3825" },
{ city: "WALHALLA", state: "VIC", postcode: "3825" },
{ city: "WALHALLA EAST", state: "VIC", postcode: "3825" },
{ city: "WESTBURY", state: "VIC", postcode: "3825" },
{ city: "WILLOW GROVE", state: "VIC", postcode: "3825" },
{ city: "YALLOURN", state: "VIC", postcode: "3825" },
{ city: "YALLOURN NORTH", state: "VIC", postcode: "3825" },
{ city: "NEERIM", state: "VIC", postcode: "3831" },
{ city: "NEERIM EAST", state: "VIC", postcode: "3831" },
{ city: "NEERIM SOUTH", state: "VIC", postcode: "3831" },
{ city: "NAYOOK", state: "VIC", postcode: "3832" },
{ city: "NEERIM JUNCTION", state: "VIC", postcode: "3832" },
{ city: "NEERIM NORTH", state: "VIC", postcode: "3832" },
{ city: "ADA", state: "VIC", postcode: "3833" },
{ city: "BAW BAW", state: "VIC", postcode: "3833" },
{ city: "BAW BAW VILLAGE", state: "VIC", postcode: "3833" },
{ city: "GENTLE ANNIE", state: "VIC", postcode: "3833" },
{ city: "ICY CREEK", state: "VIC", postcode: "3833" },
{ city: "LOCH VALLEY", state: "VIC", postcode: "3833" },
{ city: "NOOJEE", state: "VIC", postcode: "3833" },
{ city: "PIEDMONT", state: "VIC", postcode: "3833" },
{ city: "TANJIL BREN", state: "VIC", postcode: "3833" },
{ city: "TOORONGO", state: "VIC", postcode: "3833" },
{ city: "VESPER", state: "VIC", postcode: "3833" },
{ city: "THORPDALE", state: "VIC", postcode: "3835" },
{ city: "DRIFFIELD", state: "VIC", postcode: "3840" },
{ city: "HAZELWOOD", state: "VIC", postcode: "3840" },
{ city: "HAZELWOOD NORTH", state: "VIC", postcode: "3840" },
{ city: "HAZELWOOD SOUTH", state: "VIC", postcode: "3840" },
{ city: "JEERALANG", state: "VIC", postcode: "3840" },
{ city: "JEERALANG JUNCTION", state: "VIC", postcode: "3840" },
{ city: "MARYVALE", state: "VIC", postcode: "3840" },
{ city: "MID VALLEY", state: "VIC", postcode: "3840" },
{ city: "CHURCHILL", state: "VIC", postcode: "3842" },
{ city: "BLACKWARRY", state: "VIC", postcode: "3844" },
{ city: "CALLIGNEE", state: "VIC", postcode: "3844" },
{ city: "CALLIGNEE NORTH", state: "VIC", postcode: "3844" },
{ city: "CALLIGNEE SOUTH", state: "VIC", postcode: "3844" },
{ city: "CARRAJUNG", state: "VIC", postcode: "3844" },
{ city: "CARRAJUNG LOWER", state: "VIC", postcode: "3844" },
{ city: "CARRAJUNG SOUTH", state: "VIC", postcode: "3844" },
{ city: "FLYNN", state: "VIC", postcode: "3844" },
{ city: "FLYNNS CREEK", state: "VIC", postcode: "3844" },
{ city: "KOORNALLA", state: "VIC", postcode: "3844" },
{ city: "LOY YANG", state: "VIC", postcode: "3844" },
{ city: "MOUNT TASSIE", state: "VIC", postcode: "3844" },
{ city: "TYERS", state: "VIC", postcode: "3844" },
{ city: "HIAMDALE", state: "VIC", postcode: "3847" },
{ city: "NAMBROK", state: "VIC", postcode: "3847" },
{ city: "ROSEDALE", state: "VIC", postcode: "3847" },
{ city: "WILLUNG", state: "VIC", postcode: "3847" },
{ city: "WILLUNG SOUTH", state: "VIC", postcode: "3847" },
{ city: "SALE", state: "VIC", postcode: "3850" },
{ city: "SALE NORTH", state: "VIC", postcode: "3850" },
{ city: "WURRUK", state: "VIC", postcode: "3850" },
{ city: "AIRLY", state: "VIC", postcode: "3851" },
{ city: "BUNDALAGUAH", state: "VIC", postcode: "3851" },
{ city: "CLYDEBANK", state: "VIC", postcode: "3851" },
{ city: "COBAINS", state: "VIC", postcode: "3851" },
{ city: "DARRIMAN", state: "VIC", postcode: "3851" },
{ city: "DUTSON", state: "VIC", postcode: "3851" },
{ city: "DUTSON DOWNS", state: "VIC", postcode: "3851" },
{ city: "FLAMINGO BEACH", state: "VIC", postcode: "3851" },
{ city: "FULHAM", state: "VIC", postcode: "3851" },
{ city: "GIFFARD", state: "VIC", postcode: "3851" },
{ city: "GIFFARD WEST", state: "VIC", postcode: "3851" },
{ city: "GLOMAR BEACH", state: "VIC", postcode: "3851" },
{ city: "GOLDEN BEACH", state: "VIC", postcode: "3851" },
{ city: "KILMANY", state: "VIC", postcode: "3851" },
{ city: "LAKE WELLINGTON", state: "VIC", postcode: "3851" },
{ city: "LOCH SPORT", state: "VIC", postcode: "3851" },
{ city: "LONGFORD", state: "VIC", postcode: "3851" },
{ city: "MONTGOMERY", state: "VIC", postcode: "3851" },
{ city: "MYRTLEBANK", state: "VIC", postcode: "3851" },
{ city: "PARADISE BEACH", state: "VIC", postcode: "3851" },
{ city: "PEARSONDALE", state: "VIC", postcode: "3851" },
{ city: "SEACOMBE", state: "VIC", postcode: "3851" },
{ city: "SEASPRAY", state: "VIC", postcode: "3851" },
{ city: "SOMERTON PARK", state: "VIC", postcode: "3851" },
{ city: "STRADBROKE", state: "VIC", postcode: "3851" },
{ city: "THE HEART", state: "VIC", postcode: "3851" },
{ city: "THE HONEYSUCKLES", state: "VIC", postcode: "3851" },
{ city: "EAST SALE", state: "VIC", postcode: "3852" },
{ city: "SALE EAST RAAF", state: "VIC", postcode: "3852" },
{ city: "GLENGARRY", state: "VIC", postcode: "3854" },
{ city: "GLENGARRY NORTH", state: "VIC", postcode: "3854" },
{ city: "GLENGARRY WEST", state: "VIC", postcode: "3854" },
{ city: "TOONGABBIE", state: "VIC", postcode: "3856" },
{ city: "COWWARR", state: "VIC", postcode: "3857" },
{ city: "ARBUCKLE", state: "VIC", postcode: "3858" },
{ city: "BILLABONG", state: "VIC", postcode: "3858" },
{ city: "BURAGWONDUC", state: "VIC", postcode: "3858" },
{ city: "CROOKAYAN", state: "VIC", postcode: "3858" },
{ city: "DAWSON", state: "VIC", postcode: "3858" },
{ city: "DENISON", state: "VIC", postcode: "3858" },
{ city: "GILLUM", state: "VIC", postcode: "3858" },
{ city: "GLENFALLOCH", state: "VIC", postcode: "3858" },
{ city: "GLENMAGGIE", state: "VIC", postcode: "3858" },
{ city: "HEYFIELD", state: "VIC", postcode: "3858" },
{ city: "HOWITT PLAINS", state: "VIC", postcode: "3858" },
{ city: "LICOLA", state: "VIC", postcode: "3858" },
{ city: "LICOLA NORTH", state: "VIC", postcode: "3858" },
{ city: "REYNARD", state: "VIC", postcode: "3858" },
{ city: "SARGOOD", state: "VIC", postcode: "3858" },
{ city: "SEATON", state: "VIC", postcode: "3858" },
{ city: "TAMBORITHA", state: "VIC", postcode: "3858" },
{ city: "WINNINDOO", state: "VIC", postcode: "3858" },
{ city: "WORROWING", state: "VIC", postcode: "3858" },
{ city: "YANGOURA", state: "VIC", postcode: "3858" },
{ city: "MAFFRA WEST UPPER", state: "VIC", postcode: "3859" },
{ city: "NEWRY", state: "VIC", postcode: "3859" },
{ city: "TINAMBA", state: "VIC", postcode: "3859" },
{ city: "TINAMBA WEST", state: "VIC", postcode: "3859" },
{ city: "BOISDALE", state: "VIC", postcode: "3860" },
{ city: "BRIAGOLONG", state: "VIC", postcode: "3860" },
{ city: "BUSHY PARK", state: "VIC", postcode: "3860" },
{ city: "COONGULLA", state: "VIC", postcode: "3860" },
{ city: "KOOROOL", state: "VIC", postcode: "3860" },
{ city: "MAFFRA", state: "VIC", postcode: "3860" },
{ city: "MONOMAK", state: "VIC", postcode: "3860" },
{ city: "MOROKA", state: "VIC", postcode: "3860" },
{ city: "NAP NAP MARRA", state: "VIC", postcode: "3860" },
{ city: "RIVERSLEA", state: "VIC", postcode: "3860" },
{ city: "TOOLOME", state: "VIC", postcode: "3860" },
{ city: "VALENCIA CREEK", state: "VIC", postcode: "3860" },
{ city: "WOOLENOOK", state: "VIC", postcode: "3860" },
{ city: "WRATHUNG", state: "VIC", postcode: "3860" },
{ city: "WRIXON", state: "VIC", postcode: "3860" },
{ city: "BUDGEE BUDGEE", state: "VIC", postcode: "3862" },
{ city: "COBBANNAH", state: "VIC", postcode: "3862" },
{ city: "COWA", state: "VIC", postcode: "3862" },
{ city: "CROOKED RIVER", state: "VIC", postcode: "3862" },
{ city: "DARGO", state: "VIC", postcode: "3862" },
{ city: "HAWKHURST", state: "VIC", postcode: "3862" },
{ city: "HOLLANDS LANDING", state: "VIC", postcode: "3862" },
{ city: "LLOWALONG", state: "VIC", postcode: "3862" },
{ city: "MEERLIEU", state: "VIC", postcode: "3862" },
{ city: "MIOWERA", state: "VIC", postcode: "3862" },
{ city: "MOORNAPA", state: "VIC", postcode: "3862" },
{ city: "MUNRO", state: "VIC", postcode: "3862" },
{ city: "PERRY BRIDGE", state: "VIC", postcode: "3862" },
{ city: "STOCKDALE", state: "VIC", postcode: "3862" },
{ city: "STRATFORD", state: "VIC", postcode: "3862" },
{ city: "WATERFORD", state: "VIC", postcode: "3862" },
{ city: "WONGUNGARRA", state: "VIC", postcode: "3862" },
{ city: "FERNBANK", state: "VIC", postcode: "3864" },
{ city: "GLENALADALE", state: "VIC", postcode: "3864" },
{ city: "THE FINGERBOARD", state: "VIC", postcode: "3864" },
{ city: "LINDENOW", state: "VIC", postcode: "3865" },
{ city: "JUMBUK", state: "VIC", postcode: "3869" },
{ city: "YINNAR", state: "VIC", postcode: "3869" },
{ city: "YINNAR SOUTH", state: "VIC", postcode: "3869" },
{ city: "BOOLARRA", state: "VIC", postcode: "3870" },
{ city: "BOOLARRA SOUTH", state: "VIC", postcode: "3870" },
{ city: "BUDGEREE", state: "VIC", postcode: "3870" },
{ city: "BUDGEREE EAST", state: "VIC", postcode: "3870" },
{ city: "GRAND RIDGE", state: "VIC", postcode: "3870" },
{ city: "JOHNSTONES HILL", state: "VIC", postcode: "3870" },
{ city: "ALLAMBEE RESERVE", state: "VIC", postcode: "3871" },
{ city: "ALLAMBEE SOUTH", state: "VIC", postcode: "3871" },
{ city: "BAROMI", state: "VIC", postcode: "3871" },
{ city: "DARLIMURLA", state: "VIC", postcode: "3871" },
{ city: "DELBURN", state: "VIC", postcode: "3871" },
{ city: "DOLLAR", state: "VIC", postcode: "3871" },
{ city: "MIRBOO", state: "VIC", postcode: "3871" },
{ city: "MIRBOO NORTH", state: "VIC", postcode: "3871" },
{ city: "GORMANDALE", state: "VIC", postcode: "3873" },
{ city: "CHERRILONG", state: "VIC", postcode: "3874" },
{ city: "MCLOUGHLINS BEACH", state: "VIC", postcode: "3874" },
{ city: "WOODSIDE", state: "VIC", postcode: "3874" },
{ city: "WOODSIDE BEACH", state: "VIC", postcode: "3874" },
{ city: "WOODSIDE NORTH", state: "VIC", postcode: "3874" },
{ city: "BAIRNSDALE", state: "VIC", postcode: "3875" },
{ city: "BANKSIA PENINSULA", state: "VIC", postcode: "3875" },
{ city: "BENGWORDEN", state: "VIC", postcode: "3875" },
{ city: "BROADLANDS", state: "VIC", postcode: "3875" },
{ city: "BULLUMWAAL", state: "VIC", postcode: "3875" },
{ city: "CALULU", state: "VIC", postcode: "3875" },
{ city: "CLIFTON CREEK", state: "VIC", postcode: "3875" },
{ city: "DEPTFORD", state: "VIC", postcode: "3875" },
{ city: "EAST BAIRNSDALE", state: "VIC", postcode: "3875" },
{ city: "EASTWOOD", state: "VIC", postcode: "3875" },
{ city: "ELLASWOOD", state: "VIC", postcode: "3875" },
{ city: "FAIRY DELL", state: "VIC", postcode: "3875" },
{ city: "FLAGGY CREEK", state: "VIC", postcode: "3875" },
{ city: "FORGE CREEK", state: "VIC", postcode: "3875" },
{ city: "GOON NURE", state: "VIC", postcode: "3875" },
{ city: "GRANITE ROCK", state: "VIC", postcode: "3875" },
{ city: "HILLSIDE", state: "VIC", postcode: "3875" },
{ city: "IGUANA CREEK", state: "VIC", postcode: "3875" },
{ city: "LINDENOW SOUTH", state: "VIC", postcode: "3875" },
{ city: "LUCKNOW", state: "VIC", postcode: "3875" },
{ city: "MARTHAVALE", state: "VIC", postcode: "3875" },
{ city: "MELWOOD", state: "VIC", postcode: "3875" },
{ city: "MERRIJIG", state: "VIC", postcode: "3875" },
{ city: "MOUNT TAYLOR", state: "VIC", postcode: "3875" },
{ city: "NEWLANDS ARM", state: "VIC", postcode: "3875" },
{ city: "RYANS", state: "VIC", postcode: "3875" },
{ city: "SARSFIELD", state: "VIC", postcode: "3875" },
{ city: "TABBERABBERA", state: "VIC", postcode: "3875" },
{ city: "WALPA", state: "VIC", postcode: "3875" },
{ city: "WATERHOLES", state: "VIC", postcode: "3875" },
{ city: "WENTWORTH", state: "VIC", postcode: "3875" },
{ city: "WOODGLEN", state: "VIC", postcode: "3875" },
{ city: "WUK WUK", state: "VIC", postcode: "3875" },
{ city: "WY YUNG", state: "VIC", postcode: "3875" },
{ city: "EAGLE POINT", state: "VIC", postcode: "3878" },
{ city: "BOOLE POOLE", state: "VIC", postcode: "3880" },
{ city: "OCEAN GRANGE", state: "VIC", postcode: "3880" },
{ city: "PAYNESVILLE", state: "VIC", postcode: "3880" },
{ city: "RAYMOND ISLAND", state: "VIC", postcode: "3880" },
{ city: "NICHOLSON", state: "VIC", postcode: "3882" },
{ city: "BRUMBY", state: "VIC", postcode: "3885" },
{ city: "BRUTHEN", state: "VIC", postcode: "3885" },
{ city: "BUCHAN", state: "VIC", postcode: "3885" },
{ city: "BUCHAN SOUTH", state: "VIC", postcode: "3885" },
{ city: "BUTCHERS RIDGE", state: "VIC", postcode: "3885" },
{ city: "GELANTIPY", state: "VIC", postcode: "3885" },
{ city: "MOSSIFACE", state: "VIC", postcode: "3885" },
{ city: "MURRINDAL", state: "VIC", postcode: "3885" },
{ city: "SUGGAN BUGGAN", state: "VIC", postcode: "3885" },
{ city: "TAMBO UPPER", state: "VIC", postcode: "3885" },
{ city: "TIMBARRA", state: "VIC", postcode: "3885" },
{ city: "WISELEIGH", state: "VIC", postcode: "3885" },
{ city: "W TREE", state: "VIC", postcode: "3885" },
{ city: "WULGULMERANG", state: "VIC", postcode: "3885" },
{ city: "WULGULMERANG EAST", state: "VIC", postcode: "3885" },
{ city: "WULGULMERANG WEST", state: "VIC", postcode: "3885" },
{ city: "YALMY", state: "VIC", postcode: "3885" },
{ city: "NEWMERELLA", state: "VIC", postcode: "3886" },
{ city: "LAKE TYERS", state: "VIC", postcode: "3887" },
{ city: "NOWA NOWA", state: "VIC", postcode: "3887" },
{ city: "WAIREWA", state: "VIC", postcode: "3887" },
{ city: "BENDOC", state: "VIC", postcode: "3888" },
{ city: "BETE BOLONG", state: "VIC", postcode: "3888" },
{ city: "BETE BOLONG NORTH", state: "VIC", postcode: "3888" },
{ city: "BONANG", state: "VIC", postcode: "3888" },
{ city: "BRODRIBB RIVER", state: "VIC", postcode: "3888" },
{ city: "CABANANDRA", state: "VIC", postcode: "3888" },
{ city: "CAPE CONRAN", state: "VIC", postcode: "3888" },
{ city: "CORRINGLE", state: "VIC", postcode: "3888" },
{ city: "DEDDICK VALLEY", state: "VIC", postcode: "3888" },
{ city: "DELEGATE RIVER", state: "VIC", postcode: "3888" },
{ city: "GOONGERAH", state: "VIC", postcode: "3888" },
{ city: "HAYDENS BOG", state: "VIC", postcode: "3888" },
{ city: "JARRAHMOND", state: "VIC", postcode: "3888" },
{ city: "MARLO", state: "VIC", postcode: "3888" },
{ city: "MARTINS CREEK", state: "VIC", postcode: "3888" },
{ city: "NURRAN", state: "VIC", postcode: "3888" },
{ city: "ORBOST", state: "VIC", postcode: "3888" },
{ city: "SIMPSONS CREEK", state: "VIC", postcode: "3888" },
{ city: "TOSTAREE", state: "VIC", postcode: "3888" },
{ city: "TUBBUT", state: "VIC", postcode: "3888" },
{ city: "WAYGARA", state: "VIC", postcode: "3888" },
{ city: "WOMBAT CREEK", state: "VIC", postcode: "3888" },
{ city: "BELLBIRD CREEK", state: "VIC", postcode: "3889" },
{ city: "BEMM RIVER", state: "VIC", postcode: "3889" },
{ city: "CABBAGE TREE CREEK", state: "VIC", postcode: "3889" },
{ city: "CLUB TERRACE", state: "VIC", postcode: "3889" },
{ city: "COMBIENBAR", state: "VIC", postcode: "3889" },
{ city: "ERRINUNDRA", state: "VIC", postcode: "3889" },
{ city: "MANORINA", state: "VIC", postcode: "3889" },
{ city: "BULDAH", state: "VIC", postcode: "3890" },
{ city: "CANN RIVER", state: "VIC", postcode: "3890" },
{ city: "CHANDLERS CREEK", state: "VIC", postcode: "3890" },
{ city: "NOORINBEE", state: "VIC", postcode: "3890" },
{ city: "NOORINBEE NORTH", state: "VIC", postcode: "3890" },
{ city: "TAMBOON", state: "VIC", postcode: "3890" },
{ city: "TONGHI CREEK", state: "VIC", postcode: "3890" },
{ city: "GENOA", state: "VIC", postcode: "3891" },
{ city: "GIPSY POINT", state: "VIC", postcode: "3891" },
{ city: "MARAMINGO CREEK", state: "VIC", postcode: "3891" },
{ city: "WALLAGARAUGH", state: "VIC", postcode: "3891" },
{ city: "WANGARABELL", state: "VIC", postcode: "3891" },
{ city: "WINGAN RIVER", state: "VIC", postcode: "3891" },
{ city: "WROXHAM", state: "VIC", postcode: "3891" },
{ city: "MALLACOOTA", state: "VIC", postcode: "3892" },
{ city: "DOUBLE BRIDGES", state: "VIC", postcode: "3893" },
{ city: "STIRLING", state: "VIC", postcode: "3893" },
{ city: "TAMBO CROSSING", state: "VIC", postcode: "3893" },
{ city: "DOCTORS FLAT", state: "VIC", postcode: "3895" },
{ city: "ENSAY", state: "VIC", postcode: "3895" },
{ city: "ENSAY NORTH", state: "VIC", postcode: "3895" },
{ city: "REEDY CREEK", state: "VIC", postcode: "3895" },
{ city: "REEDY FLAT", state: "VIC", postcode: "3895" },
{ city: "BINDI", state: "VIC", postcode: "3896" },
{ city: "BROOKVILLE", state: "VIC", postcode: "3896" },
{ city: "NUNNIONG", state: "VIC", postcode: "3896" },
{ city: "SWIFTS CREEK", state: "VIC", postcode: "3896" },
{ city: "TONGIO", state: "VIC", postcode: "3896" },
{ city: "ANGLERS REST", state: "VIC", postcode: "3898" },
{ city: "BINGO", state: "VIC", postcode: "3898" },
{ city: "BINGO MUNJIE", state: "VIC", postcode: "3898" },
{ city: "BUNDARA", state: "VIC", postcode: "3898" },
{ city: "CASSILIS", state: "VIC", postcode: "3898" },
{ city: "COBUNGRA", state: "VIC", postcode: "3898" },
{ city: "DINNER PLAIN", state: "VIC", postcode: "3898" },
{ city: "GLEN VALLEY", state: "VIC", postcode: "3898" },
{ city: "GLEN WILLS", state: "VIC", postcode: "3898" },
{ city: "HINNOMUNJIE", state: "VIC", postcode: "3898" },
{ city: "OMEO", state: "VIC", postcode: "3898" },
{ city: "OMEO VALLEY", state: "VIC", postcode: "3898" },
{ city: "SHANNONVALE", state: "VIC", postcode: "3898" },
{ city: "BENAMBRA", state: "VIC", postcode: "3900" },
{ city: "COBBERAS", state: "VIC", postcode: "3900" },
{ city: "BUMBERRAH", state: "VIC", postcode: "3902" },
{ city: "JOHNSONVILLE", state: "VIC", postcode: "3902" },
{ city: "SWAN REACH", state: "VIC", postcode: "3903" },
{ city: "METUNG", state: "VIC", postcode: "3904" },
{ city: "KALIMNA", state: "VIC", postcode: "3909" },
{ city: "KALIMNA WEST", state: "VIC", postcode: "3909" },
{ city: "LAKE BUNGA", state: "VIC", postcode: "3909" },
{ city: "LAKES ENTRANCE", state: "VIC", postcode: "3909" },
{ city: "LAKE TYERS BEACH", state: "VIC", postcode: "3909" },
{ city: "NUNGURNER", state: "VIC", postcode: "3909" },
{ city: "NYERIMILANG", state: "VIC", postcode: "3909" },
{ city: "TOORLOO ARM", state: "VIC", postcode: "3909" },
{ city: "TUERONG", state: "VIC", postcode: "3915" },
{ city: "POINT LEO", state: "VIC", postcode: "3916" },
{ city: "ELIZABETH ISLAND", state: "VIC", postcode: "3921" },
{ city: "FRENCH ISLAND", state: "VIC", postcode: "3921" },
{ city: "COWES", state: "VIC", postcode: "3922" },
{ city: "SILVERLEAVES", state: "VIC", postcode: "3922" },
{ city: "SMITHS BEACH", state: "VIC", postcode: "3922" },
{ city: "SUMMERLANDS", state: "VIC", postcode: "3922" },
{ city: "SUNDERLAND BAY", state: "VIC", postcode: "3922" },
{ city: "SUNSET STRIP", state: "VIC", postcode: "3922" },
{ city: "SURF BEACH", state: "VIC", postcode: "3922" },
{ city: "VENTNOR", state: "VIC", postcode: "3922" },
{ city: "WIMBLEDON HEIGHTS", state: "VIC", postcode: "3922" },
{ city: "RHYLL", state: "VIC", postcode: "3923" },
{ city: "CAPE WOOLAMAI", state: "VIC", postcode: "3925" },
{ city: "CHURCHILL ISLAND", state: "VIC", postcode: "3925" },
{ city: "NEWHAVEN", state: "VIC", postcode: "3925" },
{ city: "SAN REMO", state: "VIC", postcode: "3925" },
{ city: "KUNYUNG", state: "VIC", postcode: "3930" },
{ city: "MOUNT MARTHA", state: "VIC", postcode: "3934" },
{ city: "ARTHURS SEAT", state: "VIC", postcode: "3936" },
{ city: "BONEO", state: "VIC", postcode: "3939" },
{ city: "FINGAL", state: "VIC", postcode: "3939" },
{ city: "TOOTGAROOK", state: "VIC", postcode: "3941" },
{ city: "BLAIRGOWRIE", state: "VIC", postcode: "3942" },
{ city: "BELLVIEW", state: "VIC", postcode: "3945" },
{ city: "JEETHO", state: "VIC", postcode: "3945" },
{ city: "KROWERA", state: "VIC", postcode: "3945" },
{ city: "LOCH", state: "VIC", postcode: "3945" },
{ city: "WOODLEIGH", state: "VIC", postcode: "3945" },
{ city: "BENA", state: "VIC", postcode: "3946" },
{ city: "KARDELLA SOUTH", state: "VIC", postcode: "3950" },
{ city: "KORUMBURRA", state: "VIC", postcode: "3950" },
{ city: "KORUMBURRA SOUTH", state: "VIC", postcode: "3950" },
{ city: "STRZELECKI", state: "VIC", postcode: "3950" },
{ city: "WHITELAW", state: "VIC", postcode: "3950" },
{ city: "ARAWATA", state: "VIC", postcode: "3951" },
{ city: "FAIRBANK", state: "VIC", postcode: "3951" },
{ city: "JUMBUNNA", state: "VIC", postcode: "3951" },
{ city: "KARDELLA", state: "VIC", postcode: "3951" },
{ city: "KONGWAK", state: "VIC", postcode: "3951" },
{ city: "MOYARRA", state: "VIC", postcode: "3951" },
{ city: "OUTTRIM", state: "VIC", postcode: "3951" },
{ city: "RANCEBY", state: "VIC", postcode: "3951" },
{ city: "BERRYS CREEK", state: "VIC", postcode: "3953" },
{ city: "BOOROOL", state: "VIC", postcode: "3953" },
{ city: "HALLSTON", state: "VIC", postcode: "3953" },
{ city: "KOOROOMAN", state: "VIC", postcode: "3953" },
{ city: "LEONGATHA", state: "VIC", postcode: "3953" },
{ city: "LEONGATHA NORTH", state: "VIC", postcode: "3953" },
{ city: "LEONGATHA SOUTH", state: "VIC", postcode: "3953" },
{ city: "MARDAN", state: "VIC", postcode: "3953" },
{ city: "MOUNT ECCLES", state: "VIC", postcode: "3953" },
{ city: "MOUNT ECCLES SOUTH", state: "VIC", postcode: "3953" },
{ city: "NERRENA", state: "VIC", postcode: "3953" },
{ city: "RUBY", state: "VIC", postcode: "3953" },
{ city: "TRIDA", state: "VIC", postcode: "3953" },
{ city: "WILD DOG VALLEY", state: "VIC", postcode: "3953" },
{ city: "WOOREEN", state: "VIC", postcode: "3953" },
{ city: "KOONWARRA", state: "VIC", postcode: "3954" },
{ city: "DUMBALK", state: "VIC", postcode: "3956" },
{ city: "DUMBALK NORTH", state: "VIC", postcode: "3956" },
{ city: "MEENIYAN", state: "VIC", postcode: "3956" },
{ city: "MIDDLE TARWIN", state: "VIC", postcode: "3956" },
{ city: "TARWIN", state: "VIC", postcode: "3956" },
{ city: "TARWIN LOWER", state: "VIC", postcode: "3956" },
{ city: "VENUS BAY", state: "VIC", postcode: "3956" },
{ city: "WALKERVILLE", state: "VIC", postcode: "3956" },
{ city: "WALKERVILLE NORTH", state: "VIC", postcode: "3956" },
{ city: "WALKERVILLE SOUTH", state: "VIC", postcode: "3956" },
{ city: "STONY CREEK", state: "VIC", postcode: "3957" },
{ city: "BUFFALO", state: "VIC", postcode: "3958" },
{ city: "FISH CREEK", state: "VIC", postcode: "3959" },
{ city: "SANDY POINT", state: "VIC", postcode: "3959" },
{ city: "WARATAH BAY", state: "VIC", postcode: "3959" },
{ city: "BENNISON", state: "VIC", postcode: "3960" },
{ city: "BOOLARONG", state: "VIC", postcode: "3960" },
{ city: "FOSTER", state: "VIC", postcode: "3960" },
{ city: "FOSTER NORTH", state: "VIC", postcode: "3960" },
{ city: "GUNYAH", state: "VIC", postcode: "3960" },
{ city: "MOUNT BEST", state: "VIC", postcode: "3960" },
{ city: "SHALLOW INLET", state: "VIC", postcode: "3960" },
{ city: "TIDAL RIVER", state: "VIC", postcode: "3960" },
{ city: "TURTONS CREEK", state: "VIC", postcode: "3960" },
{ city: "WILSONS PROMONTORY", state: "VIC", postcode: "3960" },
{ city: "WONGA", state: "VIC", postcode: "3960" },
{ city: "WOORARRA WEST", state: "VIC", postcode: "3960" },
{ city: "YANAKIE", state: "VIC", postcode: "3960" },
{ city: "AGNES", state: "VIC", postcode: "3962" },
{ city: "CHRISTIES", state: "VIC", postcode: "3962" },
{ city: "TOORA", state: "VIC", postcode: "3962" },
{ city: "TOORA NORTH", state: "VIC", postcode: "3962" },
{ city: "WONYIP", state: "VIC", postcode: "3962" },
{ city: "WOORARRA EAST", state: "VIC", postcode: "3962" },
{ city: "PORT FRANKLIN", state: "VIC", postcode: "3964" },
{ city: "PORT WELSHPOOL", state: "VIC", postcode: "3965" },
{ city: "BINGINWARRI", state: "VIC", postcode: "3966" },
{ city: "HAZEL PARK", state: "VIC", postcode: "3966" },
{ city: "WELSHPOOL", state: "VIC", postcode: "3966" },
{ city: "HEDLEY", state: "VIC", postcode: "3967" },
{ city: "ALBERTON", state: "VIC", postcode: "3971" },
{ city: "ALBERTON WEST", state: "VIC", postcode: "3971" },
{ city: "BALOOK", state: "VIC", postcode: "3971" },
{ city: "CALROSSIE", state: "VIC", postcode: "3971" },
{ city: "DEVON NORTH", state: "VIC", postcode: "3971" },
{ city: "GELLIONDALE", state: "VIC", postcode: "3971" },
{ city: "HIAWATHA", state: "VIC", postcode: "3971" },
{ city: "HUNTERSTON", state: "VIC", postcode: "3971" },
{ city: "JACK RIVER", state: "VIC", postcode: "3971" },
{ city: "LANGSBOROUGH", state: "VIC", postcode: "3971" },
{ city: "MACKS CREEK", state: "VIC", postcode: "3971" },
{ city: "MADALYA", state: "VIC", postcode: "3971" },
{ city: "MANNS BEACH", state: "VIC", postcode: "3971" },
{ city: "PORT ALBERT", state: "VIC", postcode: "3971" },
{ city: "ROBERTSONS BEACH", state: "VIC", postcode: "3971" },
{ city: "SNAKE ISLAND", state: "VIC", postcode: "3971" },
{ city: "STACEYS BRIDGE", state: "VIC", postcode: "3971" },
{ city: "TARRA VALLEY", state: "VIC", postcode: "3971" },
{ city: "TARRAVILLE", state: "VIC", postcode: "3971" },
{ city: "WON WRON", state: "VIC", postcode: "3971" },
{ city: "YARRAM", state: "VIC", postcode: "3971" },
{ city: "ALMURTA", state: "VIC", postcode: "3979" },
{ city: "GLEN ALVIE", state: "VIC", postcode: "3979" },
{ city: "KERNOT", state: "VIC", postcode: "3979" },
{ city: "BLIND BIGHT", state: "VIC", postcode: "3980" },
{ city: "TOORADIN", state: "VIC", postcode: "3980" },
{ city: "WARNEET", state: "VIC", postcode: "3980" },
{ city: "BAYLES", state: "VIC", postcode: "3981" },
{ city: "CATANI", state: "VIC", postcode: "3981" },
{ city: "DALMORE", state: "VIC", postcode: "3981" },
{ city: "HEATH HILL", state: "VIC", postcode: "3981" },
{ city: "KOO WEE RUP", state: "VIC", postcode: "3981" },
{ city: "KOO WEE RUP NORTH", state: "VIC", postcode: "3981" },
{ city: "YANNATHAN", state: "VIC", postcode: "3981" },
{ city: "ADAMS ESTATE", state: "VIC", postcode: "3984" },
{ city: "CALDERMEADE", state: "VIC", postcode: "3984" },
{ city: "CORINELLA", state: "VIC", postcode: "3984" },
{ city: "CORONET BAY", state: "VIC", postcode: "3984" },
{ city: "GRANTVILLE", state: "VIC", postcode: "3984" },
{ city: "JAM JERRUP", state: "VIC", postcode: "3984" },
{ city: "LANG LANG", state: "VIC", postcode: "3984" },
{ city: "LANG LANG EAST", state: "VIC", postcode: "3984" },
{ city: "MONOMEITH", state: "VIC", postcode: "3984" },
{ city: "PIONEER BAY", state: "VIC", postcode: "3984" },
{ city: "QUEENSFERRY", state: "VIC", postcode: "3984" },
{ city: "TENBY POINT", state: "VIC", postcode: "3984" },
{ city: "THE GURDIES", state: "VIC", postcode: "3984" },
{ city: "NYORA", state: "VIC", postcode: "3987" },
{ city: "MOUNTAIN VIEW", state: "VIC", postcode: "3988" },
{ city: "POOWONG", state: "VIC", postcode: "3988" },
{ city: "POOWONG EAST", state: "VIC", postcode: "3988" },
{ city: "POOWONG NORTH", state: "VIC", postcode: "3988" },
{ city: "GLEN FORBES", state: "VIC", postcode: "3990" },
{ city: "BASS", state: "VIC", postcode: "3991" },
{ city: "BLACKWOOD FOREST", state: "VIC", postcode: "3992" },
{ city: "DALYSTON", state: "VIC", postcode: "3992" },
{ city: "RYANSTON", state: "VIC", postcode: "3992" },
{ city: "WEST CREEK", state: "VIC", postcode: "3992" },
{ city: "ANDERSON", state: "VIC", postcode: "3995" },
{ city: "ARCHIES CREEK", state: "VIC", postcode: "3995" },
{ city: "CAPE PATERSON", state: "VIC", postcode: "3995" },
{ city: "HARMERS HAVEN", state: "VIC", postcode: "3995" },
{ city: "KILCUNDA", state: "VIC", postcode: "3995" },
{ city: "LANCE CREEK", state: "VIC", postcode: "3995" },
{ city: "NORTH WONTHAGGI", state: "VIC", postcode: "3995" },
{ city: "SOUTH DUDLEY", state: "VIC", postcode: "3995" },
{ city: "ST CLAIR", state: "VIC", postcode: "3995" },
{ city: "WATTLE BANK", state: "VIC", postcode: "3995" },
{ city: "WONTHAGGI", state: "VIC", postcode: "3995" },
{ city: "WOOLAMAI", state: "VIC", postcode: "3995" },
{ city: "INVERLOCH", state: "VIC", postcode: "3996" },
{ city: "POUND CREEK", state: "VIC", postcode: "3996" },
{ city: "GIBSON DESERT NORTH", state: "WA", postcode: "872" },
{ city: "GIBSON DESERT SOUTH", state: "WA", postcode: "872" },
{ city: "NGAANYATJARRA-GILES", state: "WA", postcode: "872" },
{ city: "WANNAN", state: "WA", postcode: "872" },
{ city: "YANCHEP", state: "WA", postcode: "6035" },
{ city: "TWO ROCKS", state: "WA", postcode: "6037" },
{ city: "CARABAN", state: "WA", postcode: "6041" },
{ city: "GABBADAH", state: "WA", postcode: "6041" },
{ city: "GUILDERTON", state: "WA", postcode: "6041" },
{ city: "WILBINGA", state: "WA", postcode: "6041" },
{ city: "WOODRIDGE", state: "WA", postcode: "6041" },
{ city: "SEABIRD", state: "WA", postcode: "6042" },
{ city: "BRETON BAY", state: "WA", postcode: "6043" },
{ city: "LEDGE POINT", state: "WA", postcode: "6043" },
{ city: "KARAKIN", state: "WA", postcode: "6044" },
{ city: "LANCELIN", state: "WA", postcode: "6044" },
{ city: "NILGEN", state: "WA", postcode: "6044" },
{ city: "WEDGE ISLAND", state: "WA", postcode: "6044" },
{ city: "AVON VALLEY NATIONAL PARK", state: "WA", postcode: "6084" },
{ city: "BULLSBROOK", state: "WA", postcode: "6084" },
{ city: "CHITTERING", state: "WA", postcode: "6084" },
{ city: "LOWER CHITTERING", state: "WA", postcode: "6084" },
{ city: "WALYUNGA NATIONAL PARK", state: "WA", postcode: "6084" },
{ city: "MUNDIJONG", state: "WA", postcode: "6123" },
{ city: "WHITBY", state: "WA", postcode: "6123" },
{ city: "JARRAHDALE", state: "WA", postcode: "6124" },
{ city: "ROTTNEST ISLAND", state: "WA", postcode: "6161" },
{ city: "SECRET HARBOUR", state: "WA", postcode: "6173" },
{ city: "GOLDEN BAY", state: "WA", postcode: "6174" },
{ city: "SINGLETON", state: "WA", postcode: "6175" },
{ city: "KARNUP", state: "WA", postcode: "6176" },
{ city: "PARKLANDS", state: "WA", postcode: "6180" },
{ city: "STAKE HILL", state: "WA", postcode: "6181" },
{ city: "MYARA", state: "WA", postcode: "6207" },
{ city: "NAMBEELUP", state: "WA", postcode: "6207" },
{ city: "NORTH DANDALUP", state: "WA", postcode: "6207" },
{ city: "SOLUS", state: "WA", postcode: "6207" },
{ city: "WHITTAKER", state: "WA", postcode: "6207" },
{ city: "BLYTHEWOOD", state: "WA", postcode: "6208" },
{ city: "FAIRBRIDGE", state: "WA", postcode: "6208" },
{ city: "MEELON", state: "WA", postcode: "6208" },
{ city: "NIRIMBA", state: "WA", postcode: "6208" },
{ city: "NORTH YUNDERUP", state: "WA", postcode: "6208" },
{ city: "OAKLEY", state: "WA", postcode: "6208" },
{ city: "PINJARRA", state: "WA", postcode: "6208" },
{ city: "POINT GREY", state: "WA", postcode: "6208" },
{ city: "RAVENSWOOD", state: "WA", postcode: "6208" },
{ city: "SOUTH YUNDERUP", state: "WA", postcode: "6208" },
{ city: "WEST PINJARRA", state: "WA", postcode: "6208" },
{ city: "BARRAGUP", state: "WA", postcode: "6209" },
{ city: "FURNISSDALE", state: "WA", postcode: "6209" },
{ city: "COODANUP", state: "WA", postcode: "6210" },
{ city: "DUDLEY PARK", state: "WA", postcode: "6210" },
{ city: "ERSKINE", state: "WA", postcode: "6210" },
{ city: "FALCON", state: "WA", postcode: "6210" },
{ city: "GREENFIELDS", state: "WA", postcode: "6210" },
{ city: "HALLS HEAD", state: "WA", postcode: "6210" },
{ city: "MADORA BAY", state: "WA", postcode: "6210" },
{ city: "MANDURAH", state: "WA", postcode: "6210" },
{ city: "MANDURAH DC", state: "WA", postcode: "6210" },
{ city: "MANDURAH EAST", state: "WA", postcode: "6210" },
{ city: "MANDURAH NORTH", state: "WA", postcode: "6210" },
{ city: "MEADOW SPRINGS", state: "WA", postcode: "6210" },
{ city: "SAN REMO", state: "WA", postcode: "6210" },
{ city: "SILVER SANDS", state: "WA", postcode: "6210" },
{ city: "WANNANUP", state: "WA", postcode: "6210" },
{ city: "BOUVARD", state: "WA", postcode: "6211" },
{ city: "CLIFTON", state: "WA", postcode: "6211" },
{ city: "DAWESVILLE", state: "WA", postcode: "6211" },
{ city: "HERRON", state: "WA", postcode: "6211" },
{ city: "BANKSIADALE", state: "WA", postcode: "6213" },
{ city: "DWELLINGUP", state: "WA", postcode: "6213" },
{ city: "ETMILYN", state: "WA", postcode: "6213" },
{ city: "HOLYOAKE", state: "WA", postcode: "6213" },
{ city: "INGLEHOPE", state: "WA", postcode: "6213" },
{ city: "MARRINUP", state: "WA", postcode: "6213" },
{ city: "TEESDALE", state: "WA", postcode: "6213" },
{ city: "BIRCHMONT", state: "WA", postcode: "6214" },
{ city: "COOLUP", state: "WA", postcode: "6214" },
{ city: "WEST COOLUP", state: "WA", postcode: "6214" },
{ city: "HAMEL", state: "WA", postcode: "6215" },
{ city: "LAKE CLIFTON", state: "WA", postcode: "6215" },
{ city: "NANGA BROOK", state: "WA", postcode: "6215" },
{ city: "PRESTON BEACH", state: "WA", postcode: "6215" },
{ city: "WAGERUP", state: "WA", postcode: "6215" },
{ city: "WAROONA", state: "WA", postcode: "6215" },
{ city: "YARLOOP", state: "WA", postcode: "6218" },
{ city: "COOKERNUP", state: "WA", postcode: "6220" },
{ city: "HARVEY", state: "WA", postcode: "6220" },
{ city: "HOFFMAN", state: "WA", postcode: "6220" },
{ city: "MYALUP", state: "WA", postcode: "6220" },
{ city: "UDUC", state: "WA", postcode: "6220" },
{ city: "WARAWARRUP", state: "WA", postcode: "6220" },
{ city: "MORNINGTON", state: "WA", postcode: "6221" },
{ city: "WOKALUP", state: "WA", postcode: "6221" },
{ city: "BENGER", state: "WA", postcode: "6223" },
{ city: "BEELA", state: "WA", postcode: "6224" },
{ city: "BRUNSWICK", state: "WA", postcode: "6224" },
{ city: "ALLANSON", state: "WA", postcode: "6225" },
{ city: "BOWELLING", state: "WA", postcode: "6225" },
{ city: "BUCKINGHAM", state: "WA", postcode: "6225" },
{ city: "CARDIFF", state: "WA", postcode: "6225" },
{ city: "COLLIE", state: "WA", postcode: "6225" },
{ city: "COLLIE BURN", state: "WA", postcode: "6225" },
{ city: "HARRIS RIVER", state: "WA", postcode: "6225" },
{ city: "LYALLS MILL", state: "WA", postcode: "6225" },
{ city: "MCALINDEN", state: "WA", postcode: "6225" },
{ city: "MUJA", state: "WA", postcode: "6225" },
{ city: "MUMBALLUP", state: "WA", postcode: "6225" },
{ city: "MUNGALUP", state: "WA", postcode: "6225" },
{ city: "NOGGERUP", state: "WA", postcode: "6225" },
{ city: "PALMER", state: "WA", postcode: "6225" },
{ city: "PRESTON SETTLEMENT", state: "WA", postcode: "6225" },
{ city: "SHOTTS", state: "WA", postcode: "6225" },
{ city: "WORSLEY", state: "WA", postcode: "6225" },
{ city: "YOURDAMUNG LAKE", state: "WA", postcode: "6225" },
{ city: "ROELANDS", state: "WA", postcode: "6226" },
{ city: "BUREKUP", state: "WA", postcode: "6227" },
{ city: "WATERLOO", state: "WA", postcode: "6228" },
{ city: "PICTON", state: "WA", postcode: "6229" },
{ city: "PICTON EAST", state: "WA", postcode: "6229" },
{ city: "CAREY PARK", state: "WA", postcode: "6230" },
{ city: "COLLEGE GROVE", state: "WA", postcode: "6230" },
{ city: "DALYELLUP", state: "WA", postcode: "6230" },
{ city: "DAVENPORT", state: "WA", postcode: "6230" },
{ city: "GELORUP", state: "WA", postcode: "6230" },
{ city: "GLEN IRIS", state: "WA", postcode: "6230" },
{ city: "PELICAN POINT", state: "WA", postcode: "6230" },
{ city: "USHER", state: "WA", postcode: "6230" },
{ city: "VITTORIA", state: "WA", postcode: "6230" },
{ city: "WITHERS", state: "WA", postcode: "6230" },
{ city: "EATON", state: "WA", postcode: "6232" },
{ city: "MILLBRIDGE", state: "WA", postcode: "6232" },
{ city: "BINNINGUP", state: "WA", postcode: "6233" },
{ city: "LESCHENAULT", state: "WA", postcode: "6233" },
{ city: "PARKFIELD", state: "WA", postcode: "6233" },
{ city: "WELLESLEY", state: "WA", postcode: "6233" },
{ city: "CROOKED BROOK", state: "WA", postcode: "6236" },
{ city: "DARDANUP", state: "WA", postcode: "6236" },
{ city: "DARDANUP WEST", state: "WA", postcode: "6236" },
{ city: "FERGUSON", state: "WA", postcode: "6236" },
{ city: "HENTY", state: "WA", postcode: "6236" },
{ city: "PARADISE", state: "WA", postcode: "6236" },
{ city: "WELLINGTON FOREST", state: "WA", postcode: "6236" },
{ city: "WELLINGTON MILL", state: "WA", postcode: "6236" },
{ city: "BOYANUP", state: "WA", postcode: "6237" },
{ city: "ELGIN", state: "WA", postcode: "6237" },
{ city: "GWINDINUP", state: "WA", postcode: "6237" },
{ city: "NORTH BOYANUP", state: "WA", postcode: "6237" },
{ city: "STRATHAM", state: "WA", postcode: "6237" },
{ city: "THE PLAINS", state: "WA", postcode: "6237" },
{ city: "ARGYLE", state: "WA", postcode: "6239" },
{ city: "BEELERUP", state: "WA", postcode: "6239" },
{ city: "BROOKHAMPTON", state: "WA", postcode: "6239" },
{ city: "CHARLEY CREEK", state: "WA", postcode: "6239" },
{ city: "DONNYBROOK", state: "WA", postcode: "6239" },
{ city: "GLEN MERVYN", state: "WA", postcode: "6239" },
{ city: "PAYNEDALE", state: "WA", postcode: "6239" },
{ city: "QUEENWOOD", state: "WA", postcode: "6239" },
{ city: "THOMSON BROOK", state: "WA", postcode: "6239" },
{ city: "UPPER CAPEL", state: "WA", postcode: "6239" },
{ city: "YABBERUP", state: "WA", postcode: "6239" },
{ city: "LOWDEN", state: "WA", postcode: "6240" },
{ city: "WILGA", state: "WA", postcode: "6243" },
{ city: "WILGA WEST", state: "WA", postcode: "6243" },
{ city: "BOYUP BROOK", state: "WA", postcode: "6244" },
{ city: "CHOWERUP", state: "WA", postcode: "6244" },
{ city: "DINNINUP", state: "WA", postcode: "6244" },
{ city: "KULIKUP", state: "WA", postcode: "6244" },
{ city: "MAYANUP", state: "WA", postcode: "6244" },
{ city: "SCOTTS BROOK", state: "WA", postcode: "6244" },
{ city: "TONEBRIDGE", state: "WA", postcode: "6244" },
{ city: "TRIGWELL", state: "WA", postcode: "6244" },
{ city: "BRAZIER", state: "WA", postcode: "6251" },
{ city: "KIRUP", state: "WA", postcode: "6251" },
{ city: "NEWLANDS", state: "WA", postcode: "6251" },
{ city: "MULLALYUP", state: "WA", postcode: "6252" },
{ city: "BALINGUP", state: "WA", postcode: "6253" },
{ city: "GRIMWADE", state: "WA", postcode: "6253" },
{ city: "SOUTHAMPTON", state: "WA", postcode: "6253" },
{ city: "GREENBUSHES", state: "WA", postcode: "6254" },
{ city: "NORTH GREENBUSHES", state: "WA", postcode: "6254" },
{ city: "BENJINUP", state: "WA", postcode: "6255" },
{ city: "BRIDGETOWN", state: "WA", postcode: "6255" },
{ city: "CATTERICK", state: "WA", postcode: "6255" },
{ city: "HESTER", state: "WA", postcode: "6255" },
{ city: "HESTER BROOK", state: "WA", postcode: "6255" },
{ city: "KANGAROO GULLY", state: "WA", postcode: "6255" },
{ city: "WINNEJUP", state: "WA", postcode: "6255" },
{ city: "GLENLYNN", state: "WA", postcode: "6256" },
{ city: "KINGSTON", state: "WA", postcode: "6256" },
{ city: "MARANUP", state: "WA", postcode: "6256" },
{ city: "SUNNYSIDE", state: "WA", postcode: "6256" },
{ city: "WANDILLUP", state: "WA", postcode: "6256" },
{ city: "YORNUP", state: "WA", postcode: "6256" },
{ city: "BALBARRUP", state: "WA", postcode: "6258" },
{ city: "CROWEA", state: "WA", postcode: "6258" },
{ city: "DEANMILL", state: "WA", postcode: "6258" },
{ city: "DIAMOND TREE", state: "WA", postcode: "6258" },
{ city: "DINGUP", state: "WA", postcode: "6258" },
{ city: "DIXVALE", state: "WA", postcode: "6258" },
{ city: "DONNELLY RIVER", state: "WA", postcode: "6258" },
{ city: "GLENORAN", state: "WA", postcode: "6258" },
{ city: "JARDEE", state: "WA", postcode: "6258" },
{ city: "LAKE MUIR", state: "WA", postcode: "6258" },
{ city: "LINFARNE", state: "WA", postcode: "6258" },
{ city: "MANJIMUP", state: "WA", postcode: "6258" },
{ city: "MIDDLESEX", state: "WA", postcode: "6258" },
{ city: "MORDALUP", state: "WA", postcode: "6258" },
{ city: "PALGARUP", state: "WA", postcode: "6258" },
{ city: "PERUP", state: "WA", postcode: "6258" },
{ city: "QUINNINUP", state: "WA", postcode: "6258" },
{ city: "RINGBARK", state: "WA", postcode: "6258" },
{ city: "SMITH BROOK", state: "WA", postcode: "6258" },
{ city: "UPPER WARREN", state: "WA", postcode: "6258" },
{ city: "WILGARRUP", state: "WA", postcode: "6258" },
{ city: "YANMAH", state: "WA", postcode: "6258" },
{ city: "BEEDELUP", state: "WA", postcode: "6260" },
{ city: "BIDDELIA", state: "WA", postcode: "6260" },
{ city: "CALLCUP", state: "WA", postcode: "6260" },
{ city: "CHANNYBEARUP", state: "WA", postcode: "6260" },
{ city: "COLLINS", state: "WA", postcode: "6260" },
{ city: "EASTBROOK", state: "WA", postcode: "6260" },
{ city: "LAKE JASPER", state: "WA", postcode: "6260" },
{ city: "PEERABEELUP", state: "WA", postcode: "6260" },
{ city: "PEMBERTON", state: "WA", postcode: "6260" },
{ city: "YEAGARUP", state: "WA", postcode: "6260" },
{ city: "BOORARA BROOK", state: "WA", postcode: "6262" },
{ city: "CROWEA", state: "WA", postcode: "6262" },
{ city: "MEERUP", state: "WA", postcode: "6262" },
{ city: "NORTHCLIFFE", state: "WA", postcode: "6262" },
{ city: "SHANNON", state: "WA", postcode: "6262" },
{ city: "WINDY HARBOUR", state: "WA", postcode: "6262" },
{ city: "CAPEL", state: "WA", postcode: "6271" },
{ city: "CAPEL RIVER", state: "WA", postcode: "6271" },
{ city: "FORREST BEACH", state: "WA", postcode: "6271" },
{ city: "PEPPERMINT GROVE BEACH", state: "WA", postcode: "6271" },
{ city: "STIRLING ESTATE", state: "WA", postcode: "6271" },
{ city: "BARRABUP", state: "WA", postcode: "6275" },
{ city: "CARLOTTA", state: "WA", postcode: "6275" },
{ city: "CUNDINUP", state: "WA", postcode: "6275" },
{ city: "DARRADUP", state: "WA", postcode: "6275" },
{ city: "EAST NANNUP", state: "WA", postcode: "6275" },
{ city: "JALBARRAGUP", state: "WA", postcode: "6275" },
{ city: "JARRAHWOOD", state: "WA", postcode: "6275" },
{ city: "NANNUP", state: "WA", postcode: "6275" },
{ city: "SCOTT RIVER EAST", state: "WA", postcode: "6275" },
{ city: "YOGANUP", state: "WA", postcode: "6275" },
{ city: "ABBA RIVER", state: "WA", postcode: "6280" },
{ city: "ABBEY", state: "WA", postcode: "6280" },
{ city: "ACTON PARK", state: "WA", postcode: "6280" },
{ city: "AMBERGATE", state: "WA", postcode: "6280" },
{ city: "ANNIEBROOK", state: "WA", postcode: "6280" },
{ city: "BOALLIA", state: "WA", postcode: "6280" },
{ city: "BOVELL", state: "WA", postcode: "6280" },
{ city: "BROADWATER", state: "WA", postcode: "6280" },
{ city: "BUSSELTON", state: "WA", postcode: "6280" },
{ city: "CARBUNUP RIVER", state: "WA", postcode: "6280" },
{ city: "CHAPMAN HILL", state: "WA", postcode: "6280" },
{ city: "GEOGRAPHE", state: "WA", postcode: "6280" },
{ city: "HITHERGREEN", state: "WA", postcode: "6280" },
{ city: "JINDONG", state: "WA", postcode: "6280" },
{ city: "KALGUP", state: "WA", postcode: "6280" },
{ city: "KALOORUP", state: "WA", postcode: "6280" },
{ city: "KEALY", state: "WA", postcode: "6280" },
{ city: "LUDLOW", state: "WA", postcode: "6280" },
{ city: "MARYBROOK", state: "WA", postcode: "6280" },
{ city: "METRICUP", state: "WA", postcode: "6280" },
{ city: "NORTH JINDONG", state: "WA", postcode: "6280" },
{ city: "REINSCOURT", state: "WA", postcode: "6280" },
{ city: "RUABON", state: "WA", postcode: "6280" },
{ city: "SABINA RIVER", state: "WA", postcode: "6280" },
{ city: "SIESTA PARK", state: "WA", postcode: "6280" },
{ city: "TUTUNUP", state: "WA", postcode: "6280" },
{ city: "VASSE", state: "WA", postcode: "6280" },
{ city: "WALSALL", state: "WA", postcode: "6280" },
{ city: "WEST BUSSELTON", state: "WA", postcode: "6280" },
{ city: "WILYABRUP", state: "WA", postcode: "6280" },
{ city: "WONNERUP", state: "WA", postcode: "6280" },
{ city: "YALYALUP", state: "WA", postcode: "6280" },
{ city: "YELVERTON", state: "WA", postcode: "6280" },
{ city: "YOONGARILLUP", state: "WA", postcode: "6280" },
{ city: "DUNSBOROUGH", state: "WA", postcode: "6281" },
{ city: "EAGLE BAY", state: "WA", postcode: "6281" },
{ city: "NATURALISTE", state: "WA", postcode: "6281" },
{ city: "QUEDJINUP", state: "WA", postcode: "6281" },
{ city: "QUINDALUP", state: "WA", postcode: "6281" },
{ city: "YALLINGUP", state: "WA", postcode: "6282" },
{ city: "YALLINGUP SIDING", state: "WA", postcode: "6282" },
{ city: "BAUDIN", state: "WA", postcode: "6284" },
{ city: "COWARAMUP", state: "WA", postcode: "6284" },
{ city: "GRACETOWN", state: "WA", postcode: "6284" },
{ city: "TREETON", state: "WA", postcode: "6284" },
{ city: "BRAMLEY", state: "WA", postcode: "6285" },
{ city: "BURNSIDE", state: "WA", postcode: "6285" },
{ city: "GNARABUP", state: "WA", postcode: "6285" },
{ city: "MARGARET RIVER", state: "WA", postcode: "6285" },
{ city: "OSMINGTON", state: "WA", postcode: "6285" },
{ city: "PREVELLY", state: "WA", postcode: "6285" },
{ city: "ROSA BROOK", state: "WA", postcode: "6285" },
{ city: "ROSA GLEN", state: "WA", postcode: "6285" },
{ city: "SCHROEDER", state: "WA", postcode: "6285" },
{ city: "BORANUP", state: "WA", postcode: "6286" },
{ city: "FOREST GROVE", state: "WA", postcode: "6286" },
{ city: "REDGATE", state: "WA", postcode: "6286" },
{ city: "WITCHCLIFFE", state: "WA", postcode: "6286" },
{ city: "ALEXANDRA BRIDGE", state: "WA", postcode: "6288" },
{ city: "COURTENAY", state: "WA", postcode: "6288" },
{ city: "HAMELIN BAY", state: "WA", postcode: "6288" },
{ city: "KARRIDALE", state: "WA", postcode: "6288" },
{ city: "NILLUP", state: "WA", postcode: "6288" },
{ city: "SCOTT RIVER", state: "WA", postcode: "6288" },
{ city: "WARNER GLEN", state: "WA", postcode: "6288" },
{ city: "AUGUSTA", state: "WA", postcode: "6290" },
{ city: "DEEPDENE", state: "WA", postcode: "6290" },
{ city: "EAST AUGUSTA", state: "WA", postcode: "6290" },
{ city: "KUDARDUP", state: "WA", postcode: "6290" },
{ city: "LEEUWIN", state: "WA", postcode: "6290" },
{ city: "MOLLOY ISLAND", state: "WA", postcode: "6290" },
{ city: "BADGIN", state: "WA", postcode: "6302" },
{ city: "BALLADONG", state: "WA", postcode: "6302" },
{ city: "BURGES", state: "WA", postcode: "6302" },
{ city: "CALJIE", state: "WA", postcode: "6302" },
{ city: "COLD HARBOUR", state: "WA", postcode: "6302" },
{ city: "DALIAK", state: "WA", postcode: "6302" },
{ city: "FLINT", state: "WA", postcode: "6302" },
{ city: "FLYNN", state: "WA", postcode: "6302" },
{ city: "GILGERING", state: "WA", postcode: "6302" },
{ city: "GREENHILLS", state: "WA", postcode: "6302" },
{ city: "GWAMBYGINE", state: "WA", postcode: "6302" },
{ city: "INKPEN", state: "WA", postcode: "6302" },
{ city: "KAURING", state: "WA", postcode: "6302" },
{ city: "MALEBELLING", state: "WA", postcode: "6302" },
{ city: "MOUNT HARDEY", state: "WA", postcode: "6302" },
{ city: "MOUNT OBSERVATION", state: "WA", postcode: "6302" },
{ city: "NARRALOGGAN", state: "WA", postcode: "6302" },
{ city: "QUELLINGTON", state: "WA", postcode: "6302" },
{ city: "ST RONANS", state: "WA", postcode: "6302" },
{ city: "TALBOT", state: "WA", postcode: "6302" },
{ city: "TALBOT WEST", state: "WA", postcode: "6302" },
{ city: "WILBERFORCE", state: "WA", postcode: "6302" },
{ city: "YORK", state: "WA", postcode: "6302" },
{ city: "BALLY BALLY", state: "WA", postcode: "6304" },
{ city: "BEVERLEY", state: "WA", postcode: "6304" },
{ city: "DALE", state: "WA", postcode: "6304" },
{ city: "EAST BEVERLEY", state: "WA", postcode: "6304" },
{ city: "KOKEBY", state: "WA", postcode: "6304" },
{ city: "MORBINNING", state: "WA", postcode: "6304" },
{ city: "WESTDALE", state: "WA", postcode: "6304" },
{ city: "ALDERSYDE", state: "WA", postcode: "6306" },
{ city: "BROOKTON", state: "WA", postcode: "6306" },
{ city: "BULYEE", state: "WA", postcode: "6306" },
{ city: "JELCOBINE", state: "WA", postcode: "6306" },
{ city: "KWEDA", state: "WA", postcode: "6306" },
{ city: "CODJATOTINE", state: "WA", postcode: "6308" },
{ city: "DWARDA", state: "WA", postcode: "6308" },
{ city: "EAST PINGELLY", state: "WA", postcode: "6308" },
{ city: "GILLIMANNING", state: "WA", postcode: "6308" },
{ city: "HASTINGS", state: "WA", postcode: "6308" },
{ city: "PINGELLY", state: "WA", postcode: "6308" },
{ city: "PUMPHREYS BRIDGE", state: "WA", postcode: "6308" },
{ city: "SPRINGS", state: "WA", postcode: "6308" },
{ city: "WANDERING", state: "WA", postcode: "6308" },
{ city: "WEST PINGELLY", state: "WA", postcode: "6308" },
{ city: "EAST POPANYINNING", state: "WA", postcode: "6309" },
{ city: "POPANYINNING", state: "WA", postcode: "6309" },
{ city: "STRATHERNE", state: "WA", postcode: "6309" },
{ city: "WEST POPANYINNING", state: "WA", postcode: "6309" },
{ city: "COMMODINE", state: "WA", postcode: "6311" },
{ city: "CONTINE", state: "WA", postcode: "6311" },
{ city: "CUBALLING", state: "WA", postcode: "6311" },
{ city: "DRYANDRA", state: "WA", postcode: "6311" },
{ city: "LOL GRAY", state: "WA", postcode: "6311" },
{ city: "TOWNSENDALE", state: "WA", postcode: "6311" },
{ city: "WARDERING", state: "WA", postcode: "6311" },
{ city: "YORNANING", state: "WA", postcode: "6311" },
{ city: "BOUNDAIN", state: "WA", postcode: "6312" },
{ city: "DUMBERNING", state: "WA", postcode: "6312" },
{ city: "HILLSIDE", state: "WA", postcode: "6312" },
{ city: "MINIGIN", state: "WA", postcode: "6312" },
{ city: "NARROGIN", state: "WA", postcode: "6312" },
{ city: "NARROGIN VALLEY", state: "WA", postcode: "6312" },
{ city: "NOMANS LAKE", state: "WA", postcode: "6312" },
{ city: "TOOLIBIN", state: "WA", postcode: "6312" },
{ city: "YILLIMINNING", state: "WA", postcode: "6312" },
{ city: "HIGHBURY", state: "WA", postcode: "6313" },
{ city: "ARTHUR RIVER", state: "WA", postcode: "6315" },
{ city: "BALLAYING", state: "WA", postcode: "6315" },
{ city: "CANCANNING", state: "WA", postcode: "6315" },
{ city: "COLLANILLING", state: "WA", postcode: "6315" },
{ city: "DONGOLOCKING", state: "WA", postcode: "6315" },
{ city: "GUNDARING", state: "WA", postcode: "6315" },
{ city: "JALORAN", state: "WA", postcode: "6315" },
{ city: "LIME LAKE", state: "WA", postcode: "6315" },
{ city: "MINDING", state: "WA", postcode: "6315" },
{ city: "PIESSEVILLE", state: "WA", postcode: "6315" },
{ city: "WAGIN", state: "WA", postcode: "6315" },
{ city: "WEDGECARRUP", state: "WA", postcode: "6315" },
{ city: "BOYERINE", state: "WA", postcode: "6316" },
{ city: "CARTMETICUP", state: "WA", postcode: "6316" },
{ city: "GLENCOE", state: "WA", postcode: "6316" },
{ city: "KENMARE", state: "WA", postcode: "6316" },
{ city: "WESTWOOD", state: "WA", postcode: "6316" },
{ city: "WOODANILLING", state: "WA", postcode: "6316" },
{ city: "BADGEBUP", state: "WA", postcode: "6317" },
{ city: "BULLOCK HILLS", state: "WA", postcode: "6317" },
{ city: "CARROLUP", state: "WA", postcode: "6317" },
{ city: "COBLININE", state: "WA", postcode: "6317" },
{ city: "COYRECUP", state: "WA", postcode: "6317" },
{ city: "DATATINE", state: "WA", postcode: "6317" },
{ city: "EWLYAMARTUP", state: "WA", postcode: "6317" },
{ city: "KATANNING", state: "WA", postcode: "6317" },
{ city: "MARRACOONDA", state: "WA", postcode: "6317" },
{ city: "MOOJEBING", state: "WA", postcode: "6317" },
{ city: "MURDONG", state: "WA", postcode: "6317" },
{ city: "PINWERNYING", state: "WA", postcode: "6317" },
{ city: "SOUTH DATATINE", state: "WA", postcode: "6317" },
{ city: "SOUTH GLENCOE", state: "WA", postcode: "6317" },
{ city: "BROOMEHILL", state: "WA", postcode: "6318" },
{ city: "BROOMEHILL EAST", state: "WA", postcode: "6318" },
{ city: "BROOMEHILL VILLAGE", state: "WA", postcode: "6318" },
{ city: "BROOMEHILL WEST", state: "WA", postcode: "6318" },
{ city: "BOBALONG", state: "WA", postcode: "6320" },
{ city: "BORDERDALE", state: "WA", postcode: "6320" },
{ city: "DARTNALL", state: "WA", postcode: "6320" },
{ city: "LAKE TOOLBRUNUP", state: "WA", postcode: "6320" },
{ city: "MOONIES HILL", state: "WA", postcode: "6320" },
{ city: "TAMBELLUP", state: "WA", postcode: "6320" },
{ city: "WANSBROUGH", state: "WA", postcode: "6320" },
{ city: "CRANBROOK", state: "WA", postcode: "6321" },
{ city: "TENTERDEN", state: "WA", postcode: "6322" },
{ city: "KENDENUP", state: "WA", postcode: "6323" },
{ city: "DENBARKER", state: "WA", postcode: "6324" },
{ city: "FOREST HILL", state: "WA", postcode: "6324" },
{ city: "MOUNT BARKER", state: "WA", postcode: "6324" },
{ city: "PERILLUP", state: "WA", postcode: "6324" },
{ city: "PORONGURUP", state: "WA", postcode: "6324" },
{ city: "SOUTH STIRLING", state: "WA", postcode: "6324" },
{ city: "TAKALARUP", state: "WA", postcode: "6324" },
{ city: "WOOGENELLUP", state: "WA", postcode: "6324" },
{ city: "NARRIKUP", state: "WA", postcode: "6326" },
{ city: "REDMOND", state: "WA", postcode: "6327" },
{ city: "REDMOND WEST", state: "WA", postcode: "6327" },
{ city: "CHEYNES", state: "WA", postcode: "6328" },
{ city: "GNOWELLEN", state: "WA", postcode: "6328" },
{ city: "GREEN RANGE", state: "WA", postcode: "6328" },
{ city: "KOJANEERUP SOUTH", state: "WA", postcode: "6328" },
{ city: "MANYPEAKS", state: "WA", postcode: "6328" },
{ city: "METTLER", state: "WA", postcode: "6328" },
{ city: "PALMDALE", state: "WA", postcode: "6328" },
{ city: "WELLSTEAD", state: "WA", postcode: "6328" },
{ city: "ALBANY", state: "WA", postcode: "6330" },
{ city: "BAYONET HEAD", state: "WA", postcode: "6330" },
{ city: "BIG GROVE", state: "WA", postcode: "6330" },
{ city: "BORNHOLM", state: "WA", postcode: "6330" },
{ city: "CENTENNIAL PARK", state: "WA", postcode: "6330" },
{ city: "COLLINGWOOD HEIGHTS", state: "WA", postcode: "6330" },
{ city: "COLLINGWOOD PARK", state: "WA", postcode: "6330" },
{ city: "CUTHBERT", state: "WA", postcode: "6330" },
{ city: "DROME", state: "WA", postcode: "6330" },
{ city: "ELLEKER", state: "WA", postcode: "6330" },
{ city: "EMU POINT", state: "WA", postcode: "6330" },
{ city: "FRENCHMAN BAY", state: "WA", postcode: "6330" },
{ city: "GLEDHOW", state: "WA", postcode: "6330" },
{ city: "GOODE BEACH", state: "WA", postcode: "6330" },
{ city: "GREEN VALLEY", state: "WA", postcode: "6330" },
{ city: "KALGAN", state: "WA", postcode: "6330" },
{ city: "KING RIVER", state: "WA", postcode: "6330" },
{ city: "KRONKUP", state: "WA", postcode: "6330" },
{ city: "LANGE", state: "WA", postcode: "6330" },
{ city: "LITTLE GROVE", state: "WA", postcode: "6330" },
{ city: "LOCKYER", state: "WA", postcode: "6330" },
{ city: "LOWER KING", state: "WA", postcode: "6330" },
{ city: "LOWLANDS", state: "WA", postcode: "6330" },
{ city: "MARBELUP", state: "WA", postcode: "6330" },
{ city: "MCKAIL", state: "WA", postcode: "6330" },
{ city: "MIDDLETON BEACH", state: "WA", postcode: "6330" },
{ city: "MILLBROOK", state: "WA", postcode: "6330" },
{ city: "MILPARA", state: "WA", postcode: "6330" },
{ city: "MIRA MAR", state: "WA", postcode: "6330" },
{ city: "MOUNT CLARENCE", state: "WA", postcode: "6330" },
{ city: "MOUNT ELPHINSTONE", state: "WA", postcode: "6330" },
{ city: "MOUNT MELVILLE", state: "WA", postcode: "6330" },
{ city: "NANARUP", state: "WA", postcode: "6330" },
{ city: "NAPIER", state: "WA", postcode: "6330" },
{ city: "NULLAKI", state: "WA", postcode: "6330" },
{ city: "ORANA", state: "WA", postcode: "6330" },
{ city: "PORT ALBANY", state: "WA", postcode: "6330" },
{ city: "ROBINSON", state: "WA", postcode: "6330" },
{ city: "SANDPATCH", state: "WA", postcode: "6330" },
{ city: "SEPPINGS", state: "WA", postcode: "6330" },
{ city: "SPENCER PARK", state: "WA", postcode: "6330" },
{ city: "TORBAY", state: "WA", postcode: "6330" },
{ city: "TORNDIRRUP", state: "WA", postcode: "6330" },
{ city: "VANCOUVER PENINSULA", state: "WA", postcode: "6330" },
{ city: "WALMSLEY", state: "WA", postcode: "6330" },
{ city: "WARRENUP", state: "WA", postcode: "6330" },
{ city: "WEST CAPE HOWE", state: "WA", postcode: "6330" },
{ city: "WILLYUNG", state: "WA", postcode: "6330" },
{ city: "YAKAMIA", state: "WA", postcode: "6330" },
{ city: "YOUNGS SIDING", state: "WA", postcode: "6330" },
{ city: "BOW BRIDGE", state: "WA", postcode: "6333" },
{ city: "DENMARK", state: "WA", postcode: "6333" },
{ city: "HAY", state: "WA", postcode: "6333" },
{ city: "HAZELVALE", state: "WA", postcode: "6333" },
{ city: "KENTDALE", state: "WA", postcode: "6333" },
{ city: "KORDABUP", state: "WA", postcode: "6333" },
{ city: "MOUNT LINDESAY", state: "WA", postcode: "6333" },
{ city: "MOUNT ROMANCE", state: "WA", postcode: "6333" },
{ city: "NORNALUP", state: "WA", postcode: "6333" },
{ city: "OCEAN BEACH", state: "WA", postcode: "6333" },
{ city: "PARRYVILLE", state: "WA", postcode: "6333" },
{ city: "PEACEFUL BAY", state: "WA", postcode: "6333" },
{ city: "SCOTSDALE", state: "WA", postcode: "6333" },
{ city: "SHADFORTH", state: "WA", postcode: "6333" },
{ city: "TINGLEDALE", state: "WA", postcode: "6333" },
{ city: "TRENT", state: "WA", postcode: "6333" },
{ city: "WILLIAM BAY", state: "WA", postcode: "6333" },
{ city: "GNOWANGERUP", state: "WA", postcode: "6335" },
{ city: "JACKITUP", state: "WA", postcode: "6335" },
{ city: "KEBARINGUP", state: "WA", postcode: "6335" },
{ city: "PALLINUP", state: "WA", postcode: "6335" },
{ city: "COWALELLUP", state: "WA", postcode: "6336" },
{ city: "MILLS LAKE", state: "WA", postcode: "6336" },
{ city: "MINDARABIN", state: "WA", postcode: "6336" },
{ city: "NEEDILUP", state: "WA", postcode: "6336" },
{ city: "ONGERUP", state: "WA", postcode: "6336" },
{ city: "TOOMPUP", state: "WA", postcode: "6336" },
{ city: "FITZGERALD", state: "WA", postcode: "6337" },
{ city: "GAIRDNER", state: "WA", postcode: "6337" },
{ city: "JACUP", state: "WA", postcode: "6337" },
{ city: "JERRAMUNGUP", state: "WA", postcode: "6337" },
{ city: "WEST FITZGERALD", state: "WA", postcode: "6337" },
{ city: "AMELUP", state: "WA", postcode: "6338" },
{ city: "BORDEN", state: "WA", postcode: "6338" },
{ city: "BOXWOOD HILL", state: "WA", postcode: "6338" },
{ city: "BREMER BAY", state: "WA", postcode: "6338" },
{ city: "MAGITUP", state: "WA", postcode: "6338" },
{ city: "MONJEBUP", state: "WA", postcode: "6338" },
{ city: "NALYERLUP", state: "WA", postcode: "6338" },
{ city: "NORTH STIRLINGS", state: "WA", postcode: "6338" },
{ city: "STIRLING RANGE NATIONAL PARK", state: "WA", postcode: "6338" },
{ city: "NYABING", state: "WA", postcode: "6341" },
{ city: "PINGRUP", state: "WA", postcode: "6343" },
{ city: "FITZGERALD RIVER NATIONAL PARK", state: "WA", postcode: "6346" },
{ city: "JERDACUTTUP", state: "WA", postcode: "6346" },
{ city: "RAVENSTHORPE", state: "WA", postcode: "6346" },
{ city: "WEST RIVER", state: "WA", postcode: "6346" },
{ city: "HOPETOUN", state: "WA", postcode: "6348" },
{ city: "DUMBLEYUNG", state: "WA", postcode: "6350" },
{ city: "NAIRIBIN", state: "WA", postcode: "6350" },
{ city: "NIPPERING", state: "WA", postcode: "6350" },
{ city: "MOULYINNING", state: "WA", postcode: "6351" },
{ city: "NORTH MOULYINNING", state: "WA", postcode: "6351" },
{ city: "KUKERIN", state: "WA", postcode: "6352" },
{ city: "MERILUP", state: "WA", postcode: "6352" },
{ city: "NORTH KUKERIN", state: "WA", postcode: "6352" },
{ city: "SOUTH KUKERIN", state: "WA", postcode: "6352" },
{ city: "BEENONG", state: "WA", postcode: "6353" },
{ city: "BUNICHE", state: "WA", postcode: "6353" },
{ city: "KUENDER", state: "WA", postcode: "6353" },
{ city: "LAKE GRACE", state: "WA", postcode: "6353" },
{ city: "MALLEE HILL", state: "WA", postcode: "6353" },
{ city: "NEENDALING", state: "WA", postcode: "6353" },
{ city: "NORTH BURNGUP", state: "WA", postcode: "6353" },
{ city: "NORTH LAKE GRACE", state: "WA", postcode: "6353" },
{ city: "SOUTH LAKE GRACE", state: "WA", postcode: "6353" },
{ city: "TARIN ROCK", state: "WA", postcode: "6353" },
{ city: "DUNN ROCK", state: "WA", postcode: "6355" },
{ city: "EAST NEWDEGATE", state: "WA", postcode: "6355" },
{ city: "HOLT ROCK", state: "WA", postcode: "6355" },
{ city: "LAKE BIDDY", state: "WA", postcode: "6355" },
{ city: "LAKE CAMM", state: "WA", postcode: "6355" },
{ city: "LITTLE ITALY", state: "WA", postcode: "6355" },
{ city: "MAGENTA", state: "WA", postcode: "6355" },
{ city: "MOUNT SHERIDAN", state: "WA", postcode: "6355" },
{ city: "NEWDEGATE", state: "WA", postcode: "6355" },
{ city: "SOUTH NEWDEGATE", state: "WA", postcode: "6355" },
{ city: "VARLEY", state: "WA", postcode: "6355" },
{ city: "HATTER HILL", state: "WA", postcode: "6356" },
{ city: "LAKE KING", state: "WA", postcode: "6356" },
{ city: "MOUNT MADDEN", state: "WA", postcode: "6356" },
{ city: "PINGARING", state: "WA", postcode: "6357" },
{ city: "KARLGARIN", state: "WA", postcode: "6358" },
{ city: "FORRESTANIA", state: "WA", postcode: "6359" },
{ city: "HYDEN", state: "WA", postcode: "6359" },
{ city: "LITTLE ITALY", state: "WA", postcode: "6359" },
{ city: "HARRISMITH", state: "WA", postcode: "6361" },
{ city: "TINCURRIN", state: "WA", postcode: "6361" },
{ city: "DUDININ", state: "WA", postcode: "6363" },
{ city: "WALYURIN", state: "WA", postcode: "6363" },
{ city: "JILAKIN", state: "WA", postcode: "6365" },
{ city: "JITARNING", state: "WA", postcode: "6365" },
{ city: "KULIN", state: "WA", postcode: "6365" },
{ city: "KULIN WEST", state: "WA", postcode: "6365" },
{ city: "KONDININ", state: "WA", postcode: "6367" },
{ city: "SOUTH KUMMININ", state: "WA", postcode: "6368" },
{ city: "MOUNT WALKER", state: "WA", postcode: "6369" },
{ city: "NAREMBEEN", state: "WA", postcode: "6369" },
{ city: "WADDERIN", state: "WA", postcode: "6369" },
{ city: "WEST HOLLETON", state: "WA", postcode: "6369" },
{ city: "WOOLOCUTTY", state: "WA", postcode: "6369" },
{ city: "EAST WICKEPIN", state: "WA", postcode: "6370" },
{ city: "KIRK ROCK", state: "WA", postcode: "6370" },
{ city: "MALYALLING", state: "WA", postcode: "6370" },
{ city: "WICKEPIN", state: "WA", postcode: "6370" },
{ city: "WOGOLIN", state: "WA", postcode: "6370" },
{ city: "YEALERING", state: "WA", postcode: "6372" },
{ city: "BULLARING", state: "WA", postcode: "6373" },
{ city: "ADAMSVALE", state: "WA", postcode: "6375" },
{ city: "BILBARIN", state: "WA", postcode: "6375" },
{ city: "CORRIGIN", state: "WA", postcode: "6375" },
{ city: "GORGE ROCK", state: "WA", postcode: "6375" },
{ city: "KUNJIN", state: "WA", postcode: "6375" },
{ city: "KURRENKUTTEN", state: "WA", postcode: "6375" },
{ city: "BADJALING", state: "WA", postcode: "6383" },
{ city: "BALKULING", state: "WA", postcode: "6383" },
{ city: "CUBBINE", state: "WA", postcode: "6383" },
{ city: "DANGIN", state: "WA", postcode: "6383" },
{ city: "DOODENANNING", state: "WA", postcode: "6383" },
{ city: "DULBELLING", state: "WA", postcode: "6383" },
{ city: "MOUNT STIRLING", state: "WA", postcode: "6383" },
{ city: "QUAIRADING", state: "WA", postcode: "6383" },
{ city: "SOUTH QUAIRADING", state: "WA", postcode: "6383" },
{ city: "WAMENUSKING", state: "WA", postcode: "6383" },
{ city: "YOTING", state: "WA", postcode: "6383" },
{ city: "PANTAPIN", state: "WA", postcode: "6384" },
{ city: "KWOLYIN", state: "WA", postcode: "6385" },
{ city: "SHACKLETON", state: "WA", postcode: "6386" },
{ city: "BANNISTER", state: "WA", postcode: "6390" },
{ city: "BODDINGTON", state: "WA", postcode: "6390" },
{ city: "CROSSMAN", state: "WA", postcode: "6390" },
{ city: "LOWER HOTHAM", state: "WA", postcode: "6390" },
{ city: "MARRADONG", state: "WA", postcode: "6390" },
{ city: "MOUNT COOKE", state: "WA", postcode: "6390" },
{ city: "MOUNT WELLS", state: "WA", postcode: "6390" },
{ city: "NORTH BANNISTER", state: "WA", postcode: "6390" },
{ city: "RANFORD", state: "WA", postcode: "6390" },
{ city: "UPPER MURRAY", state: "WA", postcode: "6390" },
{ city: "WURAMING", state: "WA", postcode: "6390" },
{ city: "QUINDANNING", state: "WA", postcode: "6391" },
{ city: "WILLIAMS", state: "WA", postcode: "6391" },
{ city: "BOKAL", state: "WA", postcode: "6392" },
{ city: "DARDADINE", state: "WA", postcode: "6392" },
{ city: "DARKAN", state: "WA", postcode: "6392" },
{ city: "MEEKING", state: "WA", postcode: "6392" },
{ city: "DURANILLIN", state: "WA", postcode: "6393" },
{ city: "MOODIARRUP", state: "WA", postcode: "6393" },
{ city: "BEAUFORT RIVER", state: "WA", postcode: "6394" },
{ city: "BOILUP", state: "WA", postcode: "6394" },
{ city: "BOSCABEL", state: "WA", postcode: "6394" },
{ city: "CHANGERUP", state: "WA", postcode: "6394" },
{ city: "MOKUP", state: "WA", postcode: "6394" },
{ city: "MURADUP", state: "WA", postcode: "6394" },
{ city: "ORCHID VALLEY", state: "WA", postcode: "6394" },
{ city: "QUALEUP", state: "WA", postcode: "6394" },
{ city: "CHERRY TREE POOL", state: "WA", postcode: "6395" },
{ city: "JINGALUP", state: "WA", postcode: "6395" },
{ city: "KOJONUP", state: "WA", postcode: "6395" },
{ city: "LUMEAH", state: "WA", postcode: "6395" },
{ city: "MOBRUP", state: "WA", postcode: "6395" },
{ city: "RYANSBROOK", state: "WA", postcode: "6395" },
{ city: "FRANKLAND RIVER", state: "WA", postcode: "6396" },
{ city: "ROCKY GULLY", state: "WA", postcode: "6397" },
{ city: "BROKE", state: "WA", postcode: "6398" },
{ city: "NORTH WALPOLE", state: "WA", postcode: "6398" },
{ city: "WALPOLE", state: "WA", postcode: "6398" },
{ city: "BUCKLAND", state: "WA", postcode: "6401" },
{ city: "BURLONG", state: "WA", postcode: "6401" },
{ city: "CUNJARDINE", state: "WA", postcode: "6401" },
{ city: "IRISHTOWN", state: "WA", postcode: "6401" },
{ city: "JENNACUBBINE", state: "WA", postcode: "6401" },
{ city: "JENNAPULLIN", state: "WA", postcode: "6401" },
{ city: "MALABAINE", state: "WA", postcode: "6401" },
{ city: "MEENAAR", state: "WA", postcode: "6401" },
{ city: "MOKINE", state: "WA", postcode: "6401" },
{ city: "MULUCKINE", state: "WA", postcode: "6401" },
{ city: "MUMBERKINE", state: "WA", postcode: "6401" },
{ city: "MURESK", state: "WA", postcode: "6401" },
{ city: "NORTHAM", state: "WA", postcode: "6401" },
{ city: "ROSSMORE", state: "WA", postcode: "6401" },
{ city: "SOUTHERN BROOK", state: "WA", postcode: "6401" },
{ city: "SPENCERS BROOK", state: "WA", postcode: "6401" },
{ city: "THROSSELL", state: "WA", postcode: "6401" },
{ city: "WONGAMINE", state: "WA", postcode: "6401" },
{ city: "GRASS VALLEY", state: "WA", postcode: "6403" },
{ city: "GREENWOODS VALLEY", state: "WA", postcode: "6405" },
{ city: "MECKERING", state: "WA", postcode: "6405" },
{ city: "QUELAGETTING", state: "WA", postcode: "6405" },
{ city: "WARDING EAST", state: "WA", postcode: "6405" },
{ city: "CUNDERDIN", state: "WA", postcode: "6407" },
{ city: "WAEEL", state: "WA", postcode: "6407" },
{ city: "WATERCARRIN", state: "WA", postcode: "6407" },
{ city: "WYOLA WEST", state: "WA", postcode: "6407" },
{ city: "YOUNDEGIN", state: "WA", postcode: "6407" },
{ city: "NORTH TAMMIN", state: "WA", postcode: "6409" },
{ city: "SOUTH TAMMIN", state: "WA", postcode: "6409" },
{ city: "TAMMIN", state: "WA", postcode: "6409" },
{ city: "DAADENNING CREEK", state: "WA", postcode: "6410" },
{ city: "KELLERBERRIN", state: "WA", postcode: "6410" },
{ city: "MOUNT CAROLINE", state: "WA", postcode: "6410" },
{ city: "NORTH KELLERBERRIN", state: "WA", postcode: "6410" },
{ city: "DOODLAKINE", state: "WA", postcode: "6411" },
{ city: "SOUTH DOODLAKINE", state: "WA", postcode: "6411" },
{ city: "BAANDEE", state: "WA", postcode: "6412" },
{ city: "NORTH BAANDEE", state: "WA", postcode: "6412" },
{ city: "HINES HILL", state: "WA", postcode: "6413" },
{ city: "NANGEENAN", state: "WA", postcode: "6414" },
{ city: "GOOMARIN", state: "WA", postcode: "6415" },
{ city: "KORBEL", state: "WA", postcode: "6415" },
{ city: "MERREDIN", state: "WA", postcode: "6415" },
{ city: "NOKANING", state: "WA", postcode: "6415" },
{ city: "NORPA", state: "WA", postcode: "6415" },
{ city: "TANDEGIN", state: "WA", postcode: "6415" },
{ city: "BRUCE ROCK", state: "WA", postcode: "6418" },
{ city: "ARDATH", state: "WA", postcode: "6419" },
{ city: "CRAMPHORNE", state: "WA", postcode: "6420" },
{ city: "MUNTADGIN", state: "WA", postcode: "6420" },
{ city: "BURRACOPPIN", state: "WA", postcode: "6421" },
{ city: "SOUTH BURRACOPPIN", state: "WA", postcode: "6421" },
{ city: "WARRALAKIN", state: "WA", postcode: "6421" },
{ city: "WALGOOLAN", state: "WA", postcode: "6422" },
{ city: "BOODAROCKIN", state: "WA", postcode: "6423" },
{ city: "CARRABIN", state: "WA", postcode: "6423" },
{ city: "WARRACHUPPIN", state: "WA", postcode: "6423" },
{ city: "WESTONIA", state: "WA", postcode: "6423" },
{ city: "BODALLIN", state: "WA", postcode: "6424" },
{ city: "NORTH BODALLIN", state: "WA", postcode: "6424" },
{ city: "SOUTH BODALLIN", state: "WA", postcode: "6424" },
{ city: "DULYALBIN", state: "WA", postcode: "6425" },
{ city: "MOORINE ROCK", state: "WA", postcode: "6425" },
{ city: "CORINTHIA", state: "WA", postcode: "6426" },
{ city: "GHOOLI", state: "WA", postcode: "6426" },
{ city: "HOLLETON", state: "WA", postcode: "6426" },
{ city: "MARVEL LOCH", state: "WA", postcode: "6426" },
{ city: "MOUNT HAMPTON", state: "WA", postcode: "6426" },
{ city: "MOUNT HOLLAND", state: "WA", postcode: "6426" },
{ city: "MOUNT JACKSON", state: "WA", postcode: "6426" },
{ city: "MOUNT PALMER", state: "WA", postcode: "6426" },
{ city: "PARKER RANGE", state: "WA", postcode: "6426" },
{ city: "SKELETON ROCK", state: "WA", postcode: "6426" },
{ city: "SOUTHERN CROSS", state: "WA", postcode: "6426" },
{ city: "SOUTH YILGARN", state: "WA", postcode: "6426" },
{ city: "TURKEY HILL", state: "WA", postcode: "6426" },
{ city: "YELLOWDINE", state: "WA", postcode: "6426" },
{ city: "KOOLYANOBBING", state: "WA", postcode: "6427" },
{ city: "BABAKIN", state: "WA", postcode: "6428" },
{ city: "BOORABBIN", state: "WA", postcode: "6429" },
{ city: "BULLABULLING", state: "WA", postcode: "6429" },
{ city: "COOLGARDIE", state: "WA", postcode: "6429" },
{ city: "KARRAMINDIE", state: "WA", postcode: "6429" },
{ city: "LONDONDERRY", state: "WA", postcode: "6429" },
{ city: "MOUNT BURGES", state: "WA", postcode: "6429" },
{ city: "VICTORIA ROCK", state: "WA", postcode: "6429" },
{ city: "WALLAROO", state: "WA", postcode: "6429" },
{ city: "BINDULI", state: "WA", postcode: "6430" },
{ city: "BROADWOOD", state: "WA", postcode: "6430" },
{ city: "HANNANS", state: "WA", postcode: "6430" },
{ city: "KALGOORLIE", state: "WA", postcode: "6430" },
{ city: "KARLKURLA", state: "WA", postcode: "6430" },
{ city: "LAMINGTON", state: "WA", postcode: "6430" },
{ city: "MULLINGAR", state: "WA", postcode: "6430" },
{ city: "PICCADILLY", state: "WA", postcode: "6430" },
{ city: "SOMERVILLE", state: "WA", postcode: "6430" },
{ city: "SOUTH KALGOORLIE", state: "WA", postcode: "6430" },
{ city: "WEST KALGOORLIE", state: "WA", postcode: "6430" },
{ city: "WEST LAMINGTON", state: "WA", postcode: "6430" },
{ city: "WILLIAMSTOWN", state: "WA", postcode: "6430" },
{ city: "YILKARI", state: "WA", postcode: "6430" },
{ city: "BOORARA", state: "WA", postcode: "6431" },
{ city: "BROWN HILL", state: "WA", postcode: "6431" },
{ city: "BULONG", state: "WA", postcode: "6431" },
{ city: "EMU FLAT", state: "WA", postcode: "6431" },
{ city: "FEYSVILLE", state: "WA", postcode: "6431" },
{ city: "KANOWNA", state: "WA", postcode: "6431" },
{ city: "KOOKYNIE", state: "WA", postcode: "6431" },
{ city: "KURNALPI", state: "WA", postcode: "6431" },
{ city: "LAKEWOOD", state: "WA", postcode: "6431" },
{ city: "ORA BANDA", state: "WA", postcode: "6431" },
{ city: "PLUMRIDGE LAKES", state: "WA", postcode: "6431" },
{ city: "TRAFALGAR", state: "WA", postcode: "6431" },
{ city: "WARBURTON", state: "WA", postcode: "6431" },
{ city: "BOULDER", state: "WA", postcode: "6432" },
{ city: "FIMISTON", state: "WA", postcode: "6432" },
{ city: "SOUTH BOULDER", state: "WA", postcode: "6432" },
{ city: "VICTORY HEIGHTS", state: "WA", postcode: "6432" },
{ city: "CUNDEELEE", state: "WA", postcode: "6434" },
{ city: "FORREST", state: "WA", postcode: "6434" },
{ city: "PARKESTON", state: "WA", postcode: "6434" },
{ city: "RAWLINNA", state: "WA", postcode: "6434" },
{ city: "ZANTHUS", state: "WA", postcode: "6434" },
{ city: "MENZIES", state: "WA", postcode: "6436" },
{ city: "ULARRING", state: "WA", postcode: "6436" },
{ city: "LEINSTER", state: "WA", postcode: "6437" },
{ city: "SIR SAMUEL", state: "WA", postcode: "6437" },
{ city: "LAKE DARLOT", state: "WA", postcode: "6438" },
{ city: "LEONORA", state: "WA", postcode: "6438" },
{ city: "BANDYA", state: "WA", postcode: "6440" },
{ city: "BEADELL", state: "WA", postcode: "6440" },
{ city: "COSMO NEWBERY", state: "WA", postcode: "6440" },
{ city: "LAKE WELLS", state: "WA", postcode: "6440" },
{ city: "LAVERTON", state: "WA", postcode: "6440" },
{ city: "NEALE", state: "WA", postcode: "6440" },
{ city: "KAMBALDA EAST", state: "WA", postcode: "6442" },
{ city: "KAMBALDA WEST", state: "WA", postcode: "6442" },
{ city: "BALLADONIA", state: "WA", postcode: "6443" },
{ city: "CAIGUNA", state: "WA", postcode: "6443" },
{ city: "COCKLEBIDDY", state: "WA", postcode: "6443" },
{ city: "DUNDAS", state: "WA", postcode: "6443" },
{ city: "EUCLA", state: "WA", postcode: "6443" },
{ city: "FRASER RANGE", state: "WA", postcode: "6443" },
{ city: "HIGGINSVILLE", state: "WA", postcode: "6443" },
{ city: "MADURA", state: "WA", postcode: "6443" },
{ city: "MUNDRABILLA", state: "WA", postcode: "6443" },
{ city: "NORSEMAN", state: "WA", postcode: "6443" },
{ city: "WIDGIEMOOLTHA", state: "WA", postcode: "6443" },
{ city: "NORTH CASCADE", state: "WA", postcode: "6445" },
{ city: "SALMON GUMS", state: "WA", postcode: "6445" },
{ city: "GRASS PATCH", state: "WA", postcode: "6446" },
{ city: "LORT RIVER", state: "WA", postcode: "6447" },
{ city: "MOUNT NEY", state: "WA", postcode: "6447" },
{ city: "SCADDAN", state: "WA", postcode: "6447" },
{ city: "WITTENOOM HILLS", state: "WA", postcode: "6447" },
{ city: "GIBSON", state: "WA", postcode: "6448" },
{ city: "BANDY CREEK", state: "WA", postcode: "6450" },
{ city: "BEAUMONT", state: "WA", postcode: "6450" },
{ city: "BOYATUP", state: "WA", postcode: "6450" },
{ city: "CAPE LE GRAND", state: "WA", postcode: "6450" },
{ city: "CASCADE", state: "WA", postcode: "6450" },
{ city: "CASTLETOWN", state: "WA", postcode: "6450" },
{ city: "CHADWICK", state: "WA", postcode: "6450" },
{ city: "CONDINGUP", state: "WA", postcode: "6450" },
{ city: "COOMALBIDGUP", state: "WA", postcode: "6450" },
{ city: "DALYUP", state: "WA", postcode: "6450" },
{ city: "EAST MUNGLINUP", state: "WA", postcode: "6450" },
{ city: "ESPERANCE", state: "WA", postcode: "6450" },
{ city: "HOWICK", state: "WA", postcode: "6450" },
{ city: "MERIVALE", state: "WA", postcode: "6450" },
{ city: "MONJINGUP", state: "WA", postcode: "6450" },
{ city: "MUNGLINUP", state: "WA", postcode: "6450" },
{ city: "MYRUP", state: "WA", postcode: "6450" },
{ city: "NERIDUP", state: "WA", postcode: "6450" },
{ city: "NULSEN", state: "WA", postcode: "6450" },
{ city: "PINK LAKE", state: "WA", postcode: "6450" },
{ city: "SINCLAIR", state: "WA", postcode: "6450" },
{ city: "WEST BEACH", state: "WA", postcode: "6450" },
{ city: "WINDABOUT", state: "WA", postcode: "6450" },
{ city: "BURAMINYA", state: "WA", postcode: "6452" },
{ city: "CAPE ARID", state: "WA", postcode: "6452" },
{ city: "ISRAELITE BAY", state: "WA", postcode: "6452" },
{ city: "GOOMALLING", state: "WA", postcode: "6460" },
{ city: "HULONGINE", state: "WA", postcode: "6460" },
{ city: "KARRANADGIN", state: "WA", postcode: "6460" },
{ city: "UCARTY WEST", state: "WA", postcode: "6460" },
{ city: "WALYORMOURING", state: "WA", postcode: "6460" },
{ city: "DOWERIN", state: "WA", postcode: "6461" },
{ city: "KOOMBERKINE", state: "WA", postcode: "6461" },
{ city: "HINDMARSH", state: "WA", postcode: "6462" },
{ city: "MINNIVALE", state: "WA", postcode: "6462" },
{ city: "UCARTY", state: "WA", postcode: "6462" },
{ city: "BENJABERRING", state: "WA", postcode: "6463" },
{ city: "MANMANNING", state: "WA", postcode: "6465" },
{ city: "CADOUX", state: "WA", postcode: "6466" },
{ city: "BURAKIN", state: "WA", postcode: "6467" },
{ city: "GOODLANDS", state: "WA", postcode: "6468" },
{ city: "KALANNIE", state: "WA", postcode: "6468" },
{ city: "PETRUDOR", state: "WA", postcode: "6468" },
{ city: "KULJA", state: "WA", postcode: "6470" },
{ city: "BEACON", state: "WA", postcode: "6472" },
{ city: "BIMBIJY", state: "WA", postcode: "6472" },
{ city: "CLEARY", state: "WA", postcode: "6472" },
{ city: "KARROUN HILL", state: "WA", postcode: "6472" },
{ city: "MOUROUBRA", state: "WA", postcode: "6472" },
{ city: "REMLAP", state: "WA", postcode: "6472" },
{ city: "TAMPU", state: "WA", postcode: "6472" },
{ city: "NORTH WIALKI", state: "WA", postcode: "6473" },
{ city: "WIALKI", state: "WA", postcode: "6473" },
{ city: "BADGERIN ROCK", state: "WA", postcode: "6475" },
{ city: "BOORALAMING", state: "WA", postcode: "6475" },
{ city: "DUKIN", state: "WA", postcode: "6475" },
{ city: "KOORDA", state: "WA", postcode: "6475" },
{ city: "LAKE MARGARETTE", state: "WA", postcode: "6475" },
{ city: "MOLLERIN", state: "WA", postcode: "6475" },
{ city: "NEWCARLBEON", state: "WA", postcode: "6475" },
{ city: "GABBIN", state: "WA", postcode: "6476" },
{ city: "BENCUBBIN", state: "WA", postcode: "6477" },
{ city: "WELBUNGIN", state: "WA", postcode: "6477" },
{ city: "BARBALIN", state: "WA", postcode: "6479" },
{ city: "BONNIE ROCK", state: "WA", postcode: "6479" },
{ city: "DANDANNING", state: "WA", postcode: "6479" },
{ city: "ELACHBUTTING", state: "WA", postcode: "6479" },
{ city: "KARLONING", state: "WA", postcode: "6479" },
{ city: "LAKE BROWN", state: "WA", postcode: "6479" },
{ city: "MUKINBUDIN", state: "WA", postcode: "6479" },
{ city: "WATTONING", state: "WA", postcode: "6479" },
{ city: "WILGOYNE", state: "WA", postcode: "6479" },
{ city: "NUKARNI", state: "WA", postcode: "6480" },
{ city: "BULLFINCH", state: "WA", postcode: "6484" },
{ city: "ENNUIN", state: "WA", postcode: "6484" },
{ city: "LAKE DEBORAH", state: "WA", postcode: "6484" },
{ city: "COWCOWING", state: "WA", postcode: "6485" },
{ city: "KORRELOCKING", state: "WA", postcode: "6485" },
{ city: "NALKAIN", state: "WA", postcode: "6485" },
{ city: "NEMBUDDING", state: "WA", postcode: "6485" },
{ city: "WYALKATCHEM", state: "WA", postcode: "6485" },
{ city: "NORTH YELBENI", state: "WA", postcode: "6487" },
{ city: "SOUTH YELBENI", state: "WA", postcode: "6487" },
{ city: "YELBENI", state: "WA", postcode: "6487" },
{ city: "NORTH TRAYNING", state: "WA", postcode: "6488" },
{ city: "SOUTH TRAYNING", state: "WA", postcode: "6488" },
{ city: "TRAYNING", state: "WA", postcode: "6488" },
{ city: "KUNUNOPPIN", state: "WA", postcode: "6489" },
{ city: "NORTH KUNUNOPPIN", state: "WA", postcode: "6489" },
{ city: "SOUTH KUNUNOPPIN", state: "WA", postcode: "6489" },
{ city: "BURRAN ROCK", state: "WA", postcode: "6490" },
{ city: "CHANDLER", state: "WA", postcode: "6490" },
{ city: "ELABBIN", state: "WA", postcode: "6490" },
{ city: "KWELKAN", state: "WA", postcode: "6490" },
{ city: "NUNGARIN", state: "WA", postcode: "6490" },
{ city: "TALGOMINE", state: "WA", postcode: "6490" },
{ city: "MUCHEA", state: "WA", postcode: "6501" },
{ city: "BINDOON", state: "WA", postcode: "6502" },
{ city: "BINDOON TRAINING AREA", state: "WA", postcode: "6502" },
{ city: "BAMBUN", state: "WA", postcode: "6503" },
{ city: "BEERMULLAH", state: "WA", postcode: "6503" },
{ city: "BOONANARRING", state: "WA", postcode: "6503" },
{ city: "BREERA", state: "WA", postcode: "6503" },
{ city: "COONABIDGEE", state: "WA", postcode: "6503" },
{ city: "COWALLA", state: "WA", postcode: "6503" },
{ city: "CULLALLA", state: "WA", postcode: "6503" },
{ city: "GINGIN", state: "WA", postcode: "6503" },
{ city: "GINGINUP", state: "WA", postcode: "6503" },
{ city: "GRANVILLE", state: "WA", postcode: "6503" },
{ city: "LENNARD BROOK", state: "WA", postcode: "6503" },
{ city: "MINDARRA", state: "WA", postcode: "6503" },
{ city: "MOONDAH", state: "WA", postcode: "6503" },
{ city: "MOORE RIVER NATIONAL PARK", state: "WA", postcode: "6503" },
{ city: "MUCKENBURRA", state: "WA", postcode: "6503" },
{ city: "NEERGABBY", state: "WA", postcode: "6503" },
{ city: "ORANGE SPRINGS", state: "WA", postcode: "6503" },
{ city: "RED GULLY", state: "WA", postcode: "6503" },
{ city: "WANERIE", state: "WA", postcode: "6503" },
{ city: "YEAL", state: "WA", postcode: "6503" },
{ city: "MOOLIABEENEE", state: "WA", postcode: "6504" },
{ city: "WANNAMAL", state: "WA", postcode: "6505" },
{ city: "MOGUMBER", state: "WA", postcode: "6506" },
{ city: "CATABY", state: "WA", postcode: "6507" },
{ city: "COOLJARLOO", state: "WA", postcode: "6507" },
{ city: "DANDARAGAN", state: "WA", postcode: "6507" },
{ city: "MIMEGARRA", state: "WA", postcode: "6507" },
{ city: "REGANS FORD", state: "WA", postcode: "6507" },
{ city: "YATHROO", state: "WA", postcode: "6507" },
{ city: "GLENTROMIE", state: "WA", postcode: "6509" },
{ city: "NEW NORCIA", state: "WA", postcode: "6509" },
{ city: "WADDINGTON", state: "WA", postcode: "6509" },
{ city: "YARAWINDAH", state: "WA", postcode: "6509" },
{ city: "BARBERTON", state: "WA", postcode: "6510" },
{ city: "BERKSHIRE VALLEY", state: "WA", postcode: "6510" },
{ city: "GILLINGARRA", state: "WA", postcode: "6510" },
{ city: "KOOJAN", state: "WA", postcode: "6510" },
{ city: "MOORA", state: "WA", postcode: "6510" },
{ city: "WALEBING", state: "WA", postcode: "6510" },
{ city: "CERVANTES", state: "WA", postcode: "6511" },
{ city: "COOMBERDALE", state: "WA", postcode: "6512" },
{ city: "NAMBAN", state: "WA", postcode: "6512" },
{ city: "GUNYIDI", state: "WA", postcode: "6513" },
{ city: "WATHEROO", state: "WA", postcode: "6513" },
{ city: "GREEN HEAD", state: "WA", postcode: "6514" },
{ city: "LEEMAN", state: "WA", postcode: "6514" },
{ city: "COOROW", state: "WA", postcode: "6515" },
{ city: "EGANU", state: "WA", postcode: "6515" },
{ city: "MARCHAGEE", state: "WA", postcode: "6515" },
{ city: "WADDY FOREST", state: "WA", postcode: "6515" },
{ city: "JURIEN BAY", state: "WA", postcode: "6516" },
{ city: "CARNAMAH", state: "WA", postcode: "6517" },
{ city: "ENEABBA", state: "WA", postcode: "6518" },
{ city: "WARRADARGE", state: "WA", postcode: "6518" },
{ city: "ARRINO", state: "WA", postcode: "6519" },
{ city: "ARROWSMITH EAST", state: "WA", postcode: "6519" },
{ city: "DUDAWA", state: "WA", postcode: "6519" },
{ city: "KADATHINNI", state: "WA", postcode: "6519" },
{ city: "THREE SPRINGS", state: "WA", postcode: "6519" },
{ city: "WOMARDEN", state: "WA", postcode: "6519" },
{ city: "BADGINGARRA", state: "WA", postcode: "6521" },
{ city: "BOOTHENDARRA", state: "WA", postcode: "6521" },
{ city: "GREY", state: "WA", postcode: "6521" },
{ city: "HILL RIVER", state: "WA", postcode: "6521" },
{ city: "NAMBUNG", state: "WA", postcode: "6521" },
{ city: "BUNDANOON", state: "WA", postcode: "6522" },
{ city: "HOLMWOOD", state: "WA", postcode: "6522" },
{ city: "IKEWA", state: "WA", postcode: "6522" },
{ city: "LOCKIER", state: "WA", postcode: "6522" },
{ city: "MINGENEW", state: "WA", postcode: "6522" },
{ city: "MOORIARY", state: "WA", postcode: "6522" },
{ city: "MOUNT BUDD", state: "WA", postcode: "6522" },
{ city: "NANGETTY", state: "WA", postcode: "6522" },
{ city: "YANDANOOKA", state: "WA", postcode: "6522" },
{ city: "YARRAGADEE", state: "WA", postcode: "6522" },
{ city: "ALLANOOKA", state: "WA", postcode: "6525" },
{ city: "ARROWSMITH", state: "WA", postcode: "6525" },
{ city: "BONNIEFIELD", state: "WA", postcode: "6525" },
{ city: "BOOKARA", state: "WA", postcode: "6525" },
{ city: "DONGARA", state: "WA", postcode: "6525" },
{ city: "IRWIN", state: "WA", postcode: "6525" },
{ city: "MILO", state: "WA", postcode: "6525" },
{ city: "MOUNT ADAMS", state: "WA", postcode: "6525" },
{ city: "MOUNT HORNER", state: "WA", postcode: "6525" },
{ city: "PORT DENISON", state: "WA", postcode: "6525" },
{ city: "SPRINGFIELD", state: "WA", postcode: "6525" },
{ city: "YARDARINO", state: "WA", postcode: "6525" },
{ city: "MOUNT HILL", state: "WA", postcode: "6528" },
{ city: "SOUTH GREENOUGH", state: "WA", postcode: "6528" },
{ city: "WALKAWAY", state: "WA", postcode: "6528" },
{ city: "BEACHLANDS", state: "WA", postcode: "6530" },
{ city: "BERESFORD", state: "WA", postcode: "6530" },
{ city: "BLUFF POINT", state: "WA", postcode: "6530" },
{ city: "GERALDTON", state: "WA", postcode: "6530" },
{ city: "GERALDTON DC", state: "WA", postcode: "6530" },
{ city: "HOUTMAN ABROLHOS", state: "WA", postcode: "6530" },
{ city: "KARLOO", state: "WA", postcode: "6530" },
{ city: "MAHOMETS FLATS", state: "WA", postcode: "6530" },
{ city: "MERU", state: "WA", postcode: "6530" },
{ city: "MORESBY", state: "WA", postcode: "6530" },
{ city: "MOUNT TARCOOLA", state: "WA", postcode: "6530" },
{ city: "RANGEWAY", state: "WA", postcode: "6530" },
{ city: "SPALDING", state: "WA", postcode: "6530" },
{ city: "STRATHALBYN", state: "WA", postcode: "6530" },
{ city: "SUNSET BEACH", state: "WA", postcode: "6530" },
{ city: "TARCOOLA BEACH", state: "WA", postcode: "6530" },
{ city: "UTAKARRA", state: "WA", postcode: "6530" },
{ city: "WAGGRAKINE", state: "WA", postcode: "6530" },
{ city: "WANDINA", state: "WA", postcode: "6530" },
{ city: "WEBBERTON", state: "WA", postcode: "6530" },
{ city: "WEST END", state: "WA", postcode: "6530" },
{ city: "WONTHELLA", state: "WA", postcode: "6530" },
{ city: "WOORREE", state: "WA", postcode: "6530" },
{ city: "AJANA", state: "WA", postcode: "6532" },
{ city: "BINNU", state: "WA", postcode: "6532" },
{ city: "BOOTENAL", state: "WA", postcode: "6532" },
{ city: "BRINGO", state: "WA", postcode: "6532" },
{ city: "BULLER", state: "WA", postcode: "6532" },
{ city: "BURMA ROAD", state: "WA", postcode: "6532" },
{ city: "CAPE BURNEY", state: "WA", postcode: "6532" },
{ city: "CARRARANG", state: "WA", postcode: "6532" },
{ city: "COBURN", state: "WA", postcode: "6532" },
{ city: "COOLCALALAYA", state: "WA", postcode: "6532" },
{ city: "DARTMOOR", state: "WA", postcode: "6532" },
{ city: "DEEPDALE", state: "WA", postcode: "6532" },
{ city: "DINDILOA", state: "WA", postcode: "6532" },
{ city: "DRUMMOND COVE", state: "WA", postcode: "6532" },
{ city: "DURAWAH", state: "WA", postcode: "6532" },
{ city: "EAST CHAPMAN", state: "WA", postcode: "6532" },
{ city: "EAST NABAWA", state: "WA", postcode: "6532" },
{ city: "EAST YUNA", state: "WA", postcode: "6532" },
{ city: "ELLENDALE", state: "WA", postcode: "6532" },
{ city: "ERADU", state: "WA", postcode: "6532" },
{ city: "ERADU SOUTH", state: "WA", postcode: "6532" },
{ city: "EURARDY", state: "WA", postcode: "6532" },
{ city: "GEORGINA", state: "WA", postcode: "6532" },
{ city: "GLENFIELD", state: "WA", postcode: "6532" },
{ city: "GREENOUGH", state: "WA", postcode: "6532" },
{ city: "HAMELIN POOL", state: "WA", postcode: "6532" },
{ city: "HICKETY", state: "WA", postcode: "6532" },
{ city: "HOWATHARRA", state: "WA", postcode: "6532" },
{ city: "KOJARENA", state: "WA", postcode: "6532" },
{ city: "MARRAH", state: "WA", postcode: "6532" },
{ city: "MEADOW", state: "WA", postcode: "6532" },
{ city: "MINNENOOKA", state: "WA", postcode: "6532" },
{ city: "MOONYOONOOKA", state: "WA", postcode: "6532" },
{ city: "MOUNT ERIN", state: "WA", postcode: "6532" },
{ city: "NABAWA", state: "WA", postcode: "6532" },
{ city: "NANSON", state: "WA", postcode: "6532" },
{ city: "NARALING", state: "WA", postcode: "6532" },
{ city: "NARNGULU", state: "WA", postcode: "6532" },
{ city: "NARRA TARRA", state: "WA", postcode: "6532" },
{ city: "NERREN NERREN", state: "WA", postcode: "6532" },
{ city: "NOLBA", state: "WA", postcode: "6532" },
{ city: "NORTH ERADU", state: "WA", postcode: "6532" },
{ city: "NORTHERN GULLY", state: "WA", postcode: "6532" },
{ city: "OAKAJEE", state: "WA", postcode: "6532" },
{ city: "ROCKWELL", state: "WA", postcode: "6532" },
{ city: "RUDDS GULLY", state: "WA", postcode: "6532" },
{ city: "SANDSPRINGS", state: "WA", postcode: "6532" },
{ city: "SOUTH YUNA", state: "WA", postcode: "6532" },
{ city: "TAMALA", state: "WA", postcode: "6532" },
{ city: "TIBRADDEN", state: "WA", postcode: "6532" },
{ city: "TOOLONGA", state: "WA", postcode: "6532" },
{ city: "VALENTINE", state: "WA", postcode: "6532" },
{ city: "WANDANA", state: "WA", postcode: "6532" },
{ city: "WEST BINNU", state: "WA", postcode: "6532" },
{ city: "WHITE PEAK", state: "WA", postcode: "6532" },
{ city: "WICHERINA", state: "WA", postcode: "6532" },
{ city: "WICHERINA SOUTH", state: "WA", postcode: "6532" },
{ city: "YETNA", state: "WA", postcode: "6532" },
{ city: "YUNA", state: "WA", postcode: "6532" },
{ city: "ALMA", state: "WA", postcode: "6535" },
{ city: "BOWES", state: "WA", postcode: "6535" },
{ city: "EAST BOWES", state: "WA", postcode: "6535" },
{ city: "GREGORY", state: "WA", postcode: "6535" },
{ city: "HORROCKS", state: "WA", postcode: "6535" },
{ city: "ISSEKA", state: "WA", postcode: "6535" },
{ city: "NORTHAMPTON", state: "WA", postcode: "6535" },
{ city: "OGILVIE", state: "WA", postcode: "6535" },
{ city: "SANDY GULLY", state: "WA", postcode: "6535" },
{ city: "YALLABATHARRA", state: "WA", postcode: "6535" },
{ city: "KALBARRI", state: "WA", postcode: "6536" },
{ city: "KALBARRI NATIONAL PARK", state: "WA", postcode: "6536" },
{ city: "ZUYTDORP", state: "WA", postcode: "6536" },
{ city: "DENHAM", state: "WA", postcode: "6537" },
{ city: "DIRK HARTOG ISLAND", state: "WA", postcode: "6537" },
{ city: "FRANCOIS PERON NATIONAL PARK", state: "WA", postcode: "6537" },
{ city: "MONKEY MIA", state: "WA", postcode: "6537" },
{ city: "NANGA", state: "WA", postcode: "6537" },
{ city: "SHARK BAY", state: "WA", postcode: "6537" },
{ city: "USELESS LOOP", state: "WA", postcode: "6537" },
{ city: "BEECHINA", state: "WA", postcode: "6556" },
{ city: "CHIDLOW", state: "WA", postcode: "6556" },
{ city: "GORRIE", state: "WA", postcode: "6556" },
{ city: "MALMALLING", state: "WA", postcode: "6556" },
{ city: "THE LAKES", state: "WA", postcode: "6556" },
{ city: "WOOROLOO", state: "WA", postcode: "6558" },
{ city: "WUNDOWIE", state: "WA", postcode: "6560" },
{ city: "BAKERS HILL", state: "WA", postcode: "6562" },
{ city: "COPLEY", state: "WA", postcode: "6562" },
{ city: "WOOTTATING", state: "WA", postcode: "6562" },
{ city: "CLACKLINE", state: "WA", postcode: "6564" },
{ city: "BEJOORDING", state: "WA", postcode: "6566" },
{ city: "CARANI", state: "WA", postcode: "6566" },
{ city: "COONDLE", state: "WA", postcode: "6566" },
{ city: "CULHAM", state: "WA", postcode: "6566" },
{ city: "DUMBARTON", state: "WA", postcode: "6566" },
{ city: "HODDYS WELL", state: "WA", postcode: "6566" },
{ city: "KATRINE", state: "WA", postcode: "6566" },
{ city: "NUNILE", state: "WA", postcode: "6566" },
{ city: "TOODYAY", state: "WA", postcode: "6566" },
{ city: "WEST TOODYAY", state: "WA", postcode: "6566" },
{ city: "DEWARS POOL", state: "WA", postcode: "6567" },
{ city: "JULIMAR", state: "WA", postcode: "6567" },
{ city: "MOONDYNE", state: "WA", postcode: "6567" },
{ city: "BOLGART", state: "WA", postcode: "6568" },
{ city: "WATTENING", state: "WA", postcode: "6568" },
{ city: "WYENING", state: "WA", postcode: "6568" },
{ city: "CALINGIRI", state: "WA", postcode: "6569" },
{ city: "OLD PLAINS", state: "WA", postcode: "6569" },
{ city: "YERECOIN", state: "WA", postcode: "6571" },
{ city: "PIAWANING", state: "WA", postcode: "6572" },
{ city: "BINDI BINDI", state: "WA", postcode: "6574" },
{ city: "GABALONG", state: "WA", postcode: "6574" },
{ city: "MILING", state: "WA", postcode: "6575" },
{ city: "KONNONGORRING", state: "WA", postcode: "6603" },
{ city: "LAKE HINDS", state: "WA", postcode: "6603" },
{ city: "LAKE NINAN", state: "WA", postcode: "6603" },
{ city: "MOCARDY", state: "WA", postcode: "6603" },
{ city: "WONGAN HILLS", state: "WA", postcode: "6603" },
{ city: "KONDUT", state: "WA", postcode: "6605" },
{ city: "BALLIDU", state: "WA", postcode: "6606" },
{ city: "EAST BALLIDU", state: "WA", postcode: "6606" },
{ city: "WEST BALLIDU", state: "WA", postcode: "6606" },
{ city: "EAST DAMBORING", state: "WA", postcode: "6608" },
{ city: "MARNE", state: "WA", postcode: "6608" },
{ city: "PITHARA", state: "WA", postcode: "6608" },
{ city: "DALWALLINU", state: "WA", postcode: "6609" },
{ city: "NUGADONG", state: "WA", postcode: "6609" },
{ city: "XANTIPPE", state: "WA", postcode: "6609" },
{ city: "JIBBERDING", state: "WA", postcode: "6612" },
{ city: "MIAMOON", state: "WA", postcode: "6612" },
{ city: "PAYNES FIND", state: "WA", postcode: "6612" },
{ city: "WUBIN", state: "WA", postcode: "6612" },
{ city: "BUNTINE", state: "WA", postcode: "6613" },
{ city: "MAYA", state: "WA", postcode: "6614" },
{ city: "LATHAM", state: "WA", postcode: "6616" },
{ city: "BUNJIL", state: "WA", postcode: "6620" },
{ city: "PERENJORI", state: "WA", postcode: "6620" },
{ city: "ROTHSAY", state: "WA", postcode: "6620" },
{ city: "BOWGADA", state: "WA", postcode: "6623" },
{ city: "BUNJIL", state: "WA", postcode: "6623" },
{ city: "GUTHA", state: "WA", postcode: "6623" },
{ city: "KOOLANOOKA", state: "WA", postcode: "6623" },
{ city: "MORAWA", state: "WA", postcode: "6623" },
{ city: "PINTHARUKA", state: "WA", postcode: "6623" },
{ city: "MERKANOOKA", state: "WA", postcode: "6625" },
{ city: "CANNA", state: "WA", postcode: "6627" },
{ city: "TARDUN", state: "WA", postcode: "6628" },
{ city: "DEVILS CREEK", state: "WA", postcode: "6630" },
{ city: "MULLEWA", state: "WA", postcode: "6630" },
{ city: "MURCHISON", state: "WA", postcode: "6630" },
{ city: "NERRAMYNE", state: "WA", postcode: "6630" },
{ city: "NUNIERRA", state: "WA", postcode: "6630" },
{ city: "WEST CASUARINAS", state: "WA", postcode: "6630" },
{ city: "WONGOONDY", state: "WA", postcode: "6630" },
{ city: "WOOLGORONG", state: "WA", postcode: "6630" },
{ city: "PINDAR", state: "WA", postcode: "6631" },
{ city: "AMBANIA", state: "WA", postcode: "6632" },
{ city: "TENINDEWA", state: "WA", postcode: "6632" },
{ city: "SOUTH MURCHISON", state: "WA", postcode: "6635" },
{ city: "YALGOO", state: "WA", postcode: "6635" },
{ city: "COOLADAR HILL", state: "WA", postcode: "6638" },
{ city: "DAGGAR HILLS", state: "WA", postcode: "6638" },
{ city: "MOUNT MAGNET", state: "WA", postcode: "6638" },
{ city: "PAYNESVILLE", state: "WA", postcode: "6638" },
{ city: "SANDSTONE", state: "WA", postcode: "6639" },
{ city: "CUE", state: "WA", postcode: "6640" },
{ city: "EAST MURCHISON", state: "WA", postcode: "6640" },
{ city: "LAKE AUSTIN", state: "WA", postcode: "6640" },
{ city: "REEDY", state: "WA", postcode: "6640" },
{ city: "WELD RANGE", state: "WA", postcode: "6640" },
{ city: "ANGELO RIVER", state: "WA", postcode: "6642" },
{ city: "CAPRICORN", state: "WA", postcode: "6642" },
{ city: "KARALUNDI", state: "WA", postcode: "6642" },
{ city: "KUMARINA", state: "WA", postcode: "6642" },
{ city: "MEEKATHARRA", state: "WA", postcode: "6642" },
{ city: "PEAK HILL", state: "WA", postcode: "6642" },
{ city: "LAKE CARNEGIE", state: "WA", postcode: "6646" },
{ city: "LITTLE SANDY DESERT", state: "WA", postcode: "6646" },
{ city: "WILUNA", state: "WA", postcode: "6646" },
{ city: "BABBAGE ISLAND", state: "WA", postcode: "6701" },
{ city: "BERNIER ISLAND", state: "WA", postcode: "6701" },
{ city: "BROCKMAN", state: "WA", postcode: "6701" },
{ city: "BROWN RANGE", state: "WA", postcode: "6701" },
{ city: "CARBLA", state: "WA", postcode: "6701" },
{ city: "CARNARVON", state: "WA", postcode: "6701" },
{ city: "CORAL BAY", state: "WA", postcode: "6701" },
{ city: "DORRE ISLAND", state: "WA", postcode: "6701" },
{ city: "EAST CARNARVON", state: "WA", postcode: "6701" },
{ city: "GILROYD", state: "WA", postcode: "6701" },
{ city: "GREYS PLAIN", state: "WA", postcode: "6701" },
{ city: "INGGARDA", state: "WA", postcode: "6701" },
{ city: "KENNEDY RANGE", state: "WA", postcode: "6701" },
{ city: "KINGSFORD", state: "WA", postcode: "6701" },
{ city: "LYNDON", state: "WA", postcode: "6701" },
{ city: "MACLEOD", state: "WA", postcode: "6701" },
{ city: "MASSEY BAY", state: "WA", postcode: "6701" },
{ city: "MINILYA", state: "WA", postcode: "6701" },
{ city: "MORGANTOWN", state: "WA", postcode: "6701" },
{ city: "NINGALOO", state: "WA", postcode: "6701" },
{ city: "NORTH PLANTATIONS", state: "WA", postcode: "6701" },
{ city: "SOUTH CARNARVON", state: "WA", postcode: "6701" },
{ city: "SOUTH PLANTATIONS", state: "WA", postcode: "6701" },
{ city: "TALISKER", state: "WA", postcode: "6701" },
{ city: "WOODLEIGH", state: "WA", postcode: "6701" },
{ city: "WOORAMEL", state: "WA", postcode: "6701" },
{ city: "YALARDY", state: "WA", postcode: "6701" },
{ city: "YANDOO CREEK", state: "WA", postcode: "6701" },
{ city: "EAST LYONS RIVER", state: "WA", postcode: "6705" },
{ city: "GASCOYNE JUNCTION", state: "WA", postcode: "6705" },
{ city: "GASCOYNE RIVER", state: "WA", postcode: "6705" },
{ city: "WEST LYONS RIVER", state: "WA", postcode: "6705" },
{ city: "CAPE RANGE NATIONAL PARK", state: "WA", postcode: "6707" },
{ city: "EXMOUTH", state: "WA", postcode: "6707" },
{ city: "EXMOUTH GULF", state: "WA", postcode: "6707" },
{ city: "LEARMONTH", state: "WA", postcode: "6707" },
{ city: "NORTH WEST CAPE", state: "WA", postcode: "6707" },
{ city: "CANE", state: "WA", postcode: "6710" },
{ city: "ONSLOW", state: "WA", postcode: "6710" },
{ city: "PEEDAMULLA", state: "WA", postcode: "6710" },
{ city: "TALANDJI", state: "WA", postcode: "6710" },
{ city: "YANNARIE", state: "WA", postcode: "6710" },
{ city: "THEVENARD ISLAND", state: "WA", postcode: "6711" },
{ city: "BARROW ISLAND", state: "WA", postcode: "6712" },
{ city: "DAMPIER", state: "WA", postcode: "6713" },
{ city: "DAMPIER ARCHIPELAGO", state: "WA", postcode: "6713" },
{ city: "ANTONYMYRE", state: "WA", postcode: "6714" },
{ city: "BALLA BALLA", state: "WA", postcode: "6714" },
{ city: "BAYNTON", state: "WA", postcode: "6714" },
{ city: "BULGARRA", state: "WA", postcode: "6714" },
{ city: "BURRUP", state: "WA", postcode: "6714" },
{ city: "CLEAVERVILLE", state: "WA", postcode: "6714" },
{ city: "COOYA POOYA", state: "WA", postcode: "6714" },
{ city: "GAP RIDGE", state: "WA", postcode: "6714" },
{ city: "GNOOREA", state: "WA", postcode: "6714" },
{ city: "KARRATHA", state: "WA", postcode: "6714" },
{ city: "KARRATHA INDUSTRIAL ESTATE", state: "WA", postcode: "6714" },
{ city: "MAITLAND", state: "WA", postcode: "6714" },
{ city: "MARDIE", state: "WA", postcode: "6714" },
{ city: "MILLARS WELL", state: "WA", postcode: "6714" },
{ city: "MOUNT ANKETELL", state: "WA", postcode: "6714" },
{ city: "MULATAGA", state: "WA", postcode: "6714" },
{ city: "NICKOL", state: "WA", postcode: "6714" },
{ city: "PEGS CREEK", state: "WA", postcode: "6714" },
{ city: "SHERLOCK", state: "WA", postcode: "6714" },
{ city: "STOVE HILL", state: "WA", postcode: "6714" },
{ city: "FORTESCUE", state: "WA", postcode: "6716" },
{ city: "HAMERSLEY RANGE", state: "WA", postcode: "6716" },
{ city: "MILLSTREAM", state: "WA", postcode: "6716" },
{ city: "PANNAWONICA", state: "WA", postcode: "6716" },
{ city: "ROEBOURNE", state: "WA", postcode: "6718" },
{ city: "WHIM CREEK", state: "WA", postcode: "6718" },
{ city: "COSSACK", state: "WA", postcode: "6720" },
{ city: "POINT SAMSON", state: "WA", postcode: "6720" },
{ city: "WICKHAM", state: "WA", postcode: "6720" },
{ city: "INDEE", state: "WA", postcode: "6721" },
{ city: "MUNDABULLANGANA", state: "WA", postcode: "6721" },
{ city: "PARDOO", state: "WA", postcode: "6721" },
{ city: "PORT HEDLAND", state: "WA", postcode: "6721" },
{ city: "REDBANK", state: "WA", postcode: "6721" },
{ city: "STRELLEY", state: "WA", postcode: "6721" },
{ city: "WALLAREENYA", state: "WA", postcode: "6721" },
{ city: "WEDGEFIELD", state: "WA", postcode: "6721" },
{ city: "BOODARIE", state: "WA", postcode: "6722" },
{ city: "DE GREY", state: "WA", postcode: "6722" },
{ city: "FINUCANE", state: "WA", postcode: "6722" },
{ city: "PIPPINGARRA", state: "WA", postcode: "6722" },
{ city: "SOUTH HEDLAND", state: "WA", postcode: "6722" },
{ city: "BILINGURR", state: "WA", postcode: "6725" },
{ city: "BROOME", state: "WA", postcode: "6725" },
{ city: "DAMPIER PENINSULA", state: "WA", postcode: "6725" },
{ city: "DJUGUN", state: "WA", postcode: "6725" },
{ city: "EIGHTY MILE BEACH", state: "WA", postcode: "6725" },
{ city: "GINGERAH", state: "WA", postcode: "6725" },
{ city: "LAGRANGE", state: "WA", postcode: "6725" },
{ city: "MINYIRR", state: "WA", postcode: "6725" },
{ city: "ROEBUCK", state: "WA", postcode: "6725" },
{ city: "WATERBANK", state: "WA", postcode: "6725" },
{ city: "CABLE BEACH", state: "WA", postcode: "6726" },
{ city: "CAMBALLIN", state: "WA", postcode: "6728" },
{ city: "DERBY", state: "WA", postcode: "6728" },
{ city: "GEEGULLY CREEK", state: "WA", postcode: "6728" },
{ city: "KIMBOLTON", state: "WA", postcode: "6728" },
{ city: "KING LEOPOLD RANGES", state: "WA", postcode: "6728" },
{ city: "MEDA", state: "WA", postcode: "6728" },
{ city: "ST GEORGE RANGES", state: "WA", postcode: "6728" },
{ city: "WILLARE", state: "WA", postcode: "6728" },
{ city: "COCKATOO ISLAND", state: "WA", postcode: "6731" },
{ city: "KOOLAN ISLAND", state: "WA", postcode: "6733" },
{ city: "DRYSDALE RIVER", state: "WA", postcode: "6740" },
{ city: "KALUMBURU", state: "WA", postcode: "6740" },
{ city: "MITCHELL PLATEAU", state: "WA", postcode: "6740" },
{ city: "OOMBULGURRI", state: "WA", postcode: "6740" },
{ city: "PRINCE REGENT RIVER", state: "WA", postcode: "6740" },
{ city: "WYNDHAM", state: "WA", postcode: "6740" },
{ city: "CAMBRIDGE GULF", state: "WA", postcode: "6743" },
{ city: "DURACK", state: "WA", postcode: "6743" },
{ city: "GIBB", state: "WA", postcode: "6743" },
{ city: "KUNUNURRA", state: "WA", postcode: "6743" },
{ city: "LAKE ARGYLE", state: "WA", postcode: "6743" },
{ city: "WARMUN", state: "WA", postcode: "6743" },
{ city: "CHICHESTER", state: "WA", postcode: "6751" },
{ city: "INNAWANGA", state: "WA", postcode: "6751" },
{ city: "JUNA DOWNS", state: "WA", postcode: "6751" },
{ city: "KARIJINI", state: "WA", postcode: "6751" },
{ city: "MOUNT SHEILA", state: "WA", postcode: "6751" },
{ city: "MULGA DOWNS", state: "WA", postcode: "6751" },
{ city: "NANUTARRA", state: "WA", postcode: "6751" },
{ city: "ROCKLEA", state: "WA", postcode: "6751" },
{ city: "TOM PRICE", state: "WA", postcode: "6751" },
{ city: "WITTENOOM", state: "WA", postcode: "6751" },
{ city: "NEWMAN", state: "WA", postcode: "6753" },
{ city: "PARABURDOO", state: "WA", postcode: "6754" },
{ city: "NULLAGINE", state: "WA", postcode: "6758" },
{ city: "MARBLE BAR", state: "WA", postcode: "6760" },
{ city: "TELFER", state: "WA", postcode: "6762" },
{ city: "FITZROY CROSSING", state: "WA", postcode: "6765" },
{ city: "MOUNT HARDMAN", state: "WA", postcode: "6765" },
{ city: "HALLS CREEK", state: "WA", postcode: "6770" },
{ city: "MCBEATH", state: "WA", postcode: "6770" },
{ city: "MUELLER RANGES", state: "WA", postcode: "6770" },
{ city: "ORD RIVER", state: "WA", postcode: "6770" },
{ city: "PURNULULU", state: "WA", postcode: "6770" },
{ city: "STURT CREEK", state: "WA", postcode: "6770" },
{ city: "TANAMI", state: "WA", postcode: "6770" },
{ city: "CHRISTMAS ISLAND", state: "WA", postcode: "6798" },
{ city: "HOME ISLAND COCOS (KEELING) ISLANDS", state: "WA", postcode: "6799" },
{ city: "WEST ISLAND COCOS (KEELING) ISLANDS", state: "WA", postcode: "6799" },



{ city: "HMAS CRESWELL", state: "ACT", postcode: "2540" },
{ city: "JERVIS BAY", state: "ACT", postcode: "2540" },
{ city: "WRECK BAY", state: "ACT", postcode: "2540" },
{ city: "BARTON", state: "ACT", postcode: "2600" },
{ city: "CANBERRA", state: "ACT", postcode: "2600" },
{ city: "CAPITAL HILL", state: "ACT", postcode: "2600" },
{ city: "DEAKIN", state: "ACT", postcode: "2600" },
{ city: "DEAKIN WEST", state: "ACT", postcode: "2600" },
{ city: "DUNTROON", state: "ACT", postcode: "2600" },
{ city: "HARMAN", state: "ACT", postcode: "2600" },
{ city: "HMAS HARMAN", state: "ACT", postcode: "2600" },
{ city: "JERRABOMBERRA", state: "ACT", postcode: "2600" },
{ city: "PARKES", state: "ACT", postcode: "2600" },
{ city: "PARLIAMENT HOUSE", state: "ACT", postcode: "2600" },
{ city: "RUSSELL", state: "ACT", postcode: "2600" },
{ city: "RUSSELL HILL", state: "ACT", postcode: "2600" },
{ city: "YARRALUMLA", state: "ACT", postcode: "2600" },
{ city: "ACTON", state: "ACT", postcode: "2601" },
{ city: "BLACK MOUNTAIN", state: "ACT", postcode: "2601" },
{ city: "CANBERRA", state: "ACT", postcode: "2601" },
{ city: "CANBERRA CENTRAL", state: "ACT", postcode: "2601" },
{ city: "CITY", state: "ACT", postcode: "2601" },
{ city: "AINSLIE", state: "ACT", postcode: "2602" },
{ city: "CANBERRA CENTRAL", state: "ACT", postcode: "2602" },
{ city: "DICKSON", state: "ACT", postcode: "2602" },
{ city: "DOWNER", state: "ACT", postcode: "2602" },
{ city: "HACKETT", state: "ACT", postcode: "2602" },
{ city: "LYNEHAM", state: "ACT", postcode: "2602" },
{ city: "O'CONNOR", state: "ACT", postcode: "2602" },
{ city: "WATSON", state: "ACT", postcode: "2602" },
{ city: "FORREST", state: "ACT", postcode: "2603" },
{ city: "GRIFFITH", state: "ACT", postcode: "2603" },
{ city: "MANUKA", state: "ACT", postcode: "2603" },
{ city: "RED HILL", state: "ACT", postcode: "2603" },
{ city: "CAUSEWAY", state: "ACT", postcode: "2604" },
{ city: "KINGSTON", state: "ACT", postcode: "2604" },
{ city: "NARRABUNDAH", state: "ACT", postcode: "2604" },
{ city: "CURTIN", state: "ACT", postcode: "2605" },
{ city: "GARRAN", state: "ACT", postcode: "2605" },
{ city: "HUGHES", state: "ACT", postcode: "2605" },
{ city: "CHIFLEY", state: "ACT", postcode: "2606" },
{ city: "LYONS", state: "ACT", postcode: "2606" },
{ city: "O'MALLEY", state: "ACT", postcode: "2606" },
{ city: "PHILLIP", state: "ACT", postcode: "2606" },
{ city: "PHILLIP DC", state: "ACT", postcode: "2606" },
{ city: "SWINGER HILL", state: "ACT", postcode: "2606" },
{ city: "WODEN", state: "ACT", postcode: "2606" },
{ city: "FARRER", state: "ACT", postcode: "2607" },
{ city: "ISAACS", state: "ACT", postcode: "2607" },
{ city: "MAWSON", state: "ACT", postcode: "2607" },
{ city: "PEARCE", state: "ACT", postcode: "2607" },
{ city: "TORRENS", state: "ACT", postcode: "2607" },
{ city: "CIVIC SQUARE", state: "ACT", postcode: "2608" },
{ city: "CANBERRA AIRPORT", state: "ACT", postcode: "2609" },
{ city: "CANBERRA INTERNATIONAL AIRPORT", state: "ACT", postcode: "2609" },
{ city: "FYSHWICK", state: "ACT", postcode: "2609" },
{ city: "MAJURA", state: "ACT", postcode: "2609" },
{ city: "PIALLIGO", state: "ACT", postcode: "2609" },
{ city: "SYMONSTON", state: "ACT", postcode: "2609" },
{ city: "CANBERRA MC", state: "ACT", postcode: "2610" },
{ city: "CHAPMAN", state: "ACT", postcode: "2611" },
{ city: "COOMBS", state: "ACT", postcode: "2611" },
{ city: "COREE", state: "ACT", postcode: "2611" },
{ city: "COTTER RIVER", state: "ACT", postcode: "2611" },
{ city: "DENMAN PROSPECT", state: "ACT", postcode: "2611" },
{ city: "DUFFY", state: "ACT", postcode: "2611" },
{ city: "FISHER", state: "ACT", postcode: "2611" },
{ city: "HOLDER", state: "ACT", postcode: "2611" },
{ city: "MOLONGLO VALLEY", state: "ACT", postcode: "2611" },
{ city: "MOUNT STROMLO", state: "ACT", postcode: "2611" },
{ city: "PIERCES CREEK", state: "ACT", postcode: "2611" },
{ city: "RIVETT", state: "ACT", postcode: "2611" },
{ city: "STIRLING", state: "ACT", postcode: "2611" },
{ city: "STROMLO", state: "ACT", postcode: "2611" },
{ city: "URIARRA", state: "ACT", postcode: "2611" },
{ city: "URIARRA FOREST", state: "ACT", postcode: "2611" },
{ city: "URIARRA VILLAGE", state: "ACT", postcode: "2611" },
{ city: "WARAMANGA", state: "ACT", postcode: "2611" },
{ city: "WESTON", state: "ACT", postcode: "2611" },
{ city: "WESTON CREEK", state: "ACT", postcode: "2611" },
{ city: "WRIGHT", state: "ACT", postcode: "2611" },
{ city: "BRADDON", state: "ACT", postcode: "2612" },
{ city: "CAMPBELL", state: "ACT", postcode: "2612" },
{ city: "REID", state: "ACT", postcode: "2612" },
{ city: "TURNER", state: "ACT", postcode: "2612" },
{ city: "ARANDA", state: "ACT", postcode: "2614" },
{ city: "COOK", state: "ACT", postcode: "2614" },
{ city: "HAWKER", state: "ACT", postcode: "2614" },
{ city: "JAMISON CENTRE", state: "ACT", postcode: "2614" },
{ city: "MACQUARIE", state: "ACT", postcode: "2614" },
{ city: "PAGE", state: "ACT", postcode: "2614" },
{ city: "SCULLIN", state: "ACT", postcode: "2614" },
{ city: "WEETANGERA", state: "ACT", postcode: "2614" },
{ city: "CHARNWOOD", state: "ACT", postcode: "2615" },
{ city: "DUNLOP", state: "ACT", postcode: "2615" },
{ city: "FLOREY", state: "ACT", postcode: "2615" },
{ city: "FLYNN", state: "ACT", postcode: "2615" },
{ city: "FRASER", state: "ACT", postcode: "2615" },
{ city: "HIGGINS", state: "ACT", postcode: "2615" },
{ city: "HOLT", state: "ACT", postcode: "2615" },
{ city: "KIPPAX", state: "ACT", postcode: "2615" },
{ city: "LATHAM", state: "ACT", postcode: "2615" },
{ city: "MACGREGOR", state: "ACT", postcode: "2615" },
{ city: "MELBA", state: "ACT", postcode: "2615" },
{ city: "SPENCE", state: "ACT", postcode: "2615" },
{ city: "STRATHNAIRN", state: "ACT", postcode: "2615" },
{ city: "BELCONNEN", state: "ACT", postcode: "2617" },
{ city: "BELCONNEN DC", state: "ACT", postcode: "2617" },
{ city: "BRUCE", state: "ACT", postcode: "2617" },
{ city: "EVATT", state: "ACT", postcode: "2617" },
{ city: "GIRALANG", state: "ACT", postcode: "2617" },
{ city: "KALEEN", state: "ACT", postcode: "2617" },
{ city: "LAWSON", state: "ACT", postcode: "2617" },
{ city: "MCKELLAR", state: "ACT", postcode: "2617" },
{ city: "UNIVERSITY OF CANBERRA", state: "ACT", postcode: "2617" },
{ city: "HALL", state: "ACT", postcode: "2618" },
{ city: "BEARD", state: "ACT", postcode: "2620" },
{ city: "BOOTH", state: "ACT", postcode: "2620" },
{ city: "HUME", state: "ACT", postcode: "2620" },
{ city: "JERRABOMBERRA", state: "ACT", postcode: "2620" },
{ city: "KOWEN", state: "ACT", postcode: "2620" },
{ city: "PADDYS RIVER", state: "ACT", postcode: "2620" },
{ city: "RENDEZVOUS CREEK", state: "ACT", postcode: "2620" },
{ city: "TENNENT", state: "ACT", postcode: "2620" },
{ city: "GREENWAY", state: "ACT", postcode: "2900" },
{ city: "TUGGERANONG", state: "ACT", postcode: "2900" },
{ city: "TUGGERANONG DC", state: "ACT", postcode: "2901" },
{ city: "KAMBAH", state: "ACT", postcode: "2902" },
{ city: "KAMBAH VILLAGE", state: "ACT", postcode: "2902" },
{ city: "ERINDALE CENTRE", state: "ACT", postcode: "2903" },
{ city: "OXLEY", state: "ACT", postcode: "2903" },
{ city: "WANNIASSA", state: "ACT", postcode: "2903" },
{ city: "FADDEN", state: "ACT", postcode: "2904" },
{ city: "GOWRIE", state: "ACT", postcode: "2904" },
{ city: "MACARTHUR", state: "ACT", postcode: "2904" },
{ city: "MONASH", state: "ACT", postcode: "2904" },
{ city: "BONYTHON", state: "ACT", postcode: "2905" },
{ city: "CALWELL", state: "ACT", postcode: "2905" },
{ city: "CHISHOLM", state: "ACT", postcode: "2905" },
{ city: "GILMORE", state: "ACT", postcode: "2905" },
{ city: "ISABELLA PLAINS", state: "ACT", postcode: "2905" },
{ city: "RICHARDSON", state: "ACT", postcode: "2905" },
{ city: "THEODORE", state: "ACT", postcode: "2905" },
{ city: "BANKS", state: "ACT", postcode: "2906" },
{ city: "CONDER", state: "ACT", postcode: "2906" },
{ city: "GORDON", state: "ACT", postcode: "2906" },
{ city: "CRACE", state: "ACT", postcode: "2911" },
{ city: "MITCHELL", state: "ACT", postcode: "2911" },
{ city: "GUNGAHLIN", state: "ACT", postcode: "2912" },
{ city: "CASEY", state: "ACT", postcode: "2913" },
{ city: "FRANKLIN", state: "ACT", postcode: "2913" },
{ city: "GINNINDERRA VILLAGE", state: "ACT", postcode: "2913" },
{ city: "KINLYSIDE", state: "ACT", postcode: "2913" },
{ city: "NGUNNAWAL", state: "ACT", postcode: "2913" },
{ city: "NICHOLLS", state: "ACT", postcode: "2913" },
{ city: "PALMERSTON", state: "ACT", postcode: "2913" },
{ city: "TAYLOR", state: "ACT", postcode: "2913" },
{ city: "AMAROO", state: "ACT", postcode: "2914" },
{ city: "BONNER", state: "ACT", postcode: "2914" },
{ city: "FORDE", state: "ACT", postcode: "2914" },
{ city: "HARRISON", state: "ACT", postcode: "2914" },
{ city: "JACKA", state: "ACT", postcode: "2914" },
{ city: "MONCRIEFF", state: "ACT", postcode: "2914" },
{ city: "THROSBY", state: "ACT", postcode: "2914" },
{ city: "ROYAL EXCHANGE", state: "NSW", postcode: "1225" },
{ city: "FRENCHS FOREST", state: "NSW", postcode: "1640" },
{ city: "BARANGAROO", state: "NSW", postcode: "2000" },
{ city: "CIRCULAR QUAY", state: "NSW", postcode: "2000" },
{ city: "DARLING HARBOUR", state: "NSW", postcode: "2000" },
{ city: "DAWES POINT", state: "NSW", postcode: "2000" },
{ city: "HAYMARKET", state: "NSW", postcode: "2000" },
{ city: "MILLERS POINT", state: "NSW", postcode: "2000" },
{ city: "PARLIAMENT HOUSE", state: "NSW", postcode: "2000" },
{ city: "SYDNEY", state: "NSW", postcode: "2000" },
{ city: "SYDNEY SOUTH", state: "NSW", postcode: "2000" },
{ city: "THE ROCKS", state: "NSW", postcode: "2000" },
{ city: "WALSH BAY", state: "NSW", postcode: "2000" },
{ city: "SYDNEY", state: "NSW", postcode: "2001" },
{ city: "WORLD SQUARE", state: "NSW", postcode: "2002" },
{ city: "SYDNEY UNIVERSITY", state: "NSW", postcode: "2006" },
{ city: "THE UNIVERSITY OF SYDNEY", state: "NSW", postcode: "2006" },
{ city: "BROADWAY", state: "NSW", postcode: "2007" },
{ city: "ULTIMO", state: "NSW", postcode: "2007" },
{ city: "CHIPPENDALE", state: "NSW", postcode: "2008" },
{ city: "DARLINGTON", state: "NSW", postcode: "2008" },
{ city: "PYRMONT", state: "NSW", postcode: "2009" },
{ city: "DARLINGHURST", state: "NSW", postcode: "2010" },
{ city: "STRAWBERRY HILLS", state: "NSW", postcode: "2010" },
{ city: "SURRY HILLS", state: "NSW", postcode: "2010" },
{ city: "EAST SYDNEY", state: "NSW", postcode: "2011" },
{ city: "ELIZABETH BAY", state: "NSW", postcode: "2011" },
{ city: "HMAS KUTTABUL", state: "NSW", postcode: "2011" },
{ city: "KINGS CROSS", state: "NSW", postcode: "2011" },
{ city: "POTTS POINT", state: "NSW", postcode: "2011" },
{ city: "RUSHCUTTERS BAY", state: "NSW", postcode: "2011" },
{ city: "WOOLLOOMOOLOO", state: "NSW", postcode: "2011" },
{ city: "STRAWBERRY HILLS", state: "NSW", postcode: "2012" },
{ city: "ALEXANDRIA", state: "NSW", postcode: "2015" },
{ city: "BEACONSFIELD", state: "NSW", postcode: "2015" },
{ city: "EVELEIGH", state: "NSW", postcode: "2015" },
{ city: "REDFERN", state: "NSW", postcode: "2016" },
{ city: "WATERLOO", state: "NSW", postcode: "2017" },
{ city: "WATERLOO DC", state: "NSW", postcode: "2017" },
{ city: "ZETLAND", state: "NSW", postcode: "2017" },
{ city: "EASTLAKES", state: "NSW", postcode: "2018" },
{ city: "ROSEBERY", state: "NSW", postcode: "2018" },
{ city: "BANKSMEADOW", state: "NSW", postcode: "2019" },
{ city: "BOTANY", state: "NSW", postcode: "2019" },
{ city: "BOTANY BAY", state: "NSW", postcode: "2019" },
{ city: "MASCOT", state: "NSW", postcode: "2020" },
{ city: "SYDNEY AIRPORT", state: "NSW", postcode: "2020" },
{ city: "SYDNEY DOMESTIC AIRPORT", state: "NSW", postcode: "2020" },
{ city: "SYDNEY INTERNATIONAL AIRPORT", state: "NSW", postcode: "2020" },
{ city: "CENTENNIAL PARK", state: "NSW", postcode: "2021" },
{ city: "MOORE PARK", state: "NSW", postcode: "2021" },
{ city: "PADDINGTON", state: "NSW", postcode: "2021" },
{ city: "BONDI JUNCTION", state: "NSW", postcode: "2022" },
{ city: "BONDI JUNCTION PLAZA", state: "NSW", postcode: "2022" },
{ city: "QUEENS PARK", state: "NSW", postcode: "2022" },
{ city: "BELLEVUE HILL", state: "NSW", postcode: "2023" },
{ city: "BRONTE", state: "NSW", postcode: "2024" },
{ city: "WAVERLEY", state: "NSW", postcode: "2024" },
{ city: "WOOLLAHRA", state: "NSW", postcode: "2025" },
{ city: "BONDI", state: "NSW", postcode: "2026" },
{ city: "BONDI BEACH", state: "NSW", postcode: "2026" },
{ city: "NORTH BONDI", state: "NSW", postcode: "2026" },
{ city: "TAMARAMA", state: "NSW", postcode: "2026" },
{ city: "DARLING POINT", state: "NSW", postcode: "2027" },
{ city: "EDGECLIFF", state: "NSW", postcode: "2027" },
{ city: "HMAS RUSHCUTTERS", state: "NSW", postcode: "2027" },
{ city: "POINT PIPER", state: "NSW", postcode: "2027" },
{ city: "DOUBLE BAY", state: "NSW", postcode: "2028" },
{ city: "ROSE BAY", state: "NSW", postcode: "2029" },
{ city: "DOVER HEIGHTS", state: "NSW", postcode: "2030" },
{ city: "HMAS WATSON", state: "NSW", postcode: "2030" },
{ city: "ROSE BAY NORTH", state: "NSW", postcode: "2030" },
{ city: "VAUCLUSE", state: "NSW", postcode: "2030" },
{ city: "WATSONS BAY", state: "NSW", postcode: "2030" },
{ city: "CLOVELLY", state: "NSW", postcode: "2031" },
{ city: "CLOVELLY WEST", state: "NSW", postcode: "2031" },
{ city: "RANDWICK", state: "NSW", postcode: "2031" },
{ city: "RANDWICK DC", state: "NSW", postcode: "2031" },
{ city: "ST PAULS", state: "NSW", postcode: "2031" },
{ city: "DACEYVILLE", state: "NSW", postcode: "2032" },
{ city: "KINGSFORD", state: "NSW", postcode: "2032" },
{ city: "KENSINGTON", state: "NSW", postcode: "2033" },
{ city: "COOGEE", state: "NSW", postcode: "2034" },
{ city: "SOUTH COOGEE", state: "NSW", postcode: "2034" },
{ city: "MAROUBRA", state: "NSW", postcode: "2035" },
{ city: "MAROUBRA SOUTH", state: "NSW", postcode: "2035" },
{ city: "PAGEWOOD", state: "NSW", postcode: "2035" },
{ city: "CHIFLEY", state: "NSW", postcode: "2036" },
{ city: "EASTGARDENS", state: "NSW", postcode: "2036" },
{ city: "HILLSDALE", state: "NSW", postcode: "2036" },
{ city: "LA PEROUSE", state: "NSW", postcode: "2036" },
{ city: "LITTLE BAY", state: "NSW", postcode: "2036" },
{ city: "MALABAR", state: "NSW", postcode: "2036" },
{ city: "MATRAVILLE", state: "NSW", postcode: "2036" },
{ city: "PHILLIP BAY", state: "NSW", postcode: "2036" },
{ city: "PORT BOTANY", state: "NSW", postcode: "2036" },
{ city: "FOREST LODGE", state: "NSW", postcode: "2037" },
{ city: "GLEBE", state: "NSW", postcode: "2037" },
{ city: "ANNANDALE", state: "NSW", postcode: "2038" },
{ city: "ROZELLE", state: "NSW", postcode: "2039" },
{ city: "LEICHHARDT", state: "NSW", postcode: "2040" },
{ city: "LILYFIELD", state: "NSW", postcode: "2040" },
{ city: "BALMAIN", state: "NSW", postcode: "2041" },
{ city: "BALMAIN EAST", state: "NSW", postcode: "2041" },
{ city: "BIRCHGROVE", state: "NSW", postcode: "2041" },
{ city: "ENMORE", state: "NSW", postcode: "2042" },
{ city: "NEWTOWN", state: "NSW", postcode: "2042" },
{ city: "ERSKINEVILLE", state: "NSW", postcode: "2043" },
{ city: "ST PETERS", state: "NSW", postcode: "2044" },
{ city: "SYDENHAM", state: "NSW", postcode: "2044" },
{ city: "TEMPE", state: "NSW", postcode: "2044" },
{ city: "HABERFIELD", state: "NSW", postcode: "2045" },
{ city: "ABBOTSFORD", state: "NSW", postcode: "2046" },
{ city: "CANADA BAY", state: "NSW", postcode: "2046" },
{ city: "CHISWICK", state: "NSW", postcode: "2046" },
{ city: "FIVE DOCK", state: "NSW", postcode: "2046" },
{ city: "RODD POINT", state: "NSW", postcode: "2046" },
{ city: "RUSSELL LEA", state: "NSW", postcode: "2046" },
{ city: "WAREEMBA", state: "NSW", postcode: "2046" },
{ city: "DRUMMOYNE", state: "NSW", postcode: "2047" },
{ city: "STANMORE", state: "NSW", postcode: "2048" },
{ city: "WESTGATE", state: "NSW", postcode: "2048" },
{ city: "LEWISHAM", state: "NSW", postcode: "2049" },
{ city: "PETERSHAM", state: "NSW", postcode: "2049" },
{ city: "PETERSHAM NORTH", state: "NSW", postcode: "2049" },
{ city: "CAMPERDOWN", state: "NSW", postcode: "2050" },
{ city: "MISSENDEN ROAD", state: "NSW", postcode: "2050" },
{ city: "NORTH SYDNEY", state: "NSW", postcode: "2055" },
{ city: "CHATSWOOD", state: "NSW", postcode: "2057" },
{ city: "NORTH SYDNEY", state: "NSW", postcode: "2059" },
{ city: "HMAS PLATYPUS", state: "NSW", postcode: "2060" },
{ city: "HMAS WATERHEN", state: "NSW", postcode: "2060" },
{ city: "LAVENDER BAY", state: "NSW", postcode: "2060" },
{ city: "MCMAHONS POINT", state: "NSW", postcode: "2060" },
{ city: "NORTH SYDNEY", state: "NSW", postcode: "2060" },
{ city: "NORTH SYDNEY SHOPPINGWORLD", state: "NSW", postcode: "2060" },
{ city: "WAVERTON", state: "NSW", postcode: "2060" },
{ city: "KIRRIBILLI", state: "NSW", postcode: "2061" },
{ city: "MILSONS POINT", state: "NSW", postcode: "2061" },
{ city: "CAMMERAY", state: "NSW", postcode: "2062" },
{ city: "NORTHBRIDGE", state: "NSW", postcode: "2063" },
{ city: "ARTARMON", state: "NSW", postcode: "2064" },
{ city: "CROWS NEST", state: "NSW", postcode: "2065" },
{ city: "CROWS NEST DC", state: "NSW", postcode: "2065" },
{ city: "GREENWICH", state: "NSW", postcode: "2065" },
{ city: "NAREMBURN", state: "NSW", postcode: "2065" },
{ city: "ROYAL NORTH SHORE HOSPITAL", state: "NSW", postcode: "2065" },
{ city: "ST LEONARDS", state: "NSW", postcode: "2065" },
{ city: "WOLLSTONECRAFT", state: "NSW", postcode: "2065" },
{ city: "LANE COVE", state: "NSW", postcode: "2066" },
{ city: "LANE COVE NORTH", state: "NSW", postcode: "2066" },
{ city: "LANE COVE WEST", state: "NSW", postcode: "2066" },
{ city: "LINLEY POINT", state: "NSW", postcode: "2066" },
{ city: "LONGUEVILLE", state: "NSW", postcode: "2066" },
{ city: "NORTHWOOD", state: "NSW", postcode: "2066" },
{ city: "RIVERVIEW", state: "NSW", postcode: "2066" },
{ city: "CHATSWOOD", state: "NSW", postcode: "2067" },
{ city: "CHATSWOOD DC", state: "NSW", postcode: "2067" },
{ city: "CHATSWOOD WEST", state: "NSW", postcode: "2067" },
{ city: "CASTLECRAG", state: "NSW", postcode: "2068" },
{ city: "MIDDLE COVE", state: "NSW", postcode: "2068" },
{ city: "NORTH WILLOUGHBY", state: "NSW", postcode: "2068" },
{ city: "WILLOUGHBY", state: "NSW", postcode: "2068" },
{ city: "WILLOUGHBY EAST", state: "NSW", postcode: "2068" },
{ city: "WILLOUGHBY NORTH", state: "NSW", postcode: "2068" },
{ city: "CASTLE COVE", state: "NSW", postcode: "2069" },
{ city: "ROSEVILLE", state: "NSW", postcode: "2069" },
{ city: "ROSEVILLE CHASE", state: "NSW", postcode: "2069" },
{ city: "EAST LINDFIELD", state: "NSW", postcode: "2070" },
{ city: "LINDFIELD", state: "NSW", postcode: "2070" },
{ city: "LINDFIELD WEST", state: "NSW", postcode: "2070" },
{ city: "EAST KILLARA", state: "NSW", postcode: "2071" },
{ city: "KILLARA", state: "NSW", postcode: "2071" },
{ city: "GORDON", state: "NSW", postcode: "2072" },
{ city: "PYMBLE", state: "NSW", postcode: "2073" },
{ city: "WEST PYMBLE", state: "NSW", postcode: "2073" },
{ city: "NORTH TURRAMURRA", state: "NSW", postcode: "2074" },
{ city: "SOUTH TURRAMURRA", state: "NSW", postcode: "2074" },
{ city: "TURRAMURRA", state: "NSW", postcode: "2074" },
{ city: "WARRAWEE", state: "NSW", postcode: "2074" },
{ city: "ST IVES", state: "NSW", postcode: "2075" },
{ city: "ST IVES CHASE", state: "NSW", postcode: "2075" },
{ city: "NORMANHURST", state: "NSW", postcode: "2076" },
{ city: "NORTH WAHROONGA", state: "NSW", postcode: "2076" },
{ city: "WAHROONGA", state: "NSW", postcode: "2076" },
{ city: "ASQUITH", state: "NSW", postcode: "2077" },
{ city: "HORNSBY", state: "NSW", postcode: "2077" },
{ city: "HORNSBY HEIGHTS", state: "NSW", postcode: "2077" },
{ city: "WAITARA", state: "NSW", postcode: "2077" },
{ city: "MOUNT COLAH", state: "NSW", postcode: "2079" },
{ city: "MT COLAH", state: "NSW", postcode: "2079" },
{ city: "MOUNT KURING-GAI", state: "NSW", postcode: "2080" },
{ city: "MT KURING-GAI", state: "NSW", postcode: "2080" },
{ city: "BEROWRA", state: "NSW", postcode: "2081" },
{ city: "COWAN", state: "NSW", postcode: "2081" },
{ city: "BEROWRA HEIGHTS", state: "NSW", postcode: "2082" },
{ city: "BEROWRA WATERS", state: "NSW", postcode: "2082" },
{ city: "TERREY HILLS", state: "NSW", postcode: "2084" },
{ city: "BELROSE", state: "NSW", postcode: "2085" },
{ city: "BELROSE WEST", state: "NSW", postcode: "2085" },
{ city: "DAVIDSON", state: "NSW", postcode: "2085" },
{ city: "FRENCHS FOREST", state: "NSW", postcode: "2086" },
{ city: "FRENCHS FOREST EAST", state: "NSW", postcode: "2086" },
{ city: "FORESTVILLE", state: "NSW", postcode: "2087" },
{ city: "KILLARNEY HEIGHTS", state: "NSW", postcode: "2087" },
{ city: "MIDDLE HARBOUR", state: "NSW", postcode: "2087" },
{ city: "BALMORAL", state: "NSW", postcode: "2088" },
{ city: "BALMORAL BEACH", state: "NSW", postcode: "2088" },
{ city: "CLIFTON GARDENS", state: "NSW", postcode: "2088" },
{ city: "MOSMAN", state: "NSW", postcode: "2088" },
{ city: "SPIT JUNCTION", state: "NSW", postcode: "2088" },
{ city: "KURRABA POINT", state: "NSW", postcode: "2089" },
{ city: "NEUTRAL BAY", state: "NSW", postcode: "2089" },
{ city: "NEUTRAL BAY JUNCTION", state: "NSW", postcode: "2089" },
{ city: "CREMORNE", state: "NSW", postcode: "2090" },
{ city: "CREMORNE JUNCTION", state: "NSW", postcode: "2090" },
{ city: "CREMORNE POINT", state: "NSW", postcode: "2090" },
{ city: "SEAFORTH", state: "NSW", postcode: "2092" },
{ city: "BALGOWLAH", state: "NSW", postcode: "2093" },
{ city: "BALGOWLAH HEIGHTS", state: "NSW", postcode: "2093" },
{ city: "CLONTARF", state: "NSW", postcode: "2093" },
{ city: "MANLY VALE", state: "NSW", postcode: "2093" },
{ city: "NORTH BALGOWLAH", state: "NSW", postcode: "2093" },
{ city: "FAIRLIGHT", state: "NSW", postcode: "2094" },
{ city: "MANLY", state: "NSW", postcode: "2095" },
{ city: "MANLY EAST", state: "NSW", postcode: "2095" },
{ city: "CURL CURL", state: "NSW", postcode: "2096" },
{ city: "FRESHWATER", state: "NSW", postcode: "2096" },
{ city: "QUEENSCLIFF", state: "NSW", postcode: "2096" },
{ city: "COLLAROY", state: "NSW", postcode: "2097" },
{ city: "COLLAROY BEACH", state: "NSW", postcode: "2097" },
{ city: "COLLAROY PLATEAU", state: "NSW", postcode: "2097" },
{ city: "COLLAROY PLATEAU WEST", state: "NSW", postcode: "2097" },
{ city: "WHEELER HEIGHTS", state: "NSW", postcode: "2097" },
{ city: "CROMER", state: "NSW", postcode: "2099" },
{ city: "DEE WHY", state: "NSW", postcode: "2099" },
{ city: "NARRAWEENA", state: "NSW", postcode: "2099" },
{ city: "NORTH CURL CURL", state: "NSW", postcode: "2099" },
{ city: "ALLAMBIE HEIGHTS", state: "NSW", postcode: "2100" },
{ city: "BEACON HILL", state: "NSW", postcode: "2100" },
{ city: "BROOKVALE", state: "NSW", postcode: "2100" },
{ city: "NORTH MANLY", state: "NSW", postcode: "2100" },
{ city: "OXFORD FALLS", state: "NSW", postcode: "2100" },
{ city: "WARRINGAH MALL", state: "NSW", postcode: "2100" },
{ city: "ELANORA HEIGHTS", state: "NSW", postcode: "2101" },
{ city: "INGLESIDE", state: "NSW", postcode: "2101" },
{ city: "NARRABEEN", state: "NSW", postcode: "2101" },
{ city: "NORTH NARRABEEN", state: "NSW", postcode: "2101" },
{ city: "WARRIEWOOD", state: "NSW", postcode: "2102" },
{ city: "WARRIEWOOD DC", state: "NSW", postcode: "2102" },
{ city: "WARRIEWOOD SHOPPING SQUARE", state: "NSW", postcode: "2102" },
{ city: "MONA VALE", state: "NSW", postcode: "2103" },
{ city: "BAYVIEW", state: "NSW", postcode: "2104" },
{ city: "CHURCH POINT", state: "NSW", postcode: "2105" },
{ city: "ELVINA BAY", state: "NSW", postcode: "2105" },
{ city: "LOVETT BAY", state: "NSW", postcode: "2105" },
{ city: "MCCARRS CREEK", state: "NSW", postcode: "2105" },
{ city: "MORNING BAY", state: "NSW", postcode: "2105" },
{ city: "PITTWATER", state: "NSW", postcode: "2105" },
{ city: "SCOTLAND ISLAND", state: "NSW", postcode: "2105" },
{ city: "NEWPORT", state: "NSW", postcode: "2106" },
{ city: "NEWPORT BEACH", state: "NSW", postcode: "2106" },
{ city: "AVALON", state: "NSW", postcode: "2107" },
{ city: "AVALON BEACH", state: "NSW", postcode: "2107" },
{ city: "BILGOLA", state: "NSW", postcode: "2107" },
{ city: "BILGOLA BEACH", state: "NSW", postcode: "2107" },
{ city: "BILGOLA PLATEAU", state: "NSW", postcode: "2107" },
{ city: "CLAREVILLE", state: "NSW", postcode: "2107" },
{ city: "WHALE BEACH", state: "NSW", postcode: "2107" },
{ city: "COASTERS RETREAT", state: "NSW", postcode: "2108" },
{ city: "CURRAWONG BEACH", state: "NSW", postcode: "2108" },
{ city: "GREAT MACKEREL BEACH", state: "NSW", postcode: "2108" },
{ city: "PALM BEACH", state: "NSW", postcode: "2108" },
{ city: "PITTWATER", state: "NSW", postcode: "2108" },
{ city: "MACQUARIE PARK", state: "NSW", postcode: "2109" },
{ city: "MACQUARIE UNIVERSITY", state: "NSW", postcode: "2109" },
{ city: "HUNTERS HILL", state: "NSW", postcode: "2110" },
{ city: "WOOLWICH", state: "NSW", postcode: "2110" },
{ city: "BORONIA PARK", state: "NSW", postcode: "2111" },
{ city: "GLADESVILLE", state: "NSW", postcode: "2111" },
{ city: "HENLEY", state: "NSW", postcode: "2111" },
{ city: "HUNTLEYS COVE", state: "NSW", postcode: "2111" },
{ city: "HUNTLEYS POINT", state: "NSW", postcode: "2111" },
{ city: "MONASH PARK", state: "NSW", postcode: "2111" },
{ city: "TENNYSON POINT", state: "NSW", postcode: "2111" },
{ city: "DENISTONE EAST", state: "NSW", postcode: "2112" },
{ city: "PUTNEY", state: "NSW", postcode: "2112" },
{ city: "RYDE", state: "NSW", postcode: "2112" },
{ city: "BLENHEIM ROAD", state: "NSW", postcode: "2113" },
{ city: "EAST RYDE", state: "NSW", postcode: "2113" },
{ city: "MACQUARIE CENTRE", state: "NSW", postcode: "2113" },
{ city: "MACQUARIE PARK", state: "NSW", postcode: "2113" },
{ city: "NORTH RYDE", state: "NSW", postcode: "2113" },
{ city: "DENISTONE", state: "NSW", postcode: "2114" },
{ city: "DENISTONE WEST", state: "NSW", postcode: "2114" },
{ city: "MEADOWBANK", state: "NSW", postcode: "2114" },
{ city: "MELROSE PARK", state: "NSW", postcode: "2114" },
{ city: "WEST RYDE", state: "NSW", postcode: "2114" },
{ city: "ERMINGTON", state: "NSW", postcode: "2115" },
{ city: "RYDALMERE", state: "NSW", postcode: "2116" },
{ city: "DUNDAS", state: "NSW", postcode: "2117" },
{ city: "DUNDAS VALLEY", state: "NSW", postcode: "2117" },
{ city: "OATLANDS", state: "NSW", postcode: "2117" },
{ city: "TELOPEA", state: "NSW", postcode: "2117" },
{ city: "CARLINGFORD", state: "NSW", postcode: "2118" },
{ city: "CARLINGFORD COURT", state: "NSW", postcode: "2118" },
{ city: "CARLINGFORD NORTH", state: "NSW", postcode: "2118" },
{ city: "KINGSDENE", state: "NSW", postcode: "2118" },
{ city: "BEECROFT", state: "NSW", postcode: "2119" },
{ city: "CHELTENHAM", state: "NSW", postcode: "2119" },
{ city: "PENNANT HILLS", state: "NSW", postcode: "2120" },
{ city: "THORNLEIGH", state: "NSW", postcode: "2120" },
{ city: "WESTLEIGH", state: "NSW", postcode: "2120" },
{ city: "EPPING", state: "NSW", postcode: "2121" },
{ city: "NORTH EPPING", state: "NSW", postcode: "2121" },
{ city: "EASTWOOD", state: "NSW", postcode: "2122" },
{ city: "MARSFIELD", state: "NSW", postcode: "2122" },
{ city: "WEST PENNANT HILLS", state: "NSW", postcode: "2125" },
{ city: "CHERRYBROOK", state: "NSW", postcode: "2126" },
{ city: "HOMEBUSH BAY", state: "NSW", postcode: "2127" },
{ city: "NEWINGTON", state: "NSW", postcode: "2127" },
{ city: "SYDNEY OLYMPIC PARK", state: "NSW", postcode: "2127" },
{ city: "WENTWORTH POINT", state: "NSW", postcode: "2127" },
{ city: "SILVERWATER", state: "NSW", postcode: "2128" },
{ city: "SYDNEY MARKETS", state: "NSW", postcode: "2129" },
{ city: "SUMMER HILL", state: "NSW", postcode: "2130" },
{ city: "ASHFIELD", state: "NSW", postcode: "2131" },
{ city: "CROYDON", state: "NSW", postcode: "2132" },
{ city: "CROYDON PARK", state: "NSW", postcode: "2133" },
{ city: "ENFIELD SOUTH", state: "NSW", postcode: "2133" },
{ city: "BURWOOD", state: "NSW", postcode: "2134" },
{ city: "BURWOOD NORTH", state: "NSW", postcode: "2134" },
{ city: "STRATHFIELD", state: "NSW", postcode: "2135" },
{ city: "BURWOOD HEIGHTS", state: "NSW", postcode: "2136" },
{ city: "ENFIELD", state: "NSW", postcode: "2136" },
{ city: "STRATHFIELD SOUTH", state: "NSW", postcode: "2136" },
{ city: "BREAKFAST POINT", state: "NSW", postcode: "2137" },
{ city: "CABARITA", state: "NSW", postcode: "2137" },
{ city: "CONCORD", state: "NSW", postcode: "2137" },
{ city: "MORTLAKE", state: "NSW", postcode: "2137" },
{ city: "NORTH STRATHFIELD", state: "NSW", postcode: "2137" },
{ city: "CONCORD WEST", state: "NSW", postcode: "2138" },
{ city: "CONCORD WEST DC", state: "NSW", postcode: "2138" },
{ city: "LIBERTY GROVE", state: "NSW", postcode: "2138" },
{ city: "RHODES", state: "NSW", postcode: "2138" },
{ city: "FLEMINGTON", state: "NSW", postcode: "2140" },
{ city: "HOMEBUSH", state: "NSW", postcode: "2140" },
{ city: "HOMEBUSH SOUTH", state: "NSW", postcode: "2140" },
{ city: "HOMEBUSH WEST", state: "NSW", postcode: "2140" },
{ city: "BERALA", state: "NSW", postcode: "2141" },
{ city: "LIDCOMBE", state: "NSW", postcode: "2141" },
{ city: "LIDCOMBE NORTH", state: "NSW", postcode: "2141" },
{ city: "ROOKWOOD", state: "NSW", postcode: "2141" },
{ city: "BLAXCELL", state: "NSW", postcode: "2142" },
{ city: "CAMELLIA", state: "NSW", postcode: "2142" },
{ city: "CLYDE", state: "NSW", postcode: "2142" },
{ city: "GRANVILLE", state: "NSW", postcode: "2142" },
{ city: "HOLROYD", state: "NSW", postcode: "2142" },
{ city: "ROSEHILL", state: "NSW", postcode: "2142" },
{ city: "SOUTH GRANVILLE", state: "NSW", postcode: "2142" },
{ city: "BIRRONG", state: "NSW", postcode: "2143" },
{ city: "POTTS HILL", state: "NSW", postcode: "2143" },
{ city: "REGENTS PARK", state: "NSW", postcode: "2143" },
{ city: "AUBURN", state: "NSW", postcode: "2144" },
{ city: "CONSTITUTION HILL", state: "NSW", postcode: "2145" },
{ city: "GIRRAWEEN", state: "NSW", postcode: "2145" },
{ city: "GREYSTANES", state: "NSW", postcode: "2145" },
{ city: "MAYS HILL", state: "NSW", postcode: "2145" },
{ city: "PEMULWUY", state: "NSW", postcode: "2145" },
{ city: "PENDLE HILL", state: "NSW", postcode: "2145" },
{ city: "SOUTH WENTWORTHVILLE", state: "NSW", postcode: "2145" },
{ city: "WENTWORTHVILLE", state: "NSW", postcode: "2145" },
{ city: "WESTMEAD", state: "NSW", postcode: "2145" },
{ city: "OLD TOONGABBIE", state: "NSW", postcode: "2146" },
{ city: "TOONGABBIE", state: "NSW", postcode: "2146" },
{ city: "TOONGABBIE EAST", state: "NSW", postcode: "2146" },
{ city: "KINGS LANGLEY", state: "NSW", postcode: "2147" },
{ city: "LALOR PARK", state: "NSW", postcode: "2147" },
{ city: "SEVEN HILLS", state: "NSW", postcode: "2147" },
{ city: "SEVEN HILLS WEST", state: "NSW", postcode: "2147" },
{ city: "ARNDELL PARK", state: "NSW", postcode: "2148" },
{ city: "BLACKTOWN", state: "NSW", postcode: "2148" },
{ city: "BLACKTOWN WESTPOINT", state: "NSW", postcode: "2148" },
{ city: "HUNTINGWOOD", state: "NSW", postcode: "2148" },
{ city: "KINGS PARK", state: "NSW", postcode: "2148" },
{ city: "MARAYONG", state: "NSW", postcode: "2148" },
{ city: "PROSPECT", state: "NSW", postcode: "2148" },
{ city: "HARRIS PARK", state: "NSW", postcode: "2150" },
{ city: "PARRAMATTA", state: "NSW", postcode: "2150" },
{ city: "PARRAMATTA WESTFIELD", state: "NSW", postcode: "2150" },
{ city: "NORTH PARRAMATTA", state: "NSW", postcode: "2151" },
{ city: "NORTH ROCKS", state: "NSW", postcode: "2151" },
{ city: "NORTHMEAD", state: "NSW", postcode: "2152" },
{ city: "BAULKHAM HILLS", state: "NSW", postcode: "2153" },
{ city: "BELLA VISTA", state: "NSW", postcode: "2153" },
{ city: "NORWEST", state: "NSW", postcode: "2153" },
{ city: "WINSTON HILLS", state: "NSW", postcode: "2153" },
{ city: "CASTLE HILL", state: "NSW", postcode: "2154" },
{ city: "BEAUMONT HILLS", state: "NSW", postcode: "2155" },
{ city: "KELLYVILLE", state: "NSW", postcode: "2155" },
{ city: "KELLYVILLE RIDGE", state: "NSW", postcode: "2155" },
{ city: "NORTH KELLYVILLE", state: "NSW", postcode: "2155" },
{ city: "ROUSE HILL", state: "NSW", postcode: "2155" },
{ city: "ANNANGROVE", state: "NSW", postcode: "2156" },
{ city: "GLENHAVEN", state: "NSW", postcode: "2156" },
{ city: "KENTHURST", state: "NSW", postcode: "2156" },
{ city: "CANOELANDS", state: "NSW", postcode: "2157" },
{ city: "FOREST GLEN", state: "NSW", postcode: "2157" },
{ city: "GLENORIE", state: "NSW", postcode: "2157" },
{ city: "DURAL", state: "NSW", postcode: "2158" },
{ city: "DURAL DC", state: "NSW", postcode: "2158" },
{ city: "MIDDLE DURAL", state: "NSW", postcode: "2158" },
{ city: "ROUND CORNER", state: "NSW", postcode: "2158" },
{ city: "ARCADIA", state: "NSW", postcode: "2159" },
{ city: "MERRYLANDS", state: "NSW", postcode: "2160" },
{ city: "MERRYLANDS WEST", state: "NSW", postcode: "2160" },
{ city: "GUILDFORD", state: "NSW", postcode: "2161" },
{ city: "GUILDFORD WEST", state: "NSW", postcode: "2161" },
{ city: "OLD GUILDFORD", state: "NSW", postcode: "2161" },
{ city: "YENNORA", state: "NSW", postcode: "2161" },
{ city: "CHESTER HILL", state: "NSW", postcode: "2162" },
{ city: "SEFTON", state: "NSW", postcode: "2162" },
{ city: "CARRAMAR", state: "NSW", postcode: "2163" },
{ city: "LANSDOWNE", state: "NSW", postcode: "2163" },
{ city: "VILLAWOOD", state: "NSW", postcode: "2163" },
{ city: "SMITHFIELD", state: "NSW", postcode: "2164" },
{ city: "SMITHFIELD WEST", state: "NSW", postcode: "2164" },
{ city: "WETHERILL PARK", state: "NSW", postcode: "2164" },
{ city: "WETHERILL PARK BC", state: "NSW", postcode: "2164" },
{ city: "WOODPARK", state: "NSW", postcode: "2164" },
{ city: "FAIRFIELD", state: "NSW", postcode: "2165" },
{ city: "FAIRFIELD EAST", state: "NSW", postcode: "2165" },
{ city: "FAIRFIELD HEIGHTS", state: "NSW", postcode: "2165" },
{ city: "FAIRFIELD WEST", state: "NSW", postcode: "2165" },
{ city: "CABRAMATTA", state: "NSW", postcode: "2166" },
{ city: "CABRAMATTA WEST", state: "NSW", postcode: "2166" },
{ city: "CANLEY HEIGHTS", state: "NSW", postcode: "2166" },
{ city: "CANLEY VALE", state: "NSW", postcode: "2166" },
{ city: "LANSVALE", state: "NSW", postcode: "2166" },
{ city: "GLENFIELD", state: "NSW", postcode: "2167" },
{ city: "ASHCROFT", state: "NSW", postcode: "2168" },
{ city: "BUSBY", state: "NSW", postcode: "2168" },
{ city: "CARTWRIGHT", state: "NSW", postcode: "2168" },
{ city: "GREEN VALLEY", state: "NSW", postcode: "2168" },
{ city: "HECKENBERG", state: "NSW", postcode: "2168" },
{ city: "HINCHINBROOK", state: "NSW", postcode: "2168" },
{ city: "MILLER", state: "NSW", postcode: "2168" },
{ city: "SADLEIR", state: "NSW", postcode: "2168" },
{ city: "CASULA", state: "NSW", postcode: "2170" },
{ city: "CASULA MALL", state: "NSW", postcode: "2170" },
{ city: "CHIPPING NORTON", state: "NSW", postcode: "2170" },
{ city: "HAMMONDVILLE", state: "NSW", postcode: "2170" },
{ city: "LIVERPOOL", state: "NSW", postcode: "2170" },
{ city: "LIVERPOOL SOUTH", state: "NSW", postcode: "2170" },
{ city: "LIVERPOOL WESTFIELD", state: "NSW", postcode: "2170" },
{ city: "LURNEA", state: "NSW", postcode: "2170" },
{ city: "MOOREBANK", state: "NSW", postcode: "2170" },
{ city: "MOUNT PRITCHARD", state: "NSW", postcode: "2170" },
{ city: "PRESTONS", state: "NSW", postcode: "2170" },
{ city: "WARWICK FARM", state: "NSW", postcode: "2170" },
{ city: "CARNES HILL", state: "NSW", postcode: "2171" },
{ city: "CECIL HILLS", state: "NSW", postcode: "2171" },
{ city: "ELIZABETH HILLS", state: "NSW", postcode: "2171" },
{ city: "HORNINGSEA PARK", state: "NSW", postcode: "2171" },
{ city: "HOXTON PARK", state: "NSW", postcode: "2171" },
{ city: "LEN WATERS ESTATE", state: "NSW", postcode: "2171" },
{ city: "MIDDLETON GRANGE", state: "NSW", postcode: "2171" },
{ city: "WEST HOXTON", state: "NSW", postcode: "2171" },
{ city: "PLEASURE POINT", state: "NSW", postcode: "2172" },
{ city: "SANDY POINT", state: "NSW", postcode: "2172" },
{ city: "VOYAGER POINT", state: "NSW", postcode: "2172" },
{ city: "HOLSWORTHY", state: "NSW", postcode: "2173" },
{ city: "WATTLE GROVE", state: "NSW", postcode: "2173" },
{ city: "EDMONDSON PARK", state: "NSW", postcode: "2174" },
{ city: "INGLEBURN MILPO", state: "NSW", postcode: "2174" },
{ city: "HORSLEY PARK", state: "NSW", postcode: "2175" },
{ city: "ABBOTSBURY", state: "NSW", postcode: "2176" },
{ city: "BOSSLEY PARK", state: "NSW", postcode: "2176" },
{ city: "EDENSOR PARK", state: "NSW", postcode: "2176" },
{ city: "GREENFIELD PARK", state: "NSW", postcode: "2176" },
{ city: "PRAIRIEWOOD", state: "NSW", postcode: "2176" },
{ city: "ST JOHNS PARK", state: "NSW", postcode: "2176" },
{ city: "WAKELEY", state: "NSW", postcode: "2176" },
{ city: "BONNYRIGG", state: "NSW", postcode: "2177" },
{ city: "BONNYRIGG HEIGHTS", state: "NSW", postcode: "2177" },
{ city: "CECIL PARK", state: "NSW", postcode: "2178" },
{ city: "KEMPS CREEK", state: "NSW", postcode: "2178" },
{ city: "MOUNT VERNON", state: "NSW", postcode: "2178" },
{ city: "AUSTRAL", state: "NSW", postcode: "2179" },
{ city: "LEPPINGTON", state: "NSW", postcode: "2179" },
{ city: "CHULLORA", state: "NSW", postcode: "2190" },
{ city: "GREENACRE", state: "NSW", postcode: "2190" },
{ city: "MOUNT LEWIS", state: "NSW", postcode: "2190" },
{ city: "BELFIELD", state: "NSW", postcode: "2191" },
{ city: "BELMORE", state: "NSW", postcode: "2192" },
{ city: "ASHBURY", state: "NSW", postcode: "2193" },
{ city: "CANTERBURY", state: "NSW", postcode: "2193" },
{ city: "HURLSTONE PARK", state: "NSW", postcode: "2193" },
{ city: "CAMPSIE", state: "NSW", postcode: "2194" },
{ city: "LAKEMBA", state: "NSW", postcode: "2195" },
{ city: "LAKEMBA DC", state: "NSW", postcode: "2195" },
{ city: "WILEY PARK", state: "NSW", postcode: "2195" },
{ city: "PUNCHBOWL", state: "NSW", postcode: "2196" },
{ city: "ROSELANDS", state: "NSW", postcode: "2196" },
{ city: "BASS HILL", state: "NSW", postcode: "2197" },
{ city: "GEORGES HALL", state: "NSW", postcode: "2198" },
{ city: "YAGOONA", state: "NSW", postcode: "2199" },
{ city: "YAGOONA WEST", state: "NSW", postcode: "2199" },
{ city: "BANKSTOWN", state: "NSW", postcode: "2200" },
{ city: "BANKSTOWN AERODROME", state: "NSW", postcode: "2200" },
{ city: "BANKSTOWN NORTH", state: "NSW", postcode: "2200" },
{ city: "BANKSTOWN SQUARE", state: "NSW", postcode: "2200" },
{ city: "CONDELL PARK", state: "NSW", postcode: "2200" },
{ city: "MANAHAN", state: "NSW", postcode: "2200" },
{ city: "MOUNT LEWIS", state: "NSW", postcode: "2200" },
{ city: "DULWICH HILL", state: "NSW", postcode: "2203" },
{ city: "MARRICKVILLE", state: "NSW", postcode: "2204" },
{ city: "MARRICKVILLE METRO", state: "NSW", postcode: "2204" },
{ city: "MARRICKVILLE SOUTH", state: "NSW", postcode: "2204" },
{ city: "ARNCLIFFE", state: "NSW", postcode: "2205" },
{ city: "TURRELLA", state: "NSW", postcode: "2205" },
{ city: "WOLLI CREEK", state: "NSW", postcode: "2205" },
{ city: "CLEMTON PARK", state: "NSW", postcode: "2206" },
{ city: "EARLWOOD", state: "NSW", postcode: "2206" },
{ city: "BARDWELL PARK", state: "NSW", postcode: "2207" },
{ city: "BARDWELL VALLEY", state: "NSW", postcode: "2207" },
{ city: "BEXLEY", state: "NSW", postcode: "2207" },
{ city: "BEXLEY NORTH", state: "NSW", postcode: "2207" },
{ city: "BEXLEY SOUTH", state: "NSW", postcode: "2207" },
{ city: "KINGSGROVE", state: "NSW", postcode: "2208" },
{ city: "KINGSWAY WEST", state: "NSW", postcode: "2208" },
{ city: "BEVERLY HILLS", state: "NSW", postcode: "2209" },
{ city: "NARWEE", state: "NSW", postcode: "2209" },
{ city: "LUGARNO", state: "NSW", postcode: "2210" },
{ city: "PEAKHURST", state: "NSW", postcode: "2210" },
{ city: "PEAKHURST DC", state: "NSW", postcode: "2210" },
{ city: "PEAKHURST HEIGHTS", state: "NSW", postcode: "2210" },
{ city: "RIVERWOOD", state: "NSW", postcode: "2210" },
{ city: "PADSTOW", state: "NSW", postcode: "2211" },
{ city: "PADSTOW HEIGHTS", state: "NSW", postcode: "2211" },
{ city: "REVESBY", state: "NSW", postcode: "2212" },
{ city: "REVESBY HEIGHTS", state: "NSW", postcode: "2212" },
{ city: "REVESBY NORTH", state: "NSW", postcode: "2212" },
{ city: "EAST HILLS", state: "NSW", postcode: "2213" },
{ city: "PANANIA", state: "NSW", postcode: "2213" },
{ city: "PICNIC POINT", state: "NSW", postcode: "2213" },
{ city: "MILPERRA", state: "NSW", postcode: "2214" },
{ city: "BANKSIA", state: "NSW", postcode: "2216" },
{ city: "BRIGHTON-LE-SANDS", state: "NSW", postcode: "2216" },
{ city: "KYEEMAGH", state: "NSW", postcode: "2216" },
{ city: "ROCKDALE", state: "NSW", postcode: "2216" },
{ city: "ROCKDALE DC", state: "NSW", postcode: "2216" },
{ city: "BEVERLEY PARK", state: "NSW", postcode: "2217" },
{ city: "KOGARAH", state: "NSW", postcode: "2217" },
{ city: "KOGARAH BAY", state: "NSW", postcode: "2217" },
{ city: "MONTEREY", state: "NSW", postcode: "2217" },
{ city: "RAMSGATE", state: "NSW", postcode: "2217" },
{ city: "RAMSGATE BEACH", state: "NSW", postcode: "2217" },
{ city: "ALLAWAH", state: "NSW", postcode: "2218" },
{ city: "CARLTON", state: "NSW", postcode: "2218" },
{ city: "DOLLS POINT", state: "NSW", postcode: "2219" },
{ city: "SANDRINGHAM", state: "NSW", postcode: "2219" },
{ city: "SANS SOUCI", state: "NSW", postcode: "2219" },
{ city: "HURSTVILLE", state: "NSW", postcode: "2220" },
{ city: "HURSTVILLE GROVE", state: "NSW", postcode: "2220" },
{ city: "HURSTVILLE WESTFIELD", state: "NSW", postcode: "2220" },
{ city: "BLAKEHURST", state: "NSW", postcode: "2221" },
{ city: "CARSS PARK", state: "NSW", postcode: "2221" },
{ city: "CONNELLS POINT", state: "NSW", postcode: "2221" },
{ city: "KYLE BAY", state: "NSW", postcode: "2221" },
{ city: "SOUTH HURSTVILLE", state: "NSW", postcode: "2221" },
{ city: "PENSHURST", state: "NSW", postcode: "2222" },
{ city: "MORTDALE", state: "NSW", postcode: "2223" },
{ city: "OATLEY", state: "NSW", postcode: "2223" },
{ city: "KANGAROO POINT", state: "NSW", postcode: "2224" },
{ city: "SYLVANIA", state: "NSW", postcode: "2224" },
{ city: "SYLVANIA SOUTHGATE", state: "NSW", postcode: "2224" },
{ city: "SYLVANIA WATERS", state: "NSW", postcode: "2224" },
{ city: "OYSTER BAY", state: "NSW", postcode: "2225" },
{ city: "BONNET BAY", state: "NSW", postcode: "2226" },
{ city: "COMO", state: "NSW", postcode: "2226" },
{ city: "JANNALI", state: "NSW", postcode: "2226" },
{ city: "GYMEA", state: "NSW", postcode: "2227" },
{ city: "GYMEA BAY", state: "NSW", postcode: "2227" },
{ city: "MIRANDA", state: "NSW", postcode: "2228" },
{ city: "YOWIE BAY", state: "NSW", postcode: "2228" },
{ city: "CARINGBAH", state: "NSW", postcode: "2229" },
{ city: "CARINGBAH SOUTH", state: "NSW", postcode: "2229" },
{ city: "DOLANS BAY", state: "NSW", postcode: "2229" },
{ city: "LILLI PILLI", state: "NSW", postcode: "2229" },
{ city: "PORT HACKING", state: "NSW", postcode: "2229" },
{ city: "TAREN POINT", state: "NSW", postcode: "2229" },
{ city: "BURRANEER", state: "NSW", postcode: "2230" },
{ city: "CRONULLA", state: "NSW", postcode: "2230" },
{ city: "GREENHILLS BEACH", state: "NSW", postcode: "2230" },
{ city: "WOOLOOWARE", state: "NSW", postcode: "2230" },
{ city: "KURNELL", state: "NSW", postcode: "2231" },
{ city: "GRAYS POINT", state: "NSW", postcode: "2232" },
{ city: "KAREELA", state: "NSW", postcode: "2232" },
{ city: "KIRRAWEE", state: "NSW", postcode: "2232" },
{ city: "KIRRAWEE DC", state: "NSW", postcode: "2232" },
{ city: "LOFTUS", state: "NSW", postcode: "2232" },
{ city: "SUTHERLAND", state: "NSW", postcode: "2232" },
{ city: "WORONORA", state: "NSW", postcode: "2232" },
{ city: "ENGADINE", state: "NSW", postcode: "2233" },
{ city: "HEATHCOTE", state: "NSW", postcode: "2233" },
{ city: "ROYAL NATIONAL PARK", state: "NSW", postcode: "2233" },
{ city: "WATERFALL", state: "NSW", postcode: "2233" },
{ city: "WORONORA HEIGHTS", state: "NSW", postcode: "2233" },
{ city: "YARRAWARRAH", state: "NSW", postcode: "2233" },
{ city: "ALFORDS POINT", state: "NSW", postcode: "2234" },
{ city: "BANGOR", state: "NSW", postcode: "2234" },
{ city: "BARDEN RIDGE", state: "NSW", postcode: "2234" },
{ city: "ILLAWONG", state: "NSW", postcode: "2234" },
{ city: "LUCAS HEIGHTS", state: "NSW", postcode: "2234" },
{ city: "MENAI", state: "NSW", postcode: "2234" },
{ city: "MENAI CENTRAL", state: "NSW", postcode: "2234" },
{ city: "EAST GOSFORD", state: "NSW", postcode: "2250" },
{ city: "ERINA", state: "NSW", postcode: "2250" },
{ city: "ERINA FAIR", state: "NSW", postcode: "2250" },
{ city: "GLENWORTH VALLEY", state: "NSW", postcode: "2250" },
{ city: "GOSFORD", state: "NSW", postcode: "2250" },
{ city: "GREENGROVE", state: "NSW", postcode: "2250" },
{ city: "HOLGATE", state: "NSW", postcode: "2250" },
{ city: "KARIONG", state: "NSW", postcode: "2250" },
{ city: "KULNURA", state: "NSW", postcode: "2250" },
{ city: "LISAROW", state: "NSW", postcode: "2250" },
{ city: "MURRAYS RUN", state: "NSW", postcode: "2250" },
{ city: "NARARA", state: "NSW", postcode: "2250" },
{ city: "NIAGARA PARK", state: "NSW", postcode: "2250" },
{ city: "NORTH GOSFORD", state: "NSW", postcode: "2250" },
{ city: "SOMERSBY", state: "NSW", postcode: "2250" },
{ city: "WENDOREE PARK", state: "NSW", postcode: "2250" },
{ city: "WEST GOSFORD", state: "NSW", postcode: "2250" },
{ city: "WYOMING", state: "NSW", postcode: "2250" },
{ city: "AVOCA BEACH", state: "NSW", postcode: "2251" },
{ city: "KINCUMBER", state: "NSW", postcode: "2251" },
{ city: "WOY WOY", state: "NSW", postcode: "2256" },
{ city: "ST HUBERTS ISLAND", state: "NSW", postcode: "2257" },
{ city: "UMINA BEACH", state: "NSW", postcode: "2257" },
{ city: "OURIMBAH", state: "NSW", postcode: "2258" },
{ city: "BUSHELLS RIDGE", state: "NSW", postcode: "2259" },
{ city: "FREEMANS", state: "NSW", postcode: "2259" },
{ city: "KANWAL", state: "NSW", postcode: "2259" },
{ city: "KIAR", state: "NSW", postcode: "2259" },
{ city: "KINGFISHER SHORES", state: "NSW", postcode: "2259" },
{ city: "LAKE MUNMORAH", state: "NSW", postcode: "2259" },
{ city: "LEMON TREE", state: "NSW", postcode: "2259" },
{ city: "MANNERING PARK", state: "NSW", postcode: "2259" },
{ city: "MARDI", state: "NSW", postcode: "2259" },
{ city: "MOONEE", state: "NSW", postcode: "2259" },
{ city: "POINT WOLSTONCROFT", state: "NSW", postcode: "2259" },
{ city: "ROCKY POINT", state: "NSW", postcode: "2259" },
{ city: "SUMMERLAND POINT", state: "NSW", postcode: "2259" },
{ city: "TACOMA", state: "NSW", postcode: "2259" },
{ city: "TACOMA SOUTH", state: "NSW", postcode: "2259" },
{ city: "TUGGERAH", state: "NSW", postcode: "2259" },
{ city: "TUGGERAWONG", state: "NSW", postcode: "2259" },
{ city: "WADALBA", state: "NSW", postcode: "2259" },
{ city: "WALLARAH", state: "NSW", postcode: "2259" },
{ city: "WARNERVALE", state: "NSW", postcode: "2259" },
{ city: "WATANOBBI", state: "NSW", postcode: "2259" },
{ city: "WOONGARRAH", state: "NSW", postcode: "2259" },
{ city: "WYBUNG", state: "NSW", postcode: "2259" },
{ city: "WYEE", state: "NSW", postcode: "2259" },
{ city: "WYEE POINT", state: "NSW", postcode: "2259" },
{ city: "WYONG", state: "NSW", postcode: "2259" },
{ city: "WYONGAH", state: "NSW", postcode: "2259" },
{ city: "WYONG CREEK", state: "NSW", postcode: "2259" },
{ city: "YARRAMALONG", state: "NSW", postcode: "2259" },
{ city: "ERINA HEIGHTS", state: "NSW", postcode: "2260" },
{ city: "FORRESTERS BEACH", state: "NSW", postcode: "2260" },
{ city: "NORTH AVOCA", state: "NSW", postcode: "2260" },
{ city: "TERRIGAL", state: "NSW", postcode: "2260" },
{ city: "WAMBERAL", state: "NSW", postcode: "2260" },
{ city: "BATEAU BAY", state: "NSW", postcode: "2261" },
{ city: "BAY VILLAGE", state: "NSW", postcode: "2261" },
{ city: "BERKELEY VALE", state: "NSW", postcode: "2261" },
{ city: "BLUE BAY", state: "NSW", postcode: "2261" },
{ city: "CHITTAWAY BAY", state: "NSW", postcode: "2261" },
{ city: "CHITTAWAY POINT", state: "NSW", postcode: "2261" },
{ city: "GLENNING VALLEY", state: "NSW", postcode: "2261" },
{ city: "KILLARNEY VALE", state: "NSW", postcode: "2261" },
{ city: "LONG JETTY", state: "NSW", postcode: "2261" },
{ city: "MAGENTA", state: "NSW", postcode: "2261" },
{ city: "SHELLY BEACH", state: "NSW", postcode: "2261" },
{ city: "THE ENTRANCE", state: "NSW", postcode: "2261" },
{ city: "THE ENTRANCE NORTH", state: "NSW", postcode: "2261" },
{ city: "TOOWOON BAY", state: "NSW", postcode: "2261" },
{ city: "BUDGEWOI", state: "NSW", postcode: "2262" },
{ city: "BUDGEWOI PENINSULA", state: "NSW", postcode: "2262" },
{ city: "COLONGRA", state: "NSW", postcode: "2262" },
{ city: "DOYALSON", state: "NSW", postcode: "2262" },
{ city: "DOYALSON NORTH", state: "NSW", postcode: "2262" },
{ city: "CHARMHAVEN", state: "NSW", postcode: "2263" },
{ city: "LAKE HAVEN", state: "NSW", postcode: "2263" },
{ city: "TOUKLEY", state: "NSW", postcode: "2263" },
{ city: "MORISSET", state: "NSW", postcode: "2264" },
{ city: "COORANBONG", state: "NSW", postcode: "2265" },
{ city: "BELMONT", state: "NSW", postcode: "2280" },
{ city: "BELMONT NORTH", state: "NSW", postcode: "2280" },
{ city: "BELMONT SOUTH", state: "NSW", postcode: "2280" },
{ city: "JEWELLS", state: "NSW", postcode: "2280" },
{ city: "MARKS POINT", state: "NSW", postcode: "2280" },
{ city: "VALENTINE", state: "NSW", postcode: "2280" },
{ city: "BLACKSMITHS", state: "NSW", postcode: "2281" },
{ city: "CAMS WHARF", state: "NSW", postcode: "2281" },
{ city: "CATHERINE HILL BAY", state: "NSW", postcode: "2281" },
{ city: "CAVES BEACH", state: "NSW", postcode: "2281" },
{ city: "LITTLE PELICAN", state: "NSW", postcode: "2281" },
{ city: "MURRAYS BEACH", state: "NSW", postcode: "2281" },
{ city: "NORDS WHARF", state: "NSW", postcode: "2281" },
{ city: "PELICAN", state: "NSW", postcode: "2281" },
{ city: "PINNY BEACH", state: "NSW", postcode: "2281" },
{ city: "SWANSEA", state: "NSW", postcode: "2281" },
{ city: "SWANSEA HEADS", state: "NSW", postcode: "2281" },
{ city: "ELEEBANA", state: "NSW", postcode: "2282" },
{ city: "LAKELANDS", state: "NSW", postcode: "2282" },
{ city: "WARNERS BAY", state: "NSW", postcode: "2282" },
{ city: "ARCADIA VALE", state: "NSW", postcode: "2283" },
{ city: "AWABA", state: "NSW", postcode: "2283" },
{ city: "BALMORAL", state: "NSW", postcode: "2283" },
{ city: "BLACKALLS PARK", state: "NSW", postcode: "2283" },
{ city: "BOLTON POINT", state: "NSW", postcode: "2283" },
{ city: "BUTTABA", state: "NSW", postcode: "2283" },
{ city: "CAREY BAY", state: "NSW", postcode: "2283" },
{ city: "COAL POINT", state: "NSW", postcode: "2283" },
{ city: "FASSIFERN", state: "NSW", postcode: "2283" },
{ city: "FENNELL BAY", state: "NSW", postcode: "2283" },
{ city: "FISHING POINT", state: "NSW", postcode: "2283" },
{ city: "KILABEN BAY", state: "NSW", postcode: "2283" },
{ city: "LAKE MACQUARIE", state: "NSW", postcode: "2283" },
{ city: "RATHMINES", state: "NSW", postcode: "2283" },
{ city: "RYHOPE", state: "NSW", postcode: "2283" },
{ city: "TORONTO", state: "NSW", postcode: "2283" },
{ city: "ARGENTON", state: "NSW", postcode: "2284" },
{ city: "BOOLAROO", state: "NSW", postcode: "2284" },
{ city: "BOORAGUL", state: "NSW", postcode: "2284" },
{ city: "MARMONG POINT", state: "NSW", postcode: "2284" },
{ city: "SPEERS POINT", state: "NSW", postcode: "2284" },
{ city: "TERALBA", state: "NSW", postcode: "2284" },
{ city: "WOODRISING", state: "NSW", postcode: "2284" },
{ city: "CAMERON PARK", state: "NSW", postcode: "2285" },
{ city: "CARDIFF", state: "NSW", postcode: "2285" },
{ city: "CARDIFF HEIGHTS", state: "NSW", postcode: "2285" },
{ city: "CARDIFF SOUTH", state: "NSW", postcode: "2285" },
{ city: "EDGEWORTH", state: "NSW", postcode: "2285" },
{ city: "GLENDALE", state: "NSW", postcode: "2285" },
{ city: "MACQUARIE HILLS", state: "NSW", postcode: "2285" },
{ city: "HOLMESVILLE", state: "NSW", postcode: "2286" },
{ city: "SEAHAMPTON", state: "NSW", postcode: "2286" },
{ city: "WEST WALLSEND", state: "NSW", postcode: "2286" },
{ city: "BIRMINGHAM GARDENS", state: "NSW", postcode: "2287" },
{ city: "ELERMORE VALE", state: "NSW", postcode: "2287" },
{ city: "FLETCHER", state: "NSW", postcode: "2287" },
{ city: "MARYLAND", state: "NSW", postcode: "2287" },
{ city: "MINMI", state: "NSW", postcode: "2287" },
{ city: "RANKIN PARK", state: "NSW", postcode: "2287" },
{ city: "WALLSEND", state: "NSW", postcode: "2287" },
{ city: "WALLSEND DC", state: "NSW", postcode: "2287" },
{ city: "WALLSEND SOUTH", state: "NSW", postcode: "2287" },
{ city: "ADAMSTOWN", state: "NSW", postcode: "2289" },
{ city: "ADAMSTOWN HEIGHTS", state: "NSW", postcode: "2289" },
{ city: "GARDEN SUBURB", state: "NSW", postcode: "2289" },
{ city: "HIGHFIELDS", state: "NSW", postcode: "2289" },
{ city: "KOTARA", state: "NSW", postcode: "2289" },
{ city: "KOTARA FAIR", state: "NSW", postcode: "2289" },
{ city: "KOTARA SOUTH", state: "NSW", postcode: "2289" },
{ city: "BENNETTS GREEN", state: "NSW", postcode: "2290" },
{ city: "CHARLESTOWN", state: "NSW", postcode: "2290" },
{ city: "DUDLEY", state: "NSW", postcode: "2290" },
{ city: "GATESHEAD", state: "NSW", postcode: "2290" },
{ city: "HILLSBOROUGH", state: "NSW", postcode: "2290" },
{ city: "KAHIBAH", state: "NSW", postcode: "2290" },
{ city: "MOUNT HUTTON", state: "NSW", postcode: "2290" },
{ city: "REDHEAD", state: "NSW", postcode: "2290" },
{ city: "TINGIRA HEIGHTS", state: "NSW", postcode: "2290" },
{ city: "WHITEBRIDGE", state: "NSW", postcode: "2290" },
{ city: "MEREWETHER", state: "NSW", postcode: "2291" },
{ city: "MEREWETHER HEIGHTS", state: "NSW", postcode: "2291" },
{ city: "THE JUNCTION", state: "NSW", postcode: "2291" },
{ city: "BROADMEADOW", state: "NSW", postcode: "2292" },
{ city: "HAMILTON NORTH", state: "NSW", postcode: "2292" },
{ city: "MARYVILLE", state: "NSW", postcode: "2293" },
{ city: "WICKHAM", state: "NSW", postcode: "2293" },
{ city: "CARRINGTON", state: "NSW", postcode: "2294" },
{ city: "FERN BAY", state: "NSW", postcode: "2295" },
{ city: "STOCKTON", state: "NSW", postcode: "2295" },
{ city: "ISLINGTON", state: "NSW", postcode: "2296" },
{ city: "TIGHES HILL", state: "NSW", postcode: "2297" },
{ city: "GEORGETOWN", state: "NSW", postcode: "2298" },
{ city: "WARATAH", state: "NSW", postcode: "2298" },
{ city: "WARATAH WEST", state: "NSW", postcode: "2298" },
{ city: "JESMOND", state: "NSW", postcode: "2299" },
{ city: "LAMBTON", state: "NSW", postcode: "2299" },
{ city: "NORTH LAMBTON", state: "NSW", postcode: "2299" },
{ city: "BAR BEACH", state: "NSW", postcode: "2300" },
{ city: "COOKS HILL", state: "NSW", postcode: "2300" },
{ city: "NEWCASTLE", state: "NSW", postcode: "2300" },
{ city: "NEWCASTLE EAST", state: "NSW", postcode: "2300" },
{ city: "THE HILL", state: "NSW", postcode: "2300" },
{ city: "NEWCASTLE WEST", state: "NSW", postcode: "2302" },
{ city: "HAMILTON", state: "NSW", postcode: "2303" },
{ city: "HAMILTON DC", state: "NSW", postcode: "2303" },
{ city: "HAMILTON EAST", state: "NSW", postcode: "2303" },
{ city: "HAMILTON SOUTH", state: "NSW", postcode: "2303" },
{ city: "KOORAGANG", state: "NSW", postcode: "2304" },
{ city: "MAYFIELD", state: "NSW", postcode: "2304" },
{ city: "MAYFIELD EAST", state: "NSW", postcode: "2304" },
{ city: "MAYFIELD NORTH", state: "NSW", postcode: "2304" },
{ city: "MAYFIELD WEST", state: "NSW", postcode: "2304" },
{ city: "SANDGATE", state: "NSW", postcode: "2304" },
{ city: "WARABROOK", state: "NSW", postcode: "2304" },
{ city: "KOTARA EAST", state: "NSW", postcode: "2305" },
{ city: "NEW LAMBTON", state: "NSW", postcode: "2305" },
{ city: "NEW LAMBTON HEIGHTS", state: "NSW", postcode: "2305" },
{ city: "WINDALE", state: "NSW", postcode: "2306" },
{ city: "SHORTLAND", state: "NSW", postcode: "2307" },
{ city: "CALLAGHAN", state: "NSW", postcode: "2308" },
{ city: "NEWCASTLE UNIVERSITY", state: "NSW", postcode: "2308" },
{ city: "DANGAR", state: "NSW", postcode: "2309" },
{ city: "UPPER ALLYN", state: "NSW", postcode: "2311" },
{ city: "MINIMBAH", state: "NSW", postcode: "2312" },
{ city: "NABIAC", state: "NSW", postcode: "2312" },
{ city: "WILLIAMTOWN", state: "NSW", postcode: "2318" },
{ city: "PORT STEPHENS", state: "NSW", postcode: "2319" },
{ city: "TILLIGERRY CREEK", state: "NSW", postcode: "2319" },
{ city: "MAITLAND", state: "NSW", postcode: "2320" },
{ city: "MAITLAND NORTH", state: "NSW", postcode: "2320" },
{ city: "RUTHERFORD", state: "NSW", postcode: "2320" },
{ city: "SOUTH MAITLAND", state: "NSW", postcode: "2320" },
{ city: "MORPETH", state: "NSW", postcode: "2321" },
{ city: "BERESFIELD", state: "NSW", postcode: "2322" },
{ city: "CHISHOLM", state: "NSW", postcode: "2322" },
{ city: "HEXHAM", state: "NSW", postcode: "2322" },
{ city: "THORNTON", state: "NSW", postcode: "2322" },
{ city: "EAST MAITLAND", state: "NSW", postcode: "2323" },
{ city: "RAYMOND TERRACE", state: "NSW", postcode: "2324" },
{ city: "RAYMOND TERRACE EAST", state: "NSW", postcode: "2324" },
{ city: "TEA GARDENS", state: "NSW", postcode: "2324" },
{ city: "DAIRY ARM", state: "NSW", postcode: "2325" },
{ city: "FERNANCES CROSSING", state: "NSW", postcode: "2325" },
{ city: "MILSONS ARM", state: "NSW", postcode: "2325" },
{ city: "MURRAYS RUN", state: "NSW", postcode: "2325" },
{ city: "NARONE CREEK", state: "NSW", postcode: "2325" },
{ city: "WATAGAN", state: "NSW", postcode: "2325" },
{ city: "YENGO NATIONAL PARK", state: "NSW", postcode: "2325" },
{ city: "DURAL", state: "NSW", postcode: "2330" },
{ city: "SINGLETON MILITARY AREA", state: "NSW", postcode: "2330" },
{ city: "DUNCANS CREEK", state: "NSW", postcode: "2340" },
{ city: "EAST TAMWORTH", state: "NSW", postcode: "2340" },
{ city: "GAROO", state: "NSW", postcode: "2340" },
{ city: "HALLSVILLE", state: "NSW", postcode: "2340" },
{ city: "NORTH TAMWORTH", state: "NSW", postcode: "2340" },
{ city: "SOUTH TAMWORTH", state: "NSW", postcode: "2340" },
{ city: "TAMINDA", state: "NSW", postcode: "2340" },
{ city: "TAMWORTH", state: "NSW", postcode: "2340" },
{ city: "WEST TAMWORTH", state: "NSW", postcode: "2340" },
{ city: "METZ", state: "NSW", postcode: "2350" },
{ city: "WHITLOW", state: "NSW", postcode: "2404" },
{ city: "FORSTER", state: "NSW", postcode: "2428" },
{ city: "CABBAGE TREE ISLAND", state: "NSW", postcode: "2430" },
{ city: "CHATHAM", state: "NSW", postcode: "2430" },
{ city: "CROKI", state: "NSW", postcode: "2430" },
{ city: "CUNDLETOWN", state: "NSW", postcode: "2430" },
{ city: "DIAMOND BEACH", state: "NSW", postcode: "2430" },
{ city: "DUMARESQ ISLAND", state: "NSW", postcode: "2430" },
{ city: "FAILFORD", state: "NSW", postcode: "2430" },
{ city: "GHINNI GHINNI", state: "NSW", postcode: "2430" },
{ city: "GLENTHORNE", state: "NSW", postcode: "2430" },
{ city: "HALLIDAYS POINT", state: "NSW", postcode: "2430" },
{ city: "HILLVILLE", state: "NSW", postcode: "2430" },
{ city: "JONES ISLAND", state: "NSW", postcode: "2430" },
{ city: "KIWARRAK", state: "NSW", postcode: "2430" },
{ city: "KOORAINGHAT", state: "NSW", postcode: "2430" },
{ city: "KUNDLE KUNDLE", state: "NSW", postcode: "2430" },
{ city: "LANSDOWNE", state: "NSW", postcode: "2430" },
{ city: "LANSDOWNE FOREST", state: "NSW", postcode: "2430" },
{ city: "MANNING POINT", state: "NSW", postcode: "2430" },
{ city: "MELINGA", state: "NSW", postcode: "2430" },
{ city: "MITCHELLS ISLAND", state: "NSW", postcode: "2430" },
{ city: "MONDROOK", state: "NSW", postcode: "2430" },
{ city: "OLD BAR", state: "NSW", postcode: "2430" },
{ city: "OXLEY ISLAND", state: "NSW", postcode: "2430" },
{ city: "PAMPOOLAH", state: "NSW", postcode: "2430" },
{ city: "POSSUM BRUSH", state: "NSW", postcode: "2430" },
{ city: "PURFLEET", state: "NSW", postcode: "2430" },
{ city: "RAINBOW FLAT", state: "NSW", postcode: "2430" },
{ city: "RED HEAD", state: "NSW", postcode: "2430" },
{ city: "SALTWATER", state: "NSW", postcode: "2430" },
{ city: "TALLWOODS VILLAGE", state: "NSW", postcode: "2430" },
{ city: "TAREE", state: "NSW", postcode: "2430" },
{ city: "TAREE DC", state: "NSW", postcode: "2430" },
{ city: "TAREE SOUTH", state: "NSW", postcode: "2430" },
{ city: "TINONEE", state: "NSW", postcode: "2430" },
{ city: "UPPER LANSDOWNE", state: "NSW", postcode: "2430" },
{ city: "WALLABI POINT", state: "NSW", postcode: "2430" },
{ city: "HERONS CREEK", state: "NSW", postcode: "2439" },
{ city: "EAST KEMPSEY", state: "NSW", postcode: "2440" },
{ city: "GLADSTONE", state: "NSW", postcode: "2440" },
{ city: "SOUTH KEMPSEY", state: "NSW", postcode: "2440" },
{ city: "WEST KEMPSEY", state: "NSW", postcode: "2440" },
{ city: "BLACKMANS POINT", state: "NSW", postcode: "2444" },
{ city: "FERNBANK CREEK", state: "NSW", postcode: "2444" },
{ city: "FLYNNS BEACH", state: "NSW", postcode: "2444" },
{ city: "LIGHTHOUSE BEACH", state: "NSW", postcode: "2444" },
{ city: "LIMEBURNERS CREEK", state: "NSW", postcode: "2444" },
{ city: "NORTH SHORE", state: "NSW", postcode: "2444" },
{ city: "PORT MACQUARIE", state: "NSW", postcode: "2444" },
{ city: "PORT MACQUARIE BC", state: "NSW", postcode: "2444" },
{ city: "RIVERSIDE", state: "NSW", postcode: "2444" },
{ city: "SETTLEMENT CITY", state: "NSW", postcode: "2444" },
{ city: "THE HATCH", state: "NSW", postcode: "2444" },
{ city: "THRUMSTER", state: "NSW", postcode: "2444" },
{ city: "BOAMBEE", state: "NSW", postcode: "2450" },
{ city: "COFFS HARBOUR", state: "NSW", postcode: "2450" },
{ city: "COFFS HARBOUR DC", state: "NSW", postcode: "2450" },
{ city: "COFFS HARBOUR JETTY", state: "NSW", postcode: "2450" },
{ city: "COFFS HARBOUR PLAZA", state: "NSW", postcode: "2450" },
{ city: "BOAMBEE EAST", state: "NSW", postcode: "2452" },
{ city: "SAWTELL", state: "NSW", postcode: "2452" },
{ city: "TOORMINA", state: "NSW", postcode: "2452" },
{ city: "CARRS PENINSULA", state: "NSW", postcode: "2460" },
{ city: "GRAFTON", state: "NSW", postcode: "2460" },
{ city: "GRAFTON WEST", state: "NSW", postcode: "2460" },
{ city: "SOUTHGATE", state: "NSW", postcode: "2460" },
{ city: "SOUTH GRAFTON", state: "NSW", postcode: "2460" },
{ city: "YAMBA", state: "NSW", postcode: "2464" },
{ city: "ILUKA", state: "NSW", postcode: "2466" },
{ city: "EAST LISMORE", state: "NSW", postcode: "2480" },
{ city: "LISMORE", state: "NSW", postcode: "2480" },
{ city: "LISMORE DC", state: "NSW", postcode: "2480" },
{ city: "LISMORE HEIGHTS", state: "NSW", postcode: "2480" },
{ city: "NORTH LISMORE", state: "NSW", postcode: "2480" },
{ city: "SOUTH LISMORE", state: "NSW", postcode: "2480" },
{ city: "TWEED HEADS", state: "NSW", postcode: "2485" },
{ city: "TWEED HEADS SOUTH", state: "NSW", postcode: "2486" },
{ city: "TWEED HEADS SOUTH DC", state: "NSW", postcode: "2486" },
{ city: "CONISTON", state: "NSW", postcode: "2500" },
{ city: "GWYNNEVILLE", state: "NSW", postcode: "2500" },
{ city: "KEIRAVILLE", state: "NSW", postcode: "2500" },
{ city: "MANGERTON", state: "NSW", postcode: "2500" },
{ city: "MOUNT KEIRA", state: "NSW", postcode: "2500" },
{ city: "MOUNT SAINT THOMAS", state: "NSW", postcode: "2500" },
{ city: "NORTH WOLLONGONG", state: "NSW", postcode: "2500" },
{ city: "SPRING HILL", state: "NSW", postcode: "2500" },
{ city: "WEST WOLLONGONG", state: "NSW", postcode: "2500" },
{ city: "WOLLONGONG", state: "NSW", postcode: "2500" },
{ city: "WOLLONGONG DC", state: "NSW", postcode: "2500" },
{ city: "WOLLONGONG WEST", state: "NSW", postcode: "2500" },
{ city: "CRINGILA", state: "NSW", postcode: "2502" },
{ city: "KEMBLAWARRA", state: "NSW", postcode: "2502" },
{ city: "LAKE HEIGHTS", state: "NSW", postcode: "2502" },
{ city: "PRIMBEE", state: "NSW", postcode: "2502" },
{ city: "WARRAWONG", state: "NSW", postcode: "2502" },
{ city: "PORT KEMBLA", state: "NSW", postcode: "2505" },
{ city: "BERKELEY", state: "NSW", postcode: "2506" },
{ city: "AUSTINMER", state: "NSW", postcode: "2515" },
{ city: "SCARBOROUGH", state: "NSW", postcode: "2515" },
{ city: "THIRROUL", state: "NSW", postcode: "2515" },
{ city: "BULLI", state: "NSW", postcode: "2516" },
{ city: "RUSSELL VALE", state: "NSW", postcode: "2517" },
{ city: "WOONONA", state: "NSW", postcode: "2517" },
{ city: "WOONONA EAST", state: "NSW", postcode: "2517" },
{ city: "BELLAMBI", state: "NSW", postcode: "2518" },
{ city: "CORRIMAL", state: "NSW", postcode: "2518" },
{ city: "CORRIMAL EAST", state: "NSW", postcode: "2518" },
{ city: "EAST CORRIMAL", state: "NSW", postcode: "2518" },
{ city: "TARRAWANNA", state: "NSW", postcode: "2518" },
{ city: "TOWRADGI", state: "NSW", postcode: "2518" },
{ city: "BALGOWNIE", state: "NSW", postcode: "2519" },
{ city: "FAIRY MEADOW", state: "NSW", postcode: "2519" },
{ city: "FERNHILL", state: "NSW", postcode: "2519" },
{ city: "MOUNT OUSLEY", state: "NSW", postcode: "2519" },
{ city: "MOUNT PLEASANT", state: "NSW", postcode: "2519" },
{ city: "FIGTREE", state: "NSW", postcode: "2525" },
{ city: "CORDEAUX", state: "NSW", postcode: "2526" },
{ city: "CORDEAUX HEIGHTS", state: "NSW", postcode: "2526" },
{ city: "DOMBARTON", state: "NSW", postcode: "2526" },
{ city: "FARMBOROUGH HEIGHTS", state: "NSW", postcode: "2526" },
{ city: "KEMBLA GRANGE", state: "NSW", postcode: "2526" },
{ city: "KEMBLA HEIGHTS", state: "NSW", postcode: "2526" },
{ city: "MOUNT KEMBLA", state: "NSW", postcode: "2526" },
{ city: "UNANDERRA", state: "NSW", postcode: "2526" },
{ city: "UNANDERRA DC", state: "NSW", postcode: "2526" },
{ city: "ALBION PARK", state: "NSW", postcode: "2527" },
{ city: "ALBION PARK RAIL", state: "NSW", postcode: "2527" },
{ city: "CALDERWOOD", state: "NSW", postcode: "2527" },
{ city: "CROOM", state: "NSW", postcode: "2527" },
{ city: "NORTH MACQUARIE", state: "NSW", postcode: "2527" },
{ city: "TONGARRA", state: "NSW", postcode: "2527" },
{ city: "TULLIMBAR", state: "NSW", postcode: "2527" },
{ city: "YELLOW ROCK", state: "NSW", postcode: "2527" },
{ city: "BARRACK HEIGHTS", state: "NSW", postcode: "2528" },
{ city: "BARRACK POINT", state: "NSW", postcode: "2528" },
{ city: "LAKE ILLAWARRA", state: "NSW", postcode: "2528" },
{ city: "MOUNT WARRIGAL", state: "NSW", postcode: "2528" },
{ city: "WARILLA", state: "NSW", postcode: "2528" },
{ city: "WINDANG", state: "NSW", postcode: "2528" },
{ city: "BLACKBUTT", state: "NSW", postcode: "2529" },
{ city: "DUNMORE", state: "NSW", postcode: "2529" },
{ city: "FLINDERS", state: "NSW", postcode: "2529" },
{ city: "OAK FLATS", state: "NSW", postcode: "2529" },
{ city: "OAK FLATS DC", state: "NSW", postcode: "2529" },
{ city: "SHELL COVE", state: "NSW", postcode: "2529" },
{ city: "SHELLHARBOUR", state: "NSW", postcode: "2529" },
{ city: "SHELLHARBOUR CITY CENTRE", state: "NSW", postcode: "2529" },
{ city: "AVONDALE", state: "NSW", postcode: "2530" },
{ city: "BROWNSVILLE", state: "NSW", postcode: "2530" },
{ city: "CLEVELAND", state: "NSW", postcode: "2530" },
{ city: "DAPTO", state: "NSW", postcode: "2530" },
{ city: "DOMBARTON", state: "NSW", postcode: "2530" },
{ city: "HAYWARDS BAY", state: "NSW", postcode: "2530" },
{ city: "HORSLEY", state: "NSW", postcode: "2530" },
{ city: "HUNTLEY", state: "NSW", postcode: "2530" },
{ city: "KANAHOOKA", state: "NSW", postcode: "2530" },
{ city: "KOONAWARRA", state: "NSW", postcode: "2530" },
{ city: "MARSHALL MOUNT", state: "NSW", postcode: "2530" },
{ city: "WONGAWILLI", state: "NSW", postcode: "2530" },
{ city: "YALLAH", state: "NSW", postcode: "2530" },
{ city: "KIAMA", state: "NSW", postcode: "2533" },
{ city: "KIAMA DOWNS", state: "NSW", postcode: "2533" },
{ city: "KIAMA HEIGHTS", state: "NSW", postcode: "2533" },
{ city: "MINNAMURRA", state: "NSW", postcode: "2533" },
{ city: "BERRY", state: "NSW", postcode: "2535" },
{ city: "BATEHAVEN", state: "NSW", postcode: "2536" },
{ city: "BATEMANS BAY", state: "NSW", postcode: "2536" },
{ city: "BENANDARAH", state: "NSW", postcode: "2536" },
{ city: "BIMBIMBIE", state: "NSW", postcode: "2536" },
{ city: "BUCKENBOWRA", state: "NSW", postcode: "2536" },
{ city: "CATALINA", state: "NSW", postcode: "2536" },
{ city: "CURROWAN", state: "NSW", postcode: "2536" },
{ city: "DENHAMS BEACH", state: "NSW", postcode: "2536" },
{ city: "DEPOT BEACH", state: "NSW", postcode: "2536" },
{ city: "DURRAS NORTH", state: "NSW", postcode: "2536" },
{ city: "EAST LYNNE", state: "NSW", postcode: "2536" },
{ city: "GUERILLA BAY", state: "NSW", postcode: "2536" },
{ city: "JEREMADRA", state: "NSW", postcode: "2536" },
{ city: "LILLI PILLI", state: "NSW", postcode: "2536" },
{ city: "LONG BEACH", state: "NSW", postcode: "2536" },
{ city: "MALONEYS BEACH", state: "NSW", postcode: "2536" },
{ city: "MALUA BAY", state: "NSW", postcode: "2536" },
{ city: "MOGO", state: "NSW", postcode: "2536" },
{ city: "NELLIGEN", state: "NSW", postcode: "2536" },
{ city: "NORTH BATEMANS BAY", state: "NSW", postcode: "2536" },
{ city: "PEBBLY BEACH", state: "NSW", postcode: "2536" },
{ city: "ROSEDALE", state: "NSW", postcode: "2536" },
{ city: "RUNNYFORD", state: "NSW", postcode: "2536" },
{ city: "SOUTH DURRAS", state: "NSW", postcode: "2536" },
{ city: "SUNSHINE BAY", state: "NSW", postcode: "2536" },
{ city: "SURF BEACH", state: "NSW", postcode: "2536" },
{ city: "SURFSIDE", state: "NSW", postcode: "2536" },
{ city: "WOODLANDS", state: "NSW", postcode: "2536" },
{ city: "BERGALIA", state: "NSW", postcode: "2537" },
{ city: "BINGIE", state: "NSW", postcode: "2537" },
{ city: "BROULEE", state: "NSW", postcode: "2537" },
{ city: "COILA", state: "NSW", postcode: "2537" },
{ city: "CONGO", state: "NSW", postcode: "2537" },
{ city: "DEUA", state: "NSW", postcode: "2537" },
{ city: "DEUA RIVER VALLEY", state: "NSW", postcode: "2537" },
{ city: "KIORA", state: "NSW", postcode: "2537" },
{ city: "MERINGO", state: "NSW", postcode: "2537" },
{ city: "MOGENDOURA", state: "NSW", postcode: "2537" },
{ city: "MORUYA", state: "NSW", postcode: "2537" },
{ city: "MORUYA HEADS", state: "NSW", postcode: "2537" },
{ city: "MOSSY POINT", state: "NSW", postcode: "2537" },
{ city: "TOMAKIN", state: "NSW", postcode: "2537" },
{ city: "TURLINJAH", state: "NSW", postcode: "2537" },
{ city: "TUROSS HEAD", state: "NSW", postcode: "2537" },
{ city: "WAMBAN", state: "NSW", postcode: "2537" },
{ city: "BROOMAN", state: "NSW", postcode: "2538" },
{ city: "LITTLE FOREST", state: "NSW", postcode: "2538" },
{ city: "MILTON", state: "NSW", postcode: "2538" },
{ city: "MOGOOD", state: "NSW", postcode: "2538" },
{ city: "MORTON", state: "NSW", postcode: "2538" },
{ city: "PORTERS CREEK", state: "NSW", postcode: "2538" },
{ city: "WOODBURN", state: "NSW", postcode: "2538" },
{ city: "WOODSTOCK", state: "NSW", postcode: "2538" },
{ city: "BAWLEY POINT", state: "NSW", postcode: "2539" },
{ city: "BENDALONG", state: "NSW", postcode: "2539" },
{ city: "BERRINGER LAKE", state: "NSW", postcode: "2539" },
{ city: "BURRILL LAKE", state: "NSW", postcode: "2539" },
{ city: "COCKWHY", state: "NSW", postcode: "2539" },
{ city: "CONJOLA", state: "NSW", postcode: "2539" },
{ city: "CONJOLA PARK", state: "NSW", postcode: "2539" },
{ city: "CROOBYAR", state: "NSW", postcode: "2539" },
{ city: "CUNJURONG POINT", state: "NSW", postcode: "2539" },
{ city: "DOLPHIN POINT", state: "NSW", postcode: "2539" },
{ city: "FISHERMANS PARADISE", state: "NSW", postcode: "2539" },
{ city: "KINGS POINT", state: "NSW", postcode: "2539" },
{ city: "KIOLOA", state: "NSW", postcode: "2539" },
{ city: "LAKE CONJOLA", state: "NSW", postcode: "2539" },
{ city: "LAKE TABOURIE", state: "NSW", postcode: "2539" },
{ city: "MANYANA", state: "NSW", postcode: "2539" },
{ city: "MOLLYMOOK", state: "NSW", postcode: "2539" },
{ city: "MOLLYMOOK BEACH", state: "NSW", postcode: "2539" },
{ city: "MOUNT KINGIMAN", state: "NSW", postcode: "2539" },
{ city: "NARRAWALLEE", state: "NSW", postcode: "2539" },
{ city: "POINTER MOUNTAIN", state: "NSW", postcode: "2539" },
{ city: "PRETTY BEACH", state: "NSW", postcode: "2539" },
{ city: "TERMEIL", state: "NSW", postcode: "2539" },
{ city: "ULLADULLA", state: "NSW", postcode: "2539" },
{ city: "YADBORO", state: "NSW", postcode: "2539" },
{ city: "YATTE YATTAH", state: "NSW", postcode: "2539" },
{ city: "BAMARANG", state: "NSW", postcode: "2540" },
{ city: "BARRINGELLA", state: "NSW", postcode: "2540" },
{ city: "BASIN VIEW", state: "NSW", postcode: "2540" },
{ city: "BEECROFT PENINSULA", state: "NSW", postcode: "2540" },
{ city: "BERRARA", state: "NSW", postcode: "2540" },
{ city: "BEWONG", state: "NSW", postcode: "2540" },
{ city: "BOLONG", state: "NSW", postcode: "2540" },
{ city: "BOOLIJAH", state: "NSW", postcode: "2540" },
{ city: "BREAM BEACH", state: "NSW", postcode: "2540" },
{ city: "BROWNS MOUNTAIN", state: "NSW", postcode: "2540" },
{ city: "BRUNDEE", state: "NSW", postcode: "2540" },
{ city: "BUANGLA", state: "NSW", postcode: "2540" },
{ city: "BURRIER", state: "NSW", postcode: "2540" },
{ city: "CALLALA BAY", state: "NSW", postcode: "2540" },
{ city: "CALLALA BEACH", state: "NSW", postcode: "2540" },
{ city: "CAMBEWARRA", state: "NSW", postcode: "2540" },
{ city: "CAMBEWARRA VILLAGE", state: "NSW", postcode: "2540" },
{ city: "COMBERTON", state: "NSW", postcode: "2540" },
{ city: "COMERONG ISLAND", state: "NSW", postcode: "2540" },
{ city: "CUDMIRRAH", state: "NSW", postcode: "2540" },
{ city: "CULBURRA BEACH", state: "NSW", postcode: "2540" },
{ city: "CURRARONG", state: "NSW", postcode: "2540" },
{ city: "EROWAL BAY", state: "NSW", postcode: "2540" },
{ city: "ETTREMA", state: "NSW", postcode: "2540" },
{ city: "FALLS CREEK", state: "NSW", postcode: "2540" },
{ city: "GREENWELL POINT", state: "NSW", postcode: "2540" },
{ city: "HMAS ALBATROSS", state: "NSW", postcode: "2540" },
{ city: "HUSKISSON", state: "NSW", postcode: "2540" },
{ city: "HYAMS BEACH", state: "NSW", postcode: "2540" },
{ city: "ILLAROO", state: "NSW", postcode: "2540" },
{ city: "JERRAWANGALA", state: "NSW", postcode: "2540" },
{ city: "KINGHORNE", state: "NSW", postcode: "2540" },
{ city: "LONGREACH", state: "NSW", postcode: "2540" },
{ city: "MAYFIELD", state: "NSW", postcode: "2540" },
{ city: "MEROO MEADOW", state: "NSW", postcode: "2540" },
{ city: "MONDAYONG", state: "NSW", postcode: "2540" },
{ city: "MOOLLATTOO", state: "NSW", postcode: "2540" },
{ city: "MUNDAMIA", state: "NSW", postcode: "2540" },
{ city: "MYOLA", state: "NSW", postcode: "2540" },
{ city: "NOWRA HILL", state: "NSW", postcode: "2540" },
{ city: "NOWRA NAVAL PO", state: "NSW", postcode: "2540" },
{ city: "NUMBAA", state: "NSW", postcode: "2540" },
{ city: "OLD EROWAL BAY", state: "NSW", postcode: "2540" },
{ city: "ORIENT POINT", state: "NSW", postcode: "2540" },
{ city: "PARMA", state: "NSW", postcode: "2540" },
{ city: "SANCTUARY POINT", state: "NSW", postcode: "2540" },
{ city: "ST GEORGES BASIN", state: "NSW", postcode: "2540" },
{ city: "SUSSEX INLET", state: "NSW", postcode: "2540" },
{ city: "TALLOWAL", state: "NSW", postcode: "2540" },
{ city: "TULLARWALLA", state: "NSW", postcode: "2540" },
{ city: "TWELVE MILE PEG", state: "NSW", postcode: "2540" },
{ city: "VINCENTIA", state: "NSW", postcode: "2540" },
{ city: "WATERSLEIGH", state: "NSW", postcode: "2540" },
{ city: "WOLLUMBOOLA", state: "NSW", postcode: "2540" },
{ city: "BOMADERRY", state: "NSW", postcode: "2541" },
{ city: "NORTH NOWRA", state: "NSW", postcode: "2541" },
{ city: "NOWRA", state: "NSW", postcode: "2541" },
{ city: "NOWRA DC", state: "NSW", postcode: "2541" },
{ city: "NOWRA EAST", state: "NSW", postcode: "2541" },
{ city: "NOWRA NORTH", state: "NSW", postcode: "2541" },
{ city: "SOUTH NOWRA", state: "NSW", postcode: "2541" },
{ city: "WEST NOWRA", state: "NSW", postcode: "2541" },
{ city: "BELOWRA", state: "NSW", postcode: "2545" },
{ city: "BODALLA", state: "NSW", postcode: "2545" },
{ city: "CADGEE", state: "NSW", postcode: "2545" },
{ city: "EUROBODALLA", state: "NSW", postcode: "2545" },
{ city: "NERRIGUNDAH", state: "NSW", postcode: "2545" },
{ city: "POTATO POINT", state: "NSW", postcode: "2545" },
{ city: "AKOLELE", state: "NSW", postcode: "2546" },
{ city: "BARRAGGA BAY", state: "NSW", postcode: "2546" },
{ city: "BERMAGUI", state: "NSW", postcode: "2546" },
{ city: "CENTRAL TILBA", state: "NSW", postcode: "2546" },
{ city: "CORUNNA", state: "NSW", postcode: "2546" },
{ city: "CUTTAGEE", state: "NSW", postcode: "2546" },
{ city: "DALMENY", state: "NSW", postcode: "2546" },
{ city: "DIGNAMS CREEK", state: "NSW", postcode: "2546" },
{ city: "KIANGA", state: "NSW", postcode: "2546" },
{ city: "MURRAH", state: "NSW", postcode: "2546" },
{ city: "MYSTERY BAY", state: "NSW", postcode: "2546" },
{ city: "NAROOMA", state: "NSW", postcode: "2546" },
{ city: "NORTH NAROOMA", state: "NSW", postcode: "2546" },
{ city: "TILBA TILBA", state: "NSW", postcode: "2546" },
{ city: "TINPOT", state: "NSW", postcode: "2546" },
{ city: "WADBILLIGA", state: "NSW", postcode: "2546" },
{ city: "WALLAGA LAKE", state: "NSW", postcode: "2546" },
{ city: "BERRAMBOOL", state: "NSW", postcode: "2548" },
{ city: "BOURNDA", state: "NSW", postcode: "2548" },
{ city: "MERIMBULA", state: "NSW", postcode: "2548" },
{ city: "MIRADOR", state: "NSW", postcode: "2548" },
{ city: "TURA BEACH", state: "NSW", postcode: "2548" },
{ city: "YELLOW PINCH", state: "NSW", postcode: "2548" },
{ city: "BALD HILLS", state: "NSW", postcode: "2549" },
{ city: "BROADWATER", state: "NSW", postcode: "2549" },
{ city: "GREIGS FLAT", state: "NSW", postcode: "2549" },
{ city: "LOCHIEL", state: "NSW", postcode: "2549" },
{ city: "MILLINGANDI", state: "NSW", postcode: "2549" },
{ city: "NETHERCOTE", state: "NSW", postcode: "2549" },
{ city: "PAMBULA", state: "NSW", postcode: "2549" },
{ city: "PAMBULA BEACH", state: "NSW", postcode: "2549" },
{ city: "SOUTH PAMBULA", state: "NSW", postcode: "2549" },
{ city: "ANGLEDALE", state: "NSW", postcode: "2550" },
{ city: "BEGA", state: "NSW", postcode: "2550" },
{ city: "BEMBOKA", state: "NSW", postcode: "2550" },
{ city: "BLACK RANGE", state: "NSW", postcode: "2550" },
{ city: "BROGO", state: "NSW", postcode: "2550" },
{ city: "BUCKAJO", state: "NSW", postcode: "2550" },
{ city: "BURRAGATE", state: "NSW", postcode: "2550" },
{ city: "CANDELO", state: "NSW", postcode: "2550" },
{ city: "CHINNOCK", state: "NSW", postcode: "2550" },
{ city: "COBARGO", state: "NSW", postcode: "2550" },
{ city: "COOLAGOLITE", state: "NSW", postcode: "2550" },
{ city: "COOLANGUBRA", state: "NSW", postcode: "2550" },
{ city: "COOPERS GULLY", state: "NSW", postcode: "2550" },
{ city: "DEVILS HOLE", state: "NSW", postcode: "2550" },
{ city: "DOCTOR GEORGE MOUNTAIN", state: "NSW", postcode: "2550" },
{ city: "FROGS HOLLOW", state: "NSW", postcode: "2550" },
{ city: "GREENDALE", state: "NSW", postcode: "2550" },
{ city: "JELLAT JELLAT", state: "NSW", postcode: "2550" },
{ city: "KALARU", state: "NSW", postcode: "2550" },
{ city: "KAMERUKA", state: "NSW", postcode: "2550" },
{ city: "KANOONA", state: "NSW", postcode: "2550" },
{ city: "KINGSWOOD", state: "NSW", postcode: "2550" },
{ city: "MOGAREEKA", state: "NSW", postcode: "2550" },
{ city: "MOGILLA", state: "NSW", postcode: "2550" },
{ city: "MORANS CROSSING", state: "NSW", postcode: "2550" },
{ city: "MUMBULLA MOUNTAIN", state: "NSW", postcode: "2550" },
{ city: "MYRTLE MOUNTAIN", state: "NSW", postcode: "2550" },
{ city: "NELSON", state: "NSW", postcode: "2550" },
{ city: "NEW BUILDINGS", state: "NSW", postcode: "2550" },
{ city: "NUMBUGGA", state: "NSW", postcode: "2550" },
{ city: "PERICOE", state: "NSW", postcode: "2550" },
{ city: "QUAAMA", state: "NSW", postcode: "2550" },
{ city: "REEDY SWAMP", state: "NSW", postcode: "2550" },
{ city: "ROCKY HALL", state: "NSW", postcode: "2550" },
{ city: "SOUTH WOLUMLA", state: "NSW", postcode: "2550" },
{ city: "STONY CREEK", state: "NSW", postcode: "2550" },
{ city: "TANJA", state: "NSW", postcode: "2550" },
{ city: "TANTAWANGALO", state: "NSW", postcode: "2550" },
{ city: "TARRAGANDA", state: "NSW", postcode: "2550" },
{ city: "TATHRA", state: "NSW", postcode: "2550" },
{ city: "TOOTHDALE", state: "NSW", postcode: "2550" },
{ city: "TOWAMBA", state: "NSW", postcode: "2550" },
{ city: "VERONA", state: "NSW", postcode: "2550" },
{ city: "WALLAGOOT", state: "NSW", postcode: "2550" },
{ city: "WANDELLA", state: "NSW", postcode: "2550" },
{ city: "WAPENGO", state: "NSW", postcode: "2550" },
{ city: "WOG WOG", state: "NSW", postcode: "2550" },
{ city: "WOLUMLA", state: "NSW", postcode: "2550" },
{ city: "WYNDHAM", state: "NSW", postcode: "2550" },
{ city: "YAMBULLA", state: "NSW", postcode: "2550" },
{ city: "YANKEES CREEK", state: "NSW", postcode: "2550" },
{ city: "YOWRIE", state: "NSW", postcode: "2550" },
{ city: "BOYDTOWN", state: "NSW", postcode: "2551" },
{ city: "EDEN", state: "NSW", postcode: "2551" },
{ city: "EDROM", state: "NSW", postcode: "2551" },
{ city: "GREEN CAPE", state: "NSW", postcode: "2551" },
{ city: "KIAH", state: "NSW", postcode: "2551" },
{ city: "NADGEE", state: "NSW", postcode: "2551" },
{ city: "NARRABARBA", state: "NSW", postcode: "2551" },
{ city: "NULLICA", state: "NSW", postcode: "2551" },
{ city: "NUNGATTA", state: "NSW", postcode: "2551" },
{ city: "NUNGATTA SOUTH", state: "NSW", postcode: "2551" },
{ city: "TIMBILLICA", state: "NSW", postcode: "2551" },
{ city: "WONBOYN", state: "NSW", postcode: "2551" },
{ city: "WONBOYN LAKE", state: "NSW", postcode: "2551" },
{ city: "WONBOYN NORTH", state: "NSW", postcode: "2551" },
{ city: "BADGERYS CREEK", state: "NSW", postcode: "2555" },
{ city: "BRINGELLY", state: "NSW", postcode: "2556" },
{ city: "CATHERINE FIELD", state: "NSW", postcode: "2557" },
{ city: "GLEDSWOOD HILLS", state: "NSW", postcode: "2557" },
{ city: "GREGORY HILLS", state: "NSW", postcode: "2557" },
{ city: "ROSSMORE", state: "NSW", postcode: "2557" },
{ city: "EAGLE VALE", state: "NSW", postcode: "2558" },
{ city: "ESCHOL PARK", state: "NSW", postcode: "2558" },
{ city: "KEARNS", state: "NSW", postcode: "2558" },
{ city: "BLAIRMOUNT", state: "NSW", postcode: "2559" },
{ city: "CLAYMORE", state: "NSW", postcode: "2559" },
{ city: "AIRDS", state: "NSW", postcode: "2560" },
{ city: "AMBARVALE", state: "NSW", postcode: "2560" },
{ city: "APPIN", state: "NSW", postcode: "2560" },
{ city: "BLAIR ATHOL", state: "NSW", postcode: "2560" },
{ city: "BRADBURY", state: "NSW", postcode: "2560" },
{ city: "CAMPBELLTOWN", state: "NSW", postcode: "2560" },
{ city: "CAMPBELLTOWN NORTH", state: "NSW", postcode: "2560" },
{ city: "CATARACT", state: "NSW", postcode: "2560" },
{ city: "ENGLORIE PARK", state: "NSW", postcode: "2560" },
{ city: "GILEAD", state: "NSW", postcode: "2560" },
{ city: "GLEN ALPINE", state: "NSW", postcode: "2560" },
{ city: "KENTLYN", state: "NSW", postcode: "2560" },
{ city: "LEUMEAH", state: "NSW", postcode: "2560" },
{ city: "MACARTHUR SQUARE", state: "NSW", postcode: "2560" },
{ city: "ROSEMEADOW", state: "NSW", postcode: "2560" },
{ city: "RUSE", state: "NSW", postcode: "2560" },
{ city: "ST HELENS PARK", state: "NSW", postcode: "2560" },
{ city: "WEDDERBURN", state: "NSW", postcode: "2560" },
{ city: "WOODBINE", state: "NSW", postcode: "2560" },
{ city: "GLENQUARIE", state: "NSW", postcode: "2564" },
{ city: "LONG POINT", state: "NSW", postcode: "2564" },
{ city: "MACQUARIE FIELDS", state: "NSW", postcode: "2564" },
{ city: "BARDIA", state: "NSW", postcode: "2565" },
{ city: "DENHAM COURT", state: "NSW", postcode: "2565" },
{ city: "INGLEBURN", state: "NSW", postcode: "2565" },
{ city: "MACQUARIE LINKS", state: "NSW", postcode: "2565" },
{ city: "BOW BOWING", state: "NSW", postcode: "2566" },
{ city: "MINTO", state: "NSW", postcode: "2566" },
{ city: "MINTO DC", state: "NSW", postcode: "2566" },
{ city: "MINTO HEIGHTS", state: "NSW", postcode: "2566" },
{ city: "RABY", state: "NSW", postcode: "2566" },
{ city: "ST ANDREWS", state: "NSW", postcode: "2566" },
{ city: "VARROVILLE", state: "NSW", postcode: "2566" },
{ city: "CURRANS HILL", state: "NSW", postcode: "2567" },
{ city: "HARRINGTON PARK", state: "NSW", postcode: "2567" },
{ city: "MOUNT ANNAN", state: "NSW", postcode: "2567" },
{ city: "NARELLAN", state: "NSW", postcode: "2567" },
{ city: "NARELLAN DC", state: "NSW", postcode: "2567" },
{ city: "NARELLAN VALE", state: "NSW", postcode: "2567" },
{ city: "SMEATON GRANGE", state: "NSW", postcode: "2567" },
{ city: "CAMDEN", state: "NSW", postcode: "2570" },
{ city: "CAMDEN PARK", state: "NSW", postcode: "2570" },
{ city: "CAMDEN SOUTH", state: "NSW", postcode: "2570" },
{ city: "CAWDOR", state: "NSW", postcode: "2570" },
{ city: "COBBITTY", state: "NSW", postcode: "2570" },
{ city: "ORAN PARK", state: "NSW", postcode: "2570" },
{ city: "THE OAKS", state: "NSW", postcode: "2570" },
{ city: "THERESA PARK", state: "NSW", postcode: "2570" },
{ city: "MALDON", state: "NSW", postcode: "2571" },
{ city: "PICTON", state: "NSW", postcode: "2571" },
{ city: "THIRLMERE", state: "NSW", postcode: "2572" },
{ city: "MITTAGONG", state: "NSW", postcode: "2575" },
{ city: "BOWRAL", state: "NSW", postcode: "2576" },
{ city: "EAST BOWRAL", state: "NSW", postcode: "2576" },
{ city: "BERRIMA", state: "NSW", postcode: "2577" },
{ city: "MOSS VALE", state: "NSW", postcode: "2577" },
{ city: "BANNABY", state: "NSW", postcode: "2580" },
{ city: "BANNISTER", state: "NSW", postcode: "2580" },
{ city: "BAW BAW", state: "NSW", postcode: "2580" },
{ city: "BOXERS CREEK", state: "NSW", postcode: "2580" },
{ city: "BRISBANE GROVE", state: "NSW", postcode: "2580" },
{ city: "BUNGONIA", state: "NSW", postcode: "2580" },
{ city: "CARRICK", state: "NSW", postcode: "2580" },
{ city: "CHATSBURY", state: "NSW", postcode: "2580" },
{ city: "CURRAWANG", state: "NSW", postcode: "2580" },
{ city: "CURRAWEELA", state: "NSW", postcode: "2580" },
{ city: "GOLSPIE", state: "NSW", postcode: "2580" },
{ city: "GOULBURN", state: "NSW", postcode: "2580" },
{ city: "GOULBURN DC", state: "NSW", postcode: "2580" },
{ city: "GOULBURN NORTH", state: "NSW", postcode: "2580" },
{ city: "GREENWICH PARK", state: "NSW", postcode: "2580" },
{ city: "GUNDARY", state: "NSW", postcode: "2580" },
{ city: "JERRONG", state: "NSW", postcode: "2580" },
{ city: "KINGSDALE", state: "NSW", postcode: "2580" },
{ city: "LAKE BATHURST", state: "NSW", postcode: "2580" },
{ city: "LOWER BORO", state: "NSW", postcode: "2580" },
{ city: "MAYFIELD", state: "NSW", postcode: "2580" },
{ city: "MIDDLE ARM", state: "NSW", postcode: "2580" },
{ city: "MOUNT FAIRY", state: "NSW", postcode: "2580" },
{ city: "MUMMEL", state: "NSW", postcode: "2580" },
{ city: "MYRTLEVILLE", state: "NSW", postcode: "2580" },
{ city: "PARKESBOURNE", state: "NSW", postcode: "2580" },
{ city: "POMEROY", state: "NSW", postcode: "2580" },
{ city: "QUIALIGO", state: "NSW", postcode: "2580" },
{ city: "RICHLANDS", state: "NSW", postcode: "2580" },
{ city: "ROSLYN", state: "NSW", postcode: "2580" },
{ city: "RUN-O-WATERS", state: "NSW", postcode: "2580" },
{ city: "STONEQUARRY", state: "NSW", postcode: "2580" },
{ city: "TARAGO", state: "NSW", postcode: "2580" },
{ city: "TARALGA", state: "NSW", postcode: "2580" },
{ city: "TARLO", state: "NSW", postcode: "2580" },
{ city: "TIRRANNAVILLE", state: "NSW", postcode: "2580" },
{ city: "TOWRANG", state: "NSW", postcode: "2580" },
{ city: "WAYO", state: "NSW", postcode: "2580" },
{ city: "WIARBOROUGH", state: "NSW", postcode: "2580" },
{ city: "WINDELLAMA", state: "NSW", postcode: "2580" },
{ city: "WOMBEYAN CAVES", state: "NSW", postcode: "2580" },
{ city: "WOODHOUSELEE", state: "NSW", postcode: "2580" },
{ city: "YALBRAITH", state: "NSW", postcode: "2580" },
{ city: "YARRA", state: "NSW", postcode: "2580" },
{ city: "YASS", state: "NSW", postcode: "2582" },
{ city: "BIMBERI", state: "NSW", postcode: "2611" },
{ city: "BRINDABELLA", state: "NSW", postcode: "2611" },
{ city: "COOLEMAN", state: "NSW", postcode: "2611" },
{ city: "URIARRA", state: "NSW", postcode: "2611" },
{ city: "JERRABOMBERRA", state: "NSW", postcode: "2619" },
{ city: "BURRA", state: "NSW", postcode: "2620" },
{ city: "CARWOOLA", state: "NSW", postcode: "2620" },
{ city: "CLEAR RANGE", state: "NSW", postcode: "2620" },
{ city: "CRESTWOOD", state: "NSW", postcode: "2620" },
{ city: "ENVIRONA", state: "NSW", postcode: "2620" },
{ city: "GOOGONG", state: "NSW", postcode: "2620" },
{ city: "GREENLEIGH", state: "NSW", postcode: "2620" },
{ city: "GUNDAROO", state: "NSW", postcode: "2620" },
{ city: "KARABAR", state: "NSW", postcode: "2620" },
{ city: "MICHELAGO", state: "NSW", postcode: "2620" },
{ city: "QUEANBEYAN", state: "NSW", postcode: "2620" },
{ city: "QUEANBEYAN DC", state: "NSW", postcode: "2620" },
{ city: "QUEANBEYAN EAST", state: "NSW", postcode: "2620" },
{ city: "QUEANBEYAN WEST", state: "NSW", postcode: "2620" },
{ city: "ROYALLA", state: "NSW", postcode: "2620" },
{ city: "SUTTON", state: "NSW", postcode: "2620" },
{ city: "THE ANGLE", state: "NSW", postcode: "2620" },
{ city: "THE RIDGEWAY", state: "NSW", postcode: "2620" },
{ city: "TINDERRY", state: "NSW", postcode: "2620" },
{ city: "TRALEE", state: "NSW", postcode: "2620" },
{ city: "URILA", state: "NSW", postcode: "2620" },
{ city: "WAMBOIN", state: "NSW", postcode: "2620" },
{ city: "YARROW", state: "NSW", postcode: "2620" },
{ city: "ARABLE", state: "NSW", postcode: "2630" },
{ city: "BADJA", state: "NSW", postcode: "2630" },
{ city: "BILLILINGRA", state: "NSW", postcode: "2630" },
{ city: "BINJURA", state: "NSW", postcode: "2630" },
{ city: "BOBUNDARA", state: "NSW", postcode: "2630" },
{ city: "BUCKENDERRA", state: "NSW", postcode: "2630" },
{ city: "BUNGARBY", state: "NSW", postcode: "2630" },
{ city: "BUNYAN", state: "NSW", postcode: "2630" },
{ city: "CARLAMINDA", state: "NSW", postcode: "2630" },
{ city: "CHAKOLA", state: "NSW", postcode: "2630" },
{ city: "COOLRINGDON", state: "NSW", postcode: "2630" },
{ city: "COUNTEGANY", state: "NSW", postcode: "2630" },
{ city: "DAIRYMANS PLAINS", state: "NSW", postcode: "2630" },
{ city: "DANGELONG", state: "NSW", postcode: "2630" },
{ city: "DRY PLAIN", state: "NSW", postcode: "2630" },
{ city: "FRYING PAN", state: "NSW", postcode: "2630" },
{ city: "GLEN FERGUS", state: "NSW", postcode: "2630" },
{ city: "IRONMUNGY", state: "NSW", postcode: "2630" },
{ city: "JERANGLE", state: "NSW", postcode: "2630" },
{ city: "JIMENBUEN", state: "NSW", postcode: "2630" },
{ city: "MAFFRA", state: "NSW", postcode: "2630" },
{ city: "MIDDLE FLAT", state: "NSW", postcode: "2630" },
{ city: "MIDDLINGBANK", state: "NSW", postcode: "2630" },
{ city: "MURRUMBUCCA", state: "NSW", postcode: "2630" },
{ city: "MYALLA", state: "NSW", postcode: "2630" },
{ city: "NUMERALLA", state: "NSW", postcode: "2630" },
{ city: "PEAK VIEW", state: "NSW", postcode: "2630" },
{ city: "PINE VALLEY", state: "NSW", postcode: "2630" },
{ city: "POLO FLAT", state: "NSW", postcode: "2630" },
{ city: "RHINE FALLS", state: "NSW", postcode: "2630" },
{ city: "ROCK FLAT", state: "NSW", postcode: "2630" },
{ city: "ROSE VALLEY", state: "NSW", postcode: "2630" },
{ city: "SHANNONS FLAT", state: "NSW", postcode: "2630" },
{ city: "SPRINGFIELD", state: "NSW", postcode: "2630" },
{ city: "THE BROTHERS", state: "NSW", postcode: "2630" },
{ city: "TUROSS", state: "NSW", postcode: "2630" },
{ city: "WAMBROOK", state: "NSW", postcode: "2630" },
{ city: "ALBURY", state: "NSW", postcode: "2640" },
{ city: "BUNGOWANNAH", state: "NSW", postcode: "2640" },
{ city: "EAST ALBURY", state: "NSW", postcode: "2640" },
{ city: "ETTAMOGAH", state: "NSW", postcode: "2640" },
{ city: "GLENROY", state: "NSW", postcode: "2640" },
{ city: "LAVINGTON DC", state: "NSW", postcode: "2640" },
{ city: "MOORWATHA", state: "NSW", postcode: "2640" },
{ city: "NORTH ALBURY", state: "NSW", postcode: "2640" },
{ city: "OURNIE", state: "NSW", postcode: "2640" },
{ city: "SOUTH ALBURY", state: "NSW", postcode: "2640" },
{ city: "SPLITTERS CREEK", state: "NSW", postcode: "2640" },
{ city: "TABLE TOP", state: "NSW", postcode: "2640" },
{ city: "TALMALMO", state: "NSW", postcode: "2640" },
{ city: "THURGOONA", state: "NSW", postcode: "2640" },
{ city: "WEST ALBURY", state: "NSW", postcode: "2640" },
{ city: "WIRLINGA", state: "NSW", postcode: "2640" },
{ city: "WYMAH", state: "NSW", postcode: "2640" },
{ city: "LAVINGTON", state: "NSW", postcode: "2641" },
{ city: "DHULURA", state: "NSW", postcode: "2650" },
{ city: "EAST WAGGA WAGGA", state: "NSW", postcode: "2650" },
{ city: "EUNANOREENYA", state: "NSW", postcode: "2650" },
{ city: "NORTH WAGGA WAGGA", state: "NSW", postcode: "2650" },
{ city: "WAGGA WAGGA", state: "NSW", postcode: "2650" },
{ city: "WAGGA WAGGA BC", state: "NSW", postcode: "2650" },
{ city: "WAGGA WAGGA RAAF", state: "NSW", postcode: "2651" },
{ city: "GLENMORE PARK", state: "NSW", postcode: "2745" },
{ city: "GREENDALE", state: "NSW", postcode: "2745" },
{ city: "LUDDENHAM", state: "NSW", postcode: "2745" },
{ city: "MULGOA", state: "NSW", postcode: "2745" },
{ city: "REGENTVILLE", state: "NSW", postcode: "2745" },
{ city: "WALLACIA", state: "NSW", postcode: "2745" },
{ city: "CADDENS", state: "NSW", postcode: "2747" },
{ city: "CAMBRIDGE GARDENS", state: "NSW", postcode: "2747" },
{ city: "CAMBRIDGE PARK", state: "NSW", postcode: "2747" },
{ city: "CLAREMONT MEADOWS", state: "NSW", postcode: "2747" },
{ city: "JORDAN SPRINGS", state: "NSW", postcode: "2747" },
{ city: "KINGSWOOD", state: "NSW", postcode: "2747" },
{ city: "LLANDILO", state: "NSW", postcode: "2747" },
{ city: "SHANES PARK", state: "NSW", postcode: "2747" },
{ city: "WERRINGTON", state: "NSW", postcode: "2747" },
{ city: "WERRINGTON COUNTY", state: "NSW", postcode: "2747" },
{ city: "WERRINGTON DOWNS", state: "NSW", postcode: "2747" },
{ city: "ORCHARD HILLS", state: "NSW", postcode: "2748" },
{ city: "CASTLEREAGH", state: "NSW", postcode: "2749" },
{ city: "CRANEBROOK", state: "NSW", postcode: "2749" },
{ city: "EMU HEIGHTS", state: "NSW", postcode: "2750" },
{ city: "EMU PLAINS", state: "NSW", postcode: "2750" },
{ city: "JAMISONTOWN", state: "NSW", postcode: "2750" },
{ city: "LEONAY", state: "NSW", postcode: "2750" },
{ city: "PENRITH", state: "NSW", postcode: "2750" },
{ city: "PENRITH PLAZA", state: "NSW", postcode: "2750" },
{ city: "PENRITH SOUTH", state: "NSW", postcode: "2750" },
{ city: "SOUTH PENRITH", state: "NSW", postcode: "2750" },
{ city: "SILVERDALE", state: "NSW", postcode: "2752" },
{ city: "WARRAGAMBA", state: "NSW", postcode: "2752" },
{ city: "AGNES BANKS", state: "NSW", postcode: "2753" },
{ city: "HOBARTVILLE", state: "NSW", postcode: "2753" },
{ city: "LONDONDERRY", state: "NSW", postcode: "2753" },
{ city: "RICHMOND", state: "NSW", postcode: "2753" },
{ city: "RICHMOND LOWLANDS", state: "NSW", postcode: "2753" },
{ city: "NORTH RICHMOND", state: "NSW", postcode: "2754" },
{ city: "TENNYSON", state: "NSW", postcode: "2754" },
{ city: "THE SLOPES", state: "NSW", postcode: "2754" },
{ city: "BLIGH PARK", state: "NSW", postcode: "2756" },
{ city: "CUMBERLAND REACH", state: "NSW", postcode: "2756" },
{ city: "MCGRATHS HILL", state: "NSW", postcode: "2756" },
{ city: "MULGRAVE", state: "NSW", postcode: "2756" },
{ city: "PITT TOWN BOTTOMS", state: "NSW", postcode: "2756" },
{ city: "SOUTH WINDSOR", state: "NSW", postcode: "2756" },
{ city: "WILBERFORCE", state: "NSW", postcode: "2756" },
{ city: "WINDSOR", state: "NSW", postcode: "2756" },
{ city: "WINDSOR DOWNS", state: "NSW", postcode: "2756" },
{ city: "WOMERAH", state: "NSW", postcode: "2756" },
{ city: "ERSKINE PARK", state: "NSW", postcode: "2759" },
{ city: "ST CLAIR", state: "NSW", postcode: "2759" },
{ city: "COLYTON", state: "NSW", postcode: "2760" },
{ city: "NORTH ST MARYS", state: "NSW", postcode: "2760" },
{ city: "OXLEY PARK", state: "NSW", postcode: "2760" },
{ city: "ROPES CROSSING", state: "NSW", postcode: "2760" },
{ city: "ST MARYS", state: "NSW", postcode: "2760" },
{ city: "ST MARYS EAST", state: "NSW", postcode: "2760" },
{ city: "ST MARYS SOUTH", state: "NSW", postcode: "2760" },
{ city: "COLEBEE", state: "NSW", postcode: "2761" },
{ city: "DEAN PARK", state: "NSW", postcode: "2761" },
{ city: "GLENDENNING", state: "NSW", postcode: "2761" },
{ city: "HASSALL GROVE", state: "NSW", postcode: "2761" },
{ city: "OAKHURST", state: "NSW", postcode: "2761" },
{ city: "PLUMPTON", state: "NSW", postcode: "2761" },
{ city: "SCHOFIELDS", state: "NSW", postcode: "2762" },
{ city: "TALLAWONG", state: "NSW", postcode: "2762" },
{ city: "ACACIA GARDENS", state: "NSW", postcode: "2763" },
{ city: "NIRIMBA FIELDS", state: "NSW", postcode: "2763" },
{ city: "QUAKERS HILL", state: "NSW", postcode: "2763" },
{ city: "BERKSHIRE PARK", state: "NSW", postcode: "2765" },
{ city: "BOX HILL", state: "NSW", postcode: "2765" },
{ city: "GABLES", state: "NSW", postcode: "2765" },
{ city: "GRANTHAM FARM", state: "NSW", postcode: "2765" },
{ city: "MARAYLYA", state: "NSW", postcode: "2765" },
{ city: "MARSDEN PARK", state: "NSW", postcode: "2765" },
{ city: "MELONBA", state: "NSW", postcode: "2765" },
{ city: "NELSON", state: "NSW", postcode: "2765" },
{ city: "OAKVILLE", state: "NSW", postcode: "2765" },
{ city: "RIVERSTONE", state: "NSW", postcode: "2765" },
{ city: "VINEYARD", state: "NSW", postcode: "2765" },
{ city: "EASTERN CREEK", state: "NSW", postcode: "2766" },
{ city: "ROOTY HILL", state: "NSW", postcode: "2766" },
{ city: "BUNGARRIBEE", state: "NSW", postcode: "2767" },
{ city: "DOONSIDE", state: "NSW", postcode: "2767" },
{ city: "WOODCROFT", state: "NSW", postcode: "2767" },
{ city: "GLENWOOD", state: "NSW", postcode: "2768" },
{ city: "PARKLEA", state: "NSW", postcode: "2768" },
{ city: "STANHOPE GARDENS", state: "NSW", postcode: "2768" },
{ city: "THE PONDS", state: "NSW", postcode: "2769" },
{ city: "BIDWILL", state: "NSW", postcode: "2770" },
{ city: "BLACKETT", state: "NSW", postcode: "2770" },
{ city: "DHARRUK", state: "NSW", postcode: "2770" },
{ city: "EMERTON", state: "NSW", postcode: "2770" },
{ city: "HEBERSHAM", state: "NSW", postcode: "2770" },
{ city: "LETHBRIDGE PARK", state: "NSW", postcode: "2770" },
{ city: "MINCHINBURY", state: "NSW", postcode: "2770" },
{ city: "MOUNT DRUITT", state: "NSW", postcode: "2770" },
{ city: "MOUNT DRUITT VILLAGE", state: "NSW", postcode: "2770" },
{ city: "MT DRUITT", state: "NSW", postcode: "2770" },
{ city: "SHALVEY", state: "NSW", postcode: "2770" },
{ city: "TREGEAR", state: "NSW", postcode: "2770" },
{ city: "WHALAN", state: "NSW", postcode: "2770" },
{ city: "WILLMOT", state: "NSW", postcode: "2770" },
{ city: "GLENBROOK", state: "NSW", postcode: "2773" },
{ city: "BLAXLAND", state: "NSW", postcode: "2774" },
{ city: "BLAXLAND EAST", state: "NSW", postcode: "2774" },
{ city: "FAULCONBRIDGE", state: "NSW", postcode: "2776" },
{ city: "BLUE MOUNTAINS NATIONAL PARK", state: "NSW", postcode: "2777" },
{ city: "SPRINGWOOD", state: "NSW", postcode: "2777" },
{ city: "VALLEY HEIGHTS", state: "NSW", postcode: "2777" },
{ city: "WOODFORD", state: "NSW", postcode: "2778" },
{ city: "HAZELBROOK", state: "NSW", postcode: "2779" },
{ city: "KATOOMBA", state: "NSW", postcode: "2780" },
{ city: "KATOOMBA DC", state: "NSW", postcode: "2780" },
{ city: "LEURA", state: "NSW", postcode: "2780" },
{ city: "MEDLOW BATH", state: "NSW", postcode: "2780" },
{ city: "WENTWORTH FALLS", state: "NSW", postcode: "2782" },
{ city: "LAWSON", state: "NSW", postcode: "2783" },
{ city: "BLACKHEATH", state: "NSW", postcode: "2785" },
{ city: "MOUNT VICTORIA", state: "NSW", postcode: "2786" },
{ city: "BLUE MOUNTAINS NATIONAL PARK", state: "NSW", postcode: "2787" },
{ city: "YERRANDERIE", state: "NSW", postcode: "2787" },
{ city: "OAKEY PARK", state: "NSW", postcode: "2790" },
{ city: "BATHURST", state: "NSW", postcode: "2795" },
{ city: "BATHURST WEST", state: "NSW", postcode: "2795" },
{ city: "KELSO", state: "NSW", postcode: "2795" },
{ city: "MOUNT PANORAMA", state: "NSW", postcode: "2795" },
{ city: "RAGLAN", state: "NSW", postcode: "2795" },
{ city: "SOUTH BATHURST", state: "NSW", postcode: "2795" },
{ city: "WEST BATHURST", state: "NSW", postcode: "2795" },
{ city: "BELGRAVIA", state: "NSW", postcode: "2800" },
{ city: "BOREE", state: "NSW", postcode: "2800" },
{ city: "BORENORE", state: "NSW", postcode: "2800" },
{ city: "BYNG", state: "NSW", postcode: "2800" },
{ city: "CADIA", state: "NSW", postcode: "2800" },
{ city: "CANOBOLAS", state: "NSW", postcode: "2800" },
{ city: "CARGO", state: "NSW", postcode: "2800" },
{ city: "CLERGATE", state: "NSW", postcode: "2800" },
{ city: "CLIFTON GROVE", state: "NSW", postcode: "2800" },
{ city: "EMU SWAMP", state: "NSW", postcode: "2800" },
{ city: "FOUR MILE CREEK", state: "NSW", postcode: "2800" },
{ city: "HUNTLEY", state: "NSW", postcode: "2800" },
{ city: "KANGAROOBIE", state: "NSW", postcode: "2800" },
{ city: "KERRS CREEK", state: "NSW", postcode: "2800" },
{ city: "LEWIS PONDS", state: "NSW", postcode: "2800" },
{ city: "LIDSTER", state: "NSW", postcode: "2800" },
{ city: "LOWER LEWIS PONDS", state: "NSW", postcode: "2800" },
{ city: "LUCKNOW", state: "NSW", postcode: "2800" },
{ city: "MARCH", state: "NSW", postcode: "2800" },
{ city: "MULLION CREEK", state: "NSW", postcode: "2800" },
{ city: "NANGAR", state: "NSW", postcode: "2800" },
{ city: "NASHDALE", state: "NSW", postcode: "2800" },
{ city: "OPHIR", state: "NSW", postcode: "2800" },
{ city: "ORANGE", state: "NSW", postcode: "2800" },
{ city: "ORANGE DC", state: "NSW", postcode: "2800" },
{ city: "ORANGE EAST", state: "NSW", postcode: "2800" },
{ city: "PANUARA", state: "NSW", postcode: "2800" },
{ city: "SHADFORTH", state: "NSW", postcode: "2800" },
{ city: "SPRING CREEK", state: "NSW", postcode: "2800" },
{ city: "SPRING HILL", state: "NSW", postcode: "2800" },
{ city: "SPRINGSIDE", state: "NSW", postcode: "2800" },
{ city: "SUMMER HILL CREEK", state: "NSW", postcode: "2800" },
{ city: "WALDEGRAVE", state: "NSW", postcode: "2800" },
{ city: "WINDERA", state: "NSW", postcode: "2800" },
{ city: "BALLIMORE", state: "NSW", postcode: "2830" },
{ city: "BARBIGAL", state: "NSW", postcode: "2830" },
{ city: "BENI", state: "NSW", postcode: "2830" },
{ city: "BOOTHENBA", state: "NSW", postcode: "2830" },
{ city: "BROCKLEHURST", state: "NSW", postcode: "2830" },
{ city: "BRUAH", state: "NSW", postcode: "2830" },
{ city: "BUNGLEGUMBIE", state: "NSW", postcode: "2830" },
{ city: "BURRABADINE", state: "NSW", postcode: "2830" },
{ city: "BUTLERS FALLS", state: "NSW", postcode: "2830" },
{ city: "COOLBAGGIE", state: "NSW", postcode: "2830" },
{ city: "CUMBOOGLE", state: "NSW", postcode: "2830" },
{ city: "DUBBO", state: "NSW", postcode: "2830" },
{ city: "DUBBO DC", state: "NSW", postcode: "2830" },
{ city: "DUBBO EAST", state: "NSW", postcode: "2830" },
{ city: "DUBBO GROVE", state: "NSW", postcode: "2830" },
{ city: "DUBBO WEST", state: "NSW", postcode: "2830" },
{ city: "ESCHOL", state: "NSW", postcode: "2830" },
{ city: "EULOMOGO", state: "NSW", postcode: "2830" },
{ city: "GLENGERRA", state: "NSW", postcode: "2830" },
{ city: "GOONOO FOREST", state: "NSW", postcode: "2830" },
{ city: "JONES CREEK", state: "NSW", postcode: "2830" },
{ city: "KICKABIL", state: "NSW", postcode: "2830" },
{ city: "MINORE", state: "NSW", postcode: "2830" },
{ city: "MOGRIGUY", state: "NSW", postcode: "2830" },
{ city: "MOUNTAIN CREEK", state: "NSW", postcode: "2830" },
{ city: "MURONBUNG", state: "NSW", postcode: "2830" },
{ city: "MURRUMBIDGERIE", state: "NSW", postcode: "2830" },
{ city: "RAWSONVILLE", state: "NSW", postcode: "2830" },
{ city: "TERRAMUNGAMINE", state: "NSW", postcode: "2830" },
{ city: "TOONGI", state: "NSW", postcode: "2830" },
{ city: "WAMBANGALANG", state: "NSW", postcode: "2830" },
{ city: "YARRABAR", state: "NSW", postcode: "2830" },
{ city: "PORTLAND", state: "NSW", postcode: "2847" },
{ city: "MUDGEE", state: "NSW", postcode: "2850" },
{ city: "BROKEN HILL", state: "NSW", postcode: "2880" },
{ city: "AMOSFIELD", state: "NSW", postcode: "4380" },
{ city: "RUBY CREEK", state: "NSW", postcode: "4380" },
{ city: "UNDERCLIFFE", state: "NSW", postcode: "4380" },
{ city: "DARWIN", state: "NT", postcode: "800" },
{ city: "DARWIN CITY", state: "NT", postcode: "800" },
{ city: "ALAWA", state: "NT", postcode: "810" },
{ city: "BRINKIN", state: "NT", postcode: "810" },
{ city: "CASUARINA", state: "NT", postcode: "810" },
{ city: "COCONUT GROVE", state: "NT", postcode: "810" },
{ city: "JINGILI", state: "NT", postcode: "810" },
{ city: "LEE POINT", state: "NT", postcode: "810" },
{ city: "LYONS", state: "NT", postcode: "810" },
{ city: "MILLNER", state: "NT", postcode: "810" },
{ city: "MOIL", state: "NT", postcode: "810" },
{ city: "MUIRHEAD", state: "NT", postcode: "810" },
{ city: "NAKARA", state: "NT", postcode: "810" },
{ city: "NIGHTCLIFF", state: "NT", postcode: "810" },
{ city: "RAPID CREEK", state: "NT", postcode: "810" },
{ city: "TIWI", state: "NT", postcode: "810" },
{ city: "WAGAMAN", state: "NT", postcode: "810" },
{ city: "WANGURI", state: "NT", postcode: "810" },
{ city: "ANULA", state: "NT", postcode: "812" },
{ city: "BUFFALO CREEK", state: "NT", postcode: "812" },
{ city: "HOLMES", state: "NT", postcode: "812" },
{ city: "KARAMA", state: "NT", postcode: "812" },
{ city: "LEANYER", state: "NT", postcode: "812" },
{ city: "MALAK", state: "NT", postcode: "812" },
{ city: "MARRARA", state: "NT", postcode: "812" },
{ city: "NORTHLAKES", state: "NT", postcode: "812" },
{ city: "SANDERSON", state: "NT", postcode: "812" },
{ city: "WOODLEIGH GARDENS", state: "NT", postcode: "812" },
{ city: "WULAGI", state: "NT", postcode: "812" },
{ city: "BAGOT", state: "NT", postcode: "820" },
{ city: "BAYVIEW", state: "NT", postcode: "820" },
{ city: "CHARLES DARWIN", state: "NT", postcode: "820" },
{ city: "COONAWARRA", state: "NT", postcode: "820" },
{ city: "CULLEN BAY", state: "NT", postcode: "820" },
{ city: "DARWIN CITY", state: "NT", postcode: "820" },
{ city: "DARWIN DC", state: "NT", postcode: "820" },
{ city: "DARWIN INTERNATIONAL AIRPORT", state: "NT", postcode: "820" },
{ city: "DARWIN MC", state: "NT", postcode: "820" },
{ city: "EAST POINT", state: "NT", postcode: "820" },
{ city: "EATON", state: "NT", postcode: "820" },
{ city: "FANNIE BAY", state: "NT", postcode: "820" },
{ city: "LARRAKEYAH", state: "NT", postcode: "820" },
{ city: "LUDMILLA", state: "NT", postcode: "820" },
{ city: "PARAP", state: "NT", postcode: "820" },
{ city: "RAAF BASE DARWIN", state: "NT", postcode: "820" },
{ city: "STUART PARK", state: "NT", postcode: "820" },
{ city: "THE GARDENS", state: "NT", postcode: "820" },
{ city: "THE NARROWS", state: "NT", postcode: "820" },
{ city: "WINNELLIE", state: "NT", postcode: "820" },
{ city: "WOOLNER", state: "NT", postcode: "820" },
{ city: "WINNELLIE", state: "NT", postcode: "821" },
{ city: "CHARLES DARWIN", state: "NT", postcode: "822" },
{ city: "EAST ARM", state: "NT", postcode: "822" },
{ city: "ELRUNDIE", state: "NT", postcode: "822" },
{ city: "HIDDEN VALLEY", state: "NT", postcode: "822" },
{ city: "MCMINNS LAGOON", state: "NT", postcode: "822" },
{ city: "MICKETT CREEK", state: "NT", postcode: "822" },
{ city: "TIVENDALE", state: "NT", postcode: "822" },
{ city: "WISHART", state: "NT", postcode: "822" },
{ city: "BERRIMAH", state: "NT", postcode: "828" },
{ city: "KNUCKEY LAGOON", state: "NT", postcode: "828" },
{ city: "HOLTZE", state: "NT", postcode: "829" },
{ city: "PINELANDS", state: "NT", postcode: "829" },
{ city: "ARCHER", state: "NT", postcode: "830" },
{ city: "DRIVER", state: "NT", postcode: "830" },
{ city: "DURACK", state: "NT", postcode: "830" },
{ city: "FARRAR", state: "NT", postcode: "830" },
{ city: "GRAY", state: "NT", postcode: "830" },
{ city: "MARLOW LAGOON", state: "NT", postcode: "830" },
{ city: "MICKET CREEK", state: "NT", postcode: "830" },
{ city: "MOULDEN", state: "NT", postcode: "830" },
{ city: "PALMERSTON", state: "NT", postcode: "830" },
{ city: "PALMERSTON CITY", state: "NT", postcode: "830" },
{ city: "SHOAL BAY", state: "NT", postcode: "830" },
{ city: "WOODROFFE", state: "NT", postcode: "830" },
{ city: "YARRAWONGA", state: "NT", postcode: "830" },
{ city: "BAKEWELL", state: "NT", postcode: "832" },
{ city: "BELLAMACK", state: "NT", postcode: "832" },
{ city: "GUNN", state: "NT", postcode: "832" },
{ city: "MITCHELL", state: "NT", postcode: "832" },
{ city: "ROSEBERY", state: "NT", postcode: "832" },
{ city: "ROSEBERY HEIGHTS", state: "NT", postcode: "832" },
{ city: "KATHERINE", state: "NT", postcode: "850" },
{ city: "KATHERINE EAST", state: "NT", postcode: "850" },
{ city: "KATHERINE SOUTH", state: "NT", postcode: "850" },
{ city: "KATHERINE", state: "NT", postcode: "852" },
{ city: "ALICE SPRINGS", state: "NT", postcode: "870" },
{ city: "KILGARIFF", state: "NT", postcode: "870" },
{ city: "ALICE SPRINGS", state: "NT", postcode: "872" },
{ city: "KILGARIFF", state: "NT", postcode: "873" },
{ city: "BRISBANE", state: "QLD", postcode: "4000" },
{ city: "BRISBANE ADELAIDE STREET", state: "QLD", postcode: "4000" },
{ city: "BRISBANE CITY", state: "QLD", postcode: "4000" },
{ city: "BRISBANE GPO", state: "QLD", postcode: "4000" },
{ city: "NORTH QUAY", state: "QLD", postcode: "4000" },
{ city: "PETRIE TERRACE", state: "QLD", postcode: "4000" },
{ city: "SPRING HILL", state: "QLD", postcode: "4000" },
{ city: "BRISBANE", state: "QLD", postcode: "4001" },
{ city: "BRISBANE CITY", state: "QLD", postcode: "4001" },
{ city: "CITY EAST", state: "QLD", postcode: "4002" },
{ city: "NEW FARM", state: "QLD", postcode: "4005" },
{ city: "TENERIFFE", state: "QLD", postcode: "4005" },
{ city: "BOWEN HILLS", state: "QLD", postcode: "4006" },
{ city: "FORTITUDE VALLEY", state: "QLD", postcode: "4006" },
{ city: "FORTITUDE VALLEY BC", state: "QLD", postcode: "4006" },
{ city: "HERSTON", state: "QLD", postcode: "4006" },
{ city: "NEWSTEAD", state: "QLD", postcode: "4006" },
{ city: "ASCOT", state: "QLD", postcode: "4007" },
{ city: "HAMILTON", state: "QLD", postcode: "4007" },
{ city: "HAMILTON CENTRAL", state: "QLD", postcode: "4007" },
{ city: "BRISBANE AIRPORT", state: "QLD", postcode: "4008" },
{ city: "PINKENBA", state: "QLD", postcode: "4008" },
{ city: "EAGLE FARM", state: "QLD", postcode: "4009" },
{ city: "EAGLE FARM BC", state: "QLD", postcode: "4009" },
{ city: "ALBION", state: "QLD", postcode: "4010" },
{ city: "ALBION BC", state: "QLD", postcode: "4010" },
{ city: "ALBION DC", state: "QLD", postcode: "4010" },
{ city: "CLAYFIELD", state: "QLD", postcode: "4011" },
{ city: "HENDRA", state: "QLD", postcode: "4011" },
{ city: "NUNDAH", state: "QLD", postcode: "4012" },
{ city: "TOOMBUL", state: "QLD", postcode: "4012" },
{ city: "WAVELL HEIGHTS", state: "QLD", postcode: "4012" },
{ city: "WAVELL HEIGHTS NORTH", state: "QLD", postcode: "4012" },
{ city: "NORTHGATE", state: "QLD", postcode: "4013" },
{ city: "BANYO", state: "QLD", postcode: "4014" },
{ city: "NUDGEE", state: "QLD", postcode: "4014" },
{ city: "NUDGEE BEACH", state: "QLD", postcode: "4014" },
{ city: "VIRGINIA", state: "QLD", postcode: "4014" },
{ city: "VIRGINIA BC", state: "QLD", postcode: "4014" },
{ city: "VIRGINIA DC", state: "QLD", postcode: "4014" },
{ city: "BRACKEN RIDGE", state: "QLD", postcode: "4017" },
{ city: "BRIGHTON", state: "QLD", postcode: "4017" },
{ city: "BRIGHTON EVENTIDE", state: "QLD", postcode: "4017" },
{ city: "BRIGHTON NATHAN STREET", state: "QLD", postcode: "4017" },
{ city: "DEAGON", state: "QLD", postcode: "4017" },
{ city: "SANDGATE", state: "QLD", postcode: "4017" },
{ city: "SANDGATE DC", state: "QLD", postcode: "4017" },
{ city: "SHORNCLIFFE", state: "QLD", postcode: "4017" },
{ city: "FITZGIBBON", state: "QLD", postcode: "4018" },
{ city: "TAIGUM", state: "QLD", postcode: "4018" },
{ city: "CLONTARF", state: "QLD", postcode: "4019" },
{ city: "CLONTARF BEACH", state: "QLD", postcode: "4019" },
{ city: "CLONTARF DC", state: "QLD", postcode: "4019" },
{ city: "MARGATE", state: "QLD", postcode: "4019" },
{ city: "MARGATE BEACH", state: "QLD", postcode: "4019" },
{ city: "WOODY POINT", state: "QLD", postcode: "4019" },
{ city: "NEWPORT", state: "QLD", postcode: "4020" },
{ city: "REDCLIFFE", state: "QLD", postcode: "4020" },
{ city: "REDCLIFFE NORTH", state: "QLD", postcode: "4020" },
{ city: "SCARBOROUGH", state: "QLD", postcode: "4020" },
{ city: "KIPPA-RING", state: "QLD", postcode: "4021" },
{ city: "ROTHWELL", state: "QLD", postcode: "4022" },
{ city: "BULWER", state: "QLD", postcode: "4025" },
{ city: "CAPE MORETON", state: "QLD", postcode: "4025" },
{ city: "COWAN COWAN", state: "QLD", postcode: "4025" },
{ city: "KOORINGAL", state: "QLD", postcode: "4025" },
{ city: "MORETON ISLAND", state: "QLD", postcode: "4025" },
{ city: "TANGALOOMA", state: "QLD", postcode: "4025" },
{ city: "ROYAL BRISBANE HOSPITAL", state: "QLD", postcode: "4029" },
{ city: "KALINGA", state: "QLD", postcode: "4030" },
{ city: "LUTWYCHE", state: "QLD", postcode: "4030" },
{ city: "WINDSOR", state: "QLD", postcode: "4030" },
{ city: "WOOLOOWIN", state: "QLD", postcode: "4030" },
{ city: "GORDON PARK", state: "QLD", postcode: "4031" },
{ city: "KEDRON", state: "QLD", postcode: "4031" },
{ city: "CHERMSIDE", state: "QLD", postcode: "4032" },
{ city: "CHERMSIDE BC", state: "QLD", postcode: "4032" },
{ city: "CHERMSIDE CENTRE", state: "QLD", postcode: "4032" },
{ city: "CHERMSIDE SOUTH", state: "QLD", postcode: "4032" },
{ city: "CHERMSIDE WEST", state: "QLD", postcode: "4032" },
{ city: "ASPLEY", state: "QLD", postcode: "4034" },
{ city: "BOONDALL", state: "QLD", postcode: "4034" },
{ city: "CARSELDINE", state: "QLD", postcode: "4034" },
{ city: "GEEBUNG", state: "QLD", postcode: "4034" },
{ city: "ZILLMERE", state: "QLD", postcode: "4034" },
{ city: "ALBANY CREEK", state: "QLD", postcode: "4035" },
{ city: "BRIDGEMAN DOWNS", state: "QLD", postcode: "4035" },
{ city: "BALD HILLS", state: "QLD", postcode: "4036" },
{ city: "EATONS HILL", state: "QLD", postcode: "4037" },
{ city: "ALDERLEY", state: "QLD", postcode: "4051" },
{ city: "ENOGGERA", state: "QLD", postcode: "4051" },
{ city: "GAYTHORNE", state: "QLD", postcode: "4051" },
{ city: "GRANGE", state: "QLD", postcode: "4051" },
{ city: "NEWMARKET", state: "QLD", postcode: "4051" },
{ city: "WILSTON", state: "QLD", postcode: "4051" },
{ city: "BROOKSIDE CENTRE", state: "QLD", postcode: "4053" },
{ city: "EVERTON HILLS", state: "QLD", postcode: "4053" },
{ city: "EVERTON PARK", state: "QLD", postcode: "4053" },
{ city: "MCDOWALL", state: "QLD", postcode: "4053" },
{ city: "MITCHELTON", state: "QLD", postcode: "4053" },
{ city: "STAFFORD", state: "QLD", postcode: "4053" },
{ city: "STAFFORD BC", state: "QLD", postcode: "4053" },
{ city: "STAFFORD DC", state: "QLD", postcode: "4053" },
{ city: "STAFFORD HEIGHTS", state: "QLD", postcode: "4053" },
{ city: "ARANA HILLS", state: "QLD", postcode: "4054" },
{ city: "KEPERRA", state: "QLD", postcode: "4054" },
{ city: "BUNYA", state: "QLD", postcode: "4055" },
{ city: "FERNY GROVE", state: "QLD", postcode: "4055" },
{ city: "FERNY HILLS", state: "QLD", postcode: "4055" },
{ city: "FERNY HILLS DC", state: "QLD", postcode: "4055" },
{ city: "UPPER KEDRON", state: "QLD", postcode: "4055" },
{ city: "KELVIN GROVE", state: "QLD", postcode: "4059" },
{ city: "KELVIN GROVE BC", state: "QLD", postcode: "4059" },
{ city: "KELVIN GROVE DC", state: "QLD", postcode: "4059" },
{ city: "RED HILL", state: "QLD", postcode: "4059" },
{ city: "ASHGROVE", state: "QLD", postcode: "4060" },
{ city: "ASHGROVE EAST", state: "QLD", postcode: "4060" },
{ city: "ASHGROVE WEST", state: "QLD", postcode: "4060" },
{ city: "THE GAP", state: "QLD", postcode: "4061" },
{ city: "MILTON", state: "QLD", postcode: "4064" },
{ city: "MILTON BC", state: "QLD", postcode: "4064" },
{ city: "PADDINGTON", state: "QLD", postcode: "4064" },
{ city: "ROSALIE VILLAGE", state: "QLD", postcode: "4064" },
{ city: "BARDON", state: "QLD", postcode: "4065" },
{ city: "AUCHENFLOWER", state: "QLD", postcode: "4066" },
{ city: "MOUNT COOT-THA", state: "QLD", postcode: "4066" },
{ city: "TOOWONG", state: "QLD", postcode: "4066" },
{ city: "TOOWONG BC", state: "QLD", postcode: "4066" },
{ city: "TOOWONG DC", state: "QLD", postcode: "4066" },
{ city: "ST LUCIA", state: "QLD", postcode: "4067" },
{ city: "ST LUCIA SOUTH", state: "QLD", postcode: "4067" },
{ city: "CHELMER", state: "QLD", postcode: "4068" },
{ city: "INDOOROOPILLY", state: "QLD", postcode: "4068" },
{ city: "INDOOROOPILLY CENTRE", state: "QLD", postcode: "4068" },
{ city: "TARINGA", state: "QLD", postcode: "4068" },
{ city: "BROOKFIELD", state: "QLD", postcode: "4069" },
{ city: "CHAPEL HILL", state: "QLD", postcode: "4069" },
{ city: "FIG TREE POCKET", state: "QLD", postcode: "4069" },
{ city: "KENMORE", state: "QLD", postcode: "4069" },
{ city: "KENMORE DC", state: "QLD", postcode: "4069" },
{ city: "KENMORE EAST", state: "QLD", postcode: "4069" },
{ city: "KENMORE HILLS", state: "QLD", postcode: "4069" },
{ city: "PINJARRA HILLS", state: "QLD", postcode: "4069" },
{ city: "PULLENVALE", state: "QLD", postcode: "4069" },
{ city: "UPPER BROOKFIELD", state: "QLD", postcode: "4069" },
{ city: "ANSTEAD", state: "QLD", postcode: "4070" },
{ city: "BELLBOWRIE", state: "QLD", postcode: "4070" },
{ city: "MOGGILL", state: "QLD", postcode: "4070" },
{ city: "UNIVERSITY OF QUEENSLAND", state: "QLD", postcode: "4072" },
{ city: "SEVENTEEN MILE ROCKS", state: "QLD", postcode: "4073" },
{ city: "SINNAMON PARK", state: "QLD", postcode: "4073" },
{ city: "JAMBOREE HEIGHTS", state: "QLD", postcode: "4074" },
{ city: "JINDALEE", state: "QLD", postcode: "4074" },
{ city: "MIDDLE PARK", state: "QLD", postcode: "4074" },
{ city: "MOUNT OMMANEY", state: "QLD", postcode: "4074" },
{ city: "RIVERHILLS", state: "QLD", postcode: "4074" },
{ city: "SUMNER", state: "QLD", postcode: "4074" },
{ city: "SUMNER PARK BC", state: "QLD", postcode: "4074" },
{ city: "WESTLAKE", state: "QLD", postcode: "4074" },
{ city: "CORINDA", state: "QLD", postcode: "4075" },
{ city: "GRACEVILLE", state: "QLD", postcode: "4075" },
{ city: "GRACEVILLE EAST", state: "QLD", postcode: "4075" },
{ city: "OXLEY", state: "QLD", postcode: "4075" },
{ city: "SHERWOOD", state: "QLD", postcode: "4075" },
{ city: "DARRA", state: "QLD", postcode: "4076" },
{ city: "WACOL", state: "QLD", postcode: "4076" },
{ city: "DOOLANDELLA", state: "QLD", postcode: "4077" },
{ city: "DURACK", state: "QLD", postcode: "4077" },
{ city: "INALA", state: "QLD", postcode: "4077" },
{ city: "INALA EAST", state: "QLD", postcode: "4077" },
{ city: "INALA HEIGHTS", state: "QLD", postcode: "4077" },
{ city: "RICHLANDS", state: "QLD", postcode: "4077" },
{ city: "RICHLANDS DC", state: "QLD", postcode: "4077" },
{ city: "ELLEN GROVE", state: "QLD", postcode: "4078" },
{ city: "FOREST LAKE", state: "QLD", postcode: "4078" },
{ city: "HIGHGATE HILL", state: "QLD", postcode: "4101" },
{ city: "SOUTH BRISBANE", state: "QLD", postcode: "4101" },
{ city: "SOUTH BRISBANE BC", state: "QLD", postcode: "4101" },
{ city: "WEST END", state: "QLD", postcode: "4101" },
{ city: "BURANDA", state: "QLD", postcode: "4102" },
{ city: "DUTTON PARK", state: "QLD", postcode: "4102" },
{ city: "WOOLLOONGABBA", state: "QLD", postcode: "4102" },
{ city: "ANNERLEY", state: "QLD", postcode: "4103" },
{ city: "ANNERLEY DC", state: "QLD", postcode: "4103" },
{ city: "FAIRFIELD", state: "QLD", postcode: "4103" },
{ city: "FAIRFIELD GARDENS", state: "QLD", postcode: "4103" },
{ city: "YERONGA", state: "QLD", postcode: "4104" },
{ city: "MOOROOKA", state: "QLD", postcode: "4105" },
{ city: "TENNYSON", state: "QLD", postcode: "4105" },
{ city: "YEERONGPILLY", state: "QLD", postcode: "4105" },
{ city: "BRISBANE MARKET", state: "QLD", postcode: "4106" },
{ city: "ROCKLEA", state: "QLD", postcode: "4106" },
{ city: "ROCKLEA DC", state: "QLD", postcode: "4106" },
{ city: "SALISBURY", state: "QLD", postcode: "4107" },
{ city: "SALISBURY EAST", state: "QLD", postcode: "4107" },
{ city: "ARCHERFIELD", state: "QLD", postcode: "4108" },
{ city: "ARCHERFIELD BC", state: "QLD", postcode: "4108" },
{ city: "COOPERS PLAINS", state: "QLD", postcode: "4108" },
{ city: "MACGREGOR", state: "QLD", postcode: "4109" },
{ city: "ROBERTSON", state: "QLD", postcode: "4109" },
{ city: "SUNNYBANK", state: "QLD", postcode: "4109" },
{ city: "SUNNYBANK HILLS", state: "QLD", postcode: "4109" },
{ city: "SUNNYBANK SOUTH", state: "QLD", postcode: "4109" },
{ city: "ACACIA RIDGE", state: "QLD", postcode: "4110" },
{ city: "ACACIA RIDGE BC", state: "QLD", postcode: "4110" },
{ city: "ACACIA RIDGE DC", state: "QLD", postcode: "4110" },
{ city: "HEATHWOOD", state: "QLD", postcode: "4110" },
{ city: "HEATHWOOD DF", state: "QLD", postcode: "4110" },
{ city: "LARAPINTA", state: "QLD", postcode: "4110" },
{ city: "PALLARA", state: "QLD", postcode: "4110" },
{ city: "WILLAWONG", state: "QLD", postcode: "4110" },
{ city: "NATHAN", state: "QLD", postcode: "4111" },
{ city: "KURABY", state: "QLD", postcode: "4112" },
{ city: "EIGHT MILE PLAINS", state: "QLD", postcode: "4113" },
{ city: "RUNCORN", state: "QLD", postcode: "4113" },
{ city: "KINGSTON", state: "QLD", postcode: "4114" },
{ city: "LOGAN CENTRAL", state: "QLD", postcode: "4114" },
{ city: "LOGAN CITY BC", state: "QLD", postcode: "4114" },
{ city: "LOGAN CITY DC", state: "QLD", postcode: "4114" },
{ city: "WOODRIDGE", state: "QLD", postcode: "4114" },
{ city: "ALGESTER", state: "QLD", postcode: "4115" },
{ city: "PARKINSON", state: "QLD", postcode: "4115" },
{ city: "CALAMVALE", state: "QLD", postcode: "4116" },
{ city: "DREWVALE", state: "QLD", postcode: "4116" },
{ city: "STRETTON", state: "QLD", postcode: "4116" },
{ city: "BERRINBA", state: "QLD", postcode: "4117" },
{ city: "KARAWATHA", state: "QLD", postcode: "4117" },
{ city: "BROWNS PLAINS", state: "QLD", postcode: "4118" },
{ city: "BROWNS PLAINS BC", state: "QLD", postcode: "4118" },
{ city: "FORESTDALE", state: "QLD", postcode: "4118" },
{ city: "HERITAGE PARK", state: "QLD", postcode: "4118" },
{ city: "HILLCREST", state: "QLD", postcode: "4118" },
{ city: "REGENTS PARK", state: "QLD", postcode: "4118" },
{ city: "UNDERWOOD", state: "QLD", postcode: "4119" },
{ city: "GREENSLOPES", state: "QLD", postcode: "4120" },
{ city: "STONES CORNER", state: "QLD", postcode: "4120" },
{ city: "HOLLAND PARK", state: "QLD", postcode: "4121" },
{ city: "HOLLAND PARK EAST", state: "QLD", postcode: "4121" },
{ city: "HOLLAND PARK WEST", state: "QLD", postcode: "4121" },
{ city: "TARRAGINDI", state: "QLD", postcode: "4121" },
{ city: "WELLERS HILL", state: "QLD", postcode: "4121" },
{ city: "MANSFIELD", state: "QLD", postcode: "4122" },
{ city: "MANSFIELD BC", state: "QLD", postcode: "4122" },
{ city: "MANSFIELD DC", state: "QLD", postcode: "4122" },
{ city: "MOUNT GRAVATT", state: "QLD", postcode: "4122" },
{ city: "MOUNT GRAVATT EAST", state: "QLD", postcode: "4122" },
{ city: "MT GRAVATT", state: "QLD", postcode: "4122" },
{ city: "MT GRAVATT EAST", state: "QLD", postcode: "4122" },
{ city: "UPPER MOUNT GRAVATT", state: "QLD", postcode: "4122" },
{ city: "UPPER MOUNT GRAVATT BC", state: "QLD", postcode: "4122" },
{ city: "WISHART", state: "QLD", postcode: "4122" },
{ city: "ROCHEDALE", state: "QLD", postcode: "4123" },
{ city: "ROCHEDALE SOUTH", state: "QLD", postcode: "4123" },
{ city: "BORONIA HEIGHTS", state: "QLD", postcode: "4124" },
{ city: "GREENBANK", state: "QLD", postcode: "4124" },
{ city: "LYONS", state: "QLD", postcode: "4124" },
{ city: "NEW BEITH", state: "QLD", postcode: "4124" },
{ city: "SPRING MOUNTAIN", state: "QLD", postcode: "4124" },
{ city: "MUNRUBEN", state: "QLD", postcode: "4125" },
{ city: "PARK RIDGE", state: "QLD", postcode: "4125" },
{ city: "PARK RIDGE SOUTH", state: "QLD", postcode: "4125" },
{ city: "DAISY HILL", state: "QLD", postcode: "4127" },
{ city: "PRIESTDALE", state: "QLD", postcode: "4127" },
{ city: "SLACKS CREEK", state: "QLD", postcode: "4127" },
{ city: "SPRINGWOOD", state: "QLD", postcode: "4127" },
{ city: "SHAILER PARK", state: "QLD", postcode: "4128" },
{ city: "TANAH MERAH", state: "QLD", postcode: "4128" },
{ city: "LOGANHOLME", state: "QLD", postcode: "4129" },
{ city: "LOGANHOLME BC", state: "QLD", postcode: "4129" },
{ city: "LOGANHOLME DC", state: "QLD", postcode: "4129" },
{ city: "CARBROOK", state: "QLD", postcode: "4130" },
{ city: "CORNUBIA", state: "QLD", postcode: "4130" },
{ city: "LOGANLEA", state: "QLD", postcode: "4131" },
{ city: "MEADOWBROOK", state: "QLD", postcode: "4131" },
{ city: "CRESTMEAD", state: "QLD", postcode: "4132" },
{ city: "CRESTMEAD DC", state: "QLD", postcode: "4132" },
{ city: "MARSDEN", state: "QLD", postcode: "4132" },
{ city: "CHAMBERS FLAT", state: "QLD", postcode: "4133" },
{ city: "LOGAN RESERVE", state: "QLD", postcode: "4133" },
{ city: "WATERFORD", state: "QLD", postcode: "4133" },
{ city: "WATERFORD WEST", state: "QLD", postcode: "4133" },
{ city: "COORPAROO", state: "QLD", postcode: "4151" },
{ city: "COORPAROO BC", state: "QLD", postcode: "4151" },
{ city: "COORPAROO DC", state: "QLD", postcode: "4151" },
{ city: "CAMP HILL", state: "QLD", postcode: "4152" },
{ city: "CARINA", state: "QLD", postcode: "4152" },
{ city: "CARINA HEIGHTS", state: "QLD", postcode: "4152" },
{ city: "CARINDALE", state: "QLD", postcode: "4152" },
{ city: "BELMONT", state: "QLD", postcode: "4153" },
{ city: "GUMDALE", state: "QLD", postcode: "4154" },
{ city: "RANSOME", state: "QLD", postcode: "4154" },
{ city: "WAKERLEY", state: "QLD", postcode: "4154" },
{ city: "CHANDLER", state: "QLD", postcode: "4155" },
{ city: "BURBANK", state: "QLD", postcode: "4156" },
{ city: "MACKENZIE", state: "QLD", postcode: "4156" },
{ city: "CAPALABA", state: "QLD", postcode: "4157" },
{ city: "CAPALABA BC", state: "QLD", postcode: "4157" },
{ city: "CAPALABA DC", state: "QLD", postcode: "4157" },
{ city: "CAPALABA WEST", state: "QLD", postcode: "4157" },
{ city: "SHELDON", state: "QLD", postcode: "4157" },
{ city: "THORNESIDE", state: "QLD", postcode: "4158" },
{ city: "BIRKDALE", state: "QLD", postcode: "4159" },
{ city: "ORMISTON", state: "QLD", postcode: "4160" },
{ city: "WELLINGTON POINT", state: "QLD", postcode: "4160" },
{ city: "ALEXANDRA HILLS", state: "QLD", postcode: "4161" },
{ city: "CLEVELAND", state: "QLD", postcode: "4163" },
{ city: "CLEVELAND DC", state: "QLD", postcode: "4163" },
{ city: "THORNLANDS", state: "QLD", postcode: "4164" },
{ city: "MOUNT COTTON", state: "QLD", postcode: "4165" },
{ city: "REDLAND BAY", state: "QLD", postcode: "4165" },
{ city: "VICTORIA POINT", state: "QLD", postcode: "4165" },
{ city: "VICTORIA POINT WEST", state: "QLD", postcode: "4165" },
{ city: "EAST BRISBANE", state: "QLD", postcode: "4169" },
{ city: "KANGAROO POINT", state: "QLD", postcode: "4169" },
{ city: "CANNON HILL", state: "QLD", postcode: "4170" },
{ city: "COLMSLIE", state: "QLD", postcode: "4170" },
{ city: "MORNINGSIDE", state: "QLD", postcode: "4170" },
{ city: "NORMAN PARK", state: "QLD", postcode: "4170" },
{ city: "SEVEN HILLS", state: "QLD", postcode: "4170" },
{ city: "BALMORAL", state: "QLD", postcode: "4171" },
{ city: "BULIMBA", state: "QLD", postcode: "4171" },
{ city: "HAWTHORNE", state: "QLD", postcode: "4171" },
{ city: "MURARRIE", state: "QLD", postcode: "4172" },
{ city: "TINGALPA", state: "QLD", postcode: "4173" },
{ city: "TINGALPA BC", state: "QLD", postcode: "4173" },
{ city: "TINGALPA DC", state: "QLD", postcode: "4173" },
{ city: "HEMMANT", state: "QLD", postcode: "4174" },
{ city: "FISHERMAN ISLAND", state: "QLD", postcode: "4178" },
{ city: "LYTTON", state: "QLD", postcode: "4178" },
{ city: "MORETON BAY", state: "QLD", postcode: "4178" },
{ city: "PORT OF BRISBANE", state: "QLD", postcode: "4178" },
{ city: "WYNNUM", state: "QLD", postcode: "4178" },
{ city: "WYNNUM NORTH", state: "QLD", postcode: "4178" },
{ city: "WYNNUM PLAZA", state: "QLD", postcode: "4178" },
{ city: "WYNNUM WEST", state: "QLD", postcode: "4178" },
{ city: "LOTA", state: "QLD", postcode: "4179" },
{ city: "MANLY", state: "QLD", postcode: "4179" },
{ city: "MANLY WEST", state: "QLD", postcode: "4179" },
{ city: "MORETON BAY", state: "QLD", postcode: "4179" },
{ city: "MORETON BAY", state: "QLD", postcode: "4184" },
{ city: "BETHANIA", state: "QLD", postcode: "4205" },
{ city: "ALBERTON", state: "QLD", postcode: "4207" },
{ city: "BAHRS SCRUB", state: "QLD", postcode: "4207" },
{ city: "BANNOCKBURN", state: "QLD", postcode: "4207" },
{ city: "BEENLEIGH", state: "QLD", postcode: "4207" },
{ city: "BELIVAH", state: "QLD", postcode: "4207" },
{ city: "BUCCAN", state: "QLD", postcode: "4207" },
{ city: "CEDAR CREEK", state: "QLD", postcode: "4207" },
{ city: "EAGLEBY", state: "QLD", postcode: "4207" },
{ city: "EDENS LANDING", state: "QLD", postcode: "4207" },
{ city: "HOLMVIEW", state: "QLD", postcode: "4207" },
{ city: "KAIRABAH", state: "QLD", postcode: "4207" },
{ city: "LOGAN VILLAGE", state: "QLD", postcode: "4207" },
{ city: "LUSCOMBE", state: "QLD", postcode: "4207" },
{ city: "MOUNT WARREN PARK", state: "QLD", postcode: "4207" },
{ city: "STAPYLTON", state: "QLD", postcode: "4207" },
{ city: "STEIGLITZ", state: "QLD", postcode: "4207" },
{ city: "WINDAROO", state: "QLD", postcode: "4207" },
{ city: "WOLFFDENE", state: "QLD", postcode: "4207" },
{ city: "WOONGOOLBA", state: "QLD", postcode: "4207" },
{ city: "YARRABILBA", state: "QLD", postcode: "4207" },
{ city: "YATALA", state: "QLD", postcode: "4207" },
{ city: "YATALA DC", state: "QLD", postcode: "4207" },
{ city: "GILBERTON", state: "QLD", postcode: "4208" },
{ city: "JACOBS WELL", state: "QLD", postcode: "4208" },
{ city: "KINGSHOLME", state: "QLD", postcode: "4208" },
{ city: "NORWELL", state: "QLD", postcode: "4208" },
{ city: "ORMEAU", state: "QLD", postcode: "4208" },
{ city: "ORMEAU HILLS", state: "QLD", postcode: "4208" },
{ city: "COOMERA", state: "QLD", postcode: "4209" },
{ city: "PIMPAMA", state: "QLD", postcode: "4209" },
{ city: "UPPER COOMERA", state: "QLD", postcode: "4209" },
{ city: "WILLOW VALE", state: "QLD", postcode: "4209" },
{ city: "GUANABA", state: "QLD", postcode: "4210" },
{ city: "MAUDSLAND", state: "QLD", postcode: "4210" },
{ city: "OXENFORD", state: "QLD", postcode: "4210" },
{ city: "STUDIO VILLAGE", state: "QLD", postcode: "4210" },
{ city: "WONGAWALLAN", state: "QLD", postcode: "4210" },
{ city: "ADVANCETOWN", state: "QLD", postcode: "4211" },
{ city: "BEECHMONT", state: "QLD", postcode: "4211" },
{ city: "BINNA BURRA", state: "QLD", postcode: "4211" },
{ city: "CARRARA", state: "QLD", postcode: "4211" },
{ city: "CLAGIRABA", state: "QLD", postcode: "4211" },
{ city: "GAVEN", state: "QLD", postcode: "4211" },
{ city: "GILSTON", state: "QLD", postcode: "4211" },
{ city: "HIGHLAND PARK", state: "QLD", postcode: "4211" },
{ city: "LOWER BEECHMONT", state: "QLD", postcode: "4211" },
{ city: "MOUNT NATHAN", state: "QLD", postcode: "4211" },
{ city: "NATURAL BRIDGE", state: "QLD", postcode: "4211" },
{ city: "NERANG", state: "QLD", postcode: "4211" },
{ city: "NERANG BC", state: "QLD", postcode: "4211" },
{ city: "NERANG DC", state: "QLD", postcode: "4211" },
{ city: "NUMINBAH VALLEY", state: "QLD", postcode: "4211" },
{ city: "PACIFIC PINES", state: "QLD", postcode: "4211" },
{ city: "SOUTHERN LAMINGTON", state: "QLD", postcode: "4211" },
{ city: "HELENSVALE", state: "QLD", postcode: "4212" },
{ city: "HELENSVALE TOWN CENTRE", state: "QLD", postcode: "4212" },
{ city: "HOPE ISLAND", state: "QLD", postcode: "4212" },
{ city: "SANCTUARY COVE", state: "QLD", postcode: "4212" },
{ city: "SOUTHERN MORETON BAY ISLANDS", state: "QLD", postcode: "4212" },
{ city: "AUSTINVILLE", state: "QLD", postcode: "4213" },
{ city: "BONOGIN", state: "QLD", postcode: "4213" },
{ city: "MUDGEERABA", state: "QLD", postcode: "4213" },
{ city: "NERANWOOD", state: "QLD", postcode: "4213" },
{ city: "SPRINGBROOK", state: "QLD", postcode: "4213" },
{ city: "TALLAI", state: "QLD", postcode: "4213" },
{ city: "WORONGARY", state: "QLD", postcode: "4213" },
{ city: "ARUNDEL", state: "QLD", postcode: "4214" },
{ city: "ARUNDEL BC", state: "QLD", postcode: "4214" },
{ city: "ARUNDEL DC", state: "QLD", postcode: "4214" },
{ city: "ASHMORE", state: "QLD", postcode: "4214" },
{ city: "ASHMORE CITY", state: "QLD", postcode: "4214" },
{ city: "MOLENDINAR", state: "QLD", postcode: "4214" },
{ city: "PARKWOOD", state: "QLD", postcode: "4214" },
{ city: "AUSTRALIA FAIR", state: "QLD", postcode: "4215" },
{ city: "CHIRN PARK", state: "QLD", postcode: "4215" },
{ city: "LABRADOR", state: "QLD", postcode: "4215" },
{ city: "SOUTHPORT", state: "QLD", postcode: "4215" },
{ city: "SOUTHPORT BC", state: "QLD", postcode: "4215" },
{ city: "SOUTHPORT PARK", state: "QLD", postcode: "4215" },
{ city: "BIGGERA WATERS", state: "QLD", postcode: "4216" },
{ city: "COOMBABAH", state: "QLD", postcode: "4216" },
{ city: "HOLLYWELL", state: "QLD", postcode: "4216" },
{ city: "PARADISE POINT", state: "QLD", postcode: "4216" },
{ city: "RUNAWAY BAY", state: "QLD", postcode: "4216" },
{ city: "BENOWA", state: "QLD", postcode: "4217" },
{ city: "BUNDALL", state: "QLD", postcode: "4217" },
{ city: "BUNDALL BC", state: "QLD", postcode: "4217" },
{ city: "BUNDALL DC", state: "QLD", postcode: "4217" },
{ city: "CHEVRON ISLAND", state: "QLD", postcode: "4217" },
{ city: "GOLD COAST MC", state: "QLD", postcode: "4217" },
{ city: "ISLE OF CAPRI", state: "QLD", postcode: "4217" },
{ city: "MAIN BEACH", state: "QLD", postcode: "4217" },
{ city: "SURFERS PARADISE", state: "QLD", postcode: "4217" },
{ city: "BROADBEACH", state: "QLD", postcode: "4218" },
{ city: "BROADBEACH WATERS", state: "QLD", postcode: "4218" },
{ city: "MERMAID BEACH", state: "QLD", postcode: "4218" },
{ city: "MERMAID WATERS", state: "QLD", postcode: "4218" },
{ city: "NOBBY BEACH", state: "QLD", postcode: "4218" },
{ city: "PACIFIC FAIR", state: "QLD", postcode: "4218" },
{ city: "Q SUPERCENTRE", state: "QLD", postcode: "4218" },
{ city: "WEST BURLEIGH", state: "QLD", postcode: "4219" },
{ city: "BURLEIGH BC", state: "QLD", postcode: "4220" },
{ city: "BURLEIGH DC", state: "QLD", postcode: "4220" },
{ city: "BURLEIGH HEADS", state: "QLD", postcode: "4220" },
{ city: "BURLEIGH TOWN", state: "QLD", postcode: "4220" },
{ city: "BURLEIGH WATERS", state: "QLD", postcode: "4220" },
{ city: "MIAMI", state: "QLD", postcode: "4220" },
{ city: "ELANORA", state: "QLD", postcode: "4221" },
{ city: "PALM BEACH", state: "QLD", postcode: "4221" },
{ city: "GRIFFITH UNIVERSITY", state: "QLD", postcode: "4222" },
{ city: "CURRUMBIN", state: "QLD", postcode: "4223" },
{ city: "CURRUMBIN DC", state: "QLD", postcode: "4223" },
{ city: "CURRUMBIN VALLEY", state: "QLD", postcode: "4223" },
{ city: "CURRUMBIN WATERS", state: "QLD", postcode: "4223" },
{ city: "TUGUN", state: "QLD", postcode: "4224" },
{ city: "TUGUN HEIGHTS", state: "QLD", postcode: "4224" },
{ city: "BILINGA", state: "QLD", postcode: "4225" },
{ city: "COOLANGATTA", state: "QLD", postcode: "4225" },
{ city: "CLEAR ISLAND WATERS", state: "QLD", postcode: "4226" },
{ city: "MERRIMAC", state: "QLD", postcode: "4226" },
{ city: "ROBINA", state: "QLD", postcode: "4226" },
{ city: "ROBINA DC", state: "QLD", postcode: "4226" },
{ city: "REEDY CREEK", state: "QLD", postcode: "4227" },
{ city: "VARSITY LAKES", state: "QLD", postcode: "4227" },
{ city: "TALLEBUDGERA", state: "QLD", postcode: "4228" },
{ city: "TALLEBUDGERA VALLEY", state: "QLD", postcode: "4228" },
{ city: "BOND UNIVERSITY", state: "QLD", postcode: "4229" },
{ city: "ROBINA TOWN CENTRE", state: "QLD", postcode: "4230" },
{ city: "BEAUDESERT", state: "QLD", postcode: "4285" },
{ city: "AUGUSTINE HEIGHTS", state: "QLD", postcode: "4300" },
{ city: "BELLBIRD PARK", state: "QLD", postcode: "4300" },
{ city: "BROOKWATER", state: "QLD", postcode: "4300" },
{ city: "CAMIRA", state: "QLD", postcode: "4300" },
{ city: "CAROLE PARK", state: "QLD", postcode: "4300" },
{ city: "GAILES", state: "QLD", postcode: "4300" },
{ city: "GOODNA", state: "QLD", postcode: "4300" },
{ city: "GOODNA DC", state: "QLD", postcode: "4300" },
{ city: "SPRINGFIELD", state: "QLD", postcode: "4300" },
{ city: "SPRINGFIELD CENTRAL", state: "QLD", postcode: "4300" },
{ city: "SPRINGFIELD LAKES", state: "QLD", postcode: "4300" },
{ city: "SPRING MOUNTAIN", state: "QLD", postcode: "4300" },
{ city: "COLLINGWOOD PARK", state: "QLD", postcode: "4301" },
{ city: "REDBANK", state: "QLD", postcode: "4301" },
{ city: "REDBANK PLAINS", state: "QLD", postcode: "4301" },
{ city: "DINMORE", state: "QLD", postcode: "4303" },
{ city: "NEW CHUM", state: "QLD", postcode: "4303" },
{ city: "RIVERVIEW", state: "QLD", postcode: "4303" },
{ city: "BLACKSTONE", state: "QLD", postcode: "4304" },
{ city: "BOOVAL", state: "QLD", postcode: "4304" },
{ city: "BOOVAL BC", state: "QLD", postcode: "4304" },
{ city: "BOOVAL DC", state: "QLD", postcode: "4304" },
{ city: "BOOVAL FAIR", state: "QLD", postcode: "4304" },
{ city: "BUNDAMBA", state: "QLD", postcode: "4304" },
{ city: "EBBW VALE", state: "QLD", postcode: "4304" },
{ city: "NORTH BOOVAL", state: "QLD", postcode: "4304" },
{ city: "SILKSTONE", state: "QLD", postcode: "4304" },
{ city: "BASIN POCKET", state: "QLD", postcode: "4305" },
{ city: "BRASSALL", state: "QLD", postcode: "4305" },
{ city: "BREMER", state: "QLD", postcode: "4305" },
{ city: "CHURCHILL", state: "QLD", postcode: "4305" },
{ city: "COALFALLS", state: "QLD", postcode: "4305" },
{ city: "EASTERN HEIGHTS", state: "QLD", postcode: "4305" },
{ city: "EAST IPSWICH", state: "QLD", postcode: "4305" },
{ city: "FLINDERS VIEW", state: "QLD", postcode: "4305" },
{ city: "IPSWICH", state: "QLD", postcode: "4305" },
{ city: "LEICHHARDT", state: "QLD", postcode: "4305" },
{ city: "LIMESTONE RIDGES", state: "QLD", postcode: "4305" },
{ city: "MOORES POCKET", state: "QLD", postcode: "4305" },
{ city: "NEWTOWN", state: "QLD", postcode: "4305" },
{ city: "NORTH IPSWICH", state: "QLD", postcode: "4305" },
{ city: "NORTH TIVOLI", state: "QLD", postcode: "4305" },
{ city: "ONE MILE", state: "QLD", postcode: "4305" },
{ city: "RACEVIEW", state: "QLD", postcode: "4305" },
{ city: "SADLIERS CROSSING", state: "QLD", postcode: "4305" },
{ city: "TIVOLI", state: "QLD", postcode: "4305" },
{ city: "WEST IPSWICH", state: "QLD", postcode: "4305" },
{ city: "WOODEND", state: "QLD", postcode: "4305" },
{ city: "WULKURAKA", state: "QLD", postcode: "4305" },
{ city: "YAMANTO", state: "QLD", postcode: "4305" },
{ city: "GILLA", state: "QLD", postcode: "4306" },
{ city: "LAKE WIVENHOE", state: "QLD", postcode: "4306" },
{ city: "LAKE WIVENHOE", state: "QLD", postcode: "4311" },
{ city: "LAKE WIVENHOE", state: "QLD", postcode: "4312" },
{ city: "GATTON", state: "QLD", postcode: "4343" },
{ city: "ATHOL", state: "QLD", postcode: "4350" },
{ city: "BLUE MOUNTAIN HEIGHTS", state: "QLD", postcode: "4350" },
{ city: "CENTENARY HEIGHTS", state: "QLD", postcode: "4350" },
{ city: "CHARLTON", state: "QLD", postcode: "4350" },
{ city: "CLIFFORD GARDENS", state: "QLD", postcode: "4350" },
{ city: "COTSWOLD HILLS", state: "QLD", postcode: "4350" },
{ city: "CRANLEY", state: "QLD", postcode: "4350" },
{ city: "DARLING HEIGHTS", state: "QLD", postcode: "4350" },
{ city: "DRAYTON", state: "QLD", postcode: "4350" },
{ city: "DRAYTON NORTH", state: "QLD", postcode: "4350" },
{ city: "EAST TOOWOOMBA", state: "QLD", postcode: "4350" },
{ city: "FINNIE", state: "QLD", postcode: "4350" },
{ city: "GLENVALE", state: "QLD", postcode: "4350" },
{ city: "GOWRIE MOUNTAIN", state: "QLD", postcode: "4350" },
{ city: "HARLAXTON", state: "QLD", postcode: "4350" },
{ city: "HARRISTOWN", state: "QLD", postcode: "4350" },
{ city: "KEARNEYS SPRING", state: "QLD", postcode: "4350" },
{ city: "MIDDLE RIDGE", state: "QLD", postcode: "4350" },
{ city: "MOUNT KYNOCH", state: "QLD", postcode: "4350" },
{ city: "MOUNT LOFTY", state: "QLD", postcode: "4350" },
{ city: "MOUNT RASCAL", state: "QLD", postcode: "4350" },
{ city: "NEWTOWN", state: "QLD", postcode: "4350" },
{ city: "NORTHLANDS", state: "QLD", postcode: "4350" },
{ city: "NORTH TOOWOOMBA", state: "QLD", postcode: "4350" },
{ city: "PRINCE HENRY HEIGHTS", state: "QLD", postcode: "4350" },
{ city: "RANGEVILLE", state: "QLD", postcode: "4350" },
{ city: "REDWOOD", state: "QLD", postcode: "4350" },
{ city: "ROCKVILLE", state: "QLD", postcode: "4350" },
{ city: "SOUTH TOOWOOMBA", state: "QLD", postcode: "4350" },
{ city: "SOUTHTOWN", state: "QLD", postcode: "4350" },
{ city: "TOOWOOMBA", state: "QLD", postcode: "4350" },
{ city: "TOOWOOMBA BC", state: "QLD", postcode: "4350" },
{ city: "TOOWOOMBA CITY", state: "QLD", postcode: "4350" },
{ city: "TOOWOOMBA DC", state: "QLD", postcode: "4350" },
{ city: "TOOWOOMBA EAST", state: "QLD", postcode: "4350" },
{ city: "TOOWOOMBA SOUTH", state: "QLD", postcode: "4350" },
{ city: "TOOWOOMBA VILLAGE FAIR", state: "QLD", postcode: "4350" },
{ city: "TOOWOOMBA WEST", state: "QLD", postcode: "4350" },
{ city: "TOP CAMP", state: "QLD", postcode: "4350" },
{ city: "TORRINGTON", state: "QLD", postcode: "4350" },
{ city: "WELLCAMP", state: "QLD", postcode: "4350" },
{ city: "WESTBROOK", state: "QLD", postcode: "4350" },
{ city: "WILSONTON", state: "QLD", postcode: "4350" },
{ city: "WILSONTON HEIGHTS", state: "QLD", postcode: "4350" },
{ city: "WYALLA PLAZA", state: "QLD", postcode: "4350" },
{ city: "CAWDOR", state: "QLD", postcode: "4352" },
{ city: "MOUNT DARRY", state: "QLD", postcode: "4352" },
{ city: "PASSCHENDAELE", state: "QLD", postcode: "4352" },
{ city: "TOOWOOMBA MC", state: "QLD", postcode: "4352" },
{ city: "MOUNT DARRY", state: "QLD", postcode: "4354" },
{ city: "FOREST SPRINGS", state: "QLD", postcode: "4362" },
{ city: "OLD TALGAI", state: "QLD", postcode: "4370" },
{ city: "PALGRAVE", state: "QLD", postcode: "4370" },
{ city: "WARWICK", state: "QLD", postcode: "4370" },
{ city: "WARWICK DC", state: "QLD", postcode: "4370" },
{ city: "GOLDFIELDS", state: "QLD", postcode: "4374" },
{ city: "PALGRAVE", state: "QLD", postcode: "4374" },
{ city: "PASSCHENDAELE", state: "QLD", postcode: "4374" },
{ city: "GOLDFIELDS", state: "QLD", postcode: "4380" },
{ city: "KINGS SIDING", state: "QLD", postcode: "4400" },
{ city: "MOOLA", state: "QLD", postcode: "4403" },
{ city: "BLAXLAND", state: "QLD", postcode: "4405" },
{ city: "HALLIFORD", state: "QLD", postcode: "4405" },
{ city: "JIMBOUR EAST", state: "QLD", postcode: "4405" },
{ city: "KUMBARILLA", state: "QLD", postcode: "4405" },
{ city: "NANDI", state: "QLD", postcode: "4405" },
{ city: "SPRINGVALE", state: "QLD", postcode: "4405" },
{ city: "BEELBEE", state: "QLD", postcode: "4406" },
{ city: "CROSSROADS", state: "QLD", postcode: "4406" },
{ city: "JIMBOUR EAST", state: "QLD", postcode: "4406" },
{ city: "JIMBOUR WEST", state: "QLD", postcode: "4406" },
{ city: "MOOLA", state: "QLD", postcode: "4406" },
{ city: "COORANGA", state: "QLD", postcode: "4408" },
{ city: "MOWBULLAN", state: "QLD", postcode: "4408" },
{ city: "DIAMONDY", state: "QLD", postcode: "4410" },
{ city: "JINGHI", state: "QLD", postcode: "4410" },
{ city: "TUCKERANG", state: "QLD", postcode: "4410" },
{ city: "JIMBOUR WEST", state: "QLD", postcode: "4411" },
{ city: "TUCKERANG", state: "QLD", postcode: "4411" },
{ city: "AUBURN", state: "QLD", postcode: "4413" },
{ city: "BARAKULA", state: "QLD", postcode: "4413" },
{ city: "BLACKSWAMP", state: "QLD", postcode: "4413" },
{ city: "BURRA BURRI", state: "QLD", postcode: "4413" },
{ city: "CADARGA", state: "QLD", postcode: "4413" },
{ city: "CAMEBY", state: "QLD", postcode: "4413" },
{ city: "CHINCHILLA", state: "QLD", postcode: "4413" },
{ city: "DARR CREEK", state: "QLD", postcode: "4413" },
{ city: "FAIRYLAND", state: "QLD", postcode: "4413" },
{ city: "GOOMBI", state: "QLD", postcode: "4413" },
{ city: "GREENSWAMP", state: "QLD", postcode: "4413" },
{ city: "JINGHI", state: "QLD", postcode: "4413" },
{ city: "KRAGRA", state: "QLD", postcode: "4413" },
{ city: "LANGLANDS", state: "QLD", postcode: "4413" },
{ city: "PELICAN", state: "QLD", postcode: "4413" },
{ city: "RYWUNG", state: "QLD", postcode: "4413" },
{ city: "SUJEEWONG", state: "QLD", postcode: "4413" },
{ city: "WYCHIE", state: "QLD", postcode: "4413" },
{ city: "BUNDI", state: "QLD", postcode: "4419" },
{ city: "BUNGABAN", state: "QLD", postcode: "4419" },
{ city: "GLEBE", state: "QLD", postcode: "4419" },
{ city: "ROCHE CREEK", state: "QLD", postcode: "4419" },
{ city: "WOLEEBEE", state: "QLD", postcode: "4419" },
{ city: "BAROONDAH", state: "QLD", postcode: "4420" },
{ city: "EUROMBAH", state: "QLD", postcode: "4420" },
{ city: "GLEBE", state: "QLD", postcode: "4420" },
{ city: "KINNOUL", state: "QLD", postcode: "4420" },
{ city: "WAIKOLA", state: "QLD", postcode: "4427" },
{ city: "WAIKOLA", state: "QLD", postcode: "4428" },
{ city: "BAROONDAH", state: "QLD", postcode: "4454" },
{ city: "KILMOREY FALLS", state: "QLD", postcode: "4454" },
{ city: "MOUNT HOWE", state: "QLD", postcode: "4454" },
{ city: "MOUNT MOFFATT", state: "QLD", postcode: "4454" },
{ city: "WOMBLEBANK", state: "QLD", postcode: "4454" },
{ city: "WALHALLOW", state: "QLD", postcode: "4455" },
{ city: "EURELLA", state: "QLD", postcode: "4462" },
{ city: "BARGUNYAH", state: "QLD", postcode: "4465" },
{ city: "BINDEBANGO", state: "QLD", postcode: "4465" },
{ city: "MUNGALLALA SOUTH", state: "QLD", postcode: "4465" },
{ city: "BOATMAN", state: "QLD", postcode: "4468" },
{ city: "SOMMARIVA", state: "QLD", postcode: "4468" },
{ city: "WARD", state: "QLD", postcode: "4470" },
{ city: "CAROLINE CROSSING", state: "QLD", postcode: "4477" },
{ city: "MOUNT MOFFATT", state: "QLD", postcode: "4477" },
{ city: "NIVE", state: "QLD", postcode: "4477" },
{ city: "BINDEBANGO", state: "QLD", postcode: "4488" },
{ city: "CAMERON CORNER", state: "QLD", postcode: "4492" },
{ city: "DURHAM", state: "QLD", postcode: "4492" },
{ city: "BRAY PARK", state: "QLD", postcode: "4500" },
{ city: "BRENDALE", state: "QLD", postcode: "4500" },
{ city: "BRENDALE BC", state: "QLD", postcode: "4500" },
{ city: "BRENDALE DC", state: "QLD", postcode: "4500" },
{ city: "CASHMERE", state: "QLD", postcode: "4500" },
{ city: "CLEAR MOUNTAIN", state: "QLD", postcode: "4500" },
{ city: "JOYNER", state: "QLD", postcode: "4500" },
{ city: "STRATHPINE", state: "QLD", postcode: "4500" },
{ city: "STRATHPINE CENTRE", state: "QLD", postcode: "4500" },
{ city: "WARNER", state: "QLD", postcode: "4500" },
{ city: "LAWNTON", state: "QLD", postcode: "4501" },
{ city: "PETRIE", state: "QLD", postcode: "4502" },
{ city: "DAKABIN", state: "QLD", postcode: "4503" },
{ city: "GRIFFIN", state: "QLD", postcode: "4503" },
{ city: "KALLANGUR", state: "QLD", postcode: "4503" },
{ city: "KURWONGBAH", state: "QLD", postcode: "4503" },
{ city: "MURRUMBA DOWNS", state: "QLD", postcode: "4503" },
{ city: "WHITESIDE", state: "QLD", postcode: "4503" },
{ city: "NARANGBA", state: "QLD", postcode: "4504" },
{ city: "BURPENGARY", state: "QLD", postcode: "4505" },
{ city: "BURPENGARY DC", state: "QLD", postcode: "4505" },
{ city: "BURPENGARY EAST", state: "QLD", postcode: "4505" },
{ city: "MOORINA", state: "QLD", postcode: "4506" },
{ city: "MORAYFIELD", state: "QLD", postcode: "4506" },
{ city: "BANKSIA BEACH", state: "QLD", postcode: "4507" },
{ city: "BELLARA", state: "QLD", postcode: "4507" },
{ city: "BONGAREE", state: "QLD", postcode: "4507" },
{ city: "DECEPTION BAY", state: "QLD", postcode: "4508" },
{ city: "MANGO HILL", state: "QLD", postcode: "4509" },
{ city: "NORTH LAKES", state: "QLD", postcode: "4509" },
{ city: "BEACHMERE", state: "QLD", postcode: "4510" },
{ city: "BELLMERE", state: "QLD", postcode: "4510" },
{ city: "CABOOLTURE", state: "QLD", postcode: "4510" },
{ city: "CABOOLTURE BC", state: "QLD", postcode: "4510" },
{ city: "CABOOLTURE SOUTH", state: "QLD", postcode: "4510" },
{ city: "DONNYBROOK", state: "QLD", postcode: "4510" },
{ city: "MELDALE", state: "QLD", postcode: "4510" },
{ city: "MOODLU", state: "QLD", postcode: "4510" },
{ city: "ROCKSBERG", state: "QLD", postcode: "4510" },
{ city: "TOORBUL", state: "QLD", postcode: "4510" },
{ city: "UPPER CABOOLTURE", state: "QLD", postcode: "4510" },
{ city: "GODWIN BEACH", state: "QLD", postcode: "4511" },
{ city: "NINGI", state: "QLD", postcode: "4511" },
{ city: "SANDSTONE POINT", state: "QLD", postcode: "4511" },
{ city: "BELLTHORPE", state: "QLD", postcode: "4514" },
{ city: "CEDARTON", state: "QLD", postcode: "4514" },
{ city: "COMMISSIONERS FLAT", state: "QLD", postcode: "4514" },
{ city: "D'AGUILAR", state: "QLD", postcode: "4514" },
{ city: "DELANEYS CREEK", state: "QLD", postcode: "4514" },
{ city: "MOUNT DELANEY", state: "QLD", postcode: "4514" },
{ city: "NEURUM", state: "QLD", postcode: "4514" },
{ city: "STANMORE", state: "QLD", postcode: "4514" },
{ city: "STONY CREEK", state: "QLD", postcode: "4514" },
{ city: "VILLENEUVE", state: "QLD", postcode: "4514" },
{ city: "WESTVALE", state: "QLD", postcode: "4514" },
{ city: "WOODFORD", state: "QLD", postcode: "4514" },
{ city: "GLENFERN", state: "QLD", postcode: "4515" },
{ city: "HAZELDEAN", state: "QLD", postcode: "4515" },
{ city: "KILCOY", state: "QLD", postcode: "4515" },
{ city: "KINGAHAM", state: "QLD", postcode: "4515" },
{ city: "MOUNT KILCOY", state: "QLD", postcode: "4515" },
{ city: "ROYSTON", state: "QLD", postcode: "4515" },
{ city: "SHEEP STATION CREEK", state: "QLD", postcode: "4515" },
{ city: "WINYA", state: "QLD", postcode: "4515" },
{ city: "WOOLMAR", state: "QLD", postcode: "4515" },
{ city: "ELIMBAH", state: "QLD", postcode: "4516" },
{ city: "BEERWAH", state: "QLD", postcode: "4519" },
{ city: "COOCHIN CREEK", state: "QLD", postcode: "4519" },
{ city: "CROHAMHURST", state: "QLD", postcode: "4519" },
{ city: "PEACHESTER", state: "QLD", postcode: "4519" },
{ city: "ARMSTRONG CREEK", state: "QLD", postcode: "4520" },
{ city: "CAMP MOUNTAIN", state: "QLD", postcode: "4520" },
{ city: "CEDAR CREEK", state: "QLD", postcode: "4520" },
{ city: "CLOSEBURN", state: "QLD", postcode: "4520" },
{ city: "DRAPER", state: "QLD", postcode: "4520" },
{ city: "ENOGGERA RESERVOIR", state: "QLD", postcode: "4520" },
{ city: "HIGHVALE", state: "QLD", postcode: "4520" },
{ city: "JOLLYS LOOKOUT", state: "QLD", postcode: "4520" },
{ city: "KOBBLE CREEK", state: "QLD", postcode: "4520" },
{ city: "MOUNT GLORIOUS", state: "QLD", postcode: "4520" },
{ city: "MOUNT NEBO", state: "QLD", postcode: "4520" },
{ city: "MOUNT SAMSON", state: "QLD", postcode: "4520" },
{ city: "SAMFORD", state: "QLD", postcode: "4520" },
{ city: "SAMFORD VALLEY", state: "QLD", postcode: "4520" },
{ city: "SAMFORD VILLAGE", state: "QLD", postcode: "4520" },
{ city: "SAMSONVALE", state: "QLD", postcode: "4520" },
{ city: "WIGHTS MOUNTAIN", state: "QLD", postcode: "4520" },
{ city: "YUGAR", state: "QLD", postcode: "4520" },
{ city: "AROONA", state: "QLD", postcode: "4551" },
{ city: "CALOUNDRA", state: "QLD", postcode: "4551" },
{ city: "CALOUNDRA BC", state: "QLD", postcode: "4551" },
{ city: "CALOUNDRA DC", state: "QLD", postcode: "4551" },
{ city: "CALOUNDRA WEST", state: "QLD", postcode: "4551" },
{ city: "CURRIMUNDI", state: "QLD", postcode: "4551" },
{ city: "NIRIMBA", state: "QLD", postcode: "4551" },
{ city: "SHELLY BEACH", state: "QLD", postcode: "4551" },
{ city: "BUDERIM", state: "QLD", postcode: "4556" },
{ city: "KUNDA PARK", state: "QLD", postcode: "4556" },
{ city: "SIPPY DOWNS", state: "QLD", postcode: "4556" },
{ city: "MOOLOOLABA", state: "QLD", postcode: "4557" },
{ city: "COTTON TREE", state: "QLD", postcode: "4558" },
{ city: "KULUIN", state: "QLD", postcode: "4558" },
{ city: "MAROOCHYDORE", state: "QLD", postcode: "4558" },
{ city: "MAROOCHYDORE BC", state: "QLD", postcode: "4558" },
{ city: "MAROOCHYDORE DC", state: "QLD", postcode: "4558" },
{ city: "SUNSHINE PLAZA", state: "QLD", postcode: "4558" },
{ city: "BLI BLI", state: "QLD", postcode: "4560" },
{ city: "NAMBOUR", state: "QLD", postcode: "4560" },
{ city: "NAMBOUR BC", state: "QLD", postcode: "4560" },
{ city: "NAMBOUR DC", state: "QLD", postcode: "4560" },
{ city: "NAMBOUR WEST", state: "QLD", postcode: "4560" },
{ city: "NOOSAVILLE", state: "QLD", postcode: "4566" },
{ city: "NOOSAVILLE BC", state: "QLD", postcode: "4566" },
{ city: "NOOSAVILLE DC", state: "QLD", postcode: "4566" },
{ city: "NOOSA HEADS", state: "QLD", postcode: "4567" },
{ city: "SUNSHINE BEACH", state: "QLD", postcode: "4567" },
{ city: "GYMPIE", state: "QLD", postcode: "4570" },
{ city: "GYMPIE DC", state: "QLD", postcode: "4570" },
{ city: "SOUTHSIDE", state: "QLD", postcode: "4570" },
{ city: "ALEXANDRA HEADLAND", state: "QLD", postcode: "4572" },
{ city: "COOLUM BEACH", state: "QLD", postcode: "4573" },
{ city: "MOUNT COOLUM", state: "QLD", postcode: "4573" },
{ city: "PEREGIAN BEACH", state: "QLD", postcode: "4573" },
{ city: "BIRTINYA", state: "QLD", postcode: "4575" },
{ city: "BOKARINA", state: "QLD", postcode: "4575" },
{ city: "BUDDINA", state: "QLD", postcode: "4575" },
{ city: "MINYAMA", state: "QLD", postcode: "4575" },
{ city: "PARREARRA", state: "QLD", postcode: "4575" },
{ city: "WARANA", state: "QLD", postcode: "4575" },
{ city: "WURTULLA", state: "QLD", postcode: "4575" },
{ city: "BARLIL", state: "QLD", postcode: "4605" },
{ city: "BYEE", state: "QLD", postcode: "4605" },
{ city: "CHERBOURG", state: "QLD", postcode: "4605" },
{ city: "CLOYNA", state: "QLD", postcode: "4605" },
{ city: "COBBS HILL", state: "QLD", postcode: "4605" },
{ city: "CROWNTHORPE", state: "QLD", postcode: "4605" },
{ city: "GLENROCK", state: "QLD", postcode: "4605" },
{ city: "KITOBA", state: "QLD", postcode: "4605" },
{ city: "MERLWOOD", state: "QLD", postcode: "4605" },
{ city: "MOFFATDALE", state: "QLD", postcode: "4605" },
{ city: "MOONDOONER", state: "QLD", postcode: "4605" },
{ city: "MURGON", state: "QLD", postcode: "4605" },
{ city: "OAKDALE", state: "QLD", postcode: "4605" },
{ city: "REDGATE", state: "QLD", postcode: "4605" },
{ city: "SILVERLEAF", state: "QLD", postcode: "4605" },
{ city: "SUNNY NOOK", state: "QLD", postcode: "4605" },
{ city: "TABLELANDS", state: "QLD", postcode: "4605" },
{ city: "WARNUNG", state: "QLD", postcode: "4605" },
{ city: "WINDERA", state: "QLD", postcode: "4605" },
{ city: "WOOROONDEN", state: "QLD", postcode: "4605" },
{ city: "CHELMSFORD", state: "QLD", postcode: "4606" },
{ city: "FAIRDALE", state: "QLD", postcode: "4606" },
{ city: "FICKS CROSSING", state: "QLD", postcode: "4606" },
{ city: "GREENVIEW", state: "QLD", postcode: "4606" },
{ city: "LEAFDALE", state: "QLD", postcode: "4606" },
{ city: "MOUNT MCEUEN", state: "QLD", postcode: "4606" },
{ city: "MP CREEK", state: "QLD", postcode: "4606" },
{ city: "WHEATLANDS", state: "QLD", postcode: "4606" },
{ city: "WONDAI", state: "QLD", postcode: "4606" },
{ city: "CHARLESTOWN", state: "QLD", postcode: "4608" },
{ city: "CUSHNIE", state: "QLD", postcode: "4608" },
{ city: "TINGOORA", state: "QLD", postcode: "4608" },
{ city: "WILKESDALE", state: "QLD", postcode: "4608" },
{ city: "WOOROOLIN", state: "QLD", postcode: "4608" },
{ city: "ALICE CREEK", state: "QLD", postcode: "4610" },
{ city: "BALLOGIE", state: "QLD", postcode: "4610" },
{ city: "BENAIR", state: "QLD", postcode: "4610" },
{ city: "BOOIE", state: "QLD", postcode: "4610" },
{ city: "BOONENNE", state: "QLD", postcode: "4610" },
{ city: "BOYNESIDE", state: "QLD", postcode: "4610" },
{ city: "CHAHPINGAH", state: "QLD", postcode: "4610" },
{ city: "COOLABUNIA", state: "QLD", postcode: "4610" },
{ city: "CORNDALE", state: "QLD", postcode: "4610" },
{ city: "CRAWFORD", state: "QLD", postcode: "4610" },
{ city: "DANGORE", state: "QLD", postcode: "4610" },
{ city: "DURONG", state: "QLD", postcode: "4610" },
{ city: "DURONG SOUTH", state: "QLD", postcode: "4610" },
{ city: "ELLESMERE", state: "QLD", postcode: "4610" },
{ city: "GOODGER", state: "QLD", postcode: "4610" },
{ city: "GORDONBROOK", state: "QLD", postcode: "4610" },
{ city: "HALY CREEK", state: "QLD", postcode: "4610" },
{ city: "HODGLEIGH", state: "QLD", postcode: "4610" },
{ city: "INVERLAW", state: "QLD", postcode: "4610" },
{ city: "IRONPOT", state: "QLD", postcode: "4610" },
{ city: "KINGAROY", state: "QLD", postcode: "4610" },
{ city: "KINGAROY DC", state: "QLD", postcode: "4610" },
{ city: "KUMBIA", state: "QLD", postcode: "4610" },
{ city: "MANNUEM", state: "QLD", postcode: "4610" },
{ city: "MEMERAMBI", state: "QLD", postcode: "4610" },
{ city: "TAABINGA", state: "QLD", postcode: "4610" },
{ city: "TAABINGA VILLAGE", state: "QLD", postcode: "4610" },
{ city: "WATTLE GROVE", state: "QLD", postcode: "4610" },
{ city: "MARSHLANDS", state: "QLD", postcode: "4611" },
{ city: "MONDURE", state: "QLD", postcode: "4611" },
{ city: "HIVESVILLE", state: "QLD", postcode: "4612" },
{ city: "KAWL KAWL", state: "QLD", postcode: "4612" },
{ city: "KEYSLAND", state: "QLD", postcode: "4612" },
{ city: "STONELANDS", state: "QLD", postcode: "4612" },
{ city: "WIGTON", state: "QLD", postcode: "4612" },
{ city: "ABBEYWOOD", state: "QLD", postcode: "4613" },
{ city: "BOONDOOMA", state: "QLD", postcode: "4613" },
{ city: "BRIGOODA", state: "QLD", postcode: "4613" },
{ city: "COVERTY", state: "QLD", postcode: "4613" },
{ city: "KINLEYMORE", state: "QLD", postcode: "4613" },
{ city: "MELROSE", state: "QLD", postcode: "4613" },
{ city: "OKEDEN", state: "QLD", postcode: "4613" },
{ city: "PROSTON", state: "QLD", postcode: "4613" },
{ city: "SPEEDWELL", state: "QLD", postcode: "4613" },
{ city: "STALWORTH", state: "QLD", postcode: "4613" },
{ city: "GILLA", state: "QLD", postcode: "4614" },
{ city: "NEUMGNA", state: "QLD", postcode: "4614" },
{ city: "UPPER YARRAMAN", state: "QLD", postcode: "4614" },
{ city: "YARRAMAN", state: "QLD", postcode: "4614" },
{ city: "BARKER CREEK FLAT", state: "QLD", postcode: "4615" },
{ city: "BROOKLANDS", state: "QLD", postcode: "4615" },
{ city: "BULLCAMP", state: "QLD", postcode: "4615" },
{ city: "EAST NANANGO", state: "QLD", postcode: "4615" },
{ city: "ELGIN VALE", state: "QLD", postcode: "4615" },
{ city: "GLAN DEVON", state: "QLD", postcode: "4615" },
{ city: "JOHNSTOWN", state: "QLD", postcode: "4615" },
{ city: "KUNIOON", state: "QLD", postcode: "4615" },
{ city: "MAIDENWELL", state: "QLD", postcode: "4615" },
{ city: "NANANGO", state: "QLD", postcode: "4615" },
{ city: "PIMPIMBUDGEE", state: "QLD", postcode: "4615" },
{ city: "RUNNYMEDE", state: "QLD", postcode: "4615" },
{ city: "SANDY RIDGES", state: "QLD", postcode: "4615" },
{ city: "SOUTH EAST NANANGO", state: "QLD", postcode: "4615" },
{ city: "SOUTH NANANGO", state: "QLD", postcode: "4615" },
{ city: "TARONG", state: "QLD", postcode: "4615" },
{ city: "WATTLE CAMP", state: "QLD", postcode: "4615" },
{ city: "WENGENVILLE", state: "QLD", postcode: "4615" },
{ city: "WYALLA", state: "QLD", postcode: "4615" },
{ city: "MARYBOROUGH", state: "QLD", postcode: "4650" },
{ city: "MARYBOROUGH DC", state: "QLD", postcode: "4650" },
{ city: "MARYBOROUGH WEST", state: "QLD", postcode: "4650" },
{ city: "PALLAS STREET MARYBOROUGH", state: "QLD", postcode: "4650" },
{ city: "HERVEY BAY", state: "QLD", postcode: "4655" },
{ city: "HERVEY BAY DC", state: "QLD", postcode: "4655" },
{ city: "TORQUAY", state: "QLD", postcode: "4655" },
{ city: "CHILDERS", state: "QLD", postcode: "4660" },
{ city: "BUNDABERG", state: "QLD", postcode: "4670" },
{ city: "BUNDABERG CENTRAL", state: "QLD", postcode: "4670" },
{ city: "BUNDABERG DC", state: "QLD", postcode: "4670" },
{ city: "BUNDABERG EAST", state: "QLD", postcode: "4670" },
{ city: "BUNDABERG NORTH", state: "QLD", postcode: "4670" },
{ city: "BUNDABERG SOUTH", state: "QLD", postcode: "4670" },
{ city: "BUNDABERG WEST", state: "QLD", postcode: "4670" },
{ city: "BOOLBOONDA", state: "QLD", postcode: "4671" },
{ city: "BOOYAL", state: "QLD", postcode: "4671" },
{ city: "BULLYARD", state: "QLD", postcode: "4671" },
{ city: "BUNGADOO", state: "QLD", postcode: "4671" },
{ city: "DALYSFORD", state: "QLD", postcode: "4671" },
{ city: "DAMASCUS", state: "QLD", postcode: "4671" },
{ city: "DELAN", state: "QLD", postcode: "4671" },
{ city: "DOUGHBOY", state: "QLD", postcode: "4671" },
{ city: "DRINAN", state: "QLD", postcode: "4671" },
{ city: "DUINGAL", state: "QLD", postcode: "4671" },
{ city: "GAETA", state: "QLD", postcode: "4671" },
{ city: "GIN GIN", state: "QLD", postcode: "4671" },
{ city: "GOOD NIGHT", state: "QLD", postcode: "4671" },
{ city: "HORSE CAMP", state: "QLD", postcode: "4671" },
{ city: "KOLONGA", state: "QLD", postcode: "4671" },
{ city: "LAKE MONDURAN", state: "QLD", postcode: "4671" },
{ city: "MAROONDAN", state: "QLD", postcode: "4671" },
{ city: "MCILWRAITH", state: "QLD", postcode: "4671" },
{ city: "MOLANGUL", state: "QLD", postcode: "4671" },
{ city: "MONDURAN", state: "QLD", postcode: "4671" },
{ city: "MOOLBOOLAMAN", state: "QLD", postcode: "4671" },
{ city: "MORGANVILLE", state: "QLD", postcode: "4671" },
{ city: "MOUNT PERRY", state: "QLD", postcode: "4671" },
{ city: "MUNGY", state: "QLD", postcode: "4671" },
{ city: "NEARUM", state: "QLD", postcode: "4671" },
{ city: "NEW MOONTA", state: "QLD", postcode: "4671" },
{ city: "REDHILL FARMS", state: "QLD", postcode: "4671" },
{ city: "SKYRING RESERVE", state: "QLD", postcode: "4671" },
{ city: "ST AGNES", state: "QLD", postcode: "4671" },
{ city: "ST KILDA", state: "QLD", postcode: "4671" },
{ city: "TAKILBERAN", state: "QLD", postcode: "4671" },
{ city: "TIRROAN", state: "QLD", postcode: "4671" },
{ city: "WALLAVILLE", state: "QLD", postcode: "4671" },
{ city: "WONBAH", state: "QLD", postcode: "4671" },
{ city: "WONBAH FOREST", state: "QLD", postcode: "4671" },
{ city: "MIARA", state: "QLD", postcode: "4673" },
{ city: "WATERLOO", state: "QLD", postcode: "4673" },
{ city: "YANDARAN", state: "QLD", postcode: "4673" },
{ city: "GLADSTONE", state: "QLD", postcode: "4680" },
{ city: "GLADSTONE BC", state: "QLD", postcode: "4680" },
{ city: "GLADSTONE CENTRAL", state: "QLD", postcode: "4680" },
{ city: "GLADSTONE-CITY", state: "QLD", postcode: "4680" },
{ city: "GLADSTONE DC", state: "QLD", postcode: "4680" },
{ city: "GLADSTONE HARBOUR", state: "QLD", postcode: "4680" },
{ city: "GLADSTONE SOUTH", state: "QLD", postcode: "4680" },
{ city: "SOUTH GLADSTONE", state: "QLD", postcode: "4680" },
{ city: "TANNUM SANDS", state: "QLD", postcode: "4680" },
{ city: "WEST GLADSTONE", state: "QLD", postcode: "4680" },
{ city: "RAGLAN", state: "QLD", postcode: "4697" },
{ city: "ROCKHAMPTON", state: "QLD", postcode: "4700" },
{ city: "ROCKHAMPTON CITY", state: "QLD", postcode: "4700" },
{ city: "ROCKHAMPTON HOSPITAL", state: "QLD", postcode: "4700" },
{ city: "WEST ROCKHAMPTON", state: "QLD", postcode: "4700" },
{ city: "CENTRAL QUEENSLAND UNIVERSITY", state: "QLD", postcode: "4701" },
{ city: "NORTH ROCKHAMPTON", state: "QLD", postcode: "4701" },
{ city: "PARK AVENUE", state: "QLD", postcode: "4701" },
{ city: "RED HILL ROCKHAMPTON", state: "QLD", postcode: "4701" },
{ city: "ROCKHAMPTON DC", state: "QLD", postcode: "4701" },
{ city: "ROCKHAMPTON NORTH", state: "QLD", postcode: "4701" },
{ city: "ALBINIA", state: "QLD", postcode: "4702" },
{ city: "ARCADIA VALLEY", state: "QLD", postcode: "4702" },
{ city: "LOCHINGTON", state: "QLD", postcode: "4702" },
{ city: "REWAN", state: "QLD", postcode: "4702" },
{ city: "TOGARA", state: "QLD", postcode: "4702" },
{ city: "YEPPOON", state: "QLD", postcode: "4703" },
{ city: "BUNDOORA", state: "QLD", postcode: "4705" },
{ city: "GLEBE", state: "QLD", postcode: "4719" },
{ city: "LOCHINGTON", state: "QLD", postcode: "4720" },
{ city: "BELYANDO", state: "QLD", postcode: "4721" },
{ city: "CHEESEBOROUGH", state: "QLD", postcode: "4721" },
{ city: "PEAK VALE", state: "QLD", postcode: "4721" },
{ city: "CARNARVON PARK", state: "QLD", postcode: "4722" },
{ city: "MANTUAN DOWNS", state: "QLD", postcode: "4722" },
{ city: "MINERVA", state: "QLD", postcode: "4722" },
{ city: "BUNDOORA", state: "QLD", postcode: "4723" },
{ city: "CHEESEBOROUGH", state: "QLD", postcode: "4723" },
{ city: "COTHERSTONE", state: "QLD", postcode: "4723" },
{ city: "FORK LAGOONS", state: "QLD", postcode: "4723" },
{ city: "GORDONSTONE", state: "QLD", postcode: "4723" },
{ city: "WYUNA", state: "QLD", postcode: "4723" },
{ city: "HOBARTVILLE", state: "QLD", postcode: "4724" },
{ city: "LOCHINGTON", state: "QLD", postcode: "4724" },
{ city: "QUETTA", state: "QLD", postcode: "4724" },
{ city: "EVORA", state: "QLD", postcode: "4725" },
{ city: "GRANT", state: "QLD", postcode: "4725" },
{ city: "HOME CREEK", state: "QLD", postcode: "4725" },
{ city: "IBIS", state: "QLD", postcode: "4725" },
{ city: "INGBERRY", state: "QLD", postcode: "4725" },
{ city: "MOOMBRIA", state: "QLD", postcode: "4725" },
{ city: "NARBETHONG", state: "QLD", postcode: "4725" },
{ city: "SALTERN CREEK", state: "QLD", postcode: "4725" },
{ city: "BANGALL", state: "QLD", postcode: "4726" },
{ city: "CORNISH CREEK", state: "QLD", postcode: "4726" },
{ city: "INGBERRY", state: "QLD", postcode: "4726" },
{ city: "SARDINE", state: "QLD", postcode: "4726" },
{ city: "UPLAND", state: "QLD", postcode: "4726" },
{ city: "UPPER CORNISH CREEK", state: "QLD", postcode: "4726" },
{ city: "BANGALL", state: "QLD", postcode: "4732" },
{ city: "CORNISH CREEK", state: "QLD", postcode: "4732" },
{ city: "SARDINE", state: "QLD", postcode: "4732" },
{ city: "SARINA", state: "QLD", postcode: "4737" },
{ city: "SARINA BEACH", state: "QLD", postcode: "4737" },
{ city: "SARINA RANGE", state: "QLD", postcode: "4737" },
{ city: "EAST MACKAY", state: "QLD", postcode: "4740" },
{ city: "MACKAY", state: "QLD", postcode: "4740" },
{ city: "MACKAY BC", state: "QLD", postcode: "4740" },
{ city: "MACKAY CANELAND", state: "QLD", postcode: "4740" },
{ city: "MACKAY DC", state: "QLD", postcode: "4740" },
{ city: "MACKAY HARBOUR", state: "QLD", postcode: "4740" },
{ city: "MACKAY NORTH", state: "QLD", postcode: "4740" },
{ city: "MACKAY SOUTH", state: "QLD", postcode: "4740" },
{ city: "MACKAY WEST", state: "QLD", postcode: "4740" },
{ city: "NORTH MACKAY", state: "QLD", postcode: "4740" },
{ city: "PAGET", state: "QLD", postcode: "4740" },
{ city: "SOUTH MACKAY", state: "QLD", postcode: "4740" },
{ city: "WEST MACKAY", state: "QLD", postcode: "4740" },
{ city: "MACKAY MC", state: "QLD", postcode: "4741" },
{ city: "BUNDOORA", state: "QLD", postcode: "4746" },
{ city: "CORAL SEA", state: "QLD", postcode: "4805" },
{ city: "PORUMA ISLAND", state: "QLD", postcode: "4805" },
{ city: "UGAR ISLAND", state: "QLD", postcode: "4805" },
{ city: "CORAL SEA", state: "QLD", postcode: "4806" },
{ city: "GROPER CREEK", state: "QLD", postcode: "4806" },
{ city: "WANGARATTA", state: "QLD", postcode: "4806" },
{ city: "PARKSIDE", state: "QLD", postcode: "4807" },
{ city: "COLEVALE", state: "QLD", postcode: "4808" },
{ city: "BARRATTA", state: "QLD", postcode: "4809" },
{ city: "CROMARTY", state: "QLD", postcode: "4809" },
{ city: "GIRU", state: "QLD", postcode: "4809" },
{ city: "HORSESHOE LAGOON", state: "QLD", postcode: "4809" },
{ city: "JERONA", state: "QLD", postcode: "4809" },
{ city: "MOUNT SURROUND", state: "QLD", postcode: "4809" },
{ city: "SHIRBOURNE", state: "QLD", postcode: "4809" },
{ city: "UPPER HAUGHTON", state: "QLD", postcode: "4809" },
{ city: "BELGIAN GARDENS", state: "QLD", postcode: "4810" },
{ city: "CAPE CLEVELAND", state: "QLD", postcode: "4810" },
{ city: "CASTLE HILL", state: "QLD", postcode: "4810" },
{ city: "NORTH WARD", state: "QLD", postcode: "4810" },
{ city: "PALLARENDA", state: "QLD", postcode: "4810" },
{ city: "RAILWAY ESTATE", state: "QLD", postcode: "4810" },
{ city: "ROWES BAY", state: "QLD", postcode: "4810" },
{ city: "SHELLY BEACH", state: "QLD", postcode: "4810" },
{ city: "SOUTH TOWNSVILLE", state: "QLD", postcode: "4810" },
{ city: "TOWN COMMON", state: "QLD", postcode: "4810" },
{ city: "TOWNSVILLE", state: "QLD", postcode: "4810" },
{ city: "TOWNSVILLE CITY", state: "QLD", postcode: "4810" },
{ city: "TOWNSVILLE DC", state: "QLD", postcode: "4810" },
{ city: "TOWNSVILLE MC", state: "QLD", postcode: "4810" },
{ city: "WEST END", state: "QLD", postcode: "4810" },
{ city: "CLUDEN", state: "QLD", postcode: "4811" },
{ city: "IDALIA", state: "QLD", postcode: "4811" },
{ city: "JAMES COOK UNIVERSITY", state: "QLD", postcode: "4811" },
{ city: "MOUNT STUART", state: "QLD", postcode: "4811" },
{ city: "OAK VALLEY", state: "QLD", postcode: "4811" },
{ city: "OONOONBA", state: "QLD", postcode: "4811" },
{ city: "ROSENEATH", state: "QLD", postcode: "4811" },
{ city: "STUART", state: "QLD", postcode: "4811" },
{ city: "WULGURU", state: "QLD", postcode: "4811" },
{ city: "CURRAJONG", state: "QLD", postcode: "4812" },
{ city: "GULLIVER", state: "QLD", postcode: "4812" },
{ city: "HERMIT PARK", state: "QLD", postcode: "4812" },
{ city: "HYDE PARK", state: "QLD", postcode: "4812" },
{ city: "HYDE PARK CASTLETOWN", state: "QLD", postcode: "4812" },
{ city: "MUNDINGBURRA", state: "QLD", postcode: "4812" },
{ city: "MYSTERTON", state: "QLD", postcode: "4812" },
{ city: "PIMLICO", state: "QLD", postcode: "4812" },
{ city: "ROSSLEA", state: "QLD", postcode: "4812" },
{ city: "TOWNSVILLE MILPO", state: "QLD", postcode: "4813" },
{ city: "AITKENVALE", state: "QLD", postcode: "4814" },
{ city: "AITKENVALE BC", state: "QLD", postcode: "4814" },
{ city: "ANNANDALE", state: "QLD", postcode: "4814" },
{ city: "CRANBROOK", state: "QLD", postcode: "4814" },
{ city: "DOUGLAS", state: "QLD", postcode: "4814" },
{ city: "GARBUTT", state: "QLD", postcode: "4814" },
{ city: "GARBUTT BC", state: "QLD", postcode: "4814" },
{ city: "GARBUTT EAST", state: "QLD", postcode: "4814" },
{ city: "HEATLEY", state: "QLD", postcode: "4814" },
{ city: "MOUNT LOUISA", state: "QLD", postcode: "4814" },
{ city: "MURRAY", state: "QLD", postcode: "4814" },
{ city: "THURINGOWA DC", state: "QLD", postcode: "4814" },
{ city: "VINCENT", state: "QLD", postcode: "4814" },
{ city: "CONDON", state: "QLD", postcode: "4815" },
{ city: "GRANITE VALE", state: "QLD", postcode: "4815" },
{ city: "GUMLOW", state: "QLD", postcode: "4815" },
{ city: "KELSO", state: "QLD", postcode: "4815" },
{ city: "PINNACLES", state: "QLD", postcode: "4815" },
{ city: "RASMUSSEN", state: "QLD", postcode: "4815" },
{ city: "ALLIGATOR CREEK", state: "QLD", postcode: "4816" },
{ city: "BALGAL BEACH", state: "QLD", postcode: "4816" },
{ city: "BARRINGHA", state: "QLD", postcode: "4816" },
{ city: "BROOKHILL", state: "QLD", postcode: "4816" },
{ city: "BUCHANAN", state: "QLD", postcode: "4816" },
{ city: "CALCIUM", state: "QLD", postcode: "4816" },
{ city: "CARRUCHAN", state: "QLD", postcode: "4816" },
{ city: "CLEMANT", state: "QLD", postcode: "4816" },
{ city: "CORAL SEA", state: "QLD", postcode: "4816" },
{ city: "CRIMEA", state: "QLD", postcode: "4816" },
{ city: "CRYSTAL CREEK", state: "QLD", postcode: "4816" },
{ city: "CUNGULLA", state: "QLD", postcode: "4816" },
{ city: "ELLERBECK", state: "QLD", postcode: "4816" },
{ city: "GREENVALE", state: "QLD", postcode: "4816" },
{ city: "HIDDEN VALLEY", state: "QLD", postcode: "4816" },
{ city: "HOMESTEAD", state: "QLD", postcode: "4816" },
{ city: "JULAGO", state: "QLD", postcode: "4816" },
{ city: "KENNEDY", state: "QLD", postcode: "4816" },
{ city: "MACROSSAN", state: "QLD", postcode: "4816" },
{ city: "MAJORS CREEK", state: "QLD", postcode: "4816" },
{ city: "MALPAS-TRENTON", state: "QLD", postcode: "4816" },
{ city: "MINGELA", state: "QLD", postcode: "4816" },
{ city: "MOUNT ELLIOT", state: "QLD", postcode: "4816" },
{ city: "MUTARNEE", state: "QLD", postcode: "4816" },
{ city: "NELIA", state: "QLD", postcode: "4816" },
{ city: "NOME", state: "QLD", postcode: "4816" },
{ city: "PALM ISLAND", state: "QLD", postcode: "4816" },
{ city: "PALUMA", state: "QLD", postcode: "4816" },
{ city: "PENTLAND", state: "QLD", postcode: "4816" },
{ city: "PRAIRIE", state: "QLD", postcode: "4816" },
{ city: "RAVENSWOOD", state: "QLD", postcode: "4816" },
{ city: "REID RIVER", state: "QLD", postcode: "4816" },
{ city: "ROLLINGSTONE", state: "QLD", postcode: "4816" },
{ city: "ROSS RIVER", state: "QLD", postcode: "4816" },
{ city: "SAVANNAH", state: "QLD", postcode: "4816" },
{ city: "SELLHEIM", state: "QLD", postcode: "4816" },
{ city: "THE CAPE", state: "QLD", postcode: "4816" },
{ city: "TOOMULLA", state: "QLD", postcode: "4816" },
{ city: "TOONPAN", state: "QLD", postcode: "4816" },
{ city: "TORRENS CREEK", state: "QLD", postcode: "4816" },
{ city: "WOODSTOCK", state: "QLD", postcode: "4816" },
{ city: "ALICE RIVER", state: "QLD", postcode: "4817" },
{ city: "BOHLE PLAINS", state: "QLD", postcode: "4817" },
{ city: "HERVEY RANGE", state: "QLD", postcode: "4817" },
{ city: "KIRWAN", state: "QLD", postcode: "4817" },
{ city: "RANGEWOOD", state: "QLD", postcode: "4817" },
{ city: "THURINGOWA CENTRAL", state: "QLD", postcode: "4817" },
{ city: "THURINGOWA CENTRAL BC", state: "QLD", postcode: "4817" },
{ city: "BEACH HOLM", state: "QLD", postcode: "4818" },
{ city: "BLACK RIVER", state: "QLD", postcode: "4818" },
{ city: "BLUE HILLS", state: "QLD", postcode: "4818" },
{ city: "BLUEWATER", state: "QLD", postcode: "4818" },
{ city: "BLUEWATER PARK", state: "QLD", postcode: "4818" },
{ city: "BOHLE", state: "QLD", postcode: "4818" },
{ city: "BURDELL", state: "QLD", postcode: "4818" },
{ city: "BUSHLAND BEACH", state: "QLD", postcode: "4818" },
{ city: "COSGROVE", state: "QLD", postcode: "4818" },
{ city: "DEERAGUN", state: "QLD", postcode: "4818" },
{ city: "JENSEN", state: "QLD", postcode: "4818" },
{ city: "LYNAM", state: "QLD", postcode: "4818" },
{ city: "MOUNT LOW", state: "QLD", postcode: "4818" },
{ city: "MOUNT ST JOHN", state: "QLD", postcode: "4818" },
{ city: "SAUNDERS BEACH", state: "QLD", postcode: "4818" },
{ city: "SHAW", state: "QLD", postcode: "4818" },
{ city: "TOOLAKEA", state: "QLD", postcode: "4818" },
{ city: "YABULU", state: "QLD", postcode: "4818" },
{ city: "ARCADIA", state: "QLD", postcode: "4819" },
{ city: "FLORENCE BAY", state: "QLD", postcode: "4819" },
{ city: "HORSESHOE BAY", state: "QLD", postcode: "4819" },
{ city: "MAGNETIC ISLAND", state: "QLD", postcode: "4819" },
{ city: "NELLY BAY", state: "QLD", postcode: "4819" },
{ city: "PICNIC BAY", state: "QLD", postcode: "4819" },
{ city: "WEST POINT", state: "QLD", postcode: "4819" },
{ city: "DUTTON RIVER", state: "QLD", postcode: "4821" },
{ city: "HUGHENDEN", state: "QLD", postcode: "4821" },
{ city: "PORCUPINE", state: "QLD", postcode: "4821" },
{ city: "STAMFORD", state: "QLD", postcode: "4821" },
{ city: "TANGORIN", state: "QLD", postcode: "4821" },
{ city: "ALBION", state: "QLD", postcode: "4822" },
{ city: "BELLFIELD", state: "QLD", postcode: "4822" },
{ city: "BURLEIGH", state: "QLD", postcode: "4822" },
{ city: "CAMBRIDGE", state: "QLD", postcode: "4822" },
{ city: "MAXWELTON", state: "QLD", postcode: "4822" },
{ city: "NONDA", state: "QLD", postcode: "4822" },
{ city: "RICHMOND", state: "QLD", postcode: "4822" },
{ city: "SAXBY", state: "QLD", postcode: "4822" },
{ city: "VICTORIA VALE", state: "QLD", postcode: "4822" },
{ city: "WOOLGAR", state: "QLD", postcode: "4822" },
{ city: "FOUR WAYS", state: "QLD", postcode: "4824" },
{ city: "GIDYA", state: "QLD", postcode: "4824" },
{ city: "KURIDALA", state: "QLD", postcode: "4824" },
{ city: "OORINDI", state: "QLD", postcode: "4824" },
{ city: "THREE RIVERS", state: "QLD", postcode: "4824" },
{ city: "ALEXANDRIA", state: "QLD", postcode: "4825" },
{ city: "BARKLY", state: "QLD", postcode: "4825" },
{ city: "BREAKAWAY", state: "QLD", postcode: "4825" },
{ city: "BUCKINGHAM", state: "QLD", postcode: "4825" },
{ city: "CARRANDOTTA", state: "QLD", postcode: "4825" },
{ city: "DAJARRA", state: "QLD", postcode: "4825" },
{ city: "DUCHESS", state: "QLD", postcode: "4825" },
{ city: "FIELDING", state: "QLD", postcode: "4825" },
{ city: "FISHER", state: "QLD", postcode: "4825" },
{ city: "GEORGINA", state: "QLD", postcode: "4825" },
{ city: "GUNPOWDER", state: "QLD", postcode: "4825" },
{ city: "HAPPY VALLEY", state: "QLD", postcode: "4825" },
{ city: "HEALY", state: "QLD", postcode: "4825" },
{ city: "KALKADOON", state: "QLD", postcode: "4825" },
{ city: "LANSKEY", state: "QLD", postcode: "4825" },
{ city: "LAWN HILL", state: "QLD", postcode: "4825" },
{ city: "MENZIES", state: "QLD", postcode: "4825" },
{ city: "MICA CREEK", state: "QLD", postcode: "4825" },
{ city: "MILES END", state: "QLD", postcode: "4825" },
{ city: "MORNINGTON", state: "QLD", postcode: "4825" },
{ city: "PARKSIDE", state: "QLD", postcode: "4825" },
{ city: "PIONEER", state: "QLD", postcode: "4825" },
{ city: "PITURIE", state: "QLD", postcode: "4825" },
{ city: "RYAN", state: "QLD", postcode: "4825" },
{ city: "SOLDIERS HILL", state: "QLD", postcode: "4825" },
{ city: "SPREADBOROUGH", state: "QLD", postcode: "4825" },
{ city: "SUNSET", state: "QLD", postcode: "4825" },
{ city: "THE GAP", state: "QLD", postcode: "4825" },
{ city: "THE MONUMENT", state: "QLD", postcode: "4825" },
{ city: "TOWNVIEW", state: "QLD", postcode: "4825" },
{ city: "WAVERLEY", state: "QLD", postcode: "4825" },
{ city: "WINSTON", state: "QLD", postcode: "4825" },
{ city: "CAMOOWEAL", state: "QLD", postcode: "4828" },
{ city: "AMAROO", state: "QLD", postcode: "4829" },
{ city: "BEDOURIE", state: "QLD", postcode: "4829" },
{ city: "BOULIA", state: "QLD", postcode: "4829" },
{ city: "MIN MIN", state: "QLD", postcode: "4829" },
{ city: "STURT", state: "QLD", postcode: "4829" },
{ city: "TOKO", state: "QLD", postcode: "4829" },
{ city: "WARENDA", state: "QLD", postcode: "4829" },
{ city: "WILLS", state: "QLD", postcode: "4829" },
{ city: "BURKETOWN", state: "QLD", postcode: "4830" },
{ city: "DOOMADGEE", state: "QLD", postcode: "4830" },
{ city: "GREGORY", state: "QLD", postcode: "4830" },
{ city: "GREGORY DOWNS", state: "QLD", postcode: "4830" },
{ city: "NICHOLSON", state: "QLD", postcode: "4830" },
{ city: "CARDWELL", state: "QLD", postcode: "4849" },
{ city: "DAMPER CREEK", state: "QLD", postcode: "4849" },
{ city: "HINCHINBROOK", state: "QLD", postcode: "4849" },
{ city: "LUMHOLTZ", state: "QLD", postcode: "4849" },
{ city: "RUNGOO", state: "QLD", postcode: "4849" },
{ city: "MAMU", state: "QLD", postcode: "4856" },
{ city: "GORDONVALE", state: "QLD", postcode: "4865" },
{ city: "EDMONTON", state: "QLD", postcode: "4869" },
{ city: "AEROGLEN", state: "QLD", postcode: "4870" },
{ city: "BARRON GORGE", state: "QLD", postcode: "4870" },
{ city: "BRINSMEAD", state: "QLD", postcode: "4870" },
{ city: "BUNGALOW", state: "QLD", postcode: "4870" },
{ city: "CAIRNS", state: "QLD", postcode: "4870" },
{ city: "CAIRNS CENTRAL", state: "QLD", postcode: "4870" },
{ city: "CAIRNS CITY", state: "QLD", postcode: "4870" },
{ city: "CAIRNS DC", state: "QLD", postcode: "4870" },
{ city: "CAIRNS MC", state: "QLD", postcode: "4870" },
{ city: "CAIRNS NORTH", state: "QLD", postcode: "4870" },
{ city: "CAIRNS ORCHID PLAZA", state: "QLD", postcode: "4870" },
{ city: "EARLVILLE", state: "QLD", postcode: "4870" },
{ city: "EARLVILLE BC", state: "QLD", postcode: "4870" },
{ city: "EDGE HILL", state: "QLD", postcode: "4870" },
{ city: "FRESHWATER", state: "QLD", postcode: "4870" },
{ city: "KAMERUNGA", state: "QLD", postcode: "4870" },
{ city: "KANIMBLA", state: "QLD", postcode: "4870" },
{ city: "LAMB RANGE", state: "QLD", postcode: "4870" },
{ city: "MANOORA", state: "QLD", postcode: "4870" },
{ city: "MANUNDA", state: "QLD", postcode: "4870" },
{ city: "MOOROOBOOL", state: "QLD", postcode: "4870" },
{ city: "NORTH CAIRNS", state: "QLD", postcode: "4870" },
{ city: "PARRAMATTA PARK", state: "QLD", postcode: "4870" },
{ city: "PORTSMITH", state: "QLD", postcode: "4870" },
{ city: "STRATFORD", state: "QLD", postcode: "4870" },
{ city: "WESTCOURT", state: "QLD", postcode: "4870" },
{ city: "CAIRNS MC", state: "QLD", postcode: "4872" },
{ city: "CORAL SEA", state: "QLD", postcode: "4873" },
{ city: "IRON RANGE", state: "QLD", postcode: "4892" },
{ city: "ADELAIDE", state: "SA", postcode: "5000" },
{ city: "ADELAIDE BC", state: "SA", postcode: "5000" },
{ city: "CITY WEST CAMPUS", state: "SA", postcode: "5000" },
{ city: "HALIFAX STREET", state: "SA", postcode: "5000" },
{ city: "HUTT STREET", state: "SA", postcode: "5000" },
{ city: "PARLIAMENT HOUSE", state: "SA", postcode: "5000" },
{ city: "RUNDLE MALL", state: "SA", postcode: "5000" },
{ city: "STATION ARCADE", state: "SA", postcode: "5000" },
{ city: "STURT STREET", state: "SA", postcode: "5000" },
{ city: "NORTH ADELAIDE", state: "SA", postcode: "5006" },
{ city: "NORTH ADELAIDE MELBOURNE ST", state: "SA", postcode: "5006" },
{ city: "BOWDEN", state: "SA", postcode: "5007" },
{ city: "BROMPTON", state: "SA", postcode: "5007" },
{ city: "HINDMARSH", state: "SA", postcode: "5007" },
{ city: "WELLAND", state: "SA", postcode: "5007" },
{ city: "WEST HINDMARSH", state: "SA", postcode: "5007" },
{ city: "CROYDON", state: "SA", postcode: "5008" },
{ city: "CROYDON PARK", state: "SA", postcode: "5008" },
{ city: "CROYDON PARK SOUTH", state: "SA", postcode: "5008" },
{ city: "DEVON PARK", state: "SA", postcode: "5008" },
{ city: "DUDLEY PARK", state: "SA", postcode: "5008" },
{ city: "RENOWN PARK", state: "SA", postcode: "5008" },
{ city: "RIDLEYTON", state: "SA", postcode: "5008" },
{ city: "WEST CROYDON", state: "SA", postcode: "5008" },
{ city: "ALLENBY GARDENS", state: "SA", postcode: "5009" },
{ city: "BEVERLEY", state: "SA", postcode: "5009" },
{ city: "KILKENNY", state: "SA", postcode: "5009" },
{ city: "ANGLE PARK", state: "SA", postcode: "5010" },
{ city: "FERRYDEN PARK", state: "SA", postcode: "5010" },
{ city: "REGENCY PARK", state: "SA", postcode: "5010" },
{ city: "REGENCY PARK BC", state: "SA", postcode: "5010" },
{ city: "ST CLAIR", state: "SA", postcode: "5011" },
{ city: "WOODVILLE", state: "SA", postcode: "5011" },
{ city: "WOODVILLE PARK", state: "SA", postcode: "5011" },
{ city: "WOODVILLE SOUTH", state: "SA", postcode: "5011" },
{ city: "WOODVILLE WEST", state: "SA", postcode: "5011" },
{ city: "ATHOL PARK", state: "SA", postcode: "5012" },
{ city: "MANSFIELD PARK", state: "SA", postcode: "5012" },
{ city: "WOODVILLE GARDENS", state: "SA", postcode: "5012" },
{ city: "WOODVILLE NORTH", state: "SA", postcode: "5012" },
{ city: "GILLMAN", state: "SA", postcode: "5013" },
{ city: "OTTOWAY", state: "SA", postcode: "5013" },
{ city: "PENNINGTON", state: "SA", postcode: "5013" },
{ city: "ROSEWATER", state: "SA", postcode: "5013" },
{ city: "ROSEWATER EAST", state: "SA", postcode: "5013" },
{ city: "WINGFIELD", state: "SA", postcode: "5013" },
{ city: "ALBERTON", state: "SA", postcode: "5014" },
{ city: "ALBERT PARK", state: "SA", postcode: "5014" },
{ city: "CHELTENHAM", state: "SA", postcode: "5014" },
{ city: "HENDON", state: "SA", postcode: "5014" },
{ city: "QUEENSTOWN", state: "SA", postcode: "5014" },
{ city: "ROYAL PARK", state: "SA", postcode: "5014" },
{ city: "BIRKENHEAD", state: "SA", postcode: "5015" },
{ city: "ETHELTON", state: "SA", postcode: "5015" },
{ city: "GLANVILLE", state: "SA", postcode: "5015" },
{ city: "NEW PORT", state: "SA", postcode: "5015" },
{ city: "PORT ADELAIDE", state: "SA", postcode: "5015" },
{ city: "PORT ADELAIDE BC", state: "SA", postcode: "5015" },
{ city: "PORT ADELAIDE DC", state: "SA", postcode: "5015" },
{ city: "LARGS BAY", state: "SA", postcode: "5016" },
{ city: "LARGS NORTH", state: "SA", postcode: "5016" },
{ city: "PETERHEAD", state: "SA", postcode: "5016" },
{ city: "OSBORNE", state: "SA", postcode: "5017" },
{ city: "TAPEROO", state: "SA", postcode: "5017" },
{ city: "NORTH HAVEN", state: "SA", postcode: "5018" },
{ city: "OUTER HARBOR", state: "SA", postcode: "5018" },
{ city: "EXETER", state: "SA", postcode: "5019" },
{ city: "SEMAPHORE", state: "SA", postcode: "5019" },
{ city: "SEMAPHORE PARK", state: "SA", postcode: "5019" },
{ city: "SEMAPHORE SOUTH", state: "SA", postcode: "5019" },
{ city: "WEST LAKES SHORE", state: "SA", postcode: "5020" },
{ city: "WEST LAKES", state: "SA", postcode: "5021" },
{ city: "GRANGE", state: "SA", postcode: "5022" },
{ city: "HENLEY BEACH", state: "SA", postcode: "5022" },
{ city: "HENLEY BEACH SOUTH", state: "SA", postcode: "5022" },
{ city: "KIRKCALDY", state: "SA", postcode: "5022" },
{ city: "TENNYSON", state: "SA", postcode: "5022" },
{ city: "FINDON", state: "SA", postcode: "5023" },
{ city: "SEATON", state: "SA", postcode: "5023" },
{ city: "SEATON NORTH", state: "SA", postcode: "5023" },
{ city: "FULHAM", state: "SA", postcode: "5024" },
{ city: "FULHAM GARDENS", state: "SA", postcode: "5024" },
{ city: "WEST BEACH", state: "SA", postcode: "5024" },
{ city: "FLINDERS PARK", state: "SA", postcode: "5025" },
{ city: "KIDMAN PARK", state: "SA", postcode: "5025" },
{ city: "MILE END", state: "SA", postcode: "5031" },
{ city: "MILE END SOUTH", state: "SA", postcode: "5031" },
{ city: "THEBARTON", state: "SA", postcode: "5031" },
{ city: "TORRENSVILLE", state: "SA", postcode: "5031" },
{ city: "TORRENSVILLE PLAZA", state: "SA", postcode: "5031" },
{ city: "BROOKLYN PARK", state: "SA", postcode: "5032" },
{ city: "LOCKLEYS", state: "SA", postcode: "5032" },
{ city: "UNDERDALE", state: "SA", postcode: "5032" },
{ city: "COWANDILLA", state: "SA", postcode: "5033" },
{ city: "HILTON", state: "SA", postcode: "5033" },
{ city: "HILTON PLAZA", state: "SA", postcode: "5033" },
{ city: "MARLESTON", state: "SA", postcode: "5033" },
{ city: "MARLESTON DC", state: "SA", postcode: "5033" },
{ city: "RICHMOND", state: "SA", postcode: "5033" },
{ city: "WEST RICHMOND", state: "SA", postcode: "5033" },
{ city: "CLARENCE PARK", state: "SA", postcode: "5034" },
{ city: "GOODWOOD", state: "SA", postcode: "5034" },
{ city: "KINGS PARK", state: "SA", postcode: "5034" },
{ city: "MILLSWOOD", state: "SA", postcode: "5034" },
{ city: "WAYVILLE", state: "SA", postcode: "5034" },
{ city: "ASHFORD", state: "SA", postcode: "5035" },
{ city: "BLACK FOREST", state: "SA", postcode: "5035" },
{ city: "EVERARD PARK", state: "SA", postcode: "5035" },
{ city: "FORESTVILLE", state: "SA", postcode: "5035" },
{ city: "KESWICK", state: "SA", postcode: "5035" },
{ city: "KESWICK TERMINAL", state: "SA", postcode: "5035" },
{ city: "GLANDORE", state: "SA", postcode: "5037" },
{ city: "KURRALTA PARK", state: "SA", postcode: "5037" },
{ city: "NETLEY", state: "SA", postcode: "5037" },
{ city: "NORTH PLYMPTON", state: "SA", postcode: "5037" },
{ city: "CAMDEN PARK", state: "SA", postcode: "5038" },
{ city: "PLYMPTON", state: "SA", postcode: "5038" },
{ city: "PLYMPTON PARK", state: "SA", postcode: "5038" },
{ city: "SOUTH PLYMPTON", state: "SA", postcode: "5038" },
{ city: "CLARENCE GARDENS", state: "SA", postcode: "5039" },
{ city: "EDWARDSTOWN", state: "SA", postcode: "5039" },
{ city: "MELROSE PARK", state: "SA", postcode: "5039" },
{ city: "MELROSE PARK DC", state: "SA", postcode: "5039" },
{ city: "NOVAR GARDENS", state: "SA", postcode: "5040" },
{ city: "COLONEL LIGHT GARDENS", state: "SA", postcode: "5041" },
{ city: "CUMBERLAND PARK", state: "SA", postcode: "5041" },
{ city: "DAW PARK", state: "SA", postcode: "5041" },
{ city: "PANORAMA", state: "SA", postcode: "5041" },
{ city: "WESTBOURNE PARK", state: "SA", postcode: "5041" },
{ city: "BEDFORD PARK", state: "SA", postcode: "5042" },
{ city: "CLOVELLY PARK", state: "SA", postcode: "5042" },
{ city: "FLINDERS UNIVERSITY", state: "SA", postcode: "5042" },
{ city: "PASADENA", state: "SA", postcode: "5042" },
{ city: "ST MARYS", state: "SA", postcode: "5042" },
{ city: "TONSLEY", state: "SA", postcode: "5042" },
{ city: "ASCOT PARK", state: "SA", postcode: "5043" },
{ city: "MARION", state: "SA", postcode: "5043" },
{ city: "MITCHELL PARK", state: "SA", postcode: "5043" },
{ city: "MORPHETTVILLE", state: "SA", postcode: "5043" },
{ city: "PARK HOLME", state: "SA", postcode: "5043" },
{ city: "GLENGOWRIE", state: "SA", postcode: "5044" },
{ city: "SOMERTON PARK", state: "SA", postcode: "5044" },
{ city: "GLENELG", state: "SA", postcode: "5045" },
{ city: "GLENELG EAST", state: "SA", postcode: "5045" },
{ city: "GLENELG JETTY ROAD", state: "SA", postcode: "5045" },
{ city: "GLENELG NORTH", state: "SA", postcode: "5045" },
{ city: "GLENELG SOUTH", state: "SA", postcode: "5045" },
{ city: "OAKLANDS PARK", state: "SA", postcode: "5046" },
{ city: "WARRADALE", state: "SA", postcode: "5046" },
{ city: "WARRADALE NORTH", state: "SA", postcode: "5046" },
{ city: "DARLINGTON", state: "SA", postcode: "5047" },
{ city: "SEACOMBE GARDENS", state: "SA", postcode: "5047" },
{ city: "SEACOMBE HEIGHTS", state: "SA", postcode: "5047" },
{ city: "STURT", state: "SA", postcode: "5047" },
{ city: "BRIGHTON", state: "SA", postcode: "5048" },
{ city: "DOVER GARDENS", state: "SA", postcode: "5048" },
{ city: "HOVE", state: "SA", postcode: "5048" },
{ city: "NORTH BRIGHTON", state: "SA", postcode: "5048" },
{ city: "SOUTH BRIGHTON", state: "SA", postcode: "5048" },
{ city: "KINGSTON PARK", state: "SA", postcode: "5049" },
{ city: "MARINO", state: "SA", postcode: "5049" },
{ city: "SEACLIFF", state: "SA", postcode: "5049" },
{ city: "SEACLIFF PARK", state: "SA", postcode: "5049" },
{ city: "SEAVIEW DOWNS", state: "SA", postcode: "5049" },
{ city: "BELLEVUE HEIGHTS", state: "SA", postcode: "5050" },
{ city: "EDEN HILLS", state: "SA", postcode: "5050" },
{ city: "BLACKWOOD", state: "SA", postcode: "5051" },
{ city: "COROMANDEL VALLEY", state: "SA", postcode: "5051" },
{ city: "CRAIGBURN FARM", state: "SA", postcode: "5051" },
{ city: "HAWTHORNDENE", state: "SA", postcode: "5051" },
{ city: "BELAIR", state: "SA", postcode: "5052" },
{ city: "GLENALTA", state: "SA", postcode: "5052" },
{ city: "HYDE PARK", state: "SA", postcode: "5061" },
{ city: "MALVERN", state: "SA", postcode: "5061" },
{ city: "UNLEY", state: "SA", postcode: "5061" },
{ city: "UNLEY BC", state: "SA", postcode: "5061" },
{ city: "UNLEY DC", state: "SA", postcode: "5061" },
{ city: "UNLEY PARK", state: "SA", postcode: "5061" },
{ city: "BROWN HILL CREEK", state: "SA", postcode: "5062" },
{ city: "CLAPHAM", state: "SA", postcode: "5062" },
{ city: "HAWTHORN", state: "SA", postcode: "5062" },
{ city: "KINGSWOOD", state: "SA", postcode: "5062" },
{ city: "LOWER MITCHAM", state: "SA", postcode: "5062" },
{ city: "LYNTON", state: "SA", postcode: "5062" },
{ city: "MITCHAM", state: "SA", postcode: "5062" },
{ city: "MITCHAM SHOPPING CENTRE", state: "SA", postcode: "5062" },
{ city: "NETHERBY", state: "SA", postcode: "5062" },
{ city: "SPRINGFIELD", state: "SA", postcode: "5062" },
{ city: "TORRENS PARK", state: "SA", postcode: "5062" },
{ city: "EASTWOOD", state: "SA", postcode: "5063" },
{ city: "FREWVILLE", state: "SA", postcode: "5063" },
{ city: "FULLARTON", state: "SA", postcode: "5063" },
{ city: "HIGHGATE", state: "SA", postcode: "5063" },
{ city: "PARKSIDE", state: "SA", postcode: "5063" },
{ city: "GLEN OSMOND", state: "SA", postcode: "5064" },
{ city: "GLENUNGA", state: "SA", postcode: "5064" },
{ city: "MOUNT OSMOND", state: "SA", postcode: "5064" },
{ city: "MYRTLE BANK", state: "SA", postcode: "5064" },
{ city: "ST GEORGES", state: "SA", postcode: "5064" },
{ city: "URRBRAE", state: "SA", postcode: "5064" },
{ city: "DULWICH", state: "SA", postcode: "5065" },
{ city: "GLENSIDE", state: "SA", postcode: "5065" },
{ city: "LINDEN PARK", state: "SA", postcode: "5065" },
{ city: "TOORAK GARDENS", state: "SA", postcode: "5065" },
{ city: "TUSMORE", state: "SA", postcode: "5065" },
{ city: "BEAUMONT", state: "SA", postcode: "5066" },
{ city: "BURNSIDE", state: "SA", postcode: "5066" },
{ city: "ERINDALE", state: "SA", postcode: "5066" },
{ city: "HAZELWOOD PARK", state: "SA", postcode: "5066" },
{ city: "STONYFELL", state: "SA", postcode: "5066" },
{ city: "WATERFALL GULLY", state: "SA", postcode: "5066" },
{ city: "WATTLE PARK", state: "SA", postcode: "5066" },
{ city: "BEULAH PARK", state: "SA", postcode: "5067" },
{ city: "KENT TOWN", state: "SA", postcode: "5067" },
{ city: "NORWOOD", state: "SA", postcode: "5067" },
{ city: "NORWOOD SOUTH", state: "SA", postcode: "5067" },
{ city: "ROSE PARK", state: "SA", postcode: "5067" },
{ city: "HEATHPOOL", state: "SA", postcode: "5068" },
{ city: "KENSINGTON", state: "SA", postcode: "5068" },
{ city: "KENSINGTON GARDENS", state: "SA", postcode: "5068" },
{ city: "KENSINGTON PARK", state: "SA", postcode: "5068" },
{ city: "LEABROOK", state: "SA", postcode: "5068" },
{ city: "MARRYATVILLE", state: "SA", postcode: "5068" },
{ city: "ST MORRIS", state: "SA", postcode: "5068" },
{ city: "TRINITY GARDENS", state: "SA", postcode: "5068" },
{ city: "COLLEGE PARK", state: "SA", postcode: "5069" },
{ city: "EVANDALE", state: "SA", postcode: "5069" },
{ city: "HACKNEY", state: "SA", postcode: "5069" },
{ city: "MAYLANDS", state: "SA", postcode: "5069" },
{ city: "STEPNEY", state: "SA", postcode: "5069" },
{ city: "ST PETERS", state: "SA", postcode: "5069" },
{ city: "FELIXSTOW", state: "SA", postcode: "5070" },
{ city: "FIRLE", state: "SA", postcode: "5070" },
{ city: "GLYNDE", state: "SA", postcode: "5070" },
{ city: "GLYNDE DC", state: "SA", postcode: "5070" },
{ city: "GLYNDE PLAZA", state: "SA", postcode: "5070" },
{ city: "JOSLIN", state: "SA", postcode: "5070" },
{ city: "MARDEN", state: "SA", postcode: "5070" },
{ city: "PAYNEHAM", state: "SA", postcode: "5070" },
{ city: "PAYNEHAM SOUTH", state: "SA", postcode: "5070" },
{ city: "ROYSTON PARK", state: "SA", postcode: "5070" },
{ city: "AULDANA", state: "SA", postcode: "5072" },
{ city: "MAGILL", state: "SA", postcode: "5072" },
{ city: "MAGILL NORTH", state: "SA", postcode: "5072" },
{ city: "MAGILL SOUTH", state: "SA", postcode: "5072" },
{ city: "ROSSLYN PARK", state: "SA", postcode: "5072" },
{ city: "SKYE", state: "SA", postcode: "5072" },
{ city: "TERINGIE", state: "SA", postcode: "5072" },
{ city: "WOODFORDE", state: "SA", postcode: "5072" },
{ city: "HECTORVILLE", state: "SA", postcode: "5073" },
{ city: "ROSTREVOR", state: "SA", postcode: "5073" },
{ city: "TRANMERE", state: "SA", postcode: "5073" },
{ city: "TRANMERE NORTH", state: "SA", postcode: "5073" },
{ city: "CAMPBELLTOWN", state: "SA", postcode: "5074" },
{ city: "NEWTON", state: "SA", postcode: "5074" },
{ city: "DERNANCOURT", state: "SA", postcode: "5075" },
{ city: "PARADISE", state: "SA", postcode: "5075" },
{ city: "ATHELSTONE", state: "SA", postcode: "5076" },
{ city: "CASTAMBUL", state: "SA", postcode: "5076" },
{ city: "COLLINSWOOD", state: "SA", postcode: "5081" },
{ city: "GILBERTON", state: "SA", postcode: "5081" },
{ city: "MEDINDIE", state: "SA", postcode: "5081" },
{ city: "MEDINDIE GARDENS", state: "SA", postcode: "5081" },
{ city: "VALE PARK", state: "SA", postcode: "5081" },
{ city: "WALKERVILLE", state: "SA", postcode: "5081" },
{ city: "FITZROY", state: "SA", postcode: "5082" },
{ city: "OVINGHAM", state: "SA", postcode: "5082" },
{ city: "PROSPECT", state: "SA", postcode: "5082" },
{ city: "PROSPECT EAST", state: "SA", postcode: "5082" },
{ city: "PROSPECT WEST", state: "SA", postcode: "5082" },
{ city: "THORNGATE", state: "SA", postcode: "5082" },
{ city: "BROADVIEW", state: "SA", postcode: "5083" },
{ city: "NAILSWORTH", state: "SA", postcode: "5083" },
{ city: "SEFTON PARK", state: "SA", postcode: "5083" },
{ city: "BLAIR ATHOL", state: "SA", postcode: "5084" },
{ city: "BLAIR ATHOL WEST", state: "SA", postcode: "5084" },
{ city: "KILBURN", state: "SA", postcode: "5084" },
{ city: "KILBURN NORTH", state: "SA", postcode: "5084" },
{ city: "CLEARVIEW", state: "SA", postcode: "5085" },
{ city: "ENFIELD", state: "SA", postcode: "5085" },
{ city: "ENFIELD PLAZA", state: "SA", postcode: "5085" },
{ city: "LIGHTSVIEW", state: "SA", postcode: "5085" },
{ city: "NORTHFIELD", state: "SA", postcode: "5085" },
{ city: "NORTHGATE", state: "SA", postcode: "5085" },
{ city: "GILLES PLAINS", state: "SA", postcode: "5086" },
{ city: "GREENACRES", state: "SA", postcode: "5086" },
{ city: "HAMPSTEAD GARDENS", state: "SA", postcode: "5086" },
{ city: "HILLCREST", state: "SA", postcode: "5086" },
{ city: "MANNINGHAM", state: "SA", postcode: "5086" },
{ city: "OAKDEN", state: "SA", postcode: "5086" },
{ city: "KLEMZIG", state: "SA", postcode: "5087" },
{ city: "WINDSOR GARDENS", state: "SA", postcode: "5087" },
{ city: "HOLDEN HILL", state: "SA", postcode: "5088" },
{ city: "HIGHBURY", state: "SA", postcode: "5089" },
{ city: "HOPE VALLEY", state: "SA", postcode: "5090" },
{ city: "BANKSIA PARK", state: "SA", postcode: "5091" },
{ city: "TEA TREE GULLY", state: "SA", postcode: "5091" },
{ city: "VISTA", state: "SA", postcode: "5091" },
{ city: "MODBURY", state: "SA", postcode: "5092" },
{ city: "MODBURY HEIGHTS", state: "SA", postcode: "5092" },
{ city: "MODBURY NORTH", state: "SA", postcode: "5092" },
{ city: "MODBURY NORTH DC", state: "SA", postcode: "5092" },
{ city: "PARA VISTA", state: "SA", postcode: "5093" },
{ city: "VALLEY VIEW", state: "SA", postcode: "5093" },
{ city: "CAVAN", state: "SA", postcode: "5094" },
{ city: "DRY CREEK", state: "SA", postcode: "5094" },
{ city: "GEPPS CROSS", state: "SA", postcode: "5094" },
{ city: "MAWSON LAKES", state: "SA", postcode: "5095" },
{ city: "POORAKA", state: "SA", postcode: "5095" },
{ city: "GULFVIEW HEIGHTS", state: "SA", postcode: "5096" },
{ city: "PARA HILLS", state: "SA", postcode: "5096" },
{ city: "PARA HILLS WEST", state: "SA", postcode: "5096" },
{ city: "REDWOOD PARK", state: "SA", postcode: "5097" },
{ city: "RIDGEHAVEN", state: "SA", postcode: "5097" },
{ city: "ST AGNES", state: "SA", postcode: "5097" },
{ city: "INGLE FARM", state: "SA", postcode: "5098" },
{ city: "WALKLEY HEIGHTS", state: "SA", postcode: "5098" },
{ city: "PARAFIELD", state: "SA", postcode: "5106" },
{ city: "PARAFIELD AIRPORT", state: "SA", postcode: "5106" },
{ city: "SALISBURY SOUTH", state: "SA", postcode: "5106" },
{ city: "SALISBURY SOUTH BC", state: "SA", postcode: "5106" },
{ city: "SALISBURY SOUTH DC", state: "SA", postcode: "5106" },
{ city: "GREEN FIELDS", state: "SA", postcode: "5107" },
{ city: "PARAFIELD GARDENS", state: "SA", postcode: "5107" },
{ city: "PARALOWIE", state: "SA", postcode: "5108" },
{ city: "SALISBURY", state: "SA", postcode: "5108" },
{ city: "SALISBURY DOWNS", state: "SA", postcode: "5108" },
{ city: "SALISBURY NORTH", state: "SA", postcode: "5108" },
{ city: "SALISBURY NORTH WHITES ROAD", state: "SA", postcode: "5108" },
{ city: "BRAHMA LODGE", state: "SA", postcode: "5109" },
{ city: "SALISBURY EAST", state: "SA", postcode: "5109" },
{ city: "SALISBURY EAST NORTHBRI AVE", state: "SA", postcode: "5109" },
{ city: "SALISBURY HEIGHTS", state: "SA", postcode: "5109" },
{ city: "SALISBURY PARK", state: "SA", postcode: "5109" },
{ city: "SALISBURY PLAIN", state: "SA", postcode: "5109" },
{ city: "BOLIVAR", state: "SA", postcode: "5110" },
{ city: "BURTON", state: "SA", postcode: "5110" },
{ city: "DIREK", state: "SA", postcode: "5110" },
{ city: "GLOBE DERBY PARK", state: "SA", postcode: "5110" },
{ city: "ST KILDA", state: "SA", postcode: "5110" },
{ city: "WATERLOO CORNER", state: "SA", postcode: "5110" },
{ city: "EDINBURGH", state: "SA", postcode: "5111" },
{ city: "EDINBURGH RAAF", state: "SA", postcode: "5111" },
{ city: "ELIZABETH", state: "SA", postcode: "5112" },
{ city: "ELIZABETH EAST", state: "SA", postcode: "5112" },
{ city: "ELIZABETH GROVE", state: "SA", postcode: "5112" },
{ city: "ELIZABETH SOUTH", state: "SA", postcode: "5112" },
{ city: "ELIZABETH VALE", state: "SA", postcode: "5112" },
{ city: "HILLBANK", state: "SA", postcode: "5112" },
{ city: "DAVOREN PARK", state: "SA", postcode: "5113" },
{ city: "DAVOREN PARK NORTH", state: "SA", postcode: "5113" },
{ city: "DAVOREN PARK SOUTH", state: "SA", postcode: "5113" },
{ city: "EDINBURGH NORTH", state: "SA", postcode: "5113" },
{ city: "ELIZABETH DOWNS", state: "SA", postcode: "5113" },
{ city: "ELIZABETH NORTH", state: "SA", postcode: "5113" },
{ city: "ELIZABETH PARK", state: "SA", postcode: "5113" },
{ city: "ELIZABETH WEST", state: "SA", postcode: "5113" },
{ city: "ELIZABETH WEST DC", state: "SA", postcode: "5113" },
{ city: "ANDREWS FARM", state: "SA", postcode: "5114" },
{ city: "BLAKEVIEW", state: "SA", postcode: "5114" },
{ city: "CRAIGMORE", state: "SA", postcode: "5114" },
{ city: "GOULD CREEK", state: "SA", postcode: "5114" },
{ city: "HUMBUG SCRUB", state: "SA", postcode: "5114" },
{ city: "ONE TREE HILL", state: "SA", postcode: "5114" },
{ city: "SAMPSON FLAT", state: "SA", postcode: "5114" },
{ city: "SMITHFIELD", state: "SA", postcode: "5114" },
{ city: "SMITHFIELD PLAINS", state: "SA", postcode: "5114" },
{ city: "SMITHFIELD WEST", state: "SA", postcode: "5114" },
{ city: "ULEYBURY", state: "SA", postcode: "5114" },
{ city: "YATTALUNGA", state: "SA", postcode: "5114" },
{ city: "KUDLA", state: "SA", postcode: "5115" },
{ city: "MUNNO PARA", state: "SA", postcode: "5115" },
{ city: "MUNNO PARA DOWNS", state: "SA", postcode: "5115" },
{ city: "MUNNO PARA WEST", state: "SA", postcode: "5115" },
{ city: "EVANSTON", state: "SA", postcode: "5116" },
{ city: "EVANSTON GARDENS", state: "SA", postcode: "5116" },
{ city: "EVANSTON PARK", state: "SA", postcode: "5116" },
{ city: "EVANSTON SOUTH", state: "SA", postcode: "5116" },
{ city: "HILLIER", state: "SA", postcode: "5116" },
{ city: "ANGLE VALE", state: "SA", postcode: "5117" },
{ city: "BIBARINGA", state: "SA", postcode: "5118" },
{ city: "BUCHFELDE", state: "SA", postcode: "5118" },
{ city: "CONCORDIA", state: "SA", postcode: "5118" },
{ city: "GAWLER", state: "SA", postcode: "5118" },
{ city: "GAWLER BELT", state: "SA", postcode: "5118" },
{ city: "GAWLER EAST", state: "SA", postcode: "5118" },
{ city: "GAWLER RIVER", state: "SA", postcode: "5118" },
{ city: "GAWLER SOUTH", state: "SA", postcode: "5118" },
{ city: "GAWLER WEST", state: "SA", postcode: "5118" },
{ city: "HEWETT", state: "SA", postcode: "5118" },
{ city: "KALBEEBA", state: "SA", postcode: "5118" },
{ city: "KANGAROO FLAT", state: "SA", postcode: "5118" },
{ city: "KINGSFORD", state: "SA", postcode: "5118" },
{ city: "REID", state: "SA", postcode: "5118" },
{ city: "WARD BELT", state: "SA", postcode: "5118" },
{ city: "WILLASTON", state: "SA", postcode: "5118" },
{ city: "BUCKLAND PARK", state: "SA", postcode: "5120" },
{ city: "VIRGINIA", state: "SA", postcode: "5120" },
{ city: "EYRE", state: "SA", postcode: "5121" },
{ city: "MACDONALD PARK", state: "SA", postcode: "5121" },
{ city: "PENFIELD", state: "SA", postcode: "5121" },
{ city: "PENFIELD GARDENS", state: "SA", postcode: "5121" },
{ city: "GOLDEN GROVE", state: "SA", postcode: "5125" },
{ city: "GOLDEN GROVE VILLAGE", state: "SA", postcode: "5125" },
{ city: "GREENWITH", state: "SA", postcode: "5125" },
{ city: "FAIRVIEW PARK", state: "SA", postcode: "5126" },
{ city: "SURREY DOWNS", state: "SA", postcode: "5126" },
{ city: "YATALA VALE", state: "SA", postcode: "5126" },
{ city: "WYNN VALE", state: "SA", postcode: "5127" },
{ city: "HOUGHTON", state: "SA", postcode: "5131" },
{ city: "INGLEWOOD", state: "SA", postcode: "5133" },
{ city: "MONTACUTE", state: "SA", postcode: "5134" },
{ city: "NORTON SUMMIT", state: "SA", postcode: "5136" },
{ city: "ASHTON", state: "SA", postcode: "5137" },
{ city: "BASKET RANGE", state: "SA", postcode: "5138" },
{ city: "FOREST RANGE", state: "SA", postcode: "5139" },
{ city: "HORSNELL GULLY", state: "SA", postcode: "5141" },
{ city: "URAIDLA", state: "SA", postcode: "5142" },
{ city: "CLELAND", state: "SA", postcode: "5152" },
{ city: "CRAFERS", state: "SA", postcode: "5152" },
{ city: "MOUNT LOFTY", state: "SA", postcode: "5152" },
{ city: "STIRLING", state: "SA", postcode: "5152" },
{ city: "BRADBURY", state: "SA", postcode: "5153" },
{ city: "CHAPEL HILL", state: "SA", postcode: "5153" },
{ city: "ECHUNGA", state: "SA", postcode: "5153" },
{ city: "FLAXLEY", state: "SA", postcode: "5153" },
{ city: "GREEN HILLS RANGE", state: "SA", postcode: "5153" },
{ city: "HEATHFIELD", state: "SA", postcode: "5153" },
{ city: "IRONBANK", state: "SA", postcode: "5153" },
{ city: "JUPITER CREEK", state: "SA", postcode: "5153" },
{ city: "ALDGATE", state: "SA", postcode: "5154" },
{ city: "BRIDGEWATER", state: "SA", postcode: "5155" },
{ city: "UPPER STURT", state: "SA", postcode: "5156" },
{ city: "ASHBOURNE", state: "SA", postcode: "5157" },
{ city: "CHERRY GARDENS", state: "SA", postcode: "5157" },
{ city: "COROMANDEL EAST", state: "SA", postcode: "5157" },
{ city: "HALLETT COVE", state: "SA", postcode: "5158" },
{ city: "O'HALLORAN HILL", state: "SA", postcode: "5158" },
{ city: "O'HALLORAN HILL DC", state: "SA", postcode: "5158" },
{ city: "SHEIDOW PARK", state: "SA", postcode: "5158" },
{ city: "TROTT PARK", state: "SA", postcode: "5158" },
{ city: "ABERFOYLE PARK", state: "SA", postcode: "5159" },
{ city: "CHANDLERS HILL", state: "SA", postcode: "5159" },
{ city: "FLAGSTAFF HILL", state: "SA", postcode: "5159" },
{ city: "HAPPY VALLEY", state: "SA", postcode: "5159" },
{ city: "LONSDALE", state: "SA", postcode: "5160" },
{ city: "LONSDALE DC", state: "SA", postcode: "5160" },
{ city: "PORT STANVAC", state: "SA", postcode: "5160" },
{ city: "OLD REYNELLA", state: "SA", postcode: "5161" },
{ city: "REYNELLA", state: "SA", postcode: "5161" },
{ city: "REYNELLA EAST", state: "SA", postcode: "5161" },
{ city: "MORPHETT VALE", state: "SA", postcode: "5162" },
{ city: "WOODCROFT", state: "SA", postcode: "5162" },
{ city: "HACKHAM", state: "SA", postcode: "5163" },
{ city: "HACKHAM WEST", state: "SA", postcode: "5163" },
{ city: "HUNTFIELD HEIGHTS", state: "SA", postcode: "5163" },
{ city: "ONKAPARINGA HILLS", state: "SA", postcode: "5163" },
{ city: "CHRISTIE DOWNS", state: "SA", postcode: "5164" },
{ city: "CHRISTIES BEACH", state: "SA", postcode: "5165" },
{ city: "CHRISTIES BEACH NORTH", state: "SA", postcode: "5165" },
{ city: "O'SULLIVAN BEACH", state: "SA", postcode: "5166" },
{ city: "PORT NOARLUNGA", state: "SA", postcode: "5167" },
{ city: "PORT NOARLUNGA SOUTH", state: "SA", postcode: "5167" },
{ city: "NOARLUNGA CENTRE", state: "SA", postcode: "5168" },
{ city: "NOARLUNGA DOWNS", state: "SA", postcode: "5168" },
{ city: "OLD NOARLUNGA", state: "SA", postcode: "5168" },
{ city: "MOANA", state: "SA", postcode: "5169" },
{ city: "SEAFORD", state: "SA", postcode: "5169" },
{ city: "SEAFORD HEIGHTS", state: "SA", postcode: "5169" },
{ city: "SEAFORD MEADOWS", state: "SA", postcode: "5169" },
{ city: "SEAFORD RISE", state: "SA", postcode: "5169" },
{ city: "MASLIN BEACH", state: "SA", postcode: "5170" },
{ city: "CHITON", state: "SA", postcode: "5211" },
{ city: "GOOLWA", state: "SA", postcode: "5214" },
{ city: "BIG BEND", state: "SA", postcode: "5238" },
{ city: "BOLTO", state: "SA", postcode: "5238" },
{ city: "CAURNAMONT", state: "SA", postcode: "5238" },
{ city: "FIVE MILES", state: "SA", postcode: "5238" },
{ city: "FRAHNS", state: "SA", postcode: "5238" },
{ city: "FRAYVILLE", state: "SA", postcode: "5238" },
{ city: "JULANKA HOLDINGS", state: "SA", postcode: "5238" },
{ city: "LAKE CARLET", state: "SA", postcode: "5238" },
{ city: "OLD TEAL FLAT", state: "SA", postcode: "5238" },
{ city: "PELLARING FLAT", state: "SA", postcode: "5238" },
{ city: "PORT MANNUM", state: "SA", postcode: "5238" },
{ city: "PURNONG", state: "SA", postcode: "5238" },
{ city: "ROCKY POINT", state: "SA", postcode: "5238" },
{ city: "TEAL FLAT", state: "SA", postcode: "5238" },
{ city: "WALL FLAT", state: "SA", postcode: "5238" },
{ city: "YOUNGHUSBAND", state: "SA", postcode: "5238" },
{ city: "YOUNGHUSBAND HOLDINGS", state: "SA", postcode: "5238" },
{ city: "LENSWOOD", state: "SA", postcode: "5240" },
{ city: "LOBETHAL", state: "SA", postcode: "5241" },
{ city: "BALHANNAH", state: "SA", postcode: "5242" },
{ city: "OAKBANK", state: "SA", postcode: "5243" },
{ city: "HARROGATE", state: "SA", postcode: "5244" },
{ city: "INVERBRACKIE", state: "SA", postcode: "5244" },
{ city: "WOODSIDE", state: "SA", postcode: "5244" },
{ city: "HAHNDORF", state: "SA", postcode: "5245" },
{ city: "PAECHTOWN", state: "SA", postcode: "5245" },
{ city: "VERDUN", state: "SA", postcode: "5245" },
{ city: "BLAKISTON", state: "SA", postcode: "5250" },
{ city: "LITTLEHAMPTON", state: "SA", postcode: "5250" },
{ city: "TOTNESS", state: "SA", postcode: "5250" },
{ city: "BUGLE RANGES", state: "SA", postcode: "5251" },
{ city: "MOUNT BARKER", state: "SA", postcode: "5251" },
{ city: "MOUNT BARKER JUNCTION", state: "SA", postcode: "5251" },
{ city: "MOUNT BARKER SPRINGS", state: "SA", postcode: "5251" },
{ city: "MOUNT BARKER SUMMIT", state: "SA", postcode: "5251" },
{ city: "LAKE ALEXANDRINA", state: "SA", postcode: "5255" },
{ city: "LAKE ALEXANDRINA", state: "SA", postcode: "5259" },
{ city: "MOUNT GAMBIER", state: "SA", postcode: "5290" },
{ city: "MOUNT GAMBIER DC", state: "SA", postcode: "5290" },
{ city: "MOUNT GAMBIER", state: "SA", postcode: "5291" },
{ city: "MOUNT GAMBIER EAST", state: "SA", postcode: "5291" },
{ city: "MOUNT GAMBIER WEST", state: "SA", postcode: "5291" },
{ city: "SHEA-OAK LOG", state: "SA", postcode: "5371" },
{ city: "MAGDALA", state: "SA", postcode: "5400" },
{ city: "MAGDALLA", state: "SA", postcode: "5400" },
{ city: "PINKERTON PLAINS", state: "SA", postcode: "5400" },
{ city: "WASLEYS", state: "SA", postcode: "5400" },
{ city: "WOOLSHEDS", state: "SA", postcode: "5400" },
{ city: "AUBURN", state: "SA", postcode: "5451" },
{ city: "UNDALYA", state: "SA", postcode: "5451" },
{ city: "LEASINGHAM", state: "SA", postcode: "5452" },
{ city: "WATERVALE", state: "SA", postcode: "5452" },
{ city: "ARMAGH", state: "SA", postcode: "5453" },
{ city: "BARINIA", state: "SA", postcode: "5453" },
{ city: "BENBOURNIE", state: "SA", postcode: "5453" },
{ city: "BOCONNOC PARK", state: "SA", postcode: "5453" },
{ city: "CLARE", state: "SA", postcode: "5453" },
{ city: "EMU FLAT", state: "SA", postcode: "5453" },
{ city: "GILLENTOWN", state: "SA", postcode: "5453" },
{ city: "HILL RIVER", state: "SA", postcode: "5453" },
{ city: "HOYLETON", state: "SA", postcode: "5453" },
{ city: "KYBUNGA", state: "SA", postcode: "5453" },
{ city: "PENWORTHAM", state: "SA", postcode: "5453" },
{ city: "POLISH HILL RIVER", state: "SA", postcode: "5453" },
{ city: "SEVENHILL", state: "SA", postcode: "5453" },
{ city: "SPRING FARM", state: "SA", postcode: "5453" },
{ city: "SPRING GULLY", state: "SA", postcode: "5453" },
{ city: "STANLEY FLAT", state: "SA", postcode: "5453" },
{ city: "ANDREWS", state: "SA", postcode: "5454" },
{ city: "BROUGHTON RIVER VALLEY", state: "SA", postcode: "5454" },
{ city: "EUROMINA", state: "SA", postcode: "5454" },
{ city: "HACKLINS CORNER", state: "SA", postcode: "5454" },
{ city: "MAYFIELD", state: "SA", postcode: "5454" },
{ city: "SPALDING", state: "SA", postcode: "5454" },
{ city: "WASHPOOL", state: "SA", postcode: "5454" },
{ city: "HILLTOWN", state: "SA", postcode: "5455" },
{ city: "BARABBA", state: "SA", postcode: "5460" },
{ city: "OWEN", state: "SA", postcode: "5460" },
{ city: "PINERY", state: "SA", postcode: "5460" },
{ city: "STOCKYARD CREEK", state: "SA", postcode: "5460" },
{ city: "BALAKLAVA", state: "SA", postcode: "5461" },
{ city: "BOWILLIA", state: "SA", postcode: "5461" },
{ city: "DALKEY", state: "SA", postcode: "5461" },
{ city: "ERITH", state: "SA", postcode: "5461" },
{ city: "EVERARD CENTRAL", state: "SA", postcode: "5461" },
{ city: "GOYDER", state: "SA", postcode: "5461" },
{ city: "HALBURY", state: "SA", postcode: "5461" },
{ city: "HOSKIN CORNER", state: "SA", postcode: "5461" },
{ city: "MOUNT TEMPLETON", state: "SA", postcode: "5461" },
{ city: "SAINTS", state: "SA", postcode: "5461" },
{ city: "STOW", state: "SA", postcode: "5461" },
{ city: "WATCHMAN", state: "SA", postcode: "5461" },
{ city: "WHITWARTA", state: "SA", postcode: "5461" },
{ city: "BLYTH", state: "SA", postcode: "5462" },
{ city: "ANAMA", state: "SA", postcode: "5464" },
{ city: "BRINKWORTH", state: "SA", postcode: "5464" },
{ city: "BUNGAREE", state: "SA", postcode: "5464" },
{ city: "CONDOWIE", state: "SA", postcode: "5464" },
{ city: "HART", state: "SA", postcode: "5464" },
{ city: "KOOLUNGA", state: "SA", postcode: "5464" },
{ city: "MAROLA", state: "SA", postcode: "5464" },
{ city: "ROCHESTER", state: "SA", postcode: "5464" },
{ city: "YACKA", state: "SA", postcode: "5470" },
{ city: "GULNARE", state: "SA", postcode: "5471" },
{ city: "GEORGETOWN", state: "SA", postcode: "5472" },
{ city: "GLADSTONE", state: "SA", postcode: "5473" },
{ city: "APPILA", state: "SA", postcode: "5480" },
{ city: "LAURA", state: "SA", postcode: "5480" },
{ city: "STONE HUT", state: "SA", postcode: "5480" },
{ city: "BANGOR", state: "SA", postcode: "5481" },
{ city: "MURRAY TOWN", state: "SA", postcode: "5481" },
{ city: "WIRRABARA", state: "SA", postcode: "5481" },
{ city: "WONGYARRA", state: "SA", postcode: "5481" },
{ city: "BOOLEROO CENTRE", state: "SA", postcode: "5482" },
{ city: "WEPOWIE", state: "SA", postcode: "5482" },
{ city: "MELROSE", state: "SA", postcode: "5483" },
{ city: "WILMINGTON", state: "SA", postcode: "5485" },
{ city: "CALTOWIE", state: "SA", postcode: "5490" },
{ city: "CALTOWIE NORTH", state: "SA", postcode: "5490" },
{ city: "CALTOWIE WEST", state: "SA", postcode: "5490" },
{ city: "BELALIE EAST", state: "SA", postcode: "5491" },
{ city: "BELALIE NORTH", state: "SA", postcode: "5491" },
{ city: "BUNDALEER GARDENS", state: "SA", postcode: "5491" },
{ city: "BUNDALEER NORTH", state: "SA", postcode: "5491" },
{ city: "HORNSDALE", state: "SA", postcode: "5491" },
{ city: "JAMESTOWN", state: "SA", postcode: "5491" },
{ city: "WEST BUNDALEER", state: "SA", postcode: "5491" },
{ city: "YONGALA", state: "SA", postcode: "5493" },
{ city: "BAROOTA", state: "SA", postcode: "5495" },
{ city: "GERMEIN BAY", state: "SA", postcode: "5495" },
{ city: "MAMBRAY CREEK", state: "SA", postcode: "5495" },
{ city: "NECTAR BROOK", state: "SA", postcode: "5495" },
{ city: "PORT FLINDERS", state: "SA", postcode: "5495" },
{ city: "PORT GERMEIN", state: "SA", postcode: "5495" },
{ city: "WEEROONA ISLAND", state: "SA", postcode: "5495" },
{ city: "AVON", state: "SA", postcode: "5501" },
{ city: "CALOMBA", state: "SA", postcode: "5501" },
{ city: "DUBLIN", state: "SA", postcode: "5501" },
{ city: "LEWISTON", state: "SA", postcode: "5501" },
{ city: "LONG PLAINS", state: "SA", postcode: "5501" },
{ city: "LOWER LIGHT", state: "SA", postcode: "5501" },
{ city: "MIDDLE BEACH", state: "SA", postcode: "5501" },
{ city: "PARHAM", state: "SA", postcode: "5501" },
{ city: "PORT GAWLER", state: "SA", postcode: "5501" },
{ city: "THOMPSON BEACH", state: "SA", postcode: "5501" },
{ city: "TWO WELLS", state: "SA", postcode: "5501" },
{ city: "WEBB BEACH", state: "SA", postcode: "5501" },
{ city: "WILD HORSE PLAINS", state: "SA", postcode: "5501" },
{ city: "WINDSOR", state: "SA", postcode: "5501" },
{ city: "FISCHER", state: "SA", postcode: "5502" },
{ city: "GRACE PLAINS", state: "SA", postcode: "5502" },
{ city: "KORUNYE", state: "SA", postcode: "5502" },
{ city: "MALLALA", state: "SA", postcode: "5502" },
{ city: "REDBANKS", state: "SA", postcode: "5502" },
{ city: "REEVES PLAINS", state: "SA", postcode: "5502" },
{ city: "LOCHIEL", state: "SA", postcode: "5510" },
{ city: "PIRIE EAST", state: "SA", postcode: "5540" },
{ city: "BEAUFORT", state: "SA", postcode: "5550" },
{ city: "BOWMANS", state: "SA", postcode: "5550" },
{ city: "INKERMAN", state: "SA", postcode: "5550" },
{ city: "KALLORA", state: "SA", postcode: "5550" },
{ city: "NANTAWARRA", state: "SA", postcode: "5550" },
{ city: "PORT WAKEFIELD", state: "SA", postcode: "5550" },
{ city: "PROOF RANGE", state: "SA", postcode: "5550" },
{ city: "SOUTH HUMMOCKS", state: "SA", postcode: "5550" },
{ city: "KAINTON", state: "SA", postcode: "5552" },
{ city: "KULPARA", state: "SA", postcode: "5552" },
{ city: "MELTON", state: "SA", postcode: "5552" },
{ city: "PASKEVILLE", state: "SA", postcode: "5552" },
{ city: "PORT ARTHUR", state: "SA", postcode: "5552" },
{ city: "SUNNYVALE", state: "SA", postcode: "5552" },
{ city: "THRINGTON", state: "SA", postcode: "5552" },
{ city: "BOORS PLAIN", state: "SA", postcode: "5554" },
{ city: "CUNLIFFE", state: "SA", postcode: "5554" },
{ city: "JERICHO", state: "SA", postcode: "5554" },
{ city: "JERUSALEM", state: "SA", postcode: "5554" },
{ city: "KADINA", state: "SA", postcode: "5554" },
{ city: "MATTA FLAT", state: "SA", postcode: "5554" },
{ city: "NEW TOWN", state: "SA", postcode: "5554" },
{ city: "THOMAS PLAIN", state: "SA", postcode: "5554" },
{ city: "WALLAROO MINES", state: "SA", postcode: "5554" },
{ city: "WILLAMULKA", state: "SA", postcode: "5554" },
{ city: "ALFORD", state: "SA", postcode: "5555" },
{ city: "COLLINSFIELD", state: "SA", postcode: "5555" },
{ city: "DOWLING", state: "SA", postcode: "5555" },
{ city: "DOWLINGVILLE", state: "SA", postcode: "5555" },
{ city: "HOPE GAP", state: "SA", postcode: "5555" },
{ city: "KULPARA", state: "SA", postcode: "5555" },
{ city: "LAKE VIEW", state: "SA", postcode: "5555" },
{ city: "MELTON", state: "SA", postcode: "5555" },
{ city: "MUNDOORA", state: "SA", postcode: "5555" },
{ city: "TICKERA", state: "SA", postcode: "5555" },
{ city: "WINULTA", state: "SA", postcode: "5555" },
{ city: "NORTH BEACH", state: "SA", postcode: "5556" },
{ city: "WALLAROO", state: "SA", postcode: "5556" },
{ city: "WALLAROO PLAIN", state: "SA", postcode: "5556" },
{ city: "WARBURTO", state: "SA", postcode: "5556" },
{ city: "AGERY", state: "SA", postcode: "5558" },
{ city: "CROSS ROADS", state: "SA", postcode: "5558" },
{ city: "EAST MOONTA", state: "SA", postcode: "5558" },
{ city: "HAMLEY", state: "SA", postcode: "5558" },
{ city: "KOOROONA", state: "SA", postcode: "5558" },
{ city: "MOONTA", state: "SA", postcode: "5558" },
{ city: "MOONTA BAY", state: "SA", postcode: "5558" },
{ city: "MOONTA MINES", state: "SA", postcode: "5558" },
{ city: "NALYAPPA", state: "SA", postcode: "5558" },
{ city: "NORTH MOONTA", state: "SA", postcode: "5558" },
{ city: "NORTH YELTA", state: "SA", postcode: "5558" },
{ city: "PARAMATTA", state: "SA", postcode: "5558" },
{ city: "PORT HUGHES", state: "SA", postcode: "5558" },
{ city: "YELTA", state: "SA", postcode: "5558" },
{ city: "BUTE", state: "SA", postcode: "5560" },
{ city: "NINNES", state: "SA", postcode: "5560" },
{ city: "CLINTON", state: "SA", postcode: "5570" },
{ city: "CLINTON CENTRE", state: "SA", postcode: "5570" },
{ city: "PORT CLINTON", state: "SA", postcode: "5570" },
{ city: "PRICE", state: "SA", postcode: "5570" },
{ city: "WINULTA", state: "SA", postcode: "5570" },
{ city: "ARDROSSAN", state: "SA", postcode: "5571" },
{ city: "BLACK POINT", state: "SA", postcode: "5571" },
{ city: "CUNNINGHAM", state: "SA", postcode: "5571" },
{ city: "DOWLINGVILLE", state: "SA", postcode: "5571" },
{ city: "JAMES WELL", state: "SA", postcode: "5571" },
{ city: "PETERSVILLE", state: "SA", postcode: "5571" },
{ city: "PINE POINT", state: "SA", postcode: "5571" },
{ city: "ROGUES POINT", state: "SA", postcode: "5571" },
{ city: "SANDILANDS", state: "SA", postcode: "5571" },
{ city: "TIDDY WIDDY BEACH", state: "SA", postcode: "5571" },
{ city: "ARTHURTON", state: "SA", postcode: "5572" },
{ city: "PORT ARTHUR", state: "SA", postcode: "5572" },
{ city: "BALGOWAN", state: "SA", postcode: "5573" },
{ city: "CHINAMAN WELLS", state: "SA", postcode: "5573" },
{ city: "MAITLAND", state: "SA", postcode: "5573" },
{ city: "POINT PEARCE", state: "SA", postcode: "5573" },
{ city: "PORT VICTORIA", state: "SA", postcode: "5573" },
{ city: "SOUTH KILKERRAN", state: "SA", postcode: "5573" },
{ city: "URANIA", state: "SA", postcode: "5573" },
{ city: "WAURALTEE", state: "SA", postcode: "5573" },
{ city: "WEETULTA", state: "SA", postcode: "5573" },
{ city: "YORKE VALLEY", state: "SA", postcode: "5573" },
{ city: "BLUFF BEACH", state: "SA", postcode: "5575" },
{ city: "BRENTWOOD", state: "SA", postcode: "5575" },
{ city: "CORNY POINT", state: "SA", postcode: "5575" },
{ city: "COUCH BEACH", state: "SA", postcode: "5575" },
{ city: "HARDWICKE BAY", state: "SA", postcode: "5575" },
{ city: "KOOLYWURTIE", state: "SA", postcode: "5575" },
{ city: "MARION BAY", state: "SA", postcode: "5575" },
{ city: "MINLATON", state: "SA", postcode: "5575" },
{ city: "PARSONS BEACH", state: "SA", postcode: "5575" },
{ city: "POINT SOUTTAR", state: "SA", postcode: "5575" },
{ city: "POINT TURTON", state: "SA", postcode: "5575" },
{ city: "PORT JULIA", state: "SA", postcode: "5575" },
{ city: "PORT RICKABY", state: "SA", postcode: "5575" },
{ city: "RAMSAY", state: "SA", postcode: "5575" },
{ city: "STENHOUSE BAY", state: "SA", postcode: "5575" },
{ city: "THE PINES", state: "SA", postcode: "5575" },
{ city: "WHITE HUT", state: "SA", postcode: "5575" },
{ city: "WOOL BAY", state: "SA", postcode: "5575" },
{ city: "HONITON", state: "SA", postcode: "5576" },
{ city: "PORT MOOROWIE", state: "SA", postcode: "5576" },
{ city: "YORKETOWN", state: "SA", postcode: "5576" },
{ city: "COUCH BEACH", state: "SA", postcode: "5577" },
{ city: "FOUL BAY", state: "SA", postcode: "5577" },
{ city: "INNESTON", state: "SA", postcode: "5577" },
{ city: "POINT SOUTTAR", state: "SA", postcode: "5577" },
{ city: "THE PINES", state: "SA", postcode: "5577" },
{ city: "WAROOKA", state: "SA", postcode: "5577" },
{ city: "CURRAMULKA", state: "SA", postcode: "5580" },
{ city: "PORT JULIA", state: "SA", postcode: "5580" },
{ city: "PORT VINCENT", state: "SA", postcode: "5581" },
{ city: "SHEAOAK FLAT", state: "SA", postcode: "5581" },
{ city: "PORT GILES", state: "SA", postcode: "5582" },
{ city: "STANSBURY", state: "SA", postcode: "5582" },
{ city: "COOBOWIE", state: "SA", postcode: "5583" },
{ city: "EDITHBURGH", state: "SA", postcode: "5583" },
{ city: "SULTANA POINT", state: "SA", postcode: "5583" },
{ city: "BLANCHE HARBOR", state: "SA", postcode: "5700" },
{ city: "COMMISSARIAT POINT", state: "SA", postcode: "5700" },
{ city: "CULTANA", state: "SA", postcode: "5700" },
{ city: "DAVENPORT", state: "SA", postcode: "5700" },
{ city: "MUNDALLIO", state: "SA", postcode: "5700" },
{ city: "PORT AUGUSTA", state: "SA", postcode: "5700" },
{ city: "PORT AUGUSTA NORTH", state: "SA", postcode: "5700" },
{ city: "PORT AUGUSTA WEST", state: "SA", postcode: "5700" },
{ city: "PORT PATERSON", state: "SA", postcode: "5700" },
{ city: "WAMI KATA", state: "SA", postcode: "5700" },
{ city: "WINNINOWIE", state: "SA", postcode: "5700" },
{ city: "COOYERDOO", state: "SA", postcode: "5710" },
{ city: "JENKINS", state: "SA", postcode: "5710" },
{ city: "PORT AUGUSTA", state: "SA", postcode: "5710" },
{ city: "BELTANA SOUTH", state: "SA", postcode: "5731" },
{ city: "ADELAIDE AIRPORT", state: "SA", postcode: "5950" },
{ city: "EXPORT PARK", state: "SA", postcode: "5950" },
{ city: "GARDEN ISLAND", state: "SA", postcode: "5960" },
{ city: "TORRENS ISLAND", state: "SA", postcode: "5960" },
{ city: "BATHURST STREET PO", state: "TAS", postcode: "7000" },
{ city: "GLEBE", state: "TAS", postcode: "7000" },
{ city: "HOBART", state: "TAS", postcode: "7000" },
{ city: "MOUNT STUART", state: "TAS", postcode: "7000" },
{ city: "NORTH HOBART", state: "TAS", postcode: "7000" },
{ city: "QUEENS DOMAIN", state: "TAS", postcode: "7000" },
{ city: "WEST HOBART", state: "TAS", postcode: "7000" },
{ city: "SANDY BAY", state: "TAS", postcode: "7005" },
{ city: "NEW TOWN", state: "TAS", postcode: "7008" },
{ city: "DERWENT PARK", state: "TAS", postcode: "7009" },
{ city: "GLENORCHY", state: "TAS", postcode: "7010" },
{ city: "MORNINGTON", state: "TAS", postcode: "7018" },
{ city: "ROSNY PARK", state: "TAS", postcode: "7018" },
{ city: "KINGSTON", state: "TAS", postcode: "7050" },
{ city: "ACTON PARK", state: "TAS", postcode: "7170" },
{ city: "CAMBRIDGE", state: "TAS", postcode: "7170" },
{ city: "MOUNT RUMNEY", state: "TAS", postcode: "7170" },
{ city: "ROCHES BEACH", state: "TAS", postcode: "7170" },
{ city: "SEVEN MILE BEACH", state: "TAS", postcode: "7170" },
{ city: "WESTERN JUNCTION", state: "TAS", postcode: "7212" },
{ city: "MATHINNA", state: "TAS", postcode: "7214" },
{ city: "INVERMAY", state: "TAS", postcode: "7248" },
{ city: "NEWNHAM", state: "TAS", postcode: "7248" },
{ city: "BLACKSTONE HEIGHTS", state: "TAS", postcode: "7250" },
{ city: "EAST LAUNCESTON", state: "TAS", postcode: "7250" },
{ city: "LAUNCESTON", state: "TAS", postcode: "7250" },
{ city: "NEWSTEAD", state: "TAS", postcode: "7250" },
{ city: "NORWOOD", state: "TAS", postcode: "7250" },
{ city: "NORWOOD AVENUE PO", state: "TAS", postcode: "7250" },
{ city: "PROSPECT", state: "TAS", postcode: "7250" },
{ city: "PROSPECT VALE", state: "TAS", postcode: "7250" },
{ city: "RAVENSWOOD", state: "TAS", postcode: "7250" },
{ city: "RIVERSIDE", state: "TAS", postcode: "7250" },
{ city: "ST LEONARDS", state: "TAS", postcode: "7250" },
{ city: "SUMMERHILL", state: "TAS", postcode: "7250" },
{ city: "TRAVELLERS REST", state: "TAS", postcode: "7250" },
{ city: "TREVALLYN", state: "TAS", postcode: "7250" },
{ city: "WAVERLEY", state: "TAS", postcode: "7250" },
{ city: "WEST LAUNCESTON", state: "TAS", postcode: "7250" },
{ city: "DEVONPORT", state: "TAS", postcode: "7310" },
{ city: "WEST COAST", state: "TAS", postcode: "7321" },
{ city: "MELBOURNE", state: "VIC", postcode: "3000" },
{ city: "MELBOURNE", state: "VIC", postcode: "3001" },
{ city: "EAST MELBOURNE", state: "VIC", postcode: "3002" },
{ city: "WEST MELBOURNE", state: "VIC", postcode: "3003" },
{ city: "MELBOURNE", state: "VIC", postcode: "3004" },
{ city: "ST KILDA ROAD CENTRAL", state: "VIC", postcode: "3004" },
{ city: "WORLD TRADE CENTRE", state: "VIC", postcode: "3005" },
{ city: "SOUTHBANK", state: "VIC", postcode: "3006" },
{ city: "SOUTH WHARF", state: "VIC", postcode: "3006" },
{ city: "DOCKLANDS", state: "VIC", postcode: "3008" },
{ city: "UNIVERSITY OF MELBOURNE", state: "VIC", postcode: "3010" },
{ city: "FOOTSCRAY", state: "VIC", postcode: "3011" },
{ city: "SEDDON", state: "VIC", postcode: "3011" },
{ city: "SEDDON WEST", state: "VIC", postcode: "3011" },
{ city: "BROOKLYN", state: "VIC", postcode: "3012" },
{ city: "KINGSVILLE", state: "VIC", postcode: "3012" },
{ city: "KINGSVILLE WEST", state: "VIC", postcode: "3012" },
{ city: "MAIDSTONE", state: "VIC", postcode: "3012" },
{ city: "TOTTENHAM", state: "VIC", postcode: "3012" },
{ city: "WEST FOOTSCRAY", state: "VIC", postcode: "3012" },
{ city: "YARRAVILLE", state: "VIC", postcode: "3013" },
{ city: "YARRAVILLE WEST", state: "VIC", postcode: "3013" },
{ city: "NEWPORT", state: "VIC", postcode: "3015" },
{ city: "SOUTH KINGSVILLE", state: "VIC", postcode: "3015" },
{ city: "SPOTSWOOD", state: "VIC", postcode: "3015" },
{ city: "WILLIAMSTOWN", state: "VIC", postcode: "3016" },
{ city: "WILLIAMSTOWN NORTH", state: "VIC", postcode: "3016" },
{ city: "ALTONA", state: "VIC", postcode: "3018" },
{ city: "SEAHOLME", state: "VIC", postcode: "3018" },
{ city: "BRAYBROOK", state: "VIC", postcode: "3019" },
{ city: "BRAYBROOK NORTH", state: "VIC", postcode: "3019" },
{ city: "ROBINSON", state: "VIC", postcode: "3019" },
{ city: "ALBION", state: "VIC", postcode: "3020" },
{ city: "GLENGALA", state: "VIC", postcode: "3020" },
{ city: "SUNSHINE", state: "VIC", postcode: "3020" },
{ city: "SUNSHINE NORTH", state: "VIC", postcode: "3020" },
{ city: "SUNSHINE WEST", state: "VIC", postcode: "3020" },
{ city: "ALBANVALE", state: "VIC", postcode: "3021" },
{ city: "KEALBA", state: "VIC", postcode: "3021" },
{ city: "KINGS PARK", state: "VIC", postcode: "3021" },
{ city: "ST ALBANS", state: "VIC", postcode: "3021" },
{ city: "ARDEER", state: "VIC", postcode: "3022" },
{ city: "DEER PARK EAST", state: "VIC", postcode: "3022" },
{ city: "BURNSIDE", state: "VIC", postcode: "3023" },
{ city: "BURNSIDE HEIGHTS", state: "VIC", postcode: "3023" },
{ city: "CAIRNLEA", state: "VIC", postcode: "3023" },
{ city: "CAROLINE SPRINGS", state: "VIC", postcode: "3023" },
{ city: "DEER PARK", state: "VIC", postcode: "3023" },
{ city: "DEER PARK NORTH", state: "VIC", postcode: "3023" },
{ city: "RAVENHALL", state: "VIC", postcode: "3023" },
{ city: "FIELDSTONE", state: "VIC", postcode: "3024" },
{ city: "MAMBOURIN", state: "VIC", postcode: "3024" },
{ city: "MANOR LAKES", state: "VIC", postcode: "3024" },
{ city: "MOUNT COTTRELL", state: "VIC", postcode: "3024" },
{ city: "WYNDHAM VALE", state: "VIC", postcode: "3024" },
{ city: "ALTONA EAST", state: "VIC", postcode: "3025" },
{ city: "ALTONA GATE", state: "VIC", postcode: "3025" },
{ city: "ALTONA NORTH", state: "VIC", postcode: "3025" },
{ city: "DERRIMUT", state: "VIC", postcode: "3026" },
{ city: "LAVERTON NORTH", state: "VIC", postcode: "3026" },
{ city: "LAVERTON RAAF", state: "VIC", postcode: "3027" },
{ city: "WILLIAMS LANDING", state: "VIC", postcode: "3027" },
{ city: "WILLIAMS RAAF", state: "VIC", postcode: "3027" },
{ city: "ALTONA MEADOWS", state: "VIC", postcode: "3028" },
{ city: "LAVERTON", state: "VIC", postcode: "3028" },
{ city: "SEABROOK", state: "VIC", postcode: "3028" },
{ city: "HOPPERS CROSSING", state: "VIC", postcode: "3029" },
{ city: "TARNEIT", state: "VIC", postcode: "3029" },
{ city: "TRUGANINA", state: "VIC", postcode: "3029" },
{ city: "COCOROC", state: "VIC", postcode: "3030" },
{ city: "DERRIMUT", state: "VIC", postcode: "3030" },
{ city: "POINT COOK", state: "VIC", postcode: "3030" },
{ city: "QUANDONG", state: "VIC", postcode: "3030" },
{ city: "WERRIBEE", state: "VIC", postcode: "3030" },
{ city: "WERRIBEE SOUTH", state: "VIC", postcode: "3030" },
{ city: "FLEMINGTON", state: "VIC", postcode: "3031" },
{ city: "KENSINGTON", state: "VIC", postcode: "3031" },
{ city: "ASCOT VALE", state: "VIC", postcode: "3032" },
{ city: "HIGHPOINT CITY", state: "VIC", postcode: "3032" },
{ city: "MARIBYRNONG", state: "VIC", postcode: "3032" },
{ city: "TRAVANCORE", state: "VIC", postcode: "3032" },
{ city: "KEILOR EAST", state: "VIC", postcode: "3033" },
{ city: "AVONDALE HEIGHTS", state: "VIC", postcode: "3034" },
{ city: "KEILOR", state: "VIC", postcode: "3036" },
{ city: "KEILOR NORTH", state: "VIC", postcode: "3036" },
{ city: "CALDER PARK", state: "VIC", postcode: "3037" },
{ city: "DELAHEY", state: "VIC", postcode: "3037" },
{ city: "HILLSIDE", state: "VIC", postcode: "3037" },
{ city: "SYDENHAM", state: "VIC", postcode: "3037" },
{ city: "TAYLORS HILL", state: "VIC", postcode: "3037" },
{ city: "KEILOR DOWNS", state: "VIC", postcode: "3038" },
{ city: "KEILOR LODGE", state: "VIC", postcode: "3038" },
{ city: "TAYLORS LAKES", state: "VIC", postcode: "3038" },
{ city: "WATERGARDENS", state: "VIC", postcode: "3038" },
{ city: "MOONEE PONDS", state: "VIC", postcode: "3039" },
{ city: "ABERFELDIE", state: "VIC", postcode: "3040" },
{ city: "ESSENDON", state: "VIC", postcode: "3040" },
{ city: "ESSENDON WEST", state: "VIC", postcode: "3040" },
{ city: "CROSS KEYS", state: "VIC", postcode: "3041" },
{ city: "ESSENDON FIELDS", state: "VIC", postcode: "3041" },
{ city: "ESSENDON NORTH", state: "VIC", postcode: "3041" },
{ city: "STRATHMORE", state: "VIC", postcode: "3041" },
{ city: "STRATHMORE HEIGHTS", state: "VIC", postcode: "3041" },
{ city: "AIRPORT WEST", state: "VIC", postcode: "3042" },
{ city: "KEILOR PARK", state: "VIC", postcode: "3042" },
{ city: "NIDDRIE", state: "VIC", postcode: "3042" },
{ city: "NIDDRIE NORTH", state: "VIC", postcode: "3042" },
{ city: "GLADSTONE PARK", state: "VIC", postcode: "3043" },
{ city: "GOWANBRAE", state: "VIC", postcode: "3043" },
{ city: "TULLAMARINE", state: "VIC", postcode: "3043" },
{ city: "PASCOE VALE", state: "VIC", postcode: "3044" },
{ city: "PASCOE VALE SOUTH", state: "VIC", postcode: "3044" },
{ city: "MELBOURNE AIRPORT", state: "VIC", postcode: "3045" },
{ city: "GLENROY", state: "VIC", postcode: "3046" },
{ city: "HADFIELD", state: "VIC", postcode: "3046" },
{ city: "OAK PARK", state: "VIC", postcode: "3046" },
{ city: "BROADMEADOWS", state: "VIC", postcode: "3047" },
{ city: "DALLAS", state: "VIC", postcode: "3047" },
{ city: "JACANA", state: "VIC", postcode: "3047" },
{ city: "COOLAROO", state: "VIC", postcode: "3048" },
{ city: "MEADOW HEIGHTS", state: "VIC", postcode: "3048" },
{ city: "ATTWOOD", state: "VIC", postcode: "3049" },
{ city: "CALDER PARK", state: "VIC", postcode: "3049" },
{ city: "WESTMEADOWS", state: "VIC", postcode: "3049" },
{ city: "ROYAL MELBOURNE HOSPITAL", state: "VIC", postcode: "3050" },
{ city: "HOTHAM HILL", state: "VIC", postcode: "3051" },
{ city: "NORTH MELBOURNE", state: "VIC", postcode: "3051" },
{ city: "MELBOURNE UNIVERSITY", state: "VIC", postcode: "3052" },
{ city: "PARKVILLE", state: "VIC", postcode: "3052" },
{ city: "CARLTON", state: "VIC", postcode: "3053" },
{ city: "CARLTON SOUTH", state: "VIC", postcode: "3053" },
{ city: "CARLTON NORTH", state: "VIC", postcode: "3054" },
{ city: "PRINCES HILL", state: "VIC", postcode: "3054" },
{ city: "BRUNSWICK SOUTH", state: "VIC", postcode: "3055" },
{ city: "BRUNSWICK WEST", state: "VIC", postcode: "3055" },
{ city: "MOONEE VALE", state: "VIC", postcode: "3055" },
{ city: "MORELAND WEST", state: "VIC", postcode: "3055" },
{ city: "BRUNSWICK", state: "VIC", postcode: "3056" },
{ city: "BRUNSWICK LOWER", state: "VIC", postcode: "3056" },
{ city: "BRUNSWICK NORTH", state: "VIC", postcode: "3056" },
{ city: "BRUNSWICK EAST", state: "VIC", postcode: "3057" },
{ city: "LYGON STREET NORTH", state: "VIC", postcode: "3057" },
{ city: "SUMNER", state: "VIC", postcode: "3057" },
{ city: "BATMAN", state: "VIC", postcode: "3058" },
{ city: "COBURG", state: "VIC", postcode: "3058" },
{ city: "COBURG NORTH", state: "VIC", postcode: "3058" },
{ city: "MERLYNSTON", state: "VIC", postcode: "3058" },
{ city: "MORELAND", state: "VIC", postcode: "3058" },
{ city: "GREENVALE", state: "VIC", postcode: "3059" },
{ city: "FAWKNER", state: "VIC", postcode: "3060" },
{ city: "FAWKNER EAST", state: "VIC", postcode: "3060" },
{ city: "FAWKNER NORTH", state: "VIC", postcode: "3060" },
{ city: "CAMPBELLFIELD", state: "VIC", postcode: "3061" },
{ city: "SOMERTON", state: "VIC", postcode: "3062" },
{ city: "CRAIGIEBURN", state: "VIC", postcode: "3064" },
{ city: "DONNYBROOK", state: "VIC", postcode: "3064" },
{ city: "KALKALLO", state: "VIC", postcode: "3064" },
{ city: "MICKLEHAM", state: "VIC", postcode: "3064" },
{ city: "ROXBURGH PARK", state: "VIC", postcode: "3064" },
{ city: "FITZROY", state: "VIC", postcode: "3065" },
{ city: "COLLINGWOOD", state: "VIC", postcode: "3066" },
{ city: "COLLINGWOOD NORTH", state: "VIC", postcode: "3066" },
{ city: "ABBOTSFORD", state: "VIC", postcode: "3067" },
{ city: "CLIFTON HILL", state: "VIC", postcode: "3068" },
{ city: "FITZROY NORTH", state: "VIC", postcode: "3068" },
{ city: "NORTHCOTE", state: "VIC", postcode: "3070" },
{ city: "NORTHCOTE SOUTH", state: "VIC", postcode: "3070" },
{ city: "THORNBURY", state: "VIC", postcode: "3071" },
{ city: "GILBERTON", state: "VIC", postcode: "3072" },
{ city: "NORTHLAND CENTRE", state: "VIC", postcode: "3072" },
{ city: "PRESTON", state: "VIC", postcode: "3072" },
{ city: "PRESTON LOWER", state: "VIC", postcode: "3072" },
{ city: "PRESTON SOUTH", state: "VIC", postcode: "3072" },
{ city: "PRESTON WEST", state: "VIC", postcode: "3072" },
{ city: "REGENT WEST", state: "VIC", postcode: "3072" },
{ city: "KEON PARK", state: "VIC", postcode: "3073" },
{ city: "RESERVOIR", state: "VIC", postcode: "3073" },
{ city: "RESERVOIR EAST", state: "VIC", postcode: "3073" },
{ city: "RESERVOIR NORTH", state: "VIC", postcode: "3073" },
{ city: "RESERVOIR SOUTH", state: "VIC", postcode: "3073" },
{ city: "THOMASTOWN", state: "VIC", postcode: "3074" },
{ city: "LALOR", state: "VIC", postcode: "3075" },
{ city: "LALOR PLAZA", state: "VIC", postcode: "3075" },
{ city: "EPPING", state: "VIC", postcode: "3076" },
{ city: "EPPING DC", state: "VIC", postcode: "3076" },
{ city: "ALPHINGTON", state: "VIC", postcode: "3078" },
{ city: "FAIRFIELD", state: "VIC", postcode: "3078" },
{ city: "IVANHOE", state: "VIC", postcode: "3079" },
{ city: "IVANHOE EAST", state: "VIC", postcode: "3079" },
{ city: "IVANHOE NORTH", state: "VIC", postcode: "3079" },
{ city: "BELLFIELD", state: "VIC", postcode: "3081" },
{ city: "HEIDELBERG HEIGHTS", state: "VIC", postcode: "3081" },
{ city: "HEIDELBERG RGH", state: "VIC", postcode: "3081" },
{ city: "HEIDELBERG WEST", state: "VIC", postcode: "3081" },
{ city: "MILL PARK", state: "VIC", postcode: "3082" },
{ city: "BUNDOORA", state: "VIC", postcode: "3083" },
{ city: "KINGSBURY", state: "VIC", postcode: "3083" },
{ city: "LA TROBE UNIVERSITY", state: "VIC", postcode: "3083" },
{ city: "BANYULE", state: "VIC", postcode: "3084" },
{ city: "EAGLEMONT", state: "VIC", postcode: "3084" },
{ city: "HEIDELBERG", state: "VIC", postcode: "3084" },
{ city: "ROSANNA", state: "VIC", postcode: "3084" },
{ city: "VIEWBANK", state: "VIC", postcode: "3084" },
{ city: "MACLEOD", state: "VIC", postcode: "3085" },
{ city: "MACLEOD WEST", state: "VIC", postcode: "3085" },
{ city: "YALLAMBIE", state: "VIC", postcode: "3085" },
{ city: "LA TROBE UNIVERSITY", state: "VIC", postcode: "3086" },
{ city: "WATSONIA", state: "VIC", postcode: "3087" },
{ city: "WATSONIA NORTH", state: "VIC", postcode: "3087" },
{ city: "BRIAR HILL", state: "VIC", postcode: "3088" },
{ city: "GREENSBOROUGH", state: "VIC", postcode: "3088" },
{ city: "SAINT HELENA", state: "VIC", postcode: "3088" },
{ city: "ST HELENA", state: "VIC", postcode: "3088" },
{ city: "DIAMOND CREEK", state: "VIC", postcode: "3089" },
{ city: "PLENTY", state: "VIC", postcode: "3090" },
{ city: "YARRAMBAT", state: "VIC", postcode: "3091" },
{ city: "LOWER PLENTY", state: "VIC", postcode: "3093" },
{ city: "MONTMORENCY", state: "VIC", postcode: "3094" },
{ city: "ELTHAM", state: "VIC", postcode: "3095" },
{ city: "ELTHAM NORTH", state: "VIC", postcode: "3095" },
{ city: "RESEARCH", state: "VIC", postcode: "3095" },
{ city: "WATTLE GLEN", state: "VIC", postcode: "3096" },
{ city: "BEND OF ISLANDS", state: "VIC", postcode: "3097" },
{ city: "KANGAROO GROUND", state: "VIC", postcode: "3097" },
{ city: "WATSONS CREEK", state: "VIC", postcode: "3097" },
{ city: "COTHAM", state: "VIC", postcode: "3101" },
{ city: "KEW", state: "VIC", postcode: "3101" },
{ city: "KEW EAST", state: "VIC", postcode: "3102" },
{ city: "BALWYN", state: "VIC", postcode: "3103" },
{ city: "BALWYN EAST", state: "VIC", postcode: "3103" },
{ city: "DEEPDENE", state: "VIC", postcode: "3103" },
{ city: "STRADBROKE PARK", state: "VIC", postcode: "3103" },
{ city: "BALWYN NORTH", state: "VIC", postcode: "3104" },
{ city: "GREYTHORN", state: "VIC", postcode: "3104" },
{ city: "BULLEEN", state: "VIC", postcode: "3105" },
{ city: "BULLEEN SOUTH", state: "VIC", postcode: "3105" },
{ city: "TEMPLESTOWE", state: "VIC", postcode: "3106" },
{ city: "TEMPLESTOWE LOWER", state: "VIC", postcode: "3107" },
{ city: "DONCASTER", state: "VIC", postcode: "3108" },
{ city: "DONCASTER EAST", state: "VIC", postcode: "3109" },
{ city: "DONCASTER HEIGHTS", state: "VIC", postcode: "3109" },
{ city: "THE PINES", state: "VIC", postcode: "3109" },
{ city: "TUNSTALL SQUARE PO", state: "VIC", postcode: "3109" },
{ city: "DONVALE", state: "VIC", postcode: "3111" },
{ city: "NORTH WARRANDYTE", state: "VIC", postcode: "3113" },
{ city: "WARRANDYTE", state: "VIC", postcode: "3113" },
{ city: "PARK ORCHARDS", state: "VIC", postcode: "3114" },
{ city: "WONGA PARK", state: "VIC", postcode: "3115" },
{ city: "CHIRNSIDE PARK", state: "VIC", postcode: "3116" },
{ city: "BURNLEY", state: "VIC", postcode: "3121" },
{ city: "BURNLEY NORTH", state: "VIC", postcode: "3121" },
{ city: "CREMORNE", state: "VIC", postcode: "3121" },
{ city: "RICHMOND", state: "VIC", postcode: "3121" },
{ city: "RICHMOND EAST", state: "VIC", postcode: "3121" },
{ city: "RICHMOND NORTH", state: "VIC", postcode: "3121" },
{ city: "RICHMOND SOUTH", state: "VIC", postcode: "3121" },
{ city: "AUBURN SOUTH", state: "VIC", postcode: "3122" },
{ city: "GLENFERRIE SOUTH", state: "VIC", postcode: "3122" },
{ city: "HAWTHORN", state: "VIC", postcode: "3122" },
{ city: "HAWTHORN NORTH", state: "VIC", postcode: "3122" },
{ city: "HAWTHORN WEST", state: "VIC", postcode: "3122" },
{ city: "AUBURN", state: "VIC", postcode: "3123" },
{ city: "HAWTHORN EAST", state: "VIC", postcode: "3123" },
{ city: "CAMBERWELL", state: "VIC", postcode: "3124" },
{ city: "CAMBERWELL NORTH", state: "VIC", postcode: "3124" },
{ city: "CAMBERWELL SOUTH", state: "VIC", postcode: "3124" },
{ city: "CAMBERWELL WEST", state: "VIC", postcode: "3124" },
{ city: "HARTWELL", state: "VIC", postcode: "3124" },
{ city: "MIDDLE CAMBERWELL", state: "VIC", postcode: "3124" },
{ city: "BENNETTSWOOD", state: "VIC", postcode: "3125" },
{ city: "BURWOOD", state: "VIC", postcode: "3125" },
{ city: "SURREY HILLS SOUTH", state: "VIC", postcode: "3125" },
{ city: "CAMBERWELL EAST", state: "VIC", postcode: "3126" },
{ city: "CANTERBURY", state: "VIC", postcode: "3126" },
{ city: "MONT ALBERT", state: "VIC", postcode: "3127" },
{ city: "SURREY HILLS", state: "VIC", postcode: "3127" },
{ city: "SURREY HILLS NORTH", state: "VIC", postcode: "3127" },
{ city: "BOX HILL", state: "VIC", postcode: "3128" },
{ city: "BOX HILL CENTRAL", state: "VIC", postcode: "3128" },
{ city: "BOX HILL SOUTH", state: "VIC", postcode: "3128" },
{ city: "HOUSTON", state: "VIC", postcode: "3128" },
{ city: "WATTLE PARK", state: "VIC", postcode: "3128" },
{ city: "BOX HILL NORTH", state: "VIC", postcode: "3129" },
{ city: "KERRIMUIR", state: "VIC", postcode: "3129" },
{ city: "MONT ALBERT NORTH", state: "VIC", postcode: "3129" },
{ city: "BLACKBURN", state: "VIC", postcode: "3130" },
{ city: "BLACKBURN NORTH", state: "VIC", postcode: "3130" },
{ city: "BLACKBURN SOUTH", state: "VIC", postcode: "3130" },
{ city: "LABURNUM", state: "VIC", postcode: "3130" },
{ city: "BRENTFORD SQUARE", state: "VIC", postcode: "3131" },
{ city: "FOREST HILL", state: "VIC", postcode: "3131" },
{ city: "NUNAWADING", state: "VIC", postcode: "3131" },
{ city: "MITCHAM", state: "VIC", postcode: "3132" },
{ city: "MITCHAM NORTH", state: "VIC", postcode: "3132" },
{ city: "RANGEVIEW", state: "VIC", postcode: "3132" },
{ city: "VERMONT", state: "VIC", postcode: "3133" },
{ city: "VERMONT SOUTH", state: "VIC", postcode: "3133" },
{ city: "HEATHWOOD", state: "VIC", postcode: "3134" },
{ city: "RINGWOOD", state: "VIC", postcode: "3134" },
{ city: "RINGWOOD NORTH", state: "VIC", postcode: "3134" },
{ city: "WARRANDYTE SOUTH", state: "VIC", postcode: "3134" },
{ city: "WARRANWOOD", state: "VIC", postcode: "3134" },
{ city: "BEDFORD ROAD", state: "VIC", postcode: "3135" },
{ city: "HEATHMONT", state: "VIC", postcode: "3135" },
{ city: "RINGWOOD EAST", state: "VIC", postcode: "3135" },
{ city: "CROYDON", state: "VIC", postcode: "3136" },
{ city: "CROYDON HILLS", state: "VIC", postcode: "3136" },
{ city: "CROYDON NORTH", state: "VIC", postcode: "3136" },
{ city: "CROYDON SOUTH", state: "VIC", postcode: "3136" },
{ city: "KILSYTH", state: "VIC", postcode: "3137" },
{ city: "KILSYTH SOUTH", state: "VIC", postcode: "3137" },
{ city: "MOOROOLBARK", state: "VIC", postcode: "3138" },
{ city: "LILYDALE", state: "VIC", postcode: "3140" },
{ city: "CHAPEL STREET NORTH", state: "VIC", postcode: "3141" },
{ city: "DOMAIN ROAD PO", state: "VIC", postcode: "3141" },
{ city: "SOUTH YARRA", state: "VIC", postcode: "3141" },
{ city: "HAWKSBURN", state: "VIC", postcode: "3142" },
{ city: "TOORAK", state: "VIC", postcode: "3142" },
{ city: "ARMADALE", state: "VIC", postcode: "3143" },
{ city: "ARMADALE NORTH", state: "VIC", postcode: "3143" },
{ city: "KOOYONG", state: "VIC", postcode: "3144" },
{ city: "MALVERN", state: "VIC", postcode: "3144" },
{ city: "MALVERN NORTH", state: "VIC", postcode: "3144" },
{ city: "CAULFIELD EAST", state: "VIC", postcode: "3145" },
{ city: "CENTRAL PARK", state: "VIC", postcode: "3145" },
{ city: "DARLING", state: "VIC", postcode: "3145" },
{ city: "DARLING SOUTH", state: "VIC", postcode: "3145" },
{ city: "MALVERN EAST", state: "VIC", postcode: "3145" },
{ city: "WATTLETREE ROAD PO", state: "VIC", postcode: "3145" },
{ city: "GLEN IRIS", state: "VIC", postcode: "3146" },
{ city: "TOORONGA", state: "VIC", postcode: "3146" },
{ city: "ASHBURTON", state: "VIC", postcode: "3147" },
{ city: "ASHWOOD", state: "VIC", postcode: "3147" },
{ city: "CHADSTONE", state: "VIC", postcode: "3148" },
{ city: "CHADSTONE CENTRE", state: "VIC", postcode: "3148" },
{ city: "HOLMESGLEN", state: "VIC", postcode: "3148" },
{ city: "JORDANVILLE", state: "VIC", postcode: "3148" },
{ city: "MOUNT WAVERLEY", state: "VIC", postcode: "3149" },
{ city: "PINEWOOD", state: "VIC", postcode: "3149" },
{ city: "SYNDAL", state: "VIC", postcode: "3149" },
{ city: "BRANDON PARK", state: "VIC", postcode: "3150" },
{ city: "GLEN WAVERLEY", state: "VIC", postcode: "3150" },
{ city: "WHEELERS HILL", state: "VIC", postcode: "3150" },
{ city: "BURWOOD EAST", state: "VIC", postcode: "3151" },
{ city: "BURWOOD HEIGHTS", state: "VIC", postcode: "3151" },
{ city: "KNOX CITY CENTRE", state: "VIC", postcode: "3152" },
{ city: "STUDFIELD", state: "VIC", postcode: "3152" },
{ city: "WANTIRNA", state: "VIC", postcode: "3152" },
{ city: "WANTIRNA SOUTH", state: "VIC", postcode: "3152" },
{ city: "BAYSWATER", state: "VIC", postcode: "3153" },
{ city: "BAYSWATER NORTH", state: "VIC", postcode: "3153" },
{ city: "THE BASIN", state: "VIC", postcode: "3154" },
{ city: "BORONIA", state: "VIC", postcode: "3155" },
{ city: "FERNTREE GULLY", state: "VIC", postcode: "3156" },
{ city: "LYSTERFIELD", state: "VIC", postcode: "3156" },
{ city: "LYSTERFIELD SOUTH", state: "VIC", postcode: "3156" },
{ city: "MOUNTAIN GATE", state: "VIC", postcode: "3156" },
{ city: "UPPER FERNTREE GULLY", state: "VIC", postcode: "3156" },
{ city: "UPWEY", state: "VIC", postcode: "3158" },
{ city: "MENZIES CREEK", state: "VIC", postcode: "3159" },
{ city: "SELBY", state: "VIC", postcode: "3159" },
{ city: "BELGRAVE", state: "VIC", postcode: "3160" },
{ city: "BELGRAVE HEIGHTS", state: "VIC", postcode: "3160" },
{ city: "BELGRAVE SOUTH", state: "VIC", postcode: "3160" },
{ city: "TECOMA", state: "VIC", postcode: "3160" },
{ city: "CAULFIELD JUNCTION", state: "VIC", postcode: "3161" },
{ city: "CAULFIELD NORTH", state: "VIC", postcode: "3161" },
{ city: "CAULFIELD", state: "VIC", postcode: "3162" },
{ city: "CAULFIELD SOUTH", state: "VIC", postcode: "3162" },
{ city: "HOPETOUN GARDENS", state: "VIC", postcode: "3162" },
{ city: "BOORAN ROAD PO", state: "VIC", postcode: "3163" },
{ city: "CARNEGIE", state: "VIC", postcode: "3163" },
{ city: "GLEN HUNTLY", state: "VIC", postcode: "3163" },
{ city: "MURRUMBEENA", state: "VIC", postcode: "3163" },
{ city: "BENTLEIGH EAST", state: "VIC", postcode: "3165" },
{ city: "COATESVILLE", state: "VIC", postcode: "3165" },
{ city: "HUGHESDALE", state: "VIC", postcode: "3166" },
{ city: "HUNTINGDALE", state: "VIC", postcode: "3166" },
{ city: "OAKLEIGH", state: "VIC", postcode: "3166" },
{ city: "OAKLEIGH EAST", state: "VIC", postcode: "3166" },
{ city: "OAKLEIGH SOUTH", state: "VIC", postcode: "3167" },
{ city: "CLAYTON", state: "VIC", postcode: "3168" },
{ city: "NOTTING HILL", state: "VIC", postcode: "3168" },
{ city: "CLARINDA", state: "VIC", postcode: "3169" },
{ city: "CLAYTON SOUTH", state: "VIC", postcode: "3169" },
{ city: "MULGRAVE", state: "VIC", postcode: "3170" },
{ city: "WAVERLEY GARDENS", state: "VIC", postcode: "3170" },
{ city: "SANDOWN VILLAGE", state: "VIC", postcode: "3171" },
{ city: "SPRINGVALE", state: "VIC", postcode: "3171" },
{ city: "DINGLEY", state: "VIC", postcode: "3172" },
{ city: "DINGLEY VILLAGE", state: "VIC", postcode: "3172" },
{ city: "SPRINGVALE SOUTH", state: "VIC", postcode: "3172" },
{ city: "KEYSBOROUGH", state: "VIC", postcode: "3173" },
{ city: "NOBLE PARK", state: "VIC", postcode: "3174" },
{ city: "NOBLE PARK EAST", state: "VIC", postcode: "3174" },
{ city: "NOBLE PARK NORTH", state: "VIC", postcode: "3174" },
{ city: "BANGHOLME", state: "VIC", postcode: "3175" },
{ city: "DANDENONG", state: "VIC", postcode: "3175" },
{ city: "DANDENONG EAST", state: "VIC", postcode: "3175" },
{ city: "DANDENONG NORTH", state: "VIC", postcode: "3175" },
{ city: "DANDENONG PLAZA", state: "VIC", postcode: "3175" },
{ city: "DANDENONG SOUTH", state: "VIC", postcode: "3175" },
{ city: "DUNEARN", state: "VIC", postcode: "3175" },
{ city: "DOVETON", state: "VIC", postcode: "3177" },
{ city: "EUMEMMERRING", state: "VIC", postcode: "3177" },
{ city: "ROWVILLE", state: "VIC", postcode: "3178" },
{ city: "SCORESBY", state: "VIC", postcode: "3179" },
{ city: "KNOXFIELD", state: "VIC", postcode: "3180" },
{ city: "PRAHRAN", state: "VIC", postcode: "3181" },
{ city: "PRAHRAN EAST", state: "VIC", postcode: "3181" },
{ city: "WINDSOR", state: "VIC", postcode: "3181" },
{ city: "ST KILDA", state: "VIC", postcode: "3182" },
{ city: "ST KILDA SOUTH", state: "VIC", postcode: "3182" },
{ city: "ST KILDA WEST", state: "VIC", postcode: "3182" },
{ city: "BALACLAVA", state: "VIC", postcode: "3183" },
{ city: "ST KILDA EAST", state: "VIC", postcode: "3183" },
{ city: "BRIGHTON ROAD", state: "VIC", postcode: "3184" },
{ city: "ELWOOD", state: "VIC", postcode: "3184" },
{ city: "ELSTERNWICK", state: "VIC", postcode: "3185" },
{ city: "GARDENVALE", state: "VIC", postcode: "3185" },
{ city: "RIPPONLEA", state: "VIC", postcode: "3185" },
{ city: "BRIGHTON", state: "VIC", postcode: "3186" },
{ city: "BRIGHTON NORTH", state: "VIC", postcode: "3186" },
{ city: "DENDY", state: "VIC", postcode: "3186" },
{ city: "WERE STREET PO", state: "VIC", postcode: "3186" },
{ city: "BRIGHTON EAST", state: "VIC", postcode: "3187" },
{ city: "NORTH ROAD", state: "VIC", postcode: "3187" },
{ city: "HAMPTON", state: "VIC", postcode: "3188" },
{ city: "HAMPTON EAST", state: "VIC", postcode: "3188" },
{ city: "HAMPTON NORTH", state: "VIC", postcode: "3188" },
{ city: "MOORABBIN", state: "VIC", postcode: "3189" },
{ city: "MOORABBIN EAST", state: "VIC", postcode: "3189" },
{ city: "WISHART", state: "VIC", postcode: "3189" },
{ city: "HIGHETT", state: "VIC", postcode: "3190" },
{ city: "SANDRINGHAM", state: "VIC", postcode: "3191" },
{ city: "CHELTENHAM", state: "VIC", postcode: "3192" },
{ city: "CHELTENHAM EAST", state: "VIC", postcode: "3192" },
{ city: "CHELTENHAM NORTH", state: "VIC", postcode: "3192" },
{ city: "SOUTHLAND CENTRE", state: "VIC", postcode: "3192" },
{ city: "BEAUMARIS", state: "VIC", postcode: "3193" },
{ city: "BLACK ROCK", state: "VIC", postcode: "3193" },
{ city: "BLACK ROCK NORTH", state: "VIC", postcode: "3193" },
{ city: "CROMER", state: "VIC", postcode: "3193" },
{ city: "MENTONE", state: "VIC", postcode: "3194" },
{ city: "MENTONE EAST", state: "VIC", postcode: "3194" },
{ city: "MOORABBIN AIRPORT", state: "VIC", postcode: "3194" },
{ city: "ASPENDALE", state: "VIC", postcode: "3195" },
{ city: "ASPENDALE GARDENS", state: "VIC", postcode: "3195" },
{ city: "BRAESIDE", state: "VIC", postcode: "3195" },
{ city: "MORDIALLOC", state: "VIC", postcode: "3195" },
{ city: "MORDIALLOC NORTH", state: "VIC", postcode: "3195" },
{ city: "PARKDALE", state: "VIC", postcode: "3195" },
{ city: "WATERWAYS", state: "VIC", postcode: "3195" },
{ city: "BONBEACH", state: "VIC", postcode: "3196" },
{ city: "CHELSEA", state: "VIC", postcode: "3196" },
{ city: "CHELSEA HEIGHTS", state: "VIC", postcode: "3196" },
{ city: "EDITHVALE", state: "VIC", postcode: "3196" },
{ city: "CARRUM", state: "VIC", postcode: "3197" },
{ city: "PATTERSON LAKES", state: "VIC", postcode: "3197" },
{ city: "BELVEDERE PARK", state: "VIC", postcode: "3198" },
{ city: "SEAFORD", state: "VIC", postcode: "3198" },
{ city: "FRANKSTON", state: "VIC", postcode: "3199" },
{ city: "FRANKSTON EAST", state: "VIC", postcode: "3199" },
{ city: "FRANKSTON HEIGHTS", state: "VIC", postcode: "3199" },
{ city: "FRANKSTON SOUTH", state: "VIC", postcode: "3199" },
{ city: "KARINGAL", state: "VIC", postcode: "3199" },
{ city: "KARINGAL CENTRE", state: "VIC", postcode: "3199" },
{ city: "FRANKSTON NORTH", state: "VIC", postcode: "3200" },
{ city: "PINES FOREST", state: "VIC", postcode: "3200" },
{ city: "CARRUM DOWNS", state: "VIC", postcode: "3201" },
{ city: "HEATHERTON", state: "VIC", postcode: "3202" },
{ city: "BENTLEIGH", state: "VIC", postcode: "3204" },
{ city: "MCKINNON", state: "VIC", postcode: "3204" },
{ city: "ORMOND", state: "VIC", postcode: "3204" },
{ city: "PATTERSON", state: "VIC", postcode: "3204" },
{ city: "SOUTH MELBOURNE", state: "VIC", postcode: "3205" },
{ city: "SOUTH MELBOURNE DC", state: "VIC", postcode: "3205" },
{ city: "ALBERT PARK", state: "VIC", postcode: "3206" },
{ city: "MIDDLE PARK", state: "VIC", postcode: "3206" },
{ city: "GARDEN CITY", state: "VIC", postcode: "3207" },
{ city: "PORT MELBOURNE", state: "VIC", postcode: "3207" },
{ city: "LITTLE RIVER", state: "VIC", postcode: "3211" },
{ city: "AVALON", state: "VIC", postcode: "3212" },
{ city: "LARA", state: "VIC", postcode: "3212" },
{ city: "POINT WILSON", state: "VIC", postcode: "3212" },
{ city: "ANAKIE", state: "VIC", postcode: "3213" },
{ city: "BATESFORD", state: "VIC", postcode: "3213" },
{ city: "LOVELY BANKS", state: "VIC", postcode: "3213" },
{ city: "MOORABOOL", state: "VIC", postcode: "3213" },
{ city: "CORIO", state: "VIC", postcode: "3214" },
{ city: "NORLANE", state: "VIC", postcode: "3214" },
{ city: "NORTH SHORE", state: "VIC", postcode: "3214" },
{ city: "BELL PARK", state: "VIC", postcode: "3215" },
{ city: "BELL POST HILL", state: "VIC", postcode: "3215" },
{ city: "DRUMCONDRA", state: "VIC", postcode: "3215" },
{ city: "GEELONG NORTH", state: "VIC", postcode: "3215" },
{ city: "HAMLYN HEIGHTS", state: "VIC", postcode: "3215" },
{ city: "NORTH GEELONG", state: "VIC", postcode: "3215" },
{ city: "RIPPLESIDE", state: "VIC", postcode: "3215" },
{ city: "BELMONT", state: "VIC", postcode: "3216" },
{ city: "FRESHWATER CREEK", state: "VIC", postcode: "3216" },
{ city: "GROVEDALE", state: "VIC", postcode: "3216" },
{ city: "GROVEDALE EAST", state: "VIC", postcode: "3216" },
{ city: "HIGHTON", state: "VIC", postcode: "3216" },
{ city: "MARSHALL", state: "VIC", postcode: "3216" },
{ city: "MOUNT DUNEED", state: "VIC", postcode: "3216" },
{ city: "WANDANA HEIGHTS", state: "VIC", postcode: "3216" },
{ city: "WAURN PONDS", state: "VIC", postcode: "3216" },
{ city: "ARMSTRONG CREEK", state: "VIC", postcode: "3217" },
{ city: "CHARLEMONT", state: "VIC", postcode: "3217" },
{ city: "DEAKIN UNIVERSITY", state: "VIC", postcode: "3217" },
{ city: "FRESHWATER CREEK", state: "VIC", postcode: "3217" },
{ city: "MOUNT DUNEED", state: "VIC", postcode: "3217" },
{ city: "FYANSFORD", state: "VIC", postcode: "3218" },
{ city: "GEELONG WEST", state: "VIC", postcode: "3218" },
{ city: "HERNE HILL", state: "VIC", postcode: "3218" },
{ city: "MANIFOLD HEIGHTS", state: "VIC", postcode: "3218" },
{ city: "MURGHEBOLUC", state: "VIC", postcode: "3218" },
{ city: "STONEHAVEN", state: "VIC", postcode: "3218" },
{ city: "BREAKWATER", state: "VIC", postcode: "3219" },
{ city: "EAST GEELONG", state: "VIC", postcode: "3219" },
{ city: "NEWCOMB", state: "VIC", postcode: "3219" },
{ city: "ST ALBANS PARK", state: "VIC", postcode: "3219" },
{ city: "THOMSON", state: "VIC", postcode: "3219" },
{ city: "WHITTINGTON", state: "VIC", postcode: "3219" },
{ city: "BAREENA", state: "VIC", postcode: "3220" },
{ city: "GEELONG", state: "VIC", postcode: "3220" },
{ city: "NEWTOWN", state: "VIC", postcode: "3220" },
{ city: "SOUTH GEELONG", state: "VIC", postcode: "3220" },
{ city: "GEELONG MC", state: "VIC", postcode: "3221" },
{ city: "TORQUAY", state: "VIC", postcode: "3228" },
{ city: "COLAC", state: "VIC", postcode: "3250" },
{ city: "COLAC EAST", state: "VIC", postcode: "3250" },
{ city: "COLAC WEST", state: "VIC", postcode: "3250" },
{ city: "WARRNAMBOOL", state: "VIC", postcode: "3280" },
{ city: "WARRNAMBOOL EAST", state: "VIC", postcode: "3280" },
{ city: "WARRNAMBOOL WEST", state: "VIC", postcode: "3280" },
{ city: "HAMILTON", state: "VIC", postcode: "3300" },
{ city: "PORTLAND", state: "VIC", postcode: "3305" },
{ city: "PORTLAND NORTH", state: "VIC", postcode: "3305" },
{ city: "PORTLAND WEST", state: "VIC", postcode: "3305" },
{ city: "GRANGEFIELDS", state: "VIC", postcode: "3335" },
{ city: "AINTREE", state: "VIC", postcode: "3336" },
{ city: "DEANSIDE", state: "VIC", postcode: "3336" },
{ city: "FRASER RISE", state: "VIC", postcode: "3336" },
{ city: "HARKNESS", state: "VIC", postcode: "3337" },
{ city: "MELTON", state: "VIC", postcode: "3337" },
{ city: "MELTON WEST", state: "VIC", postcode: "3337" },
{ city: "MELTON SOUTH", state: "VIC", postcode: "3338" },
{ city: "BACCHUS MARSH", state: "VIC", postcode: "3340" },
{ city: "BAKERY HILL", state: "VIC", postcode: "3350" },
{ city: "BALLARAT", state: "VIC", postcode: "3350" },
{ city: "BALLARAT CENTRAL", state: "VIC", postcode: "3350" },
{ city: "BALLARAT EAST", state: "VIC", postcode: "3350" },
{ city: "BALLARAT NORTH", state: "VIC", postcode: "3350" },
{ city: "BALLARAT WEST", state: "VIC", postcode: "3350" },
{ city: "GOLDEN POINT", state: "VIC", postcode: "3350" },
{ city: "BALLARAT ROADSIDE DELIVERY", state: "VIC", postcode: "3352" },
{ city: "WENDOUREE", state: "VIC", postcode: "3355" },
{ city: "ARARAT", state: "VIC", postcode: "3377" },
{ city: "WARRACKNABEAL", state: "VIC", postcode: "3393" },
{ city: "HORSHAM", state: "VIC", postcode: "3400" },
{ city: "HORSHAM WEST", state: "VIC", postcode: "3400" },
{ city: "KYNETON", state: "VIC", postcode: "3444" },
{ city: "KYNETON SOUTH", state: "VIC", postcode: "3444" },
{ city: "ADELAIDE LEAD", state: "VIC", postcode: "3465" },
{ city: "ALMA", state: "VIC", postcode: "3465" },
{ city: "BOWENVALE", state: "VIC", postcode: "3465" },
{ city: "BUNG BONG", state: "VIC", postcode: "3465" },
{ city: "COTSWOLD", state: "VIC", postcode: "3465" },
{ city: "CRAIGIE", state: "VIC", postcode: "3465" },
{ city: "DAISY HILL", state: "VIC", postcode: "3465" },
{ city: "FLAGSTAFF", state: "VIC", postcode: "3465" },
{ city: "GOLDEN POINT", state: "VIC", postcode: "3465" },
{ city: "HAVELOCK", state: "VIC", postcode: "3465" },
{ city: "HOMEBUSH", state: "VIC", postcode: "3465" },
{ city: "MAJORCA", state: "VIC", postcode: "3465" },
{ city: "MARYBOROUGH", state: "VIC", postcode: "3465" },
{ city: "MOONLIGHT FLAT", state: "VIC", postcode: "3465" },
{ city: "NATTE YALLOCK", state: "VIC", postcode: "3465" },
{ city: "RATHSCAR", state: "VIC", postcode: "3465" },
{ city: "RATHSCAR WEST", state: "VIC", postcode: "3465" },
{ city: "RODBOROUGH", state: "VIC", postcode: "3465" },
{ city: "SIMSON", state: "VIC", postcode: "3465" },
{ city: "TIMOR", state: "VIC", postcode: "3465" },
{ city: "TIMOR WEST", state: "VIC", postcode: "3465" },
{ city: "WAREEK", state: "VIC", postcode: "3465" },
{ city: "WEDDERBURN", state: "VIC", postcode: "3518" },
{ city: "WEDDERBURN JUNCTION", state: "VIC", postcode: "3518" },
{ city: "BENDIGO", state: "VIC", postcode: "3550" },
{ city: "BENDIGO SOUTH", state: "VIC", postcode: "3550" },
{ city: "DIAMOND HILL", state: "VIC", postcode: "3550" },
{ city: "EAST BENDIGO", state: "VIC", postcode: "3550" },
{ city: "FLORA HILL", state: "VIC", postcode: "3550" },
{ city: "IRONBARK", state: "VIC", postcode: "3550" },
{ city: "KENNINGTON", state: "VIC", postcode: "3550" },
{ city: "LONG GULLY", state: "VIC", postcode: "3550" },
{ city: "NORTH BENDIGO", state: "VIC", postcode: "3550" },
{ city: "QUARRY HILL", state: "VIC", postcode: "3550" },
{ city: "SANDHURST EAST", state: "VIC", postcode: "3550" },
{ city: "SPRING GULLY", state: "VIC", postcode: "3550" },
{ city: "STRATHDALE", state: "VIC", postcode: "3550" },
{ city: "TYSONS REEF", state: "VIC", postcode: "3550" },
{ city: "WEST BENDIGO", state: "VIC", postcode: "3550" },
{ city: "WHITE HILLS", state: "VIC", postcode: "3550" },
{ city: "GOLDEN SQUARE", state: "VIC", postcode: "3555" },
{ city: "ECHUCA", state: "VIC", postcode: "3564" },
{ city: "ECHUCA EAST", state: "VIC", postcode: "3564" },
{ city: "ECHUCA SOUTH", state: "VIC", postcode: "3564" },
{ city: "ECHUCA VILLAGE", state: "VIC", postcode: "3564" },
{ city: "ECHUCA WEST", state: "VIC", postcode: "3564" },
{ city: "ARDMONA", state: "VIC", postcode: "3629" },
{ city: "COOMBOONA", state: "VIC", postcode: "3629" },
{ city: "MOOROOPNA", state: "VIC", postcode: "3629" },
{ city: "MOOROOPNA NORTH", state: "VIC", postcode: "3629" },
{ city: "UNDERA", state: "VIC", postcode: "3629" },
{ city: "BRANDITT", state: "VIC", postcode: "3630" },
{ city: "CANIAMBO", state: "VIC", postcode: "3630" },
{ city: "COLLIVER", state: "VIC", postcode: "3630" },
{ city: "DUNKIRK", state: "VIC", postcode: "3630" },
{ city: "SHEPPARTON", state: "VIC", postcode: "3630" },
{ city: "SHEPPARTON SOUTH", state: "VIC", postcode: "3630" },
{ city: "SHEPPARTON EAST", state: "VIC", postcode: "3631" },
{ city: "SHEPPARTON NORTH", state: "VIC", postcode: "3631" },
{ city: "DOOKIE COLLEGE", state: "VIC", postcode: "3647" },
{ city: "SEYMOUR", state: "VIC", postcode: "3660" },
{ city: "SEYMOUR SOUTH", state: "VIC", postcode: "3660" },
{ city: "BENALLA", state: "VIC", postcode: "3672" },
{ city: "BENALLA WEST", state: "VIC", postcode: "3672" },
{ city: "WANGARATTA", state: "VIC", postcode: "3677" },
{ city: "WANGARATTA WEST", state: "VIC", postcode: "3677" },
{ city: "EAST WANGARATTA", state: "VIC", postcode: "3678" },
{ city: "NORTH WANGARATTA", state: "VIC", postcode: "3678" },
{ city: "WANGARATTA FORWARD", state: "VIC", postcode: "3678" },
{ city: "WANGARATTA SOUTH", state: "VIC", postcode: "3678" },
{ city: "WEST WODONGA", state: "VIC", postcode: "3690" },
{ city: "WODONGA", state: "VIC", postcode: "3690" },
{ city: "WODONGA PLAZA", state: "VIC", postcode: "3690" },
{ city: "WODONGA FORWARD", state: "VIC", postcode: "3691" },
{ city: "MORANG SOUTH", state: "VIC", postcode: "3752" },
{ city: "SOUTH MORANG", state: "VIC", postcode: "3752" },
{ city: "WALLAN", state: "VIC", postcode: "3756" },
{ city: "WHITTLESEA", state: "VIC", postcode: "3757" },
{ city: "KILMORE", state: "VIC", postcode: "3764" },
{ city: "KILMORE EAST", state: "VIC", postcode: "3764" },
{ city: "MONASH UNIVERSITY", state: "VIC", postcode: "3800" },
{ city: "ENDEAVOUR HILLS", state: "VIC", postcode: "3802" },
{ city: "HALLAM", state: "VIC", postcode: "3803" },
{ city: "NARRE WARREN EAST", state: "VIC", postcode: "3804" },
{ city: "NARRE WARREN NORTH", state: "VIC", postcode: "3804" },
{ city: "FOUNTAIN GATE", state: "VIC", postcode: "3805" },
{ city: "NARRE WARREN", state: "VIC", postcode: "3805" },
{ city: "NARRE WARREN SOUTH", state: "VIC", postcode: "3805" },
{ city: "BERWICK", state: "VIC", postcode: "3806" },
{ city: "BEACONSFIELD", state: "VIC", postcode: "3807" },
{ city: "PAKENHAM", state: "VIC", postcode: "3810" },
{ city: "PAKENHAM SOUTH", state: "VIC", postcode: "3810" },
{ city: "PAKENHAM UPPER", state: "VIC", postcode: "3810" },
{ city: "WARRAGUL", state: "VIC", postcode: "3820" },
{ city: "WARRAGUL SOUTH", state: "VIC", postcode: "3821" },
{ city: "WARRAGUL WEST", state: "VIC", postcode: "3821" },
{ city: "TRAFALGAR", state: "VIC", postcode: "3824" },
{ city: "TRAFALGAR EAST", state: "VIC", postcode: "3824" },
{ city: "TRAFALGAR SOUTH", state: "VIC", postcode: "3824" },
{ city: "MOE", state: "VIC", postcode: "3825" },
{ city: "MOE SOUTH", state: "VIC", postcode: "3825" },
{ city: "MORWELL", state: "VIC", postcode: "3840" },
{ city: "MORWELL EAST", state: "VIC", postcode: "3840" },
{ city: "MORWELL UPPER", state: "VIC", postcode: "3840" },
{ city: "TRARALGON", state: "VIC", postcode: "3844" },
{ city: "TRARALGON EAST", state: "VIC", postcode: "3844" },
{ city: "TRARALGON SOUTH", state: "VIC", postcode: "3844" },
{ city: "LANGWARRIN", state: "VIC", postcode: "3910" },
{ city: "BAXTER", state: "VIC", postcode: "3911" },
{ city: "LANGWARRIN SOUTH", state: "VIC", postcode: "3911" },
{ city: "PEARCEDALE", state: "VIC", postcode: "3912" },
{ city: "SOMERVILLE", state: "VIC", postcode: "3912" },
{ city: "TYABB", state: "VIC", postcode: "3913" },
{ city: "HASTINGS", state: "VIC", postcode: "3915" },
{ city: "MERRICKS", state: "VIC", postcode: "3916" },
{ city: "SHOREHAM", state: "VIC", postcode: "3916" },
{ city: "BITTERN", state: "VIC", postcode: "3918" },
{ city: "CRIB POINT", state: "VIC", postcode: "3919" },
{ city: "HMAS CERBERUS", state: "VIC", postcode: "3920" },
{ city: "BALNARRING", state: "VIC", postcode: "3926" },
{ city: "BALNARRING BEACH", state: "VIC", postcode: "3926" },
{ city: "MERRICKS BEACH", state: "VIC", postcode: "3926" },
{ city: "MERRICKS NORTH", state: "VIC", postcode: "3926" },
{ city: "SOMERS", state: "VIC", postcode: "3927" },
{ city: "MAIN RIDGE", state: "VIC", postcode: "3928" },
{ city: "FLINDERS", state: "VIC", postcode: "3929" },
{ city: "MOUNT ELIZA", state: "VIC", postcode: "3930" },
{ city: "MORNINGTON", state: "VIC", postcode: "3931" },
{ city: "MOOROODUC", state: "VIC", postcode: "3933" },
{ city: "DROMANA", state: "VIC", postcode: "3936" },
{ city: "SAFETY BEACH", state: "VIC", postcode: "3936" },
{ city: "RED HILL", state: "VIC", postcode: "3937" },
{ city: "RED HILL SOUTH", state: "VIC", postcode: "3937" },
{ city: "MCCRAE", state: "VIC", postcode: "3938" },
{ city: "CAPE SCHANCK", state: "VIC", postcode: "3939" },
{ city: "ROSEBUD", state: "VIC", postcode: "3939" },
{ city: "ROSEBUD PLAZA", state: "VIC", postcode: "3939" },
{ city: "CAPEL SOUND", state: "VIC", postcode: "3940" },
{ city: "ROSEBUD WEST", state: "VIC", postcode: "3940" },
{ city: "RYE", state: "VIC", postcode: "3941" },
{ city: "ST ANDREWS BEACH", state: "VIC", postcode: "3941" },
{ city: "SORRENTO", state: "VIC", postcode: "3943" },
{ city: "PORTSEA", state: "VIC", postcode: "3944" },
{ city: "LYNBROOK", state: "VIC", postcode: "3975" },
{ city: "LYNDHURST", state: "VIC", postcode: "3975" },
{ city: "HAMPTON PARK", state: "VIC", postcode: "3976" },
{ city: "BOTANIC RIDGE", state: "VIC", postcode: "3977" },
{ city: "CANNONS CREEK", state: "VIC", postcode: "3977" },
{ city: "CRANBOURNE", state: "VIC", postcode: "3977" },
{ city: "CRANBOURNE EAST", state: "VIC", postcode: "3977" },
{ city: "CRANBOURNE NORTH", state: "VIC", postcode: "3977" },
{ city: "CRANBOURNE SOUTH", state: "VIC", postcode: "3977" },
{ city: "CRANBOURNE WEST", state: "VIC", postcode: "3977" },
{ city: "DEVON MEADOWS", state: "VIC", postcode: "3977" },
{ city: "JUNCTION VILLAGE", state: "VIC", postcode: "3977" },
{ city: "SANDHURST", state: "VIC", postcode: "3977" },
{ city: "SKYE", state: "VIC", postcode: "3977" },
{ city: "CARDINIA", state: "VIC", postcode: "3978" },
{ city: "CLYDE", state: "VIC", postcode: "3978" },
{ city: "CLYDE NORTH", state: "VIC", postcode: "3978" },
{ city: "CITY DELIVERY CENTRE", state: "WA", postcode: "6000" },
{ city: "PERTH", state: "WA", postcode: "6000" },
{ city: "PERTH GPO", state: "WA", postcode: "6000" },
{ city: "HIGHGATE", state: "WA", postcode: "6003" },
{ city: "NORTHBRIDGE", state: "WA", postcode: "6003" },
{ city: "EAST PERTH", state: "WA", postcode: "6004" },
{ city: "KINGS PARK", state: "WA", postcode: "6005" },
{ city: "WEST PERTH", state: "WA", postcode: "6005" },
{ city: "NORTH PERTH", state: "WA", postcode: "6006" },
{ city: "LEEDERVILLE", state: "WA", postcode: "6007" },
{ city: "WEST LEEDERVILLE", state: "WA", postcode: "6007" },
{ city: "DAGLISH", state: "WA", postcode: "6008" },
{ city: "SHENTON PARK", state: "WA", postcode: "6008" },
{ city: "SUBIACO", state: "WA", postcode: "6008" },
{ city: "SUBIACO EAST", state: "WA", postcode: "6008" },
{ city: "BROADWAY NEDLANDS", state: "WA", postcode: "6009" },
{ city: "CRAWLEY", state: "WA", postcode: "6009" },
{ city: "DALKEITH", state: "WA", postcode: "6009" },
{ city: "NEDLANDS", state: "WA", postcode: "6009" },
{ city: "NEDLANDS DC", state: "WA", postcode: "6009" },
{ city: "CLAREMONT", state: "WA", postcode: "6010" },
{ city: "CLAREMONT NORTH", state: "WA", postcode: "6010" },
{ city: "KARRAKATTA", state: "WA", postcode: "6010" },
{ city: "MOUNT CLAREMONT", state: "WA", postcode: "6010" },
{ city: "SWANBOURNE", state: "WA", postcode: "6010" },
{ city: "COTTESLOE", state: "WA", postcode: "6011" },
{ city: "PEPPERMINT GROVE", state: "WA", postcode: "6011" },
{ city: "MOSMAN PARK", state: "WA", postcode: "6012" },
{ city: "FLOREAT", state: "WA", postcode: "6014" },
{ city: "FLOREAT FORUM", state: "WA", postcode: "6014" },
{ city: "JOLIMONT", state: "WA", postcode: "6014" },
{ city: "WEMBLEY", state: "WA", postcode: "6014" },
{ city: "CITY BEACH", state: "WA", postcode: "6015" },
{ city: "GLENDALOUGH", state: "WA", postcode: "6016" },
{ city: "MOUNT HAWTHORN", state: "WA", postcode: "6016" },
{ city: "HERDSMAN", state: "WA", postcode: "6017" },
{ city: "OSBORNE PARK", state: "WA", postcode: "6017" },
{ city: "OSBORNE PARK DC", state: "WA", postcode: "6017" },
{ city: "CHURCHLANDS", state: "WA", postcode: "6018" },
{ city: "DOUBLEVIEW", state: "WA", postcode: "6018" },
{ city: "GWELUP", state: "WA", postcode: "6018" },
{ city: "GWELUP DC", state: "WA", postcode: "6018" },
{ city: "INNALOO", state: "WA", postcode: "6018" },
{ city: "KARRINYUP", state: "WA", postcode: "6018" },
{ city: "WOODLANDS", state: "WA", postcode: "6018" },
{ city: "SCARBOROUGH", state: "WA", postcode: "6019" },
{ city: "WEMBLEY DOWNS", state: "WA", postcode: "6019" },
{ city: "CARINE", state: "WA", postcode: "6020" },
{ city: "MARMION", state: "WA", postcode: "6020" },
{ city: "NORTH BEACH", state: "WA", postcode: "6020" },
{ city: "SORRENTO", state: "WA", postcode: "6020" },
{ city: "WATERMANS BAY", state: "WA", postcode: "6020" },
{ city: "BALCATTA", state: "WA", postcode: "6021" },
{ city: "STIRLING", state: "WA", postcode: "6021" },
{ city: "HAMERSLEY", state: "WA", postcode: "6022" },
{ city: "DUNCRAIG", state: "WA", postcode: "6023" },
{ city: "GREENWOOD", state: "WA", postcode: "6024" },
{ city: "WARWICK", state: "WA", postcode: "6024" },
{ city: "CRAIGIE", state: "WA", postcode: "6025" },
{ city: "HILLARYS", state: "WA", postcode: "6025" },
{ city: "KALLAROO", state: "WA", postcode: "6025" },
{ city: "PADBURY", state: "WA", postcode: "6025" },
{ city: "KINGSLEY", state: "WA", postcode: "6026" },
{ city: "WOODVALE", state: "WA", postcode: "6026" },
{ city: "BELDON", state: "WA", postcode: "6027" },
{ city: "CONNOLLY", state: "WA", postcode: "6027" },
{ city: "EDGEWATER", state: "WA", postcode: "6027" },
{ city: "HEATHRIDGE", state: "WA", postcode: "6027" },
{ city: "JOONDALUP", state: "WA", postcode: "6027" },
{ city: "JOONDALUP DC", state: "WA", postcode: "6027" },
{ city: "MULLALOO", state: "WA", postcode: "6027" },
{ city: "OCEAN REEF", state: "WA", postcode: "6027" },
{ city: "BURNS BEACH", state: "WA", postcode: "6028" },
{ city: "CURRAMBINE", state: "WA", postcode: "6028" },
{ city: "ILUKA", state: "WA", postcode: "6028" },
{ city: "KINROSS", state: "WA", postcode: "6028" },
{ city: "TRIGG", state: "WA", postcode: "6029" },
{ city: "CLARKSON", state: "WA", postcode: "6030" },
{ city: "MERRIWA", state: "WA", postcode: "6030" },
{ city: "MINDARIE", state: "WA", postcode: "6030" },
{ city: "QUINNS ROCKS", state: "WA", postcode: "6030" },
{ city: "RIDGEWOOD", state: "WA", postcode: "6030" },
{ city: "TAMALA PARK", state: "WA", postcode: "6030" },
{ city: "BANKSIA GROVE", state: "WA", postcode: "6031" },
{ city: "CARRAMAR", state: "WA", postcode: "6031" },
{ city: "NEERABUP", state: "WA", postcode: "6031" },
{ city: "NOWERGUP", state: "WA", postcode: "6032" },
{ city: "CARABOODA", state: "WA", postcode: "6033" },
{ city: "EGLINTON", state: "WA", postcode: "6034" },
{ city: "BUTLER", state: "WA", postcode: "6036" },
{ city: "JINDALEE", state: "WA", postcode: "6036" },
{ city: "ALKIMOS", state: "WA", postcode: "6038" },
{ city: "COOLBINIA", state: "WA", postcode: "6050" },
{ city: "MENORA", state: "WA", postcode: "6050" },
{ city: "MOUNT LAWLEY", state: "WA", postcode: "6050" },
{ city: "MAYLANDS", state: "WA", postcode: "6051" },
{ city: "BEDFORD", state: "WA", postcode: "6052" },
{ city: "INGLEWOOD", state: "WA", postcode: "6052" },
{ city: "BAYSWATER", state: "WA", postcode: "6053" },
{ city: "ASHFIELD", state: "WA", postcode: "6054" },
{ city: "BASSENDEAN", state: "WA", postcode: "6054" },
{ city: "BASSENDEAN DC", state: "WA", postcode: "6054" },
{ city: "EDEN HILL", state: "WA", postcode: "6054" },
{ city: "KIARA", state: "WA", postcode: "6054" },
{ city: "LOCKRIDGE", state: "WA", postcode: "6054" },
{ city: "BRABHAM", state: "WA", postcode: "6055" },
{ city: "BUSHMEAD", state: "WA", postcode: "6055" },
{ city: "CAVERSHAM", state: "WA", postcode: "6055" },
{ city: "DAYTON", state: "WA", postcode: "6055" },
{ city: "GUILDFORD", state: "WA", postcode: "6055" },
{ city: "HAZELMERE", state: "WA", postcode: "6055" },
{ city: "HENLEY BROOK", state: "WA", postcode: "6055" },
{ city: "SOUTH GUILDFORD", state: "WA", postcode: "6055" },
{ city: "WEST SWAN", state: "WA", postcode: "6055" },
{ city: "BASKERVILLE", state: "WA", postcode: "6056" },
{ city: "BELLEVUE", state: "WA", postcode: "6056" },
{ city: "BOYA", state: "WA", postcode: "6056" },
{ city: "GREENMOUNT", state: "WA", postcode: "6056" },
{ city: "HELENA VALLEY", state: "WA", postcode: "6056" },
{ city: "HERNE HILL", state: "WA", postcode: "6056" },
{ city: "JANE BROOK", state: "WA", postcode: "6056" },
{ city: "KOONGAMIA", state: "WA", postcode: "6056" },
{ city: "MIDDLE SWAN", state: "WA", postcode: "6056" },
{ city: "MIDLAND", state: "WA", postcode: "6056" },
{ city: "MIDVALE", state: "WA", postcode: "6056" },
{ city: "MILLENDON", state: "WA", postcode: "6056" },
{ city: "RED HILL", state: "WA", postcode: "6056" },
{ city: "STRATTON", state: "WA", postcode: "6056" },
{ city: "SWAN VIEW", state: "WA", postcode: "6056" },
{ city: "VIVEASH", state: "WA", postcode: "6056" },
{ city: "WOODBRIDGE", state: "WA", postcode: "6056" },
{ city: "HIGH WYCOMBE", state: "WA", postcode: "6057" },
{ city: "MAIDA VALE", state: "WA", postcode: "6057" },
{ city: "FORRESTFIELD", state: "WA", postcode: "6058" },
{ city: "DIANELLA", state: "WA", postcode: "6059" },
{ city: "DOG SWAMP", state: "WA", postcode: "6060" },
{ city: "JOONDANNA", state: "WA", postcode: "6060" },
{ city: "TUART HILL", state: "WA", postcode: "6060" },
{ city: "YOKINE", state: "WA", postcode: "6060" },
{ city: "BALGA", state: "WA", postcode: "6061" },
{ city: "MIRRABOOKA", state: "WA", postcode: "6061" },
{ city: "NOLLAMARA", state: "WA", postcode: "6061" },
{ city: "WESTMINSTER", state: "WA", postcode: "6061" },
{ city: "EMBLETON", state: "WA", postcode: "6062" },
{ city: "MORLEY", state: "WA", postcode: "6062" },
{ city: "NORANDA", state: "WA", postcode: "6062" },
{ city: "BEECHBORO", state: "WA", postcode: "6063" },
{ city: "BENNETT SPRINGS", state: "WA", postcode: "6063" },
{ city: "ALEXANDER HEIGHTS", state: "WA", postcode: "6064" },
{ city: "GIRRAWHEEN", state: "WA", postcode: "6064" },
{ city: "KOONDOOLA", state: "WA", postcode: "6064" },
{ city: "MARANGAROO", state: "WA", postcode: "6064" },
{ city: "ASHBY", state: "WA", postcode: "6065" },
{ city: "DARCH", state: "WA", postcode: "6065" },
{ city: "HOCKING", state: "WA", postcode: "6065" },
{ city: "KINGSWAY", state: "WA", postcode: "6065" },
{ city: "LANDSDALE", state: "WA", postcode: "6065" },
{ city: "MADELEY", state: "WA", postcode: "6065" },
{ city: "PEARSALL", state: "WA", postcode: "6065" },
{ city: "SINAGRA", state: "WA", postcode: "6065" },
{ city: "TAPPING", state: "WA", postcode: "6065" },
{ city: "WANGARA", state: "WA", postcode: "6065" },
{ city: "WANGARA DC", state: "WA", postcode: "6065" },
{ city: "WANNEROO", state: "WA", postcode: "6065" },
{ city: "BALLAJURA", state: "WA", postcode: "6066" },
{ city: "CULLACABARDEE", state: "WA", postcode: "6067" },
{ city: "WHITEMAN", state: "WA", postcode: "6068" },
{ city: "AVELEY", state: "WA", postcode: "6069" },
{ city: "BELHUS", state: "WA", postcode: "6069" },
{ city: "BRIGADOON", state: "WA", postcode: "6069" },
{ city: "ELLENBROOK", state: "WA", postcode: "6069" },
{ city: "ELLENBROOK EAST", state: "WA", postcode: "6069" },
{ city: "THE VINES", state: "WA", postcode: "6069" },
{ city: "UPPER SWAN", state: "WA", postcode: "6069" },
{ city: "DARLINGTON", state: "WA", postcode: "6070" },
{ city: "GLEN FORREST", state: "WA", postcode: "6071" },
{ city: "HOVEA", state: "WA", postcode: "6071" },
{ city: "MAHOGANY CREEK", state: "WA", postcode: "6072" },
{ city: "MUNDARING", state: "WA", postcode: "6073" },
{ city: "MUNDARING DC", state: "WA", postcode: "6073" },
{ city: "SAWYERS VALLEY", state: "WA", postcode: "6074" },
{ city: "BICKLEY", state: "WA", postcode: "6076" },
{ city: "CARMEL", state: "WA", postcode: "6076" },
{ city: "GOOSEBERRY HILL", state: "WA", postcode: "6076" },
{ city: "HACKETTS GULLY", state: "WA", postcode: "6076" },
{ city: "KALAMUNDA", state: "WA", postcode: "6076" },
{ city: "LESMURDIE", state: "WA", postcode: "6076" },
{ city: "PAULLS VALLEY", state: "WA", postcode: "6076" },
{ city: "PICKERING BROOK", state: "WA", postcode: "6076" },
{ city: "PIESSE BROOK", state: "WA", postcode: "6076" },
{ city: "RESERVOIR", state: "WA", postcode: "6076" },
{ city: "WALLISTON", state: "WA", postcode: "6076" },
{ city: "WALLISTON DC", state: "WA", postcode: "6076" },
{ city: "GNANGARA", state: "WA", postcode: "6077" },
{ city: "JANDABUP", state: "WA", postcode: "6077" },
{ city: "MARIGINIUP", state: "WA", postcode: "6078" },
{ city: "PINJAR", state: "WA", postcode: "6078" },
{ city: "LEXIA", state: "WA", postcode: "6079" },
{ city: "MELALEUCA", state: "WA", postcode: "6079" },
{ city: "PARKERVILLE", state: "WA", postcode: "6081" },
{ city: "STONEVILLE", state: "WA", postcode: "6081" },
{ city: "BAILUP", state: "WA", postcode: "6082" },
{ city: "MOUNT HELENA", state: "WA", postcode: "6082" },
{ city: "GIDGEGANNUP", state: "WA", postcode: "6083" },
{ city: "MORANGUP", state: "WA", postcode: "6083" },
{ city: "MALAGA", state: "WA", postcode: "6090" },
{ city: "BURSWOOD", state: "WA", postcode: "6100" },
{ city: "LATHLAIN", state: "WA", postcode: "6100" },
{ city: "VICTORIA PARK", state: "WA", postcode: "6100" },
{ city: "CARLISLE", state: "WA", postcode: "6101" },
{ city: "CARLISLE NORTH", state: "WA", postcode: "6101" },
{ city: "CARLISLE SOUTH", state: "WA", postcode: "6101" },
{ city: "EAST VICTORIA PARK", state: "WA", postcode: "6101" },
{ city: "BENTLEY", state: "WA", postcode: "6102" },
{ city: "BENTLEY DC", state: "WA", postcode: "6102" },
{ city: "BENTLEY SOUTH", state: "WA", postcode: "6102" },
{ city: "ST JAMES", state: "WA", postcode: "6102" },
{ city: "RIVERVALE", state: "WA", postcode: "6103" },
{ city: "ASCOT", state: "WA", postcode: "6104" },
{ city: "BELMONT", state: "WA", postcode: "6104" },
{ city: "NEWBURN", state: "WA", postcode: "6104" },
{ city: "REDCLIFFE", state: "WA", postcode: "6104" },
{ city: "CLOVERDALE", state: "WA", postcode: "6105" },
{ city: "KEWDALE", state: "WA", postcode: "6105" },
{ city: "PERTH AIRPORT", state: "WA", postcode: "6105" },
{ city: "WELSHPOOL", state: "WA", postcode: "6106" },
{ city: "WELSHPOOL DC", state: "WA", postcode: "6106" },
{ city: "BECKENHAM", state: "WA", postcode: "6107" },
{ city: "CANNINGTON", state: "WA", postcode: "6107" },
{ city: "EAST CANNINGTON", state: "WA", postcode: "6107" },
{ city: "KENWICK", state: "WA", postcode: "6107" },
{ city: "QUEENS PARK", state: "WA", postcode: "6107" },
{ city: "WATTLE GROVE", state: "WA", postcode: "6107" },
{ city: "WILSON", state: "WA", postcode: "6107" },
{ city: "THORNLIE", state: "WA", postcode: "6108" },
{ city: "MADDINGTON", state: "WA", postcode: "6109" },
{ city: "ORANGE GROVE", state: "WA", postcode: "6109" },
{ city: "GOSNELLS", state: "WA", postcode: "6110" },
{ city: "HUNTINGDALE", state: "WA", postcode: "6110" },
{ city: "MARTIN", state: "WA", postcode: "6110" },
{ city: "SOUTHERN RIVER", state: "WA", postcode: "6110" },
{ city: "ASHENDON", state: "WA", postcode: "6111" },
{ city: "CAMILLO", state: "WA", postcode: "6111" },
{ city: "CANNING MILLS", state: "WA", postcode: "6111" },
{ city: "CHAMPION LAKES", state: "WA", postcode: "6111" },
{ city: "KARRAGULLEN", state: "WA", postcode: "6111" },
{ city: "KELMSCOTT", state: "WA", postcode: "6111" },
{ city: "KELMSCOTT DC", state: "WA", postcode: "6111" },
{ city: "LESLEY", state: "WA", postcode: "6111" },
{ city: "ROLEYSTONE", state: "WA", postcode: "6111" },
{ city: "ARMADALE", state: "WA", postcode: "6112" },
{ city: "BEDFORDALE", state: "WA", postcode: "6112" },
{ city: "BROOKDALE", state: "WA", postcode: "6112" },
{ city: "FORRESTDALE", state: "WA", postcode: "6112" },
{ city: "HARRISDALE", state: "WA", postcode: "6112" },
{ city: "HAYNES", state: "WA", postcode: "6112" },
{ city: "HILBERT", state: "WA", postcode: "6112" },
{ city: "MOUNT NASURA", state: "WA", postcode: "6112" },
{ city: "MOUNT RICHON", state: "WA", postcode: "6112" },
{ city: "PIARA WATERS", state: "WA", postcode: "6112" },
{ city: "SEVILLE GROVE", state: "WA", postcode: "6112" },
{ city: "WUNGONG", state: "WA", postcode: "6112" },
{ city: "OAKFORD", state: "WA", postcode: "6121" },
{ city: "OLDBURY", state: "WA", postcode: "6121" },
{ city: "BYFORD", state: "WA", postcode: "6122" },
{ city: "CARDUP", state: "WA", postcode: "6122" },
{ city: "DARLING DOWNS", state: "WA", postcode: "6122" },
{ city: "KARRAKUP", state: "WA", postcode: "6122" },
{ city: "HOPELAND", state: "WA", postcode: "6125" },
{ city: "MARDELLA", state: "WA", postcode: "6125" },
{ city: "SERPENTINE", state: "WA", postcode: "6125" },
{ city: "KEYSBROOK", state: "WA", postcode: "6126" },
{ city: "LANGFORD", state: "WA", postcode: "6147" },
{ city: "LYNWOOD", state: "WA", postcode: "6147" },
{ city: "PARKWOOD", state: "WA", postcode: "6147" },
{ city: "FERNDALE", state: "WA", postcode: "6148" },
{ city: "RIVERTON", state: "WA", postcode: "6148" },
{ city: "ROSSMOYNE", state: "WA", postcode: "6148" },
{ city: "SHELLEY", state: "WA", postcode: "6148" },
{ city: "BULL CREEK", state: "WA", postcode: "6149" },
{ city: "LEEMING", state: "WA", postcode: "6149" },
{ city: "BATEMAN", state: "WA", postcode: "6150" },
{ city: "MURDOCH", state: "WA", postcode: "6150" },
{ city: "WINTHROP", state: "WA", postcode: "6150" },
{ city: "KENSINGTON", state: "WA", postcode: "6151" },
{ city: "SOUTH PERTH", state: "WA", postcode: "6151" },
{ city: "SOUTH PERTH ANGELO ST", state: "WA", postcode: "6151" },
{ city: "COMO", state: "WA", postcode: "6152" },
{ city: "KARAWARA", state: "WA", postcode: "6152" },
{ city: "MANNING", state: "WA", postcode: "6152" },
{ city: "SALTER POINT", state: "WA", postcode: "6152" },
{ city: "WATERFORD", state: "WA", postcode: "6152" },
{ city: "APPLECROSS", state: "WA", postcode: "6153" },
{ city: "APPLECROSS NORTH", state: "WA", postcode: "6153" },
{ city: "ARDROSS", state: "WA", postcode: "6153" },
{ city: "BRENTWOOD", state: "WA", postcode: "6153" },
{ city: "CANNING BRIDGE APPLECROSS", state: "WA", postcode: "6153" },
{ city: "MOUNT PLEASANT", state: "WA", postcode: "6153" },
{ city: "ALFRED COVE", state: "WA", postcode: "6154" },
{ city: "BOORAGOON", state: "WA", postcode: "6154" },
{ city: "MYAREE", state: "WA", postcode: "6154" },
{ city: "CANNING VALE", state: "WA", postcode: "6155" },
{ city: "CANNING VALE DC", state: "WA", postcode: "6155" },
{ city: "CANNING VALE EAST", state: "WA", postcode: "6155" },
{ city: "CANNING VALE SOUTH", state: "WA", postcode: "6155" },
{ city: "WILLETTON", state: "WA", postcode: "6155" },
{ city: "ATTADALE", state: "WA", postcode: "6156" },
{ city: "MELVILLE", state: "WA", postcode: "6156" },
{ city: "WILLAGEE", state: "WA", postcode: "6156" },
{ city: "WILLAGEE CENTRAL", state: "WA", postcode: "6156" },
{ city: "BICTON", state: "WA", postcode: "6157" },
{ city: "PALMYRA", state: "WA", postcode: "6157" },
{ city: "PALMYRA DC", state: "WA", postcode: "6157" },
{ city: "EAST FREMANTLE", state: "WA", postcode: "6158" },
{ city: "NORTH FREMANTLE", state: "WA", postcode: "6159" },
{ city: "FREMANTLE", state: "WA", postcode: "6160" },
{ city: "BEACONSFIELD", state: "WA", postcode: "6162" },
{ city: "SOUTH FREMANTLE", state: "WA", postcode: "6162" },
{ city: "WHITE GUM VALLEY", state: "WA", postcode: "6162" },
{ city: "BIBRA LAKE", state: "WA", postcode: "6163" },
{ city: "BIBRA LAKE DC", state: "WA", postcode: "6163" },
{ city: "COOLBELLUP", state: "WA", postcode: "6163" },
{ city: "HAMILTON HILL", state: "WA", postcode: "6163" },
{ city: "HILTON", state: "WA", postcode: "6163" },
{ city: "KARDINYA", state: "WA", postcode: "6163" },
{ city: "NORTH COOGEE", state: "WA", postcode: "6163" },
{ city: "NORTH LAKE", state: "WA", postcode: "6163" },
{ city: "O'CONNOR", state: "WA", postcode: "6163" },
{ city: "SAMSON", state: "WA", postcode: "6163" },
{ city: "SPEARWOOD", state: "WA", postcode: "6163" },
{ city: "ATWELL", state: "WA", postcode: "6164" },
{ city: "AUBIN GROVE", state: "WA", postcode: "6164" },
{ city: "BANJUP", state: "WA", postcode: "6164" },
{ city: "BEELIAR", state: "WA", postcode: "6164" },
{ city: "COCKBURN CENTRAL", state: "WA", postcode: "6164" },
{ city: "HAMMOND PARK", state: "WA", postcode: "6164" },
{ city: "JANDAKOT", state: "WA", postcode: "6164" },
{ city: "SOUTH LAKE", state: "WA", postcode: "6164" },
{ city: "SUCCESS", state: "WA", postcode: "6164" },
{ city: "TREEBY", state: "WA", postcode: "6164" },
{ city: "YANGEBUP", state: "WA", postcode: "6164" },
{ city: "HOPE VALLEY", state: "WA", postcode: "6165" },
{ city: "NAVAL BASE", state: "WA", postcode: "6165" },
{ city: "COOGEE", state: "WA", postcode: "6166" },
{ city: "HENDERSON", state: "WA", postcode: "6166" },
{ city: "LAKE COOGEE", state: "WA", postcode: "6166" },
{ city: "MUNSTER", state: "WA", postcode: "6166" },
{ city: "WATTLEUP", state: "WA", postcode: "6166" },
{ city: "ANKETELL", state: "WA", postcode: "6167" },
{ city: "BERTRAM", state: "WA", postcode: "6167" },
{ city: "CALISTA", state: "WA", postcode: "6167" },
{ city: "CASUARINA", state: "WA", postcode: "6167" },
{ city: "KWINANA BEACH", state: "WA", postcode: "6167" },
{ city: "KWINANA TOWN CENTRE", state: "WA", postcode: "6167" },
{ city: "MANDOGALUP", state: "WA", postcode: "6167" },
{ city: "MEDINA", state: "WA", postcode: "6167" },
{ city: "ORELIA", state: "WA", postcode: "6167" },
{ city: "PARMELIA", state: "WA", postcode: "6167" },
{ city: "POSTANS", state: "WA", postcode: "6167" },
{ city: "THE SPECTACLES", state: "WA", postcode: "6167" },
{ city: "WANDI", state: "WA", postcode: "6167" },
{ city: "COOLOONGUP", state: "WA", postcode: "6168" },
{ city: "EAST ROCKINGHAM", state: "WA", postcode: "6168" },
{ city: "GARDEN ISLAND", state: "WA", postcode: "6168" },
{ city: "HILLMAN", state: "WA", postcode: "6168" },
{ city: "PERON", state: "WA", postcode: "6168" },
{ city: "ROCKINGHAM", state: "WA", postcode: "6168" },
{ city: "ROCKINGHAM BEACH", state: "WA", postcode: "6168" },
{ city: "ROCKINGHAM DC", state: "WA", postcode: "6168" },
{ city: "SAFETY BAY", state: "WA", postcode: "6169" },
{ city: "SHOALWATER", state: "WA", postcode: "6169" },
{ city: "WAIKIKI", state: "WA", postcode: "6169" },
{ city: "WARNBRO", state: "WA", postcode: "6169" },
{ city: "LEDA", state: "WA", postcode: "6170" },
{ city: "WELLARD", state: "WA", postcode: "6170" },
{ city: "BALDIVIS", state: "WA", postcode: "6171" },
{ city: "PORT KENNEDY", state: "WA", postcode: "6172" },
{ city: "LAKELANDS", state: "WA", postcode: "6180" },
{ city: "KERALUP", state: "WA", postcode: "6182" },
{ city: "BUNBURY", state: "WA", postcode: "6230" },
{ city: "EAST BUNBURY", state: "WA", postcode: "6230" },
{ city: "SOUTH BUNBURY", state: "WA", postcode: "6230" },
{ city: "AUSTRALIND", state: "WA", postcode: "6233" },
{ city: "DRUMSITE", state: "WA", postcode: "6798" },
{ city: "KAMPONG", state: "WA", postcode: "6798" },
{ city: "POON SAAN", state: "WA", postcode: "6798" },
{ city: "SETTLEMENT", state: "WA", postcode: "6798" },
{ city: "SILVER CITY", state: "WA", postcode: "6798" },
{ city: "HOME ISLAND", state: "WA", postcode: "6799" },
{ city: "WEST IS COCOS (KEELING)", state: "WA", postcode: "6799" },
{ city: "WEST ISLAND", state: "WA", postcode: "6799" },
{ city: "CANNING VALE", state: "WA", postcode: "6970" }

    ];

    

    const nonServiceAreas = [

    ];

    const input = document.getElementById('zipInput');
    const dropdown = document.getElementById('autocompleteDropdown');
    const form = document.getElementById('zipForm');
    // 合并数据集用于自动补全
    const allLocations = [...serviceAreas, ...nonServiceAreas];

       
// 防抖函数
function debounce(func, wait) {
    let timeout;
    return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

input.addEventListener('input', debounce(function(e) {
    const rawInput = e.target.value.toLowerCase();
    const numberParts = rawInput.match(/\d+/g) || [''];
    const textPart = rawInput.replace(/\d+/g, '').trim();
    
    let matches = allLocations.filter(location => {
        const numberMatch = numberParts.some(num => 
            location.postcode.startsWith(num)
        );
        
        const textMatch = textPart === '' || 
            location.city.toLowerCase().includes(textPart) ||
            location.state.toLowerCase().includes(textPart);
        
        return (numberParts[0] !== '' ? numberMatch : true) && textMatch;
    });

    // 只显示前10个匹配项，减少渲染量
    matches = matches.slice(0, 10);

    matches.sort((a, b) => {
        const aFullMatch = a.postcode === numberParts.join('');
        const bFullMatch = b.postcode === numberParts.join('');
        if (aFullMatch !== bFullMatch) return bFullMatch - aFullMatch;
        
        const aStarts = a.postcode.startsWith(numberParts.join(''));
        const bStarts = b.postcode.startsWith(numberParts.join(''));
        if (aStarts !== bStarts) return bStarts - aStarts;
        
        return a.postcode.localeCompare(b.postcode);
    });

    renderAutocomplete(matches);
}, 300)); // 300毫秒延迟


  
    function renderAutocomplete(items) {
        dropdown.innerHTML = items.map(item => `
            <div class="autocomplete-item" data-postcode="${item.postcode}">
                <span class="postcode">${item.postcode}</span>&nbsp;
                <span class="location-info">${item.city}, ${item.state}</span>   
            </div>
        `).join('');
        
        dropdown.style.display = items.length ? 'block' : 'none';
    }
  

    dropdown.addEventListener('click', function(e) {
        if (e.target.closest('.autocomplete-item')) {
            const item = e.target.closest('.autocomplete-item');
            input.value = `${item.querySelector('.location-info').textContent} ${item.dataset.postcode}`;
            dropdown.style.display = 'none';
            form.dispatchEvent(new Event('submit'));
        }
    });
  
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.input-container')) {
            dropdown.style.display = 'none';
        }
    });
  


  
    
    form.addEventListener('submit', function(e) {
    e.preventDefault();
    const inputValue = input.value.trim();

        // 增强格式兼容性：允许州名带空格和小写字母
    let addressMatch = inputValue.match(/^(.+?),\s*([A-Za-z]{2,})\s+(\d{3,})$/i);

            // 新增邮编独立验证逻辑
    const postcodeMatch = inputValue.match(/^(\d{3,})$/);

    if (addressMatch) {
        let [, city, state, postcode] = addressMatch;
        state = state.toUpperCase().replace(/\s+/g, ''); // 标准化州名格式
        
        const isService = serviceAreas.some(a => 
            a.city.toLowerCase() === city.toLowerCase() && 
            a.state.toUpperCase() === state && 
            a.postcode.startsWith(postcode) // 允许邮编部分匹配
        );
        
        showResult(...getResult(isService));
    } else if (postcodeMatch) {
        const postcodePrefix = postcodeMatch[1];
        const isService = serviceAreas.some(a => 
            a.postcode.startsWith(postcodePrefix)
        );
        showResult(...getResult(isService));
    } else {
        showResult('⚠️ Please select from suggestions', '#dc3545');
    }
});
// 新增标准化结果处理方法
function getResult(isService) {
    return [
        isService ? `✅ Support Free Delivery` 
                 : `❌ Delivery Not Available`,
        isService ? '#28a745' : '#dc3545'
    ];
};

  
    function showResult(message, color) {
        const resultDiv = document.getElementById('result');
        resultDiv.style.display = 'block';
        resultDiv.style.color = color;
        resultDiv.textContent = message;
    }


